/* My Milestone customiser engine.
   Loaded once per page. The section pushes its config onto window.MSQ as
   {c: MSC scalars, d: MSD Liquid-built data} and this drains the queue. */
function MSENGINE(MSC,MSD){
  var root = document.getElementById('cz-'+MSC[0]);
  if(!root || root.dataset.czInit) return;
  root.dataset.czInit = '1';
  var $ = function(id){ return root.querySelector('#'+id); };

  var ACCENTS=[
    {name:"Brand", hex:MSC[1]},
    {name:"Lime",  hex:"#C6F000"},
    {name:"Ice",   hex:"#46B1FF"},
    {name:"Magma", hex:"#FF2D55"},
    {name:"Chalk", hex:"#F2F2F2"}
  ];
  var PRODUCTS={
    magnet:{label:"10×12.5 cm Fridge Magnet · lustre", spec:"10×12.5 cm · 300 DPI", price:MSC[2], ar:0.8},
    poster:{label:"A3 Poster · premium heavyweight paper", spec:"A3 · 29.7×42 cm · 256–300 DPI",price:MSC[3], ar:0.70714},
    tee:{   label:"Unisex Tee · route + name",                spec:"DTF print · S–XL",  price:MSC[4], ar:0.75},
    /* 250 x 250 mm insert for a SANNAHED 25x25: 27 x 27 cm outer, 6 cm deep.
       Square, so ar is 1 - the only format that is not a paper ratio. */
    frame:{ label:"Medal Frame · 25×25 cm",  spec:"25×25 cm · 6 cm deep", price:MSC[73], ar:1},
    /* A4 is the same 1:root-2 as A3, so the artwork is the poster's - only the
       product, the mockups and the price differ. */
    a4print:{ label:"Framed A4 Print · ready to hang", spec:"A4 · 21×29.7 cm · framed",
              price:MSC[83], ar:0.70707},
    /* The file itself. Paper proportions, because the customer prints it at
       whichever size they like - the artwork is the poster's. */
    digital:{ label:"Digital Download · instant", spec:"Print file, wallpaper + reel",
              price:MSC[89], ar:0.70714}
  };
  /* Formats whose Elevation slot is Photo instead. Elevation is a style; Photo
     is a design, so these also route the click through framePhoto().
     formats: not poster,tee,magnet,digital - a photo belongs behind glass. Any
     new framed format almost certainly belongs in here. */
  var PHOTO_FMTS={frame:1, a4print:1};
  function isPhotoFmt(f){ return !!PHOTO_FMTS[f||'']; }
  /* Formats whose mockups are photographs of a frame: the window is found in
     the image at runtime instead of being measured in advance.
     formats: not poster,tee,magnet,digital - nothing to find a window in. A
     new framed format belongs in here or its artwork lands in the wrong box. */
  var FRAMED_FMTS={frame:1, a4print:1};
  /* Mockup SETS whose blank is a light surface on a light scene: paper behind
     glass, a bare sheet on a desk. Sampling "the blank's colour" and keeping
     what matches cannot separate those from the wall or the table behind them,
     so the artwork is clipped to the print rectangle instead and nothing is
     keyed. Keyed on the mockup set rather than the format, because the A4
     poster shares a format with the A3 and not a blank.
     The dark blanks - poster, tee, magnet - keep the key: it is what holds a
     finger or a shadow in front of the artwork. */
  var LIGHT_BLANKS={frame:1, a4print:1, poster_a4:1, digital:1};
  /* Nothing is posted, nothing is printed here, and there is no blank to
     photograph. Several branches below key off that rather than off the name. */
  var DIGITAL_FMTS={digital:1};
  function isDigital(f){ return !!DIGITAL_FMTS[f||'']; }

  /* Formats that are built and working but not being offered yet. A hidden
     format is left out of the tab row and the format ring, and that is all:
     its own product page still renders it, so a live link or a running ad
     never breaks because of a settings change. */
  var HIDDEN_FMTS=(function(){
    var o={}, raw=String(MSC[93]||'');
    raw.split(',').forEach(function(t){
      t=t.trim().toLowerCase(); if(!t) return;
      if(!PRODUCTS[t]){
        console.warn('Milestone: "Hide these formats" names '+t+', which is not '+
          'a format. Valid names: '+Object.keys(PRODUCTS).join(', '));
        return;
      }
      o[t]=1;
    });
    return o;
  })();
  function isHidden(f){ return !!HIDDEN_FMTS[f||'']; }
  /* Drop the hidden ones, but never return nothing - an all-hidden setting is
     a typo, not an instruction to empty the page. */
  /* 1 Nov: framed formats are offered with an event only in these states.
     MSC[110] is the section's "Framed formats with an event" setting: state
     codes, comma-separated; ALL is every state. An engine uploaded ahead of
     its section reads NSW, the rule as Marc gave it. */
  var FRAMED_STATES=(function(){
    var raw=(MSC[110]===undefined || MSC[110]===null) ? 'NSW' : String(MSC[110]);
    raw=raw.trim().toUpperCase(); if(!raw) raw='NSW';
    if(raw==='ALL' || raw==='*') return null;
    return raw.split(/[\s,]+/).filter(Boolean);
  })();
  /* Is format f offered alongside the route on this page? Only an event's
     route (one from the catalogue) is ever refused, and never on the framed
     product's own page: someone shopping by format can always buy it. */
  function framedOffered(f){
    if(!FRAMED_FMTS[f||''] || !FRAMED_STATES) return true;
    if(typeof PM_FMT!=='undefined' && PM && f===PM_FMT) return true;
    var r=null; try{ r=currentRoute(); }catch(e){ r=null; }
    if(!r) return true;
    return FRAMED_STATES.indexOf(routeState(r))>=0;
  }
  function showable(list){
    var v=list.filter(function(f){ return !isHidden(f); });
    return v.length ? v : list;
  }
  var state={accent:ACCENTS[0].hex, product:"poster", view:"mockup", slide:0, mockIdx:0, mapStyle:"standard", terrainTheme:"standard", mask:null, bbox:null, srcFile:null, srcUrl:"", srcType:"", locked:false, race:"", style:"neon", coords:null, eles:null, heatCanvas:null, heatBbox:null, mapImg:null, mapUrl:""};
  /* Activity (12 Oct). Declared up here because syncRibbonRow() can run early. */
  var SPORTS={
    run:  { name:'Run',   lab:'PACE',  field:'Pace',  unit:'/km',   unitP:'/KM',   unitMi:'/MI', ph:'5:30',
            stats:['dist','time','pace'],               msc:101, col:'#FF5A1F' },
    trail:{ name:'Trail', lab:'PACE',  field:'Pace',  unit:'/km',   unitP:'/KM',   unitMi:'/MI', ph:'7:30', ribbon:true,
            stats:['dist','time','gain','pace'],        msc:102, col:'#FF9F1C' },
    cycle:{ name:'Ride',  lab:'SPEED', field:'Speed', unit:'km/h',  unitP:'KM/H',  unitMi:'MPH', ph:'28.5', ribbon:true,
            stats:['dist','time','pace','gain'],        msc:103, col:'#FFB000', gainField:true },
    hike: { name:'Hike',  lab:'',      field:'',      unit:'',      unitP:'',      unitMi:'',    ph:'',     ribbon:true,
            stats:['dist','gain','summit','time'],      msc:104, col:'#B15CFF', noPace:true },
    swim: { name:'Swim',  lab:'PACE',  field:'Pace',  unit:'/100m', unitP:'/100M', unitMi:'/100M', ph:'1:45', per100:true,
            stats:['dist','time','pace'],               msc:105, col:'#FF3DB8' },
    /* 5K Run (23 Oct): a route entry's sport, never picked by the customer.
       Its design is Stat Bar, which prints time, date, run number and place. */
    run5k:{ name:'5K Run', lab:'PACE', field:'Pace',  unit:'/km',   unitP:'/KM',   unitMi:'/MI', ph:'', noPace:true,
            stats:['dist','time'],                      msc:101, col:'#FF5A1F' }
  };
  var SPORT='run', SPORT_SRC='', _ribTouched=false, _ribAuto=false, _accTouched=false;

  var BAYRUN=[[-33.87242,151.15166],[-33.87009,151.15193],[-33.86847,151.152],[-33.86715,151.15277],[-33.86635,151.1535],[-33.86623,151.15493],[-33.86605,151.15541],[-33.8653,151.15691],[-33.86469,151.15842],[-33.86435,151.15894],[-33.86332,151.16088],[-33.86334,151.16138],[-33.86291,151.16153],[-33.86254,151.16205],[-33.86199,151.16292],[-33.86093,151.16331],[-33.86074,151.16369],[-33.86096,151.16387],[-33.86115,151.16424],[-33.86025,151.16302],[-33.85894,151.16153],[-33.85774,151.16046],[-33.8574,151.15847],[-33.85712,151.15696],[-33.85719,151.15658],[-33.85759,151.15647],[-33.85914,151.15659],[-33.85917,151.15658],[-33.85919,151.15657],[-33.8593,151.15641],[-33.8594,151.15609],[-33.85933,151.1556],[-33.85934,151.15544],[-33.85937,151.15518],[-33.85935,151.15508],[-33.85931,151.15494],[-33.85916,151.15462],[-33.85886,151.15415],[-33.85875,151.15395],[-33.85872,151.15366],[-33.85896,151.1531],[-33.85905,151.15291],[-33.8591,151.15284],[-33.85919,151.15279],[-33.85928,151.15276],[-33.85958,151.15268],[-33.8597,151.15263],[-33.85978,151.15256],[-33.85981,151.15252],[-33.85988,151.1524],[-33.86003,151.152],[-33.86032,151.15125],[-33.8604,151.15114],[-33.86146,151.15],[-33.86179,151.14962],[-33.86198,151.14932],[-33.86217,151.1487],[-33.86234,151.14775],[-33.86232,151.14714],[-33.86225,151.14638],[-33.86233,151.1455],[-33.8624,151.14512],[-33.86253,151.14497],[-33.86302,151.14446],[-33.86315,151.1444],[-33.8633,151.14439],[-33.8645,151.14485],[-33.86492,151.14518],[-33.86508,151.14539],[-33.86507,151.14541],[-33.86506,151.14543],[-33.86507,151.14545],[-33.86508,151.14547],[-33.8651,151.14549],[-33.86512,151.1455],[-33.86516,151.14556],[-33.86547,151.14641],[-33.86551,151.14651],[-33.86556,151.14661],[-33.86567,151.14671],[-33.86612,151.14685],[-33.86625,151.14685],[-33.86636,151.14679],[-33.8665,151.14655],[-33.86663,151.14615],[-33.86666,151.14615],[-33.86668,151.14614],[-33.86669,151.14612],[-33.86669,151.14609],[-33.86669,151.14606],[-33.86667,151.14604],[-33.86689,151.14538],[-33.86757,151.14395],[-33.868,151.14212],[-33.86817,151.14178],[-33.8682,151.14178],[-33.86822,151.14177],[-33.86824,151.14176],[-33.86825,151.14174],[-33.86826,151.14172],[-33.86827,151.14169],[-33.86826,151.14166],[-33.86825,151.14164],[-33.86824,151.14162],[-33.86845,151.14131],[-33.8687,151.1411],[-33.86923,151.1409],[-33.86959,151.14092],[-33.86995,151.14106],[-33.87024,151.14127],[-33.8707,151.14183],[-33.87074,151.14188],[-33.87011,151.14354],[-33.86991,151.14437],[-33.86985,151.14515],[-33.8699,151.14607],[-33.87016,151.14727],[-33.87027,151.14779],[-33.87033,151.14806],[-33.87026,151.14811],[-33.87027,151.14823],[-33.87056,151.14867],[-33.87079,151.14882],[-33.87106,151.14896],[-33.87155,151.14933],[-33.87157,151.14938],[-33.87168,151.14951],[-33.87175,151.14984],[-33.87194,151.15004],[-33.87171,151.14973],[-33.87168,151.1495],[-33.87155,151.14935],[-33.87165,151.14939],[-33.8719,151.1496],[-33.87199,151.14987],[-33.87203,151.15005],[-33.87224,151.15091],[-33.87226,151.151],[-33.87235,151.15134],[-33.87237,151.15142],[-33.87245,151.15156],[-33.87247,151.15166]];
  var BAYRUN_E=[4.0,3.0,4.0,5.0,6.0,4.0,7.0,5.0,4.0,4.0,14.0,13.0,8.0,4.0,5.0,11.0,12.0,13.0,16.0,6.0,0.0,7.0,12.0,13.0,15.0,13.0,1.0,1.0,1.0,3.0,6.0,11.0,10.0,10.0,10.0,11.0,12.0,13.0,13.0,13.0,11.0,11.0,10.0,10.0,9.0,8.0,8.0,8.0,9.0,9.0,10.0,11.0,11.0,11.0,10.0,8.0,5.0,4.0,6.0,7.0,6.0,6.0,5.0,5.0,5.0,5.0,6.0,6.0,6.0,6.0,6.0,5.0,5.0,5.0,5.0,5.0,2.0,2.0,2.0,2.0,1.0,1.0,1.0,1.0,4.0,4.0,4.0,4.0,4.0,4.0,4.0,5.0,1.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,4.0,3.0,2.0,-1.0,1.0,3.0,4.0,5.0,5.0,3.0,5.0,3.0,6.0,7.0,5.0,4.0,3.0,3.0,3.0,4.0,4.0,3.0,3.0,3.0,2.0,2.0,2.0,3.0,3.0,3.0,2.0,2.0,2.0,2.0,2.0,3.0,3.0,4.0,4.0];
  var RACES={"sydney-marathon":{c:[[-33.8332,151.208],[-33.83883,151.20696],[-33.83902,151.20703],[-33.8414,151.20921],[-33.84258,151.21055],[-33.84509,151.21164],[-33.84797,151.21256],[-33.84947,151.21231],[-33.85365,151.20994],[-33.85882,151.20667],[-33.86153,151.20562],[-33.86344,151.20468],[-33.86597,151.2034],[-33.86729,151.20295],[-33.8707,151.20327],[-33.87211,151.20336],[-33.87357,151.20272],[-33.87419,151.2012],[-33.87449,151.19881],[-33.87475,151.1978],[-33.87491,151.19702],[-33.87127,151.19483],[-33.86632,151.19198],[-33.86594,151.19197],[-33.86541,151.19235],[-33.86409,151.19198],[-33.86379,151.19231],[-33.86369,151.19294],[-33.8659,151.19429],[-33.86649,151.1948],[-33.86761,151.19401],[-33.87063,151.19564],[-33.87315,151.19719],[-33.87374,151.19792],[-33.87394,151.19884],[-33.87349,151.20099],[-33.87268,151.2024],[-33.87118,151.20276],[-33.8691,151.2031],[-33.86873,151.2035],[-33.86337,151.20293],[-33.86196,151.20283],[-33.86081,151.20268],[-33.85842,151.20259],[-33.85751,151.20295],[-33.85707,151.20346],[-33.85676,151.20543],[-33.85549,151.20722],[-33.85481,151.20808],[-33.85389,151.20857],[-33.85428,151.20965],[-33.85521,151.20998],[-33.85579,151.20886],[-33.85645,151.2087],[-33.85801,151.20911],[-33.85934,151.20878],[-33.86123,151.20837],[-33.86139,151.20896],[-33.86368,151.20892],[-33.86888,151.2085],[-33.86634,151.21001],[-33.86497,151.21113],[-33.86577,151.21238],[-33.86972,151.21195],[-33.86998,151.21226],[-33.87043,151.21277],[-33.87675,151.21214],[-33.87713,151.21251],[-33.88075,151.21686],[-33.8841,151.21765],[-33.88686,151.21904],[-33.8903,151.22041],[-33.89841,151.22202],[-33.90138,151.22218],[-33.90093,151.21563],[-33.90139,151.22099],[-33.90201,151.22268],[-33.90466,151.22391],[-33.91099,151.2231],[-33.91184,151.2233],[-33.91365,151.22502],[-33.92123,151.22667],[-33.92381,151.22763],[-33.92448,151.22809],[-33.92835,151.23315],[-33.92957,151.23522],[-33.93058,151.23626],[-33.9312,151.23701],[-33.93071,151.23686],[-33.92968,151.23604],[-33.92877,151.23463],[-33.92713,151.23221],[-33.92505,151.22946],[-33.92382,151.22781],[-33.91956,151.22656],[-33.91363,151.22524],[-33.9119,151.22353],[-33.91131,151.22327],[-33.90502,151.22409],[-33.90422,151.22396],[-33.90177,151.22287],[-33.89609,151.22179],[-33.89164,151.22091],[-33.88745,151.21947],[-33.88678,151.21921],[-33.88743,151.21977],[-33.89097,151.22115],[-33.89096,151.22231],[-33.89151,151.22344],[-33.89554,151.22382],[-33.89537,151.22277],[-33.89539,151.22237],[-33.89559,151.22241],[-33.89725,151.22681],[-33.89774,151.22764],[-33.89921,151.22777],[-33.90073,151.22798],[-33.90403,151.23157],[-33.90462,151.2334],[-33.90418,151.23564],[-33.9031,151.23729],[-33.90103,151.24077],[-33.89956,151.241],[-33.8973,151.24015],[-33.89553,151.2383],[-33.89427,151.23595],[-33.89408,151.23406],[-33.89458,151.23227],[-33.89651,151.23034],[-33.89719,151.22888],[-33.89717,151.22733],[-33.89693,151.22687],[-33.89622,151.22519],[-33.89558,151.22393],[-33.8893,151.22319],[-33.88871,151.22273],[-33.88798,151.22212],[-33.88708,151.22221],[-33.88665,151.21922],[-33.8852,151.21832],[-33.88375,151.21762],[-33.88061,151.21688],[-33.87695,151.21239],[-33.87501,151.21245],[-33.8705,151.21319],[-33.86985,151.21439],[-33.86883,151.21624],[-33.86717,151.21787],[-33.86574,151.21972],[-33.86386,151.22093],[-33.86237,151.22248],[-33.86105,151.2222],[-33.85985,151.22203],[-33.86026,151.22183],[-33.8634,151.22094],[-33.86566,151.21891],[-33.86732,151.21766],[-33.86924,151.21527],[-33.8703,151.21365],[-33.87033,151.213],[-33.86974,151.21206],[-33.86554,151.21251],[-33.85948,151.21333],[-33.85888,151.21344],[-33.85814,151.2143]],e:null},
"city2surf":{c:[[-33.8737,151.21284],[-33.87412,151.21542],[-33.87497,151.22046],[-33.87517,151.22119],[-33.87566,151.22216],[-33.87595,151.22288],[-33.87616,151.22412],[-33.87635,151.22622],[-33.87626,151.22815],[-33.87625,151.22885],[-33.8764,151.2298],[-33.87704,151.23323],[-33.87728,151.23369],[-33.87836,151.23492],[-33.8786,151.23535],[-33.87915,151.23818],[-33.87925,151.23842],[-33.87919,151.23878],[-33.87878,151.23956],[-33.87865,151.24006],[-33.8785,151.24121],[-33.87855,151.24186],[-33.87844,151.24215],[-33.87792,151.24268],[-33.87772,151.24297],[-33.87744,151.24364],[-33.87723,151.24461],[-33.87706,151.24497],[-33.87648,151.24553],[-33.87575,151.24634],[-33.87534,151.24654],[-33.87485,151.24706],[-33.87452,151.24719],[-33.87353,151.24721],[-33.87328,151.2473],[-33.87295,151.2477],[-33.87283,151.24809],[-33.87231,151.25001],[-33.87208,151.25047],[-33.87158,151.2509],[-33.87095,151.25145],[-33.87028,151.25191],[-33.8701,151.25228],[-33.87008,151.25241],[-33.87016,151.25289],[-33.87167,151.25614],[-33.87206,151.25732],[-33.87232,151.25859],[-33.8725,151.25983],[-33.87256,151.26148],[-33.87284,151.26271],[-33.87285,151.26311],[-33.87265,151.26369],[-33.87235,151.26413],[-33.87164,151.26592],[-33.87111,151.26741],[-33.86966,151.26978],[-33.8691,151.27044],[-33.86894,151.2706],[-33.86814,151.27071],[-33.86797,151.27078],[-33.86774,151.27094],[-33.8676,151.27116],[-33.86755,151.2713],[-33.86743,151.27174],[-33.86734,151.27185],[-33.86715,151.27195],[-33.86663,151.2718],[-33.86654,151.2718],[-33.86627,151.27196],[-33.86598,151.27225],[-33.86557,151.27257],[-33.86543,151.27303],[-33.86521,151.27319],[-33.86497,151.27316],[-33.86483,151.27304],[-33.86458,151.2726],[-33.86431,151.27239],[-33.86353,151.27221],[-33.8621,151.2722],[-33.86156,151.27204],[-33.86139,151.27199],[-33.861,151.27198],[-33.86068,151.27214],[-33.86051,151.27234],[-33.86009,151.27298],[-33.85963,151.27335],[-33.85939,151.27377],[-33.85923,151.27451],[-33.85914,151.27544],[-33.85942,151.2761],[-33.85948,151.27672],[-33.85953,151.27756],[-33.85948,151.27801],[-33.85927,151.27832],[-33.85738,151.28027],[-33.85707,151.28136],[-33.85703,151.28153],[-33.85706,151.28198],[-33.85729,151.28219],[-33.85744,151.28204],[-33.85811,151.28125],[-33.85997,151.27948],[-33.86086,151.27847],[-33.86127,151.27819],[-33.86136,151.27817],[-33.86165,151.27814],[-33.86283,151.27838],[-33.86289,151.27872],[-33.86322,151.2806],[-33.86332,151.28103],[-33.86343,151.28113],[-33.86379,151.28108],[-33.86504,151.2808],[-33.8667,151.28142],[-33.86683,151.28179],[-33.86708,151.28198],[-33.86711,151.28198],[-33.86843,151.28174],[-33.87407,151.28044],[-33.87432,151.28044],[-33.87468,151.28054],[-33.87891,151.27968],[-33.87924,151.27965],[-33.87939,151.27983],[-33.87958,151.28119],[-33.87973,151.28136],[-33.88011,151.28132],[-33.88032,151.28142],[-33.88066,151.28182],[-33.88114,151.2824],[-33.88146,151.28253],[-33.88339,151.2825],[-33.8836,151.28257],[-33.88375,151.28267],[-33.88489,151.28354],[-33.8854,151.28405],[-33.88598,151.28428],[-33.88677,151.28438],[-33.88766,151.28339],[-33.8879,151.28327],[-33.88814,151.28328],[-33.88898,151.28356],[-33.88919,151.28345],[-33.88991,151.28271],[-33.89,151.28242],[-33.88994,151.28227],[-33.88972,151.28189],[-33.88975,151.28113],[-33.8898,151.28058],[-33.88973,151.28016],[-33.88934,151.27942],[-33.88906,151.27867],[-33.88893,151.2781],[-33.88892,151.27795],[-33.88891,151.27703],[-33.88901,151.27662],[-33.88915,151.27636],[-33.88931,151.27616],[-33.88974,151.2757],[-33.88976,151.27586],[-33.88945,151.27621],[-33.88925,151.27645],[-33.88908,151.27689],[-33.88907,151.27783],[-33.88924,151.27871],[-33.88941,151.27916],[-33.88978,151.27996],[-33.88985,151.27992],[-33.89012,151.27975],[-33.89017,151.27949],[-33.89021,151.27864]],e:[30.0,30.0,32.0,40.0,62.0,73.0,50.0,26.0,16.0,18.0,15.0,23.0,28.0,41.0,44.0,45.0,47.0,45.0,36.0,31.0,20.0,15.0,11.0,9.0,8.0,8.0,10.0,11.0,16.0,16.0,16.0,21.0,23.0,23.0,23.0,26.0,27.0,28.0,30.0,28.0,26.0,23.0,20.0,18.0,16.0,5.0,4.0,7.0,2.0,6.0,9.0,10.0,10.0,7.0,6.0,7.0,8.0,13.0,15.0,18.0,19.0,21.0,24.0,26.0,33.0,35.0,36.0,32.0,32.0,34.0,38.0,43.0,50.0,53.0,53.0,53.0,49.0,49.0,58.0,68.0,67.0,67.0,69.0,70.0,71.0,75.0,78.0,79.0,81.0,80.0,82.0,79.0,77.0,76.0,76.0,81.0,80.0,80.0,80.0,82.0,83.0,82.0,71.0,68.0,70.0,70.0,69.0,69.0,66.0,55.0,53.0,54.0,57.0,58.0,64.0,62.0,63.0,63.0,74.0,80.0,80.0,80.0,75.0,73.0,73.0,77.0,77.0,74.0,70.0,67.0,66.0,64.0,60.0,57.0,56.0,46.0,43.0,37.0,35.0,31.0,29.0,28.0,26.0,24.0,18.0,16.0,16.0,14.0,11.0,11.0,12.0,15.0,17.0,16.0,16.0,16.0,17.0,18.0,18.0,17.0,17.0,17.0,17.0,16.0,15.0,15.0,15.0,12.0,12.0,9.0,9.0,10.0]},
"gold-coast-marathon":{c:[[-27.96632,153.41635],[-27.97025,153.41894],[-27.9742,153.42044],[-27.97887,153.42185],[-27.97919,153.42253],[-27.97772,153.42292],[-27.97522,153.42452],[-27.97471,153.42511],[-27.97434,153.4267],[-27.97313,153.42771],[-27.97011,153.42794],[-27.96921,153.42752],[-27.96732,153.42692],[-27.96526,153.42709],[-27.96312,153.42674],[-27.96087,153.42668],[-27.95471,153.42689],[-27.96134,153.42693],[-27.96261,153.42681],[-27.9648,153.42726],[-27.96579,153.42725],[-27.9673,153.42699],[-27.96852,153.42729],[-27.96982,153.42795],[-27.97213,153.42807],[-27.97412,153.42783],[-27.97516,153.42849],[-27.97715,153.4288],[-27.97935,153.42899],[-27.98467,153.42966],[-27.98884,153.4297],[-27.99088,153.43005],[-27.9974,153.43065],[-28.00108,153.43102],[-28.00214,153.43114],[-28.0036,153.43124],[-28.00494,153.43134],[-28.00893,153.43135],[-28.01309,153.43198],[-28.01374,153.43126],[-28.01511,153.43176],[-28.01768,153.43238],[-28.01915,153.43247],[-28.02064,153.43258],[-28.02127,153.43354],[-28.02434,153.43418],[-28.02534,153.43415],[-28.02688,153.43432],[-28.02716,153.43372],[-28.03181,153.43445],[-28.03581,153.43569],[-28.04104,153.43701],[-28.04987,153.43918],[-28.05202,153.43956],[-28.05915,153.44131],[-28.06061,153.4417],[-28.06478,153.44325],[-28.06391,153.44297],[-28.06113,153.44218],[-28.06064,153.44172],[-28.06007,153.44151],[-28.05731,153.44084],[-28.05434,153.44008],[-28.05189,153.43953],[-28.04984,153.43624],[-28.04073,153.43399],[-28.03797,153.43276],[-28.03595,153.43412],[-28.03499,153.43501],[-28.02721,153.43358],[-28.02692,153.43357],[-28.02683,153.43432],[-28.02545,153.43414],[-28.02392,153.4341],[-28.02129,153.43352],[-28.02113,153.43309],[-28.02068,153.43238],[-28.02034,153.43245],[-28.01916,153.43245],[-28.01772,153.43236],[-28.01625,153.43204],[-28.01409,153.43144],[-28.01328,153.43085],[-28.01321,153.43047],[-28.01271,153.42983],[-28.01084,153.4296],[-28.00885,153.42946],[-28.00782,153.42936],[-28.00627,153.42921],[-28.00609,153.43106],[-28.00458,153.43134],[-28.00233,153.43111],[-28.00141,153.43112],[-27.99937,153.4308],[-27.99115,153.43013],[-27.99094,153.42974],[-27.9884,153.4298],[-27.98467,153.42965],[-27.9792,153.42898],[-27.97715,153.42881],[-27.97618,153.42827],[-27.97526,153.42661],[-27.97466,153.42531],[-27.9765,153.42382],[-27.97863,153.42266],[-27.9795,153.42222],[-27.97787,153.42154],[-27.97431,153.42047],[-27.97209,153.41962],[-27.96875,153.41786],[-27.96266,153.4135],[-27.95679,153.40944],[-27.95329,153.40794],[-27.94751,153.40866],[-27.94406,153.40792],[-27.94078,153.40779],[-27.93824,153.40721],[-27.93597,153.40696],[-27.93296,153.40627],[-27.93088,153.40557],[-27.92736,153.40587],[-27.92616,153.40565],[-27.92552,153.40409],[-27.92556,153.40371],[-27.92421,153.40388],[-27.92142,153.4043],[-27.91968,153.4043],[-27.92221,153.40423],[-27.92535,153.40378],[-27.9256,153.40475],[-27.92634,153.40584],[-27.92789,153.40593],[-27.93029,153.40578],[-27.93115,153.40567],[-27.93297,153.40634],[-27.93584,153.40698],[-27.9376,153.40733],[-27.93841,153.40738],[-27.93996,153.4077],[-27.94093,153.40798],[-27.94174,153.40858],[-27.94238,153.40992],[-27.94481,153.41014],[-27.94951,153.40948],[-27.95325,153.4093],[-27.95454,153.40937],[-27.9553,153.40886],[-27.95968,153.41153],[-27.96289,153.41403],[-27.9626,153.41492],[-27.96309,153.416],[-27.96392,153.41665]],e:[11.0,7.0,-4.0,4.0,1.0,3.0,1.0,1.0,6.0,2.0,3.0,2.0,5.0,2.0,7.0,4.0,7.0,5.0,6.0,5.0,5.0,6.0,2.0,3.0,5.0,7.0,6.0,7.0,14.0,10.0,1.0,1.0,8.0,6.0,1.0,4.0,2.0,7.0,20.0,9.0,7.0,12.0,11.0,11.0,10.0,7.0,10.0,8.0,17.0,12.0,9.0,11.0,11.0,12.0,8.0,11.0,10.0,9.0,9.0,11.0,9.0,10.0,10.0,11.0,7.0,7.0,7.0,7.0,7.0,13.0,19.0,7.0,10.0,9.0,10.0,10.0,9.0,11.0,11.0,13.0,14.0,11.0,13.0,7.0,6.0,11.0,10.0,8.0,12.0,19.0,6.0,1.0,1.0,2.0,1.0,1.0,1.0,10.0,16.0,7.0,5.0,11.0,2.0,3.0,4.0,3.0,1.0,-3.0,3.0,3.0,5.0,6.0,5.0,6.0,5.0,5.0,6.0,3.0,6.0,5.0,4.0,3.0,8.0,2.0,15.0,5.0,6.0,7.0,4.0,10.0,2.0,5.0,5.0,5.0,5.0,2.0,5.0,5.0,6.0,4.0,3.0,1.0,5.0,6.0,6.0,7.0,3.0,4.0,3.0,4.0,2.0,4.0]},
"melbourne-marathon":{c:[[-37.82013,144.97614],[-37.81886,144.97584],[-37.81732,144.97356],[-37.81638,144.97158],[-37.81726,144.96838],[-37.82009,144.96858],[-37.82145,144.96905],[-37.82501,144.97068],[-37.82798,144.97116],[-37.8312,144.97117],[-37.83323,144.97213],[-37.83429,144.97399],[-37.83696,144.97566],[-37.83976,144.97661],[-37.84395,144.97814],[-37.84783,144.97955],[-37.85156,144.98091],[-37.8547,144.9821],[-37.85714,144.98167],[-37.85734,144.97981],[-37.85485,144.97871],[-37.85262,144.97846],[-37.85012,144.9775],[-37.84827,144.97514],[-37.84803,144.97331],[-37.84657,144.97129],[-37.8451,144.97062],[-37.84366,144.97085],[-37.8414,144.97177],[-37.83925,144.97108],[-37.83851,144.96896],[-37.83834,144.96704],[-37.83901,144.96512],[-37.84026,144.96369],[-37.84099,144.96336],[-37.84134,144.96319],[-37.84207,144.9624],[-37.84357,144.96301],[-37.84543,144.96495],[-37.84653,144.96655],[-37.84731,144.96804],[-37.84864,144.97039],[-37.85132,144.97351],[-37.8524,144.97364],[-37.85266,144.97244],[-37.84957,144.9686],[-37.84769,144.96602],[-37.84682,144.96624],[-37.84754,144.96601],[-37.84958,144.96839],[-37.85273,144.97233],[-37.85214,144.97393],[-37.85313,144.97498],[-37.8539,144.97592],[-37.85516,144.97718],[-37.85667,144.97907],[-37.85792,144.9801],[-37.85879,144.97871],[-37.86051,144.97588],[-37.86171,144.97331],[-37.86103,144.97262],[-37.85891,144.97064],[-37.85696,144.96733],[-37.85477,144.96304],[-37.85306,144.95958],[-37.85086,144.95505],[-37.84876,144.95076],[-37.84681,144.94669],[-37.84487,144.94255],[-37.84427,144.94017],[-37.84456,144.94062],[-37.8454,144.94326],[-37.84739,144.94744],[-37.84961,144.95209],[-37.85184,144.95673],[-37.85407,144.96138],[-37.85599,144.9648],[-37.85853,144.96925],[-37.8602,144.97173],[-37.86177,144.97272],[-37.86383,144.97207],[-37.86521,144.97274],[-37.86687,144.97428],[-37.86969,144.97599],[-37.87249,144.97641],[-37.87667,144.97698],[-37.88062,144.9775],[-37.8826,144.97821],[-37.88483,144.98028],[-37.88681,144.9835],[-37.88931,144.98763],[-37.88881,144.98681],[-37.88632,144.98272],[-37.88479,144.98026],[-37.88246,144.97828],[-37.88039,144.97762],[-37.87608,144.97703],[-37.87166,144.97642],[-37.86936,144.97599],[-37.86651,144.97425],[-37.86518,144.97282],[-37.86313,144.97227],[-37.86201,144.97343],[-37.86032,144.97629],[-37.85795,144.98027],[-37.85629,144.98255],[-37.85394,144.9819],[-37.84989,144.98043],[-37.84585,144.97895],[-37.84293,144.9779],[-37.83909,144.97653],[-37.83631,144.9754],[-37.83417,144.97387],[-37.83291,144.97184],[-37.83046,144.97111],[-37.82732,144.97121],[-37.82501,144.97068],[-37.82356,144.96907],[-37.82319,144.96615],[-37.82128,144.96717],[-37.82072,144.96951],[-37.82166,144.9738],[-37.82224,144.97264],[-37.82294,144.97134],[-37.82394,144.97151],[-37.82578,144.9725],[-37.82663,144.97248],[-37.82774,144.97298],[-37.82972,144.97423],[-37.83077,144.97605],[-37.83225,144.97782],[-37.83328,144.97992],[-37.83346,144.9821],[-37.83395,144.98255],[-37.83385,144.98027],[-37.83316,144.97494],[-37.83229,144.97201],[-37.83075,144.97161],[-37.82764,144.97168],[-37.82586,144.97145],[-37.82327,144.97019],[-37.82059,144.96902],[-37.81881,144.96812],[-37.81733,144.96812],[-37.81615,144.97211],[-37.81566,144.9741],[-37.81611,144.97705],[-37.81817,144.97864],[-37.81868,144.97886],[-37.82049,144.98185],[-37.82059,144.98359],[-37.8202,144.98428],[-37.81958,144.98406]],e:[10.9,11.7,18.4,19.6,16.9,16.5,15.0,15.8,17.7,17.1,16.0,16.3,15.9,25.4,14.4,14.4,14.2,15.4,19.0,17.9,12.1,10.4,10.9,10.2,10.2,10.3,10.1,9.9,10.1,9.7,9.9,10.0,10.3,10.4,9.8,9.5,9.4,9.5,9.8,8.9,8.6,9.1,8.5,9.0,8.9,9.1,8.8,9.1,8.9,9.1,9.0,9.1,8.9,9.1,10.0,15.1,18.2,17.6,9.5,10.4,9.5,8.3,8.2,7.7,7.8,13.6,8.0,7.6,7.3,7.2,7.0,6.4,8.0,8.0,7.8,7.8,5.8,12.2,8.4,9.1,7.8,8.1,8.6,6.3,8.9,5.0,6.3,7.6,7.7,8.1,8.0,8.0,7.0,7.7,7.4,1.7,7.9,7.4,8.0,8.4,8.2,10.3,10.9,10.4,18.8,18.8,14.4,14.6,16.8,19.0,13.5,16.7,15.9,15.5,18.0,17.4,15.1,11.5,9.8,11.4,10.1,13.1,16.1,17.6,18.9,21.9,23.3,24.7,32.1,32.6,29.9,26.6,28.9,30.0,25.8,19.2,16.9,18.6,18.6,17.5,15.4,16.9,17.3,16.3,20.4,24.9,15.8,12.5,12.3,12.6,19.6,25.9,23.6]},
"great-ocean-road":{c:[[-38.54176,143.97572],[-38.54248,143.97581],[-38.54364,143.97826],[-38.54588,143.98258],[-38.55086,143.98508],[-38.55255,143.98377],[-38.55425,143.98221],[-38.55547,143.97827],[-38.55461,143.97714],[-38.55406,143.97624],[-38.55558,143.97525],[-38.55703,143.97606],[-38.55816,143.9763],[-38.56068,143.97628],[-38.56333,143.97451],[-38.56502,143.97368],[-38.56632,143.97228],[-38.56696,143.96951],[-38.56669,143.96727],[-38.56733,143.96623],[-38.56889,143.9651],[-38.57078,143.96474],[-38.57232,143.96313],[-38.57443,143.96077],[-38.57535,143.95882],[-38.57572,143.95542],[-38.57612,143.95392],[-38.57622,143.95082],[-38.57503,143.94917],[-38.577,143.94811],[-38.57843,143.94648],[-38.57958,143.94518],[-38.581,143.94314],[-38.58199,143.94059],[-38.58261,143.93831],[-38.58373,143.93726],[-38.58607,143.93472],[-38.58705,143.93382],[-38.5883,143.93103],[-38.58898,143.92887],[-38.58988,143.92641],[-38.59153,143.92398],[-38.59315,143.92225],[-38.59517,143.92077],[-38.59692,143.91912],[-38.59982,143.92033],[-38.60174,143.92083],[-38.604,143.9193],[-38.60623,143.91907],[-38.61047,143.9165],[-38.61192,143.91491],[-38.61418,143.91588],[-38.61747,143.91212],[-38.61996,143.91136],[-38.62391,143.9086],[-38.62581,143.90722],[-38.62787,143.90427],[-38.62927,143.90105],[-38.62983,143.89862],[-38.63194,143.89685],[-38.63338,143.89292],[-38.63385,143.89122],[-38.63743,143.89183],[-38.63979,143.89224],[-38.64144,143.89326],[-38.64159,143.89154],[-38.64237,143.88898],[-38.64296,143.88688],[-38.64599,143.88362],[-38.64726,143.88308],[-38.64786,143.88123],[-38.65016,143.87748],[-38.65111,143.87428],[-38.65313,143.87141],[-38.65552,143.86963],[-38.65773,143.8678],[-38.66195,143.86407],[-38.66549,143.86378],[-38.66672,143.86195],[-38.66996,143.86289],[-38.6709,143.86462],[-38.67173,143.86355],[-38.67295,143.85994],[-38.67416,143.85754],[-38.67426,143.85438],[-38.67585,143.84882],[-38.67683,143.84551],[-38.6771,143.84265],[-38.67884,143.84112],[-38.68187,143.84025],[-38.68247,143.83902],[-38.68449,143.83883],[-38.68573,143.83816],[-38.68727,143.83692],[-38.68879,143.83731],[-38.69094,143.83705],[-38.69208,143.83535],[-38.69188,143.83338],[-38.69196,143.83015],[-38.69168,143.82814],[-38.69182,143.82471],[-38.69129,143.8227],[-38.69044,143.8214],[-38.69118,143.81827],[-38.69197,143.81641],[-38.69265,143.81376],[-38.69276,143.81088],[-38.69266,143.80935],[-38.69398,143.80678],[-38.69441,143.80444],[-38.69649,143.80164],[-38.69778,143.79063],[-38.69982,143.78402],[-38.70234,143.77585],[-38.70385,143.77512],[-38.70463,143.77351],[-38.7046,143.77139],[-38.70583,143.76877],[-38.70508,143.76752],[-38.70488,143.76506],[-38.70464,143.76326],[-38.70511,143.76233],[-38.70668,143.75896],[-38.70621,143.75753],[-38.70654,143.75592],[-38.70818,143.75454],[-38.71094,143.75155],[-38.7121,143.74894],[-38.71373,143.74317],[-38.71544,143.73623],[-38.71696,143.7324],[-38.71676,143.72964],[-38.72113,143.72255],[-38.7247,143.71523],[-38.72412,143.71194],[-38.72685,143.70763],[-38.72859,143.7032],[-38.72944,143.6998],[-38.7332,143.68908],[-38.73974,143.67732],[-38.74766,143.67083],[-38.75496,143.66902],[-38.75677,143.66952]],e:[3.0,12.0,10.0,14.0,13.0,15.0,15.0,24.0,21.0,10.0,17.0,17.0,14.0,18.0,31.0,32.0,28.0,28.0,18.0,9.0,14.0,15.0,22.0,23.0,22.0,24.0,25.0,15.0,4.0,15.0,33.0,46.0,55.0,57.0,49.0,30.0,53.0,52.0,71.0,62.0,48.0,46.0,29.0,13.0,7.0,24.0,11.0,22.0,16.0,12.0,23.0,10.0,26.0,22.0,25.0,20.0,23.0,17.0,4.0,20.0,13.0,9.0,8.0,21.0,8.0,22.0,20.0,31.0,16.0,16.0,24.0,30.0,20.0,22.0,14.0,11.0,9.0,8.0,5.0,6.0,13.0,23.0,38.0,41.0,52.0,52.0,49.0,39.0,30.0,8.0,11.0,23.0,33.0,44.0,38.0,40.0,27.0,47.0,54.0,57.0,51.0,39.0,47.0,31.0,27.0,23.0,14.0,5.0,9.0,13.0,11.0,12.0,7.0,14.0,14.0,16.0,11.0,15.0,26.0,15.0,10.0,8.0,18.0,23.0,25.0,18.0,14.0,8.0,9.0,15.0,13.0,7.0,11.0,10.0,9.0,8.0,6.0,8.0,11.0,4.0,4.0,3.0,4.0]},
"ultra-trail-australia":{c:[[-33.72843,150.30011],[-33.73251,150.29861],[-33.72872,150.29473],[-33.72855,150.28974],[-33.73174,150.28592],[-33.73468,150.28224],[-33.7389,150.28083],[-33.74706,150.27975],[-33.74944,150.2762],[-33.75593,150.26843],[-33.75724,150.2657],[-33.76155,150.26482],[-33.76728,150.26589],[-33.77411,150.26308],[-33.78413,150.26089],[-33.79211,150.26188],[-33.79742,150.26776],[-33.80603,150.2683],[-33.81137,150.26474],[-33.81259,150.26478],[-33.82134,150.25973],[-33.82738,150.25543],[-33.82257,150.25458],[-33.81762,150.25183],[-33.81309,150.25057],[-33.80374,150.25037],[-33.79863,150.25031],[-33.79566,150.24764],[-33.79166,150.23844],[-33.79025,150.23064],[-33.78862,150.22641],[-33.79083,150.21823],[-33.79442,150.21172],[-33.79434,150.20762],[-33.79236,150.20486],[-33.78958,150.20714],[-33.79125,150.21093],[-33.78981,150.21692],[-33.78663,150.22124],[-33.78359,150.22409],[-33.78372,150.22973],[-33.77658,150.23407],[-33.77588,150.23323],[-33.77465,150.23201],[-33.76609,150.23092],[-33.75782,150.23472],[-33.74441,150.237],[-33.74005,150.23751],[-33.73684,150.23678],[-33.74022,150.23035],[-33.73895,150.22393],[-33.73481,150.22064],[-33.7359,150.21484],[-33.73578,150.20982],[-33.73364,150.20795],[-33.72927,150.20861],[-33.73284,150.21222],[-33.73393,150.21623],[-33.73403,150.22318],[-33.73549,150.22959],[-33.73583,150.23655],[-33.73135,150.24281],[-33.73093,150.25263],[-33.73061,150.25894],[-33.72654,150.2722],[-33.71902,150.27758],[-33.71342,150.28842],[-33.70933,150.28941],[-33.70945,150.29267],[-33.71089,150.29229],[-33.71621,150.29806],[-33.71641,150.30611],[-33.72157,150.30387],[-33.7259,150.30618],[-33.72947,150.30651],[-33.7301,150.3083],[-33.73237,150.3119],[-33.73356,150.31438],[-33.73483,150.31507],[-33.73478,150.31587],[-33.7326,150.31673],[-33.72566,150.32021],[-33.72412,150.31955],[-33.72397,150.32076],[-33.72247,150.32181],[-33.72082,150.32287],[-33.72278,150.32402],[-33.72454,150.32599],[-33.72549,150.32806],[-33.72568,150.33006],[-33.72411,150.33482],[-33.72507,150.3355],[-33.72756,150.33643],[-33.72877,150.33891],[-33.72433,150.34559],[-33.72282,150.3497],[-33.72446,150.35666],[-33.71957,150.3571],[-33.71891,150.35801],[-33.71661,150.35699],[-33.71367,150.35776],[-33.71344,150.36325],[-33.71963,150.36344],[-33.72329,150.36427],[-33.7264,150.36549],[-33.72642,150.36873],[-33.72702,150.37064],[-33.72639,150.37323],[-33.72792,150.37476],[-33.73002,150.37407],[-33.73371,150.37297],[-33.73913,150.37788],[-33.74743,150.37748],[-33.7541,150.37564],[-33.75953,150.37582],[-33.76694,150.37398],[-33.77595,150.38088],[-33.77932,150.37948],[-33.77958,150.37856],[-33.77928,150.37602],[-33.77477,150.37133],[-33.76875,150.36451],[-33.76554,150.36106],[-33.76408,150.35369],[-33.76262,150.34887],[-33.75774,150.34656],[-33.75263,150.34033],[-33.75179,150.33644],[-33.75167,150.33126],[-33.74973,150.32938],[-33.75068,150.3263],[-33.74554,150.32344],[-33.74131,150.32115],[-33.7399,150.31924],[-33.73434,150.3195],[-33.72884,150.32382],[-33.7266,150.32223],[-33.72682,150.31976],[-33.73061,150.32007],[-33.73369,150.31956],[-33.73634,150.31676],[-33.73556,150.31361],[-33.73241,150.30905],[-33.72956,150.30364],[-33.72944,150.30297],[-33.72829,150.30212],[-33.72848,150.30107],[-33.7284,150.3001]],e:[959.0,985.0,973.0,928.0,913.0,951.0,1019.0,1005.0,1024.0,1024.0,1010.0,1025.0,1042.0,1055.0,1068.0,1046.0,979.0,967.0,883.0,856.0,791.0,751.0,663.0,610.0,599.0,672.0,670.0,708.0,722.0,634.0,621.0,668.0,741.0,779.0,709.0,626.0,671.0,649.0,629.0,537.0,558.0,593.0,631.0,683.0,758.0,726.0,619.0,593.0,575.0,582.0,580.0,550.0,573.0,576.0,586.0,494.0,529.0,552.0,543.0,549.0,572.0,562.0,573.0,578.0,601.0,660.0,780.0,969.0,981.0,970.0,1023.0,971.0,957.0,942.0,862.0,937.0,886.0,940.0,872.0,758.0,760.0,728.0,866.0,797.0,863.0,905.0,909.0,909.0,932.0,943.0,901.0,896.0,889.0,905.0,944.0,910.0,878.0,842.0,819.0,832.0,882.0,906.0,901.0,885.0,802.0,841.0,808.0,850.0,808.0,837.0,862.0,889.0,865.0,854.0,837.0,797.0,791.0,724.0,664.0,534.0,471.0,391.0,336.0,231.0,269.0,311.0,345.0,404.0,351.0,314.0,372.0,427.0,520.0,590.0,642.0,607.0,671.0,732.0,686.0,659.0,698.0,751.0,708.0,794.0,843.0,931.0,954.0,958.0]},
"the-bay-run":{c:[[-33.87242,151.15166],[-33.87009,151.15193],[-33.86847,151.152],[-33.86715,151.15277],[-33.86635,151.1535],[-33.86623,151.15493],[-33.86605,151.15541],[-33.8653,151.15691],[-33.86469,151.15842],[-33.86435,151.15894],[-33.86332,151.16088],[-33.86334,151.16138],[-33.86291,151.16153],[-33.86254,151.16205],[-33.86199,151.16292],[-33.86093,151.16331],[-33.86074,151.16369],[-33.86096,151.16387],[-33.86115,151.16424],[-33.86025,151.16302],[-33.85894,151.16153],[-33.85774,151.16046],[-33.8574,151.15847],[-33.85712,151.15696],[-33.85719,151.15658],[-33.85759,151.15647],[-33.85914,151.15659],[-33.85917,151.15658],[-33.85919,151.15657],[-33.8593,151.15641],[-33.8594,151.15609],[-33.85933,151.1556],[-33.85934,151.15544],[-33.85937,151.15518],[-33.85935,151.15508],[-33.85931,151.15494],[-33.85916,151.15462],[-33.85886,151.15415],[-33.85875,151.15395],[-33.85872,151.15366],[-33.85896,151.1531],[-33.85905,151.15291],[-33.8591,151.15284],[-33.85919,151.15279],[-33.85928,151.15276],[-33.85958,151.15268],[-33.8597,151.15263],[-33.85978,151.15256],[-33.85981,151.15252],[-33.85988,151.1524],[-33.86003,151.152],[-33.86032,151.15125],[-33.8604,151.15114],[-33.86146,151.15],[-33.86179,151.14962],[-33.86198,151.14932],[-33.86217,151.1487],[-33.86234,151.14775],[-33.86232,151.14714],[-33.86225,151.14638],[-33.86233,151.1455],[-33.8624,151.14512],[-33.86253,151.14497],[-33.86302,151.14446],[-33.86315,151.1444],[-33.8633,151.14439],[-33.8645,151.14485],[-33.86492,151.14518],[-33.86508,151.14539],[-33.86507,151.14541],[-33.86506,151.14543],[-33.86507,151.14545],[-33.86508,151.14547],[-33.8651,151.14549],[-33.86512,151.1455],[-33.86516,151.14556],[-33.86547,151.14641],[-33.86551,151.14651],[-33.86556,151.14661],[-33.86567,151.14671],[-33.86612,151.14685],[-33.86625,151.14685],[-33.86636,151.14679],[-33.8665,151.14655],[-33.86663,151.14615],[-33.86666,151.14615],[-33.86668,151.14614],[-33.86669,151.14612],[-33.86669,151.14609],[-33.86669,151.14606],[-33.86667,151.14604],[-33.86689,151.14538],[-33.86757,151.14395],[-33.868,151.14212],[-33.86817,151.14178],[-33.8682,151.14178],[-33.86822,151.14177],[-33.86824,151.14176],[-33.86825,151.14174],[-33.86826,151.14172],[-33.86827,151.14169],[-33.86826,151.14166],[-33.86825,151.14164],[-33.86824,151.14162],[-33.86845,151.14131],[-33.8687,151.1411],[-33.86923,151.1409],[-33.86959,151.14092],[-33.86995,151.14106],[-33.87024,151.14127],[-33.8707,151.14183],[-33.87074,151.14188],[-33.87011,151.14354],[-33.86991,151.14437],[-33.86985,151.14515],[-33.8699,151.14607],[-33.87016,151.14727],[-33.87027,151.14779],[-33.87033,151.14806],[-33.87026,151.14811],[-33.87027,151.14823],[-33.87056,151.14867],[-33.87079,151.14882],[-33.87106,151.14896],[-33.87155,151.14933],[-33.87157,151.14938],[-33.87168,151.14951],[-33.87175,151.14984],[-33.87194,151.15004],[-33.87171,151.14973],[-33.87168,151.1495],[-33.87155,151.14935],[-33.87165,151.14939],[-33.8719,151.1496],[-33.87199,151.14987],[-33.87203,151.15005],[-33.87224,151.15091],[-33.87226,151.151],[-33.87235,151.15134],[-33.87237,151.15142],[-33.87245,151.15156],[-33.87247,151.15166]],e:[4.0,3.0,4.0,5.0,6.0,4.0,7.0,5.0,4.0,4.0,14.0,13.0,8.0,4.0,5.0,11.0,12.0,13.0,16.0,6.0,0.0,7.0,12.0,13.0,15.0,13.0,1.0,1.0,1.0,3.0,6.0,11.0,10.0,10.0,10.0,11.0,12.0,13.0,13.0,13.0,11.0,11.0,10.0,10.0,9.0,8.0,8.0,8.0,9.0,9.0,10.0,11.0,11.0,11.0,10.0,8.0,5.0,4.0,6.0,7.0,6.0,6.0,5.0,5.0,5.0,5.0,6.0,6.0,6.0,6.0,6.0,5.0,5.0,5.0,5.0,5.0,2.0,2.0,2.0,2.0,1.0,1.0,1.0,1.0,4.0,4.0,4.0,4.0,4.0,4.0,4.0,5.0,1.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,3.0,4.0,3.0,2.0,-1.0,1.0,3.0,4.0,5.0,5.0,3.0,5.0,3.0,6.0,7.0,5.0,4.0,3.0,3.0,3.0,4.0,4.0,3.0,3.0,3.0,2.0,2.0,2.0,3.0,3.0,3.0,2.0,2.0,2.0,2.0,2.0,3.0,3.0,4.0,4.0]},
"peaks-challenge-falls-creek":{c:[[-36.8633,147.28222],[-36.85581,147.27373],[-36.84808,147.26967],[-36.84391,147.26432],[-36.84382,147.25446],[-36.84361,147.24437],[-36.84601,147.24137],[-36.84121,147.24415],[-36.83663,147.23528],[-36.82964,147.23299],[-36.82291,147.23072],[-36.81795,147.23036],[-36.81122,147.22764],[-36.81657,147.22406],[-36.8088,147.22489],[-36.80362,147.22252],[-36.80188,147.2182],[-36.79518,147.21715],[-36.7844,147.21856],[-36.774,147.21414],[-36.76755,147.21434],[-36.76374,147.20952],[-36.75792,147.2055],[-36.7543,147.19658],[-36.74982,147.19256],[-36.74584,147.18918],[-36.73932,147.18896],[-36.73913,147.1816],[-36.74329,147.16818],[-36.71777,147.14614],[-36.71945,147.13944],[-36.72225,147.13194],[-36.72755,147.13649],[-36.72438,147.12882],[-36.71848,147.12916],[-36.71532,147.12654],[-36.71719,147.11955],[-36.719,147.11203],[-36.7148,147.10469],[-36.71575,147.09577],[-36.71942,147.08772],[-36.72404,147.07114],[-36.73242,147.05188],[-36.73262,147.02188],[-36.75398,147.01897],[-36.80007,147.04631],[-36.84693,147.07811],[-36.86439,147.06485],[-36.89634,147.0623],[-36.90306,147.0614],[-36.90871,147.0591],[-36.91148,147.05474],[-36.91763,147.05363],[-36.92228,147.0516],[-36.9225,147.05825],[-36.92294,147.06619],[-36.92839,147.0641],[-36.93427,147.06188],[-36.93983,147.05942],[-36.94597,147.05705],[-36.95257,147.05704],[-36.95968,147.05701],[-36.96982,147.05705],[-36.98041,147.0554],[-36.9886,147.05792],[-36.9946,147.06313],[-37.002,147.0724],[-37.00632,147.08351],[-37.00319,147.09523],[-37.00141,147.10781],[-36.98898,147.11206],[-36.98178,147.12023],[-36.97358,147.12629],[-36.97488,147.13757],[-36.99036,147.14837],[-36.99457,147.16742],[-37.01881,147.19373],[-37.02481,147.21491],[-37.02239,147.24701],[-37.02595,147.27036],[-37.04155,147.31021],[-37.05779,147.33163],[-37.07869,147.35495],[-37.08126,147.38268],[-37.08908,147.3839],[-37.09551,147.41012],[-37.10311,147.4278],[-37.12832,147.46045],[-37.13498,147.49347],[-37.13686,147.50707],[-37.12881,147.52898],[-37.12665,147.53895],[-37.1184,147.5532],[-37.11407,147.56275],[-37.11384,147.57178],[-37.10368,147.58254],[-37.08839,147.59898],[-37.06156,147.60246],[-37.04796,147.60094],[-37.02738,147.59194],[-37.0235,147.58673],[-37.01679,147.57368],[-37.00531,147.55823],[-37.00042,147.54618],[-37.00126,147.54108],[-37.00035,147.52789],[-36.99829,147.52114],[-36.99407,147.50868],[-36.99476,147.49432],[-36.98661,147.49421],[-36.97719,147.48852],[-36.97129,147.48242],[-36.96672,147.47898],[-36.95997,147.47957],[-36.95623,147.47307],[-36.94973,147.47199],[-36.94024,147.47116],[-36.93291,147.47108],[-36.92573,147.46676],[-36.92696,147.46219],[-36.93312,147.4482],[-36.93555,147.43747],[-36.94237,147.42606],[-36.94271,147.41786],[-36.94608,147.40727],[-36.94757,147.39842],[-36.95424,147.3845],[-36.95058,147.37342],[-36.95326,147.35657],[-36.94995,147.33908],[-36.94139,147.32611],[-36.9357,147.31176],[-36.9266,147.29958],[-36.90685,147.28878],[-36.89362,147.30042],[-36.88628,147.3072],[-36.88474,147.31601],[-36.87561,147.31699],[-36.87057,147.31139],[-36.87482,147.29914],[-36.87161,147.28635],[-36.86374,147.28572],[-36.8633,147.28222]],e:null}};

  var swWrap=$('cz-swatches');
  if(swWrap){ ACCENTS.forEach(function(a,i){
    var b=document.createElement('div');
    b.className='cz-sw'+(i===0?' cz-on':''); b.style.background=a.hex; b.title=a.name;
    b.onclick=function(){ state.accent=a.hex; _accTouched=true;
      swWrap.querySelectorAll('.cz-sw').forEach(function(c){c.classList.remove('cz-on');}); b.classList.add('cz-on');
      if(isMapLike(state.style)){ ensureMap(function(){ ensureMap2(render); }); } else { render(); } };
    swWrap.appendChild(b);
  }); }

  $('cz-tabs').addEventListener('click',function(e){
    var t=e.target.closest('.cz-tab'); if(!t)return;
    state.product=t.getAttribute('data-p');
    Array.prototype.forEach.call(t.parentNode.children,function(c){c.classList.remove('cz-on');}); t.classList.add('cz-on');
    var p=PRODUCTS[state.product];
    if(IS_PO && state.product!=='frame' && typeof framePhoto==='function') framePhoto(false);
    refreshStyles();
    $('cz-price').textContent=p.price; $('cz-spec').textContent=p.spec;
    $('cz-cap').innerHTML='<b>'+p.label.split(' · ')[0]+'</b> · '+p.label.split(' · ').slice(1).join(' · ');
    toggleSize();
    showSlide(0);
  });

  ['cz-title','cz-loc','cz-name','cz-dist','cz-h','cz-m','cz-s','cz-pace','cz-date'].forEach(function(id){ var e=$(id); if(e) e.addEventListener('input',render); });
  (function(){ var e=$('cz-sf'); if(e) e.addEventListener('change',function(){
    _sfTouched=true;      /* 30 Oct: the customer's own choice outranks the default */
    /* On the map style the markers live in the tile, so it has to be refetched. */
    if(state.style==='terrain' && state.terrainBase){ state.mapImg=terrainWithSf(state.terrainBase); render(); }
    else if(state.style==='map' && !state.mapUser){ ensureMap(render); } else { render(); }
  }); })();
  (function(){ var e=$('cz-km'); if(e) e.addEventListener('change',function(){
    /* Terrain: recomposite the built canvas. Map: the markers and halo are
       in the tile, so it is refetched. */
    if(state.style==='terrain' && state.terrainBase){ state.mapImg=terrainWithSf(state.terrainBase); render(); }
    else if(state.style==='map' && !state.mapUser){ ensureMap(render); } else { render(); }
  }); })();
  (function(){ var e=$('cz-ribbon'); if(e) e.addEventListener('change',function(){
    /* Gallery's panels change height with the ribbon, so its map is a new shape. */
    if(IS_GAL) galRibRefetch(); else render(); }); })();
  (function(){
    var pk=$('cz-galPick');
    if(pk) pk.onclick=function(){ if(typeof splitFilePick==='function') splitFilePick(); };
    var z=$('cz-galZoom');
    if(z) z.addEventListener('input',function(){
      galZoom=Math.max(1,Math.min(GAL_ZOOM_MAX,galZoomCap(),(parseInt(z.value,10)||100)/100));
      render(); galDpiNote();
    });
    var rs=$('cz-galReset');
    if(rs) rs.onclick=function(){ galPhotoReset(); if(z) z.value=100; render(); galDpiNote(); };
  })();
  $('cz-moreBtn').onclick=function(){ $('cz-opt').classList.toggle('cz-show');
    this.textContent=$('cz-opt').classList.contains('cz-show')?'– Hide stats':'+ Add stats (distance, time, pace)'; };

  var drop=$('cz-drop'), file=$('cz-file');
  drop.onclick=function(){file.click();};
  file.onchange=function(e){ if(e.target.files[0]) handleFile(e.target.files[0]); };
  ['dragover','dragenter'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.add('cz-over');});});
  ['dragleave','drop'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.remove('cz-over');});});
  drop.addEventListener('drop',function(e){ var f=e.dataTransfer.files[0]; if(f) handleFile(f); });

  function handleFile(f){ if(isImageFile(f)) loadPhoto(f); else loadGPX(f); }
  /* Anything not obviously an image is worth offering to the route parser:
     iOS frequently reports a perfectly good GPX as application/octet-stream,
     and .tcx / .kml used to be sent to the image decoder and die there. */
  function isImageFile(f){
    return /^image\//i.test(f.type||'') ||
           /\.(png|jpe?g|jpe|heic|heif|webp|gif|bmp|tiff?)$/i.test(f.name||'');
  }
  function isGPX(f){ return !isImageFile(f); }

  function looksLikeMap(img){
    var s=Math.min(1,220/Math.max(img.width,img.height)), w=Math.max(1,Math.round(img.width*s)), h=Math.max(1,Math.round(img.height*s));
    var c=document.createElement('canvas'); c.width=w;c.height=h; var x=c.getContext('2d'); x.drawImage(img,0,0,w,h);
    var d; try{ d=x.getImageData(0,0,w,h).data; }catch(e){ return false; }
    var solid=0,total=w*h,i; for(i=0;i<d.length;i+=4){ if(d[i+3]<180)continue;
      if(d[i]>235&&d[i+1]>235&&d[i+2]>235)continue; solid++; }
    return (solid/total)>0.25;
  }

  function cropMapToRoute(img){
    var cap=1600, sc=Math.min(1,cap/Math.max(img.width,img.height));
    var w=Math.max(2,Math.round(img.width*sc)), h=Math.max(2,Math.round(img.height*sc));
    var c=document.createElement('canvas'); c.width=w;c.height=h; var x=c.getContext('2d'); x.drawImage(img,0,0,w,h);
    var d; try{ d=x.getImageData(0,0,w,h).data; }catch(e){ return c; }
    var N=w*h, bin=new Uint8Array(N), i;
    for(i=0;i<N;i++){ var o=i*4, r=d[o],g=d[o+1],b=d[o+2],a=d[o+3];
      bin[i]=(a>60 && (Math.max(r,g,b)-Math.min(r,g,b))>55 && Math.max(r,g,b)>90)?1:0; }
    
    var label=new Int32Array(N), stack=new Int32Array(N), cur=0, s;
    var cx0=[0],cy0=[0],cx1=[0],cy1=[0],carea=[0];
    for(s=0;s<N;s++){ if(bin[s]&&!label[s]){ cur++; var sp=0; stack[sp++]=s; label[s]=cur;
      var mnx=w,mny=h,mxx=0,mxy=0,cnt=0;
      while(sp>0){ var q=stack[--sp], qx=q%w, qy=(q/w)|0, dx,dy; cnt++;
        if(qx<mnx)mnx=qx; if(qx>mxx)mxx=qx; if(qy<mny)mny=qy; if(qy>mxy)mxy=qy;
        for(dy=-1;dy<=1;dy++){ var ny=qy+dy; if(ny<0||ny>=h)continue;
          for(dx=-1;dx<=1;dx++){ if(!dx&&!dy)continue; var nx=qx+dx; if(nx<0||nx>=w)continue;
            var ni=ny*w+nx; if(bin[ni]&&!label[ni]){ label[ni]=cur; stack[sp++]=ni; } } } }
      cx0[cur]=mnx;cy0[cur]=mny;cx1[cur]=mxx;cy1[cur]=mxy;carea[cur]=cnt; } }
    if(!cur) return c;

    var bestA=0,bi=0,k; for(k=1;k<=cur;k++){ if(carea[k]>bestA){ bestA=carea[k]; bi=k; } }
    if(!bi || Math.max(cx1[bi]-cx0[bi],cy1[bi]-cy0[bi])<w*0.05) return c;
    var minX=cx0[bi],minY=cy0[bi],maxX=cx1[bi],maxY=cy1[bi];
    var mgx=(maxX-minX)*0.05+w*0.008, mgy=(maxY-minY)*0.05+h*0.008;
    var x0=Math.max(0,Math.round(minX-mgx)), y0=Math.max(0,Math.round(minY-mgy));
    var cw=Math.min(w-x0,Math.round((maxX-minX)+2*mgx)), ch=Math.min(h-y0,Math.round((maxY-minY)+2*mgy));
    var oc=document.createElement('canvas'); oc.width=cw; oc.height=ch;
    oc.getContext('2d').drawImage(c, x0,y0,cw,ch, 0,0,cw,ch); return oc;
  }
  /* The customer's own route (or a fresh start) replaces any catalogue route,
     so ?r= comes off the address: currentRoute() reads it, and while it is
     there awaitingRoute() waits for that route's GPX instead of drawing the
     map, and its official gain, sport and copy keep applying. */
  function forgetRouteParam(){
    try{ if(getParam('r') && window.history && history.replaceState){
      var _u=new URL(window.location.href); _u.searchParams.delete('r');
      history.replaceState(null,'',_u.pathname+_u.search+_u.hash); } }catch(e){}
  }
  function loadPhoto(f){
    forgetRouteParam(); state.emptyRoute=false;
    state.srcFile=f; state.srcUrl=''; state.srcType='image';
    resetRouteData(); clearStats(); $('cz-title').value='My Milestone'; titleTouched=false;
    var img=new Image();
    img.onload=function(){
      if(looksLikeMap(img)){
        state.mapImg=cropMapToRoute(img); state.mapUser=true; state.mapUrl='user'; state.style='map'; markStyle('map');
        $('cz-dropTitle').textContent='✓ Map added — tap to replace';
      } else {
        processToMask(img); state.style='neon'; markStyle('neon');
        $('cz-dropTitle').textContent='✓ Route added — tap to replace';
      }
      drop.classList.add('cz-has'); showClear(true); refreshStyles(); render();
    };
    img.onerror=function(){ var t=$('cz-dropTitle');
      if(t) t.textContent='That file couldn’t be read — upload a GPX file or a screenshot.'; };
    img.src=URL.createObjectURL(f);
    runOCR(f);
  }

  function downsampleIdx(n,mx){ var o=[],i; if(n<=mx){ for(i=0;i<n;i++)o.push(i); return o; } var st=Math.ceil(n/mx); for(i=0;i<n;i+=st)o.push(i); if(o[o.length-1]!==n-1)o.push(n-1); return o; }
  function routeKm(c){ var R=6371,d=0,i; for(i=1;i<c.length;i++){ var a=c[i-1],b=c[i];
    var dLa=(b[0]-a[0])*Math.PI/180,dLo=(b[1]-a[1])*Math.PI/180,la1=a[0]*Math.PI/180,la2=b[0]*Math.PI/180;
    var h=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(la1)*Math.cos(la2)*Math.sin(dLo/2)*Math.sin(dLo/2);
    d+=2*R*Math.asin(Math.min(1,Math.sqrt(h))); } return d; }
  /* Kept the name because loadGPX and loadGPX2 both call it; it now tries
     GPX, then TCX, then KML, then GeoJSON, and returns the first that yields
     two or more points. All four are text, so nothing binary is attempted -
     .fit needs a real parser and is deliberately not handled here. */
  /* ---- a route as text -------------------------------------------------
     Lat/lon at 1e5, which is about 1.1 m - the same precision mapUrlFor()
     already rounds the static-map request to, so the stored track draws the
     same picture the GPX would have. Elevation in DECIMETRES: whole metres
     round away enough of the climb to move the number printed on a poster.

     The channels are interleaved rather than stored as three strings so there
     is one codec to get right instead of two, and a truncated string loses a
     whole point rather than silently pairing one route's latitudes with
     another's longitudes. */
  function _pvarEnc(v){
    v = (v<0) ? ~(v<<1) : (v<<1);
    var s='';
    while(v >= 0x20){ s += String.fromCharCode((0x20 | (v & 0x1f)) + 63); v >>>= 5; }
    return s + String.fromCharCode(v + 63);
  }
  function encodePoly(coords, eles){
    if(!coords || coords.length<2) return '';
    var s='', la=0, lo=0, el=0, i, nla, nlo, nel, c;
    for(i=0;i<coords.length;i++){
      c=coords[i]; if(!c || !isFinite(c[0]) || !isFinite(c[1])) continue;
      nla=Math.round(c[0]*1e5);
      nlo=Math.round(c[1]*1e5);
      nel=Math.round(((eles && isFinite(eles[i])) ? eles[i] : 0)*10);
      s += _pvarEnc(nla-la) + _pvarEnc(nlo-lo) + _pvarEnc(nel-el);
      la=nla; lo=nlo; el=nel;
    }
    return s;
  }
  function decodePoly(str){
    if(!str) return null;
    var s=String(str), n=s.length, i=0, la=0, lo=0, el=0;
    var coords=[], eles=[], any=false;
    function rd(){
      var r=0, sh=0, b;
      do{
        if(i>=n) return null;
        b=s.charCodeAt(i++)-63;
        if(b<0 || b>63) return null;          /* not our alphabet */
        r |= (b & 0x1f) << sh; sh += 5;
        if(sh>30) return null;                /* a run this long is corruption */
      } while(b >= 0x20);
      return (r & 1) ? ~(r >>> 1) : (r >>> 1);
    }
    while(i<n){
      var dla=rd(); if(dla===null) break;
      var dlo=rd(); if(dlo===null) break;
      var del=rd(); if(del===null) break;
      la+=dla; lo+=dlo; el+=del;
      if(la<-9000000 || la>9000000 || lo<-18000000 || lo>18000000) return null;
      coords.push([la/1e5, lo/1e5]); eles.push(el/10);
      if(el!==0) any=true;
    }
    if(coords.length<2) return null;
    /* A GPX with no elevation gives a null eles array, and the usable-relief
       test downstream is written for that. All-zero is the same thing. */
    return { coords:coords, eles:(any?eles:null) };
  }
  function parseGPX(text){
    if(typeof text!=='string' || !text) return null;
    var t=text.replace(/^\uFEFF/,'');
    var r = parseGPXText(t) || parseTCXText(t) || parseKMLText(t) || parseGeoJSONText(t);
    return (r && r.coords && r.coords.length>1) ? r : null;
  }
  function xmlDoc(text){
    if(!/^\s*</.test(text)) return null;
    var doc; try{ doc=new DOMParser().parseFromString(text,'application/xml'); }catch(e){ return null; }
    if(!doc || doc.getElementsByTagName('parsererror').length) return null;
    return doc;
  }
  /* getElementsByTagName is namespace-sensitive in XML documents and KML and
     TCX both declare default namespaces, so match on local name instead. */
  function byLocal(doc,name){
    var all=doc.getElementsByTagName('*'), out=[], i;
    for(i=0;i<all.length;i++){ if((all[i].localName||all[i].nodeName||'').toLowerCase()===name) out.push(all[i]); }
    return out;
  }
  function firstText(el,name){
    var k=el.getElementsByTagName('*'), i;
    for(i=0;i<k.length;i++){ if((k[i].localName||k[i].nodeName||'').toLowerCase()===name) return k[i].textContent; }
    return null;
  }
  function parseGPXText(text){
    var doc=xmlDoc(text); if(!doc) return null;
    var nodes=byLocal(doc,'trkpt');
    if(!nodes.length) nodes=byLocal(doc,'rtept');
    if(!nodes.length) nodes=byLocal(doc,'wpt');
    if(!nodes.length) return null;
    var coords=[],eles=[],firstTime=null,times=[],i;
    for(i=0;i<nodes.length;i++){
      var la=parseFloat(nodes[i].getAttribute('lat')), lo=parseFloat(nodes[i].getAttribute('lon'));
      if(isNaN(la)||isNaN(lo)) continue;
      coords.push([la,lo]);
      var ee=firstText(nodes[i],'ele'); eles.push(ee!=null?parseFloat(ee):NaN);
      var te=firstText(nodes[i],'time'); if(!firstTime && te) firstTime=te;
      times.push(te ? Date.parse(te) : NaN);
    }
    /* Strava and Garmin write the activity into <trk><type>: running,
       cycling, road_biking, hiking... */
    return {coords:coords,eles:eles,firstTime:firstTime,times:times,sport:(function(){ var _t=byLocal(doc,'trk')[0]; return (_t&&firstText(_t,'type'))||''; })()};
  }
  function parseTCXText(text){
    var doc=xmlDoc(text); if(!doc) return null;
    var nodes=byLocal(doc,'trackpoint'); if(!nodes.length) return null;
    var coords=[],eles=[],firstTime=null,times=[],i;
    for(i=0;i<nodes.length;i++){
      var las=firstText(nodes[i],'latitudedegrees'), los=firstText(nodes[i],'longitudedegrees');
      if(las==null||los==null) continue;
      var la=parseFloat(las), lo=parseFloat(los);
      if(isNaN(la)||isNaN(lo)) continue;
      coords.push([la,lo]);
      var ee=firstText(nodes[i],'altitudemeters'); eles.push(ee!=null?parseFloat(ee):NaN);
      var te=firstText(nodes[i],'time'); if(!firstTime && te) firstTime=te;
      times.push(te ? Date.parse(te) : NaN);
    }
    var _act=byLocal(doc,'activity')[0];
    return {coords:coords,eles:eles,firstTime:firstTime,times:times,sport:(_act&&_act.getAttribute('Sport'))||''};
  }
  function parseKMLText(text){
    var doc=xmlDoc(text); if(!doc) return null;
    var blocks=byLocal(doc,'coordinates'); if(!blocks.length) return null;
    var coords=[],eles=[],b,i;
    for(b=0;b<blocks.length;b++){
      var parts=(blocks[b].textContent||'').trim().split(/\s+/);
      for(i=0;i<parts.length;i++){
        var c=parts[i].split(',');
        if(c.length<2) continue;
        var lo=parseFloat(c[0]), la=parseFloat(c[1]);
        if(isNaN(la)||isNaN(lo)) continue;
        coords.push([la,lo]); eles.push(c.length>2?parseFloat(c[2]):NaN);
      }
      if(coords.length>1) break;   /* first track wins, not every placemark */
    }
    return {coords:coords,eles:eles,firstTime:null};
  }
  function parseGeoJSONText(text){
    if(!/^\s*[\{\[]/.test(text)) return null;
    var j; try{ j=JSON.parse(text); }catch(e){ return null; }
    var coords=[], eles=[];
    function eat(arr){
      for(var i=0;i<arr.length;i++){
        var p=arr[i];
        if(typeof p[0]==='number' && typeof p[1]==='number'){
          coords.push([p[1],p[0]]); eles.push(p.length>2?p[2]:NaN);
        }
      }
    }
    function walk(o,depth){
      if(!o || typeof o!=='object' || depth>8) return;
      if(o.type==='LineString' && o.coordinates) eat(o.coordinates);
      else if(o.type==='MultiLineString' && o.coordinates){
        for(var m=0;m<o.coordinates.length;m++) eat(o.coordinates[m]);
      }
      else if(o.geometry) walk(o.geometry,depth+1);
      else if(o.features){ for(var f=0;f<o.features.length && coords.length<2;f++) walk(o.features[f],depth+1); }
      else if(o.geometries){ for(var g=0;g<o.geometries.length && coords.length<2;g++) walk(o.geometries[g],depth+1); }
    }
    walk(j,0);
    return {coords:coords,eles:eles,firstTime:null};
  }
  function projectFit(coords,S,pad){
    var i,lats=[],lons=[]; for(i=0;i<coords.length;i++){lats.push(coords[i][0]);lons.push(coords[i][1]);}
    var minLa=Math.min.apply(null,lats),maxLa=Math.max.apply(null,lats),k=Math.cos((minLa+maxLa)/2*Math.PI/180);
    var xs=[],ys=[]; for(i=0;i<coords.length;i++){xs.push(coords[i][1]*k);ys.push(coords[i][0]);}
    var minX=Math.min.apply(null,xs),maxX=Math.max.apply(null,xs),minY=Math.min.apply(null,ys),maxY=Math.max.apply(null,ys);
    var spanX=(maxX-minX)||1e-6,spanY=(maxY-minY)||1e-6;
    var s=Math.min(S*(1-2*pad)/spanX,S*(1-2*pad)/spanY),offX=(S-spanX*s)/2,offY=(S-spanY*s)/2;
    var pts=[]; for(i=0;i<coords.length;i++){ pts.push([offX+(xs[i]-minX)*s, offY+(maxY-ys[i])*s]); }
    return {pts:pts, bbox:{x:offX,y:offY,w:spanX*s,h:spanY*s}};
  }
  function gpxToCanvas(coords){
    var S=1000,c=document.createElement('canvas');c.width=S;c.height=S;
    var x=c.getContext('2d');x.fillStyle='#fff';x.fillRect(0,0,S,S);
    var pj=projectFit(coords,S,0.12).pts,i;
    x.strokeStyle='#111';x.lineWidth=Math.max(4,S*0.012);x.lineCap='round';x.lineJoin='round';x.beginPath();
    for(i=0;i<pj.length;i++){ i?x.lineTo(pj[i][0],pj[i][1]):x.moveTo(pj[i][0],pj[i][1]); }
    x.stroke(); return c;
  }
  function egrad(t){ t=t<0?0:t>1?1:t;
    var st=[[0,[255,240,190]],[0.5,[255,140,40]],[1,[214,40,20]]],i;
    for(i=0;i<st.length-1;i++){ var a=st[i],b=st[i+1];
      if(t<=b[0]){ var f=(t-a[0])/((b[0]-a[0])||1);
        return 'rgb('+Math.round(a[1][0]+(b[1][0]-a[1][0])*f)+','+Math.round(a[1][1]+(b[1][1]-a[1][1])*f)+','+Math.round(a[1][2]+(b[1][2]-a[1][2])*f)+')'; } }
    return 'rgb(214,40,20)';
  }
  function buildHeatCanvas(coords,eles){
    var S=1000,c=document.createElement('canvas');c.width=S;c.height=S;
    var x=c.getContext('2d'),pf=projectFit(coords,S,0.10),pj=pf.pts,i;
    var emin=Infinity,emax=-Infinity; for(i=0;i<eles.length;i++){ if(isFinite(eles[i])){ if(eles[i]<emin)emin=eles[i]; if(eles[i]>emax)emax=eles[i]; } }
    var has=(emax-emin)>1, lw=Math.max(4,S*0.013);
    x.save(); x.strokeStyle='rgba(255,120,40,0.45)'; x.lineWidth=lw*1.9; x.lineCap='round'; x.lineJoin='round';
    x.shadowColor='rgba(255,120,40,0.85)'; x.shadowBlur=lw*1.3; x.beginPath();
    for(i=0;i<pj.length;i++){ i?x.lineTo(pj[i][0],pj[i][1]):x.moveTo(pj[i][0],pj[i][1]); } x.stroke(); x.restore();
    x.lineWidth=lw; x.lineCap='round'; x.lineJoin='round';
    for(i=0;i<pj.length-1;i++){ var t=has&&isFinite(eles[i])?((eles[i]-emin)/(emax-emin)):0.5;
      x.strokeStyle=egrad(t); x.beginPath(); x.moveTo(pj[i][0],pj[i][1]); x.lineTo(pj[i+1][0],pj[i+1][1]); x.stroke(); }
    state.heatCanvas=c;
    var m=lw*2.8, bx=Math.max(0,pf.bbox.x-m), by=Math.max(0,pf.bbox.y-m);
    state.heatBbox={x:bx, y:by, w:Math.min(S-bx,pf.bbox.w+2*m), h:Math.min(S-by,pf.bbox.h+2*m)};
  }
  function encPoly(coords){ var out=[],plat=0,plon=0,i;
    function enc(v){ v=v<0?~(v<<1):(v<<1); while(v>=0x20){out.push(String.fromCharCode((0x20|(v&0x1f))+63));v>>=5;} out.push(String.fromCharCode(v+63)); }
    for(i=0;i<coords.length;i++){ var la=Math.round(coords[i][0]*1e5),lo=Math.round(coords[i][1]*1e5); enc(la-plat); enc(lo-plon); plat=la;plon=lo; } return out.join(''); }
  function dpSimplify(pts,tol){
    if(pts.length<3) return pts.slice();
    var keep=new Array(pts.length); keep[0]=keep[pts.length-1]=true;
    var stack=[[0,pts.length-1]];
    while(stack.length){ var seg=stack.pop(),s=seg[0],e=seg[1],maxd=-1,idx=-1;
      var ax=pts[s][1],ay=pts[s][0],bx=pts[e][1],by=pts[e][0],dx=bx-ax,dy=by-ay,len=Math.sqrt(dx*dx+dy*dy),i;
      /* A closed loop: both ends are the same point, so measure distance to
         it - against a zero-length line every point measured 0 and the whole
         route was dropped. */
      for(i=s+1;i<e;i++){ var d=(len>1e-12)?Math.abs((pts[i][1]-ax)*dy-(pts[i][0]-ay)*dx)/len
                                           :Math.sqrt((pts[i][1]-ax)*(pts[i][1]-ax)+(pts[i][0]-ay)*(pts[i][0]-ay));
        if(d>maxd){maxd=d;idx=i;} }
      if(maxd>tol&&idx>-1){ keep[idx]=true; stack.push([s,idx]); stack.push([idx,e]); } }
    var out=[],j; for(j=0;j<pts.length;j++) if(keep[j]) out.push(pts[j]); return out;
  }

  function isMapLike(s){ return s==='map' || s==='terrain'; }
  var TDEM='https://s3.amazonaws.com/elevation-tiles-prod/terrarium/', TMAXZ=15, TSIZE=256, TMAXT=32;

  /* Neon design: the map panel is now the editorial panel (landscape, ~1.09),
     so terrain is built at that aspect and cover-fit, like the Geoapify tile. */
  var TOUT_W=2500, TOUT_H=2300;
  /* Editorial's map window is landscape and the draw is a cover fit, so the
     terrain has to be built at that aspect or it loses ~30% of its height to
     the clip. Mirrors the 1000x780 vs 800x1000 the static map already uses. */
  var TOUT_E_W=2500, TOUT_E_H=1950;
  /* Terrain covers the whole tile, so the terrain is built at the tile
     aspect or a cover fit crops. Tile is A3, 0.70714. */
  var TOUT_F_W=1950, TOUT_F_H=2758;
  /* The frame's panel is 107 x 185 mm. Terrain is built here rather than
     fetched, so the panel ratio work on the static map never reached it and a
     0.71 canvas was being cover-fitted into a 0.58 panel. */
  var TOUT_FR_W=1600;
  /* Gallery's terrain fills one tall column rather than a full-width panel, so
     it is narrower than the others at comparable detail. */
  var TOUT_GAL_W=1400;
  function toutDims(){
    var _fp=(typeof focusProd==='function') ? focusProd() : state.product;
    if(_fp==='frame') return [TOUT_FR_W, Math.round(TOUT_FR_W/FR_AR)];
    /* planTerrain() pads the route out to whatever aspect it is handed - the
       same job galPadArea does for the static map. Hand it the neon tile's
       shape, as this did, and a wide route is padded to the wrong shape and
       then cover-cropped by the gallery panel. */
    if(ndOn()) return [TOUT_GAL_W, Math.round(TOUT_GAL_W/Math.max(0.05,ndArtAR(_fp)))];
    if(IS_GAL) return [TOUT_GAL_W,
                       Math.round(TOUT_GAL_W/Math.max(0.05,galAspectFor(_fp)))];
    return IS_TD ? [TOUT_F_W,TOUT_F_H]
                 : (IS_EDT ? [TOUT_E_W,TOUT_E_H] : [TOUT_W,TOUT_H]); }
  /* Map labels over water leave small islands of road/land class behind.
     Return to water any non-water component that is small, enclosed (does not
     touch the tile edge) and low (< 3 m). Returns the number of pixels fixed. */
  var TLABEL_MAX=4000;
  function cleanWaterLabels(CLS,ele,mw,mh){
    var n=mw*mh, lab=new Int32Array(n), q=new Int32Array(n), nc=0, fixed=0, s0;
    for(s0=0;s0<n;s0++){
      if(lab[s0] || CLS[s0]===1) continue;
      nc++; var qh=0, qt=0, emax=-1e9, edge=false;
      lab[s0]=nc; q[qt++]=s0;
      while(qh<qt){
        var ci=q[qh++]; if(ele[ci]>emax) emax=ele[ci];
        var yy=(ci/mw)|0, xx=ci-yy*mw;
        if(xx===0||yy===0||xx===mw-1||yy===mh-1) edge=true;
        if(xx>0    && !lab[ci-1]  && CLS[ci-1]!==1) { lab[ci-1]=nc;  q[qt++]=ci-1; }
        if(xx<mw-1 && !lab[ci+1]  && CLS[ci+1]!==1) { lab[ci+1]=nc;  q[qt++]=ci+1; }
        if(yy>0    && !lab[ci-mw] && CLS[ci-mw]!==1){ lab[ci-mw]=nc; q[qt++]=ci-mw; }
        if(yy<mh-1 && !lab[ci+mw] && CLS[ci+mw]!==1){ lab[ci+mw]=nc; q[qt++]=ci+mw; }
      }
      if(!edge && qt<=TLABEL_MAX && emax<3.0){
        for(var z=0;z<qt;z++) CLS[q[z]]=1;
        fixed+=qt;
      }
    }
    return fixed;
  }
  function _lon2t(lon,z){ return (lon+180)/360*Math.pow(2,z); }
  function _lat2t(lat,z){ var r=lat*Math.PI/180; return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2*Math.pow(2,z); }

  /* Vertical exaggeration applied on top of the auto factor below. Override
     for tuning with ?exag=N on any page carrying the customiser. */
  var TERRAIN_EXAG = 4;
  /* Multidirectional hillshade (22 Oct pm): four lights blended, SW, W, NW
     and N with NW the strongest, then darkened by slope. The blend narrows
     the light-to-shadow range, so it is stretched back about flat ground. */
  var TERRAIN_LIGHTS = [[225,0.20],[270,0.25],[315,0.35],[360,0.20]];
  var TERRAIN_SLOPE_DARK = 0.35;   // darkening at and past TERRAIN_SLOPE_REF
  var TERRAIN_SLOPE_REF = 50;      // degrees, after exaggeration
  var TERRAIN_STRETCH = 1.85;
  /* Both of these only ever grow water. Switchable so a canal city can be
     rendered with each one off and the culprit identified by eye. */
  var TERRAIN_ROADFIX = 1;   // road/urban pixels surrounded by water become water
  var TERRAIN_CSMOOTH = 2;   // passes of 3x3 majority smoothing over the classes
  try{
    var _qs = location.search || '';
    var _exm = /[?&]exag=([0-9.]+)/.exec(_qs);
    if(_exm){ var _exv = parseFloat(_exm[1]);
      if(isFinite(_exv) && _exv > 0 && _exv <= 20) TERRAIN_EXAG = _exv; }
    var _rdm = /[?&]crd=([01])/.exec(_qs);
    if(_rdm) TERRAIN_ROADFIX = +_rdm[1];
    var _csm = /[?&]csm=([0-4])/.exec(_qs);
    if(_csm) TERRAIN_CSMOOTH = +_csm[1];
  }catch(e){}

  /* The Terrain design's route box: above the title, below the date bar. */
  var TERRAIN_TD_BOX=[0.085,0.165,0.915,0.625];
  function planTerrain(coords,W,H,box){
    if(!coords||coords.length<2) return null;
    var minLa=Infinity,maxLa=-Infinity,minLo=Infinity,maxLo=-Infinity,i;
    for(i=0;i<coords.length;i++){ var la=coords[i][0],lo=coords[i][1];
      if(!isFinite(la)||!isFinite(lo)) continue;
      if(la<minLa)minLa=la; if(la>maxLa)maxLa=la; if(lo<minLo)minLo=lo; if(lo>maxLo)maxLo=lo; }
    if(!isFinite(minLa)||!isFinite(minLo)) return null;
    if(box){
      /* fit the route into the box, then the terrain out to the whole sheet */
      var mxf=function(lo){ return (lo+180)/360; }, myf=function(la){ var r=la*Math.PI/180; return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2; };
      var X0=mxf(minLo), X1=mxf(maxLo), Y0=myf(maxLa), Y1=myf(minLa), tiny=0.0006/360;
      if(X1-X0<tiny){ X0-=tiny/2; X1+=tiny/2; } if(Y1-Y0<tiny){ Y0-=tiny/2; Y1+=tiny/2; }
      var bw=(box[2]-box[0])*W, bh=(box[3]-box[1])*H, sc=Math.min(bw/(X1-X0), bh/(Y1-Y0));
      var ox=box[0]*W+(bw-(X1-X0)*sc)/2, oy=box[1]*H+(bh-(Y1-Y0)*sc)/2;
      var WX0=X0-ox/sc, WX1=WX0+W/sc, WY0=Y0-oy/sc, WY1=WY0+H/sc;
      var ila=function(y){ return Math.atan(Math.sinh(Math.PI*(1-2*y)))*180/Math.PI; };
      minLo=WX0*360-180; maxLo=WX1*360-180; maxLa=ila(WY0); minLa=ila(WY1);
    } else {
    var _tmg=(typeof DESIGN_KIND!=='undefined' && DESIGN_KIND==='rings') ? 0.30 : 0.15;
    var mLa=Math.max((maxLa-minLa)*_tmg,0.0006), mLo=Math.max((maxLo-minLo)*_tmg,0.0006);
    minLa-=mLa; maxLa+=mLa; minLo-=mLo; maxLo+=mLo;
    }
    var t=W/H,z;
    for(z=TMAXZ;z>=1;z--){
      var wx0=_lon2t(minLo,z)*TSIZE, wx1=_lon2t(maxLo,z)*TSIZE;
      var wy0=_lat2t(maxLa,z)*TSIZE, wy1=_lat2t(minLa,z)*TSIZE;
      var cw=wx1-wx0, ch=wy1-wy0;
      if(cw/ch>t){ var nh=cw/t,d=(nh-ch)/2; wy0-=d; wy1+=d; ch=nh; }
      else { var nw=ch*t,e=(nw-cw)/2; wx0-=e; wx1+=e; cw=nw; }
      var x0=Math.floor(wx0/TSIZE), x1=Math.floor((wx1-0.0001)/TSIZE);
      var y0=Math.floor(wy0/TSIZE), y1=Math.floor((wy1-0.0001)/TSIZE);
      var nx=x1-x0+1, ny=y1-y0+1;
      if(nx*ny<=TMAXT) return {z:z,x0:x0,y0:y0,nx:nx,ny:ny,lat:(minLa+maxLa)/2,
        crop:{x:wx0-x0*TSIZE,y:wy0-y0*TSIZE,w:cw,h:ch}};
    }
    return null;
  }
  function terrainKey(coords){ var _td=toutDims(), p=planTerrain(coords,_td[0],_td[1],IS_TD?TERRAIN_TD_BOX:null);
    return p?('t:'+p.z+':'+p.x0+':'+p.y0+':'+p.nx+':'+p.ny+':'+TSHADE+':'+TTINT+':'+(state.terrainTheme||'standard')+':x'+TERRAIN_EXAG+':r'+TERRAIN_ROADFIX+':s'+TERRAIN_CSMOOTH+':c'+routeHex()+':e'+(IS_EDT?1:0)+(IS_TD?'f':'')+(IS_GAL?'g':'')+':n3'+(TTINT==='topo'&&MAPKEY?':m':'')+((typeof tplOn==='function'&&tplOn())?':pl':'')+(IS_TD?':fb':'')):''; }
  function contourStep(range){ var s=[5,10,20,25,50,100,200,250,500,1000],t=range/10,i;
    for(i=0;i<s.length;i++) if(s[i]>=t) return s[i]; return 1000; }
  
  /* ==== Terrain: suburb names along the route (29 Oct, Marc: "Improve terrain
     design with suburb names like 3d design") ===============================
     The same names, the same rule as the 3D design: OpenStreetMap places
     (city, town, suburb, village, neighbourhood) from OpenFreeMap's vector
     tiles, kept only inside small squares laid along the track - every r
     metres, r = length/25 between 800 m and 3 km. No key, no MapLibre: the
     place layer is read straight out of the tiles (a small vector-tile
     reader below). Drawn under the route, kept clear of the type, and left
     out entirely if the tiles can't be had - the poster is complete without
     them. Every single-sport design's terrain look (29 Oct pm, Marc: "all
     terrain in other designs to have the suburb name"); the triathlon builds
     its terrain its own way and is not included. */
  var TPL_OFM='https://tiles.openfreemap.org/planet', TPL_CLASSES={city:0,town:1,suburb:2,village:3,neighbourhood:4}, TPL_WAIT=9000;
  var TPL={ tpl:null, tplWait:[], tiles:{} };
  function tplOn(){
    if(typeof IS_TRI!=='undefined' && IS_TRI) return false;
    return state.style==='terrain' && !(typeof sbOn==='function' && sbOn()) && !(typeof t3On==='function' && t3On());
  }
  function tplHav(a,b){   /* [lat,lon] */
    var R=6371008.8,r=Math.PI/180,dla=(b[0]-a[0])*r,dlo=(b[1]-a[1])*r;
    var h=Math.sin(dla/2)*Math.sin(dla/2)+Math.cos(a[0]*r)*Math.cos(b[0]*r)*Math.sin(dlo/2)*Math.sin(dlo/2);
    return 2*R*Math.asin(Math.min(1,Math.sqrt(h)));
  }
  /* The 3D design's corridor: squares of half-side r along the track. */
  function tplCorridor(coords){
    var total=0, i, ok=[];
    for(i=0;i<coords.length;i++) if(isFinite(coords[i][0]) && isFinite(coords[i][1])) ok.push(coords[i]);
    if(ok.length<2) return null;
    for(i=1;i<ok.length;i++) total+=tplHav(ok[i-1],ok[i]);
    var r=Math.max(800,Math.min(3000,total/25)), acc=r, sq=[], lat0=ok[0][0]*Math.PI/180;
    var dLa=r/111320, dLo=r/(111320*Math.cos(lat0));
    for(i=0;i<ok.length;i++){
      if(i>0) acc+=tplHav(ok[i-1],ok[i]);
      if(acc<r && i!==ok.length-1) continue; acc=0;
      sq.push([ok[i][0]-dLa, ok[i][0]+dLa, ok[i][1]-dLo, ok[i][1]+dLo]);
      if(sq.length>=200) break;
    }
    return sq;
  }
  function tplInside(sq,la,lo){
    for(var i=0;i<sq.length;i++){ var q=sq[i]; if(la>=q[0] && la<=q[1] && lo>=q[2] && lo<=q[3]) return true; }
    return false;
  }
  /* ---- a minimal Mapbox Vector Tile reader: the place layer's points ------- */
  function tplVarint(b,s){ var v=0, m=1, c; do { c=b[s.p++]; v+=(c&0x7f)*m; m*=128; } while(c>=0x80 && s.p<b.length); return v; }
  function tplSkip(b,s,wt){ if(wt===0) tplVarint(b,s); else if(wt===1) s.p+=8; else if(wt===2){ var l=tplVarint(b,s); s.p+=l; } else if(wt===5) s.p+=4; else s.p=b.length; }
  function tplStr(b,a,e){ var o='', i; for(i=a;i<e;i++) o+='%'+(b[i]<16?'0':'')+b[i].toString(16);
    try{ return decodeURIComponent(o); }catch(x){ return ''; } }
  function tplValue(b,a,e){
    var s={p:a}, v=null;
    while(s.p<e){ var k=tplVarint(b,s), f=Math.floor(k/8), wt=k&7;
      if(f===1 && wt===2){ var l=tplVarint(b,s); v=tplStr(b,s.p,s.p+l); s.p+=l; }
      else if(f===2 && wt===5){ v=new DataView(b.buffer,b.byteOffset+s.p,4).getFloat32(0,true); s.p+=4; }
      else if(f===3 && wt===1){ v=new DataView(b.buffer,b.byteOffset+s.p,8).getFloat64(0,true); s.p+=8; }
      else if((f===4||f===5) && wt===0) v=tplVarint(b,s);
      else if(f===6 && wt===0){ var z=tplVarint(b,s); v=(z%2)?-(z+1)/2:z/2; }
      else if(f===7 && wt===0) v=!!tplVarint(b,s);
      else tplSkip(b,s,wt);
    }
    return v;
  }
  function tplLayer(b,a,e,tz,tx,ty,out){
    var s={p:a}, name='', keys=[], vals=[], feats=[], ext=4096;
    while(s.p<e){ var k=tplVarint(b,s), f=Math.floor(k/8), wt=k&7, l;
      if(f===1 && wt===2){ l=tplVarint(b,s); name=tplStr(b,s.p,s.p+l); s.p+=l; }
      else if(f===2 && wt===2){ l=tplVarint(b,s); feats.push([s.p,s.p+l]); s.p+=l; }
      else if(f===3 && wt===2){ l=tplVarint(b,s); keys.push(tplStr(b,s.p,s.p+l)); s.p+=l; }
      else if(f===4 && wt===2){ l=tplVarint(b,s); vals.push(tplValue(b,s.p,s.p+l)); s.p+=l; }
      else if(f===5 && wt===0) ext=tplVarint(b,s);
      else tplSkip(b,s,wt);
    }
    if(name!=='place') return;
    var n2=Math.pow(2,tz);
    feats.forEach(function(fe){
      var s2={p:fe[0]}, tags=[], geom=[], type=0;
      while(s2.p<fe[1]){ var k2=tplVarint(b,s2), f2=Math.floor(k2/8), w2=k2&7, l2, end;
        if((f2===2||f2===4) && w2===2){ l2=tplVarint(b,s2); end=s2.p+l2; var arr=(f2===2)?tags:geom; while(s2.p<end) arr.push(tplVarint(b,s2)); }
        else if(f2===3 && w2===0) type=tplVarint(b,s2);
        else tplSkip(b,s2,w2);
      }
      if(type!==1 || geom.length<3 || (geom[0]&7)!==1) return;
      var zz=function(v){ return (v%2)?-(v+1)/2:v/2; }, px=zz(geom[1]), py=zz(geom[2]);
      var pr={}, i;
      for(i=0;i+1<tags.length;i+=2) pr[keys[tags[i]]]=vals[tags[i+1]];
      var wx=(tx+px/ext)/n2, wy=(ty+py/ext)/n2;
      var lon=wx*360-180, lat=Math.atan(Math.sinh(Math.PI*(1-2*wy)))*180/Math.PI;
      out.push({ name:String(pr['name:en']||pr['name_en']||pr['name']||''), cls:String(pr['class']||''), rank:+pr['rank']||99, lat:lat, lon:lon });
    });
  }
  function tplDecode(buf,tz,tx,ty){
    var b=new Uint8Array(buf), s={p:0}, out=[];
    while(s.p<b.length){ var k=tplVarint(b,s), f=Math.floor(k/8), wt=k&7;
      if(f===3 && wt===2){ var l=tplVarint(b,s); tplLayer(b,s.p,s.p+l,tz,tx,ty,out); s.p+=l; }
      else tplSkip(b,s,wt);
    }
    return out;
  }
  /* ---- fetching ------------------------------------------------------------ */
  function tplTemplate(cb){
    if(TPL.tpl) { cb(TPL.tpl); return; }
    TPL.tplWait.push(cb); if(TPL.tplWait.length>1) return;
    var done=function(t){ TPL.tpl=t||''; var w=TPL.tplWait; TPL.tplWait=[]; w.forEach(function(f){ f(TPL.tpl); }); if(!t) TPL.tpl=null; };
    try{
      fetch(TPL_OFM).then(function(r){ return r.ok?r.json():null; })
        .then(function(j){ done(j && j.tiles && j.tiles[0] ? j.tiles[0] : ''); }, function(){ done(''); });
    }catch(e){ done(''); }
  }
  function tplTile(url,tz,tx,ty,cb){
    if(TPL.tiles.hasOwnProperty(url)){ cb(TPL.tiles[url]); return; }
    try{
      fetch(url).then(function(r){ return r.ok?r.arrayBuffer():null; })
        .then(function(buf){ var l=null; try{ l=buf?tplDecode(buf,tz,tx,ty):null; }catch(e){ console.warn('Milestone: place tile unreadable',e); }
                             if(l) TPL.tiles[url]=l; cb(l||[]); }, function(){ cb([]); });
    }catch(e){ cb([]); }
  }
  /* The places for this route: deduplicated by name, best first. cb(list),
     always, within TPL_WAIT. */
  function tplFetch(coords,cb){
    var sq=tplCorridor(coords||[]); if(!sq){ cb([]); return; }
    var called=false, fin=function(l){ if(called) return; called=true; cb(l); };
    var to=setTimeout(function(){ fin([]); },TPL_WAIT);
    var t2=function(lo,z){ return Math.floor((lo+180)/360*Math.pow(2,z)); };
    var t2y=function(la,z){ var r=la*Math.PI/180; return Math.floor((1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2*Math.pow(2,z)); };
    var tilesAt=function(z){ var seen={}, list=[];
      sq.forEach(function(q){ var x0=t2(q[2],z), x1=t2(q[3],z), y0=t2y(q[1],z), y1=t2y(q[0],z), x, y;
        for(x=x0;x<=x1;x++) for(y=y0;y<=y1;y++){ var k=x+'/'+y; if(!seen[k]){ seen[k]=1; list.push([z,x,y]); } } });
      return list; };
    /* the finest zoom whose corridor is a sensible number of tiles */
    var z=13, T=tilesAt(z);
    while(T.length>36 && z>11){ z--; T=tilesAt(z); }
    if(T.length>48) T=T.slice(0,48);
    tplTemplate(function(tpl){
      if(!tpl){ clearTimeout(to); fin([]); return; }
      var left=T.length, all=[];
      T.forEach(function(t){
        var url=tpl.replace('{z}',t[0]).replace('{x}',t[1]).replace('{y}',t[2]);
        tplTile(url,t[0],t[1],t[2],function(l){
          all=all.concat(l);
          if(--left>0) return;
          clearTimeout(to);
          var seen={}, out=[];
          all.filter(function(p){ return p.name && TPL_CLASSES.hasOwnProperty(p.cls) && tplInside(sq,p.lat,p.lon); })
             .sort(function(a,b){ return (TPL_CLASSES[a.cls]-TPL_CLASSES[b.cls]) || (a.rank-b.rank); })
             .forEach(function(p){ var k=p.name.toUpperCase(); if(!seen[k]){ seen[k]=1; out.push(p); } });
          /* the suburbs at the start and the finish lead (29 Oct pm, Marc: "make
             sure suburb name from the start is also available"): the nearest
             named place to each end, within the corridor */
          var ends=[coords[0], coords[coords.length-1]], lead=[];
          ends.forEach(function(e,ei){ var bi=-1, bd=1e18;
            out.forEach(function(p,j){ var d2=tplHav(e,[p.lat,p.lon]); if(d2<bd){ bd=d2; bi=j; } });
            if(bi>=0 && lead.indexOf(out[bi])<0){ out[bi].end=ei?'finish':'start'; lead.push(out[bi]); } });
          fin(lead.concat(out.filter(function(p){ return lead.indexOf(p)<0; })));
        });
      });
      if(!T.length){ clearTimeout(to); fin([]); }
    });
  }
  /* ---- drawing, inside paintTerrain, before the route goes on --------------- */
  function tplDraw(ctx,p,W,H,S,places,coords,o){
    o=o||{};
    var proj=function(la,lo){ var wx=_lon2t(lo,p.z)*TSIZE-p.x0*TSIZE, wy=_lat2t(la,p.z)*TSIZE-p.y0*TSIZE;
      return [(wx-p.crop.x)/p.crop.w*W,(wy-p.crop.y)/p.crop.h*H]; };
    var step=Math.max(1,Math.floor(coords.length/600)), rp=[], i;
    for(i=0;i<coords.length;i+=step) rp.push(proj(coords[i][0],coords[i][1]));
    var items=places.map(function(pl){ var c=proj(pl.lat,pl.lon); return { name:pl.name, cls:pl.cls, x:c[0], y:c[1] }; });
    /* where the type goes: the date / name / scale bar at the top, the title
       and stats at the foot (renderTerrainDesign) - a map panel (the phone
       files, the other designs' windows) has its own edges only */
    return tplPlace(ctx,W,H,items,rp,{ S:S, dark:o.dark, circle:o.circle, max:o.panel?8:14,
      keep:o.panel ? [] : [[0,0,W,H*0.135],[W*0.55,0,W,H*0.19],[0,H*0.655,W,H]] });
  }
  /* Place and draw names at screen points (items: name, cls, x, y), best
     first, clear of the route (rp), of keep boxes and of each other; o.S is
     the size unit (W/800), o.k scales the type, o.dark light-on-dark.
     Shared by the terrain (tplDraw) and the 3D design (t3_module). */
  function tplPlace(ctx,W,H,items,rp,o){
    o=o||{};
    var S=o.S||W/800, keep=o.keep||[], max=o.max||14, kk=o.k||1, mg=W*0.04, i;
    var inCircle=function(bx){ if(!o.circle) return true; var cx=W/2, cy=H/2, r=Math.min(W,H)/2*0.94;
      return [[bx[0],bx[1]],[bx[2],bx[1]],[bx[0],bx[3]],[bx[2],bx[3]]].every(function(q){ var dx=q[0]-cx, dy=q[1]-cy; return dx*dx+dy*dy<=r*r; }); };
    var placed=[], drawn=[];
    var hit=function(a,b){ return a[0]<b[2] && a[2]>b[0] && a[1]<b[3] && a[3]>b[1]; };
    var onRoute=function(bx){ var n=0; for(var j=0;j<rp.length;j++){ var q=rp[j]; if(q[0]>bx[0] && q[0]<bx[2] && q[1]>bx[1] && q[1]<bx[3]) n++; } return n; };
    ctx.save(); ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.lineJoin='round';
    for(i=0;i<items.length && drawn.length<max;i++){
      var pl=items[i], c=[pl.x,pl.y];
      if(!(isFinite(c[0]) && isFinite(c[1]) && c[0]>mg && c[0]<W-mg && c[1]>mg && c[1]<H-mg)) continue;
      var fs=kk*S*(pl.cls==='city'?19:(pl.cls==='town'?16:14)), txt=spaced(pl.name.toUpperCase(),0.12);
      ctx.font='700 '+fs+'px Inter,sans-serif';
      var w=ctx.measureText(txt).width, h=fs*1.1, pad=fs*0.6, best=null;
      /* on the spot, else close by - above, below, either side - never on top
         of the route, which so often runs through the suburb's middle */
      var sx=w/2+fs*0.9;
      [[0,0],[0,-1.15],[0,1.15],[sx,0],[-sx,0],[0,-2.2],[0,2.2],[sx,-1.15],[-sx,-1.15],[sx,1.15],[-sx,1.15]].forEach(function(d){
        if(best) return;
        var x=c[0]+d[0], y=c[1]+d[1]*h, bx=[x-w/2-pad,y-h/2-pad*0.5,x+w/2+pad,y+h/2+pad*0.5];
        if(bx[0]<mg*0.5 || bx[2]>W-mg*0.5 || bx[1]<mg*0.5 || bx[3]>H-mg*0.5) return;
        if(!inCircle(bx)) return;
        for(var k=0;k<keep.length;k++) if(hit(bx,keep[k])) return;
        for(k=0;k<placed.length;k++) if(hit(bx,placed[k])) return;
        if(onRoute([bx[0]+pad,bx[1]+pad*0.5,bx[2]-pad,bx[3]-pad*0.5])>0) return;
        best=[x,y,bx];
      });
      if(!best) continue;
      placed.push(best[2]);
      ctx.lineWidth=Math.max(1.5,fs*0.24);
      ctx.strokeStyle=o.dark?'rgba(10,12,16,0.62)':'rgba(255,253,248,0.78)';
      ctx.strokeText(txt,best[0],best[1]);
      ctx.fillStyle=o.dark?'rgba(243,239,231,0.86)':'rgba(40,36,30,0.80)';
      ctx.fillText(txt,best[0],best[1]);
      drawn.push(pl.name);
    }
    ctx.restore();
    return drawn;
  }

  function buildTerrain(coords,cb,dims){
    var _td=dims||toutDims(), W=_td[0], H=_td[1], p=planTerrain(coords,W,H,(!dims && IS_TD)?TERRAIN_TD_BOX:null);
    if(!p){ cb(null); return; }
    var mw=p.nx*TSIZE, mh=p.ny*TSIZE;
    var mos=document.createElement('canvas'); mos.width=mw; mos.height=mh;
    var mc=mos.getContext('2d',{willReadFrequently:true});
    mc.fillStyle='rgb(128,0,0)'; mc.fillRect(0,0,mw,mh);          

    var wantMap=(TTINT==='topo' && !!MAPKEY);
    var mmos=null, mmc=null;
    if(wantMap){ mmos=document.createElement('canvas'); mmos.width=mw; mmos.height=mh;
      mmc=mmos.getContext('2d',{willReadFrequently:true}); mmc.fillStyle='#EDEADB'; mmc.fillRect(0,0,mw,mh); }
    var total=p.nx*p.ny*(wantMap?2:1), pending=total, demFailed=0, mapFailed=0, done=false;
    /* the place names along the route, fetched beside the tiles (tplace_module) */
    var _plList=null, _plWait=(typeof tplOn==='function' && tplOn()), _gridDone=false;
    if(_plWait) tplFetch(coords,function(l){ _plList=l; _plWait=false; if(_gridDone) finish(); });
    function finish(){
      _gridDone=true; if(_plWait) return;
      if(done) return; done=true;
      if(demFailed===p.nx*p.ny){ cb(null); return; }
      var mapOk=wantMap && (mapFailed < p.nx*p.ny*0.25);           
      if(wantMap && !mapOk) console.error('Milestone: topo map layer failed ('+mapFailed+' tiles) — falling back to elevation-only water');
      try{ cb(paintTerrain(mos,mc,p,W,H,coords, mapOk?mmos:null, mapOk?mmc:null, _plList?{list:_plList, panel:(!!dims || !IS_TD), circle:(!dims && typeof DESIGN_KIND!=='undefined' && DESIGN_KIND==='rings')}:null)); }
      catch(e){ console.error('Milestone: terrain render failed —',e); cb(null); }
    }
    var to=setTimeout(function(){ demFailed=p.nx*p.ny; finish(); },20000);
    function fetchGrid(base,ctx2,isMap){
      for(var ty=0;ty<p.ny;ty++) for(var tx=0;tx<p.nx;tx++){
        (function(tx,ty){
          var im=new Image(); im.crossOrigin='anonymous';
          im.onload=function(){ try{ ctx2.drawImage(im,tx*TSIZE,ty*TSIZE); }catch(e){}
            if(--pending===0){ clearTimeout(to); finish(); } };
          im.onerror=function(){ if(isMap) mapFailed++; else demFailed++;
            if(--pending===0){ clearTimeout(to); finish(); } };
          im.src=base(tx,ty);
        })(tx,ty);
      }
    }
    fetchGrid(function(tx,ty){ return TDEM+p.z+'/'+(p.x0+tx)+'/'+(p.y0+ty)+'.png'; },mc,false);
    if(wantMap) fetchGrid(function(tx,ty){ return 'https://maps.geoapify.com/v1/tile/osm-bright/'+p.z+'/'+(p.x0+tx)+'/'+(p.y0+ty)+'.png?apiKey='+MAPKEY; },mmc,true);
  }
  function paintTerrain(mos,mc,p,W,H,coords,mmos,mmc,places){
    var mw=mos.width, mh=mos.height;
    var d=mc.getImageData(0,0,mw,mh).data, n=mw*mh, i;

    var CLS=null;
    if(mmos&&mmc){
      var md=mmc.getImageData(0,0,mw,mh).data;
      CLS=new Uint8Array(n);
      for(i=0;i<n;i++){
        var mr=md[i*4],mg=md[i*4+1],mb=md[i*4+2];
        var mxc=Math.max(mr,mg,mb), mnc=Math.min(mr,mg,mb), df=mxc-mnc;
        var L2=(mxc+mnc)/2, sat=df===0?0:df/(255-Math.abs(2*L2-255));
        var hue=0;
        if(df>0){ if(mxc===mr) hue=60*(((mg-mb)/df)%6); else if(mxc===mg) hue=60*((mb-mr)/df+2); else hue=60*((mr-mg)/df+4); if(hue<0)hue+=360; }
        if(L2<130 && sat<0.30) CLS[i]=4;                           
        else if(sat>0.12 && hue>=175 && hue<=255) CLS[i]=1;        
        else if(sat>0.07 && hue>=60 && hue<=170 && L2>90) CLS[i]=2; 
        else if(L2>232 && sat<0.14) CLS[i]=3;                      
        else if(sat>0.30 && hue>=32 && hue<=56 && L2>120) CLS[i]=3; 
        else CLS[i]=0;
      }

      var CT=new Uint8Array(n), mp2, ip;

      var hp2;
      for(hp2=0;hp2<1;hp2++){
        for(var dy2=0;dy2<mh;dy2++) for(var dx2=0;dx2<mw;dx2++){
          var di2=dy2*mw+dx2, mc2=CLS[di2];

          if(mc2!==3 && mc2!==0){ CT[di2]=mc2; continue; }
          var near=false, ey, ex;
          for(ey=-2;ey<=2&&!near;ey++){ var yy7=dy2+ey; if(yy7<0||yy7>=mh) continue;
            for(ex=-2;ex<=2;ex++){ var xx7=dx2+ex; if(xx7<0||xx7>=mw) continue;
              if(CLS[yy7*mw+xx7]===4){ near=true; break; } } }
          CT[di2]=near?4:mc2;
        }
        var hsw=CLS; CLS=CT; CT=hsw;
      }
      for(ip=0;ip<10;ip++){
        var changed=0;
        for(var cy=0;cy<mh;cy++) for(var cx=0;cx<mw;cx++){
          var me=CLS[cy*mw+cx];
          if(me!==4){ CT[cy*mw+cx]=me; continue; }
          var cnts=[0,0,0,0], seen=0, by, bx;
          for(by=-1;by<=1;by++){ var yy5=cy+by; if(yy5<0||yy5>=mh) continue;
            for(bx=-1;bx<=1;bx++){ var xx5=cx+bx; if(xx5<0||xx5>=mw) continue;
              var nc2=CLS[yy5*mw+xx5]; if(nc2!==4){ cnts[nc2]++; seen++; } } }
          if(seen>=3){ var bi=0, bv=-1, ci2;
            for(ci2=0;ci2<4;ci2++){ if(cnts[ci2]>bv){ bv=cnts[ci2]; bi=ci2; } }
            CT[cy*mw+cx]=bi; changed++;
          } else CT[cy*mw+cx]=4;
        }
        var csw=CLS; CLS=CT; CT=csw;
        if(!changed) break;
      }
      for(var li=0;li<n;li++){ if(CLS[li]===4) CLS[li]=0; }        
      if(TERRAIN_ROADFIX){
      for(var hy=0;hy<mh;hy++) for(var hx=0;hx<mw;hx++){
        var hi=hy*mw+hx;
        if(CLS[hi]!==3){ CT[hi]=CLS[hi]; continue; }
        var rc=0, wc=0, gc2=0, hb, ha;
        for(hb=-2;hb<=2;hb++){ var yy6=hy+hb; if(yy6<0||yy6>=mh) continue;
          for(ha=-2;ha<=2;ha++){ var xx6=hx+ha; if(xx6<0||xx6>=mw) continue;
            var hc=CLS[yy6*mw+xx6]; if(hc===3)rc++; else if(hc===1)wc++; else if(hc===2)gc2++; } }
        CT[hi]=(rc<7 && (wc>=9||gc2>=9)) ? (wc>=gc2?1:2) : 3;
      }
      var csw2=CLS; CLS=CT; CT=csw2;
      }
      for(mp2=0;mp2<TERRAIN_CSMOOTH;mp2++){
        for(var cy=0;cy<mh;cy++) for(var cx=0;cx<mw;cx++){
          var cnts=[0,0,0,0], by, bx;
          for(by=-1;by<=1;by++){ var yy5=cy+by; if(yy5<0||yy5>=mh) continue;
            for(bx=-1;bx<=1;bx++){ var xx5=cx+bx; if(xx5<0||xx5>=mw) continue;
              cnts[CLS[yy5*mw+xx5]]++; } }
          var bi=0, bv=-1, ci2;
          for(ci2=0;ci2<4;ci2++){ if(cnts[ci2]>bv){ bv=cnts[ci2]; bi=ci2; } }
          CT[cy*mw+cx]=bi;
        }
        var csw=CLS; CLS=CT; CT=csw;
      }
      CT=null;
    }
    var ele=new Float32Array(n), mn=Infinity, mx=-Infinity;
    var _topo=(TTINT==='topo');
    var wSeed=_topo?new Uint8Array(n):null;
    for(i=0;i<n;i++){ var e=(d[i*4]*256+d[i*4+1]+d[i*4+2]/256)-32768; ele[i]=e;
      if(e<mn)mn=e; if(e>mx)mx=e;

      if(_topo && (e<=-0.5 || (e>-0.002&&e<0.002))) wSeed[i]=1;
    }
    if(_topo){

      var sm=new Float32Array(n), pass;
      for(pass=0;pass<2;pass++){
        var src=pass?ele:ele, dst=sm;
        for(var sy=0;sy<mh;sy++) for(var sx=0;sx<mw;sx++){
          var acc=0, cnt=0, qy, qx;
          for(qy=-1;qy<=1;qy++){ var yy3=sy+qy; if(yy3<0||yy3>=mh) continue;
            for(qx=-1;qx<=1;qx++){ var xx3=sx+qx; if(xx3<0||xx3>=mw) continue;
              acc+=src[yy3*mw+xx3]; cnt++; } }
          dst[sy*mw+sx]=acc/cnt;
        }
        var tmp=ele; ele=sm; sm=tmp;
      }
      sm=null;
    }
    
    var cs=156543.03392*Math.cos(p.lat*Math.PI/180)/Math.pow(2,p.z);
    var zen=(90-45)*Math.PI/180;
    /* The lights: compass azimuth and weight, in the engine's own angle
       convention below. Flat ground is cos(zen) under every one of them, so
       the blend leaves it where the single light had it. */
    var _lz=[], _li;
    for(_li=0;_li<TERRAIN_LIGHTS.length;_li++) _lz.push([(360-TERRAIN_LIGHTS[_li][0]+90)*Math.PI/180, TERRAIN_LIGHTS[_li][1]]);
    var _flat=Math.cos(zen), _sdk=TERRAIN_SLOPE_DARK, _sref=TERRAIN_SLOPE_REF*Math.PI/180, _str=TERRAIN_STRETCH;
    var sh=document.createElement('canvas'); sh.width=mw; sh.height=mh;
    var sc=sh.getContext('2d'), out=sc.createImageData(mw,mh), o=out.data;
    var dark=(TSHADE!=='light');

    var topo=(TTINT==='topo');
    var warm=(TTINT!=='neutral');
    if(topo) dark=false;                                  
    var RAMP = warm ? (dark ? [24,20,16, 148,128,99] : [151,140,120, 250,246,238])
                    : (dark ? [18,18,18, 125,125,125] : [150,150,150, 255,255,255]);

    var HYP=[ [168,181,152], [199,205,174], [222,222,199], [235,231,215] ];  
    var WATER=[170,199,214];
    var TTH=(topo && TTHEMES[state.terrainTheme])?TTHEMES[state.terrainTheme]:null;

    var RAMP4=TTH?TTH.ramp:HYP;
    var S=W/800;                                          
    function E(x,y){ x=x<0?0:(x>mw-1?mw-1:x); y=y<0?0:(y>mh-1?mh-1:y); return ele[y*mw+x]; }
    function Ef(x,y){                                     
      var fx0=Math.floor(x), fy0=Math.floor(y), fx=x-fx0, fy=y-fy0;
      var q0=E(fx0,fy0), q1=E(fx0+1,fy0), q2=E(fx0,fy0+1), q3=E(fx0+1,fy0+1);
      return (q0*(1-fx)+q1*fx)*(1-fy)+(q2*(1-fx)+q3*fx)*fy;
    }

    var cx0=Math.max(1,Math.floor(p.crop.x)), cx1=Math.min(mw-2,Math.ceil(p.crop.x+p.crop.w));
    var cy0=Math.max(1,Math.floor(p.crop.y)), cy1=Math.min(mh-2,Math.ceil(p.crop.y+p.crop.h));
    var cmn=Infinity, cmx=-Infinity, gsum=0, gcnt=0;
    var gst=Math.max(1,Math.round(Math.min(cx1-cx0,cy1-cy0)/140));
    for(var sy2=cy0;sy2<=cy1;sy2+=gst) for(var sx2=cx0;sx2<=cx1;sx2+=gst){
      var ev=ele[sy2*mw+sx2]; if(ev<cmn)cmn=ev; if(ev>cmx)cmx=ev;
      var ga=(ele[sy2*mw+sx2+1]-ele[sy2*mw+sx2-1])/(2*cs);
      var gb=(ele[(sy2+1)*mw+sx2]-ele[(sy2-1)*mw+sx2])/(2*cs);
      gsum+=Math.sqrt(ga*ga+gb*gb); gcnt++;
    }
    if(!isFinite(cmn)){ cmn=mn; cmx=mx; }

    var relief=cmx-cmn, zf=1, gmean=gcnt?(gsum/gcnt):0;
    if(relief>=10 && isFinite(gmean) && gmean>1e-6){
      zf=Math.tan(7*Math.PI/180)/gmean; if(zf<1)zf=1; if(zf>6)zf=6; }
    zf *= TERRAIN_EXAG;

    var wMask=null;
    if(topo && wSeed && !(mmos&&mmc)){
      var comp=new Int32Array(n), Q=new Int32Array(n), qi, nc=0;
      var csize=[0], cseed=[0];
      for(qi=0;qi<n;qi++){
        if(comp[qi] || ele[qi]>3.0) continue;
        nc++; var sz=0, sd=0, qh=0, qt=0;
        comp[qi]=nc; Q[qt++]=qi;
        while(qh<qt){
          var ci=Q[qh++]; sz++; if(wSeed[ci]) sd++;
          var cy2=(ci/mw)|0, cx2=ci-cy2*mw;
          if(cx2>0     && !comp[ci-1]  && ele[ci-1] <=3.0){ comp[ci-1]=nc;  Q[qt++]=ci-1; }
          if(cx2<mw-1  && !comp[ci+1]  && ele[ci+1] <=3.0){ comp[ci+1]=nc;  Q[qt++]=ci+1; }
          if(cy2>0     && !comp[ci-mw] && ele[ci-mw]<=3.0){ comp[ci-mw]=nc; Q[qt++]=ci-mw; }
          if(cy2<mh-1  && !comp[ci+mw] && ele[ci+mw]<=3.0){ comp[ci+mw]=nc; Q[qt++]=ci+mw; }
        }
        csize.push(sz); cseed.push(sd);
      }
      var isW=new Uint8Array(nc+1), wi;
      for(wi=1;wi<=nc;wi++){ if(cseed[wi]>=25 && cseed[wi]>=0.08*csize[wi]) isW[wi]=1; }
      wMask=new Uint8Array(n);
      for(qi=0;qi<n;qi++){ if(isW[comp[qi]] && ele[qi]<=1.6) wMask[qi]=1; }
      
      var mp, wTmp=new Uint8Array(n);
      for(mp=0;mp<2;mp++){
        for(var my=0;my<mh;my++) for(var mx2=0;mx2<mw;mx2++){
          var cnt2=0, tot2=0, ay, ax;
          for(ay=-1;ay<=1;ay++){ var yy4=my+ay; if(yy4<0||yy4>=mh) continue;
            for(ax=-1;ax<=1;ax++){ var xx4=mx2+ax; if(xx4<0||xx4>=mw) continue;
              tot2++; cnt2+=wMask[yy4*mw+xx4]; } }
          wTmp[my*mw+mx2]=(cnt2*2>=tot2)?1:0;
        }
        var wsw=wMask; wMask=wTmp; wTmp=wsw;
      }
      comp=null; Q=null; wSeed=null; wTmp=null;
    }
    if(CLS){ try{ cleanWaterLabels(CLS,ele,mw,mh); }catch(e){ console.warn('Milestone: label cleanup skipped',e); } }
    var vArr=new Float32Array(mw*mh);
    for(var y=0;y<mh;y++) for(var x=0;x<mw;x++){
      var a=E(x-1,y-1),b=E(x,y-1),c=E(x+1,y-1),
          f=E(x-1,y),            g=E(x+1,y),
          h2=E(x-1,y+1),i2=E(x,y+1),j=E(x+1,y+1);
      var dzdx=zf*((c+2*g+j)-(a+2*f+h2))/(8*cs), dzdy=zf*((h2+2*i2+j)-(a+2*b+c))/(8*cs);
      var sl=Math.atan(Math.sqrt(dzdx*dzdx+dzdy*dzdy)), as=Math.atan2(dzdy,-dzdx);
      var v=0, _cz=Math.cos(zen)*Math.cos(sl), _sz=Math.sin(zen)*Math.sin(sl), _lk;
      for(_lk=0;_lk<_lz.length;_lk++){ var _v1=_cz+_sz*Math.cos(_lz[_lk][0]-as); v+=(_v1<0?0:_v1)*_lz[_lk][1]; }
      v=_flat+(v-_flat)*_str;                                   /* stretch about flat ground */
      var _sd=sl/_sref; if(_sd>1)_sd=1; v*=1-_sdk*_sd;         /* darken by slope */
      v*=255;
      vArr[y*mw+x]=v<0?0:(v>255?255:v);
    }
    for(var y=0;y<mh;y++) for(var x=0;x<mw;x++){
      var t2=vArr[y*mw+x]/255, k=(y*mw+x)*4;
      if(topo){
        var pe=ele[y*mw+x];
        var cls=CLS?CLS[y*mw+x]:((wMask&&wMask[y*mw+x])?1:0);
        if(cls===1){ var wc2=TTH?TTH.water:WATER; o[k]=wc2[0]; o[k+1]=wc2[1]; o[k+2]=wc2[2]; }
        else if(cls===2){
          var sg2=0.62+0.38*t2;                            
          var gcol=TTH?TTH.green:[146,166,128];
          o[k]=gcol[0]*sg2; o[k+1]=gcol[1]*sg2; o[k+2]=gcol[2]*sg2;
        }
        else if(cls===3){
          var sr2=0.80+0.20*t2;                            
          var rc3=TTH?TTH.road:[246,242,230];
          o[k]=rc3[0]*sr2; o[k+1]=rc3[1]*sr2; o[k+2]=rc3[2]*sr2;
        }
        else{

          var tt=(pe-Math.max(cmn,0))/Math.max(cmx-Math.max(cmn,0),40);
          tt=tt<0?0:(tt>1?1:tt);
          var sh2=0.62+0.38*t2;                            
          var fi=tt*(RAMP4.length-1), i0=Math.floor(fi), i1=i0<RAMP4.length-1?i0+1:i0, ft=fi-i0;
          o[k]  =(RAMP4[i0][0]+(RAMP4[i1][0]-RAMP4[i0][0])*ft)*sh2;
          o[k+1]=(RAMP4[i0][1]+(RAMP4[i1][1]-RAMP4[i0][1])*ft)*sh2;
          o[k+2]=(RAMP4[i0][2]+(RAMP4[i1][2]-RAMP4[i0][2])*ft)*sh2;
        }
        o[k+3]=255;
      } else {
      o[k]  =RAMP[0]+(RAMP[3]-RAMP[0])*t2;
      o[k+1]=RAMP[1]+(RAMP[4]-RAMP[1])*t2;
      o[k+2]=RAMP[2]+(RAMP[5]-RAMP[2])*t2;
      o[k+3]=255;
      }
    }
    sc.putImageData(out,0,0);
    
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
    var ctx=cv.getContext('2d');
    ctx.fillStyle=topo?(TTH?TTH.paper:'#EDEADB'):(dark?'#17171A':(warm?'#F3EFE7':'#F2F2F0')); ctx.fillRect(0,0,W,H);
    ctx.imageSmoothingEnabled=true; ctx.imageSmoothingQuality='high';
    ctx.drawImage(sh,p.crop.x,p.crop.y,p.crop.w,p.crop.h,0,0,W,H);
    
    var range=cmx-cmn;
    if(isFinite(range)&&range>8){
      var step=contourStep(range), st=Math.max(4,Math.round(3*S)), gw=Math.ceil(W/st)+1, gh=Math.ceil(H/st)+1;
      var sx=p.crop.w/W, sy=p.crop.h/H, gr=new Float32Array(gw*gh), gwat=new Uint8Array(gw*gh), gx,gy;
      for(gy=0;gy<gh;gy++) for(gx=0;gx<gw;gx++){
        var mxp=p.crop.x+gx*st*sx, myp=p.crop.y+gy*st*sy, gi=gy*gw+gx;
        gr[gi]=Ef(mxp,myp);
        var wxi=Math.round(mxp), wyi=Math.round(myp);
        wxi=wxi<0?0:(wxi>mw-1?mw-1:wxi); wyi=wyi<0?0:(wyi>mh-1?mh-1:wyi);
        var wpi=wyi*mw+wxi;
        gwat[gi] = CLS ? (CLS[wpi]===1?1:0)
                 : (wMask ? wMask[wpi] : (gr[gi]<=0.5?1:0));
      }
      ctx.lineWidth=Math.max(1,S);
      ctx.strokeStyle = topo ? (TTH?('rgba('+TTH.road[0]+','+TTH.road[1]+','+TTH.road[2]+',0.22)'):'rgba(108,98,80,0.28)')
                       : warm ? (dark?'rgba(247,238,222,0.20)':'rgba(82,66,48,0.24)')
                             : (dark?'rgba(243,239,231,0.20)':'rgba(23,23,26,0.22)');
      ctx.beginPath();
      var seg=function(a,b){ ctx.moveTo(a[0],a[1]); ctx.lineTo(b[0],b[1]); };
      var lo=Math.ceil(cmn/step)*step;
      for(var L=lo;L<=cmx;L+=step){
        for(gy=0;gy<gh-1;gy++) for(gx=0;gx<gw-1;gx++){
          /* Skip only where the whole cell is water, so the lines run right
             up to the shoreline instead of stopping a cell short. */
          if(gwat[gy*gw+gx] && gwat[gy*gw+gx+1] && gwat[(gy+1)*gw+gx+1] && gwat[(gy+1)*gw+gx]) continue;
          var v0=gr[gy*gw+gx],v1=gr[gy*gw+gx+1],v2=gr[(gy+1)*gw+gx+1],v3=gr[(gy+1)*gw+gx];
          var id=(v0>L?8:0)|(v1>L?4:0)|(v2>L?2:0)|(v3>L?1:0);
          if(id===0||id===15) continue;
          var X=gx*st, Y=gy*st;
          var T=[X+((L-v0)/((v1-v0)||1e-9))*st, Y];
          var B=[X+((L-v3)/((v2-v3)||1e-9))*st, Y+st];
          var Lf=[X, Y+((L-v0)/((v3-v0)||1e-9))*st];
          var R=[X+st, Y+((L-v1)/((v2-v1)||1e-9))*st];
          switch(id){
            case 1: case 14: seg(Lf,B); break;
            case 2: case 13: seg(B,R); break;
            case 3: case 12: seg(Lf,R); break;
            case 4: case 11: seg(T,R); break;
            case 6: case 9:  seg(T,B); break;
            case 7: case 8:  seg(T,Lf); break;
            case 5: seg(T,Lf); seg(B,R); break;
            case 10: seg(T,R); seg(Lf,B); break;
          }
        }
      }
      ctx.stroke();
    }
    
    if(topo && (CLS||wMask)){ try{ terrainCoast(ctx,p,W,H,S,mw,mh,CLS,wMask); }catch(e){ console.warn('Milestone: coastline skipped',e); } }
    /* suburb names, under the route (tplace_module) */
    if(places && places.list && places.list.length){
      try{ cv._places=tplDraw(ctx,p,W,H,S,places.list,coords,{dark:dark && !topo, panel:places.panel, circle:places.circle}); }
      catch(e){ console.warn('Milestone: place names skipped',e); }
    }
    var pr=[],k2;
    for(k2=0;k2<coords.length;k2++){
      var wx=_lon2t(coords[k2][1],p.z)*TSIZE-p.x0*TSIZE, wy=_lat2t(coords[k2][0],p.z)*TSIZE-p.y0*TSIZE;
      pr.push([(wx-p.crop.x)/p.crop.w*W,(wy-p.crop.y)/p.crop.h*H]);
    }
    /* Exact canvas positions of the route ends, in this canvas's own
       projection - used to place start/finish markers later. */
    if(pr.length>1) cv._sfPts={s:pr[0], f:pr[pr.length-1], S:S};
    /* Metres per canvas pixel at the centre latitude: the tile zoom's
       ground resolution, scaled by crop-to-canvas. For the scale bar. */
    cv._mpp=cs*p.crop.w/W; cv._S=S;
    /* The same terrain before the route goes on, and the route's positions on
       it, for the reel: it reveals this route along its length over the bare
       terrain, so its last frame is this canvas exactly. */
    if(pr.length>1){
      try{ var _bare=document.createElement('canvas'); _bare.width=W; _bare.height=H;
           _bare.getContext('2d').drawImage(cv,0,0);
           cv._bare=_bare; cv._pr=pr; cv._lw=9*S; }catch(e){}
    }
    if(pr.length>1){
      ctx.lineJoin='round'; ctx.lineCap='round';
      ctx.strokeStyle='rgba(0,0,0,0.35)'; ctx.lineWidth=9*S;
      ctx.beginPath(); ctx.moveTo(pr[0][0],pr[0][1]);
      for(k2=1;k2<pr.length;k2++) ctx.lineTo(pr[k2][0],pr[k2][1]);
      ctx.stroke();
      if(!(typeof relayStroke==='function' && relayStroke(ctx,pr,6*S,coords))){
      ctx.strokeStyle=routeHex(); ctx.lineWidth=6*S;
      ctx.beginPath(); ctx.moveTo(pr[0][0],pr[0][1]);
      for(k2=1;k2<pr.length;k2++) ctx.lineTo(pr[k2][0],pr[k2][1]);
      ctx.stroke();
      }
    }

    sh.width=sh.height=1; mos.width=mos.height=1;   
    return cv;
  }
  /* The coast: a thin solid line where water meets land (22 Oct). Cream -
     the brand paper - rather than black (22 Oct pm, Marc): on real harbour
     renders black read as an outline, cream reads as a shore, on the dark
     themes too. */
  var TERRAIN_COAST='#F3EFE7';
  function terrainCoast(ctx,p,W,H,S,mw,mh,CLS,wM){
    var x0=Math.max(0,Math.floor(p.crop.x)-2), y0=Math.max(0,Math.floor(p.crop.y)-2);
    var x1=Math.min(mw-1,Math.ceil(p.crop.x+p.crop.w)+2), y1=Math.min(mh-1,Math.ceil(p.crop.y+p.crop.h)+2);
    var fw=x1-x0+1, fh=y1-y0+1; if(fw<3 || fh<3) return;
    var f=new Float32Array(fw*fh), g=new Float32Array(fw*fh), x, y, i, any=0, all=1;
    for(y=0;y<fh;y++) for(x=0;x<fw;x++){
      var mi=(y0+y)*mw+(x0+x), w=CLS ? (CLS[mi]===1?1:0) : (wM[mi]?1:0);
      f[y*fw+x]=w; any|=w; all&=w;
    }
    if(!any || all) return;
    /* two 3x3 box passes, edges clamped */
    for(var pass=0;pass<2;pass++){
      for(y=0;y<fh;y++) for(x=0;x<fw;x++){
        var sum=0, cnt=0;
        for(var dy=-1;dy<=1;dy++){ var yy=y+dy; if(yy<0||yy>=fh) continue;
          for(var dx=-1;dx<=1;dx++){ var xx=x+dx; if(xx<0||xx>=fw) continue; sum+=f[yy*fw+xx]; cnt++; } }
        g[y*fw+x]=sum/cnt;
      }
      var t=f; f=g; g=t;
    }
    var kx=W/p.crop.w, ky=H/p.crop.h, ox=x0-p.crop.x, oy=y0-p.crop.y;
    ctx.save();
    ctx.beginPath();
    var seg=function(a,b){ ctx.moveTo((ox+a[0])*kx,(oy+a[1])*ky); ctx.lineTo((ox+b[0])*kx,(oy+b[1])*ky); };
    var L=0.5;
    for(y=0;y<fh-1;y++) for(x=0;x<fw-1;x++){
      var v0=f[y*fw+x], v1=f[y*fw+x+1], v2=f[(y+1)*fw+x+1], v3=f[(y+1)*fw+x];
      var id=(v0>L?8:0)|(v1>L?4:0)|(v2>L?2:0)|(v3>L?1:0);
      if(id===0||id===15) continue;
      var T=[x+(L-v0)/((v1-v0)||1e-9), y], B=[x+(L-v3)/((v2-v3)||1e-9), y+1];
      var Lf=[x, y+(L-v0)/((v3-v0)||1e-9)], R=[x+1, y+(L-v1)/((v2-v1)||1e-9)];
      switch(id){
        case 1: case 14: seg(Lf,B); break;
        case 2: case 13: seg(B,R); break;
        case 3: case 12: seg(Lf,R); break;
        case 4: case 11: seg(T,R); break;
        case 6: case 9:  seg(T,B); break;
        case 7: case 8:  seg(T,Lf); break;
        case 5: seg(T,Lf); seg(B,R); break;
        case 10: seg(T,R); seg(Lf,B); break;
      }
    }
    ctx.lineCap='round'; ctx.lineJoin='round';
    ctx.strokeStyle=TERRAIN_COAST; ctx.lineWidth=Math.max(1,S);
    ctx.stroke();
    ctx.restore();
  }
  /* True while the canvas is still showing the boot placeholder on a product
     that has its own GPX coming. Building a Geoapify tile now would render the
     Bay Run and cache it against a Bay Run URL. */
  function awaitingRoute(){
    if(!state.routeIsDefault) return false;
    if(typeof PM_DEF!=='undefined' && PM_DEF && PM_DEF.gpx) return true;
    /* Some products carry the route as a ?gpx= parameter rather than the
       metafield. Same wait, same reason - and ?r= is a third way in, which
       without this line would let the placeholder build a map. */
    try{ if(getParam('gpx')) return true; }catch(e){}
    try{
      /* True only before the catalogue is assigned, and only for an explicit
         ?r= - a page handle is a weaker signal and most pages are not events. */
      if(getParam('r') && typeof ROUTES_CAT==='undefined') return true;
      var _rr=currentRoute(); if(_rr && _rr.gpx) return true;
    }catch(e){}
    return false;
  }
  function mapUrlFor(phoneAR){ if(awaitingRoute()) return '';
    if(!state.coords || state.coords.length<2) return '';
    if(typeof sbOn==='function' && sbOn()) return sbKey();
    /* 3D: its own render, keyed on the route and the shape (no map key needed) */
    if(typeof t3On==='function' && t3On()) return t3Key();
    if(state.style==='terrain') return terrainKey(state.coords)+relaySig();
    if(!state.coords||!MAPKEY) return '';
    var simp=dpSimplify(state.coords,0.00002);
    /* With the halo on the geometry carries two polylines, so the route is
       fitted to 200 points rather than 300 - by loosening the tolerance,
       since thinning by index is what made straight lines. */
    var _halo=(typeof kmOn==='function' && kmOn() && state.style==='map' && !relayOpt()), _cap=_halo?200:300, _tol=0.00006;
    if(simp.length>_cap) simp=dpSimplify(state.coords,_tol);
    while(_halo && simp.length>_cap && _tol<0.01){ _tol*=1.2; simp=dpSimplify(state.coords,_tol); }
    if(simp.length>_cap){ var ix=downsampleIdx(simp.length,_cap); simp=ix.map(function(i){return simp[i];}); }
    var minLa=Infinity,maxLa=-Infinity,minLo=Infinity,maxLo=-Infinity;
    var pp=simp.map(function(c){ var la=c[0],lo=c[1];
      if(la<minLa)minLa=la; if(la>maxLa)maxLa=la; if(lo<minLo)minLo=lo; if(lo>maxLo)maxLo=lo;
      return lo.toFixed(5)+','+la.toFixed(5); });
    /* Rings' window is a circle: a wider margin keeps the route off its rim. */
    var _mgn=(typeof DESIGN_KIND!=='undefined' && DESIGN_KIND==='rings') ? 0.30 : 0.15;
    var mLa=Math.max((maxLa-minLa)*_mgn,0.0006), mLo=Math.max((maxLo-minLo)*_mgn,0.0006);
    var aLo0=minLo-mLo, aLa0=minLa-mLa, aLo1=maxLo+mLo, aLa1=maxLa+mLa;
    /* Gallery's panel is a tall column and the route it holds can be any shape.
       Geoapify fits this rect to the image by covering it, so a rect taller
       than the image loses its top and bottom - which is a route with its ends
       cut off. Padding the rect out to the image's own aspect first means
       nothing is fitted: the route keeps its margin and the padding arrives as
       more map.

       galPadArea is defined below, next to galAspectFor, because the aspect it
       pads to is the same number. */
    /* Every editorial route, not only the relay (27 Oct, p_edtfit): see below. */
    var _rea=(!phoneAR && IS_EDT && !(typeof focusProd==='function' && focusProd()==='frame')) ? relayEdtAR() : 0;
    if(_rea>0){
      var _rpa=galPadArea(aLo0,aLa0,aLo1,aLa1,_rea);
      aLo0=_rpa[0]; aLa0=_rpa[1]; aLo1=_rpa[2]; aLa1=_rpa[3];
    }
    if(phoneAR || IS_GAL){
      var _pa=galPadArea(aLo0,aLa0,aLo1,aLa1, phoneAR ||
                         galAspectFor(typeof focusProd==='function'?focusProd():state.product));
      aLo0=_pa[0]; aLa0=_pa[1]; aLo1=_pa[2]; aLa1=_pa[3];
    }
    var area='rect:'+aLo0.toFixed(5)+','+aLa0.toFixed(5)+','+aLo1.toFixed(5)+','+aLa1.toFixed(5);
    /* The frame's panel is much taller than the poster's, so it gets its own
       route treatment: a dark line under the vermilion one, which a 107 mm
       panel over a street map needs to stay readable. Two polylines double the
       URL, so the point count is capped when the outline is on. */
    var _fr=(typeof focusProd==='function' && focusProd()==='frame');
    /* The route outline is off. It is one line to bring back - a second,
       thicker polyline joined with '|' before this one - and ensureMap already
       retries without it, so turning it on again cannot cost the map. */
    var geom='polyline:'+pp.join(',')+';linecolor:'+routeHex().toLowerCase()+';linewidth:5;lineopacity:1';
    var _rgm=relayGeom(simp); if(_rgm) geom=_rgm;
    /* The halo (22 Oct pm): a wider paper-coloured line under the route,
       first in the list so ensureMap's retry drops it if it is refused. */
    else if(_halo) geom='polyline:'+pp.join(',')+';linecolor:'+mapHaloHex()+';linewidth:9;lineopacity:1|'+geom;
    /* Start/finish as Geoapify markers, so they sit under Geoapify's own
       projection. A loop (ends within ~80 m) gets one combined marker. */
    var mk='';
    if(typeof sfOn==='function' && sfOn() && state.style==='map' && typeof kmOn==='function' && kmOn()){   /* 30 Oct pm: with the km markers only - otherwise drawn over the static map (mapWithSf) */
      var a0=state.coords[0], a1=state.coords[state.coords.length-1];
      var loop=(routeKm([a0,a1])<0.08);
      var mS='lonlat:'+a0[1].toFixed(5)+','+a0[0].toFixed(5)+';type:circle;color:#ffffff;strokecolor:#17171A;size:small;shadow:no';
      var mF='lonlat:'+a1[1].toFixed(5)+','+a1[0].toFixed(5)+';type:circle;color:#17171A;strokecolor:#ffffff;size:small;shadow:no';
      mk='&marker='+encodeURIComponent(loop?mS:(mF+'|'+mS));
    }
    /* Km markers (22 Oct pm): the same way, a cream circle with the numeral. */
    if(typeof kmOn==='function' && kmOn() && state.style==='map'){
      var _kms=kmMarks(state.coords), _kl=[], _ki;
      for(_ki=0;_ki<_kms.length;_ki++) _kl.push('lonlat:'+_kms[_ki].lon.toFixed(5)+','+_kms[_ki].lat.toFixed(5)+
        ';type:circle;color:#F3EFE7;strokecolor:'+routeHex()+';contentcolor:#17171A;size:small;text:'+kmLabel(_kms[_ki].k)+';textsize:small;shadow:no');
      if(_kl.length) mk+=(mk?'%7C':'&marker=')+encodeURIComponent(_kl.join('|'));
    }
    /* Neon design: tile at the editorial panel's aspect (plus the 3.5%
       attribution crop), so cover-fit does not cut tall routes. */
    /* Request the map at the shape it will be drawn into. Geoapify stamps a
       ~3.5% attribution strip along the bottom which drawArtInto crops, so the
       height is grossed up to leave the right ratio after that crop. */
    var _mw=1000, _mh=(IS_EDT?780:950);
    if(phoneAR){ _mw=600; _mh=Math.round(600/(phoneAR*0.965)); }
    else if(_fr){ _mw=700; _mh=Math.round(700/(FR_AR*0.965)); }   /* 0.965 = the attribution crop */
    else if(_rea>0){ _mh=Math.round(1000/(_rea*0.965)); }
    /* Gallery's panel is about 1:2 and varies a little by format, because the
       text block above it does. _galAR is what the last layout actually used. */
    /* The new designs (28 Oct): their route window's own shape. */
    else if(ndOn()){ var _nar=ndArtAR(); _mw=800; _mh=Math.round(800/(_nar*0.965)); }
    else if(IS_GAL){
      /* focusProd(), not state.product: the hero is what the customer is
         looking at, and it is the panel the map has to fit without cropping. */
      var _gar=galAspectFor(typeof focusProd==='function'?focusProd():state.product);
      _mw=600; _mh=Math.round(600/(_gar*0.965));
    }
    /* p_edtfit (27 Oct): the area padded to the whole image's shape, the
       attribution strip included (the padding above is to the shape after
       that crop, which leaves 3.5% to spare). Then covering the area and
       fitting it inside are the same thing, so the tile-built map (markers
       on) and Geoapify's own (markers off) frame the route identically. */
    if(!phoneAR){
      var _xpa=galPadArea(aLo0,aLa0,aLo1,aLa1,_mw/_mh);
      area='rect:'+_xpa[0].toFixed(5)+','+_xpa[1].toFixed(5)+','+_xpa[2].toFixed(5)+','+_xpa[3].toFixed(5);
    }
    return 'https://maps.geoapify.com/v1/staticmap?style='+(MAPSTYLES[state.mapStyle]||'osm-bright')+'&width='+_mw+'&height='+_mh+'&format=png&area='+encodeURIComponent(area)+'&geometry='+encodeURIComponent(geom)+mk+'&apiKey='+MAPKEY; }
  /* Bumped on every map build. An in-flight response carrying an older ticket
     is a leftover from a route we have since replaced - drop it rather than
     letting it repaint the stage. */
  var _mapGen=0;
  /* What the last map request did. Read by ?czdebug=1 - the failure mode this
     records is invisible otherwise: the panel just says "Loading map..." */
  var _mapDiag={state:'idle',url:'',len:0,note:''};
  function ensureMap(cb){
    var gen=++_mapGen; state.mapFailed=false;
    if(awaitingRoute()){
      state.mapImg=null; state.mapUrl='';
      var hw=$('cz-styleHint'); if(hw) hw.textContent='Loading your route\u2026';
      cb&&cb(); return;
    }
    var u=mapUrlFor(); if(!u){ cb&&cb(); return; }
    if(state.mapImg && state.mapUrl===u){
      if(state.style==='terrain' && state.terrainBase) state.mapImg=terrainWithSf(state.terrainBase);
      else if(state.style==='map' && !state.mapTaint) state.mapImg=mapWithSf(state.mapImg,u);   /* 30 Oct pm: a toggle redraws from the bare map */
      updateStyleHint(); cb&&cb(); return;
    }
    var h=$('cz-styleHint'); if(h) h.textContent=(state.style==='terrain')?'Building terrain…':'Loading map…';
    function fail(msg){ state.mapImg=null; state.mapUrl=''; state.mapFailed=true;
      if(h) h.textContent=msg; cb&&cb(); }
    if(state.style==='terrain' && !(typeof sbOn==='function' && sbOn())){
      buildTerrain(state.coords,function(cv){
        if(gen!==_mapGen) return;
        if(!cv){ fail('Terrain couldn’t be built for this route — try another style.'); return; }
        state.terrainBase=cv;
        state.mapImg=terrainWithSf(cv); state.mapUrl=u; state.mapTaint=false; updateStyleHint(); cb&&cb();
      });
      return;
    }
    /* 3D: an offscreen MapLibre render (t3_module); the route is drawn on top. */
    if(typeof t3On==='function' && t3On()){
      if(h) h.textContent='Building the 3D map\u2026';
      t3LoadMap(false,function(cv){
        if(gen!==_mapGen) return;
        if(!cv){ fail('The 3D map couldn\u2019t be built for this route.'); return; }
        state.mapImg=cv; state.mapUrl=u; state.mapTaint=false; state.mapHiFor='';
        _mapDiag={state:'loaded',url:u,len:u.length,note:'3d'+(cv._t3Flat?(' '+cv._t3Flat):'')};
        updateStyleHint(); cb&&cb();
      });
      return;
    }
    /* Stat Bar: its own map, tiles first, no route baked in (sb_module). */
    if(typeof sbOn==='function' && sbOn()){
      sbLoadMap(1,function(cv){
        if(gen!==_mapGen) return;
        if(!cv){ fail('Map couldn\u2019t load \u2014 check the map key in settings.'); return; }
        state.mapImg=cv; state.mapUrl=u; state.mapTaint=false; state.mapHiFor='';
        _mapDiag={state:'loaded',url:u,len:u.length,note:'statbar '+(cv._sbCrop?'static':'tiles')};
        updateStyleHint(); cb&&cb();
      });
      return;
    }
    var reqU=u;
    _mapDiag={state:'requested',url:u,len:u.length,note:''};
    function load(cross){ var im=new Image(); if(cross) im.crossOrigin='anonymous';
      im.onload=function(){ if(gen!==_mapGen) return;
        var out=im;
        if(cross && state.mapStyle==='dark'){ try{ out=liftDarkTile(im); }catch(e){ out=im; } }
        state.mapImg=cross?mapWithSf(out,u):out; state.mapUrl=u; state.mapTaint=!cross;   /* 30 Oct pm: start / finish over the map */
        _mapDiag.state='loaded'; _mapDiag.len=reqU.length;
        _mapDiag.px=(im.naturalWidth||im.width)+'x'+(im.naturalHeight||im.height);
        updateStyleHint(); cb&&cb(); };
      im.onerror=function(){ if(gen!==_mapGen) return;
        if(cross){ load(false); return; }
        /* If Geoapify rejected the marker syntax, keep the map and drop the
           markers rather than losing the whole style. */
        /* Two polylines - the frame's route outline - are the newest thing in
           this URL and the least load-bearing. Drop the outline before anything
           else and keep the map. */
        if(/geometry=[^&]*?%7C/.test(reqU)){
          console.warn('Milestone: map rejected the route outline, retrying with a single line');
          _mapDiag.note='outline rejected \u2014 single line';
          reqU=reqU.replace(/(geometry=)[^&]*?%7C/,'$1'); load(true); return;
        }
        if(reqU.indexOf('&marker=')>=0){
          console.warn('Milestone: map markers rejected, retrying without');
          reqU=reqU.replace(/&marker=[^&]*/,''); load(true);
          setTimeout(function(){ if(state.mapFailed) return; var hh=$('cz-styleHint'); if(hh) hh.textContent='Route markers aren\u2019t available on this map style.'; },1200);
          return;
        }
        console.error('Milestone: map failed to load —', u);
        _mapDiag.state='failed'; _mapDiag.len=reqU.length; _mapDiag.url=reqU;
        fail('Map couldn’t load — check the map key in settings.'); };
      relayImgSrc(im,reqU); }
    load(true);
  }
  /* The halo's colour on the Map style: paper on the light tiles, near-ink
     on the dark ones - it separates the route from the streets either way. */
  function mapHaloHex(){ return (state.mapStyle==='dark') ? '#1b1b1d' : '#f3efe7'; }
  /* Metres per image pixel of a static map (22 Oct pm): the cover fit of the
     area rect into the image (what relayTileMap draws by), at the rect's
     centre latitude, divided by the scale geoPts measured off the route when
     it found one. Cached on the image. 0 when the URL is not ours. */
  function mapMpp(url,im){
    if(!im) return 0;
    if(im._mpp!==undefined && im._mppFor===url) return im._mpp;
    var out=0;
    try{
      var q=function(k){ var m=new RegExp('[?&]'+k+'=([^&]*)').exec(url); return m?decodeURIComponent(m[1]):''; };
      var Wp=im.naturalWidth||im.width, Hp=im.naturalHeight||im.height;
      var ar=/rect:([-\d.]+),([-\d.]+),([-\d.]+),([-\d.]+)/.exec(q('area'));
      if(ar && Wp>1 && Hp>1){
        var R=Math.PI/180, my=function(la){ return Math.log(Math.tan(Math.PI/4+la*R/2)); };
        var X0=(+ar[1])*R, X1=(+ar[3])*R, Y0=my(+ar[2]), Y1=my(+ar[4]);
        var k=Math.max(Wp/Math.max(1e-12,Math.abs(X1-X0)), Hp/Math.max(1e-12,Math.abs(Y1-Y0)));
        out=6378137*Math.cos(((+ar[2])+(+ar[4]))/2*R)/k;
        var cal=(typeof geoPts==='function') ? geoPts(url,im) : null;
        if(cal && cal.s>0) out/=cal.s;
      }
    }catch(e){ out=0; }
    im._mpp=out; im._mppFor=url;
    return out;
  }
  /* dark-matter draws streets and labels within ~10 levels of the land.
     Lift grey pixels above the land level toward white, on a curve read from
     this tile's own histogram. The route (coloured) and a 1px ring round it
     are left alone so the line keeps a clean edge. */
  function liftDarkTile(img){
    var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    var x=c.getContext('2d'); x.drawImage(img,0,0);
    var id=x.getImageData(0,0,w,h), d=id.data, n=w*h, i, p;
    var L=new Float32Array(n), ch=new Uint8Array(n), hist=new Uint32Array(256), tot=0;
    for(i=0,p=0;i<n;i++,p+=4){
      var r=d[p],g=d[p+1],b=d[p+2], mx=Math.max(r,g,b), mn=Math.min(r,g,b);
      ch[i]=mx-mn; L[i]=0.2126*r+0.7152*g+0.0722*b;
      if(ch[i]<18){ hist[L[i]|0]++; tot++; }
    }
    if(!tot) return img;
    function pct(q){ var acc=0, lim=q*tot; for(var k=0;k<256;k++){ acc+=hist[k]; if(acc>=lim) return k; } return 255; }
    var lo=pct(0.75)+1, hi=Math.max(pct(0.995), lo+10), span=hi-lo, TOP=225;
    /* route mask, grown by one pixel */
    var rm=new Uint8Array(n), yy, xx;
    for(yy=0;yy<h;yy++) for(xx=0;xx<w;xx++){
      i=yy*w+xx; if(ch[i]<=10) continue;
      for(var dy=-1;dy<=1;dy++){ var y2=yy+dy; if(y2<0||y2>=h) continue;
        for(var dx=-1;dx<=1;dx++){ var x2=xx+dx; if(x2>=0&&x2<w) rm[y2*w+x2]=1; } }
    }
    for(i=0,p=0;i<n;i++,p+=4){
      if(rm[i]) continue;
      var wt=1-Math.min(1,Math.max(0,(ch[i]-4)/10)); if(wt<=0) continue;
      var l=L[i], t=(l-lo)/span; if(t<=0) continue; if(t>1) t=1;
      t=Math.pow(t,0.75);
      var o=l+(TOP-l)*t, gn=l>0.5?o/l:1;
      d[p]  =Math.min(255,d[p]  +(d[p]  *gn-d[p])  *wt);
      d[p+1]=Math.min(255,d[p+1]+(d[p+1]*gn-d[p+1])*wt);
      d[p+2]=Math.min(255,d[p+2]+(d[p+2]*gn-d[p+2])*wt);
    }
    x.putImageData(id,0,0);
    return c;
  }
  function setStyleBtn(s,on){
    var b=document.querySelector('#cz-styles [data-s="'+s+'"]');
    if(!b) return;
    /* While this slot is the frame's Photo control it is a DESIGN, not a style,
       so the elevation availability rules do not apply to it. Without this the
       editorial branch disables it moments after the relabel enables it. */
    if(b.getAttribute('data-photo')==='1'){ b.disabled=false; b.classList.remove('cz-dim'); return; }
    b.disabled=!on; b.classList.toggle('cz-dim',!on);
  }
  /* Clamp a stored style to what this design can actually draw.

     A design in KIND_STYLE cannot render without a bitmap, so its ring offers
     only map and terrain. A product generated before that design existed - or a
     ?style= carried over from another one - stores something else, and it was
     being re-applied the moment the route resolved: the ring ended up sitting
     on a disabled Neon tab with the artwork rendering as neon. Picking a route
     from the iconic list did it every time. */
  function styleForDesign(s){
    if(!s || !KIND_STYLE[DESIGN_KIND||'']) return s;
    return (s==='map'||s==='terrain') ? s : (KIND_STYLE_ALL[DESIGN_KIND||'']||'map');
  }
  function refreshStyles(){
    /* Before any branch returns. The editorial and terrain designs bail out
       further down, which is why putting this at the bottom meant the frame
       never showed Photo at all. */
    var _ph=$('cz-styles'), _pb=_ph?_ph.querySelector('[data-s="heat"]'):null;
    if(_pb){
      var _isF=isPhotoFmt(focusProd());
      _pb.textContent=_isF?'Photo':'Elevation';
      _pb.setAttribute('data-photo',_isF?'1':'0');
      if(_isF) _pb.disabled=false;          /* a design, not a style - always offerable */
    }
    if(state.mapUser){
      setStyleBtn('neon',false); setStyleBtn('heat',false); setStyleBtn('map',true); setStyleBtn('terrain',false);
      if(state.style!=='map'){ selectStyle('map'); return; }
      updateStyleHint(); return;
    }
    /* 3D has one style, its own 3D map, with or without a Geoapify key. */
    if(typeof t3On==='function' && t3On()){
      setStyleBtn('neon',false); setStyleBtn('heat',false); setStyleBtn('map',true); setStyleBtn('terrain',false);
      if(state.style!=='map'){ selectStyle('map'); return; }
      updateStyleHint(); return;
    }
    /* Stat Bar has one style, its own map - studio or not (23 Oct night: the
       studio branch below returned first, and Stat Bar waited for a map that
       was never asked for). */
    if(typeof sbOn==='function' && sbOn()){
      setStyleBtn('neon',false); setStyleBtn('heat',false); setStyleBtn('map',!!MAPKEY); setStyleBtn('terrain',false);
      if(state.style!=='map'){ selectStyle('map'); return; }
      updateStyleHint(); return;
    }
    if(STUDIO){
      setStyleBtn('neon',true); setStyleBtn('heat',true);
      setStyleBtn('map',!!MAPKEY); setStyleBtn('terrain',true);
      updateStyleHint(); return;
    }
    /* From KIND_STYLE, which is already the list of designs that cannot draw
       anything without a bitmap - not a fourth hand-written set of design
       names. Gallery was missing from that set, so it fell through to the
       generic branch below, which offers Neon and drops to it: picking a route
       from the iconic list landed on neon every time. */
    if(KIND_STYLE[DESIGN_KIND||'']){
      /* Neon and Elevation are masks with no bitmap behind them, so there is
         nothing for them to bleed. Terrain leads on full bleed. */
      var mOkE=!!(state.coords && MAPKEY), tOkE=!!state.coords;
      setStyleBtn('neon',false); setStyleBtn('heat',false);
      setStyleBtn('map',mOkE); setStyleBtn('terrain',tOkE);
      /* Which of the two a design leads on, from the same table: 'terrain'
         leads on terrain, anything else on the map. */
      var _lead=KIND_STYLE_ALL[DESIGN_KIND||''];
      var firstE = (_lead==='terrain') ? (tOkE?'terrain':(mOkE?'map':''))
                                       : (mOkE?'map':'terrain');
      if(state.style!=='map' && state.style!=='terrain'){ if(firstE){ selectStyle(firstE); return; } }
      if(state.style==='map' && !mOkE && tOkE){ selectStyle('terrain'); return; }
      if(state.style==='terrain' && !tOkE && mOkE){ selectStyle('map'); return; }
      updateStyleHint(); return;
    }
    setStyleBtn('neon',true);
    var eOk=false;
    if(state.eles){ var mn=Infinity,mx=-Infinity,n=0,i; for(i=0;i<state.eles.length;i++){ if(isFinite(state.eles[i])){ n++; if(state.eles[i]<mn)mn=state.eles[i]; if(state.eles[i]>mx)mx=state.eles[i]; } } eOk=(n>2&&(mx-mn)>1); }
    var mOk=!!(state.coords && MAPKEY), tOk=!!state.coords;
    setStyleBtn('heat',eOk); setStyleBtn('map',mOk); setStyleBtn('terrain',tOk);
    if((state.style==='heat'&&!eOk)||(state.style==='map'&&!mOk)||(state.style==='terrain'&&!tOk)){ selectStyle('neon'); return; }
    updateStyleHint();
  }
  /* Start/finish needs our own projection. Map and terrain tiles carry the
     route baked in under Geoapify's, so the dots cannot be placed truthfully -
     hide the control rather than let it do nothing. */
  /* The name only exists on the frame layout, so the field follows the format
     rather than sitting unexplained on a poster. */
  function syncNameRow(){
    var el=$('cz-name'); if(!el) return;
    var row=$('cz-nameRow') || (el.closest ? el.closest('label') : null);
    if(!row||!row.style) return;
    /* Every design draws the name now, not just the frame, so the field is
       always offered. Clearing the inline value rather than setting one hands
       the row back to the stylesheet - .cz-fld{display:block}, plus whatever
       the current layout overrides - so it stacks label-over-input like every
       other field instead of sitting beside its own label. */
    row.style.display = '';
  }
  function syncSfRow(){
    var box=$('cz-sf'); if(!box) return;
    var row=box.parentNode; if(!row || !row.style) return;
    /* Neon, and since 22 Oct pm Terrain and Street Map (Marc's pick #2).
       Markers reach the designs by three routes - drawn by drawStartFinish()
       in renderDesign, composited into the terrain canvas by terrainWithSf(),
       and asked of Geoapify in mapUrlFor() when the style is map. Not on
       Gallery or photo-overlay. */
    var ok = sfRowOk() &&
             (state.style!=='terrain' || !!(state.terrainBase && state.terrainBase._sfPts));
    row.style.display = ok ? 'flex' : 'none';
    if(!ok && box.checked) box.checked=false;
    /* 30 Oct: untouched, the box shows the default */
    if(ok && !_sfTouched) box.checked=sfDefaultOn();
  }
  /* 30 Oct (Marc): the designs that mark start and finish - every design on
     its Map or Terrain look but Stat Bar, Dashboard and Skyline (3D draws its
     own); Neon, Street Map, Terrain and Gallery on their other looks too, as
     before. Not over a map the customer supplied, not on the frame. */
  var SF_KINDS={'':1,'terrain':1,'editorial':1,'gallery':1,'manifesto':2,'rings':2,'cover':2,'card':2,'horizon':2};
  function sfRowOk(){
    var k=(typeof DESIGN_KIND==='undefined' || !DESIGN_KIND) ? '' : DESIGN_KIND, w=SF_KINDS[k];
    if(!w || !state.coords || state.mapUser) return false;
    if(w===2 && state.style!=='map' && state.style!=='terrain') return false;
    try{ if(focusProd()==='frame') return false; }catch(e){}
    return true;
  }
  /* On by default on a Map or Terrain look; the Neon look's words stay off. */
  function sfDefaultOn(){ return sfRowOk() && (state.style==='map' || state.style==='terrain'); }
  var _sfTouched=false;
  /* Km markers, scale bar and north arrow (22 Oct pm): Terrain and Street
     Map, with a route, never on the frame (its panel is too small for a
     numeral) and not over a map the customer supplied (unknown scale). */
  function kmOn(){ var e=$('cz-km'); return !!(e && e.checked); }
  function syncKmRow(){
    var box=$('cz-km'), row=$('cz-kmRow'); if(!box || !row) return;
    var ok = !!state.coords && !state.mapUser &&
             (typeof DESIGN_KIND!=='undefined' && (DESIGN_KIND==='terrain' || DESIGN_KIND==='editorial' || DESIGN_KIND==='gallery')) &&
             focusProd()!=='frame' &&
             (state.style!=='terrain' || !!(state.terrainBase && state.terrainBase._pr));
    row.style.display = ok ? 'flex' : 'none';
    if(!ok && box.checked) box.checked=false;
  }
  /* The Gallery photo controls. Shown for that design only, and the zoom
     slider only once there is a photo to zoom - an inert slider above an empty
     panel reads as something that is broken. */
  function syncGalRow(){
    var row=$('cz-galRow'); if(!row) return;
    var on = (typeof DESIGN_KIND!=='undefined' && (DESIGN_KIND==='gallery' || sbOn() || ndPh()));
    row.style.display = on ? 'block' : 'none';
    if(!on) return;
    var pk=$('cz-galPick'); if(pk) pk.textContent = splitPhoto ? 'Change photo' : 'Add your photo';
    var zr=$('cz-galZoomRow'); if(zr) zr.style.display = splitPhoto ? 'flex' : 'none';
    var hn=$('cz-galHint'); if(hn) hn.style.display = splitPhoto ? 'block' : 'none';
    galDpiNote();
  }

  /* What the cropped area works out to at the printed size. The brief's
     threshold is 150 DPI on the PANEL, which is not the sheet: on A3 the panel
     is about 126 x 250 mm, so a photo that would be ample across a whole poster
     can still be thin in this column. Measured off the layout rather than
     estimated, so moving the panels moves the warning with them. */
  var GAL_DPI_WARN=150;
  function galPanelDpi(){ return splitPhoto?galPanelDpiFor(splitPhoto):null; }
  /* Takes the image rather than reading splitPhoto, so the picker can judge a
     photo before accepting it - at that point it is not the design's photo. */
  function galPanelDpiFor(im,zo){
    if(!im) return null;
    if(typeof sbOn==='function' && sbOn()) return sbPanelDpiFor(im,zo);
    if(typeof ndPh==='function' && ndPh()) return ndPanelDpiFor(im,zo);
    var sheet=galSheet(), W=1000, H=Math.round(W*sheet[1]/sheet[0]);
    var cv=_galMeasureCv || (_galMeasureCv=document.createElement('canvas'));
    var L=galLayout(cv.getContext('2d'),0,0,W,H);
    /* The panel's real size in inches, from its share of the sheet. */
    var inW=sheet[0]*L.photoR.w/W, inH=sheet[1]*L.photoR.h/H;
    var c=galCrop(im,L.photoR.w,L.photoR.h,zo);
    return Math.min(c.sw/inW, c.sh/inH);
  }
  var _galMeasureCv=null;
  function galDpiNote(){
    /* The slider stops where the photo would start to soften. */
    try{ var zs=$('cz-galZoom'); if(zs && splitPhoto){
      var cap=galZoomCap(); if(galZoom>cap) galZoom=cap;
      zs.max=String(Math.max(100,Math.floor(cap*100))); zs.value=String(Math.round(galZoom*100));
      zs.disabled = cap<1.02; } }catch(e){}
    var el=$('cz-galDpi'); if(!el) return;
    var d=galPanelDpi();
    if(d===null || d>=GAL_DPI_WARN){ el.style.display='none'; el.textContent=''; return; }
    el.style.display='block';
    el.textContent='This photo prints at about '+Math.round(d)+' DPI in the panel, '+
      'under the '+GAL_DPI_WARN+' it wants, so zoom is off for it. Use the original '+
      'from your camera roll rather than one saved from Instagram or Facebook.';
  }

  function syncRibbonRow(){
    var row=$('cz-ribbonRow'); if(!row) return;
    /* Editorial only, and only when the GPX actually carries relief. */
    /* Not on the frame: the panel is 107 mm wide and the ribbon would be a
       smear. Every other format keeps it. */
    var ok = (typeof DESIGN_KIND!=='undefined'
              && (DESIGN_KIND==='editorial' || DESIGN_KIND==='gallery'))
             && focusProd()!=='frame'
             && isMapLike(state.style) && eleUsable();
    var _gWas=galRibOn();
    row.style.display = ok ? 'flex' : 'none';
    var c=$('cz-ribbon');
    if(!ok){ if(c) c.checked=false; }
    /* A ride's ribbon is on by default - climbing is the story of a ride -
       until the customer unticks it. */
    else if(c && !c.checked && !_ribTouched && sp().ribbon){ c.checked=true; _ribAuto=true; }
    if(galRibOn()!==_gWas) galRibRefetch();
  }
  var MEDAL_NOTE='<span class="cz-attrib">The dashed circle is where your own medal hangs, '
    +'on the ribbon slot \u2014 it is not printed. The frame is included.</span>';
  function updateStyleHint(){ syncRibbonRow(); syncSfRow(); syncKmRow(); syncGalRow(); sbSyncUI(); if(typeof giftSync==='function') giftSync();
    var h=$('cz-styleHint'); if(!h)return;
    if(state.mapUser){ h.textContent='Map screenshot detected — only the Map style is available for this upload.'; }
    else if(state.style==='heat'){ h.textContent='Coloured by elevation — low is light, high is red.'; }
    else if(state.style==='map'){ h.innerHTML='Your route on a map. <span class="cz-attrib">Map data © OpenStreetMap contributors, via Geoapify.</span>'; }
    else if(state.style==='terrain'){ h.innerHTML='<b>Beta</b> — contour lines and hillshading, best for trail and hill routes. Still being refined. <span class="cz-attrib">Elevation: Mapzen Terrain Tiles / AWS Open Data.</span>'; }
    else if(!state.coords){ h.textContent='Upload a GPX to unlock the Elevation, Map & Terrain styles.'; }
    else if(!MAPKEY){ h.textContent='Add a map key in settings to enable the Map style.'; }
    else { h.textContent=''; }
    /* Appended to whatever the style hint just said, so it rides on an element
       that is demonstrably on screen rather than one inserted beside it. */
    if(focusProd()==='frame'){
      var _cur=h.innerHTML;
      h.innerHTML = _cur ? (_cur+'<br>'+MEDAL_NOTE) : MEDAL_NOTE;
    }
    var pal=$('cz-pal'); if(pal) pal.classList.toggle('cz-show', routePalOn());
    var ms=$('cz-mstyles'); if(ms) ms.classList.toggle('cz-show', state.style==='map' && !state.mapUser);
    var ts2=$('cz-tstyles'); if(ts2) ts2.classList.toggle('cz-show', state.style==='terrain' && !state.mapUser);
    if(typeof updatePageAttrib==='function') updatePageAttrib();
  }
  var NEON=['#FF5A1F','#FF2D55','#FF3DB8','#B15CFF','#4C8DFF','#22D3EE','#34F06E','#D6F000','#FFD028','#F2F2F2'];
  /* p_routecol (27 Oct): the printed styles' palette - strong enough on a
     light map and on hillshade. The sport's own colour leads it (routePal). */
  var ROUTE_PAL=[{hex:'#FF5A1F',name:'Vermilion'},{hex:'#D7263D',name:'Red'},{hex:'#C2189B',name:'Magenta'},
                 {hex:'#6D3FD1',name:'Violet'},{hex:'#1F6FEB',name:'Blue'},{hex:'#0E8C8C',name:'Teal'},
                 {hex:'#2E9E45',name:'Green'},{hex:'#E3A008',name:'Gold'},{hex:'#17171A',name:'Ink'}];
  var NEON_NAMES=['Vermilion','Red','Pink','Violet','Blue','Cyan','Green','Lime','Yellow','White'];
  function routeDefHex(){
    if(typeof sbOn==='function' && sbOn()) return SB_ACC;
    var _rlh=''; try{ _rlh=relayHex()||relaySoloHex(); }catch(e){}
    return _rlh || routeHexBase();
  }
  /* [{hex,name}] for the style on screen. */
  function routePal(){
    if(state.style==='neon') return NEON.map(function(h,i){ return {hex:h, name:NEON_NAMES[i]||h}; });
    var d=routeDefHex().toUpperCase(), out=[{hex:d, name:'Sport colour'}];
    ROUTE_PAL.forEach(function(c){ if(c.hex.toUpperCase()!==d) out.push(c); });
    return out;
  }
  function routeColName(hex){
    var h=String(hex||'').toUpperCase(), p=routePal().concat(ROUTE_PAL), i;
    for(i=0;i<p.length;i++) if(p[i].hex.toUpperCase()===h) return p[i].name+' '+h;
    return h;
  }
  /* The palette is offered on every style but Elevation and a map screenshot. */
  function routePalOn(){
    if(state.mapUser) return false;
    if(state.style==='neon') return true;
    if(state.style==='heat') return false;
    return routeColOK();
  }
  /* 30 Oct (Marc): the route colour row sits after the stats fields, on every
     design and layout - straight after #cz-opt, wherever that block lives. */
  function palBottom(){
    var pal=$('cz-pal'), opt=$('cz-opt'); if(!pal || !opt || !opt.parentNode) return;
    /* Stat Bar's colourways stay where they were (25 Oct, Marc: above the
       preview): a marker keeps the row's old place */
    if(!$('cz-palhome') && pal.parentNode){ var hm=document.createElement('div'); hm.id='cz-palhome'; pal.parentNode.insertBefore(hm, pal); }
    if(opt.nextSibling!==pal) opt.parentNode.insertBefore(pal, opt.nextSibling);
    pal.classList.add('cz-palbottom');
    if(typeof sbColourRow==='function') try{ sbColourRow(); }catch(e){}
  }
  function buildPalette(){ var p=$('cz-pal'); if(!p)return; p.innerHTML='';
    var lab=document.createElement('span'); lab.className='cz-lbl cz-pallbl'; lab.textContent='Route colour'; p.appendChild(lab);
    var cur=(state.style==='neon') ? String(state.accent) : (routePick() ? String(state.accent) : routeDefHex());
    routePal().forEach(function(c){ var hex=c.hex, b=document.createElement('button'); b.type='button';
      b.className='cz-sw2'+(hex.toLowerCase()===cur.toLowerCase()?' cz-on':'');
      b.style.background=hex; b.title=c.name; b.setAttribute('aria-label','Route colour '+c.name);
      b.setAttribute('data-hex',hex);
      b.addEventListener('click',function(){ state.accent=hex; _accTouched=true;
        p.querySelectorAll('.cz-sw2').forEach(function(c){c.classList.remove('cz-on');}); b.classList.add('cz-on');
        /* Stat Bar draws its line at render. Street Map and Terrain have it
           baked in, and their keys carry routeHex(), so ensureMap fetches or
           builds the new picture (the old one stays up meanwhile). */
        if(typeof sbOn==='function' && sbOn()){ render(); }
        else if(typeof t3On==='function' && t3On()){ render(); }   /* 3D draws its route at render */
        else if(isMapLike(state.style) && !state.mapUser){ ensureMap(function(){ ensureMap2(render); }); }
        else { render(); } });
      p.appendChild(b); }); }
  function markStyle(s){ Array.prototype.forEach.call(document.querySelectorAll('#cz-styles .cz-tab'),function(b){ b.classList.toggle('cz-on', b.getAttribute('data-s')===s); }); }
  function selectStyle(s){ state.style=s;
    /* Switching to the map puts it on the design's own palette, unless the
       customer has chosen one - 'standard' is the untouched value, the same
       test start-up uses. Without this a design could end up on osm-bright
       after a style change even though start-up had set it to positron. */
    if(s==='map' && state.mapStyle==='standard'){
      var _st=tileThemeFor(DESIGN_KIND);
      if(_st){
        state.mapStyle=_st;
        try{
          var _sm=root.querySelectorAll('#cz-mstyles .cz-mtab');
          for(var _si=0;_si<_sm.length;_si++)
            _sm[_si].classList.toggle('cz-on',_sm[_si].getAttribute('data-ms')===_st);
        }catch(e){}
      }
    }
    Array.prototype.forEach.call(document.querySelectorAll('#cz-styles .cz-tab'),function(b){ b.classList.toggle('cz-on', b.getAttribute('data-s')===s); });
    /* p_routecol: a neon white does not belong on a light map. */
    if(_accTouched && !routePal().some(function(c){ return c.hex.toLowerCase()===String(state.accent).toLowerCase(); })){
      _accTouched=false; state.accent=routeHex();
    }
    try{ buildPalette(); }catch(e){}
    updateStyleHint();
    if(isMapLike(s)){ ensureMap(function(){ ensureMap2(render); }); } else { render(); }
  }
  function resetRouteData(){ state.coords=null; state.eles=null; state.heatCanvas=null; state.heatBbox=null; state.mapImg=null; state.mapUrl=''; state.mapUser=false; state.routeIsDefault=false; }
  function showClear(on){ var c=$('cz-clear'); if(c) c.style.display=on?'block':'none'; }
  function resetAll(){
    forgetRouteParam(); ownForget();
    restoreProductCopy();
    resetRouteData();
    state.srcFile=null; state.srcUrl=''; state.srcType=''; state.race=''; state.locked=false;
    if(drop){ drop.classList.remove('cz-has'); drop.style.pointerEvents=''; }
    if(file){ file.disabled=false; file.value=''; }
    $('cz-dropTitle').textContent='Tap to add your route — GPX or image';
    var sp=drop&&drop.querySelector('span'); if(sp) sp.innerHTML='Drop a <b>.gpx</b>, a route screenshot, or a map screenshot — we crop to your route automatically.';
    var oc=$('cz-ocrStatus'); if(oc){ oc.className='cz-ocrstat'; oc.textContent=''; }
    $('cz-title').value='Your Route'; $('cz-loc').value='Sydney, Australia';
    ['cz-dist','cz-pace','cz-h','cz-m','cz-s'].forEach(function(id){ var e=$(id); if(e) e.value=''; });
    var de=$('cz-date'); if(de) de.value='';   
    var op=$('cz-opt'); if(op) op.classList.remove('cz-show');
    var mb=$('cz-moreBtn'); if(mb) mb.textContent='+ Add stats (distance, time, pace)';
    titleTouched=false; dateTouched=false;
    try{ relaySyncUI(); }catch(e){}
    var rurl=$('cz-routeurl'); if(rurl) rurl.value='';
    state.r2=null;                                     
    var r2e=$('cz-r2'); if(r2e) r2e.style.display='none';
    var a2e=$('cz-add2'); if(a2e) a2e.style.display='';
    var d2e=$('cz-drop2'); if(d2e) d2e.classList.remove('cz-has');
    var d2t=$('cz-drop2Title'); if(d2t) d2t.textContent='Tap to add route 2 — GPX or screenshot';
    var f2=$('cz-file2'); if(f2) f2.value='';
    ['cz-dist2','cz-pace2','cz-h2','cz-m2','cz-s2','cz-date2'].forEach(function(id){ var e=$(id); if(e) e.value=''; });
    loadDefaultRoute();
    /* Nothing else is coming after a start over - the sample is the route, so
       the map is drawn for it instead of waiting for the product's default. */
    state.routeIsDefault=false;
    /* From the table, not a ternary per design: a ternary is how Gallery would
       have reset to neon while its own strip tile said map. KIND_STYLE_ALL is
       assigned further down but this only runs on a user action. */
    var boot0=KIND_STYLE_ALL[DESIGN_KIND||'']||'neon';
    state.style=boot0; markStyle(boot0); refreshStyles(); render();
    /* A map style needs its map asked for - render() alone left Street Map and
       Gallery on "Loading map" after a start over. */
    if(isMapLike(boot0)) ensureMap(function(){ ensureMap2(render); });
    showClear(false);
  }
  /* An upload has no address, so it is kept for the visit (26 Oct): a design
     switch carries own=1 and the next page loads it back. */
  var OWN_KEY='msOwnRoute';
  function ownSave(cds,els,type,name){
    try{ sessionStorage.setItem(OWN_KEY, JSON.stringify({poly:encodePoly(cds,els), type:type||'', file:name||'route.gpx'})); }catch(e){}
  }
  function ownHas(){ try{ return !!sessionStorage.getItem(OWN_KEY); }catch(e){ return false; } }
  function ownForget(){ try{ sessionStorage.removeItem(OWN_KEY); }catch(e){} }
  function ownRestore(){
    if(!getParam('own') || getParam('r') || getParam('gpx') || getParam('race')) return false;
    var o=null; try{ o=JSON.parse(sessionStorage.getItem(OWN_KEY)||'null'); }catch(e){}
    var d=(o && o.poly) ? decodePoly(o.poly) : null; if(!d || !d.coords || d.coords.length<2) return false;
    var esc=function(t){ return String(t).replace(/[<>&]/g,''); }, pts=[], i;
    for(i=0;i<d.coords.length;i++){
      var e=d.eles ? d.eles[i] : NaN;
      pts.push('<trkpt lat="'+d.coords[i][0]+'" lon="'+d.coords[i][1]+'">'+(isFinite(e)?'<ele>'+e+'</ele>':'')+'</trkpt>');
    }
    var txt='<?xml version="1.0"?><gpx version="1.1"><trk>'+(o.type?'<type>'+esc(o.type)+'</type>':'')+'<trkseg>'+pts.join('')+'</trkseg></trk></gpx>', f;
    try{ f=new File([txt], o.file||'route.gpx', {type:'application/gpx+xml'}); }
    catch(e2){ f=new Blob([txt], {type:'application/gpx+xml'}); try{ f.name=o.file||'route.gpx'; }catch(e3){} }
    loadGPX(f, true); return true;
  }
  function loadGPX(f, keep){
    var st=$('cz-ocrStatus'); st.className='cz-ocrstat cz-load'; st.textContent='Reading your GPX…';
    var rd=new FileReader();
    rd.onerror=function(){ st.className='cz-ocrstat cz-warn'; st.textContent='Couldn’t open that file.'; };
    rd.onload=function(){
      var g=parseGPX(rd.result);
      if(g && g.sport) setSport(g.sport,'file');
      if(!g || g.coords.length<2){
        /* Could still be an image the browser mislabelled, so try that before
           giving up - only then is it genuinely an unsupported file. */
        if(/^\s*[^<{]/.test(String(rd.result||'').slice(0,40)) && f.size && f.size>1024){ loadPhoto(f); return; }
        st.className='cz-ocrstat cz-warn';
        st.textContent='Couldn’t find a route in that file. GPX, TCX, KML and GeoJSON all work — .fit files need converting first.';
        return;
      }
      var idx=downsampleIdx(g.coords.length,3000), cds=idx.map(function(i){return g.coords[i];}), els=idx.map(function(i){return g.eles[i];});
      state.srcFile=f; state.srcUrl=''; state.srcType='gpx'; state.emptyRoute=false;
      forgetRouteParam();
      if(!keep) clearStats();
      ownSave(cds,els,g.sport||'',f.name);
      if(typeof ndHalfFromFile==='function') ndHalfFromFile(g);
      state.coords=cds; state.eles=els; state.mapImg=null; state.mapUrl='';
      state.routeIsDefault=false;
      state.style='neon'; markStyle('neon');
      processToMask(gpxToCanvas(cds));
      buildHeatCanvas(cds,els);
      drop.classList.add('cz-has'); $('cz-dropTitle').textContent='✓ Route loaded — tap to replace';
      var nm=titleFromFilename(f.name); if(nm && !titleTouched){ $('cz-title').value=nm.slice(0,28); }
      var km=routeKm(g.coords), kmStr=(km<100?km.toFixed(1):Math.round(km))+' km';
      if(km>0) $('cz-dist').value=kmStr;
      
      if($('cz-dist').value||$('cz-date').value){ $('cz-opt').classList.add('cz-show'); $('cz-moreBtn').textContent='– Hide stats'; }
      showClear(true); st.className='cz-ocrstat cz-ok'; st.textContent='✓ Exact route loaded'+(km>0?(' · '+kmStr):'')+'.';
      refreshStyles(); render();
    };
    rd.readAsText(f);
  }
  /* The gallery panel's width over its height for a given format, worked out
     from the sheet and the layout fractions rather than read back from the last
     render. Everything in the text block is a fraction of W, so W cancels and
     this is exact for a one-line title - which is the case the map is framed
     for. A wrapped title moves it by a percent or two, which the cover-crop
     absorbs.

     It has to be computable without a canvas: the map request is made before
     anything has been laid out, and reading back "whatever rendered last" is
     what fed the magnet a poster-shaped map. */
  /* Grow a lon/lat rect until its RENDERED shape matches `want` (width over
     height). Only ever grows - shrinking it would crop the route, which is the
     thing this exists to prevent.

     A degree of longitude is cos(latitude) as wide as a degree of latitude on
     the rendered map, so the comparison has to be made in rendered units or the
     padding is about 20% too wide at Sydney's latitude and wrong in the other
     direction near the equator. */
  function galPadArea(lo0,la0,lo1,la1,want){
    var dLo=lo1-lo0, dLa=la1-la0;
    if(!(dLo>0) || !(dLa>0) || !(want>0)) return [lo0,la0,lo1,la1];
    var k=Math.cos((la0+la1)/2*Math.PI/180);
    if(!(k>0.05)) k=0.05;                       /* nobody runs at the pole */
    var have=(dLo*k)/dLa;
    if(have<want){                              /* too tall - widen it */
      var needLo=want*dLa/k, addLo=(needLo-dLo)/2;
      lo0-=addLo; lo1+=addLo;
    } else if(have>want){                       /* too wide - heighten it */
      var needLa=(dLo*k)/want, addLa=(needLa-dLa)/2;
      la0-=addLa; la1+=addLa;
    }
    return [lo0,la0,lo1,la1];
  }
  /* Gallery's ribbon: a ride's, while it is ticked and drawable. */
  function galRibOn(){ return !!(IS_GAL && typeof ribbonOn==='function' && ribbonOn()); }
  function galRibRefetch(){
    try{
      if(isMapLike(state.style) && !state.mapUser && state.coords){
        state.mapImg=null; state.mapUrl=''; state.terrainBase=null;
        ensureMap(function(){ ensureMap2(render); });
      } else render();
    }catch(e){}
  }
  function galAspectFor(prod){
    var sheet=galSheet(prod), cmp=galCompact(prod);
    var H=sheet[1]/sheet[0];                 /* height in units of width */
    var m=cmp?GAL.mComp:GAL.mFull;
    var pw=(1-2*m)/2;
    var text=GAL.accH+GAL.accGap
            +(cmp?GAL.titleComp:GAL.titleFull)*GAL.titleLh
            /* The line under the title is in both modes now - it carries the
               name - so it is always part of the block. A poster with neither a
               name nor a date has no line and comes out a couple of percent
               taller than this; the map's 15% margin absorbs that. */
            +GAL.mergeGap+(cmp?GAL.mergeSize:GAL.mergeFull)*GAL.lhMono
            +GAL.hairGap+GAL.key+GAL.hairGap
            +(cmp?GAL.labComp:GAL.labFull)*GAL.lhMono+GAL.labGap
            +(cmp?GAL.valComp:GAL.valFull)*GAL.valLh
            +GAL.botPad;
    if(galRibOn()) text+=GAL.ribGap+GAL.ribH+relayRibExtra(1);
    var ph=H-2*m-GAL.gap-text;
    if(!(ph>0.05)) ph=0.05;
    return pw/ph;
  }
  function mapUrlForCoords(coords){ if(!coords||!MAPKEY) return '';
    var simp=dpSimplify(coords,0.00002);
    if(simp.length>300) simp=dpSimplify(coords,0.00006);
    if(simp.length>300){ var ix=downsampleIdx(simp.length,300); simp=ix.map(function(i){return simp[i];}); }
    var minLa=Infinity,maxLa=-Infinity,minLo=Infinity,maxLo=-Infinity;
    var pp=simp.map(function(c){ var la=c[0],lo=c[1];
      if(la<minLa)minLa=la; if(la>maxLa)maxLa=la; if(lo<minLo)minLo=lo; if(lo>maxLo)maxLo=lo;
      return lo.toFixed(5)+','+la.toFixed(5); });
    var mLa=Math.max((maxLa-minLa)*0.15,0.0006), mLo=Math.max((maxLo-minLo)*0.15,0.0006);
    var area='rect:'+(minLo-mLo).toFixed(5)+','+(minLa-mLa).toFixed(5)+','+(maxLo+mLo).toFixed(5)+','+(maxLa+mLa).toFixed(5);
    var geom='polyline:'+pp.join(',')+';linecolor:'+routeHex().toLowerCase()+';linewidth:5;lineopacity:1';
    return 'https://maps.geoapify.com/v1/staticmap?style='+(MAPSTYLES[state.mapStyle]||'osm-bright')+'&width='+(IS_EDT?1000:800)+'&height='+(IS_EDT?780:1000)+'&format=png&area='+encodeURIComponent(area)+'&geometry='+encodeURIComponent(geom)+'&apiKey='+MAPKEY; }
  var _map2Gen=0;
  function ensureMap2(cb){ var gen2=++_map2Gen;
    if(!has2() || !isMapLike(state.style)){ cb&&cb(); return; }
    if(!state.r2.coords){ cb&&cb(); return; }                       
    var u=(state.style==='terrain')?terrainKey(state.r2.coords):mapUrlForCoords(state.r2.coords); if(!u){ cb&&cb(); return; }
    if(state.r2.mapImg && state.r2.mapUrl===u){ cb&&cb(); return; }
    var h=$('cz-styleHint'); if(h) h.textContent=(state.style==='terrain')?'Building terrain…':'Loading maps…';
    function fail2(msg){ state.r2.mapImg=null; state.r2.mapUrl=''; if(h) h.textContent=msg; cb&&cb(); }
    if(state.style==='terrain'){
      buildTerrain(state.r2.coords,function(cv){
        if(gen2!==_map2Gen) return;
        if(!cv){ fail2('Terrain couldn’t be built for the second route.'); return; }
        state.r2.mapImg=cv; state.r2.mapUrl=u; if(h)h.textContent=''; cb&&cb();
      });
      return;
    }
    function load(cross){ var im=new Image(); if(cross) im.crossOrigin='anonymous';
      im.onload=function(){ if(gen2!==_map2Gen) return;
        state.r2.mapImg=im; state.r2.mapUrl=u; if(h)h.textContent=''; cb&&cb(); };
      im.onerror=function(){ if(gen2!==_map2Gen) return;
        if(cross){ load(false); }
        else { console.error('Milestone: route 2 map failed to load —', u); fail2('Second route’s map couldn’t load — check the map key.'); } };
      im.src=u; }
    load(true); }
  function loadGPX2(f){
    var rd=new FileReader();
    rd.onload=function(){
      var g=parseGPX(rd.result), t2=$('cz-drop2Title');
      if(!g || g.coords.length<2){ if(t2)t2.textContent='Couldn’t read that GPX — try another.'; return; }
      var idx=downsampleIdx(g.coords.length,3000), cds=idx.map(function(i){return g.coords[i];}), els=idx.map(function(i){return g.eles[i];});
      var save={mask:state.mask,bbox:state.bbox,heatCanvas:state.heatCanvas,heatBbox:state.heatBbox};   
      processToMask(gpxToCanvas(cds)); buildHeatCanvas(cds,els);                                        
      state.r2={coords:cds,eles:els,mask:state.mask,bbox:state.bbox,heatCanvas:state.heatCanvas,heatBbox:state.heatBbox,mapImg:null,mapUrl:'',mapUser:false};
      state.mask=save.mask; state.bbox=save.bbox; state.heatCanvas=save.heatCanvas; state.heatBbox=save.heatBbox; 
      var d2=$('cz-drop2'); if(d2) d2.classList.add('cz-has'); if(t2)t2.textContent='✓ Route 2 loaded — tap to replace';
      var km=routeKm(g.coords); if(km>0 && $('cz-dist2') && !$('cz-dist2').value) $('cz-dist2').value=(km<100?km.toFixed(1):Math.round(km))+' km';
      ensureMap2(render);
    };
    rd.readAsText(f);
  }
  function loadPhoto2(f){
    var img=new Image(), t2=$('cz-drop2Title');
    img.onload=function(){
      var save={mask:state.mask,bbox:state.bbox};
      if(looksLikeMap(img)){
        state.r2={coords:null,eles:null,mask:null,bbox:null,heatCanvas:null,heatBbox:null,mapImg:cropMapToRoute(img),mapUrl:'user',mapUser:true};
        if(t2)t2.textContent='✓ Map added — tap to replace';
      } else {
        processToMask(img);                             
        state.r2={coords:null,eles:null,mask:state.mask,bbox:state.bbox,heatCanvas:null,heatBbox:null,mapImg:null,mapUrl:'',mapUser:false};
        state.mask=save.mask; state.bbox=save.bbox;     
        if(t2)t2.textContent='✓ Route added — tap to replace';
      }
      var d2=$('cz-drop2'); if(d2)d2.classList.add('cz-has');
      render();
    };
    img.onerror=function(){ if(t2) t2.textContent='That file couldn’t be read — upload a GPX file or a screenshot.'; };
    img.src=URL.createObjectURL(f);
  }
  function handleFile2(f){ if(isGPX(f)) loadGPX2(f); else loadPhoto2(f); }
  (function(){
    function show2(on){ var r2=$('cz-r2'), a2=$('cz-add2');
      if(r2) r2.style.display=on?'block':'none';
      if(a2) a2.style.display=on?'none':''; }
    var a=$('cz-add2'); if(a) a.onclick=function(){ show2(true); };
    var rm=$('cz-rm2'); if(rm) rm.onclick=function(){ state.r2=null; show2(false); render(); };
    var d=$('cz-drop2'); if(d) d.onclick=function(){ var f=$('cz-file2'); if(f)f.click(); };
    var fi=$('cz-file2'); if(fi) fi.onchange=function(){ if(fi.files&&fi.files[0]) handleFile2(fi.files[0]); };
    ['cz-dist2','cz-h2','cz-m2','cz-s2','cz-pace2','cz-date2'].forEach(function(id){ var e=$(id); if(e) e.addEventListener('input',render); });
  })();
  document.getElementById('cz-styles').addEventListener('click',function(e){
    var t=e.target.closest('.cz-tab'); if(!t||t.disabled)return;
    /* On the frame the Elevation slot is relabelled Photo and switches the
       DESIGN rather than the style - see refreshStyles(). */
    if(t.getAttribute('data-photo')==='1'){ framePhoto(true); return; }
    if(IS_PO && isPhotoFmt(focusProd())) framePhoto(false);
    selectStyle(t.getAttribute('data-s'));
  });
  /* What the design was before Photo took over, so leaving Photo goes back to
     it instead of dropping to neon. */
  var _frPrevKind=null;
  function framePhoto(on){
    if(on && _frPrevKind===null) _frPrevKind=DESIGN_KIND;
    var k = on ? 'photo-overlay' : (_frPrevKind||'');
    if(!on) _frPrevKind=null;
    DESIGN_KIND=k;
    IS_SPLIT=(k==='photo-split'); IS_EDT=(k==='editorial');
    IS_TD=(k==='terrain');        IS_PO=(k==='photo-overlay');
    IS_GAL=(k==='gallery');
    kindAttr();
    if(on){
      state.style='neon';                 /* the photo is the background now */
      markStyle('heat');                  /* the relabelled tab stays lit */
      /* No canvas hit rect to rely on here, so ask for the file outright. */
      if(!splitPhoto && typeof splitFilePick==='function') splitFilePick();
    }
    /* Both of these: refreshStyles re-enables the right tabs for the restored
       design, updateStyleHint shows or hides the tile and terrain theme rows.
       Without the second, the Standard/Dark/Light row sat under Photo. */
    refreshStyles(); updateStyleHint();
    render();
  }
  document.getElementById('cz-mstyles').addEventListener('click',function(e){ var b=e.target.closest('.cz-mtab'); if(!b)return;
    state.mapStyle=b.getAttribute('data-ms');
    Array.prototype.forEach.call(this.children,function(c){c.classList.remove('cz-on');}); b.classList.add('cz-on');
    state.mapUrl=''; if(state.style==='map') ensureMap(function(){ ensureMap2(render); }); });
  var _tsEl=document.getElementById('cz-tstyles');
  if(_tsEl) _tsEl.addEventListener('click',function(e){ var b=e.target.closest('.cz-mtab'); if(!b)return;
    state.terrainTheme=b.getAttribute('data-tt');
    Array.prototype.forEach.call(this.children,function(c){c.classList.remove('cz-on');}); b.classList.add('cz-on');
    state.mapImg=null; state.mapUrl=''; if(state.style==='terrain') ensureMap(function(){ ensureMap2(render); }); });
  (function(){ var q=$('cz-q'), tip=$('cz-tip');
    if(q&&tip){ q.addEventListener('click',function(e){ e.stopPropagation(); tip.classList.toggle('cz-show'); });
      document.addEventListener('click',function(e){ if(tip.classList.contains('cz-show') && !tip.contains(e.target) && e.target!==q) tip.classList.remove('cz-show'); }); } })();
  (function(){ var c=$('cz-clear'); if(c) c.addEventListener('click',resetAll); })();

  function titleFromFilename(name){
    var n=(name||'').replace(/\.[^.]+$/,'').replace(/[_\-]+/g,' ').replace(/\s+/g,' ').trim();
    return n.replace(/\b\w/g,function(ch){return ch.toUpperCase();});
  }
  /* No sample route any more: a page with nothing preloaded starts empty,
     and every design shows "+ ADD YOUR GPX" where the route goes. */
  function loadDefaultRoute(){
    state.coords=null; state.eles=null; state.srcType=''; state.srcFile=null;
    state.mask=null; state.bbox=null; state.heatCanvas=null; state.heatBbox=null;
    state.mapImg=null; state.mapUrl=''; state.mapUser=false; state.terrainBase=null;
    state.routeIsDefault=true; state.emptyRoute=true;
  }
  function noRoute(){
    if(typeof IS_TRI!=='undefined' && IS_TRI) return false;
    if(!state.emptyRoute) return false;
    if(state.coords && state.coords.length>1) return false;
    try{ if(awaitingRoute()) return false; }catch(e){}
    return true;
  }
  /* The empty route slot - same words and dashed box as the photo slot. */
  var gpxPromptRect=null;
  function drawRoutePrompt(ctx,x,y,w,h,dark){
    if(_splitHeroPaint) gpxPromptRect={x:x,y:y,w:w,h:h};
    ctx.save(); ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
    ctx.strokeStyle=dark?'rgba(255,255,255,0.32)':'rgba(23,23,26,0.28)';
    var u=Math.min(w,h);
    ctx.setLineDash([u*0.035,u*0.035]); ctx.lineWidth=Math.max(1,u*0.007);
    ctx.strokeRect(x+w*0.05,y+h*0.05,w*0.90,h*0.90); ctx.setLineDash([]);
    ctx.textAlign='center'; ctx.textBaseline='alphabetic';
    var t1='+  ADD YOUR GPX', ps=Math.min(w*0.075,h*0.13), g=0;
    ctx.font='700 '+ps+'px Inter,sans-serif';
    while(ctx.measureText(t1).width>w*0.80 && ps>6 && g++<60){ ps*=0.94; ctx.font='700 '+ps+'px Inter,sans-serif'; }
    ctx.fillStyle=dark?'#F0EDE6':'#17171A';
    ctx.fillText(t1, x+w/2, y+h/2-ps*0.05);
    ctx.font='500 '+(ps*0.48)+'px Inter,sans-serif';
    ctx.fillStyle=dark?'rgba(240,237,230,0.70)':'rgba(23,23,26,0.58)';
    ctx.fillText('tap here to upload', x+w/2, y+h/2+ps*0.95);
    ctx.textAlign='left'; ctx.restore();
  }
  function pickGpx(){ var f=$('cz-file'); if(f){ try{ f.click(); }catch(e){} } }

  var titleTouched=false;
  $('cz-title').addEventListener('input',function(){titleTouched=true;});
  var dateTouched=false;
  $('cz-date').addEventListener('input',function(){dateTouched=true;});
  (function(){ var b=$('cz-dateClear'); if(b) b.addEventListener('click',function(){ var de=$('cz-date'); if(de) de.value=''; dateTouched=true; render(); }); })();
  (function(){
    document.addEventListener('click',function(e){
      var b=e.target && e.target.closest ? e.target.closest('.cz-statoff') : null; if(!b) return;
      e.preventDefault(); e.stopPropagation();
      var k=b.getAttribute('data-stat'); STAT_OFF[k]=!STAT_OFF[k]; syncStatBtns(); render();
    });
    var F={dist:['cz-dist'], time:['cz-h','cz-m','cz-s'], pace:['cz-pace'], gain:['cz-gain'], summit:['cz-summit']};
    Object.keys(F).forEach(function(k){ F[k].forEach(function(id){ var el=$(id); if(el) el.addEventListener('input',function(){
      if(STAT_OFF[k]){ STAT_OFF[k]=false; syncStatBtns(); render(); } }); }); });
    syncStatBtns();
  })();
  var _tess=null;
  function loadTesseract(){
    if(window.Tesseract) return Promise.resolve(window.Tesseract);
    if(_tess) return _tess;
    _tess=new Promise(function(res,rej){
      var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js';
      s.onload=function(){res(window.Tesseract);}; s.onerror=function(){rej(new Error('blocked'));};
      document.head.appendChild(s);
      setTimeout(function(){ if(!window.Tesseract) rej(new Error('timeout')); },20000);
    });
    return _tess;
  }
  function parseStats(text){
    var lines=text.split('\n').map(function(l){return l.trim();}).filter(Boolean);
    var out={title:null,distance:null,time:null,pace:null,date:null};
    var skip=/^(distance|time|pace|elev|elevation|km|mi|strava|avg|average|speed|calories|cal|bpm|moving|elapsed|run|ride)$/i;
    for(var i=0;i<lines.length;i++){ var l=lines[i];
      if(skip.test(l))continue; if(/^[\d.:/hm%\s]+$/i.test(l))continue;
      if(/[A-Za-z]{3,}/.test(l)&&l.replace(/[^A-Za-z]/g,'').length>=3&&l.length<=28){ out.title=l; break; } }
    var flat=lines.join(' ');
    var m=flat.match(/(\d{1,2}:\d{2})\s*\/?\s*km/i); if(m) out.pace=m[1]+' /km';
    var paceVal=out.pace?out.pace.split(' ')[0]:null;
    
    m=flat.match(/\b(\d{1,2}):(\d{2}):(\d{2})\b/);
    if(m){ out.time=m[1]+':'+m[2]+':'+m[3]; }
    else { m=flat.match(/(\d{1,2})\s*h\s*(\d{1,2})\s*m/i);
      if(m){ out.time=(+m[1])+'h '+(+m[2])+'m'; }
      else { var ms=flat.match(/\b\d{1,2}:\d{2}\b(?!\s*\/?\s*km)/gi);
        if(ms){ for(var j=0;j<ms.length;j++){ if(ms[j]!==paceVal){ out.time=ms[j]; break; } } } } }
    var decs=flat.match(/\b\d{1,3}\.\d{1,2}\b/g)||[];
    for(var k=0;k<decs.length;k++){ if(decs[k]!==paceVal){ out.distance=decs[k]+' km'; break; } }
    m=flat.match(/\b\d{1,2}\s+[A-Za-z]{3,9}\.?\s+\d{4}\b/)||flat.match(/\b[A-Za-z]{3,9}\.?\s+\d{1,2},?\s+\d{4}\b/);
    if(m) out.date=m[0];
    return out;
  }
  function parseTimeToHMS(str){
    if(!str) return null; var s=String(str);
    var hm=s.match(/(\d{1,2})\s*h\s*(\d{1,2})\s*m/i); if(hm) return {h:+hm[1],m:+hm[2],s:0};
    var hms=s.match(/(\d{1,2}):(\d{2}):(\d{2})/); if(hms) return {h:+hms[1],m:+hms[2],s:+hms[3]};
    var ms=s.match(/(\d{1,2}):(\d{2})/); if(ms) return {h:0,m:+ms[1],s:+ms[2]};
    return null;
  }
  function clearStats(){ ['cz-dist','cz-pace','cz-h','cz-m','cz-s'].forEach(function(id){ var e=$(id); if(e) e.value=''; });
    var de=$('cz-date'); if(de) de.value=''; dateTouched=false; }
  function timeStr(){ var raw=['cz-h','cz-m','cz-s'].map(function(id){ var e=$(id); return e?(+String(e.value).replace(/\D/g,'')||0):0; });
    var tot=raw[0]*3600+raw[1]*60+raw[2]; if(tot<=0) return '';
    var h=Math.floor(tot/3600), m=Math.floor((tot%3600)/60), sec=tot%60, p=[];
    if(h>0)p.push(h+'H'); if(m>0)p.push(m+'M'); if(sec>0)p.push(sec+'S'); return p.join(' '); }
  function setHMS(h,m,s){ var H=+h||0,M=+m||0,S=+s||0;
    if(S>=60){ M+=Math.floor(S/60); S=S%60; } if(M>=60){ H+=Math.floor(M/60); M=M%60; }
    var Hh=$('cz-h'),Mm=$('cz-m'),Ss=$('cz-s');
    if(Hh)Hh.value=H>0?H:''; if(Mm)Mm.value=(M>0||H>0)?M:''; if(Ss)Ss.value=S>0?S:''; }
  function toISO(t){ var d=(t instanceof Date)?t:new Date(t); if(!d||isNaN(d.getTime()))return '';
    return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  function prettyDate(v){ if(!v)return ''; var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v); if(!m)return v;
    var mo=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return (+m[3])+' '+mo[(+m[2])-1]+' '+m[1]; }
  function fillFromOCR(s){
    var stats=false;
    [['distance','cz-dist'],['pace','cz-pace']].forEach(function(p){
      var el=$(p[1]); if(s[p[0]]&&el){ el.value=s[p[0]]; stats=true; } });
    if(s.time){ var t=parseTimeToHMS(s.time); if(t){ setHMS(t.h||'',t.m||'',t.s||''); stats=true; } }
    
    if(stats){ $('cz-opt').classList.add('cz-show'); $('cz-moreBtn').textContent='– Hide stats'; }
    return stats;
  }
  function detectAlpha(f){ return new Promise(function(res){ var img=new Image();
    img.onload=function(){ var w=Math.min(img.width,240)||1, h=Math.max(1,Math.round(img.height*(w/img.width)));
      var c=document.createElement('canvas'); c.width=w;c.height=h; var x=c.getContext('2d'); x.drawImage(img,0,0,w,h);
      var d; try{ d=x.getImageData(0,0,w,h).data; }catch(e){ res(false); return; }
      var trans=0,n=d.length/4,i; for(i=0;i<d.length;i+=4){ if(d[i+3]<180)trans++; } res(trans>n*0.12); };
    img.onerror=function(){res(false);}; img.src=URL.createObjectURL(f); }); }
  function ocrCanvasFor(f,bg){ return new Promise(function(res,rej){ var img=new Image();
    img.onload=function(){ var cap=1600, sc=Math.min(1,cap/Math.max(img.width,img.height));
      var w=Math.max(2,Math.round(img.width*sc)), h=Math.max(2,Math.round(img.height*sc));
      var c=document.createElement('canvas'); c.width=w;c.height=h; var x=c.getContext('2d');
      x.fillStyle=bg; x.fillRect(0,0,w,h); x.drawImage(img,0,0,w,h); res(c); };
    img.onerror=rej; img.src=URL.createObjectURL(f); }); }
  function mergeStats(list){ var o={title:null,distance:null,time:null,pace:null,date:null};
    list.forEach(function(s){ for(var k in o){ if(!o[k]&&s[k]) o[k]=s[k]; } }); return o; }
  function runOCR(f){
    var st=$('cz-ocrStatus'); st.className='cz-ocrstat cz-load'; st.textContent='Reading your photo…';
    loadTesseract().then(function(T){
      return detectAlpha(f).then(function(hasAlpha){

        var srcs = hasAlpha ? [ocrCanvasFor(f,'#111'), ocrCanvasFor(f,'#fff')] : [Promise.resolve(f)];
        return Promise.all(srcs).then(function(imgs){
          return T.createWorker('eng',1,{logger:function(m){
            if(m.status==='recognizing text') st.textContent='Reading your photo… '+Math.round(m.progress*100)+'%'; }})
          .then(function(worker){
            return imgs.reduce(function(chain,im){ return chain.then(function(acc){
              return worker.recognize(im).then(function(r){ return acc.concat([parseStats(r.data.text||'')]); }); });
            }, Promise.resolve([])).then(function(parsed){ worker.terminate();
              var found=fillFromOCR(mergeStats(parsed)); render();
              if(found){ st.className='cz-ocrstat cz-ok'; st.textContent='✓ Read your stats — check they’re right before adding to cart.'; }
              else { st.className='cz-ocrstat cz-warn'; st.textContent='No stats on this image — add any you like below, or leave them blank.'; }
            });
          });
        });
      });
    }).catch(function(){ st.className='cz-ocrstat cz-warn';
      st.textContent='Couldn’t read this image automatically — type your stats below.'; });
  }

  function processToMask(img){
    var cap=1400, sc=Math.min(1,cap/Math.max(img.width,img.height));
    var w=Math.max(2,Math.round(img.width*sc)), h=Math.max(2,Math.round(img.height*sc));
    var c=document.createElement('canvas'); c.width=w;c.height=h;
    var x=c.getContext('2d'); x.drawImage(img,0,0,w,h);
    var d=x.getImageData(0,0,w,h), p=d.data, N=w*h, i;

    var trans=0; for(i=0;i<p.length;i+=4){ if(p[i+3]<180) trans++; }
    var alphaMode = trans > N*0.12;
    
    var bin=new Uint8Array(N);
    for(i=0;i<N;i++){ var o=i*4, r=p[o],g=p[o+1],b=p[o+2],a=p[o+3];
      bin[i] = (alphaMode ? (a>70) : (a>24 && !(r>232&&g>232&&b>232))) ? 1 : 0; }

    var label=new Int32Array(N), stack=new Int32Array(N), cur=0, s;
    var cMnx=[0],cMny=[0],cMxx=[0],cMxy=[0];
    for(s=0;s<N;s++){
      if(bin[s] && !label[s]){
        cur++; var sp=0; stack[sp++]=s; label[s]=cur;
        var mnx=w,mny=h,mxx=0,mxy=0;
        while(sp>0){ var q=stack[--sp];
          var qx=q%w, qy=(q/w)|0, dy, dx;
          if(qx<mnx)mnx=qx; if(qx>mxx)mxx=qx; if(qy<mny)mny=qy; if(qy>mxy)mxy=qy;
          for(dy=-1;dy<=1;dy++){ var ny=qy+dy; if(ny<0||ny>=h)continue;
            for(dx=-1;dx<=1;dx++){ if(!dx&&!dy)continue; var nx=qx+dx; if(nx<0||nx>=w)continue;
              var ni=ny*w+nx; if(bin[ni]&&!label[ni]){ label[ni]=cur; stack[sp++]=ni; } } } }
        cMnx[cur]=mnx;cMny[cur]=mny;cMxx[cur]=mxx;cMxy[cur]=mxy;
      }
    }
    var ext=[0], maxExt=0, k;
    for(k=1;k<=cur;k++){ var e=Math.max(cMxx[k]-cMnx[k], cMxy[k]-cMny[k]); ext[k]=e; if(e>maxExt)maxExt=e; }
    var extThresh=maxExt*0.40;
    var minX=w,minY=h,maxX=0,maxY=0,found=false;
    for(i=0;i<N;i++){
      var keep = bin[i] && ext[label[i]]>=extThresh, o2=i*4;
      if(keep){ p[o2]=255;p[o2+1]=255;p[o2+2]=255;p[o2+3]=255;
        var px=i%w, py=(i/w)|0;
        if(px<minX)minX=px; if(px>maxX)maxX=px; if(py<minY)minY=py; if(py>maxY)maxY=py; found=true;
      } else { p[o2+3]=0; } }
    x.putImageData(d,0,0); state.mask=c;
    state.bbox=found?{x:minX,y:minY,w:maxX-minX+1,h:maxY-minY+1}:{x:0,y:0,w:w,h:h};
  }
  function buildSampleMask(){
    var w=900,h=1000,c=document.createElement('canvas');c.width=w;c.height=h;
    var x=c.getContext('2d');x.strokeStyle='#fff';x.lineWidth=22;x.lineCap='round';x.lineJoin='round';x.beginPath();
    var cx=w/2,cy=h/2,N=240;
    for(var i=0;i<=N;i++){ var a=i/N*Math.PI*2;
      var rr=300*(1+0.18*Math.sin(3*a+0.5)+0.10*Math.sin(7*a+1.1)+0.05*Math.sin(13*a));
      var px=cx+Math.cos(a)*rr, py=cy+Math.sin(a)*rr*1.05; i?x.lineTo(px,py):x.moveTo(px,py); }
    x.closePath();x.stroke(); state.mask=c; state.bbox={x:120,y:120,w:w-240,h:h-240};
  }
  /* The Neon route's glow, everywhere it is drawn: the preview, the physical
     and digital print files, the wallpaper.

     WebKit caps a canvas shadow's blur radius at 128 px, and the 3508 px
     digital print asked for 158 - on an iPhone that glow came out clipped to a
     hard rectangle round the route. So no pass here ever asks for more than
     GLOW_MAX. Above it, the two glow passes are rendered at a reduced scale
     into a canvas padded by three blur radii on every side, then scaled up:
     a blur has no fine detail to lose. The two sharp passes are still drawn
     at full resolution on top. At or under GLOW_MAX this is exactly the four
     draws it replaces. */
  var GLOW_MAX=96;
  function glowArt(ctx,src,sx,sy,sw,sh,dx,dy,dw,dh,glow,color){
    var sharp=function(){ ctx.drawImage(src,sx,sy,sw,sh,dx,dy,dw,dh); };
    if(!(glow>GLOW_MAX)){
      var pass=function(blur){ ctx.save(); ctx.shadowColor=color; ctx.shadowBlur=blur;
        ctx.drawImage(src,sx,sy,sw,sh,dx,dy,dw,dh); ctx.restore(); };
      pass(glow); pass(glow*0.5); sharp(); sharp();
      return;
    }
    var k=GLOW_MAX/glow, pad=glow*3;
    var cw=Math.max(1,Math.ceil((dw+2*pad)*k)), ch=Math.max(1,Math.ceil((dh+2*pad)*k));
    var c=document.createElement('canvas'); c.width=cw; c.height=ch;
    var g=c.getContext('2d');
    var gpass=function(blur){ g.save(); g.shadowColor=color; g.shadowBlur=blur;
      g.drawImage(src,sx,sy,sw,sh,pad*k,pad*k,dw*k,dh*k); g.restore(); };
    gpass(glow*k); gpass(glow*0.5*k);
    ctx.save(); ctx.imageSmoothingEnabled=true;
    try{ ctx.imageSmoothingQuality='high'; }catch(e){}
    ctx.drawImage(c,0,0,cw,ch,dx-pad,dy-pad,cw/k,ch/k);
    ctx.restore();
    sharp(); sharp();
  }
  function colourised(){
    var _rcz=relayColourised(); if(_rcz) return _rcz;
    var m=state.mask,t=document.createElement('canvas');t.width=m.width;t.height=m.height;
    var x=t.getContext('2d');x.drawImage(m,0,0);
    x.globalCompositeOperation='source-in';x.fillStyle=state.accent;x.fillRect(0,0,t.width,t.height); return t;
  }
  function spaced(t,em){ em=em||0.08; return t.split('').join('\u200a'.repeat(Math.max(1,Math.round(em*8)))); }

  /* Shared by the four styles that render through renderDesign. */
  function dsDate(){
    var v=($('cz-date')&&$('cz-date').value)||'', m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    return m ? (m[3]+'.'+m[2]+'.'+m[1]) : '';
  }
  /* The name, for the designs. Same field the medal frame reads, so a
     customer types it once whatever format they are on. */
  function dsName(){ var e=$('cz-name'); return (((e&&e.value)||'').trim()).toUpperCase(); }
  /* Shrink `txt` until it fits `avail`, using the caller's own font string with
     %s where the size goes. Returns the size it settled on. */
  function dsFit(ctx,fontTpl,txt,track,avail,size){
    var g=0;
    ctx.font=fontTpl.replace('%s',size);
    while(ctx.measureText(spaced(txt,track)).width>avail && size>4 && g++<60){
      size*=0.95; ctx.font=fontTpl.replace('%s',size);
    }
    return size;
  }
  function dsCoord(){
    var c=state.coords&&state.coords[0]; if(!c) return '';
    return Math.abs(c[0]).toFixed(4)+'\u00b0'+(c[0]<0?'S':'N')+' '+
           Math.abs(c[1]).toFixed(4)+'\u00b0'+(c[1]<0?'W':'E');
  }
  /* Greedy wrap that never returns a line wider than the column: a word too
     long for it is hard-broken rather than allowed to run past the trim. */
  function dsWrap(ctx,text,fs,maxW,track){
    ctx.font='800 '+fs+'px Inter,sans-serif';
    function wd(s){ return ctx.measureText(spaced(s,track)).width; }
    var words=String(text).split(/\s+/).filter(Boolean), lines=[], cur='', i;
    for(i=0;i<words.length;i++){
      var word=words[i];
      while(wd(word)>maxW && word.length>1){
        var cut=word.length;
        while(cut>1 && wd(word.slice(0,cut))>maxW) cut--;
        if(cur){ lines.push(cur); cur=''; }
        lines.push(word.slice(0,cut)); word=word.slice(cut);
      }
      var t=cur?cur+' '+word:word;
      if(!cur || wd(t)<=maxW) cur=t; else { lines.push(cur); cur=word; }
    }
    if(cur) lines.push(cur);
    return lines.length?lines:[''];
  }
  /* Hold the size unless the title genuinely will not fit in maxLines. */
  function dsTitle(ctx,title,fs,maxW,maxLines,track,floor){
    var lines;
    for(;;){
      lines=dsWrap(ctx,title,fs,maxW,track);
      if(lines.length<=maxLines || fs<=floor) break;
      fs*=0.95;
    }
    while(lines.length>3 && fs>floor*0.6){ fs*=0.95; lines=dsWrap(ctx,title,fs,maxW,track); }
    return {lines:lines, fs:fs};
  }

  function renderDesign(ctx,ox,oy,W,H,fillBg){
    var prod=state.product;
    if(fillBg){
      if(prod==='tee'){ ctx.fillStyle='#26262b'; ctx.fillRect(ox,oy,W,H); }
      else { var g=ctx.createRadialGradient(ox+W/2,oy+H*0.1,0,ox+W/2,oy+H*0.1,H); g.addColorStop(0,'#16161b');g.addColorStop(1,'#0d0d10'); ctx.fillStyle=g; ctx.fillRect(ox,oy,W,H); }
    }
    /* The tee prints at a smaller physical size than the poster, so its type
       is lifted rather than shrunk - the reverse of what this used to do. */
    var k = (prod==='tee') ? 1.12 : 1;
    var mL=ox+W*0.085, mR=W*0.085, cx=ox+W/2, safe=H*0.078, colW=W*0.83;

    var title=($('cz-title').value.trim()||'My Milestone').toUpperCase();
    var loc=($('cz-loc').value||'').toUpperCase();
    /* DATE has moved to the top strip, so this is three columns, not four. */
    var stats=statRows('')
      .filter(function(s){return s[1]&&s[1].trim();});
    var hasStats=stats.length>0;

    var topY=oy+H*0.085, ruleY=topY+H*0.022;
    ctx.textBaseline='alphabetic';
    ctx.font='600 '+(W*0.019)+'px Inter,sans-serif'; ctx.fillStyle='#8a8a90';
    var _d=dsDate(), _n=dsName(), _dw=0;
    if(_d){ ctx.textAlign='left';  ctx.fillText(spaced(_d,0.14), mL, topY);
            _dw=ctx.measureText(spaced(_d,0.14)).width; }
    if(_n){
      var _av=(ox+W-mR)-(mL+_dw)-W*0.04;
      var _ns=dsFit(ctx,'700 %spx Inter,sans-serif',_n,0.06,_av,W*0.030);
      ctx.font='700 '+_ns+'px Inter,sans-serif';
      ctx.textAlign='right'; ctx.fillText(spaced(_n,0.06), ox+W-mR, topY);
    }
    ctx.strokeStyle='rgba(255,255,255,0.14)'; ctx.lineWidth=Math.max(1,W*0.0008);
    ctx.beginPath(); ctx.moveTo(mL,ruleY); ctx.lineTo(ox+W-mR,ruleY); ctx.stroke();

    /* One line, always. Measure at the design size and scale to the column -
       width is linear in font size, tracking included, since spaced() uses
       hair spaces. Two passes absorb rounding in measureText. */
    var track=0.08, fs=W*0.098*k;
    for(var _p=0;_p<2;_p++){
      ctx.font='800 '+fs+'px Inter,sans-serif';
      var _tw=ctx.measureText(spaced(title,track)).width;
      if(_tw>colW) fs*=colW/_tw; else break;
    }
    var lines=[title], lineH=fs*1.06;

    /* Stat type is measured before anything is placed, because the divider is
       positioned off the stat cap line rather than a fixed offset - that is
       what left it sitting hard against the numbers. */
    var vF=W*0.046*k, lF=W*0.021*k, cw=colW/(stats.length||1), avail=cw*0.90, mv=0, ml=0;
    if(hasStats){
      ctx.font='800 '+vF+'px Inter,sans-serif';
      stats.forEach(function(s){ mv=Math.max(mv,ctx.measureText(s[1].toUpperCase()).width); });
      if(mv>avail) vF*=avail/mv;
      ctx.font='600 '+lF+'px Inter,sans-serif';
      stats.forEach(function(s){ ml=Math.max(ml,ctx.measureText(spaced(s[0],0.1)).width); });
      if(ml>avail) lF*=avail/ml;
    }

    var GAP=W*0.050, locFs=W*0.028*k;
    var labBase=oy+H-safe, valBase=labBase-W*0.042, valCap=valBase-vF*0.72;
    var divY   = hasStats ? (valCap-GAP) : (labBase-GAP);
    var locBase= divY-GAP;
    var titleBase = loc ? (locBase-locFs-H*0.022) : (divY-GAP);
    var titleCap  = titleBase-(lines.length-1)*lineH-fs*0.76;

    /* The route has its own inset inside the column. Without it a short title
       leaves a tall box, the fit scales up until the width binds, and the
       artwork runs to the margin. */
    var routeTop=ruleY+H*0.045, routeBot=titleCap-H*0.050;
    var routeAreaH=Math.max(H*0.22, routeBot-routeTop);
    var rw=colW-W*0.08, rx=mL+W*0.04;

    if(state.style==='heat' && state.heatCanvas){
      var hb=state.heatBbox, s=Math.min(rw/hb.w, routeAreaH/hb.h);
      var dw=hb.w*s, dh=hb.h*s, dx=rx+(rw-dw)/2, dy=routeTop+(routeAreaH-dh)/2;
      ctx.drawImage(state.heatCanvas, hb.x,hb.y,hb.w,hb.h, dx,dy,dw,dh);
      drawStartFinish(ctx,dx,dy,dw,dh);
    } else if(isMapLike(state.style) && state.mapImg){
      /* Same panel as the editorial design: full column, 13.5% to 67.3% of
         height. It gives way to the title if the text block is ever taller,
         but never the other way round. */
      var im=state.mapImg, cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035), sw=im.width, sh=im.height-cropB;
      var pL=mL, pW=colW, pT=oy+H*0.135, pB=Math.min(oy+H*0.673, titleCap-H*0.030), pH=Math.max(H*0.20,pB-pT);
      ctx.save(); ctx.beginPath(); ctx.rect(pL,pT,pW,pH); ctx.clip();
      if(!state.mapUser){
        /* Geoapify tile and terrain canvas are both built near the panel
           aspect, so cover-fit only trims a sliver. */
        var sc=Math.max(pW/sw, pH/sh), vw=pW/sc, vh=pH/sc;
        ctx.drawImage(im, (sw-vw)/2,(sh-vh)/2,vw,vh, pL,pT,pW,pH);
      } else {
        /* A user's own map screenshot: contain, so nothing of theirs is cut. */
        ctx.fillStyle='#101014'; ctx.fillRect(pL,pT,pW,pH);
        var s=Math.min(pW/sw, pH/sh), dw=sw*s, dh=sh*s;
        ctx.drawImage(im, 0,0,sw,sh, pL+(pW-dw)/2, pT+(pH-dh)/2, dw, dh);
      }
      ctx.restore();
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,.10)'; ctx.lineWidth=1; ctx.strokeRect(pL,pT,pW,pH); ctx.restore();
    } else if(state.mask&&state.bbox){
      var col=colourised(), bb=state.bbox, glow=W*0.045;
      var availW=rw-glow, availH=routeAreaH-glow;
      var s2=Math.min(availW/bb.w,availH/bb.h), dw2=bb.w*s2, dh2=bb.h*s2;
      var dx2=rx+(rw-dw2)/2, dy2=routeTop+(routeAreaH-dh2)/2;
      var draw=function(blur){ ctx.save(); if(blur){ctx.shadowColor=state.accent;ctx.shadowBlur=blur;}
        ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,dx2,dy2,dw2,dh2); ctx.restore(); };
      glowArt(ctx,col,bb.x,bb.y,bb.w,bb.h,dx2,dy2,dw2,dh2,glow,state.accent);
      drawStartFinish(ctx,dx2,dy2,dw2,dh2);
    }
    if(noRoute()) drawRoutePrompt(ctx, rx, routeTop, rw, routeAreaH, true);

    ctx.textAlign='center';
    ctx.font='800 '+fs+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4';
    for(var li=0; li<lines.length; li++){
      ctx.fillText(spaced(lines[li],track), cx, titleBase-(lines.length-1-li)*lineH);
    }
    if(loc){ ctx.font='600 '+locFs+'px Inter,sans-serif'; ctx.fillStyle='#9b9aa2';
      ctx.fillText(spaced(loc,0.18), cx, locBase); }
    if(hasStats){
      ctx.fillStyle=state.accent; ctx.fillRect(cx-W*0.10,divY,W*0.20,Math.max(2,W*0.005));
      stats.forEach(function(s,i){ var sx=mL+cw*(i+0.5);
        ctx.font='800 '+vF+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4';
        ctx.fillText(s[1].toUpperCase(),sx,valBase);
        ctx.font='600 '+lF+'px Inter,sans-serif'; ctx.fillStyle='#9b9aa2';
        ctx.fillText(spaced(s[0],0.1),sx,labBase); });
    }
  }

  function has2(){ return !!(state.r2 && (state.r2.mask || state.r2.mapImg)); }
  function timeStrN(n){ var raw=['cz-h'+n,'cz-m'+n,'cz-s'+n].map(function(id){ var e=$(id); return e?(+String(e.value).replace(/\D/g,'')||0):0; });
    var tot=raw[0]*3600+raw[1]*60+raw[2]; if(tot<=0) return '';
    var h=Math.floor(tot/3600), m=Math.floor((tot%3600)/60), sec=tot%60, p=[];
    if(h>0)p.push(h+'H'); if(m>0)p.push(m+'M'); if(sec>0)p.push(sec+'S'); return p.join(' '); }
  function statsFor(n){ return statRows(n,{time:function(){ return timeStrN(n); }}).concat([['DATE',prettyDate(($('cz-date'+n)||{}).value||'')]])
      .filter(function(s){return s[1]&&String(s[1]).trim();}); }
  function colourisedForR(m,accent){ var t=document.createElement('canvas');t.width=m.width;t.height=m.height;
    var x=t.getContext('2d');x.drawImage(m,0,0); x.globalCompositeOperation='source-in';x.fillStyle=accent;x.fillRect(0,0,t.width,t.height); return t; }
  function rFrom(src){ return {style:state.style, mask:src.mask, bbox:src.bbox, heatCanvas:src.heatCanvas, heatBbox:src.heatBbox,
    mapImg:src.mapImg, mapUser:src.mapUser, accent:state.accent}; }

  /* ---- start / finish markers -----------------------------------------
     Mask branch only. dx,dy,dw,dh is the rect state.mask was drawn into,
     already cropped to state.bbox. */
  function sfOn(){ var e=$('cz-sf'); if(!e) return false; return _sfTouched ? !!e.checked : sfDefaultOn(); }   /* 30 Oct: on by default */
  /* Usable elevation: enough finite samples, and more than a metre of relief.
     A flat line is worse than no ribbon. */
  function eleUsable(){
    var e=state.eles; if(!e || e.length<3) return false;
    var mn=1/0,mx=-1/0,n=0,i,v;
    for(i=0;i<e.length;i++){ v=e[i]; if(isFinite(v)){ n++; if(v<mn)mn=v; if(v>mx)mx=v; } }
    return n>2 && (mx-mn)>1;
  }
  function ribbonOn(){ var e=$('cz-ribbon'); return !!(e && e.checked && eleUsable()); }
  function eleStats(){
    var e=state.eles, mn=1/0, mx=-1/0, gain=0, prev=null, i, v, out=[];
    for(i=0;i<e.length;i++){ v=e[i]; if(!isFinite(v)) continue;
      out.push(v); if(v<mn)mn=v; if(v>mx)mx=v;
      if(prev!==null && v>prev) gain+=v-prev; prev=v; }
    return {pts:out, min:mn, max:mx, gain:gain};
  }
  function drawRibbon(ctx,lx,rx,top,h,W){
    if(relayIsTeam() && relayRibbon(ctx,lx,rx,top,h,W)) return;
    var st=eleStats(), p=st.pts, n=p.length; if(n<3) return;
    var span=(st.max-st.min)||1, i, x, y;
    ctx.save();
    ctx.beginPath();
    for(i=0;i<n;i++){
      x=lx+(rx-lx)*(i/(n-1)); y=top+h-((p[i]-st.min)/span)*h;
      i?ctx.lineTo(x,y):ctx.moveTo(x,y);
    }
    var lastX=lx+(rx-lx);
    ctx.lineTo(lastX,top+h); ctx.lineTo(lx,top+h); ctx.closePath();
    ctx.fillStyle=relayHex()||'#DDD7CA'; ctx.fill();
    ctx.beginPath();
    for(i=0;i<n;i++){
      x=lx+(rx-lx)*(i/(n-1)); y=top+h-((p[i]-st.min)/span)*h;
      i?ctx.lineTo(x,y):ctx.moveTo(x,y);
    }
    ctx.strokeStyle='#17171A'; ctx.lineWidth=Math.max(1,W*0.0016); ctx.lineJoin='round'; ctx.stroke();
    ctx.beginPath(); ctx.moveTo(lx,top+h); ctx.lineTo(rx,top+h);
    ctx.strokeStyle='#cfc9bc'; ctx.lineWidth=Math.max(1,W*0.0012); ctx.stroke();
    ctx.fillStyle='#8d8a85'; ctx.font='400 '+(W*0.0155)+'px "Roboto Mono",ui-monospace,Menlo,monospace';
    ctx.textAlign='left';  ctx.fillText(summitVal('')||(Math.round(st.max)+' M'), lx, top-W*0.006);
    var _rg=gainVal(''); if(_rg){ ctx.textAlign='right'; ctx.fillText(_rg+' GAIN', rx, top-W*0.006); }
    ctx.textAlign='left';
    ctx.restore();
  }
  function sfLum(ctx,x,y,r){
    try{
      var d=ctx.getImageData(Math.max(0,(x-r)|0),Math.max(0,(y-r)|0),
                             Math.max(1,(r*2)|0),Math.max(1,(r*2)|0)).data;
      var sum=0,n=0;
      for(var i=0;i<d.length;i+=16){ sum+=0.2126*d[i]+0.7152*d[i+1]+0.0722*d[i+2]; n++; }
      return n?sum/n:0;
    }catch(e){ return 0; }
  }
  function sfDot(ctx,x,y,r,filled,ink){
    ctx.save();
    ctx.shadowColor='rgba(0,0,0,.55)'; ctx.shadowBlur=r*1.6;
    ctx.beginPath(); ctx.arc(x,y,r,0,7);
    if(filled){ ctx.fillStyle=ink; ctx.fill(); }
    else { ctx.lineWidth=Math.max(1.5,r*0.42); ctx.strokeStyle=ink; ctx.stroke(); }
    ctx.restore();
  }
  /* Place START / FINISH (or one combined marker for a loop) at two screen
     points. U is the size unit; boxY/boxH decide whether labels go below. */
  function drawSfPoints(ctx,a,b,U,boxY,boxH){
    var r=Math.max(3,U*0.016), fs=Math.max(7,U*0.030);
    var loop=Math.sqrt((a[0]-b[0])*(a[0]-b[0])+(a[1]-b[1])*(a[1]-b[1])) < U*0.045;
    function place(pt,txt,filled){
      var light=sfLum(ctx,pt[0],pt[1],r*3)>140;
      var ink=light?'#17171A':'#FFFFFF';
      ctx.save();
      sfDot(ctx,pt[0],pt[1],r,filled,ink);
      ctx.font='600 '+fs+'px Inter,sans-serif'; ctx.textAlign='center';
      ctx.shadowColor=light?'rgba(255,255,255,.7)':'rgba(0,0,0,.7)'; ctx.shadowBlur=fs*0.9;
      ctx.fillStyle=ink;
      var below=(pt[1]+r*2.6+fs) < (boxY+boxH);
      /* Inside the map, even when the route starts at its edge (26 Oct). */
      var _lt=spaced(txt,0.16), _lw=ctx.measureText(_lt).width, _cw=(ctx.canvas&&ctx.canvas.width)||0, _lx=pt[0];
      if(_cw>_lw+fs) _lx=Math.max(_lw/2+fs*0.4, Math.min(_cw-_lw/2-fs*0.4, _lx));
      ctx.fillText(_lt, _lx, below?(pt[1]+r*2.6+fs):(pt[1]-r*2.4));
      ctx.restore();
    }
    if(loop) place(b,'START \u00b7 FINISH',true);
    else { place(a,'START',false); place(b,'FINISH',true); }
  }
  /* ---- km markers, scale bar, north arrow (22 Oct pm) -------------------
     The step: 5 km, 10 on a ride, 1 on a short route, and never more than
     twelve marks on a page. */
  function kmStep(L){
    var base=(SPORT==='cycle')?10:5, cand=[1,2,5,10,20,25,50,100], mn=(L<8)?1:base, i;
    for(i=0;i<cand.length;i++){ if(cand[i]>=mn && L/cand[i]<=12) return cand[i]; }
    return cand[cand.length-1];
  }
  /* Where each mark falls on the track: the point index and the fraction to
     the next point, from the same haversine distance the stats use. The last
     mark is dropped when it would sit on the finish. */
  function kmMarks(coords){
    if(!coords || coords.length<2) return [];
    var cum=[0], t=0, i, R=6371;
    for(i=1;i<coords.length;i++){ var a=coords[i-1], b=coords[i];
      var dLa=(b[0]-a[0])*Math.PI/180, dLo=(b[1]-a[1])*Math.PI/180, la1=a[0]*Math.PI/180, la2=b[0]*Math.PI/180;
      var h=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(la1)*Math.cos(la2)*Math.sin(dLo/2)*Math.sin(dLo/2);
      t+=2*R*Math.asin(Math.min(1,Math.sqrt(h))); cum.push(t); }
    var L=t, st=kmStep(L), out=[], k, j=1;
    if(!(L>0)) return out;
    for(k=st; k<=L-st*0.15; k+=st){
      while(j<cum.length && cum[j]<k) j++;
      if(j>=cum.length) break;
      var f=(k-cum[j-1])/((cum[j]-cum[j-1])||1e-9);
      out.push({i:j-1, f:f, k:k, lat:coords[j-1][0]+(coords[j][0]-coords[j-1][0])*f, lon:coords[j-1][1]+(coords[j][1]-coords[j-1][1])*f});
    }
    return out;
  }
  function kmLabel(k){ return String(Math.round(k*10)/10); }
  /* The discs on a terrain canvas: pr is the projected track, parallel to
     coords; S the canvas's size unit (W/800). Cream, rimmed in the route
     colour, the numeral in ink - the same cream the coast is drawn in. */
  /* p_kmread (27 Oct): how much of the poster's width the map is, so the
     km discs can be the same share of the poster on every design. */
  function kmArtFrac(){
    try{
      var fp=(typeof focusProd==='function') ? focusProd() : state.product;
      if(IS_GAL){ var gm=(typeof galCompact==='function' && galCompact(fp)) ? GAL.mComp : GAL.mFull; return (1-2*gm)/2; }
      if(fp==='frame') return FR.mapW;
      if(IS_EDT) return EDT.mR-EDT.mL;
      if(typeof DESIGN_KIND!=='undefined' && DESIGN_KIND==='rings') return 0.42;   /* 30 Oct pm: the dial */
    }catch(e){}
    return 1;
  }
  function kmArtBoost(){ return Math.max(1, Math.min(2.6, 0.95/Math.max(0.2, kmArtFrac()))); }
  function drawKmMarks(ctx,pr,coords,S){
    if(!pr || !coords || pr.length!==coords.length) return;
    S*=kmArtBoost();
    /* 29 Oct pm (Marc: "km markers should be readable"): radius 13 at 800 px, was 7.5 */
    var marks=kmMarks(coords), r=13*S, fs=14.5*S, col=routeHex(), q, m;
    ctx.save(); ctx.textAlign='center'; ctx.textBaseline='middle';
    for(q=0;q<marks.length;q++){ m=marks[q];
      var a=pr[m.i], b=pr[m.i+1]||a, x=a[0]+(b[0]-a[0])*m.f, y=a[1]+(b[1]-a[1])*m.f;
      /* One circle: a wide ink stroke under a shadow, the cream fill over its
         inner half, the route-coloured ring on top - an ink edge outside. */
      ctx.beginPath(); ctx.arc(x,y,r,0,7);
      ctx.shadowColor='rgba(0,0,0,0.55)'; ctx.shadowBlur=r*0.9;
      ctx.lineWidth=4.5*S; ctx.strokeStyle='#17171A'; ctx.stroke();
      ctx.shadowColor='transparent'; ctx.shadowBlur=0;
      ctx.fillStyle='#F3EFE7'; ctx.fill();
      ctx.lineWidth=Math.max(1,2.2*S); ctx.strokeStyle=col; ctx.stroke();
      /* The numeral fills the disc's inner width and no more. */
      var t=kmLabel(m.k), f=fs; ctx.font='800 '+f+'px Inter,sans-serif';
      var tw=ctx.measureText(t).width, room=(r-2.2*S)*1.75;
      if(tw>room){ f=f*room/tw; ctx.font='800 '+f+'px Inter,sans-serif'; }
      ctx.fillStyle='#17171A'; ctx.fillText(t, x, y+f*0.06);
    }
    ctx.restore();
  }
  /* The scale bar's length: the longest round figure that fits maxPx. */
  function scaleLen(mpp,maxPx){ var c=[100,200,250,500,1000,2000,2500,5000,10000,20000,50000,100000], best=c[0], i;
    for(i=0;i<c.length;i++){ if(c[i]/mpp<=maxPx) best=c[i]; } return best; }
  function scaleText(m){ return m>=1000 ? (String(m/1000)+' KM') : (String(m)+' M'); }
  /* Scale bar and north arrow. o.mpp metres per pixel at the scale drawn;
     o.u the size unit; o.bar [x, baseline y, longest px, 'right' to end at x];
     o.north [x, baseline y of the N]; o.ink, o.halo (a shadow colour), o.font. */
  function drawMapCues(ctx,o){
    return;   /* 26 Oct (Marc): no scale bar or north arrow, on any design. */
    ctx.save(); ctx.textBaseline='alphabetic'; ctx.lineCap='butt'; ctx.lineJoin='miter';
    var u=o.u, lw=Math.max(1,u*0.09), fs=u*0.95;
    ctx.shadowColor=o.halo; ctx.shadowBlur=u*0.55;
    if(o.bar && o.mpp>0){ var m=scaleLen(o.mpp,o.bar[2]), px=m/o.mpp, bx=o.bar[0], by=o.bar[1];
      if(o.bar[3]==='right') bx-=px;
      ctx.strokeStyle=o.ink; ctx.lineWidth=lw;
      ctx.beginPath(); ctx.moveTo(bx,by); ctx.lineTo(bx+px,by);
      ctx.moveTo(bx+lw/2,by-u*0.45); ctx.lineTo(bx+lw/2,by); ctx.moveTo(bx+px-lw/2,by-u*0.45); ctx.lineTo(bx+px-lw/2,by); ctx.stroke();
      ctx.fillStyle=o.ink; ctx.font='600 '+fs+'px '+o.font; ctx.textAlign='center';
      ctx.fillText(spaced(scaleText(m),0.06), bx+px/2, by-u*0.75);
    }
    if(o.north){ var nx=o.north[0], ny=o.north[1], top=ny-fs*1.15;
      ctx.fillStyle=o.ink; ctx.font='700 '+(fs*1.1)+'px '+o.font; ctx.textAlign='center';
      ctx.fillText('N', nx, ny);
      ctx.beginPath(); ctx.moveTo(nx, top-u*1.15); ctx.lineTo(nx+u*0.42, top); ctx.lineTo(nx, top-u*0.3); ctx.lineTo(nx-u*0.42, top); ctx.closePath(); ctx.fill();
    }
    ctx.restore();
  }
  /* Terrain: markers composited onto a copy of the built canvas - the km
     discs first, start and finish on top of them. */
  /* 30 Oct pm: the start and finish icons over a static Geoapify map (mapUrlFor no longer asks
     Geoapify for them). Where the route's ends are: geoPts, aligned to the line in the image, or
     the cover-fit projection of the area rect. Not on a map built from the tiles (they drew them),
     not over a tainted image. The bare map is kept as _sfBase, so a toggle redraws from it. */
  function mapWithSf(im,url){
    if(!im) return im;
    var base=im._sfBase||im;
    if(!(typeof sfOn==='function' && sfOn()) || state.style!=='map' || !url || url.indexOf('staticmap')<0 ||
       (typeof relayTilesFor==='function' && relayTilesFor(url))) return base;
    var c=state.coords; if(!c || c.length<2) return base;
    var W=base.naturalWidth||base.width, H=base.naturalHeight||base.height, a=null, b=null;
    try{ var g=geoPts(url,base); if(g && g.pts && g.pts.length>1){ a=g.pts[0]; b=g.pts[g.pts.length-1]; } }catch(e){}
    if(!a){
      try{
        var q=function(k){ var m=new RegExp('[?&]'+k+'=([^&]*)').exec(url); return m?decodeURIComponent(m[1]):''; };
        var ar=/rect:([-\d.]+),([-\d.]+),([-\d.]+),([-\d.]+)/.exec(q('area')); if(!ar) return base;
        var R=Math.PI/180, mx=function(lo){ return lo*R; }, my=function(la){ return Math.log(Math.tan(Math.PI/4+la*R/2)); };
        var X0=mx(+ar[1]), Y0=my(+ar[2]), X1=mx(+ar[3]), Y1=my(+ar[4]);
        var k=Math.max(W/(X1-X0), H/(Math.abs(Y1-Y0)||1e-9)), cx=(X0+X1)/2, cy=(Y0+Y1)/2;
        var P=function(p){ return [W/2+(mx(p[1])-cx)*k, H/2-(my(p[0])-cy)*k]; };
        a=P(c[0]); b=P(c[c.length-1]);
      }catch(e){ return base; }
    }
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
    try{ var x=cv.getContext('2d'); x.drawImage(base,0,0); terrainSfIcons(x,a,b,W,W); }catch(e){ return base; }
    cv._sfBase=base; return cv;
  }
  function terrainWithSf(base){
    var sf=!!(base && base._sfPts && sfOn()), km=!!(base && base._pr && kmOn());
    if(!sf && !km) return base;
    var c=document.createElement('canvas'); c.width=base.width; c.height=base.height;
    var x=c.getContext('2d'); x.drawImage(base,0,0);
    var P=base._sfPts, U=Math.min(c.width,c.height)*0.70;
    if(km) drawKmMarks(x,base._pr,state.coords,base._S||(P&&P.S)||(c.width/800));
    if(sf) terrainSfIcons(x,P.s,P.f,c.width,c.width);
    c._sfPts=P; c._base=base; c._mpp=base._mpp;
    return c;
  }
  /* 29 Oct pm: start and finish as the 3D design draws them - a green dot in a
     white ring, a chequered disc - on every terrain look. */
  function terrainSfIcons(ctx,a,b,W,lim){
    W*=(typeof kmArtBoost==='function' ? kmArtBoost() : 1);   /* 30 Oct pm: Gallery's narrow map, as the km discs */
    var u=W/1000, r=Math.max(5,15*u);
    t3Dot(ctx,a[0],a[1],r,'#8BE04E','#FFFFFF',3.5*u);
    var d=Math.sqrt((a[0]-b[0])*(a[0]-b[0])+(a[1]-b[1])*(a[1]-b[1]));
    /* a loop: the flag beside the dot rather than on it */
    if(d<r*2.2){ var _sx=(lim && a[0]+r*3.4>lim) ? -1 : 1; t3Flag(ctx,a[0]+_sx*r*2.3,a[1],r,u); } else t3Flag(ctx,b[0],b[1],r,u);
  }
  function drawStartFinish(ctx,dx,dy,dw,dh){
    if(!sfOn()) return;
    var c=state.coords;
    if(!c || c.length<2 || !state.bbox || !state.mask) return;
    var pj=projectFit(c,1000,0.12).pts, bb=state.bbox;
    if(!bb.w || !bb.h) return;
    var sx=dw/bb.w, sy=dh/bb.h;
    function toScreen(p){ return [dx+(p[0]-bb.x)*sx, dy+(p[1]-bb.y)*sy]; }
    var a=toScreen(pj[0]), b=toScreen(pj[pj.length-1]);
    var U=Math.min(dw,dh), r=Math.max(3,U*0.016), fs=Math.max(7,U*0.030);
    var loop=Math.sqrt((a[0]-b[0])*(a[0]-b[0])+(a[1]-b[1])*(a[1]-b[1])) < U*0.045;
    function place(pt,txt,filled){
      var light=sfLum(ctx,pt[0],pt[1],r*3)>140;   /* what is actually under it */
      var ink=light?'#17171A':'#FFFFFF';
      ctx.save();
      sfDot(ctx,pt[0],pt[1],r,filled,ink);
      ctx.font='600 '+fs+'px Inter,sans-serif'; ctx.textAlign='center';
      ctx.shadowColor=light?'rgba(255,255,255,.7)':'rgba(0,0,0,.7)'; ctx.shadowBlur=fs*0.9;
      ctx.fillStyle=ink;
      var below=(pt[1]+r*2.6+fs) < (dy+dh);
      ctx.fillText(spaced(txt,0.16), pt[0], below?(pt[1]+r*2.6+fs):(pt[1]-r*2.4));
      ctx.restore();
    }
    if(loop) place(b,'START \u00b7 FINISH',true);
    else { place(a,'START',false); place(b,'FINISH',true); }
  }
  function paintRouteArt(ctx, ox, oy, W, H, R){          
    if(R.style==='heat' && R.heatCanvas){
      var hb=R.heatBbox, s=Math.min(W*0.94/hb.w, H/hb.h), dw=hb.w*s, dh=hb.h*s, dx=ox+(W-dw)/2, dy=oy+(H-dh)/2;
      ctx.drawImage(R.heatCanvas, hb.x,hb.y,hb.w,hb.h, dx,dy,dw,dh);
    } else if(isMapLike(R.style) && R.mapImg){
      var im=R.mapImg, cropB=(R.mapUser||R.style==='terrain')?0:Math.round(im.height*0.035), sw=im.width, sh=im.height-cropB;
      var s2=Math.min(W*0.92/sw, H/sh), dw2=sw*s2, dh2=sh*s2, dx2=ox+(W-dw2)/2, dy2=oy+(H-dh2)/2;
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,.10)'; ctx.lineWidth=1;
      ctx.drawImage(im, 0,0,sw,sh, dx2,dy2,dw2,dh2); ctx.strokeRect(dx2,dy2,dw2,dh2); ctx.restore();
    } else if(R.mask&&R.bbox){
      var col=colourisedForR(R.mask,R.accent), bb=R.bbox, pad=0.08, glow=W*0.045;
      var availW=W*(1-pad*2)-glow, availH=H-glow;
      var s3=Math.min(availW/bb.w,availH/bb.h), dw3=bb.w*s3, dh3=bb.h*s3, dx3=ox+(W-dw3)/2, dy3=oy+(H-dh3)/2;
      var draw=function(blur){ ctx.save(); if(blur){ctx.shadowColor=R.accent;ctx.shadowBlur=blur;}
        ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3); ctx.restore(); };
      glowArt(ctx,col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3,glow,R.accent);
    }
  }
  function drawStatsD(ctx, stats, xL, xR, y0, rowH, w){
    stats.forEach(function(s,i){ var c=i%2, r=(i/2)|0, x=(stats.length===1?((xL+xR)/2):(c===0?xL:xR)), y=y0+r*rowH;
      ctx.textAlign='center';
      ctx.font='800 '+(w*0.064)+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4'; ctx.fillText(String(s[1]).toUpperCase(), x, y);
      ctx.font='600 '+(w*0.03)+'px Inter,sans-serif'; ctx.fillStyle='#8b8a92'; ctx.fillText(spaced(s[0],0.1), x, y+w*0.05); });
  }
  function drawTileD(ctx, R, stats, x, y, w, th, m){
    ctx.save(); ctx.fillStyle='rgba(255,255,255,0.02)'; ctx.strokeStyle='rgba(255,255,255,0.09)'; ctx.lineWidth=1.5;
    roundRect(ctx,x,y,w,th,10); ctx.fill(); ctx.stroke(); ctx.restore();
    paintRouteArt(ctx, x+w*0.04, y+m.inTop, w*0.92, m.routeH, R);
    if(stats.length){
      var dy=y+m.inTop+m.routeH+m.divGap*0.5;
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,0.10)'; ctx.lineWidth=1.5;
      ctx.beginPath(); ctx.moveTo(x+w*0.16,dy); ctx.lineTo(x+w*0.84,dy); ctx.stroke(); ctx.restore();
      drawStatsD(ctx, stats, x+w*0.30, x+w*0.70, y+m.inTop+m.routeH+m.divGap+m.rowH*0.55, m.rowH, w);
    }
  }
  function renderDouble(ctx, ox, oy, W, H, fillBg){
    var prod=state.product;
    if(fillBg){
      if(prod==='tee'){ ctx.fillStyle='#26262b'; ctx.fillRect(ox,oy,W,H); }
      else { var g=ctx.createRadialGradient(ox+W/2,oy+H*0.1,0,ox+W/2,oy+H*0.1,H); g.addColorStop(0,'#16161b');g.addColorStop(1,'#0d0d10'); ctx.fillStyle=g; ctx.fillRect(ox,oy,W,H); }
    }
    var title=($('cz-title').value.trim()||'My Milestone').toUpperCase(), loc=($('cz-loc').value||'').toUpperCase();
    var s1=statsFor(''), s2=statsFor('2');
    var nRows=Math.max(Math.ceil(s1.length/2),Math.ceil(s2.length/2));
    var pad=W*0.05, gap=W*0.04, tw=(W-2*pad-gap)/2;
    var inTop=tw*0.09, inBot=tw*0.09, divGap=tw*0.12, rowH=tw*0.2;
    var statsH = nRows>0 ? (divGap + nRows*rowH) : 0;

    var fs=W*(prod==='poster'?0.082:0.07), tt=spaced(title);
    ctx.font='800 '+fs+'px Inter,sans-serif';
    while(ctx.measureText(tt).width>W*0.84 && fs>3){ fs*=0.94; ctx.font='800 '+fs+'px Inter,sans-serif'; }

    var bottomMargin=H*0.07, tileGap=H*0.045, topMargin=oy+H*0.05;
    var titleY = oy + H - bottomMargin - (loc? W*0.05 : 0);      
    var titleTopEdge = titleY - fs*0.78;
    var top = topMargin;
    var th = (titleTopEdge - tileGap) - top;
    var routeH = th - inTop - inBot - statsH;
    var minRoute = tw*0.5;
    if(routeH < minRoute){ routeH=minRoute; th=inTop+inBot+statsH+routeH; top=Math.max(topMargin, titleTopEdge - tileGap - th); }

    var m={inTop:inTop, routeH:routeH, divGap:divGap, rowH:rowH, inBot:inBot};
    drawTileD(ctx, rFrom(state),    s1, ox+pad,        top, tw, th, m);
    drawTileD(ctx, rFrom(state.r2), s2, ox+pad+tw+gap, top, tw, th, m);

    var cx=ox+W/2;
    ctx.textAlign='center'; ctx.font='800 '+fs+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4';
    ctx.fillText(tt, cx, titleY);
    if(loc){ ctx.font='600 '+(W*0.026)+'px Inter,sans-serif'; ctx.fillStyle='#9b9aa2'; ctx.fillText(spaced(loc,0.18), cx, titleY+W*0.05); }
  }

  function drawAttrib(ctx,ox,oy,W,H){  }
  function updatePageAttrib(){
    var el=document.getElementById('cz-pageattrib');
    if(!el){ el=document.createElement('div'); el.id='cz-pageattrib'; el.className='cz-pageattrib'; }

    var anchor=root.querySelector('.cz-pmstage')||root.querySelector('.cz-thumbs')||root.querySelector('.cz-hero');
    if(anchor && anchor.parentNode){ if(el.previousElementSibling!==anchor) anchor.parentNode.insertBefore(el,anchor.nextSibling); }
    else if(!el.parentNode) root.appendChild(el);
    var t='';
    if(state.style==='map') t='Map data \u00a9 OpenStreetMap contributors, via Geoapify';
    else if(state.style==='terrain') t='Elevation: Mapzen Terrain Tiles \u00b7 AWS Open Data'+((typeof tplOn==='function'&&tplOn())?' \u00b7 Place names \u00a9 OpenStreetMap contributors, via OpenFreeMap':'');
    el.textContent=t; el.style.display=t?'block':'none';
  }

  var EDT={ mL:0.084, mR:0.911, dateY:0.0755, ruleY:0.105, mapT:0.135, mapGap:0.082,
            ribbonH:0.060, ribbonGap:0.026,
            titleLast:0.755, titleLead:0.056, titleSize:0.0615, locY:0.797,
            divY:0.840, divSplit:0.218, labY:0.879, valY:0.919, colX:[0.084,0.290,0.520] };

  function edtTracked(ctx,t,px,py,tr){
    var i,cx=px;
    for(i=0;i<t.length;i++){ ctx.fillText(t.charAt(i),cx,py); cx+=ctx.measureText(t.charAt(i)).width+tr; }
  }
  function edtTrackedW(ctx,t,tr){
    var w=0,i;
    for(i=0;i<t.length;i++) w+=ctx.measureText(t.charAt(i)).width+tr;
    return w-tr;
  }
  function edtVal(id){ var e=$(id); return e?(e.value||'').trim():''; }
  function edtTime(){
    var h=parseInt(edtVal('cz-h'),10)||0, m=parseInt(edtVal('cz-m'),10)||0, sec=parseInt(edtVal('cz-s'),10)||0;
    if(!h && !m && !sec) return '';
    var p2=function(n){ return (n<10?'0':'')+n; };
    return h? (h+':'+p2(m)+':'+p2(sec)) : (m+':'+p2(sec));
  }
  function edtDate(){
    var v=edtVal('cz-date'), m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    return m? (m[3]+'.'+m[2]+'.'+m[1]) : '';
  }
  /* "30 AUG 2026". Lifted out of renderPhotoOverlay so Gallery's compact line
     and the Photo design cannot disagree about what a date looks like. */
  var GAL_MON=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  function monDate(){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(edtVal('cz-date'));
    return m ? ((+m[3])+' '+GAL_MON[(+m[2])-1]+' '+m[1]) : '';
  }
  /* "SYDNEY, NSW \u00b7 30 AUG 2026", or whichever half exists. Still used by
     the Photo design. */
  function locDateLine(){
    var l=(edtVal('cz-loc')||'').toUpperCase(), d=monDate();
    return (l&&d) ? (l+' \u00b7 '+d) : (l||d);
  }
  /* The line under Gallery's title: the name and the date, joined by a middot,
     with whichever of them the customer filled in. Compact adds the location,
     because its info row has no column for it. Empty parts are dropped rather
     than leaving a stranded separator. */
  function galSubLine(cmp){
    var p=[dsName()];
    if(cmp || relayLeg()) p.push((edtVal('cz-loc')||'').toUpperCase());
    p.push(monDate());
    return p.filter(function(x){ return x; }).join(' \u00b7 ');
  }
  /* ---- pace, or speed ---------------------------------------------------
     Every design prints paceVal(). The field wins if the customer filled it in -
     they may be quoting what their watch said, which is moving pace, not
     distance over elapsed time - tidied so "5:30", "5.30" and "5:30 min/km"
     all print as 5:30 /KM. Otherwise it is worked out, which is the common
     case: 3:47:51 over 42.2 km is 5:24. A ride is speed: 120 km in 4:12:30 is
     28.5 KM/H. A distance typed in miles gets miles units. */
  function sp(){ return SPORTS[SPORT]||SPORTS.run; }
  function sportKey(v){
    v=String(v||'').trim().toLowerCase(); if(!v) return '';
    if(/^(run[\s_-]*5k|5k([\s_-]*run)?)$/.test(v)) return 'run5k';
    if(/cycl|bik|ride|velo|gravel|mtb|e-?bike/.test(v)) return 'cycle';
    if(/swim/.test(v)) return 'swim';
    if(/hik|walk|trek|tramp/.test(v)) return 'hike';
    if(/trail|ultra|fell|sky/.test(v)) return 'trail';
    if(/run|jog|marathon/.test(v)) return 'run';
    return '';
  }
  var SPORT_RANK={'':0, sbdef:0.5, file:1, user:2, route:3, param:4};
  /* A click always counts; anything else only replaces a weaker source, so an
     uploaded file cannot undo the customer's own choice. */
  function setSport(v, src){
    var k=sportKey(v); src=src||'user'; if(!k) return false;
    /* Stat Bar's 5K default: a running file is a 5K Run's file. */
    if(src==='file' && SPORT_SRC==='sbdef' && SPORT==='run5k' && k==='run') return false;
    if(src!=='user' && SPORT_RANK[src] < SPORT_RANK[SPORT_SRC]) return false;
    var was=SPORT, colWas=routeHex(); SPORT=k; SPORT_SRC=src;
    if(k!==was){
      var c=$('cz-ribbon');
      if(c && !_ribTouched && _ribAuto && !sp().ribbon){ c.checked=false; _ribAuto=false; }
      try{ syncRibbonRow(); }catch(e){}
    }
    syncSportUI();
    if(k!==was){
      if(!_accTouched){ state.accent=routeHex(); try{ buildPalette(); }catch(e){} }
      try{
        if(routeHex()!==colWas && isMapLike(state.style) && !state.mapUser){
          /* The line is baked into the map (Street Map) or drawn into the
             terrain, so a new colour is a new picture. */
          state.mapImg=null; state.mapUrl=''; state.terrainBase=null;
          ensureMap(function(){ ensureMap2(render); });
        } else render();
      }catch(e){}
    }
    return k!==was;
  }
  function _isMi(n){ return /\bmi(les?)?\b/i.test(edtVal('cz-dist'+(n||''))); }
  function _unitP(n){ return _isMi(n) ? sp().unitMi : sp().unitP; }
  function _pnum(v){ var x=parseFloat(String(v||'').replace(',','.').replace(/[^0-9.]/g,'')); return isFinite(x)?x:0; }
  /* Kilometres, whatever was typed: "42.2 km", "42.2", "2500 m". Miles stay
     miles - _isMi() switches the units instead. */
  function distKm(n){
    var raw=edtVal('cz-dist'+(n||'')), x=_pnum(raw); if(!x) return 0;
    if(/\d\s*m\b/i.test(raw) && !/km/i.test(raw)) return x/1000;
    return x;
  }
  function _secs(n){ var g=function(id){ return parseInt(edtVal(id+n),10)||0; };
    return g('cz-h')*3600+g('cz-m')*60+g('cz-s'); }
  function paceTyped(v,n){
    var raw=String(v||'').trim(); if(!raw || sp().noPace) return '';
    var u=_unitP(n);
    if(SPORT==='cycle'){
      var t=raw.replace(/\s*(km\s*\/\s*h(r)?|kmh|kph|km\s*per\s*hour|mph)\.?\s*$/i,'').trim();
      if(/^\d+([.,]\d+)?$/.test(t)) return t.replace(',','.')+' '+u;
      return raw.toUpperCase();
    }
    var t2=raw.replace(/\s*(min(ute)?s?\s*)?(\/|per)\s*(100\s*m|km|kilomet(er|re)s?|mi(le)?s?)\.?\s*$/i,'')
              .replace(/\s*min(ute)?s?\s*$/i,'').trim();
    var m=/^(\d{1,2})\s*[:.'’]\s*(\d{2})$/.exec(t2);
    if(m && +m[2]<60) return (+m[1])+':'+m[2]+' '+u;
    if(/^\d{1,2}$/.test(t2)) return (+t2)+':00 '+u;
    return raw.toUpperCase();
  }
  function paceAuto(n){
    n=n||''; var d=distKm(n), tot=_secs(n);
    if(!d || d<=0 || !tot || sp().noPace) return '';
    if(sp().per100){ var p1=Math.round(tot/(d*10)), qm=Math.floor(p1/60), qs=p1%60;
      return qm+':'+(qs<10?'0':'')+qs+' '+sp().unitP; }
    if(SPORT==='cycle'){ var v=d/(tot/3600); return (v>=100?String(Math.round(v)):v.toFixed(1))+' '+_unitP(n); }
    var per=Math.round(tot/d), pm=Math.floor(per/60), ps=per%60;
    return pm+':'+(ps<10?'0':'')+ps+' '+_unitP(n);
  }
  function paceVal(n){ n=n||''; return paceTyped(edtVal('cz-pace'+n),n) || paceAuto(n); }
  function paceLab(){ return sp().lab; }
  function galPace(){ return paceVal(''); }

  /* ---- elevation gain and high point ----------------------------------- */
  function fmtM(v){ v=Math.round(v); return String(v).replace(/\B(?=(\d{3})+(?!\d))/g,',')+' M'; }
  /* Climbing, counted only once a rise passes 3 m - the jitter in a GPS or
     barometric trace on flat ground is not climbing, and summing every
     wiggle (what the ribbon used to print) overstates a flat course badly. */
  function gainOf(e){
    var T=3, ref=null, g=0, i, v;
    for(i=0;i<(e?e.length:0);i++){ v=e[i]; if(!isFinite(v)) continue;
      if(ref===null){ ref=v; continue; }
      if(v>ref){ if(v-ref>=T){ g+=v-ref; ref=v; } }
      else if(ref-v>=T) ref=v; }
    return g;
  }
  function _mTyped(v){
    var raw=String(v||'').trim(); if(!raw) return '';
    var t=raw.replace(/\s*(m|metres?|meters?)\.?\s*$/i,'').replace(/,/g,'').trim();
    if(/^\d+(\.\d+)?$/.test(t)) return fmtM(+t);
    return raw.toUpperCase();
  }
  function gainAuto(n){
    if(n) return '';
    try{ var rt=currentRoute(), og=rt?parseFloat(String(rt.gain||'').replace(/[,\s]/g,'').replace(/[^0-9.]/g,'')):0;
      var _rlg=relayLeg(); if(_rlg) og=_rlg.ascent||0;
      if(og>0) return fmtM(og); }catch(e){}
    if(!eleUsable()) return '';
    var g=gainOf(state.eles); return g>=1 ? fmtM(g) : '';
  }
  function summitAuto(n){
    if(n || !eleUsable()) return '';
    var mx=-1/0, i; for(i=0;i<state.eles.length;i++){ if(isFinite(state.eles[i]) && state.eles[i]>mx) mx=state.eles[i]; }
    return isFinite(mx) ? fmtM(mx) : '';
  }
  function gainVal(n){ n=n||''; return _mTyped(edtVal('cz-gain'+n)) || gainAuto(n); }
  function summitVal(n){ n=n||''; return _mTyped(edtVal('cz-summit'+n)) || summitAuto(n); }

  /* ---- the stats every design prints ------------------------------------
     The activity's stats in its order of preference, the first three that
     have a value. opt.time formats the time (designs differ: 3H 47M or
     3:47:51); opt.upper uppercases the distance as typed. */
  /* Stats the customer removed ("remove" by each field, like Date). Not
     printed anywhere and not on the order; typing in the field adds it back. */
  var STAT_OFF={};
  try{ String(getParam('hide')||'').toLowerCase().split(',').forEach(function(k){
    k=k.trim(); if(/^(dist|time|pace|gain|summit)$/.test(k)) STAT_OFF[k]=true; }); }catch(e){}
  syncStatBtns();
  function syncStatBtns(){
    try{ Array.prototype.forEach.call(document.querySelectorAll('.cz-statoff'),function(b){
      var k=b.getAttribute('data-stat'), off=!!STAT_OFF[k];
      b.textContent=off?'add back':'remove'; b.setAttribute('aria-pressed',off?'true':'false');
      var f=b.closest('.cz-fld'); if(f) f.classList.toggle('cz-off',off);
    }); }catch(e){}
  }
  function statRows(n, opt){
    n=n||''; opt=opt||{};
    var tf=opt.time || function(){ return n ? timeStrN(n) : timeStr(); };
    var dv=edtVal('cz-dist'+n); if(opt.upper) dv=dv.toUpperCase();
    var get={
      dist:  function(){ return ['DISTANCE', dv]; },
      time:  function(){ return ['TIME', tf()]; },
      pace:  function(){ return [paceLab(), paceVal(n)]; },
      gain:  function(){ return ['ELEV GAIN', gainVal(n)]; },
      summit:function(){ return ['HIGH POINT', summitVal(n)]; }
    };
    var out=[], k=sp().stats, i, r;
    for(i=0;i<k.length && out.length<(opt.max||3);i++){
      if(STAT_OFF[k[i]]) continue;
      r=get[k[i]](); if(r[0] && r[1] && String(r[1]).trim()) out.push(r);
    }
    return out;
  }

  /* ---- route colour by activity ---------------------------------------- */
  /* Literal reads, so verify.py can see the section must emit up to MSC[105]. */
  function routeHex(){
    var _rlh=relayHex()||relaySoloHex(); if(_rlh) return _rlh;
    /* p_routecol (27 Oct): the customer's pick, where the palette is offered. */
    if(routePick()) return String(state.accent).toUpperCase();
    return routeHexBase();
  }
  function routePick(){
    return !!(_accTouched && routeColOK() && /^#[0-9a-f]{6}$/i.test(String(state.accent||'')));
  }
  /* Where the route colour may be chosen: not on a relay (the legs have
     colours), not on the triathlon. */
  function routeColOK(){
    if(typeof IS_TRI!=='undefined' && IS_TRI) return false;
    try{ if(relayOpt()) return false; }catch(e){}
    return true;
  }
  /* The sport's own colour - what the route is drawn in until a pick. */
  /* 29 Oct: the ride was magenta; a store still holding that default gets the new amber */
  var RIDE_OLD='#FF2D9A', SWIM_OLD='#FFD028';
  function routeHexBase(){
    var ROUTE_COL={101:MSC[101],102:MSC[102],103:MSC[103],104:MSC[104],105:MSC[105]};
    var c=String(ROUTE_COL[sp().msc]||'').trim();
    if(sp().msc===103 && c.toUpperCase()===RIDE_OLD) c='';   /* the old default, never chosen */
    if(sp().msc===105 && c.toUpperCase()===SWIM_OLD) c='';
    if(SPORT==='run' && !c) c=String(MSC[1]||'').trim();
    return /^#[0-9a-f]{6}$/i.test(c) ? c.toUpperCase() : sp().col;
  }
  function syncMField(id){
    var I=$(id), A=$(id+'Auto'), au=(id==='cz-gain')?gainAuto(''):summitAuto(''), typed=!!(I && I.value.trim());
    if(I) I.placeholder = au ? au.replace(/\s*M$/,'') : (id==='cz-gain'?'850':'1,240');
    if(A) A.hidden = !(au && !typed);
  }
  function syncPaceField(n){
    n=n||''; var u=sp(), mi=_isMi(n);
    var R=$('cz-paceRow'+n); if(R) R.style.display = u.noPace ? 'none' : '';
    var L=$('cz-paceLbl'+n); if(L) L.textContent=u.field;
    var U=$('cz-paceUnit'+n); if(U) U.textContent=mi?(SPORT==='cycle'?'mph':'/mi'):u.unit;
    var I=$('cz-pace'+n), A=$('cz-paceAuto'+n), au=paceAuto(n), typed=!!(I && I.value.trim());
    if(I) I.placeholder = au ? au.replace(/\s+\S+$/,'') : u.ph;
    if(A) A.hidden = !(au && !typed);
  }
  /* A your-route product with no course loaded: the customer's own file is
     coming, so the customer says what it was - the stats, the pace or speed
     and the ribbon follow. Hidden whenever a route entry sets the sport. */
  function sportPickOn(){
    if(!(PM && PM_FAM==='your-route')) return false;
    if(typeof IS_TRI!=='undefined' && IS_TRI) return false;
    if(SPORT_SRC==='route' || currentRoute()) return false;
    return !(getParam('gpx') || getParam('race'));
  }
  function syncSportRow(){ var row=$('cz-sport'); if(row) row.style.display=sportPickOn()?'':'none'; }
  function syncSportUI(){
    var row=$('cz-sport');
    if(row) Array.prototype.forEach.call(row.querySelectorAll('[data-sp]'),function(b){
      var on=b.getAttribute('data-sp')===SPORT;
      b.classList.toggle('cz-on',on); b.setAttribute('aria-pressed',on?'true':'false'); });
    syncPaceField(''); syncPaceField('2');
    var k=sp().stats.slice(0,3);
    var gr=$('cz-gainRow'); if(gr) gr.style.display = (k.indexOf('gain')>=0 || sp().gainField) ? '' : 'none';
    var hr=$('cz-summitRow'); if(hr) hr.style.display = (k.indexOf('summit')>=0) ? '' : 'none';
    syncMField('cz-gain'); syncMField('cz-summit');
    try{ sbSyncUI(); }catch(e){}
    var mb=$('cz-moreBtn');
    if(mb && /^\+/.test(mb.textContent)){
      var nm={dist:'distance',time:'time',pace:(sp().field||'').toLowerCase(),gain:'elevation',summit:'high point'};
      mb.textContent='+ Add stats ('+k.map(function(x){ return nm[x]; }).join(', ')+')';
    }
  }

  function edtCoord(){
    if(!state.coords || !state.coords.length) return '';
    var i,sa=0,so=0,c=state.coords;
    for(i=0;i<c.length;i++){ sa+=c[i][0]; so+=c[i][1]; }
    var la=sa/c.length, lo=so/c.length;
    return Math.abs(la).toFixed(4)+'\u00B0'+(la<0?'S':'N')+'  '+Math.abs(lo).toFixed(4)+'\u00B0'+(lo<0?'W':'E');
  }

  /* The art panel - map, terrain tiles, or the colourised route mask - fitted
     into an arbitrary rect. Lifted out of renderEditorial so the medal frame
     paints the same art rather than a second copy of this that can drift.
     Photo is handled here too, so a frame in Photo style shows the photo with
     the route over it and nothing else changes at the call sites. */
  function drawArtInto(ctx,x,y,w,h){
    ctx.save(); ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
    ctx.fillStyle='#E9E5DC'; ctx.fillRect(x,y,w,h);
    if(IS_PO && !splitPhoto){
      /* Photo chosen, none supplied yet - say so in the panel rather than
         quietly falling through to the map. */
      ctx.fillStyle='#3a3a40'; ctx.fillRect(x,y,w,h);
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,0.35)';
      ctx.setLineDash([w*0.05,w*0.05]); ctx.lineWidth=Math.max(2,w*0.012);
      ctx.strokeRect(x+w*0.06,y+h*0.04,w*0.88,h*0.92); ctx.restore();
      ctx.textAlign='center'; ctx.fillStyle='#f0ede6';
      ctx.font='700 '+(w*0.085)+'px Inter,sans-serif';
      ctx.fillText('+', x+w/2, y+h/2-w*0.03);
      ctx.font='600 '+(w*0.055)+'px Inter,sans-serif';
      ctx.fillText('ADD YOUR', x+w/2, y+h/2+w*0.08);
      ctx.fillText('PHOTO',    x+w/2, y+h/2+w*0.16);
      ctx.textAlign='left'; ctx.restore(); return;
    }
    if(IS_PO && splitPhoto){
      var ir=splitPhoto.width/splitPhoto.height, br=w/h, psw,psh,psx,psy;
      if(ir>br){ psh=splitPhoto.height; psw=psh*br; psy=0; psx=(splitPhoto.width-psw)*splitPhotoOff.x; }
      else { psw=splitPhoto.width; psh=psw/br; psx=0; psy=(splitPhoto.height-psh)*splitPhotoOff.y; }
      ctx.drawImage(splitPhoto, psx,psy,psw,psh, x,y,w,h);
      if(state.mask && state.bbox){
        /* Low in the frame, where a race photo is usually darkest, and carrying
           a shadow so a pale sky or a wet road cannot swallow it. Drawn twice
           under the shadow because one pass is too faint to separate the line
           from a busy photo. */
        var pc=colourised(), pb=state.bbox;
        var ps=Math.min(w*0.78/pb.w, h*0.40/pb.h);
        var pdw=pb.w*ps, pdh=pb.h*ps;
        var pdx=x+(w-pdw)/2, pdy=y+h-pdh-h*0.055;
        ctx.save();
        ctx.shadowColor='rgba(0,0,0,0.60)';
        ctx.shadowBlur=Math.max(4,w*0.045);
        ctx.shadowOffsetY=Math.max(1,w*0.010);
        ctx.drawImage(pc,pb.x,pb.y,pb.w,pb.h, pdx,pdy,pdw,pdh);
        ctx.drawImage(pc,pb.x,pb.y,pb.w,pb.h, pdx,pdy,pdw,pdh);
        ctx.restore();
        ctx.drawImage(pc,pb.x,pb.y,pb.w,pb.h, pdx,pdy,pdw,pdh);
      }
      ctx.restore(); return;
    }
    if(noRoute()){ drawRoutePrompt(ctx,x,y,w,h,false); ctx.restore(); return; }
    if(isMapLike(state.style) && state.mapImg){
      var im=state.mapImg;
      /* Geoapify stamps its own strip along the bottom; terrain and a
         user-supplied map have none, so only crop when we fetched it. */
      var cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035);
      var sw=im.width, sh=im.height-cropB;
      var sc=Math.max(w/sw, h/sh);
      var dw=sw*sc, dh=sh*sc;
      ctx.drawImage(im,0,0,sw,sh, x+(w-dw)/2, y+(h-dh)/2, dw,dh);
      /* Scale bar bottom-left, north arrow top-right (22 Oct pm): Terrain
         and Street Map, box ticked, a map whose scale is known. */
      if((IS_EDT||IS_TD) && !state.mapUser && typeof kmOn==='function' && kmOn()){
        var _mpp=(im._mpp>0) ? im._mpp : ((state.style==='map' && typeof mapMpp==='function') ? mapMpp(state.mapUrl,im) : 0);
        if(_mpp>0){
          var _pu=w*0.03, _mono=IS_EDT ? '"Roboto Mono",ui-monospace,Menlo,monospace' : 'Inter,sans-serif';
          var _bx=x+w*0.05, _by=y+h-_pu*1.2, _nx=x+w-_pu*1.6, _ny=y+_pu*2.9;
          var _lt=sfLum(ctx,_bx+_pu*3,_by-_pu*0.5,_pu*1.5)>140, _ln=sfLum(ctx,_nx,_ny-_pu,_pu*1.5)>140;
          drawMapCues(ctx,{mpp:_mpp/sc, u:_pu, font:_mono, ink:_lt?'#17171A':'#FFFFFF', halo:_lt?'rgba(243,239,231,0.9)':'rgba(0,0,0,0.7)',
                           bar:[_bx,_by,w*0.26]});
          drawMapCues(ctx,{mpp:_mpp/sc, u:_pu, font:_mono, ink:_ln?'#17171A':'#FFFFFF', halo:_ln?'rgba(243,239,231,0.9)':'rgba(0,0,0,0.7)',
                           north:[_nx,_ny]});
        }
      }
    } else if(state.mask && state.bbox){
      var col=colourised(), bb=state.bbox;
      var s3=Math.min(w*0.86/bb.w, h*0.86/bb.h), dw3=bb.w*s3, dh3=bb.h*s3;
      ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h, x+(w-dw3)/2, y+(h-dh3)/2, dw3,dh3);
    }
    ctx.restore();
  }

  /* ---- Gallery: route map left, the customer's photo right ------------------
     Fractions of the artwork width W, so one rule set serves every aspect
     ratio - A3 at 0.707 and the magnet at 0.8 - with the panel height taking
     up whatever the text block leaves. Checked against the reference artboard
     (594 x 840): margin 44, panels 500 tall, gap 30, accent 28 x 3, title 60,
     name 18, hairline 1, labels 9, values 17, column gap 12. */
  var GAL={
    mFull:0.074,    mComp:0.060,
    key:0.0017,     gap:0.050,
    accW:0.047,     accH:0.005,   accGap:0.017,
    titleFull:0.101, titleComp:0.110, titleFloor:0.060,
    titleLh:0.92,   titleTrack:0.005,
    hairGap:0.024,
    labFull:0.015,  labComp:0.022,  labTrack:0.16, labGap:0.010,
    valFull:0.029,  valComp:0.040,  valLh:1.05,
    colGap:0.020,   locWeight:1.6,
    /* The line under the title. Compact's is larger against its larger title;
       full mode sits a little under where the name used to be at 0.030. */
    mergeSize:0.026, mergeFull:0.022, mergeGap:0.016, mergeTrack:0.10,
    /* Clear space below the value baseline, inside the bottom margin. The
       artboard leaves 91 of 594 px here, which puts the bottom margin at about
       three times the top; Marc picked half of it, so the poster still breathes
       under the stats without reading as unbalanced. Panels land at ~65% of H
       where the artboard has ~60% and a flush bottom would give ~70%. */
    botPad:0.075,
    mapInX:0.10,    mapInY:0.08,
    /* The elevation ribbon (rides): gap above it holds its two labels. */
    ribGap:0.040,   ribH:0.072,
    photoFocus:0.60,
    paper:'#F3EFE7', ink:'#17171A', lbl:'#5E5B63', acc:'#FF5A1F',
    /* Neutral, not warm. These were a step down from cream paper; against white
       the same taupe reads as a dirty block rather than an empty panel. */
    /* 29 Oct pm: back on cream (Street Map's paper), so a step down from it again */
    mapBg:'#E8E3D8', photoBg:'#DDD7CB',
    /* Cap heights, measured from the two stacks the design uses. Only used to
       put a baseline where CSS would have centred the glyphs in a line box. */
    capOsw:0.73, capMono:0.72, lhMono:1.15
  };
  function galCond(sz,wt){ return (wt||600)+' '+sz+'px Oswald,"Arial Narrow",sans-serif'; }
  function galMono(sz,wt){ return (wt||400)+' '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace'; }
  /* Where the baseline goes inside a line box of lh*sz, with the glyphs
     centred: the artboard's 60px/0.92 title lands at 49.5, which this gives. */
  function galBase(sz,lh,cap){ return sz*(lh+cap)/2; }
  /* On the tee the artwork has no paper ground - renderMain is called with
     fillBg false and the shirt shows through - so ink would be invisible.
     The panels always carry their own background, so only the type flips. */
  function galInk(fillBg){ return (!fillBg && state.product==='tee') ? '#FFFFFF' : GAL.ink; }
  function galLblCol(fillBg){ return (!fillBg && state.product==='tee') ? '#CFC9BC' : GAL.lbl; }

  /* Split a title for the two-line case: at the comma if there is one, else at
     the space nearest the middle. Same instinct as the editorial title, which
     splits on commas only - this one has to cope with "NORTH SYDNEY TO OPERA
     HOUSE 42.2K", which has none. */
  function galWrap(t){
    var ci=t.indexOf(',');
    if(ci>0) return [t.slice(0,ci).trim(), t.slice(ci+1).trim()].filter(Boolean);
    var mid=t.length/2, best=-1, i;
    for(i=0;i<t.length;i++){
      if(t.charAt(i)!==' ') continue;
      if(best<0 || Math.abs(i-mid)<Math.abs(best-mid)) best=i;
    }
    if(best<0) return [t];
    return [t.slice(0,best).trim(), t.slice(best+1).trim()];
  }

  /* The info row. A column with no value disappears and the rest spread evenly,
     so a customer who entered no time gets LOCATION . DATE . DISTANCE rather
     than two empty slots. LOCATION gets 1.6x the width: it is the one that runs
     long. Compact drops to three columns and the other two merge into a line
     under the title. */
  function galCols(cmp){
    var out=[];
    function add(l,v,w){ if(v) out.push({ label:l, value:String(v).toUpperCase(), w:w||1 }); }
    /* DATE has gone to the line under the title. LOCATION stays here in full
       mode - it is the one that runs long, and the row has the width for it. */
    if(!cmp && !relayLeg()) add('LOCATION',(edtVal('cz-loc')||''),GAL.locWeight);
    statRows('',{time:edtTime}).forEach(function(r){ add(r[0],r[1]); });
    return out;
  }

  /* All the geometry, in one place, so the canvas and the resolution warning
     cannot disagree about how big the photo panel is. Pure apart from reading
     the form fields and measuring text. */
  function galLayout(ctx,ox,oy,W,H){
    var cmp=galCompact(), floor=galFloor(W);
    var fit=function(v){ return Math.max(floor,v); };   /* 6 pt wins over the fraction */
    var m=W*(cmp?GAL.mComp:GAL.mFull);
    var lx=ox+m, rx=ox+W-m, inner=rx-lx;
    var key=Math.max(1,W*GAL.key);

    /* Nothing shares the title's row any more - the name moved to the line
       below it - so the title has the whole inner width to work with. */
    var raw=(edtVal('cz-title')||'Your Route').toUpperCase();
    var tsz=fit(W*(cmp?GAL.titleComp:GAL.titleFull));
    var tFloor=fit(W*GAL.titleFloor);
    var room=inner;
    var ttr=tsz*GAL.titleTrack, lines=[raw], g=0;
    ctx.font=galCond(tsz,600);
    while(edtTrackedW(ctx,raw,ttr)>room && tsz>tFloor && g++<200){
      tsz*=0.97; ttr=tsz*GAL.titleTrack; ctx.font=galCond(tsz,600);
    }
    /* The loop shrinks THEN tests, so the last step can land up to 3% under the
       floor. Clamped back, because the floor is where the brief says to stop
       shrinking and start wrapping - not somewhere just below it. */
    if(tsz<tFloor){ tsz=tFloor; ttr=tsz*GAL.titleTrack; ctx.font=galCond(tsz,600); }
    if(edtTrackedW(ctx,raw,ttr)>room){
      /* At the floor and still over: wrap rather than shrink further. Line one
         shares the row with the name; line two has the whole width. If even
         that overflows there is nothing left but to shrink, down to the point
         floor - better small than off the paper. */
      lines=galWrap(raw); g=0;
      while(g++<200){
        ctx.font=galCond(tsz,600);
        var o1=edtTrackedW(ctx,lines[0],ttr)>room;
        var o2=lines.length>1 && edtTrackedW(ctx,lines[1],ttr)>inner;
        if((!o1 && !o2) || tsz<=floor) break;
        tsz*=0.97; ttr=tsz*GAL.titleTrack;
      }
    }

    var msz=fit(W*(cmp?GAL.mergeSize:GAL.mergeFull)), mergeTxt=galSubLine(cmp);
    if(mergeTxt && relayOpt()){ var _mg=0; ctx.font=galMono(msz,500);
      while(edtTrackedW(ctx,mergeTxt,msz*GAL.mergeTrack)>inner && msz>floor && _mg++<80){ msz*=0.96; ctx.font=galMono(msz,500); }
      if(msz<floor) msz=floor; }
    var cols=galCols(cmp);
    var lsz=fit(W*(cmp?GAL.labComp:GAL.labFull));
    var vsz=fit(W*(cmp?GAL.valComp:GAL.valFull));

    /* The text block, measured from its own top down. */
    var y=0, out={ cmp:cmp, m:m, lx:lx, rx:rx, inner:inner, key:key,
                   lines:lines, tsz:tsz, ttr:ttr,
                   mergeTxt:mergeTxt, msz:msz,
                   cols:cols, lsz:lsz, vsz:vsz, floor:floor };
    /* Advanced in line boxes, the way the artboard stacks them: a gap in the
       brief sits between boxes, so stepping from one baseline to the next gap
       would swallow each line's descender. */
    out.accY=y;  y+=W*GAL.accH;
    y+=W*GAL.accGap;
    out.tBase=[];
    for(var i=0;i<lines.length;i++)
      out.tBase.push(y + i*tsz*GAL.titleLh + galBase(tsz,GAL.titleLh,GAL.capOsw));
    y+=lines.length*tsz*GAL.titleLh;
    if(mergeTxt){
      y+=W*GAL.mergeGap;
      out.mBase=y+galBase(msz,GAL.lhMono,GAL.capMono);
      y+=msz*GAL.lhMono;
    }
    y+=W*GAL.hairGap;
    out.hairY=y; y+=key;
    y+=W*GAL.hairGap;
    out.labBase=y+galBase(lsz,GAL.lhMono,GAL.capMono);  y+=lsz*GAL.lhMono;
    y+=W*GAL.labGap;
    out.valBase=y+galBase(vsz,GAL.valLh,GAL.capOsw);    y+=vsz*GAL.valLh;
    y+=W*GAL.botPad;
    out.textH=y;

    /* Columns across the inner width, each one's share set by its weight, with
       the brief's gap between. A dropped column is simply not in the list, so
       the rest spread into its room without anything here knowing why. */
    var sumW=0, ci;
    for(ci=0;ci<cols.length;ci++) sumW+=cols[ci].w;
    var avail=inner-(cols.length>1?(cols.length-1)*W*GAL.colGap:0);
    var cx=lx;
    for(ci=0;ci<cols.length;ci++){
      var c=cols[ci];
      c.x=cx; c.w2=sumW>0?(avail*c.w/sumW):avail;
      cx+=c.w2+W*GAL.colGap;
      /* Fit the value. Shrink to 80% first, then wrap - a 20% reduction is
         still readable next to its neighbours, where a free shrink is not. */
      c.vsz=vsz; c.vLines=[c.value];
      ctx.font=galCond(c.vsz,500);
      if(ctx.measureText(c.value).width>c.w2){
        c.vsz=Math.max(floor,vsz*0.8);
        ctx.font=galCond(c.vsz,500);
        if(ctx.measureText(c.value).width>c.w2) c.vLines=galWrap(c.value);
      }
      /* Label too: it is tracked, and LOCATION is the long one. */
      c.lsz=lsz; c.ltr=lsz*GAL.labTrack;
      ctx.font=galMono(c.lsz,400);
      if(edtTrackedW(ctx,c.label,c.ltr)>c.w2){
        var lr=c.w2/edtTrackedW(ctx,c.label,c.ltr);
        c.lsz=Math.max(floor,c.lsz*lr); c.ltr=c.lsz*GAL.labTrack;
      }
    }
    /* A value that wrapped needs a second line under the row, so the block is
       that much taller. Measured here rather than guessed above, because it
       depends on what the customer typed. */
    var extra=0;
    for(ci=0;ci<cols.length;ci++)
      if(cols[ci].vLines.length>1) extra=Math.max(extra,(cols[ci].vLines.length-1)*cols[ci].vsz*GAL.valLh);
    out.textH+=extra; out.colExtra=extra;

    /* Where the photo sits in its panel before the customer moves it. Race
       photos put the runner low in frame, so the crop starts below centre. */
    out.focus={ x:0.5, y:GAL.photoFocus };

    /* Panels take what is left. A format so short that nothing is left would
       render a negative panel, so it is clamped - the text is the part the
       customer typed and the part that has to stay legible. */
    var pw=inner/2;
    var _rb=galRibOn(), ribGap=_rb?W*GAL.ribGap:0, ribH=_rb?W*GAL.ribH:0;
    var _rx=_rb?relayRibExtra(W):0;
    var ph=H-2*m-W*GAL.gap-out.textH-ribGap-ribH-_rx;
    if(ph<H*0.18) ph=H*0.18;
    out.ribR=_rb ? { x:lx, y:oy+m+ph+ribGap, w:inner, h:ribH } : null;
    out.panel={ x:lx, y:oy+m, w:inner, h:ph };
    out.mapR  ={ x:lx,    y:oy+m, w:pw, h:ph };
    out.photoR={ x:lx+pw, y:oy+m, w:pw, h:ph };
    /* The route sits inside the map panel, not against its edges. Both insets
       are fractions of the panel WIDTH so the margin reads as even: on a 1:2
       panel, 8% of the height would be nearly twice the side inset. */
    out.routeR={ x:out.mapR.x+pw*GAL.mapInX, y:out.mapR.y+pw*GAL.mapInY,
                 w:pw*(1-2*GAL.mapInX),      h:ph-2*pw*GAL.mapInY };
    out.textY=oy+m+ph+ribGap+ribH+_rx+W*GAL.gap;
    return out;
  }

  /* ---- medal frame: 250 x 250 mm insert -------------------------------------
     The medal is a reserved zone, never something the route may sit under, so
     this is its own layout rather than a square crop of the poster. The medal
     itself is drawn for the preview and the mockups and omitted from the print
     file - printing a picture of a medal behind the real one would be absurd.
     Geometry is fractions of the square; see medal-frame-layouts.png. */
  /* mapT equals pad: the art panel sits the same distance from the top as it
     does from the left, so the square reads as one margin all the way round.
     Changing mapT or mapB changes the panel ratio - keep FR_AR, the map request
     and TOUT_FR_* in step or wide routes crop again. */
  var FR={ pad:0.0465, gap:0.036, mapW:0.428, mapT:0.0465, mapB:0.812,
           tickY:0.052, tickW:0.124, zoneD:0.420, zoneT:0.112, medalD:0.320,
           nameY:0.612, ruleY:0.648, ruleW:0.150, statT:0.678, statGap:0.100,
           titleY:0.900, titleSz:0.052, locY:0.940,
           nameSz:0.045, statLblSz:0.0200, statValSz:0.0440, statValDrop:0.058 };
  var FR_AR = FR.mapW / (FR.mapB - FR.mapT);     /* 0.5591 */
  /* The right column's name, rule and stats share the medal's centre line.
     false puts them back on the left margin, which is how it shipped first. */
  var FR_CENTER = true;
  /* The illustrative medal for the frame insert.

     Struck metal does not read as metal because of its colour - it reads because
     the brightness sweeps AROUND the circumference as the surface turns towards
     and away from the light. A linear gradient cannot do that, which is what made
     the first attempt look like a cartoon coin. So the body is an angular sweep,
     drawn as wedges rather than createConicGradient, which Safari only got in
     16.4 and this has to work on whatever phone the customer has.

     Everything on top of the sweep is rgba, not opaque, so the shaping survives
     whatever colour the route sets - silver, bronze, gunmetal, anything. */

  /* #rgb / #rrggbb -> [r,g,b]. Anything unreadable falls back rather than
     throwing, because these values come from a metafield a human types. */
  function frHex(h, fb){
    var s = String(h || '').trim().replace(/^#/, '');
    if (s.length === 3) s = s.charAt(0)+s.charAt(0)+s.charAt(1)+s.charAt(1)+s.charAt(2)+s.charAt(2);
    if (!/^[0-9a-fA-F]{6}$/.test(s)) return frHex(fb || '#C9A227', '#C9A227');
    return [parseInt(s.slice(0,2),16), parseInt(s.slice(2,4),16), parseInt(s.slice(4,6),16)];
  }
  /* amt > 0 lightens toward white, amt < 0 darkens toward black */
  function frSh(rgb, amt){
    var f = function(c){
      var v = amt >= 0 ? c + (255 - c) * amt : c * (1 + amt);
      return Math.max(0, Math.min(255, Math.round(v)));
    };
    return 'rgb(' + f(rgb[0]) + ',' + f(rgb[1]) + ',' + f(rgb[2]) + ')';
  }
  /* the shade amount at a point around the circle, interpolated between the
     lighting keys below. t is 0 at 12 o'clock, 0.25 at 3 o'clock. */
  function frRing(keys, t){
    t = t - Math.floor(t);
    var n = keys.length, f = t * n, i = Math.floor(f), g = f - i;
    var a = keys[i % n], b = keys[(i + 1) % n];
    g = g * g * (3 - 2 * g);                  /* smoothstep, or the bands show */
    return a + (b - a) * g;
  }
  /* like frSh, but translucent, for the overlays that shape the metal */
  function frShA(rgb, amt, a){
    return frSh(rgb, amt).replace('rgb(', 'rgba(').replace(')', ',' + a + ')');
  }
  /* an angular sweep over a disc: 160 wedges, each overlapping the next, which
     is cheap and leaves no seams at the sizes this is drawn at.
     The wedges all meet at the centre, which leaves a starburst pinch there -
     real metal has no such point, so the middle is washed back out with a soft
     radial of the sweep's own mean shade. */
  function frSweep(ctx, cx, cy, rad, rgb, keys, phase){
    var N = 160, i, t, a0, a1, mean = 0;
    for (i = 0; i < N; i++){
      t = i / N;
      a0 = t * Math.PI * 2 - Math.PI / 2;
      a1 = (i + 1.7) / N * Math.PI * 2 - Math.PI / 2;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, rad, a0, a1);
      ctx.closePath();
      ctx.fillStyle = frSh(rgb, frRing(keys, t + (phase || 0)));
      ctx.fill();
    }
    for (i = 0; i < keys.length; i++) mean += keys[i];
    mean /= keys.length;
    var cg = ctx.createRadialGradient(cx, cy, 0, cx, cy, rad * 0.58);
    cg.addColorStop(0.00, frShA(rgb, mean + 0.04, 0.92));
    cg.addColorStop(0.45, frShA(rgb, mean + 0.02, 0.45));
    cg.addColorStop(1.00, frShA(rgb, mean, 0));
    ctx.fillStyle = cg;
    ctx.fillRect(cx - rad, cy - rad, rad * 2, rad * 2);
  }

  /* The medal is an illustration of the customer's own medal. It is drawn in the
     preview and the mockups and left out of the print file. */
  function frameMedal(ctx, ox, oy, W, H, zc, zcy, r, medalHex, ribbonHex){
    var M = frHex(medalHex, '#C9A227');
    var R = frHex(ribbonHex, '#1F3A5F');
    var rw = FR.tickW * W;                      /* the ribbon fills the cut slot */
    var barW = rw * 1.42, barH = r * 0.26;
    var barY = zcy - r - barH * 0.18;
    /* Light from the upper left, so the crests run upper-left to lower-right and
       the two flanks fall away. Eight keys from 12 o'clock, clockwise. */
    var LIT = [0.30, 0.02, -0.20, 0.04, 0.26, 0.00, -0.22, 0.14];

    ctx.save();

    /* ---- ribbon ---------------------------------------------------------- */
    var rg = ctx.createLinearGradient(zc - rw/2, 0, zc + rw/2, 0);
    rg.addColorStop(0.00, frSh(R, -0.38));
    rg.addColorStop(0.14, frSh(R,  0.16));
    rg.addColorStop(0.40, frSh(R,  0.03));
    rg.addColorStop(0.70, frSh(R, -0.18));
    rg.addColorStop(1.00, frSh(R, -0.42));
    ctx.fillStyle = rg;
    ctx.fillRect(zc - rw/2, oy, rw, (zcy - r * 0.55) - oy);

    /* ---- the disc -------------------------------------------------------- */
    ctx.save();
    ctx.shadowColor = 'rgba(23,23,26,0.26)';
    ctx.shadowBlur = Math.max(5, r * 0.30);
    ctx.shadowOffsetX = Math.max(1, r * 0.04);
    ctx.shadowOffsetY = Math.max(2, r * 0.10);
    ctx.beginPath(); ctx.arc(zc, zcy, r, 0, Math.PI*2);
    ctx.fillStyle = frSh(M, 0); ctx.fill();     /* a solid pass, so the shadow
                                                   is cast once, not 160 times */
    ctx.restore();

    ctx.save();
    ctx.beginPath(); ctx.arc(zc, zcy, r, 0, Math.PI*2); ctx.clip();
    frSweep(ctx, zc, zcy, r, M, LIT, 0);

    /* the rim: a crest near the edge and a dark roll right at it, laid over the
       sweep as rgba so the angular variation still shows through */
    var rim = ctx.createRadialGradient(zc, zcy, r * 0.74, zc, zcy, r);
    rim.addColorStop(0.00, 'rgba(255,255,255,0)');
    rim.addColorStop(0.52, 'rgba(255,255,255,0)');
    rim.addColorStop(0.74, 'rgba(255,255,255,0.20)');
    rim.addColorStop(0.90, 'rgba(255,255,255,0.05)');
    rim.addColorStop(1.00, 'rgba(0,0,0,0.34)');
    ctx.fillStyle = rim; ctx.fillRect(zc - r, zcy - r, r*2, r*2);

    /* the recessed face, one step in: its own sweep, turned a little so its
       crests do not line up with the rim's */
    var fr = r * 0.74;
    ctx.save();
    ctx.beginPath(); ctx.arc(zc, zcy, fr, 0, Math.PI*2); ctx.clip();
    frSweep(ctx, zc, zcy, fr, M, LIT, 0.045);
    var face = ctx.createRadialGradient(zc, zcy - fr*0.25, fr*0.1, zc, zcy, fr);
    face.addColorStop(0.00, 'rgba(255,255,255,0.10)');
    face.addColorStop(0.70, 'rgba(0,0,0,0.02)');
    face.addColorStop(1.00, 'rgba(0,0,0,0.16)');
    ctx.fillStyle = face; ctx.fillRect(zc - fr, zcy - fr, fr*2, fr*2);
    ctx.restore();

    /* the step itself - a dark groove with a lit lip above it. Two hairlines are
       what separate "recessed panel" from "circle drawn on a circle". */
    ctx.lineWidth = Math.max(1, r * 0.022);
    ctx.beginPath(); ctx.arc(zc, zcy, fr + ctx.lineWidth*0.5, 0, Math.PI*2);
    ctx.strokeStyle = 'rgba(0,0,0,0.22)'; ctx.stroke();
    ctx.lineWidth = Math.max(1, r * 0.012);
    ctx.beginPath(); ctx.arc(zc, zcy, fr + r*0.030, 0, Math.PI*2);
    ctx.strokeStyle = 'rgba(255,255,255,0.26)'; ctx.stroke();

    /* specular - a soft smear across the upper left, not a hard shine */
    var sp = ctx.createRadialGradient(zc - r*0.40, zcy - r*0.46, r*0.04,
                                      zc - r*0.30, zcy - r*0.34, r*0.95);
    sp.addColorStop(0.00, 'rgba(255,255,255,0.30)');
    sp.addColorStop(0.45, 'rgba(255,255,255,0.07)');
    sp.addColorStop(1.00, 'rgba(255,255,255,0)');
    ctx.fillStyle = sp; ctx.fillRect(zc - r, zcy - r, r*2, r*2);
    ctx.restore();

    /* ---- the mount the ribbon threads ------------------------------------ */
    /* A ring, not a bar: the ribbon shows through it, which is the detail that
       says the two objects are joined rather than stacked. */
    var bx = zc - barW/2, by = barY - barH/2, rr = barH * 0.42;
    var rect = function(x, y, w, h, k){
      ctx.beginPath();
      ctx.moveTo(x + k, y);
      ctx.lineTo(x + w - k, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + k);
      ctx.lineTo(x + w, y + h - k);
      ctx.quadraticCurveTo(x + w, y + h, x + w - k, y + h);
      ctx.lineTo(x + k, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - k);
      ctx.lineTo(x, y + k);
      ctx.quadraticCurveTo(x, y, x + k, y);
      ctx.closePath();
    };
    var bg = ctx.createLinearGradient(0, by, 0, by + barH);
    bg.addColorStop(0.00, frSh(M,  0.34));
    bg.addColorStop(0.38, frSh(M,  0.04));
    bg.addColorStop(0.62, frSh(M, -0.10));
    bg.addColorStop(1.00, frSh(M, -0.32));
    rect(bx, by, barW, barH, rr);
    ctx.fillStyle = bg; ctx.fill();

    var ix = r * 0.055, iy = barH * 0.26;
    var inner = ctx.createLinearGradient(zc - rw/2, 0, zc + rw/2, 0);
    inner.addColorStop(0.00, frSh(R, -0.52));
    inner.addColorStop(0.30, frSh(R, -0.22));
    inner.addColorStop(1.00, frSh(R, -0.54));
    rect(bx + ix, by + iy, barW - ix*2, barH - iy*2, (barH - iy*2) * 0.45);
    ctx.fillStyle = inner; ctx.fill();

    ctx.restore();
  }
  function frameName(){ return (edtVal('cz-name')||''); }
  /* The route decides, then the section default, then plain gold and navy.
     currentRoute() is declared further down the same scope, so hoisting makes
     this safe at call time. */
  function medalCols(){
    var rt=null; try{ rt=currentRoute(); }catch(e){}
    return [ (rt&&rt.medal)||MSC[80]||'#C9A227',
             (rt&&rt.ribbon)||MSC[81]||'#1F3A5F' ];
  }
  /* The location and the date share one line under the title, inside the left
     column - they must never reach the gutter, or the date sits on the pace
     figure. Returns the line already fitted, or null when there is nothing to
     draw. Four steps, in order of what costs the reader least:
       1 full spacing, 2 a tight separator, 3 shrink (tracking with it) down to
       a floor, 4 the location gives way a character at a time.
     The date is never what gets cut: it is the part a customer checks. */
  function frameSub(ctx,W,loc,dt,colW){
    loc=(loc||'').toUpperCase().replace(/\s+$/,'');
    dt=(dt||'').toUpperCase().replace(/\s+$/,'');
    if(!loc && !dt) return null;
    var sz=W*0.0165, tr=W*0.0040, floor=W*0.0128, g=0;
    var sep=(loc&&dt)?'   \u00b7   ':'';
    var txt=loc+sep+dt;
    var wide=function(t){
      ctx.font='400 '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace';
      return edtTrackedW(ctx,t,tr);
    };
    if(wide(txt)<=colW) return {t:txt,sz:sz,tr:tr};
    if(sep){ sep=' \u00b7 '; txt=loc+sep+dt;
             if(wide(txt)<=colW) return {t:txt,sz:sz,tr:tr}; }
    while(wide(txt)>colW && sz*0.97>=floor && g++<40){ sz*=0.97; tr*=0.97; }
    if(wide(txt)<=colW) return {t:txt,sz:sz,tr:tr};
    if(loc&&dt){
      var cut=loc;
      while(cut.length>1 && wide(cut+'\u2026'+sep+dt)>colW) cut=cut.slice(0,-1);
      txt=cut.replace(/[\s,]+$/,'')+'\u2026'+sep+dt;
    } else {
      var one=txt;
      while(one.length>1 && wide(one+'\u2026')>colW) one=one.slice(0,-1);
      txt=one.replace(/[\s,]+$/,'')+'\u2026';
    }
    return {t:txt,sz:sz,tr:tr};
  }
  function renderFrame(ctx,ox,oy,W,H,fillBg,showMedal){
    var mono=function(sz,wt){ return (wt||400)+' '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace'; };
    var cond=function(sz,wt){ return (wt||700)+' '+sz+'px Oswald,"Arial Narrow",sans-serif'; };
    if(fillBg){ ctx.fillStyle='#F3EFE7'; ctx.fillRect(ox,oy,W,H); }
    ctx.textBaseline='alphabetic'; ctx.textAlign='left';

    var lx=ox+FR.pad*W, mapR=lx+FR.mapW*W, rx=mapR+FR.gap*W, rr=ox+W-FR.pad*W, rw=rr-rx;
    var mt=oy+FR.mapT*H, mb=oy+FR.mapB*H;
    drawArtInto(ctx,lx,mt,mapR-lx,mb-mt);

    /* ribbon slot marks - the cut lines up on these, and the ribbon hides them */
    var zc=rx+rw/2, ty=oy+FR.tickY*H;
    ctx.strokeStyle='#8d8a85'; ctx.lineWidth=Math.max(1,W*0.0016);
    ctx.beginPath(); ctx.moveTo(zc-FR.tickW*W/2,ty); ctx.lineTo(zc-FR.tickW*W/2,ty+W*0.014); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(zc+FR.tickW*W/2,ty); ctx.lineTo(zc+FR.tickW*W/2,ty+W*0.014); ctx.stroke();

    var zd=FR.zoneD*W, zcy=oy+FR.zoneT*H+zd/2;
    if(showMedal){
      /* Drawn for the preview and the mockups, never for the print file -
         showMedal is false there, so nobody pays to have a picture of a medal
         printed behind the real one. */
      var _mc=medalCols();
      frameMedal(ctx,ox,oy,W,H,zc,zcy,FR.medalD*W/2,_mc[0],_mc[1]);
    }

    /* every x in this column goes through here, so the two alignments cannot
       drift apart - centred text is placed by its own measured width, never by
       ctx.textAlign, which edtTracked does not honour */
    var ccx=rx+rw/2;
    var put=function(w){ return FR_CENTER ? ccx-w/2 : rx; };

    var nm=frameName().toUpperCase();
    if(nm){
      var ns=W*FR.nameSz, tr=W*0.0016, gn=0;
      ctx.font=cond(ns,600);
      while(edtTrackedW(ctx,nm,tr)>rw && gn++<60){ ns*=0.96; ctx.font=cond(ns,600); }
      ctx.fillStyle='#17171A';
      edtTracked(ctx,nm,put(edtTrackedW(ctx,nm,tr)),oy+FR.nameY*H,tr);
    }

    var ry=oy+FR.ruleY*H;
    ctx.lineCap='butt';
    ctx.strokeStyle='#FF5A1F'; ctx.lineWidth=Math.max(2,W*0.0075);
    var rlx=put(FR.ruleW*W);
    ctx.beginPath(); ctx.moveTo(rlx,ry); ctx.lineTo(rlx+FR.ruleW*W,ry); ctx.stroke();
    if(!FR_CENTER){
      /* the grey tail reads as a rule only because the orange anchors its left
         end; centred it is a line trailing off the edge, so it is dropped */
      ctx.strokeStyle='#cfc9bc'; ctx.lineWidth=Math.max(1,W*0.0012);
      ctx.beginPath(); ctx.moveTo(rx+FR.ruleW*W,ry); ctx.lineTo(rr,ry); ctx.stroke();
    }

    var rows=statRows('',{time:edtTime,upper:true});
    var shown=0;
    for(var i=0;i<rows.length;i++){
      if(!rows[i][1]) continue;
      var y=oy+(FR.statT+shown*FR.statGap)*H; shown++;
      ctx.fillStyle='#8d8a85'; ctx.font=mono(W*FR.statLblSz,400);
      edtTracked(ctx,rows[i][0],put(edtTrackedW(ctx,rows[i][0],W*0.0048)),y,W*0.0048);
      ctx.fillStyle='#17171A'; ctx.font=mono(W*FR.statValSz,500);
      ctx.fillText(rows[i][1],put(ctx.measureText(rows[i][1]).width),y+W*FR.statValDrop);
    }

    var t=(edtVal('cz-title')||'Your Route').toUpperCase(), ts=W*FR.titleSz, gt=0;
    ctx.font=cond(ts,700);
    while(ctx.measureText(t).width>(mapR-lx) && gt++<80){ ts*=0.97; ctx.font=cond(ts,700); }
    ctx.fillStyle='#17171A'; ctx.fillText(t,lx,oy+FR.titleY*H);

    var sb=frameSub(ctx,W,edtVal('cz-loc'),edtDate(),mapR-lx);
    if(sb){ ctx.fillStyle='#8d8a85'; ctx.font=mono(sb.sz,400);
      edtTracked(ctx,sb.t,lx,oy+FR.locY*H,sb.tr); }

    /* A recessed edge so the insert reads as sitting behind glass rather than
       floating. Preview and mockups only - never on the print file. */
    if(showMedal){
      var iw=Math.max(2,W*0.030);
      var gT=ctx.createLinearGradient(0,oy,0,oy+iw);
      gT.addColorStop(0,'rgba(23,23,26,0.16)'); gT.addColorStop(1,'rgba(23,23,26,0)');
      ctx.fillStyle=gT; ctx.fillRect(ox,oy,W,iw);
      var gL=ctx.createLinearGradient(ox,0,ox+iw,0);
      gL.addColorStop(0,'rgba(23,23,26,0.12)'); gL.addColorStop(1,'rgba(23,23,26,0)');
      ctx.fillStyle=gL; ctx.fillRect(ox,oy,iw,H);
      var gB=ctx.createLinearGradient(0,oy+H,0,oy+H-iw*0.7);
      gB.addColorStop(0,'rgba(255,255,255,0.30)'); gB.addColorStop(1,'rgba(255,255,255,0)');
      ctx.fillStyle=gB; ctx.fillRect(ox,oy+H-iw*0.7,W,iw*0.7);
    }
  }
  function renderEditorial(ctx,ox,oy,W,H,fillBg){
    var mono=function(sz,wt){ return (wt||400)+' '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace'; };
    var cond=function(sz,wt){ return (wt||700)+' '+sz+'px Oswald,"Arial Narrow",sans-serif'; };
    if(fillBg){ ctx.fillStyle='#F3EFE7'; ctx.fillRect(ox,oy,W,H); }
    var lx=ox+EDT.mL*W, rx=ox+EDT.mR*W, cw=rx-lx;

    ctx.textBaseline='alphabetic'; ctx.textAlign='left';

    var dt=edtDate(), nm2=dsName(), dtw=0;
    if(dt){ ctx.fillStyle='#17171A'; ctx.font=mono(W*0.0215,500);
            edtTracked(ctx,dt,lx,oy+H*EDT.dateY,W*0.0042);
            dtw=edtTrackedW(ctx,dt,W*0.0042); }
    if(nm2){
      var avail=cw-dtw-W*0.04, nsz=W*0.0300, ntr=W*0.0038, ng=0;
      ctx.font=mono(nsz,700);
      while(edtTrackedW(ctx,nm2,ntr)>avail && nsz>4 && ng++<60){
        nsz*=0.95; ntr*=0.95; ctx.font=mono(nsz,700);
      }
      ctx.fillStyle='#17171A';
      edtTracked(ctx,nm2,rx-edtTrackedW(ctx,nm2,ntr),oy+H*EDT.dateY,ntr);
    }
    ctx.strokeStyle='#cfc9bc'; ctx.lineWidth=Math.max(1,W*0.0012);
    ctx.beginPath(); ctx.moveTo(lx,oy+H*EDT.ruleY); ctx.lineTo(rx,oy+H*EDT.ruleY); ctx.stroke();

    var raw=(edtVal('cz-title')||'Your Route').toUpperCase();
    var lines=raw.split(',').map(function(t){ return t.trim(); }).filter(Boolean);
    if(!lines.length) lines=['YOUR ROUTE'];
    if(lines.length>3) lines=lines.slice(0,3);
    var ts=H*EDT.titleSize, guard=0;
    ctx.font=cond(ts,700);
    while(guard++<80){
      var over=false,q;
      for(q=0;q<lines.length;q++){ if(ctx.measureText(lines[q]).width>cw){ over=true; break; } }
      if(!over) break;
      ts*=0.97; ctx.font=cond(ts,700);
    }
    var tFirst=EDT.titleLast-(lines.length-1)*EDT.titleLead;

    var rib=ribbonOn(), ribH=rib?(H*EDT.ribbonH):0, ribGap=rib?(H*EDT.ribbonGap):0;
    var mt=oy+H*EDT.mapT, mb=oy+H*(tFirst-EDT.mapGap)-ribH-ribGap-(rib?relayRibExtra(W):0), mh=mb-mt;
    drawArtInto(ctx,lx,mt,cw,mh);

    if(rib) drawRibbon(ctx,lx,rx,mb+ribGap,ribH,W);

    ctx.fillStyle='#17171A'; ctx.textAlign='left'; ctx.font=cond(ts,700);
    for(var n=0;n<lines.length;n++) ctx.fillText(lines[n],lx,oy+H*(tFirst+n*EDT.titleLead));

    var loc=(edtVal('cz-loc')||'').toUpperCase();
    if(loc){ ctx.fillStyle='#8d8a85'; ctx.font=mono(W*0.0235,400); edtTracked(ctx,loc,lx,oy+H*EDT.locY,W*0.0088); }

    ctx.lineWidth=Math.max(2,W*0.0032); ctx.lineCap='butt';
    ctx.strokeStyle='#FF5A1F';
    ctx.beginPath(); ctx.moveTo(lx,oy+H*EDT.divY); ctx.lineTo(ox+EDT.divSplit*W,oy+H*EDT.divY); ctx.stroke();
    ctx.strokeStyle='#d8d3c8'; ctx.lineWidth=Math.max(1,W*0.0012);
    ctx.beginPath(); ctx.moveTo(ox+EDT.divSplit*W,oy+H*EDT.divY); ctx.lineTo(rx,oy+H*EDT.divY); ctx.stroke();

    var _sr3=statRows('',{time:edtTime,upper:true});
    var labels=_sr3.map(function(r){ return r[0]; }), values=_sr3.map(function(r){ return r[1]; });
    /* Columns start at fixed positions, so each one's room is the gap to the
       next start - or to the right margin for the last. Without this a value
       like "100.00 KM" runs straight into TIME. */
    var colEnd=[EDT.colX[1],EDT.colX[2],EDT.mR], GUT=W*0.022;
    for(var i2=0;i2<3;i2++){
      if(!values[i2]) continue;
      var sx=ox+EDT.colX[i2]*W, room=(colEnd[i2]-EDT.colX[i2])*W-GUT;
      var lp=W*0.0168, lt=W*0.0080;
      ctx.font=mono(lp,400);
      var lw=edtTrackedW(ctx,labels[i2],lt);
      if(lw>room){ var lr=room/lw; lp*=lr; lt*=lr; ctx.font=mono(lp,400); }
      ctx.fillStyle='#8d8a85';
      edtTracked(ctx,labels[i2],sx,oy+H*EDT.labY,lt);
      var vp=W*0.0405, vt=W*0.0016;
      ctx.font=mono(vp,500);
      var vw=edtTrackedW(ctx,values[i2],vt);
      if(vw>room){ var vr=room/vw; vp*=vr; vt*=vr; ctx.font=mono(vp,500); }
      ctx.fillStyle='#17171A';
      edtTracked(ctx,values[i2],sx,oy+H*EDT.valY,vt);
    }
  }


  function studioBuild(){
    if(!STUDIO) return;
    var wrap=document.createElement('div');
    wrap.id='cz-studio';
    wrap.style.cssText='margin:18px 0;padding:16px;border:2px solid #FF5A1F;border-radius:12px;background:#fff8f4;font:13px/1.6 ui-monospace,Menlo,monospace';
    wrap.innerHTML=''
      +'<div style="font-weight:800;letter-spacing:.08em;text-transform:uppercase;margin-bottom:10px">Asset studio &middot; private</div>'
      +'<div style="margin-bottom:9px">Design <select id="cz-stD"><option value="">Base</option><option value="editorial">Editorial</option><option value="photo-split">Route &amp; Photo</option></select>'
      +' &nbsp; Style <select id="cz-stS"><option value="neon">Neon</option><option value="heat">Elevation</option><option value="map">Map</option><option value="terrain">Terrain</option></select>'
      +' &nbsp; Scale <select id="cz-stX"><option value="1">1x</option><option value="2" selected>2x</option><option value="3">3x</option></select></div>'
      +'<div><button type="button" id="cz-stApply">Apply</button> '
      +'<button type="button" id="cz-stOne">Download current</button> '
      +'<button type="button" id="cz-stAll">Download all combos</button></div>'
      +'<div id="cz-stMsg" style="margin-top:9px;color:#8a5a12"></div>';
    root.appendChild(wrap);
    var msg=function(t){ var m=document.getElementById('cz-stMsg'); if(m) m.textContent=t||''; };
    function setDesign(kind){
      DESIGN_KIND = kind || '';
      IS_SPLIT = (DESIGN_KIND === 'photo-split');
      IS_EDT   = (DESIGN_KIND === 'editorial');
      IS_TD    = (DESIGN_KIND === 'terrain');
      IS_PO    = (DESIGN_KIND === 'photo-overlay');
      IS_GAL   = (DESIGN_KIND === 'gallery');
      kindAttr();
    }
    function exportNow(tag){
      var d=dims(), x=parseInt(document.getElementById('cz-stX').value,10)||1;
      var cv=document.createElement('canvas');
      cv.width=d[0]*x; cv.height=d[1]*x;
      paint(cv.getContext('2d'), cv.width, cv.height);
      try{
        cv.toBlob(function(b){
          if(!b){ msg('Export failed - canvas may be tainted by a map tile.'); return; }
          var el=$('cz-title'), t=((el&&el.value)||'route').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
          var a=document.createElement('a');
          a.href=URL.createObjectURL(b);
          a.download=t+'-'+tag+'-'+cv.width+'x'+cv.height+'.png';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function(){ URL.revokeObjectURL(a.href); },3000);
        },'image/png');
      }catch(e){ msg('Export failed: '+((e&&e.message)||e)); }
    }
    document.getElementById('cz-stApply').onclick=function(){
      setDesign(document.getElementById('cz-stD').value);
      refreshStyles();
      selectStyle(document.getElementById('cz-stS').value);
      msg('Applied. Give map or terrain a moment to fetch, then download.');
    };
    document.getElementById('cz-stOne').onclick=function(){
      exportNow((DESIGN_KIND||'base')+'-'+state.style);
    };
    document.getElementById('cz-stAll').onclick=function(){
      var kinds=['','editorial','photo-split','terrain','photo-overlay','gallery'], styles=['neon','heat','map','terrain'], jobs=[];
      kinds.forEach(function(k){ styles.forEach(function(st){ jobs.push([k,st]); }); });
      var i=0;
      msg('Rendering '+jobs.length+' combinations...');
      (function step(){
        if(i>=jobs.length){ msg('Done - '+jobs.length+' files.'); return; }
        var j=jobs[i++];
        setDesign(j[0]); refreshStyles(); selectStyle(j[1]);
        msg('('+i+'/'+jobs.length+') '+(j[0]||'base')+' / '+j[1]);
        setTimeout(function(){ exportNow((j[0]||'base')+'-'+j[1]); setTimeout(step,900); },1500);
      })();
    };
  }

  /* Terrain edge to edge with the type over scrims. The route is already in
     the image - paintTerrain strokes it, and the static map bakes it in via
     the geometry parameter - so nothing draws it again here. */
  function renderTerrainDesign(ctx,ox,oy,W,H,fillBg){
    var U=Math.min(W,H), k=(state.product==='tee')?1.12:1;
    var mL=ox+W*0.085, colW=W*0.83, track=0.05;

    ctx.fillStyle='#101216'; ctx.fillRect(ox,oy,W,H);
    var im = (isMapLike(state.style) && state.mapImg) ? state.mapImg : null;
    if(im){
      /* Crop the attribution strip off the static map before covering with it,
         the same way renderDesign does; drawAttrib re-adds it as live text. */
      var cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035);
      var sw=im.width, sh=im.height-cropB;
      var s=Math.max(W/sw, H/sh), dw=sw*s, dh=sh*s;
      ctx.save(); ctx.beginPath(); ctx.rect(ox,oy,W,H); ctx.clip();
      ctx.drawImage(im,0,0,sw,sh, ox+(W-dw)/2, oy+(H-dh)/2, dw, dh);
      ctx.restore();
    } else if(state.mask && state.bbox){
      var col=colourised(), bb=state.bbox;
      var s2=Math.min(W*0.78/bb.w, H*0.52/bb.h), dw2=bb.w*s2, dh2=bb.h*s2;
      ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h, ox+(W-dw2)/2, oy+H*0.30-dh2/2, dw2, dh2);
    }
    if(noRoute()) drawRoutePrompt(ctx, ox+W*0.11, oy+H*0.13, W*0.78, H*0.36, true);

    /* Scrims set from measurement, not taste. The brightest terrain in the
       bottom band is L239, so bare white on it is 1.15:1. At 0.58 the same
       white is 5.4:1 - past the 4.5 small-text threshold - while leaving the
       terrain far more visible than the 0.93 this started at. The type also
       carries a soft shadow, which buys legibility over busy ground without
       darkening the image any further. */
    var gb=ctx.createLinearGradient(0,oy+H*0.44,0,oy+H);
    gb.addColorStop(0,'rgba(8,9,12,0)'); gb.addColorStop(0.42,'rgba(8,9,12,0.28)');
    gb.addColorStop(1,'rgba(8,9,12,0.58)');
    ctx.fillStyle=gb; ctx.fillRect(ox,oy+H*0.44,W,H*0.56);
    var gt=ctx.createLinearGradient(0,oy,0,oy+H*0.20);
    gt.addColorStop(0,'rgba(8,9,12,0.48)'); gt.addColorStop(1,'rgba(8,9,12,0)');
    ctx.fillStyle=gt; ctx.fillRect(ox,oy,W,H*0.20);
    function shadowOn(){ ctx.shadowColor='rgba(6,7,10,0.55)'; ctx.shadowBlur=U*0.014; ctx.shadowOffsetY=U*0.002; }
    function shadowOff(){ ctx.shadowColor='transparent'; ctx.shadowBlur=0; ctx.shadowOffsetY=0; }

    var topY=oy+H*0.072;
    ctx.textBaseline='alphabetic';
    shadowOn();
    ctx.font='600 '+(U*0.019)+'px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,0.90)';
    var _d=dsDate(), _n=dsName(), _dw=0;
    if(_d){ ctx.textAlign='left';  ctx.fillText(spaced(_d,0.14), mL, topY);
            _dw=ctx.measureText(spaced(_d,0.14)).width; }
    if(_n){
      var _av=(ox+W-W*0.085)-(mL+_dw)-W*0.04;
      var _ns=dsFit(ctx,'700 %spx Inter,sans-serif',_n,0.06,_av,U*0.030);
      ctx.font='700 '+_ns+'px Inter,sans-serif';
      ctx.textAlign='right'; ctx.fillText(spaced(_n,0.06), ox+W-W*0.085, topY);
    }
    ctx.strokeStyle='rgba(255,255,255,0.34)'; ctx.lineWidth=Math.max(1,U*0.0009);
    ctx.beginPath(); ctx.moveTo(mL,topY+H*0.020); ctx.lineTo(ox+W-W*0.085,topY+H*0.020); ctx.stroke();
    shadowOff();
    /* Scale bar and north arrow (22 Oct pm), under the rule at the right,
       where nothing else of the design sits. The terrain is cover-fitted, so
       its metres-per-pixel is divided by the fit. */
    if(im && im._mpp>0 && state.style==='terrain' && typeof kmOn==='function' && kmOn()){
      var _cu=U*0.022, _cfit=Math.max(W/im.width, H/im.height), _cy=topY+H*0.020+_cu*2.9, _rx=ox+W-W*0.085;
      drawMapCues(ctx,{mpp:im._mpp/_cfit, u:_cu, ink:'rgba(255,255,255,0.92)', halo:'rgba(6,7,10,0.75)', font:'Inter,sans-serif',
        north:[_rx-_cu*0.6,_cy], bar:[_rx-_cu*2.4,_cy,W*0.22,'right']});
    }

    var title=(($('cz-title')&&$('cz-title').value.trim())||'My Milestone').toUpperCase();
    var loc=(($('cz-loc')&&$('cz-loc').value)||'').toUpperCase();
    /* Same three stats as the rest of the range. Elevation gain would suit a
       terrain design better, but there is no field for it and deriving it from
       GPS elevation is noisy enough to print a wrong number on a paid poster. */
    var stats=statRows('')
      .filter(function(s){return s[1]&&(''+s[1]).trim();});
    var lay=dsTitle(ctx,title,U*0.092*k,colW,2,track,U*0.048);
    var lines=lay.lines, fs=lay.fs, lineH=fs*1.05;
    var locFs=U*0.024*k, labFs=U*0.019*k, valFs=U*0.040*k;
    var labBase=oy+H-H*0.062, valBase=labBase-labFs-H*0.014;
    if(!stats.length){ valBase=labBase; }
    var locBase=(stats.length?valBase-valFs-H*0.030:labBase);
    var titleBase=locBase-(loc?locFs+H*0.022:H*0.004);

    ctx.textAlign='left'; shadowOn();
    ctx.font='800 '+fs+'px Inter,sans-serif'; ctx.fillStyle='#FFFFFF';
    for(var li=0; li<lines.length; li++)
      ctx.fillText(spaced(lines[li],track), mL, titleBase-(lines.length-1-li)*lineH);
    if(loc){ ctx.font='600 '+locFs+'px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,0.86)';
      ctx.fillText(spaced(loc,0.18), mL, locBase); }
    if(stats.length){
      /* Same measure-then-shrink the other designs use; without it a long
         distance overlaps the next column. */
      var cw=colW/stats.length, avail=cw*0.90, mv=0, ml=0;
      ctx.font='800 '+valFs+'px Inter,sans-serif';
      stats.forEach(function(s){ mv=Math.max(mv,ctx.measureText((''+s[1]).toUpperCase()).width); });
      if(mv>avail) valFs*=avail/mv;
      ctx.font='600 '+labFs+'px Inter,sans-serif';
      stats.forEach(function(s){ ml=Math.max(ml,ctx.measureText(spaced(s[0],0.1)).width); });
      if(ml>avail) labFs*=avail/ml;
      stats.forEach(function(s,i){ var x=mL+cw*i;
        ctx.font='600 '+labFs+'px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,0.86)';
        ctx.fillText(spaced(s[0],0.1), x, labBase);
        ctx.font='800 '+valFs+'px Inter,sans-serif'; ctx.fillStyle='#FFFFFF';
        ctx.fillText((''+s[1]).toUpperCase(), x, valBase); });
    }
    shadowOff();
  }

  /* Block placement, as a fraction of the tile so it survives a product
     switch, plus its own scale. */
  var poOff={x:0.50, y:0.72}, poScale=1.0, poRot=0, poRect=null;
  /* Which element a drag moves. Explicit, because leaving it to wherever the
     finger landed meant the photo and the text fought each other with nothing
     on screen to say which would win. */
  var poSel='text';

  function renderPhotoOverlay(ctx,ox,oy,W,H,fillBg){
    var U=Math.min(W,H), k=(state.product==='tee')?1.12:1;

    /* Photo fills the tile, positioned by the same offset the split design
       uses, so drag-to-reposition behaves identically. */
    if(splitPhotoLoading){
      ctx.fillStyle='#2a2a30'; ctx.fillRect(ox,oy,W,H);
      ctx.textAlign='center'; ctx.fillStyle='#e8e4dc';
      ctx.font='600 '+(U*0.045)+'px Inter,sans-serif';
      ctx.fillText('Loading photo\u2026', ox+W/2, oy+H/2);
      poRect=null; return;
    }
    if(splitPhoto){
      var ir=splitPhoto.width/splitPhoto.height, br=W/H, sw,sh,sx,sy;
      if(ir>br){ sh=splitPhoto.height; sw=sh*br; sy=0; sx=(splitPhoto.width-sw)*splitPhotoOff.x; }
      else { sw=splitPhoto.width; sh=sw/br; sx=0; sy=(splitPhoto.height-sh)*splitPhotoOff.y; }
      ctx.save(); ctx.beginPath(); ctx.rect(ox,oy,W,H); ctx.clip();
      ctx.drawImage(splitPhoto, sx,sy,sw,sh, ox,oy,W,H);
      ctx.restore();
    } else {
      ctx.fillStyle='#3a3a40'; ctx.fillRect(ox,oy,W,H);
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,0.35)';
      ctx.setLineDash([U*0.02,U*0.02]); ctx.lineWidth=Math.max(2,U*0.006);
      ctx.strokeRect(ox+W*0.04,oy+H*0.04,W*0.92,H*0.92); ctx.restore();
      ctx.textAlign='center'; ctx.fillStyle='#f0ede6';
      ctx.font='700 '+(U*0.055)+'px Inter,sans-serif';
      ctx.fillText('+  ADD YOUR PHOTO', ox+W/2, oy+H/2-U*0.005);
      ctx.font='500 '+(U*0.03)+'px Inter,sans-serif'; ctx.fillStyle='#c9c6bf';
      ctx.fillText('tap here to upload', ox+W/2, oy+H/2+U*0.05);
      splitChipRect=null;
    }

    /* ---- measure the block ---- */
    var track=0.04, sc=poScale;
    var title=(($('cz-title')&&$('cz-title').value.trim())||'My Milestone').toUpperCase();
    var loc=(($('cz-loc')&&$('cz-loc').value)||'').toUpperCase();
    var poDt=monDate();
    var locLine=locDateLine();
    var st=statRows('')
      .filter(function(s){return s[1]&&(''+s[1]).trim();});
    var bw=U*0.46*sc*k;
    var valFs=U*0.034*sc*k, labFs=U*0.0135*sc*k, locFs=U*0.017*sc*k;
    var titleFs=U*0.060*sc*k, floor=valFs*1.25;
    ctx.font='800 '+titleFs+'px Inter,sans-serif';
    while(ctx.measureText(spaced(title,track)).width>bw && titleFs>floor){
      titleFs*=0.97; ctx.font='800 '+titleFs+'px Inter,sans-serif';
    }
    ctx.font='800 '+titleFs+'px Inter,sans-serif';
    var tw=ctx.measureText(spaced(title,track)).width, maxBw=Math.min(U*0.86, W-U*0.10);
    if(tw>bw) bw=Math.min(maxBw, tw);
    ctx.font='800 '+titleFs+'px Inter,sans-serif';
    while(ctx.measureText(spaced(title,track)).width>bw && titleFs>U*0.020*sc){
      titleFs*=0.97; ctx.font='800 '+titleFs+'px Inter,sans-serif';
    }
    /* The title stays the largest thing in the block. */
    if(valFs>titleFs*0.80) valFs=titleFs*0.80;
    if(labFs>valFs*0.55) labFs=valFs*0.55;
    /* location alone always fitted; location + date need not, so shrink it */
    if(locLine){
      ctx.font='600 '+locFs+'px Inter,sans-serif';
      while(ctx.measureText(spaced(locLine,0.18)).width>bw && locFs>U*0.010*sc){
        locFs*=0.96; ctx.font='600 '+locFs+'px Inter,sans-serif';
      }
    }

    var stacked=false;
    if(st.length){
      ctx.font='800 '+valFs+'px Inter,sans-serif';
      var widest=0;
      st.forEach(function(x){ widest=Math.max(widest,ctx.measureText((''+x[1]).toUpperCase()).width); });
      stacked = widest > (bw/st.length)*0.88;
    }

    /* Gaps scale with the type, not the block width - a long title widens the
       block on its own and width-derived gaps then drift out of step. */
    var routeH=U*0.15*sc, gRoute=U*0.026*sc, gLoc=U*0.011*sc,
        gStats=U*0.030*sc, gStack=U*0.020*sc;
    var hh=routeH+gRoute+titleFs*0.80;
    if(locLine) hh+=titleFs*0.22+gLoc+locFs;
    if(st.length){
      if(stacked) st.forEach(function(_,i){ hh+=(i===0?gStats:gStack)+valFs*0.80+valFs*0.26+labFs*1.05; });
      else hh+=gStats+valFs*0.80+valFs*0.26+labFs*1.05;
    }
    hh+=labFs*0.30;

    var bx=ox+poOff.x*W-bw/2, by=oy+poOff.y*H-hh/2;
    bx=Math.max(ox+U*0.04, Math.min(ox+W-bw-U*0.04, bx));
    by=Math.max(oy+U*0.04, Math.min(oy+H-hh-U*0.04, by));

    /* Pick light or dark from what is actually under the block. A photo can be
       anything, so this is sampled rather than assumed. */
    var darkBG=true;
    try{
      var pd=ctx.getImageData(Math.max(0,bx|0),Math.max(0,by|0),
        Math.max(1,Math.min(W-1,bw|0)),Math.max(1,Math.min(H-1,hh|0))).data;
      var sum=0,n=0;
      for(var q=0;q<pd.length;q+=64){ sum+=0.2126*pd[q]+0.7152*pd[q+1]+0.0722*pd[q+2]; n++; }
      if(n) darkBG=(sum/n)<140;
    }catch(e){}
    var ink=darkBG?'#FFFFFF':'#17171A';
    var sub=darkBG?'rgba(255,255,255,.82)':'rgba(23,23,26,.66)';

    /* Soft scrim: on a busy photo no single text colour works, because the
       mean can be mid-grey while individual pixels run 10 to 245. */
    var cxm=bx+bw/2, cym=by+hh/2, rad=Math.max(bw,hh)*0.85;
    /* Radial, so rotation does not change it - no transform needed here. */
    var gr=ctx.createRadialGradient(cxm,cym,0,cxm,cym,rad);
    if(darkBG){ gr.addColorStop(0,'rgba(8,9,12,0.70)'); gr.addColorStop(0.65,'rgba(8,9,12,0.40)'); gr.addColorStop(1,'rgba(8,9,12,0)'); }
    else { gr.addColorStop(0,'rgba(245,242,235,0.82)'); gr.addColorStop(0.65,'rgba(245,242,235,0.48)'); gr.addColorStop(1,'rgba(245,242,235,0)'); }
    ctx.save(); ctx.beginPath(); ctx.rect(ox,oy,W,H); ctx.clip();
    ctx.fillStyle=gr; ctx.fillRect(cxm-rad,cym-rad,rad*2,rad*2); ctx.restore();

    /* ---- paint the block, centred ---- */
    var cx=bx+bw/2, yy=by;
    /* Rotate about the block's centre, so the scrim and the type turn together
       and the layout maths below stays in unrotated coordinates. */
    var rot=poRot||0;
    if(rot){ ctx.save(); ctx.translate(bx+bw/2, by+hh/2); ctx.rotate(rot);
             ctx.translate(-(bx+bw/2), -(by+hh/2)); }
    ctx.textAlign='center'; ctx.textBaseline='alphabetic';
    if(state.mask&&state.bbox){
      var col=colourised(), bb=state.bbox;
      var rs=Math.min(bw*0.62/bb.w, routeH/bb.h), dw=bb.w*rs, dh=bb.h*rs;
      ctx.save(); ctx.shadowColor='rgba(0,0,0,0.45)'; ctx.shadowBlur=U*0.010*sc;
      ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h, cx-dw/2, yy+(routeH-dh)/2, dw,dh);
      ctx.restore();
    } else if(noRoute()){
      drawRoutePrompt(ctx, cx-bw*0.36, yy, bw*0.72, routeH, darkBG);
    }
    yy+=routeH+gRoute+titleFs*0.80;
    ctx.save();
    ctx.shadowColor=darkBG?'rgba(6,7,10,0.55)':'rgba(255,255,255,0.45)';
    ctx.shadowBlur=U*0.012*sc;
    ctx.font='800 '+titleFs+'px Inter,sans-serif'; ctx.fillStyle=ink;
    ctx.fillText(spaced(title,track),cx,yy);
    if(locLine){ yy+=titleFs*0.22+gLoc+locFs;
      ctx.font='600 '+locFs+'px Inter,sans-serif'; ctx.fillStyle=sub;
      ctx.fillText(spaced(locLine,0.18),cx,yy); }
    if(st.length){
      if(stacked){
        st.forEach(function(s,i){
          yy+=(i===0?gStats:gStack)+valFs*0.80;
          ctx.font='800 '+valFs+'px Inter,sans-serif'; ctx.fillStyle=ink;
          ctx.fillText((''+s[1]).toUpperCase(),cx,yy);
          yy+=valFs*0.26+labFs*1.05;
          ctx.font='600 '+labFs+'px Inter,sans-serif'; ctx.fillStyle=sub;
          ctx.fillText(spaced(s[0],0.12),cx,yy);
        });
      } else {
        yy+=gStats+valFs*0.80;
        var cw=bw/st.length, avail=cw*0.90, vF=valFs, lF=labFs, mv=0, ml=0;
        ctx.font='800 '+vF+'px Inter,sans-serif';
        st.forEach(function(s){ mv=Math.max(mv,ctx.measureText((''+s[1]).toUpperCase()).width); });
        if(mv>avail) vF*=avail/mv;
        ctx.font='600 '+lF+'px Inter,sans-serif';
        st.forEach(function(s){ ml=Math.max(ml,ctx.measureText(spaced(s[0],0.12)).width); });
        if(ml>avail) lF*=avail/ml;
        st.forEach(function(s,i){ var sx2=bx+cw*(i+0.5);
          ctx.font='800 '+vF+'px Inter,sans-serif'; ctx.fillStyle=ink;
          ctx.fillText((''+s[1]).toUpperCase(),sx2,yy);
          ctx.font='600 '+lF+'px Inter,sans-serif'; ctx.fillStyle=sub;
          /* Clear the value's descender before the label's cap line. */
          ctx.fillText(spaced(s[0],0.12),sx2,yy+vF*0.26+lF*1.05); });
      }
    }
    ctx.restore();
    if(rot) ctx.restore();

    /* Affordances only on the on-screen hero. _splitHeroPaint is false for the
       tile that goes to Cloudinary, so none of this reaches the print. */
    if(_splitHeroPaint && splitPhoto){
      /* Show what a drag will move. Drawn before the chip so the chip stays on
         top of it. */
      if(poSel==='text'){
        ctx.save();
        if(rot){ ctx.translate(bx+bw/2, by+hh/2); ctx.rotate(rot); ctx.translate(-(bx+bw/2), -(by+hh/2)); }
        ctx.strokeStyle='rgba(255,90,31,0.95)'; ctx.lineWidth=Math.max(2,U*0.004);
        ctx.setLineDash([U*0.018,U*0.014]);
        ctx.strokeRect(bx-U*0.018,by-U*0.018,bw+U*0.036,hh+U*0.036);
        ctx.restore();
      } else {
        ctx.save(); ctx.strokeStyle='rgba(255,90,31,0.95)'; ctx.lineWidth=Math.max(3,U*0.006);
        var m=U*0.012, L=U*0.070;
        [[ox+m,oy+m,1,1],[ox+W-m,oy+m,-1,1],[ox+m,oy+H-m,1,-1],[ox+W-m,oy+H-m,-1,-1]]
          .forEach(function(c){ ctx.beginPath();
            ctx.moveTo(c[0]+L*c[2],c[1]); ctx.lineTo(c[0],c[1]); ctx.lineTo(c[0],c[1]+L*c[3]); ctx.stroke(); });
        ctx.restore();
      }
      var bW=W*0.40, bH=H*0.038, bX=ox+(W-bW)/2, bY=oy+H*0.088;
      ctx.fillStyle='rgba(255,90,31,0.92)'; roundRect(ctx,bX,bY,bW,bH,bH*0.5); ctx.fill();
      ctx.fillStyle='#fff'; ctx.textAlign='center';
      ctx.font='700 '+(H*0.020)+'px Inter,sans-serif';
      ctx.fillText(poSel==='text'?'MOVING: TEXT  \u00b7  TAP PHOTO TO SWITCH'
                                 :'MOVING: PHOTO  \u00b7  TAP TEXT TO SWITCH', ox+W/2, bY+bH*0.68);

      var chipW=W*0.40, chipH=H*0.045, chipX=ox+(W-chipW)/2, chipY=oy+H*0.035;
      ctx.fillStyle='rgba(13,13,16,0.62)'; roundRect(ctx,chipX,chipY,chipW,chipH,chipH*0.3); ctx.fill();
      ctx.fillStyle='#F2F2F4'; ctx.textAlign='center';
      ctx.font='600 '+(H*0.024)+'px Inter,sans-serif';
      ctx.fillText('CHANGE PHOTO', ox+W/2, chipY+chipH*0.68);
      ctx.fillStyle='rgba(242,242,244,0.60)'; ctx.font='500 '+(H*0.020)+'px Inter,sans-serif';
      ctx.fillText('drag the text to move it \u00b7 drag the photo to reframe', ox+W/2, oy+H-H*0.028);
      splitChipRect={x:chipX,y:chipY,w:chipW,h:chipH};
      poRect={x:bx,y:by,w:bw,h:hh};
    }
    /* poRect is deliberately NOT cleared on non-hero renders: the thumbnails
       repaint after the hero, and nulling it there left the block unhittable. */
  }

  /* ===== Stat Bar: the 5K Run's own design (23 Oct 2026, Marc) =============
     Spec: claude/statbar-design-spec.md, rev 2; reference renders in
     statbar-reference.zip. A standard street map recoloured to the
     colourway's two tones, with the route, km discs and S/F drawn on it; a
     full-width row of results; the customer's photo beside the title.
     Offered on every single sport since 25 Oct (5K Run is Stat Bar's alone:
     kindForSport); the colourways are a swatch row above the preview.
     Every measurement is a fraction of the output's width W. Spliced in by
     p_statbar.py from statbar/sb_module.js - edit this file, not the engine. */
  function sbOn(){ return (typeof DESIGN_KIND!=='undefined') && DESIGN_KIND==='statbar'; }
  /* The six colourways. `dark` decides the marker colour (bg on the dark
     three, text on the light three) and which mockup blanks the art sits on. */
  var SB_COLOURS=[
    {id:'harbour', name:'Harbour', dark:true,  bg:'#15253B', mapDark:'#2A4566', mapLight:'#E3EAF2', elevFill:'#22385A', soft:'#8FA7C6', text:'#F3EFE7', rule:'#34507A'},
    {id:'forest',  name:'Forest',  dark:true,  bg:'#1E3A2B', mapDark:'#2F5A43', mapLight:'#E6EEDF', elevFill:'#2A4D3A', soft:'#8FB79A', text:'#F3EFE7', rule:'#3E6B52'},
    {id:'charcoal',name:'Charcoal',dark:true,  bg:'#232427', mapDark:'#4A4C52', mapLight:'#ECEBE7', elevFill:'#303236', soft:'#9A9CA3', text:'#F3EFE7', rule:'#44464C'},
    {id:'sky',     name:'Sky',     dark:false, bg:'#BCD5EA', mapDark:'#2C4A6B', mapLight:'#F1F6FB', elevFill:'#A6C3DC', soft:'#3F5F80', text:'#14243A', rule:'#8EAECB'},
    {id:'lilac',   name:'Lilac',   dark:false, bg:'#CEC5E4', mapDark:'#4A3D6B', mapLight:'#F5F2FA', elevFill:'#BAB0D6', soft:'#5B4E7C', text:'#241A3A', rule:'#A79CC7'},
    {id:'blush',   name:'Blush',   dark:false, bg:'#F0CFC3', mapDark:'#6B3A30', mapLight:'#FBF1ED', elevFill:'#E3B9AA', soft:'#8A5143', text:'#3A1C16', rule:'#D7A797'}
  ];
  var SB_ACC='#FF5A1F';
  /* The route line in the customer's pick (p_routecol, 27 Oct); the
     accents stay vermilion. */
  function sbRouteHex(){ return (typeof routePick==='function' && routePick()) ? String(state.accent).toUpperCase() : SB_ACC; }
  /* The formats Stat Bar is built for (spec 2).
     formats: not frame,tee */
  var SB_FMTS={poster:1, a4print:1, magnet:1, digital:1};
  /* The map panel's aspect on every format. */
  var SB_MAP_AR=1.45;
  var sbColour=(function(){
    var c=String(getParam('colour')||getParam('color')||'').trim().toLowerCase(), i;
    for(i=0;i<SB_COLOURS.length;i++) if(SB_COLOURS[i].id===c) return c;
    return 'harbour';                 /* Marc: lead with Harbour (25 Oct) */
  })();
  function sbPal(id){
    id=id||sbColour; var i;
    for(i=0;i<SB_COLOURS.length;i++) if(SB_COLOURS[i].id===id) return SB_COLOURS[i];
    return SB_COLOURS[0];
  }
  function sbMarker(p){ p=p||sbPal(); return p.dark ? p.bg : p.text; }
  /* The tables' 'colourway' entries, resolved (KIND_GROUND, KIND_BLANK). */
  function kindGround(k){ var v=KIND_GROUND[k||'']; return v==='colourway' ? sbPal().bg : v; }
  function kindBlank(k){ var v=KIND_BLANK[k||'']; return v==='colourway' ? (sbPal().dark ? '' : 'edt_') : v; }

  /* ---- layouts (fractions of W) ------------------------------------------ */
  var SB_POSTER={ M:0.064, mapH:0.601, r0:0.695, r1:0.795, ruleW:0.002, divIn:0.18,
    labSz:0.013, labTr:0.003, labTop:0.715, valSz:0.032, valTop:0.737,
    by:0.830, phW:0.400, phH:0.520, gap:0.040,
    eleH:0.170, eleProf:0.150, eleLab:0.182, eleLabSz:0.012, eleTr:0.003, eleLw:0.002,
    tSz:0.058, t1:0.240, t1NoEle:0.020, tFloor:0.036, tagSz:0.013, tagTr:0.003, tagGap:0.023,
    nameSz:0.026, nameTop:0.470, barW:0.048, barH:0.006, barTop:0.512 };
  var SB_MAG={ M:0.050, r0:0.6975, r1:0.810, ruleW:0.0025, divIn:0.18,
    labSz:0.021, labTr:0.005, valSz:0.0425, valFloor:0.036,
    by:0.8425, phW:0.3125, gap:0.040,
    tSz:0.065, t1:-0.005, tFloor:0.040, tagSz:0.021, tagTr:0.005, tagGap:0.0285,
    nameSz:0.035, nameUp:0.0775, barW:0.055, barH:0.0075, barUp:0.025 };
  var SB_WALL={ M:0.050, mapT:0.760, mapB:1.448, r0:1.4875, r1:1.607, ruleW:0.0028, divIn:0.18,
    labSz:0.0167, labTr:0.004, valSz:0.0389,
    tTop:1.657, tSz:0.0667, tW:0.900, tagTop:1.751, tagSz:0.018, tagTr:0.004,
    nameTop:1.826, nameSz:0.0333, barTop:1.881, barW:0.061, barH:0.007, foot:1.888 };
  /* The map's drawing, as fractions of the PANEL's width (spec 6). */
  var SB_MAPDRAW={ casing:0.013, line:0.007, disc:0.013, discEdge:0.0023, discNum:0.016,
                   sf:0.018, sfEdge:0.0023, sfTxt:0.0126 };
  /* Separate S and F once the ends are this far apart, metres. */
  var SB_SF_SPLIT_M=30;

  /* ---- type ------------------------------------------------------------- */
  function sbFont(wt,sz){ return wt+' '+sz+'px Inter,sans-serif'; }
  /* PIL draws at the top of the ascender; the canvas at a baseline. Inter's
     ascender is 0.96875 em. */
  function sbAsc(ctx,sz){
    try{ var m=ctx.measureText('H'); if(m && m.fontBoundingBoxAscent>0) return m.fontBoundingBoxAscent; }catch(e){}
    return sz*0.96875;
  }
  /* Text whose TOP is at `top`, tracked by `tr` px, aligned left / center. */
  function sbText(ctx,txt,x,top,wt,sz,col,align,tr){
    ctx.font=sbFont(wt,sz); ctx.fillStyle=col; ctx.textBaseline='alphabetic'; ctx.textAlign='left';
    var by=top+sbAsc(ctx,sz), w=tr ? edtTrackedW(ctx,txt,tr) : ctx.measureText(txt).width;
    var x0=(align==='center') ? x-w/2 : x;
    if(tr) edtTracked(ctx,txt,x0,by,tr); else ctx.fillText(txt,x0,by);
    return w;
  }
  function sbWidth(ctx,txt,wt,sz,tr){ ctx.font=sbFont(wt,sz); return tr ? edtTrackedW(ctx,txt,tr) : ctx.measureText(txt).width; }

  /* ---- fields ------------------------------------------------------------- */
  function sbRunNo(){ var v=edtVal('cz-runno').replace(/[^0-9]/g,''); return v ? String(parseInt(v,10)) : ''; }
  function sbPlace(){ return edtVal('cz-place'); }
  function sbTime(){
    if(STAT_OFF.time) return '';
    var g=function(id){ var e=$(id); return e ? (+String(e.value).replace(/\D/g,'')||0) : 0; };
    var tot=g('cz-h')*3600+g('cz-m')*60+g('cz-s'); if(tot<=0) return '';
    var h=Math.floor(tot/3600), m=Math.floor((tot%3600)/60), s=tot%60, p2=function(n){ return (n<10?'0':'')+n; };
    return h>0 ? (h+':'+p2(m)+':'+p2(s)) : (m+':'+p2(s));
  }
  function sbDate(){ var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(edtVal('cz-date')); return m ? (m[3]+'.'+m[2]+'.'+m[1].slice(2)) : ''; }
  /* 5K Run: TIME, DATE, RUN, PLACE. Every other sport: Gallery's stats
     (statRows - distance, time, pace or speed, gain ...) then DATE (25 Oct,
     Marc: "inputs including stats are the same as gallery"). An empty one
     drops out and the rest share. */
  function sbCells(){
    var r=sbRunNo(), d=sbDate(), cs;
    if(SPORT==='run5k') cs=[['TIME',sbTime()],['DATE',d],['RUN',r?('#'+r):''],['PLACE',sbPlace()]];
    else cs=statRows('',{upper:true, time:sbTime}).map(function(c){ return [c[0],String(c[1]).toUpperCase()]; }).concat([['DATE',d]]);
    return cs
      .filter(function(c){ return c[1] && String(c[1]).trim(); });
  }
  /* The route's typed distance, km; the measured length when none is typed. */
  function sbKm(){
    var k=distKm(''); if(k>0) return _isMi('') ? k*1.609344 : k;
    return (state.coords && state.coords.length>1) ? routeKm(state.coords) : 0;
  }
  /* The title, in coloured runs: a trailing distance token ("5K") in the
     accent. Two lines, broken before the word in front of the token. */
  function sbTitleParts(){
    var raw=(edtVal('cz-title')||'My Milestone').toUpperCase().replace(/\s+/g,' ').trim();
    var m=/^(.*?)\s*(\d+(?:\.\d+)?\s?K)$/.exec(raw);
    var head=m ? m[1].trim() : raw, tok=m ? m[2].replace(/\s/g,'') : '';
    return {head:head, tok:tok, raw:raw};
  }
  /* Lines as arrays of [text, accent?] runs. one=true: a single line. */
  function sbTitleLines(one){
    var T=sbTitleParts(), w=T.head ? T.head.split(' ') : [];
    if(one) return [[[T.head+(T.tok&&T.head?' ':''),false]].concat(T.tok?[[T.tok,true]]:[])];
    if(T.tok){
      if(w.length<2) return [[[T.head+(T.head?' ':''),false],[T.tok,true]]];
      return [[[w.slice(0,-1).join(' '),false]], [[w[w.length-1]+' ',false],[T.tok,true]]];
    }
    if(w.length<2) return [[[T.head,false]]];
    return [[[w.slice(0,-1).join(' '),false]], [[w[w.length-1],false]]];
  }
  function sbLineW(ctx,line,sz){ ctx.font=sbFont(900,sz); var w=0; line.forEach(function(r){ w+=ctx.measureText(r[0]).width; }); return w; }
  /* Shrink to fit `avail`, down to `floor`; past the floor, wrap the first
     line's words onto lines of their own. Returns {lines, sz}. */
  function sbFitTitle(ctx,avail,sz,floor){
    var lines=sbTitleLines(false), mx=function(L,s){ var a=0; L.forEach(function(l){ a=Math.max(a,sbLineW(ctx,l,s)); }); return a; }, g=0;
    while(mx(lines,sz)>avail && sz>floor && g++<80) sz=Math.max(floor,sz*0.97);
    if(mx(lines,sz)<=avail) return {lines:lines, sz:sz};
    var words=[], rest=lines.slice(1);
    lines[0].forEach(function(r){ r[0].split(' ').forEach(function(t){ if(t) words.push([t,r[1]]); }); });
    var out=[], cur=[];
    words.forEach(function(wd){
      var tryL=cur.length ? cur.concat([[' ',false],wd]) : [wd];
      if(cur.length && sbLineW(ctx,tryL,sz)>avail){ out.push(cur); cur=[wd]; } else cur=tryL;
    });
    if(cur.length) out.push(cur);
    return {lines:out.concat(rest), sz:sz};
  }
  function sbDrawLine(ctx,line,x,top,sz,pal,align){
    ctx.font=sbFont(900,sz); ctx.textBaseline='alphabetic'; ctx.textAlign='left';
    var w=sbLineW(ctx,line,sz), cx=(align==='center') ? x-w/2 : x, by=top+sbAsc(ctx,sz);
    line.forEach(function(r){ ctx.fillStyle=r[1] ? SB_ACC : pal.text; ctx.fillText(r[0],cx,by); cx+=ctx.measureText(r[0]).width; });
  }

  /* ---- the map ------------------------------------------------------------ */
  function sbArea(){
    var c=state.coords; if(!c || c.length<2) return null;
    var a=Infinity,b=-Infinity,d=Infinity,e=-Infinity,i;
    for(i=0;i<c.length;i++){ var la=c[i][0], lo=c[i][1]; if(!isFinite(la)||!isFinite(lo)) continue;
      if(la<a)a=la; if(la>b)b=la; if(lo<d)d=lo; if(lo>e)e=lo; }
    if(!isFinite(a)) return null;
    /* about 4% of padding, then out to the panel's aspect, centred */
    var pLa=Math.max((b-a)*0.04,0.0002), pLo=Math.max((e-d)*0.04,0.0002);
    return galPadArea(d-pLo, a-pLa, e+pLo, b+pLa, SB_MAP_AR);
  }
  /* The standard style, no route and no markers: they are drawn here. */
  function sbMapUrl(sf,h){
    var A=sbArea(); if(!A || !MAPKEY) return '';
    var area='rect:'+A[0].toFixed(6)+','+A[1].toFixed(6)+','+A[2].toFixed(6)+','+A[3].toFixed(6);
    return 'https://maps.geoapify.com/v1/staticmap?style=osm-bright&width=1000&height='+(h||Math.round(1000/SB_MAP_AR))+
           '&format=png&area='+encodeURIComponent(area)+(sf>1?('&scaleFactor='+sf):'')+'&apiKey='+MAPKEY;
  }
  /* The page's map key. Deliberately not the URL: no 'geoapify' in it, so
     the static-map machinery (the 2x refetch, the route-free copy for the
     reel, geoPts) leaves this map alone - it has none of those problems. */
  function sbKey(){ var A=sbArea(); return (A && MAPKEY) ? ('statbar|'+A.map(function(v){ return v.toFixed(6); }).join(',')) : ''; }
  /* Web Mercator, covering fit of the area into a W x H image - the fit the
     tile mosaic is drawn in (relayTileMap), and Geoapify's own. */
  function sbProj(u,W,H){
    var m=/rect%3A([-\d.]+)%2C([-\d.]+)%2C([-\d.]+)%2C([-\d.]+)/.exec(u)||/rect:([-\d.]+),([-\d.]+),([-\d.]+),([-\d.]+)/.exec(u);
    if(!m) return null;
    var mx=function(lo){ return (lo+180)/360; };
    var my=function(la){ var r=la*Math.PI/180; return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2; };
    var X0=mx(+m[1]), X1=mx(+m[3]), Yn=my(+m[4]), Ys=my(+m[2]);
    var k=Math.max(W/Math.max(1e-12,X1-X0), H/Math.max(1e-12,Ys-Yn)), cx=(X0+X1)/2, cy=(Yn+Ys)/2;
    return {wx0:cx-W/2/k, wy0:cy-H/2/k, k:k, mx:mx, my:my};
  }
  /* Tiles first (exact projection); the static map if they are refused. */
  function sbLoadMap(sf,cb){
    var u=sbMapUrl(sf); if(!u){ cb(null); return; }
    relayTileMap(u,function(cv){
      if(cv){ cv._sbProj=sbProj(u,cv.width,cv.height); cv._sbCrop=0; cv._sbFor=sbKey(); cb(cv); return; }
      var hg=Math.round(1000/(SB_MAP_AR*0.965)), u2=sbMapUrl(sf,hg), im=new Image();
      im.crossOrigin='anonymous';
      im.onload=function(){ im._sbProj=sbProj(u2,im.naturalWidth||im.width,im.naturalHeight||im.height);
                            im._sbCrop=0.035; im._sbFor=sbKey(); cb(im); };
      im.onerror=function(){ cb(null); };
      im.src=u2;
    });
  }
  function sbHiWanted(){
    return !!(sbOn() && MAPKEY && state.mapImg && state.mapUrl && state.mapUrl.indexOf('statbar|')===0 &&
              state.mapHiFor!==state.mapUrl);
  }
  /* The print map, before any file is built from it. */
  function sbEnsureHi(cb){
    var u=state.mapUrl, done=false, fin=function(){ if(!done){ done=true; cb(); } };
    var t=setTimeout(fin, MAP_HI_WAIT);
    sbLoadMap(MAP_HI_SF,function(cv){
      clearTimeout(t); if(done) return;
      if(cv && state.mapUrl===u && sbOn()){ state.mapImg=cv; state.mapHiFor=u; }
      else state.mapHiFor=u;     /* tried; do not ask again for this map */
      fin();
    });
  }
  /* The duotone: L = .299R+.587G+.114B, t = clamp((L-120)/125), mapDark to
     mapLight. Cached on the image, per colourway. */
  function sbDuo(im,pal){
    var c=im._sbDuo||(im._sbDuo={});
    if(c[pal.id]) return c[pal.id];
    var w=im.naturalWidth||im.width, h=im.naturalHeight||im.height;
    var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
    var x=cv.getContext('2d',{willReadFrequently:true}); x.drawImage(im,0,0);
    var hx=function(s){ return [parseInt(s.substr(1,2),16),parseInt(s.substr(3,2),16),parseInt(s.substr(5,2),16)]; };
    var D=hx(pal.mapDark), Lt=hx(pal.mapLight);
    try{
      var id=x.getImageData(0,0,w,h), d=id.data, i, L, t;
      for(i=0;i<d.length;i+=4){
        L=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2];
        t=(L-120)/125; t=t<0?0:(t>1?1:t);
        d[i]=D[0]+(Lt[0]-D[0])*t; d[i+1]=D[1]+(Lt[1]-D[1])*t; d[i+2]=D[2]+(Lt[2]-D[2])*t; d[i+3]=255;
      }
      x.putImageData(id,0,0);
    }catch(e){
      /* A map that cannot be read back (cross-origin): its shapes under the
         light tone, rather than a bright map in the wrong colours. */
      x.globalCompositeOperation='color'; x.fillStyle=pal.mapDark; x.fillRect(0,0,w,h);
      x.globalCompositeOperation='source-over';
    }
    c[pal.id]=cv; return cv;
  }
  /* The track in panel pixels, every point. Cached per image and rect. */
  var _sbPts={key:'',pts:null,len:0,cum:null};
  function sbPanelPts(im,x,y,w,h){
    var c=state.coords, P=im && im._sbProj; if(!c || c.length<2 || !P) return null;
    var iw=im.naturalWidth||im.width, ih=(im.naturalHeight||im.height)*(1-(im._sbCrop||0));
    var key=(im._sbFor||'')+'|'+iw+'x'+ih+'|'+[x,y,w,h].join(',')+'|'+c.length+'|'+c[0][0]+','+c[0][1];
    if(_sbPts.key===key) return _sbPts;
    var sc=Math.max(w/iw,h/ih), dx=x+(w-iw*sc)/2, dy=y+(h-ih*sc)/2, pts=[], cum=[0], i;
    for(i=0;i<c.length;i++){
      var px=(P.mx(c[i][1])-P.wx0)*P.k, py=(P.my(c[i][0])-P.wy0)*P.k;
      pts.push([dx+px*sc, dy+py*sc]);
      if(i) cum.push(cum[i-1]+Math.sqrt(Math.pow(pts[i][0]-pts[i-1][0],2)+Math.pow(pts[i][1]-pts[i-1][1],2)));
    }
    _sbPts={key:key, pts:pts, cum:cum, len:cum[cum.length-1]};
    return _sbPts;
  }
  function sbAt(R,s){
    var c=R.cum, p=R.pts, lo=1, hi=c.length-1;
    if(s<=0) return {p:p[0],i:0};
    if(s>=R.len) return {p:p[p.length-1],i:p.length-1};
    while(lo<hi){ var md=(lo+hi)>>1; if(c[md]<s) lo=md+1; else hi=md; }
    var t=(s-c[lo-1])/((c[lo]-c[lo-1])||1);
    return {p:[p[lo-1][0]+(p[lo][0]-p[lo-1][0])*t, p[lo-1][1]+(p[lo][1]-p[lo-1][1])*t], i:lo};
  }
  /* The route, its casing, the km discs and S/F, onto a panel x,y,w,h.
     o.prog: how much of the route is drawn (0..1, the reel); o.pop: disc
     scale-in. Returns the drawn track. */
  function sbDrawRoute(ctx,im,x,y,w,h,pal,o){
    o=o||{}; var R=sbPanelPts(im,x,y,w,h); if(!R || !(R.len>0)) return null;
    var prog=(o.prog==null)?1:o.prog, upto=R.len*prog, D=SB_MAPDRAW, mk=sbMarker(pal), i;
    ctx.save(); ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
    ctx.lineJoin='round'; ctx.lineCap='round';
    var path=function(){
      ctx.beginPath(); ctx.moveTo(R.pts[0][0],R.pts[0][1]);
      for(i=1;i<R.pts.length && R.cum[i]<=upto;i++) ctx.lineTo(R.pts[i][0],R.pts[i][1]);
      if(prog<1){ var e=sbAt(R,upto).p; ctx.lineTo(e[0],e[1]); }
    };
    if(prog>0){
      path(); ctx.strokeStyle=pal.mapLight; ctx.lineWidth=D.casing*w; ctx.stroke();
      path(); ctx.strokeStyle=sbRouteHex(); ctx.lineWidth=D.line*w;   ctx.stroke();
    }
    /* km discs: disc k at k / typed km of the drawn path */
    var L=sbKm(), st=L>0 ? kmStep(L) : 0, k, rr=D.disc*w;
    if(st>0) for(k=st; k<=L-st*0.15; k+=st){
      var f=k/L; if(f>prog+1e-9) break;
      var sc=(o.pop && prog<1) ? Math.min(1,(prog-f)/0.04) : 1; if(sc<=0) continue;
      var p=sbAt(R,R.len*f).p, r=rr*(0.4+0.6*sc);
      ctx.beginPath(); ctx.arc(p[0],p[1],r,0,Math.PI*2); ctx.fillStyle=mk; ctx.fill();
      ctx.lineWidth=Math.max(1,D.discEdge*w); ctx.strokeStyle=pal.mapLight; ctx.stroke();
      ctx.font=sbFont(700,D.discNum*w*(0.4+0.6*sc)); ctx.fillStyle=pal.mapLight; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(kmLabel(k), p[0], p[1]+D.discNum*w*0.06);
    }
    /* S/F at the first point; S and F apart once the ends are 30 m apart */
    var c=state.coords, apart=routeKm([c[0],c[c.length-1]])*1000>SB_SF_SPLIT_M;
    var box=function(pt,txt){
      var s=D.sf*w; ctx.fillStyle=mk; ctx.fillRect(pt[0]-s,pt[1]-s,2*s,2*s);
      ctx.lineWidth=Math.max(1,D.sfEdge*w); ctx.strokeStyle=pal.mapLight; ctx.strokeRect(pt[0]-s,pt[1]-s,2*s,2*s);
      ctx.font=sbFont(900,D.sfTxt*w*(txt.length>1?1:1.35)); ctx.fillStyle=pal.mapLight; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(txt, pt[0], pt[1]+D.sfTxt*w*0.06);
    };
    if(apart){ box(R.pts[0],'S'); if(prog>=1) box(R.pts[R.pts.length-1],'F'); }
    else box(R.pts[0],'S/F');
    ctx.restore();
    ctx.textAlign='left'; ctx.textBaseline='alphabetic';
    return R;
  }
  /* The map panel: the recoloured map, cover-fitted, then the route. */
  function sbMap(ctx,x,y,w,h,pal,o){
    o=o||{};
    ctx.save(); ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
    ctx.fillStyle=pal.mapLight; ctx.fillRect(x,y,w,h);
    if(noRoute()){ ctx.restore(); drawRoutePrompt(ctx,x,y,w,h,pal.dark); return; }
    var im=state.mapImg, ok=!!(im && im._sbProj && state.mapUrl && state.mapUrl===sbKey());
    if(ok){
      var iw=im.naturalWidth||im.width, ih=(im.naturalHeight||im.height)*(1-(im._sbCrop||0));
      var sc=Math.max(w/iw,h/ih);
      ctx.globalAlpha=(o.alpha==null)?1:o.alpha;
      ctx.drawImage(sbDuo(im,pal),0,0,iw,ih, x+(w-iw*sc)/2, y+(h-ih*sc)/2, iw*sc, ih*sc);
      ctx.globalAlpha=1;
    } else if(state.coords){
      /* Waiting for the map, or no map key: the panel says so on screen only. */
      if(_splitHeroPaint || !MAPKEY){
        ctx.fillStyle=pal.mapDark; ctx.font=sbFont(500,Math.max(7,w*0.03)); ctx.textAlign='center';
        ctx.fillText(MAPKEY?'Loading map…':'Add a map key in settings', x+w/2, y+h/2); ctx.textAlign='left';
      }
    }
    ctx.restore();
    if(ok) sbDrawRoute(ctx,im,x,y,w,h,pal,o);
  }

  /* ---- the photo panel (Gallery's crop, drag, pinch and zoom) ------------ */
  function sbPhoto(ctx,r,pal){
    if(_splitHeroPaint) galPhotoRect={x:r.x,y:r.y,w:r.w,h:r.h};
    ctx.save(); ctx.beginPath(); ctx.rect(r.x,r.y,r.w,r.h); ctx.clip();
    if(!splitPhoto){
      ctx.fillStyle=pal.bg; ctx.fillRect(r.x,r.y,r.w,r.h);
      ctx.globalAlpha=0.6; ctx.fillStyle=pal.mapLight; ctx.fillRect(r.x,r.y,r.w,r.h); ctx.globalAlpha=1;
      var t='+  ADD YOUR PHOTO', s=r.w*0.075, g=0;
      ctx.font=sbFont(700,s);
      while(ctx.measureText(t).width>r.w*0.80 && s>6 && g++<60){ s*=0.95; ctx.font=sbFont(700,s); }
      ctx.fillStyle=pal.text; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(t, r.x+r.w/2, r.y+r.h/2);
      ctx.textAlign='left'; ctx.textBaseline='alphabetic'; ctx.restore(); return;
    }
    var c=galCrop(splitPhoto,r.w,r.h);
    ctx.drawImage(splitPhoto, c.sx, c.sy, c.sw, c.sh, r.x, r.y, r.w, r.h);
    ctx.restore();
  }
  /* The panel DPI the zoom is capped against: the poster's, the largest
     format a photo goes on (spec 8). */
  function sbPanelDpiFor(im,zo){
    if(!im) return null;
    var sh=SHEET_IN.poster, P=SB_POSTER, inW=sh[0]*P.phW, inH=sh[0]*P.phH;
    var c=galCrop(im,P.phW,P.phH,zo);
    return Math.min(c.sw/inW, c.sh/inH);
  }

  /* ---- the stat bar --------------------------------------------------------- */
  /* x0..x1, rules at y0/y1 (px). L: labSz, labTr, valSz, ruleW, divIn,
     labTop/valTop (px) - or derived from the bar's height. Returns false
     when there is nothing to show. */
  function sbStatBar(ctx,cells,x0,x1,y0,y1,W,L,pal,o){
    o=o||{}; if(!cells.length) return false;
    var hh=y1-y0, rw=Math.max(1,L.ruleW*W), n=cells.length, cw=(x1-x0)/n, i;
    var labSz=L.labSz*W, labTr=L.labTr*W, valSz=o.valSz || L.valSz*W;
    var labTop=(o.labTop!=null)?o.labTop:(y0+hh*0.2), valTop=(o.valTop!=null)?o.valTop:(labTop+labSz*1.6);
    /* In the reel the rules arrive with the first cell, not before it. */
    ctx.globalAlpha=(o.reveal==null)?1:Math.max(0,Math.min(1,o.reveal*n));
    ctx.fillStyle=pal.rule;
    ctx.fillRect(x0,y0-rw/2,x1-x0,rw); ctx.fillRect(x0,y1-rw/2,x1-x0,rw);
    for(i=1;i<n;i++) ctx.fillRect(x0+cw*i-rw/2, y0+hh*L.divIn, rw, hh*(1-2*L.divIn));
    ctx.globalAlpha=1;
    for(i=0;i<n;i++){
      var cx=x0+cw*i+cw/2, show=(o.reveal==null)?1:Math.max(0,Math.min(1,o.reveal*n-i));
      if(show<=0) continue;
      ctx.globalAlpha=show;
      sbText(ctx,cells[i][0],cx,labTop,500,labSz,pal.soft,'center',labTr);
      var vs=valSz, g=0; while(sbWidth(ctx,String(cells[i][1]),700,vs)>cw*0.92 && g++<40) vs*=0.96;
      sbText(ctx,String(cells[i][1]),cx,valTop,700,vs,pal.text,'center');
      ctx.globalAlpha=1;
    }
    return true;
  }
  /* The magnet's floor: values shrink to valFloor, then PLACE drops (or,
     with no PLACE - every sport but 5K Run - DATE). */
  function sbMagnetCells(ctx,cells,x0,x1,W){
    var L=SB_MAG, fits=function(cs,vs){ var cw=(x1-x0)/cs.length, i;
      for(i=0;i<cs.length;i++) if(sbWidth(ctx,String(cs[i][1]),700,vs)>cw*0.92) return false;
      for(i=0;i<cs.length;i++) if(sbWidth(ctx,cs[i][0],500,L.labSz*W,L.labTr*W)>cw*0.92) return false;
      return true; };
    var vs=L.valSz*W, g=0;
    while(!fits(cells,vs) && vs>L.valFloor*W && g++<60) vs=Math.max(L.valFloor*W, vs*0.97);
    if(fits(cells,vs)) return {cells:cells, valSz:vs};
    var gone=cells.some(function(c){ return c[0]==='PLACE'; }) ? 'PLACE' : 'DATE';
    var dropped=cells.filter(function(c){ return c[0]!==gone; });
    vs=L.valSz*W; g=0;
    while(!fits(dropped,vs) && vs>L.valFloor*W && g++<60) vs=Math.max(L.valFloor*W, vs*0.97);
    return {cells:dropped, valSz:vs};
  }

  /* ---- elevation (poster only) -------------------------------------------- */
  function sbElevation(ctx,x0,x1,top,W,pal){
    var L=SB_POSTER, e=state.eles, n=e.length, N=Math.min(465,n), raw=[], i, j;
    for(i=0;i<N;i++){ var v=e[Math.round(i*(n-1)/Math.max(1,N-1))]; raw.push(isFinite(v)?v:NaN); }
    for(i=0;i<N;i++) if(!isFinite(raw[i])) raw[i]=(i?raw[i-1]:0);
    var mn=Infinity, mx=-Infinity; raw.forEach(function(v){ if(v<mn)mn=v; if(v>mx)mx=v; });
    var sm=raw.map(function(v,i2){ var a=0,c=0; for(j=Math.max(0,i2-6);j<=Math.min(N-1,i2+6);j++){ a+=raw[j]; c++; } return a/c; });
    var lo=mn-30, hi=mx+2, bot=top+L.eleH*W, ph=L.eleProf*W;
    var pts=sm.map(function(v,i2){ return [x0+(x1-x0)*i2/Math.max(1,N-1), bot-ph*(v-lo)/((hi-lo)||1)]; });
    ctx.beginPath(); ctx.moveTo(x0,bot); pts.forEach(function(p){ ctx.lineTo(p[0],p[1]); }); ctx.lineTo(x1,bot); ctx.closePath();
    ctx.fillStyle=pal.elevFill; ctx.fill();
    ctx.beginPath(); pts.forEach(function(p,i2){ if(i2) ctx.lineTo(p[0],p[1]); else ctx.moveTo(p[0],p[1]); });
    ctx.strokeStyle=pal.soft; ctx.lineWidth=Math.max(1,L.eleLw*W); ctx.lineJoin='round'; ctx.stroke();
    sbText(ctx,Math.round(mn)+'–'+Math.round(mx)+' M',x0,top+L.eleLab*W,500,L.eleLabSz*W,pal.soft,'left',L.eleTr*W);
  }

  /* ---- the right-hand column: title, tagline, name, bar ------------------- */
  function sbRight(ctx,rx,colW,top,W,L,pal,nameTop,barTop){
    var fit=sbFitTitle(ctx,colW,L.tSz*W,L.tFloor*W), pitch=fit.sz*1.1, i;
    for(i=0;i<fit.lines.length;i++) sbDrawLine(ctx,fit.lines[i],rx-W*0.002,top+i*pitch,fit.sz,pal,'left');
    var tagTop=top+(fit.lines.length-1)*pitch+fit.sz+L.tagGap*W;
    var loc=edtVal('cz-loc').toUpperCase();
    if(loc){ var ts=L.tagSz*W, g=0; while(sbWidth(ctx,loc,500,ts,L.tagTr*W)>colW && ts>4 && g++<40) ts*=0.96;
             sbText(ctx,loc,rx,tagTop,500,ts,pal.soft,'left',L.tagTr*W); }
    var nm=dsName();
    if(nm){ var ns=L.nameSz*W, g2=0; while(sbWidth(ctx,nm,700,ns)>colW && ns>4 && g2++<40) ns*=0.96;
            sbText(ctx,nm,rx,nameTop,700,ns,pal.text,'left'); }
    ctx.fillStyle=SB_ACC; ctx.fillRect(rx,barTop,L.barW*W,L.barH*W);
    return {titleTop:top, lines:fit.lines.length, sz:fit.sz, tagTop:tagTop};
  }

  /* ---- the formats ---------------------------------------------------------- */
  var _sbFontsAsked=false;
  function sbFonts(){
    if(_sbFontsAsked || !(document.fonts && document.fonts.load)) return;
    _sbFontsAsked=true;
    Promise.all(['500 20px Inter','700 20px Inter','900 40px Inter'].map(function(f){ return document.fonts.load(f); }))
      .then(function(){ try{ render(); }catch(e){} }).catch(function(){});
  }
  /* The sheet's own height over its width: A3 / A4 1.414, the magnet 4:5. */
  var SB_NAT_AR={magnet:1.25};
  function renderStatBar(ctx,ox,oy,W,H,fillBg){
    sbFonts();
    var pal=sbPal();
    ctx.save(); ctx.translate(ox,oy);
    /* Its own ground, whatever the blank is: half the colourways are light. */
    ctx.fillStyle=pal.bg; ctx.fillRect(0,0,W,H);
    /* A mockup's window is rarely the sheet's shape (the held poster is about
       1:1.33). The layout is in fractions of the width, so fit it: the width
       whose natural height fits, centred, the strips left over in the ground
       (23 Oct pm, Marc). The sheet's own shape is drawn exactly as before. */
    var nat=SB_NAT_AR[state.product]||Math.SQRT2, w=W, h=H, dx=0, dy=0;
    if(H < W*nat-0.5){ w=H/nat; dx=(W-w)/2; }
    else if(H > W*nat+0.5){ h=W*nat; dy=(H-h)/2; }
    if(dx||dy) ctx.translate(dx,dy);
    if(state.product==='magnet') sbMagnet(ctx,w,h,pal); else sbPoster(ctx,w,h,pal);
    ctx.restore();
  }
  function sbPoster(ctx,W,H,pal){
    var L=SB_POSTER, M=L.M*W, mw=W-2*M, mh=L.mapH*W;
    sbMap(ctx,M,M,mw,mh,pal);
    sbStatBar(ctx,sbCells(),M,W-M,L.r0*W,L.r1*W,W,L,pal,{labTop:L.labTop*W, valTop:L.valTop*W});
    var by=L.by*W, rx=M+(L.phW+L.gap)*W, colW=W-M-rx;
    sbPhoto(ctx,{x:M,y:by,w:L.phW*W,h:L.phH*W},pal);
    var ele=eleUsable();
    if(ele) sbElevation(ctx,rx,W-M,by,W,pal);
    sbRight(ctx,rx,colW,by+(ele?L.t1:L.t1NoEle)*W,W,L,pal,by+L.nameTop*W,by+L.barTop*W);
  }
  function sbMagnet(ctx,W,H,pal){
    var L=SB_MAG, M=L.M*W, mw=W-2*M, mh=mw/SB_MAP_AR;
    sbMap(ctx,M,M,mw,mh,pal);
    var fc=sbMagnetCells(ctx,sbCells(),M,W-M,W);
    sbStatBar(ctx,fc.cells,M,W-M,L.r0*W,L.r1*W,W,L,pal,{valSz:fc.valSz});
    var by=L.by*W, phH=H-M-by, rx=M+(L.phW+L.gap)*W, colW=W-M-rx, pb=by+phH;
    sbPhoto(ctx,{x:M,y:by,w:L.phW*W,h:phH},pal);
    sbRight(ctx,rx,colW,by+L.t1*W,W,L,pal,pb-L.nameUp*W,pb-L.barUp*W);
  }
  /* The wallpaper's centred content block, from the map's top to the bar's
     foot, drawn with its top at `top`. o.t: the reel's clock (seconds). */
  function sbWallBlock(ctx,W,top,pal,o){
    o=o||{}; var L=SB_WALL, y=function(f){ return top+(f-L.mapT)*W; };
    var s=(o.t==null)?99:o.t, span=function(a,b){ return s<=a?0:(s>=b?1:(s-a)/(b-a)); };
    sbMap(ctx,0,y(L.mapT),W,(L.mapB-L.mapT)*W,pal,{alpha:span(0,0.6), prog:(o.t==null)?1:reelEase(span(0.6,3.6)), pop:o.t!=null});
    sbStatBar(ctx,sbCells(),L.M*W,W-L.M*W,y(L.r0),y(L.r1),W,L,pal,{reveal:(o.t==null)?null:span(3.6,4.6)});
    var a=span(4.6,5.6), dy=(1-a)*W*0.012;
    if(a<=0) return;
    ctx.save(); ctx.globalAlpha=a;
    var ts=L.tSz*W, line=sbTitleLines(true)[0], g=0;
    while(sbLineW(ctx,line,ts)>L.tW*W && ts>4 && g++<60) ts*=0.97;
    sbDrawLine(ctx,line,W/2,y(L.tTop)+dy,ts,pal,'center');
    var loc=edtVal('cz-loc').toUpperCase();
    if(loc){ var gs=L.tagSz*W, g1=0; while(sbWidth(ctx,loc,500,gs,L.tagTr*W)>W*0.9 && gs>4 && g1++<40) gs*=0.96;
             sbText(ctx,loc,W/2,y(L.tagTop)+dy,500,gs,pal.soft,'center',L.tagTr*W); }
    var nm=dsName();
    if(nm){ var ns=L.nameSz*W, g2=0; while(sbWidth(ctx,nm,700,ns)>W*0.9 && ns>4 && g2++<40) ns*=0.96;
            sbText(ctx,nm,W/2,y(L.nameTop)+dy,700,ns,pal.text,'center'); }
    ctx.fillStyle=SB_ACC; ctx.fillRect(W/2-L.barW*W/2, y(L.barTop)+dy, L.barW*W, L.barH*W);
    ctx.restore();
  }
  /* 1440 x 3200: the top quarter left for the clock, the foot for the
     lock-screen buttons. No photo and no elevation (Marc, 23 Oct). */
  function sbWallpaper(ctx,W,H,chrome){
    sbFonts();
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      var pal=sbPal();
      ctx.fillStyle=pal.bg; ctx.fillRect(0,0,W,H);
      if(chrome){
        ctx.save(); ctx.textAlign='center'; ctx.fillStyle=pal.soft;
        ctx.font=sbFont(600,W*0.028); ctx.fillText('Saturday 25 October', W/2, W*0.195);
        ctx.font=sbFont(700,W*0.208); ctx.fillText('9:41', W/2, W*0.40);
        ctx.restore();
      }
      sbWallBlock(ctx,W,SB_WALL.mapT*W,pal);
    } finally { _splitHeroPaint=keep; }
  }
  /* The reel, 1080 x 1920: the wallpaper's block centred on the frame, the
     map fading in, the route drawing from S/F with each disc popping as the
     line passes it, the cells left to right, then the type (spec 7c). */
  function sbReelInto(ctx,X,Y,W,H,t){
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      var pal=sbPal(), L=SB_WALL, blockH=(L.foot-L.mapT)*W;
      ctx.save(); ctx.beginPath(); ctx.rect(X,Y,W,H); ctx.clip(); ctx.translate(X,Y);
      ctx.fillStyle=pal.bg; ctx.fillRect(0,0,W,H);
      sbWallBlock(ctx,W,(H-blockH)/2,pal,{t:Math.max(0,Math.min(1,t))*6});
      ctx.restore();
    } finally { _splitHeroPaint=keep; }
  }

  /* ---- the customiser ------------------------------------------------------ */
  /* The two 5K Run fields exist only while the sport is 5K Run: no input,
     no order property, nothing in the cart on any other sport (spec 5). */
  function sbSyncFields(){
    var want=(SPORT==='run5k'), rr=$('cz-runRow'), pr=$('cz-placeRow');
    if(!want){ if(rr&&rr.parentNode) rr.parentNode.removeChild(rr); if(pr&&pr.parentNode) pr.parentNode.removeChild(pr); return; }
    if(rr && pr) return;
    var d=$('cz-date'), anchor=d ? d.closest('.cz-fld') : null; if(!anchor || !anchor.parentNode) return;
    var mk=function(id,rid,lab,hint,mx,im){
      var l=document.createElement('label'); l.className='cz-fld'; l.id=rid;
      l.innerHTML='<span class="cz-lbl">'+lab+'</span><input type="text" id="'+id+'" maxlength="'+mx+'" placeholder="'+hint+'"'+(im?' inputmode="'+im+'"':'')+'/>';
      l.querySelector('input').addEventListener('input',render);
      return l;
    };
    var a=mk('cz-runno','cz-runRow','Run number','e.g. 50 for your 50th',5,'numeric');
    var b=mk('cz-place','cz-placeRow','Place','e.g. 112th',8,'');
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
    anchor.parentNode.insertBefore(a, anchor.nextSibling);
  }
  /* Stat Bar has one style (its own map) and its colourways stand in for the
     map themes, so the style and theme rows go while it is showing. */
  var _sbWas5k=null;
  function sbSyncUI(){
    try{ sbSyncFields(); }catch(e){}
    try{ sbColourRow(); }catch(e){}
    /* The Activity row's 5K Run button: Stat Bar's page only (5K Run draws
       nothing else). */
    var b5=document.querySelector('#cz-sport [data-sp="run5k"]'); if(b5) b5.style.display=sbOn()?'':'none';
    /* On 5K Run the strip has Stat Bar alone (so it hides); off it, the
       other designs come back - rebuilt when that changes. */
    var is5=(SPORT==='run5k');
    if(_sbWas5k!==null && _sbWas5k!==is5 && sbOn()) kindStripSoon();
    _sbWas5k=is5;
    ['cz-styles','cz-mstyles','cz-tstyles'].forEach(function(id){
      var el=$(id); if(!el || !el.style) return;
      if(sbOn()){ if(el._sbHid===undefined) el._sbHid=el.style.display||''; el.style.display='none'; }
      else if(el._sbHid!==undefined){ el.style.display=el._sbHid; el._sbHid=undefined; }
    });
  }
  /* The colourways: a swatch row above the preview, beside where Neon's route
     colours sit (#cz-pal), shown on Stat Bar only (25 Oct, Marc). */
  function sbSetColour(id){
    if(!SB_COLOURS.some(function(c){ return c.id===id; }) || id===sbColour) return;
    sbColour=id; render(); sbColourRow();
  }
  function sbColourRow(){
    var pal=$('cz-pal'), row=$('cz-sbpal');
    if(!row){
      if(!sbOn() || !pal || !pal.parentNode) return;
      row=document.createElement('div'); row.className='cz-sbpal'; row.id='cz-sbpal';
      row.setAttribute('role','group'); row.setAttribute('aria-label','Colour');
    }
    /* Kept beside #cz-pal wherever the layout has moved it. */
    var _anc=$('cz-palhome')||pal;   /* 30 Oct: the route colours moved; the colourways did not */
    if(_anc && _anc.parentNode && _anc.nextSibling!==row) _anc.parentNode.insertBefore(row, _anc.nextSibling);
    row.style.display=sbOn() ? '' : 'none';
    if(!sbOn()) return;
    row.innerHTML='';
    var lab=document.createElement('span'); lab.className='cz-lbl'; lab.textContent='Colour'; row.appendChild(lab);
    SB_COLOURS.forEach(function(c){
      var b=document.createElement('button'); b.type='button';
      var on=(c.id===sbColour);
      b.className='cz-sbsw'+(on?' cz-on':''); b.setAttribute('data-colour',c.id);
      b.setAttribute('aria-label',c.name); b.setAttribute('aria-pressed',on?'true':'false'); b.title=c.name;
      b.style.background='linear-gradient(135deg,'+c.bg+' 0 55%,'+c.mapLight+' 55% 100%)';
      b.addEventListener('click',function(){ sbSetColour(c.id); });
      row.appendChild(b);
    });
    var nm=document.createElement('span'); nm.className='cz-sbname'; nm.textContent=sbPal().name; row.appendChild(nm);
  }
  /* What the order carries, on top of what every design records. */
  function sbProps(props){
    props['Design']='Stat Bar';
    props['Colour']=sbPal().name;
    var r=sbRunNo(); if(r) props['Run number']='#'+r;
    var p=sbPlace(); if(p) props['Place']=p;
  }

  /* ---- 5K Run routes ------------------------------------------------------- */
  /* A route entry whose Sport is 5K Run draws Stat Bar, on Stat Bar's own
     product: section setting "5K Run product" (MSC[109]). */
  function isRun5kRoute(r){ return sportKey(r && r.sport)==='run5k'; }
  function run5kRouteUrl(r){
    var base=String(MSC[109]||'').trim(); if(base.charAt(0)!=='/') base='/products/your-route-statbar-poster';
    var f=''; try{ f=String(focusProd()||''); }catch(e){}
    var _ev=''; try{ _ev=evBackHandle(); }catch(e){}      /* 30 Oct: the way back to the event page */
    return base.split('?')[0].split('#')[0]+'?r='+encodeURIComponent(r.code)+((SB_FMTS[f] && f!=='poster')?'&product='+encodeURIComponent(f):'')
      +(_ev?'&ev='+encodeURIComponent(_ev):'')+((typeof giftOn==='function' && giftOn())?'&gift=1':'');
  }
  /* Stat Bar is offered on every sport (25 Oct); the 5K Run draws Stat Bar
     alone. */
  function kindForSport(k){ return SPORT!=='run5k' || (k||'')==='statbar'; }
  /* ===== end Stat Bar ====================================================== */

  /* ==== New designs (28 Oct 2026, the "Sports and triathlon designs" chat) ====
     Six single-sport designs from the 100-design canvas, numbered as there:
       10 Manifesto     manifesto   the stats as a first-person sentence
       23 Rings         rings       a course clock: distance, climbs and elevation round the map
       28 Dashboard     dashboard   an instrument cluster, the route on its screen
       61 Cover Story   cover       a magazine cover: the customer's photo, the
                                    route on it under big cover lines, a tall
                                    MYMILESTONE masthead (28 Oct pm)
       73 Trading Card  card        a player card: overall rating, the route in its window, ratings
       96 Horizon Split horizon     ink over paper, the elevation is the horizon
     Every one draws the sport's own stats (statRows - the same three, in the
     same order, as every other design), the route in routeHex() (the sport's
     colour or the customer's pick), and its route window through ndArt(),
     which serves Neon, Elevation, Map and Terrain alike. The window's shape is
     fixed per design and format (ndArtAR), never by the text, so the map is
     fetched once at exactly that shape (mapUrlFor, toutDims).
     Built by designs/p_newdesigns.py into milestone-engine.js; this file is
     the source. ES5. */
  var ND_KINDS={ manifesto:1, rings:1, dashboard:1, cover:1, card:1, horizon:1 };
  var ND_INK='#17171A', ND_PAPER='#F3EFE7', ND_MUTED='#8A8890';
  function ndOn(k){ k=(k===undefined)?((typeof DESIGN_KIND!=='undefined')?DESIGN_KIND:''):k; return !!(ND_KINDS && ND_KINDS[k||'']); }
  /* The photo designs among them: Cover Story, and (29 Oct pm) Trading Card
     and Horizon Split. Horizon's photo is optional - without one it is the
     night sky it was. */
  function ndPh(){ return (typeof DESIGN_KIND!=='undefined') && (DESIGN_KIND==='cover' || DESIGN_KIND==='card' || DESIGN_KIND==='horizon'); }
  function ndPhOptional(){ return (typeof DESIGN_KIND!=='undefined') && DESIGN_KIND==='horizon'; }
  /* The photo's window per design, for the crop, the drag and the DPI. */
  function ndPhotoRect(kind,W,H){
    var L=ndLayout(kind,W,H);
    return kind==='cover' ? L.photo : (kind==='card' ? L.art : (kind==='horizon' ? L.photo : null));
  }
  /* Horizon's photo in black and white unless the customer keeps its colour
     (cached per photo). 30 Oct pm (Marc: "black and white but with blue
     tone"): the black-and-white runs from a deep navy to a pale blue-white,
     so it is a blue-toned monochrome, not a neutral grey. */
  var ND_HZ_D=[14,27,46], ND_HZ_L=[217,230,242];
  function ndHzColour(){ var e=$('cz-hzColour'); return !!(e && e.checked); }
  function ndGrey(im){
    if(im._ndGrey) return im._ndGrey;
    var w=im.naturalWidth||im.width, h=im.naturalHeight||im.height, cv=document.createElement('canvas');
    cv.width=w; cv.height=h; var x=cv.getContext('2d',{willReadFrequently:true}); x.drawImage(im,0,0);
    try{ var id=x.getImageData(0,0,w,h), d=id.data, i, L;
      for(i=0;i<d.length;i+=4){ L=(0.299*d[i]+0.587*d[i+1]+0.114*d[i+2])/255;
        d[i]=ND_HZ_D[0]+(ND_HZ_L[0]-ND_HZ_D[0])*L; d[i+1]=ND_HZ_D[1]+(ND_HZ_L[1]-ND_HZ_D[1])*L; d[i+2]=ND_HZ_D[2]+(ND_HZ_L[2]-ND_HZ_D[2])*L; }
      x.putImageData(id,0,0);
    }catch(e){ x.globalCompositeOperation='saturation'; x.fillStyle='#808080'; x.fillRect(0,0,w,h);
      x.globalCompositeOperation='color'; x.fillStyle='rgb(60,90,130)'; x.fillRect(0,0,w,h); x.globalCompositeOperation='source-over'; }
    im._ndGrey=cv; return cv;
  }
  /* The customer's photo cover-cropped into r (Gallery's drag and pinch), or
     the "add your photo" panel. */
  function ndPhoto(ctx,r,ox,oy,W,o){
    o=o||{};
    if(_splitHeroPaint) galPhotoRect={x:ox+r.x,y:oy+r.y,w:r.w,h:r.h};
    if(splitPhoto){
      var c=galCrop(splitPhoto,r.w,r.h), src=o.grey?ndGrey(splitPhoto):splitPhoto;
      ctx.drawImage(src,c.sx,c.sy,c.sw,c.sh,r.x,r.y,r.w,r.h);
      return true;
    }
    if(o.optional) return false;
    ctx.fillStyle='#2A2A30'; ctx.fillRect(r.x,r.y,r.w,r.h);
    var bw=Math.min(r.w*0.7,W*0.5), bh=Math.min(r.h*0.36,W*0.3), bx=r.x+(r.w-bw)/2, by=r.y+(r.h-bh)/2-(o.lift||0);
    ctx.strokeStyle='rgba(255,255,255,0.30)'; ctx.setLineDash([W*0.02,W*0.02]); ctx.lineWidth=Math.max(1,W*0.003);
    ctx.strokeRect(bx,by,bw,bh); ctx.setLineDash([]);
    ndText(ctx,'+  ADD YOUR PHOTO',bx+bw/2,by+bh*0.52,700,W*0.03,'#F0EDE6','center',0,bw*0.9);
    if(o.sub) ndText(ctx,o.sub,bx+bw/2,by+bh*0.52+W*0.035,500,W*0.02,'rgba(240,237,230,0.65)','center',0,bw*0.9);
    return false;
  }
  function ndFont(w,s){ return w+' '+Math.max(1,s)+'px Inter,sans-serif'; }
  /* Shrink until txt fits `max` wide. Returns the size used (font left set). */
  function ndFit(ctx,txt,w,s,max,em){
    var g=0, t=em?spaced(txt,em):txt; ctx.font=ndFont(w,s);
    while(ctx.measureText(t).width>max && s>4 && g++<90){ s*=0.96; ctx.font=ndFont(w,s); }
    return s;
  }
  function ndText(ctx,txt,x,y,w,s,col,align,em,max){
    if(!txt) return 0;
    var t=em?spaced(txt,em):txt;
    if(max) s=ndFit(ctx,txt,w,s,max,em); else ctx.font=ndFont(w,s);
    ctx.fillStyle=col; ctx.textAlign=align||'left'; ctx.textBaseline='alphabetic';
    ctx.fillText(t,x,y); var wd=ctx.measureText(t).width; ctx.textAlign='left'; return wd;
  }
  function ndRRect(ctx,x,y,w,h,r){
    r=Math.max(0,Math.min(r,w/2,h/2));
    ctx.beginPath(); ctx.moveTo(x+r,y); ctx.lineTo(x+w-r,y); ctx.arcTo(x+w,y,x+w,y+r,r);
    ctx.lineTo(x+w,y+h-r); ctx.arcTo(x+w,y+h,x+w-r,y+h,r); ctx.lineTo(x+r,y+h); ctx.arcTo(x,y+h,x,y+h-r,r);
    ctx.lineTo(x,y+r); ctx.arcTo(x,y,x+r,y,r); ctx.closePath();
  }
  function ndMix(hex,to,t){
    var a=parseInt(hex.slice(1),16), b=parseInt(to.slice(1),16);
    var r=Math.round(((a>>16)&255)*(1-t)+((b>>16)&255)*t), g=Math.round(((a>>8)&255)*(1-t)+((b>>8)&255)*t), c=Math.round((a&255)*(1-t)+(b&255)*t);
    return '#'+((1<<24)+(r<<16)+(g<<8)+c).toString(16).slice(1);
  }

  /* ---- what every design prints ------------------------------------------ */
  var ND_VERB={ run:'ran', run5k:'ran', trail:'ran', cycle:'rode', hike:'hiked', swim:'swam' };
  /* The route's title is place and distance ("Bondi to Manly 39K"); the
     place half is what the sentence and the big title lines carry. */
  function ndPlace(t){
    t=String(t||'').trim();
    var p=t.replace(/[\s·\-–,]*\b\d+(?:[.,]\d+)?\s*(?:K|KM|M|MI|MILES?)\b\.?\s*$/i,'').trim();
    return p || t;
  }
  function ndData(){
    var title=edtVal('cz-title'), place=ndPlace(title), loc=edtVal('cz-loc');
    var m=/^(.*?)\s+to\s+(.*)$/i.exec(place);
    var dv=edtVal('cz-date'), dm=/^(\d{4})-(\d{2})-(\d{2})$/.exec(dv);
    return {
      title:title.toUpperCase(), place:place, from:m?m[1]:'', to:m?m[2]:'', loc:loc,
      date:prettyDate(dv).toUpperCase(), year:dm?dm[1]:'', month:dm?(+dm[2]):0,
      name:dsName(), dist:ndComma(edtVal('cz-dist').toUpperCase()),
      stats:statRows('',{upper:true, time:sbTime}).map(function(r){ return r[0]==='DISTANCE' ? [r[0], ndComma(r[1])] : r; }),
      time:sbTime(), sport:(sp().name||'').toUpperCase(), verb:ND_VERB[SPORT]||'ran',
      col:routeHex()
    };
  }
  /* "2300 M" -> "2,300 M": four or more digits get their comma. */
  function ndComma(v){ return String(v||'').replace(/\b(\d{4,})(?![\d.,])/g,function(x){ return x.replace(/\B(?=(\d{3})+(?!\d))/g,','); }); }
  /* A stat's value split into number and unit ("5:15 /KM" -> "5:15", "/KM"). */
  function ndSplitVal(v){
    var m=/^([+\-]?[\d.,:]+)\s*(.*)$/.exec(String(v||'').trim());
    return m ? [m[1], m[2]] : [String(v||''), ''];
  }
  /* The elevation as n samples along the distance, 0..1; null without one. */
  function ndProfile(n){
    if(!eleUsable() || !state.coords) return null;
    var c=state.coords, e=state.eles, cum=[0], i, R=6371;
    for(i=1;i<c.length;i++){ var a=c[i-1], b=c[i], dLa=(b[0]-a[0])*Math.PI/180, dLo=(b[1]-a[1])*Math.PI/180;
      var h=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(a[0]*Math.PI/180)*Math.cos(b[0]*Math.PI/180)*Math.sin(dLo/2)*Math.sin(dLo/2);
      cum.push(cum[i-1]+2*R*Math.asin(Math.min(1,Math.sqrt(h)))); }
    var tot=cum[cum.length-1]; if(!(tot>0)) return null;
    var out=[], j=0, mn=1/0, mx=-1/0, last=NaN;
    for(i=0;i<n;i++){ var d=tot*i/(n-1);
      while(j<cum.length-2 && cum[j+1]<d) j++;
      var f=(cum[j+1]-cum[j])>0 ? (d-cum[j])/(cum[j+1]-cum[j]) : 0, v0=e[j], v1=e[j+1];
      var v=isFinite(v0)&&isFinite(v1) ? v0+(v1-v0)*f : (isFinite(v0)?v0:(isFinite(v1)?v1:last));
      if(!isFinite(v)) v=0; last=v; out.push(v); if(v<mn)mn=v; if(v>mx)mx=v; }
    /* a light smoothing, so GPS jitter does not read as a jagged skyline */
    var sm=out.map(function(v,k){ var s=0,w=0,q; for(q=-2;q<=2;q++){ var x=out[k+q]; if(x!==undefined){ s+=x; w++; } } return s/w; });
    var rng=Math.max(1e-6,mx-mn);
    return { v:sm.map(function(v){ return (v-mn)/rng; }), min:mn, max:mx, km:tot };
  }
  /* "1:12:06", "72:06", "1h12m6s" -> seconds. */
  function ndSecs(v){
    v=String(v||'').trim().toLowerCase(); if(!v) return 0;
    var m=/^(?:(\d+)\s*h)?\s*(?:(\d+)\s*m)?\s*(?:(\d+)\s*s)?$/.exec(v);
    if(m && (m[1]||m[2]||m[3])) return (+m[1]||0)*3600+(+m[2]||0)*60+(+m[3]||0);
    var p=v.split(':').map(function(x){ return parseInt(x,10); });
    if(p.some(function(x){ return !isFinite(x); })) return 0;
    if(p.length===3) return p[0]*3600+p[1]*60+p[2];
    if(p.length===2) return p[0]*60+p[1];
    return 0;
  }
  function ndClock(t){ t=Math.round(t); var h=Math.floor(t/3600), m=Math.floor(t%3600/60), s=t%60, p=function(n){ return (n<10?'0':'')+n; };
    return h>0 ? (h+':'+p(m)+':'+p(s)) : (m+':'+p(s)); }
  function ndKm(k){ return (k>=10?(Math.round(k*10)/10):(Math.round(k*100)/100))+' KM'; }
  /* A swim's distance reads in metres. */
  function ndDistShort(k){ if(SPORT==='swim' && k<10) return String(Math.round(k*1000)).replace(/\B(?=(\d{3})+(?!\d))/g,',')+' M'; return ndKm(k); }

  /* ---- layout: where each design's route window and photo sit ------------- */
  /* Fractions of the sheet, so one rule set serves A3 (0.707) and the magnet
     (0.8). The window never moves with the text. */
  function ndLayout(kind,W,H){
    var m=W*0.075;
    if(kind==='manifesto') return { art:{ x:m, y:H*0.535, w:W-2*m, h:H*0.335 } };
    if(kind==='rings'){
      /* 29 Oct: the course clock. The dial takes what the text block leaves;
         the light map fills the circle inside the elevation band. */
      /* the text block is set from the foot up (the stats, then the most it
         can hold: title, halfway row, two flags); the dial fills the rest */
      var hu=W/297, tbk=28*hu+(ndHalf()?22*hu:0)+((typeof eleUsable==='function'&&eleUsable())?24*hu:12*hu);
      var top=H-56*hu-tbk, R=Math.min(W*0.36,(top-W*0.112)/2.385), cy=W*0.085+R*(1+19/104), ri=R*(1-43/104);
      return { R:R, cx:W/2, cy:cy, top:top, art:{ x:W/2-ri, y:cy-ri, w:2*ri, h:2*ri, circle:true } };
    }
    if(kind==='dashboard'){
      /* 29 Oct (Marc: no empty foot): set from the bottom up - the athlete,
         the readout strip, then the cluster takes all the height left. */
      var sx=m+W*0.022, py=H*0.115, sh=H*0.095, stY=H*0.965-W*0.06-sh, ph=stY-H*0.03-py;
      return { panel:{ x:m, y:py, w:W-2*m, h:ph }, strip:{ x:m, y:stY, w:W-2*m, h:sh },
               art:{ x:sx, y:py+W*0.045, w:W-2*sx, h:ph*0.60 } };
    }
    if(kind==='cover'){
      /* 28 Oct pm (Marc): a magazine. The block at the foot is set from the
         bottom in W, the route sits on the photo under the cover lines. */
      var mc=W*0.06, by=H-W*0.38, ry=by-W*0.235;
      return { photo:{ x:0, y:0, w:W, h:by+W*0.03 }, by:by,
               art:{ x:mc, y:ry, w:W*0.44, h:W*0.19 } };
    }
    if(kind==='card'){
      /* 29 Oct pm (Marc: "make the card occupy the whole poster"): the card is
         the sheet, its foil the edge. The window (the photo) takes what the
         ratings leave. */
      var u=W/297, ccw=W, cch=H;
      var iix=8*u, iiy=8*u, iiw=ccw-16*u, iih=cch-16*u, below=20*u+4*17*u+8*u+36*u;
      return { card:{ x:0, y:0, w:ccw, h:cch }, art:{ x:iix+8*u, y:iiy+44*u, w:iiw-16*u, h:iih-44*u-below } };
    }
    /* 29 Oct (Marc: no empty foot): a taller sky, the type set from the bottom up */
    /* 29 Oct pm: the sky is the customer's photo (to the horizon's top) */
    if(kind==='horizon') return { art:{ x:0, y:0, w:W, h:H*0.56 }, hz:H*0.60, photo:{ x:0, y:0, w:W, h:H*0.60 } };
    return { art:{ x:m, y:m, w:W-2*m, h:H-2*m } };
  }
  function ndArtAR(prod){
    var ar=(PRODUCTS[prod||((typeof focusProd==='function')?focusProd():state.product)]||PRODUCTS.poster).ar;
    var L=ndLayout(DESIGN_KIND,1000,1000/ar), a=L.art;
    return a.w/a.h;
  }

  /* ---- the route window ---------------------------------------------------- */
  /* o.dark: an ink window (Neon glows); o.bg: its fill; o.inset: how much of
     the window Neon's route may use. Map and Terrain fill the window. */
  function ndArt(ctx,r,o){
    o=o||{};
    ctx.save(); ctx.beginPath();
    if(r.circle) ctx.arc(r.x+r.w/2, r.y+r.h/2, r.w/2, 0, Math.PI*2);
    else if(o.round) ndRRect(ctx,r.x,r.y,r.w,r.h,o.round);
    else ctx.rect(r.x,r.y,r.w,r.h);
    ctx.clip();
    if(o.bg){ ctx.fillStyle=o.bg; ctx.fillRect(r.x,r.y,r.w,r.h); }
    if(noRoute()){ ctx.restore(); drawRoutePrompt(ctx,r.x,r.y,r.w,r.h,!!o.dark); return; }
    var inset=o.inset||0.80;
    if(isMapLike(state.style) && state.mapImg){
      var im=state.mapImg, cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035);
      /* Dashboard (29 Oct pm, Marc: "default map but keep the blue-green
         background, same as statbar"): the street map in the screen's two
         tones, the route kept in its colour and glowing */
      if(o.duo && state.style==='map' && !state.mapUser){ im=ndDuoMap(im); }
      var sw=im.width, sh=im.height-cropB, sc=Math.max(r.w/sw, r.h/sh), dw=sw*sc, dh=sh*sc;
      ctx.drawImage(im,0,0,sw,sh, r.x+(r.w-dw)/2, r.y+(r.h-dh)/2, dw,dh);
    } else if(state.style==='heat' && state.heatCanvas && state.heatBbox){
      var hb=state.heatBbox, hs=Math.min(r.w*inset/hb.w, r.h*inset/hb.h), hw=hb.w*hs, hh=hb.h*hs;
      ctx.drawImage(state.heatCanvas, hb.x,hb.y,hb.w,hb.h, r.x+(r.w-hw)/2, r.y+(r.h-hh)/2, hw,hh);
    } else if(state.mask && state.bbox && !isMapLike(state.style)){
      var col=colourised(), bb=state.bbox, glow=o.dark ? Math.min(r.w,r.h)*0.035 : 0;
      var s3=Math.min((r.w*inset-glow)/bb.w, (r.h*inset-glow)/bb.h), dw3=bb.w*s3, dh3=bb.h*s3;
      var dx3=r.x+(r.w-dw3)/2, dy3=r.y+(r.h-dh3)/2;
      if(glow>0) glowArt(ctx,col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3,glow,state.accent);
      else ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3);
    } else {
      var ms=Math.max(6,Math.min(r.w,r.h)*0.06);
      ctx.fillStyle=o.dark?'rgba(240,237,230,0.6)':'rgba(23,23,26,0.5)'; ctx.font=ndFont(500,ms); ctx.textAlign='center';
      ctx.fillText(isMapLike(state.style)?'Loading map…':'', r.x+r.w/2, r.y+r.h/2); ctx.textAlign='left';
    }
    ctx.restore();
  }
  /* The map in the dashboard screen's tones: grey map shapes go to a dark-to-
     light teal by luminance (a light map is read inverted, so land stays dark);
     the route and markers (anything coloured) keep their colour, with a glow.
     Cached on the image. */
  var ND_DUO_D=[15,27,30], ND_DUO_L=[110,196,206];
  function ndHue(r,g,b){ var mx=Math.max(r,g,b), mn=Math.min(r,g,b), d=mx-mn, h=0; if(!d) return 0;
    if(mx===r) h=((g-b)/d)%6; else if(mx===g) h=(b-r)/d+2; else h=(r-g)/d+4; h*=60; return h<0?h+360:h; }
  function ndDuoMap(im){
    if(im._ndDuo) return im._ndDuo;
    var w=im.naturalWidth||im.width, h=im.naturalHeight||im.height;
    var cv=document.createElement('canvas'); cv.width=w; cv.height=h;
    var x=cv.getContext('2d',{willReadFrequently:true}); x.drawImage(im,0,0);
    var mk=document.createElement('canvas'); mk.width=w; mk.height=h;
    try{
      var id=x.getImageData(0,0,w,h), d=id.data, md=mk.getContext('2d').createImageData(w,h), m=md.data, i, L, sum=0, n=0;
      for(i=0;i<d.length;i+=64){ sum+=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2]; n++; }
      var light=(sum/Math.max(1,n))>128, rh=routeHex(), RH=ndHue(parseInt(rh.substr(1,2),16),parseInt(rh.substr(3,2),16),parseInt(rh.substr(5,2),16));
      for(i=0;i<d.length;i+=4){
        var r=d[i], g=d[i+1], b=d[i+2], mx=Math.max(r,g,b), mn=Math.min(r,g,b);
        /* the route (its own hue, saturated): kept */
        if(mx-mn>60 && mx>110){ var dh=Math.abs(ndHue(r,g,b)-RH); if(Math.min(dh,360-dh)<28){ m[i]=r; m[i+1]=g; m[i+2]=b; m[i+3]=255; continue; } }
        L=0.299*r+0.587*g+0.114*b;
        var t=light ? (255-L)/150 : (L-25)/110; t=t<0?0:(t>1?1:t); t=Math.pow(t,1.15);
        d[i]=ND_DUO_D[0]+(ND_DUO_L[0]-ND_DUO_D[0])*t; d[i+1]=ND_DUO_D[1]+(ND_DUO_L[1]-ND_DUO_D[1])*t; d[i+2]=ND_DUO_D[2]+(ND_DUO_L[2]-ND_DUO_D[2])*t; d[i+3]=255;
      }
      x.putImageData(id,0,0);
      var mc=mk.getContext('2d'); mc.putImageData(md,0,0);
      /* the glow: the route again, blurred by its own shadow, then sharp */
      x.save(); x.shadowColor=routeHex(); x.shadowBlur=Math.max(4,w*0.012); x.globalCompositeOperation='lighter'; x.globalAlpha=0.75;
      x.drawImage(mk,0,0); x.restore(); x.drawImage(mk,0,0);
    }catch(e){
      x.globalCompositeOperation='color'; x.fillStyle='#0F1B1E'; x.fillRect(0,0,w,h); x.globalCompositeOperation='source-over';
    }
    im._ndDuo=cv; return cv;
  }
  /* A stat row: n cells, label over value, hairline rules. */
  function ndStatRow(ctx,cells,x0,x1,y,W,o){
    o=o||{}; if(!cells.length) return;
    var n=cells.length, cw=(x1-x0)/n, ls=o.labSz||W*0.0135, vs=o.valSz||W*0.034, i;
    for(i=0;i<n;i++){
      var cx=x0+cw*i+(i?W*0.012:0);
      ndText(ctx,cells[i][0],cx,y,700,ls,o.lab||ND_MUTED,'left',0.14,cw-W*0.02);
      ndText(ctx,cells[i][1],cx,y+vs*1.25,o.valW||800,vs,o.val||ND_INK,'left',0,cw-W*0.02);
      if(i && o.rule){ ctx.fillStyle=o.rule; ctx.fillRect(x0+cw*i-W*0.001, y-ls*1.3, Math.max(1,W*0.0015), vs*1.25+ls*1.6); }
    }
  }

  /* ---- 10 Manifesto ----------------------------------------------------------- */
  /* The sentence, as words tagged ink or colour; facts in the sport colour. */
  function ndSentence(d){
    var w=[], ink=0, hi=1;
    function add(t,c){ if(c){ t=String(t).replace(/(\d)\s+(?=\S)/g,'$1\u00a0'); } String(t).split(/[ \t\n]+/).forEach(function(x){ if(x) w.push([x,c]); }); }
    if(d.date) add('On '+d.date.charAt(0)+d.date.slice(1).toLowerCase()+',',ink);
    add('I '+d.verb,ink);
    var st=d.stats, i, dist='';
    for(i=0;i<st.length;i++) if(st[i][0]==='DISTANCE') dist=st[i][1];
    if(dist) add(dist,hi);
    if(d.from && d.to){ add('from',ink); add(d.from,hi); add('to',ink); add(d.to,hi); }
    else if(d.place){ add('at',ink); add(d.place,hi); }
    else if(d.loc){ add('in',ink); add(d.loc.split(',')[0],hi); }
    var climbed=false;
    for(i=0;i<st.length;i++){
      var L=st[i][0], v=st[i][1];
      if(L==='DISTANCE') continue;
      if(L==='TIME'){ add('in',ink); add(v,hi); }
      else if(L==='ELEV GAIN'){ add(climbed?'and':'and climbed',ink); add(v,hi); climbed=true; }
      else if(L==='HIGH POINT'){ add('topping out at',ink); add(v,hi); }
      else { add('at',ink); add(v,hi); }
    }
    if(w.length) w[w.length-1][2]='.';
    return w.map(function(x){ return [x[0].toUpperCase(),x[1],x[2]||'']; });
  }
  function ndWrap(ctx,words,maxW,s){
    ctx.font=ndFont(800,s);
    var sp=ctx.measureText(' ').width, lines=[], cur=[], cw=0;
    words.forEach(function(wd){ var ww=ctx.measureText(wd[0]+(wd[2]||'')).width;
      if(cur.length && cw+sp+ww>maxW){ lines.push(cur); cur=[]; cw=0; }
      cur.push(wd); cw+=(cur.length>1?sp:0)+ww; });
    if(cur.length) lines.push(cur);
    return lines;
  }
  function renderManifesto(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('manifesto',W,H), d=ndData(), m=W*0.075;
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle=ND_PAPER; ctx.fillRect(0,0,W,H);
    var words=ndSentence(d), top=H*0.075, room=L.art.y-H*0.045-top, maxW=W-2*m;
    var s=W*0.105, lines=[], lh=1.04, g=0;
    for(;;){ lines=ndWrap(ctx,words,maxW,s); if(lines.length*s*lh<=room || s<W*0.03 || g++>80) break; s*=0.96; }
    ctx.font=ndFont(800,s); ctx.textBaseline='alphabetic';
    var sp=ctx.measureText(' ').width, y=top+s*0.86;
    lines.forEach(function(line){ var x=m;
      line.forEach(function(wd,k){ ctx.fillStyle=wd[1]?d.col:ND_INK; ctx.fillText(wd[0],x,y); x+=ctx.measureText(wd[0]).width;
        if(wd[2]){ ctx.fillStyle=ND_INK; ctx.fillText(wd[2],x,y); x+=ctx.measureText(wd[2]).width; } x+=sp; });
      y+=s*lh; });
    ndArt(ctx,L.art,{ bg:'#E9E5DC', inset:0.78 });
    var fy=H*0.915;
    ctx.fillStyle=ND_INK; ctx.fillRect(m,fy-H*0.022,W-2*m,Math.max(1,W*0.0018));
    ndText(ctx,d.name?('— '+d.name):'',m,fy,800,W*0.016,ND_INK,'left',0.10,W*0.45);
    ndText(ctx,[d.sport,d.loc.toUpperCase()].filter(Boolean).join(' · '),W-m,fy,600,W*0.0135,ND_MUTED,'right',0.14,W*0.45);
    ctx.restore();
  }

  /* ---- 23 Rings --------------------------------------------------------------- */
  /* ---- 23 Rings: the course clock (29 Oct, from the Designs chat) ---------- */
  /* Clockwise from 12 o'clock (start and finish), halfway at 6. Outer ring: a
     distance scale - split into the two halves when the halfway time is typed.
     Middle ring: lit wherever the course climbs. Inner band: the elevation
     profile wrapped round the map. Flags: 1 = the high point, 2 = the biggest
     climb. Everything but the halfway time comes from the route file. */
  function ndElev(n){
    var pr=ndProfile(n); if(!pr) return null;
    return { e:pr.v.map(function(v){ return pr.min+v*(pr.max-pr.min); }), km:pr.km, min:pr.min, max:pr.max };
  }
  function ndBigClimb(e){
    var best={ gain:0, i:0, j:0 }, i, j;
    for(i=0;i<e.length;i++){ var peak=e[i], pj=i;
      for(j=i+1;j<e.length;j++){ if(e[j]>peak){ peak=e[j]; pj=j; } if(e[j]<peak-5) break; }
      if(peak-e[i]>best.gain) best={ gain:peak-e[i], i:i, j:pj }; }
    return best;
  }
  /* The halfway time: Rings only, never on a hike (it prints no time), and only
     when it is shorter than the finish time. */
  function ndHalfOn(){ return (typeof DESIGN_KIND!=='undefined') && DESIGN_KIND==='rings' && SPORT!=='hike'; }
  function ndHalf(){
    if(!ndHalfOn()) return 0;
    var h=ndSecs(edtVal('cz-half')), t=ndSecs(sbTime());
    return (h>0 && t>h) ? h : 0;
  }
  function ndArc(ctx,cx,cy,r,a0,a1){ ctx.beginPath(); ctx.arc(cx,cy,r,a0,a1); }
  function renderRings(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('rings',W,H), d=ndData(), m=W*0.067, col=d.col, i;
    var cx=L.cx, cy=L.cy, R=L.R, u=R/104, N=360, km=distKm('')||0;
    var ang=function(f){ return -Math.PI/2+f*Math.PI*2; };
    var P=function(r,f){ return [cx+r*Math.cos(ang(f)), cy+r*Math.sin(ang(f))]; };
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle=ND_PAPER; ctx.fillRect(0,0,W,H);
    ndText(ctx,d.sport,m,H*0.04,800,W*0.0145,col,'left',0.2);
    ndText(ctx,d.date,W-m,H*0.04,700,W*0.0145,ND_MUTED,'right',0.18);
    /* the map fills the centre circle */
    ndArt(ctx,L.art,{ bg:'#ECE6DA', inset:0.68 });
    /* ---- outer ring: the distance scale */
    var half=ndHalf();
    ctx.lineCap='round';
    ctx.strokeStyle='#E2DBCD'; ctx.lineWidth=5*u; ndArc(ctx,cx,cy,R,0,Math.PI*2); ctx.stroke();
    if(half){
      ctx.strokeStyle=ND_INK; ndArc(ctx,cx,cy,R,ang(0)+0.01,ang(0.5)-0.01); ctx.stroke();
      ctx.strokeStyle=col; ndArc(ctx,cx,cy,R,ang(0.5)+0.01,ang(1)-0.01); ctx.stroke();
    }
    ctx.lineCap='butt';
    if(km>0){
      var steps=[0.1,0.2,0.5,1,2,5,10,20,50], step=1, labStep=50, k;
      for(k=0;k<steps.length;k++) if(km/steps[k]<=60){ step=steps[k]; break; }
      for(k=0;k<steps.length;k++) if(steps[k]>=step && km/steps[k]<=5){ labStep=steps[k]; break; }
      var nT=Math.floor(km/step+1e-6);
      for(i=1;i<=nT;i++){ var f=i*step/km; if(f>0.999) continue;
        var dk=i*step, major=Math.abs(dk/labStep-Math.round(dk/labStep))<1e-6, a=P(R+4*u,f), b=P(R+(major?9:6.5)*u,f);
        ctx.strokeStyle=major?'rgba(23,23,26,0.9)':'rgba(23,23,26,0.5)'; ctx.lineWidth=Math.max(0.6,(major?0.6:0.3)*u);
        ctx.beginPath(); ctx.moveTo(a[0],a[1]); ctx.lineTo(b[0],b[1]); ctx.stroke();
        if(major && Math.abs(f-0.5)>0.06 && f<0.95){ var lp=P(R+14.5*u,f);
          ndText(ctx,String(Math.round(dk*10)/10),lp[0],lp[1]+1.3*u,700,3.6*u,ND_MUTED,'center'); } }
    }
    ctx.strokeStyle=ND_INK; ctx.lineWidth=Math.max(1,0.9*u);
    ctx.beginPath(); ctx.moveTo(cx,cy-R-12*u); ctx.lineTo(cx,cy-R+4*u); ctx.stroke();
    ndText(ctx,'START · FINISH',cx,cy-R-15*u,800,3.4*u,ND_INK,'center',0.2);
    ctx.beginPath(); ctx.moveTo(cx,cy+R-4*u); ctx.lineTo(cx,cy+R+12*u); ctx.stroke();
    var hk=km>0 ? ndDistShort(km/2) : '';
    ndText(ctx,'HALFWAY'+(hk?(' · '+hk):''),cx,cy+R+17*u,800,3.4*u,ND_INK,'center',0.2);
    /* ---- middle ring: where the course climbs */
    var Rc=R-13*u, E=ndElev(N), flags=[], flat=false;
    ctx.strokeStyle='#E2DBCD'; ctx.lineWidth=7*u; ndArc(ctx,cx,cy,Rc,0,Math.PI*2); ctx.stroke();
    var r0=Rc-24*u, bh=14*u;
    if(E){
      var e=E.e, dm=Math.max(1,E.km*1000/(N-1));
      ctx.strokeStyle=col; ctx.lineWidth=7*u;
      for(i=0;i<N-1;i++){ var gr=(e[i+1]-e[i])/dm; if(gr<=0.004) continue;
        ctx.globalAlpha=Math.min(1,0.3+gr*10); ndArc(ctx,cx,cy,Rc,ang(i/(N-1)),ang((i+1)/(N-1))+0.002); ctx.stroke(); }
      ctx.globalAlpha=1;
      /* ---- inner band: the elevation, wrapped round the map */
      var lo=E.min, hi=E.max; if(hi-lo<30) hi=lo+30;
      ctx.beginPath();
      for(i=0;i<N;i++){ var p=P(r0+(e[i]-lo)/(hi-lo)*bh,i/(N-1)); if(i) ctx.lineTo(p[0],p[1]); else ctx.moveTo(p[0],p[1]); }
      for(i=N-1;i>=0;i--){ var q=P(r0,i/(N-1)); ctx.lineTo(q[0],q[1]); }
      ctx.closePath(); ctx.globalAlpha=0.22; ctx.fillStyle=col; ctx.fill(); ctx.globalAlpha=1;
      ctx.beginPath();
      for(i=0;i<N;i++){ var p2=P(r0+(e[i]-lo)/(hi-lo)*bh,i/(N-1)); if(i) ctx.lineTo(p2[0],p2[1]); else ctx.moveTo(p2[0],p2[1]); }
      ctx.strokeStyle=ND_INK; ctx.lineWidth=Math.max(0.6,0.6*u); ctx.stroke();
      flat=(E.max-E.min)<8;
      if(!flat){
        var hiI=0; for(i=1;i<N;i++) if(e[i]>e[hiI]) hiI=i;
        var bc=ndBigClimb(e), kmAt=function(ix){ return (Math.round(E.km*ix/(N-1)*10)/10).toFixed(1); };
        flags.push({ n:1, f:hiI/(N-1), r:r0+bh+3.5*u, label:'HIGH POINT', val:fmtM(Math.round(E.max)), at:'AT '+kmAt(hiI)+' KM' });
        if(bc.gain>5) flags.push({ n:2, f:((bc.i+bc.j)/2)/(N-1), r:Rc, label:'BIGGEST CLIMB', val:'+'+fmtM(Math.round(bc.gain)), at:kmAt(bc.i)+'–'+kmAt(bc.j)+' KM' });
      }
    }
    ctx.strokeStyle=ND_INK; ctx.lineWidth=Math.max(0.5,0.4*u); ndArc(ctx,cx,cy,r0,0,Math.PI*2); ctx.stroke();
    var flagDot=function(x,y,n){ ctx.fillStyle=ND_PAPER; ctx.beginPath(); ctx.arc(x,y,3.4*u,0,Math.PI*2); ctx.fill();
      ctx.strokeStyle=ND_INK; ctx.lineWidth=Math.max(0.7,0.7*u); ctx.stroke(); ndText(ctx,String(n),x,y+1.25*u,900,3.6*u,ND_INK,'center'); };
    flags.forEach(function(fl){ var p=P(fl.r,fl.f); flagDot(p[0],p[1],fl.n); });
    /* ---- the text block, anchored to the stats at the foot */
    var w=W-2*m, hu=W/297, tb=22*hu+(half?22*hu:0)+flags.length*12*hu+((E&&flat)?12*hu:0);
    var y=Math.max(L.top+15*hu, H-56*hu-tb+15*hu-6*hu);
    ndText(ctx,(d.place||d.title).toUpperCase(),m,y,900,15*hu,ND_INK,'left',0,w);
    ndText(ctx,[d.loc.toUpperCase(),d.dist].filter(Boolean).join(' · '),m,y+9*hu,600,4.2*hu,ND_MUTED,'left',0.16,w);
    y+=22*hu; ctx.fillStyle=ND_INK; ctx.fillRect(m,y-6*hu,w,Math.max(1,0.5*hu));
    if(half){
      var tot=ndSecs(sbTime()), h2=tot-half, diff=half-h2;
      var verdict=Math.abs(diff)<15 ? 'EVEN SPLIT' : (diff>0 ? 'NEGATIVE SPLIT BY '+ndClock(diff) : 'SECOND HALF +'+ndClock(-diff));
      ctx.fillStyle=ND_INK; ctx.fillRect(m,y-3*hu,7*hu,3.5*hu);
      ndText(ctx,'1ST HALF',m+10*hu,y+1*hu,800,3.6*hu,ND_MUTED,'left',0.16);
      ndText(ctx,ndClock(half),m+10*hu,y+10*hu,900,9*hu,ND_INK,'left');
      ctx.fillStyle=col; ctx.fillRect(m+70*hu,y-3*hu,7*hu,3.5*hu);
      ndText(ctx,'2ND HALF',m+80*hu,y+1*hu,800,3.6*hu,ND_MUTED,'left',0.16);
      ndText(ctx,ndClock(h2),m+80*hu,y+10*hu,900,9*hu,ND_INK,'left');
      var bw=104*hu; ctx.fillStyle=col; ndRRect(ctx,W-m-bw,y-4*hu,bw,17*hu,2*hu); ctx.fill();
      ndText(ctx,verdict,W-m-bw/2,y+6.4*hu,900,5*hu,'#FFFFFF','center',0.06,bw-8*hu);
      y+=22*hu; ctx.fillStyle='rgba(23,23,26,0.16)'; ctx.fillRect(m,y-6*hu,w,Math.max(1,0.3*hu));
    }
    flags.forEach(function(fl){
      flagDot(m+3.4*hu,y-1.4*hu,fl.n);
      ndText(ctx,fl.label,m+11*hu,y,800,4.4*hu,ND_INK,'left',0.12);
      ndText(ctx,fl.at,m+70*hu,y,600,4*hu,ND_MUTED,'left',0.1);
      ndText(ctx,fl.val,W-m,y+0.3*hu,900,6*hu,ND_INK,'right');
      ctx.fillStyle='rgba(23,23,26,0.16)'; ctx.fillRect(m,y+4.5*hu,w,Math.max(1,0.3*hu)); y+=12*hu; });
    if(E && flat){ ndText(ctx,'A FLAT COURSE · NO CLIMBS TO SPEAK OF',m,y,700,4.2*hu,ND_MUTED,'left',0.14,w); }
    ndStatRow(ctx,d.stats,m,W-m,H-42*hu,W,{ val:ND_INK, valSz:9*hu, labSz:3.4*hu });
    ndText(ctx,d.name,m,H-12*hu,800,4.2*hu,ND_INK,'left',0.2,W*0.6);
    ctx.restore();
  }

  /* ---- 28 Dashboard -------------------------------------------------------- */
  /* A gauge's scale: a round ceiling a little above the value. */
  function ndCeil(v){ var c=[5,10,15,21.1,25,30,42.2,50,60,80,100,120,150,200,250,300,500,1000,2000,3000,5000,10000];
    for(var i=0;i<c.length;i++) if(c[i]>=v*1.12) return c[i]; return v*1.2; }
  function ndGauge(ctx,cx,cy,R,frac,col,val,lab,sub,W){
    var a0=Math.PI*0.75, a1=Math.PI*2.25, i;
    ctx.fillStyle='#141417'; ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.fill();
    ctx.strokeStyle='rgba(255,255,255,0.10)'; ctx.lineWidth=Math.max(1,W*0.002); ctx.beginPath(); ctx.arc(cx,cy,R,0,Math.PI*2); ctx.stroke();
    for(i=0;i<=40;i++){ var t=i/40, a=a0+(a1-a0)*t, big=(i%5===0), r0=R*0.80, r1=R*(big?0.93:0.89);
      ctx.strokeStyle= t<=frac ? col : 'rgba(255,255,255,0.28)'; ctx.lineWidth=Math.max(1,W*(big?0.0035:0.0018));
      ctx.beginPath(); ctx.moveTo(cx+Math.cos(a)*r0,cy+Math.sin(a)*r0); ctx.lineTo(cx+Math.cos(a)*r1,cy+Math.sin(a)*r1); ctx.stroke(); }
    var an=a0+(a1-a0)*Math.max(0,Math.min(1,frac));
    ctx.save(); ctx.shadowColor=col; ctx.shadowBlur=R*0.10;
    ctx.strokeStyle=col; ctx.lineWidth=Math.max(1.5,W*0.005); ctx.lineCap='round';
    ctx.beginPath(); ctx.moveTo(cx,cy); ctx.lineTo(cx+Math.cos(an)*R*0.72,cy+Math.sin(an)*R*0.72); ctx.stroke(); ctx.restore();
    ctx.fillStyle='#2A2A30'; ctx.beginPath(); ctx.arc(cx,cy,R*0.09,0,Math.PI*2); ctx.fill();
    ndText(ctx,val,cx,cy+R*0.42,800,R*0.22,'#FFFFFF','center',0,R*1.2);
    ndText(ctx,lab,cx,cy+R*0.60,700,R*0.085,col,'center',0.14,R*1.3);
    ndText(ctx,sub,cx,cy+R*0.72,600,R*0.07,'rgba(255,255,255,0.45)','center',0.12,R*1.3);
  }
  /* The second gauge: the sport's third stat, on a scale that suits it. */
  function ndGauge2(d){
    var st=d.stats, i, row=null;
    for(i=0;i<st.length;i++) if(st[i][0]!=='DISTANCE' && st[i][0]!=='TIME'){ row=st[i]; break; }
    if(!row) return null;
    var sv=ndSplitVal(row[1]), num=sv[0], unit=sv[1], f=0;
    if(/:/.test(num)){ var s=ndSecs(num), lo=(SPORT==='swim')?60:150, hi=(SPORT==='swim')?240:720; f=1-(s-lo)/(hi-lo); }
    else { var v=parseFloat(num.replace(/[,+]/g,''))||0; f=v/ndCeil(v); }
    return { val:num, lab:row[0], sub:unit||'', f:Math.max(0.04,Math.min(0.97,f)) };
  }
  function renderDashboard(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('dashboard',W,H), d=ndData(), m=W*0.075, col=d.col, P=L.panel, A=L.art;
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle='#0E0E10'; ctx.fillRect(0,0,W,H);
    ndText(ctx,(d.place||d.title).toUpperCase(),m,H*0.06,900,W*0.05,'#FFFFFF','left',0,W-2*m);
    ndText(ctx,[d.sport,d.loc.toUpperCase(),d.date].filter(Boolean).join(' · '),m,H*0.085,600,W*0.0135,'rgba(255,255,255,0.5)','left',0.12,W-2*m);
    /* the cluster */
    ctx.fillStyle='#19191D'; ndRRect(ctx,P.x,P.y,P.w,P.h,W*0.035); ctx.fill();
    ctx.strokeStyle='rgba(255,255,255,0.06)'; ctx.lineWidth=Math.max(1,W*0.002); ctx.stroke();
    /* the screen: a dark glass with a grid, the route on it */
    ctx.save(); ndRRect(ctx,A.x,A.y,A.w,A.h,W*0.02); ctx.clip();
    ctx.fillStyle='#0F1B1E'; ctx.fillRect(A.x,A.y,A.w,A.h);
    ctx.strokeStyle='rgba(120,200,210,0.07)'; ctx.lineWidth=1;
    var gs=A.w/14, gx, gy;
    for(gx=A.x;gx<=A.x+A.w;gx+=gs){ ctx.beginPath(); ctx.moveTo(gx,A.y); ctx.lineTo(gx,A.y+A.h); ctx.stroke(); }
    for(gy=A.y;gy<=A.y+A.h;gy+=gs){ ctx.beginPath(); ctx.moveTo(A.x,gy); ctx.lineTo(A.x+A.w,gy); ctx.stroke(); }
    ctx.restore();
    ndArt(ctx,A,{ dark:true, round:W*0.02, inset:0.72, duo:true });
    var pr=ndProfile(120);
    if(pr && !isMapLike(state.style)){
      var py0=A.y+A.h*0.97, ph=A.h*0.12, i;
      ctx.save(); ndRRect(ctx,A.x,A.y,A.w,A.h,W*0.02); ctx.clip();
      ctx.beginPath(); ctx.moveTo(A.x,py0);
      for(i=0;i<pr.v.length;i++) ctx.lineTo(A.x+A.w*i/(pr.v.length-1), py0-pr.v[i]*ph);
      ctx.lineTo(A.x+A.w,py0); ctx.closePath(); ctx.fillStyle='rgba(120,200,210,0.22)'; ctx.fill(); ctx.restore();
    }
    ndText(ctx,'NAV · COURSE',A.x+W*0.02,A.y+W*0.03,700,W*0.011,'rgba(255,255,255,0.45)','left',0.16);
    ndText(ctx,d.dist,A.x+A.w-W*0.02,A.y+W*0.03,700,W*0.011,'rgba(255,255,255,0.45)','right',0.12);
    /* gauges: distance, and the sport's third stat */
    var gyC=A.y+A.h+(P.y+P.h-A.y-A.h)/2, gR=Math.min(W*0.15,(P.y+P.h-A.y-A.h)*0.42);
    var km=distKm('')||0, g1=ndSplitVal(d.dist), g2=ndGauge2(d);
    ndGauge(ctx,P.x+W*0.035+gR,gyC,gR,km>0?km/ndCeil(km):0,col,g1[0]||'—','DISTANCE',(SPORT==='swim'&&/M$/.test(d.dist)&&!/KM$/.test(d.dist))?'METRES':'KILOMETRES',W);
    if(g2) ndGauge(ctx,P.x+P.w-W*0.035-gR,gyC,gR,g2.f,col,g2.val,g2.lab,g2.sub,W);
    /* the centre: elapsed */
    var bw=W*0.20, bh=W*0.075, bx=W/2-bw/2, bY=gyC-bh*0.95;
    ctx.fillStyle='#232328'; ndRRect(ctx,bx,bY,bw,bh,W*0.01); ctx.fill();
    /* the elapsed time - or, where the sport does not print one (hike), its other stat */
    var cen=null, ci;
    for(ci=0;ci<d.stats.length;ci++) if(d.stats[ci][0]==='TIME') cen=['ELAPSED',d.stats[ci][1]];
    if(!cen) for(ci=d.stats.length-1;ci>=0;ci--) if(d.stats[ci][0]!=='DISTANCE' && !(g2 && d.stats[ci][0]===g2.lab)){ cen=d.stats[ci]; break; }
    ndText(ctx,cen?cen[0]:'ELAPSED',W/2,bY+bh*0.32,700,W*0.0105,'rgba(255,255,255,0.45)','center',0.16);
    ndText(ctx,(cen&&cen[1])||'—',W/2,bY+bh*0.80,800,W*0.032,'#FFFFFF','center',0,bw*0.9);
    ndText(ctx,d.sport,W/2,bY+bh*1.45,700,W*0.012,col,'center',0.16);
    /* the readout strip: the sport's stats and the date */
    var cells=d.stats.slice(); if(d.date) cells.push(['DATE',d.date]);
    var S=L.strip;
    ctx.fillStyle='#19191D'; ndRRect(ctx,S.x,S.y,S.w,S.h,W*0.025); ctx.fill();
    ndStatRow(ctx,cells,S.x+W*0.03,S.x+S.w-W*0.01,S.y+S.h*0.36,W,{ lab:'rgba(255,255,255,0.45)', val:'#FFFFFF', valSz:Math.min(W*0.036,S.h*0.30), labSz:W*0.0145, rule:'rgba(255,255,255,0.10)' });
    ndText(ctx,'ATHLETE',m,H*0.965-W*0.03,700,W*0.0125,'rgba(255,255,255,0.45)','left',0.16);
    ndText(ctx,d.name||'',m,H*0.965,800,W*0.026,'#FFFFFF','left',0.08,W*0.6);
    ctx.restore();
  }

  /* ---- 61 Cover Story ------------------------------------------------------ */
  function ndBarcode(ctx,x,y,w,h,seed){
    ctx.fillStyle='#FFFFFF'; ctx.fillRect(x,y,w,h);
    var n=48, bw=(w*0.88)/n, i, s=seed||7;
    ctx.fillStyle=ND_INK;
    for(i=0;i<n;i++){ s=(s*9301+49297)%233280; if(s/233280>0.42) ctx.fillRect(x+w*0.06+i*bw, y+h*0.10, bw*(s%3===0?1.6:0.8), h*0.62); }
  }
  function renderCover(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('cover',W,H), d=ndData(), m=W*0.06, col=d.col, P=L.photo, A=L.art;
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle='#121214'; ctx.fillRect(0,0,W,H);
    /* the cover photo (Gallery's crop, drag and pinch) */
    if(_splitHeroPaint) galPhotoRect={x:ox+P.x,y:oy+P.y,w:P.w,h:P.h};
    ctx.save(); ctx.beginPath(); ctx.rect(P.x,P.y,P.w,P.h); ctx.clip();
    if(splitPhoto){
      var c=galCrop(splitPhoto,P.w,P.h);
      ctx.drawImage(splitPhoto,c.sx,c.sy,c.sw,c.sh,P.x,P.y,P.w,P.h);
    } else {
      ctx.fillStyle='#2A2A30'; ctx.fillRect(P.x,P.y,P.w,P.h);
      ctx.strokeStyle='rgba(255,255,255,0.30)'; ctx.setLineDash([W*0.02,W*0.02]); ctx.lineWidth=Math.max(1,W*0.003);
      ctx.strokeRect(P.x+W*0.52,P.y+P.h*0.30,P.w-W*0.58,P.h*0.52); ctx.setLineDash([]);
      ndText(ctx,'+  ADD YOUR PHOTO',W*0.52+(P.w-W*0.58)/2,P.y+P.h*0.56,700,W*0.03,'#F0EDE6','center',0,P.w-W*0.62);
      ndText(ctx,'it’s the cover',W*0.52+(P.w-W*0.58)/2,P.y+P.h*0.56+W*0.035,500,W*0.02,'rgba(240,237,230,0.65)','center');
    }
    /* legibility: masthead dark at the top, the cover lines on the left, the photo fades into the page */
    var gT=ctx.createLinearGradient(0,P.y,0,P.y+W*0.34); gT.addColorStop(0,'rgba(10,10,12,0.72)'); gT.addColorStop(1,'rgba(10,10,12,0)');
    ctx.fillStyle=gT; ctx.fillRect(P.x,P.y,P.w,W*0.34);
    var gL=ctx.createLinearGradient(0,0,W*0.62,0); gL.addColorStop(0,'rgba(10,10,12,0.62)'); gL.addColorStop(1,'rgba(10,10,12,0)');
    ctx.fillStyle=gL; ctx.fillRect(P.x,P.y+W*0.22,W*0.62,P.h-W*0.22);
    var gB=ctx.createLinearGradient(0,P.y+P.h-W*0.30,0,P.y+P.h); gB.addColorStop(0,'rgba(18,18,20,0)'); gB.addColorStop(1,'rgba(18,18,20,1)');
    ctx.fillStyle=gB; ctx.fillRect(P.x,P.y+P.h-W*0.30,P.w,W*0.30+1);
    ctx.restore();
    /* the masthead: edge to edge and tall, as a magazine sets its name */
    var ty0=W*0.036;
    ndText(ctx,'THE '+(d.sport||'RUN')+' ISSUE',m,ty0,800,W*0.016,col,'left',0.16);
    ndText(ctx,d.date,W-m,ty0,700,W*0.016,'#FFFFFF','right',0.14);
    var mx=W*0.04, ms=ndFit(ctx,'MYMILESTONE',900,W*0.3,W-2*mx,0), tall=1.6;
    ctx.save(); ctx.font=ndFont(900,ms); ctx.textBaseline='alphabetic'; ctx.fillStyle='#FFFFFF'; ctx.textAlign='left';
    var mw=ctx.measureText('MYMILESTONE').width, mb=ty0+W*0.012+ms*0.73*tall;
    ctx.translate((W-mw)/2,mb); ctx.scale(1,tall); ctx.fillText('MYMILESTONE',0,0); ctx.restore();
    var vy=mb+W*0.035;
    ctx.fillStyle='rgba(255,255,255,0.55)'; ctx.fillRect(m,vy-W*0.024,W-2*m,Math.max(1,W*0.0015));
    ndText(ctx,d.loc.toUpperCase(),m,vy,700,W*0.0135,'rgba(255,255,255,0.85)','left',0.14,W*0.5);
    ndText(ctx,'VOL. '+(d.year?d.year.slice(2):'26')+' · NO. '+(d.month?((d.month<10?'0':'')+d.month):'01'),W-m,vy,700,W*0.0135,'rgba(255,255,255,0.85)','right',0.14);
    /* cover lines down the left: the sport's stats after the distance, then the name - big */
    var cl=[], i;
    for(i=0;i<d.stats.length;i++) if(d.stats[i][0]!=='DISTANCE') cl.push([d.stats[i][1], d.stats[i][0]==='TIME'?'ON THE CLOCK, START TO FINISH':(d.stats[i][0]==='ELEV GAIN'?'EVERY METRE CLIMBED':(d.stats[i][0]==='HIGH POINT'?'THE VIEW FROM THE TOP':(d.stats[i][0]==='SPEED'?'AVERAGE SPEED, ALL THE WAY':'THE PACE THAT HELD')))]);
    var first=(d.name||'').split(/\s+/)[0];
    if(first) cl.push([first,'THE ATHLETE, UNFILTERED']);   /* 30 Oct (Marc): was "in their own words" */
    cl=cl.slice(0,3);
    var vs=W*0.078, y0=vy+W*0.035+vs, room=A.y-W*0.045-y0-W*0.03, step=cl.length>1?Math.min(W*0.20,room/(cl.length-1)):0;
    if(step<vs*1.15){ vs=Math.max(W*0.05,step/1.15); }
    cl.forEach(function(c,k){ var yy=y0+step*k;
      ctx.fillStyle=col; ctx.fillRect(m,yy-vs*0.95,W*0.05,Math.max(2,W*0.005));
      ndText(ctx,c[0],m,yy,900,vs,col,'left',0,W*0.55);
      ndText(ctx,c[1],m,yy+W*0.03,800,W*0.0155,'#FFFFFF','left',0.08,W*0.5); });
    /* the route, on the photo under the cover lines */
    ndArt(ctx,A,{ dark:true, round:W*0.012, inset:0.92 });
    /* the main cover line: the distance, the place, the name */
    var by=L.by, dv=ndSplitVal(d.dist);
    ndText(ctx,'COVER STORY',m,by,800,W*0.015,col,'left',0.16);
    var ns=W*0.15, nw=ndText(ctx,dv[0]||'',m,by+ns*0.93,900,ns,'#FFFFFF','left',0,W*0.62);
    if(dv[1]) ndText(ctx,dv[1],m+nw+W*0.015,by+ns*0.93,800,W*0.04,col,'left');
    var ty=by+ns*0.93+W*0.058;
    ndText(ctx,(d.place||d.title).toUpperCase(),m,ty,900,W*0.046,'#FFFFFF','left',0,W-2*m-W*0.22);
    var ctm=''; d.stats.forEach(function(r){ if(r[0]==='TIME') ctm=r[1]; });   /* only where the sport prints a time */
    ndText(ctx,[d.name,[d.dist,ctm?('IN '+ctm):''].filter(Boolean).join(' ')].filter(Boolean).join(' · '),m,ty+W*0.036,600,W*0.0145,'rgba(255,255,255,0.6)','left',0.12,W-2*m-W*0.24);
    /* the sticker and the barcode */
    var sx=W-m-W*0.075, sy=by+W*0.07;
    ctx.fillStyle=col; ctx.beginPath(); ctx.arc(sx,sy,W*0.065,0,Math.PI*2); ctx.fill();
    ndText(ctx,'FINISHER',sx,sy-W*0.002,900,W*0.017,ND_INK,'center');
    ndText(ctx,'EDITION',sx,sy+W*0.021,900,W*0.017,ND_INK,'center');
    var bh=Math.min(W*0.10,H-by-W*0.27);
    ndBarcode(ctx,W-m-W*0.17,H-W*0.05-bh,W*0.17,bh,(d.dist.length*131+d.place.length*17)||7);
    ndText(ctx,d.date,W-m-W*0.085,H-W*0.05-bh*0.07,700,W*0.0105,ND_INK,'center',0.08,W*0.15);
    ctx.restore();
  }

  /* ---- 73 Trading Card: player ratings (29 Oct, from the Designs chat) ------ */
  /* Ratings out of 99 worked out from what the customer already has - no new
     field. Every score is kept between 60 and 99, so a first-timer's card is
     still one worth sharing. Run, trail, ride: ENDURANCE, SPEED, CLIMB, GRIT.
     Hike (no time printed): ENDURANCE, CLIMB, ALTITUDE, GRIT - its grit from
     the distance and the climb. Swim (no climb): ENDURANCE, SPEED, GRIT. No
     time typed: no SPEED and no GRIT, rather than made-up ones. */
  function ndNum(v){ return parseFloat(String(v||'').replace(/,/g,'').replace(/[^\d.]/g,''))||0; }
  function ndRatings(d){
    var cl=function(v){ return v<0?0:(v>1?1:v); }, sc=function(t){ return Math.round(60+39*cl(t)); };
    var lg=function(v,a,b){ return Math.log(v/a)/Math.log(b/a); };
    var km=distKm('')||0, t=ndSecs(sbTime()), hrs=t/3600;
    var gain=ndNum(typeof gainVal==='function'?gainVal():''), high=ndNum(typeof summitVal==='function'?summitVal():'');
    var s=SPORT==='run5k'?'run':(SPORT==='cycle'?'ride':SPORT), out=[];
    var END={ run:[3,100], trail:[5,100], ride:[20,250], hike:[5,60], swim:[0.5,10] }[s]||[3,100];
    var stat=function(lab){ for(var i=0;i<d.stats.length;i++) if(d.stats[i][0]===lab) return d.stats[i][1]; return ''; };
    if(km<=0) return out;
    out.push(['ENDURANCE', sc(lg(km,END[0],END[1])), d.dist]);
    var gTxt=gain>0 ? '+'+fmtM(gain) : '';
    if(s==='hike'){
      out.push(['CLIMB', sc(Math.sqrt(gain/km/60)), gTxt||'FLAT']);
      if(high>0) out.push(['ALTITUDE', sc(high/2200), fmtM(high)]);
      /* Naismith: an hour per 5 km and per 600 m climbed - effort, not a time */
      out.push(['GRIT', sc(lg(Math.max(km/5+gain/600,0.3),0.3,14)), [d.dist, gTxt].filter(Boolean).join(' · ')]);
      return out;
    }
    if(hrs>0){
      var ratio;
      if(s==='ride') ratio=(km/(hrs*60))/(42/60);
      else if(s==='swim') ratio=1.1/((hrs*60)/(km*10));
      else ratio=3.0/((hrs*60)/(km+gain/100));
      out.push(['SPEED', sc((ratio-0.3)/0.6), stat('SPEED')||stat('PACE')]);
    }
    if(s!=='swim') out.push(['CLIMB', sc(Math.sqrt(gain/km/50)), gTxt||'FLAT']);
    if(hrs>0) out.push(['GRIT', sc(lg(Math.max(hrs,0.3),0.3,14)), stat('TIME')||sbTime()]);
    return out;
  }
  function renderCard(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('card',W,H), d=ndData(), C=L.card, A=L.art, col=d.col, u=W/297, i;
    var Rt=ndRatings(d), ovr=Rt.length ? Math.round(Rt.reduce(function(a,b){ return a+b[1]; },0)/Rt.length) : 0;
    ctx.save(); ctx.translate(ox,oy);
    /* the foil: the sport colour into a pale sheen and back, edge to edge */
    var gf=ctx.createLinearGradient(0,0,W,H);
    gf.addColorStop(0,col); gf.addColorStop(0.5,ndMix(col,'#FFFFFF',0.85)); gf.addColorStop(1,col);
    ctx.fillStyle=gf; ctx.fillRect(0,0,W,H);
    var ix=C.x+8*u, iy=C.y+8*u, iw=C.w-16*u, ih=C.h-16*u;
    ctx.fillStyle='#F7F4EC'; ndRRect(ctx,ix,iy,iw,ih,5*u); ctx.fill();
    /* the overall rating, top left like a player card */
    ctx.fillStyle=ND_INK; ndRRect(ctx,ix+8*u,iy+7*u,34*u,30*u,3*u); ctx.fill();
    ndText(ctx,ovr?String(ovr):'—',ix+25*u,iy+27*u,900,19*u,'#FFFFFF','center',0,30*u);
    ndText(ctx,'OVR',ix+25*u,iy+34*u,800,3.6*u,col,'center',0.3);
    ndText(ctx,d.name||'YOUR NAME',ix+50*u,iy+20*u,900,14*u,d.name?ND_INK:'rgba(23,23,26,0.35)','left',0.02,iw-60*u);
    ndText(ctx,[d.sport,d.loc.toUpperCase()].filter(Boolean).join(' · '),ix+50*u,iy+29*u,700,3.6*u,ND_MUTED,'left',0.18,iw-60*u);
    /* the window: the customer's photo (29 Oct pm, Marc), the neon route in
       its bottom-right corner, the title ribbon across its foot */
    var ry=A.y+A.h-4*u, rw=A.w*0.78;
    ctx.save(); ctx.beginPath(); ctx.rect(A.x,A.y,A.w,A.h); ctx.clip();
    var hasPh=ndPhoto(ctx,A,ox,oy,W,{ sub:'it’s your player card', lift:A.h*0.20 });
    var RB={ x:A.x+A.w*0.54, y:A.y+A.h*0.52, w:A.w*0.43, h:(ry-12*u)-(A.y+A.h*0.52) };
    if(hasPh){
      /* a dark corner for the glow to read on */
      var gr=ctx.createRadialGradient(RB.x+RB.w*0.6,RB.y+RB.h*0.6,0,RB.x+RB.w*0.6,RB.y+RB.h*0.6,Math.max(RB.w,RB.h)*0.95);
      gr.addColorStop(0,'rgba(10,10,12,0.62)'); gr.addColorStop(1,'rgba(10,10,12,0)');
      ctx.fillStyle=gr; ctx.fillRect(A.x,A.y,A.w,A.h);
    }
    ctx.restore();
    ndArt(ctx,RB,{ dark:true, inset:0.94 });
    ctx.fillStyle=ND_INK; ctx.beginPath(); ctx.moveTo(A.x-4*u,ry-9*u); ctx.lineTo(A.x-4*u+rw,ry-9*u);
    ctx.lineTo(A.x+2*u+rw,ry-2.5*u); ctx.lineTo(A.x-4*u+rw,ry+4*u); ctx.lineTo(A.x-4*u,ry+4*u); ctx.closePath(); ctx.fill();
    ndText(ctx,(d.place||d.title).toUpperCase(),A.x+4*u,ry-0.9*u,900,5.4*u,'#FFFFFF','left',0.06,rw-10*u);
    /* the ratings - spaced to fill what the card has below the window */
    var sy=A.y+A.h+20*u, foot=iy+ih-5*u, statY=foot-14*u, n=Math.max(1,Rt.length);
    var rowH=Math.max(15*u,Math.min(24*u,(statY-16*u-8*u-sy)/n));
    ndText(ctx,'PLAYER RATINGS',A.x,sy-7*u,800,3.6*u,ND_MUTED,'left',0.24);
    var bx=A.x+50*u, bw=A.w-50*u-24*u;
    Rt.forEach(function(r,k){ var yy=sy+k*rowH;
      ndText(ctx,r[0],A.x,yy+2.4*u,900,4.4*u,ND_INK,'left',0.1,46*u);
      ndText(ctx,r[2]||'',A.x,yy+8*u,600,3.3*u,ND_MUTED,'left',0.1,46*u);
      ctx.fillStyle='#E3DED3'; ndRRect(ctx,bx,yy-2*u,bw,6*u,1*u); ctx.fill();
      ctx.fillStyle=col; ndRRect(ctx,bx,yy-2*u,Math.max(2*u,bw*(r[1]-50)/49),6*u,1*u); ctx.fill();
      ndText(ctx,String(r[1]),A.x+A.w,yy+4.2*u,900,10*u,ND_INK,'right'); });
    if(!Rt.length) ndText(ctx,'ADD YOUR ROUTE FOR YOUR RATINGS',A.x,sy+4*u,700,4*u,ND_MUTED,'left',0.14,A.w);
    ctx.fillStyle='#D9D3C7'; ctx.fillRect(A.x,statY-16*u-7*u+6*u,A.w,Math.max(1,0.4*u));
    ndStatRow(ctx,d.stats,A.x,A.x+A.w,statY-8*u,W,{ valSz:7.5*u, labSz:3.2*u });
    ndText(ctx,d.sport,ix+8*u,foot,800,3.4*u,ND_MUTED,'left',0.22);
    ndText(ctx,[d.date,'1 OF 1'].filter(Boolean).join(' · '),ix+iw-8*u,foot,800,3.4*u,ND_MUTED,'right',0.2);
    ctx.restore();
  }

  /* ---- 96 Horizon Split ---------------------------------------------------- */
  function renderHorizon(ctx,ox,oy,W,H,fillBg){
    var L=ndLayout('horizon',W,H), d=ndData(), m=W*0.075, col=d.col, i;
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle='#151517'; ctx.fillRect(0,0,W,H);
    /* 29 Oct pm (Marc): the sky is the customer's photo, black and white
       unless they keep its colour; dimmed so the route still glows. No photo:
       the night sky, as before. */
    ctx.save(); ctx.beginPath(); ctx.rect(L.photo.x,L.photo.y,L.photo.w,L.photo.h); ctx.clip();
    if(ndPhoto(ctx,L.photo,ox,oy,W,{ optional:true, grey:!ndHzColour() })){
      ctx.fillStyle='rgba(12,12,14,0.38)'; ctx.fillRect(L.photo.x,L.photo.y,L.photo.w,L.photo.h);
      var gT=ctx.createLinearGradient(0,0,0,W*0.12); gT.addColorStop(0,'rgba(12,12,14,0.55)'); gT.addColorStop(1,'rgba(12,12,14,0)');
      ctx.fillStyle=gT; ctx.fillRect(0,0,W,W*0.12);
    } else if(_splitHeroPaint && !splitPhoto){
      ndText(ctx,'+ ADD A PHOTO FOR THE SKY',W/2,L.photo.h*0.10,700,W*0.016,'rgba(240,237,230,0.45)','center',0.12,W*0.8);
    }
    ctx.restore();
    ndArt(ctx,L.art,{ dark:true, inset:0.74 });
    /* the horizon: the elevation profile, paper below it */
    var pr=ndProfile(160), hz=L.hz, amp=H*0.065, pts=[];
    for(i=0;i<160;i++){ var t=i/159, v=pr ? pr.v[i] : (0.5+0.5*Math.sin(t*Math.PI*2*2.2))*0.35;
      pts.push([W*t, hz-v*amp]); }
    ctx.fillStyle=ND_PAPER; ctx.beginPath(); ctx.moveTo(0,H); ctx.lineTo(0,pts[0][1]);
    pts.forEach(function(p){ ctx.lineTo(p[0],p[1]); }); ctx.lineTo(W,H); ctx.closePath(); ctx.fill();
    ctx.strokeStyle=col; ctx.lineWidth=Math.max(1.5,W*0.004); ctx.lineJoin='round';
    ctx.beginPath(); pts.forEach(function(p,k){ if(k) ctx.lineTo(p[0],p[1]); else ctx.moveTo(p[0],p[1]); }); ctx.stroke();
    ndText(ctx,d.sport,m,H*0.04,800,W*0.0135,col,'left',0.16);
    ndText(ctx,d.date,W-m,H*0.04,600,W*0.0135,'rgba(255,255,255,0.6)','right',0.14);
    /* the type, on paper - set from the foot up, the distance as big as the
       space between the horizon and the place allows */
    var nameY=H*0.965, statY=nameY-W*0.11, ruleY=statY-W*0.05, locY=ruleY-W*0.026, placeY=locY-W*0.03, y=placeY-W*0.068;
    var ns=Math.max(W*0.12,Math.min(W*0.24,(y-(hz+W*0.035))/0.73)), dv=ndSplitVal(d.dist);
    var nw=ndText(ctx,dv[0]||'',m,y,900,ns,ND_INK,'left',0,W*0.66);
    if(dv[1]) ndText(ctx,dv[1],m+nw+W*0.015,y,800,Math.max(W*0.03,ns*0.2),col,'left',0.06);
    ndText(ctx,pr?'ELEVATION':'',W-m,hz+W*0.06,700,W*0.0115,ND_MUTED,'right',0.14);
    ndText(ctx,pr?'IS THE HORIZON':'',W-m,hz+W*0.06+W*0.017,700,W*0.0115,ND_MUTED,'right',0.14);
    ndText(ctx,(d.place||d.title).toUpperCase(),m,placeY,900,W*0.05,ND_INK,'left',0,W-2*m);
    ndText(ctx,d.loc.toUpperCase(),m,locY,600,W*0.015,ND_MUTED,'left',0.14,W-2*m);
    ctx.fillStyle=ND_INK; ctx.fillRect(m,ruleY,W-2*m,Math.max(1,W*0.0018));
    var cells=d.stats.filter(function(r){ return r[0]!=='DISTANCE'; });
    ndStatRow(ctx,cells,m,W-m,statY,W,{ valSz:W*0.042, labSz:W*0.0145 });
    ndText(ctx,d.name,m,nameY,800,W*0.016,ND_INK,'left',0.14,W*0.6);
    ctx.restore();
  }

  function ndRender(ctx,ox,oy,W,H,fillBg){
    var k=DESIGN_KIND;
    if(_splitHeroPaint){ ndSyncHalf(); ndSyncHz(); }   /* the sport can change on the page; a photo arrives */
    if(k==='manifesto') renderManifesto(ctx,ox,oy,W,H,fillBg);
    else if(k==='rings') renderRings(ctx,ox,oy,W,H,fillBg);
    else if(k==='dashboard') renderDashboard(ctx,ox,oy,W,H,fillBg);
    else if(k==='cover') renderCover(ctx,ox,oy,W,H,fillBg);
    else if(k==='card') renderCard(ctx,ox,oy,W,H,fillBg);
    else if(k==='horizon') renderHorizon(ctx,ox,oy,W,H,fillBg);
  }
  /* The cover photo's DPI on the poster, for the zoom cap and the warning. */
  function ndPanelDpiFor(im,zo){
    if(!im) return null;
    var ar=PRODUCTS.poster.ar, W=1000, H=W/ar, P=ndPhotoRect(DESIGN_KIND,W,H)||ndLayout('cover',W,H).photo, inW=11.69, inH=16.54;
    var c=galCrop(im,P.w,P.h,zo);
    return Math.min(c.sw/(inW*P.w/W), c.sh/(inH*P.h/H));
  }
  /* The one optional field (29 Oct, replacing "Time for each third"): the
     halfway time, on Rings only and never on a hike. Customers can find it -
     most results list a halfway split, Strava shows it - and a route file
     the customer uploads with timestamps fills it in (ndHalfFromFile). */
  function ndSyncHalf(){
    var r=$('cz-ndHalf'); if(!r) return;
    r.style.display=ndHalfOn()?'':'none';
  }
  function ndHzUI(){
    var row=$('cz-galRow'); if(!row || $('cz-hzColourRow')) return;
    var d=document.createElement('label'); d.id='cz-hzColourRow'; d.className='cz-chk'; d.style.cssText='display:none;margin-top:8px;align-items:center;gap:8px;font-size:13px';
    d.innerHTML='<input type="checkbox" id="cz-hzColour"> Keep the photo in colour <span style="color:#8A8890">(blue-toned black and white otherwise)</span>';
    row.appendChild(d);
    var e=$('cz-hzColour'); if(e) e.addEventListener('change',function(){ render(); });
    ndSyncHz();
  }
  function ndSyncHz(){ var r=$('cz-hzColourRow'); if(r) r.style.display=(DESIGN_KIND==='horizon' && splitPhoto)?'flex':'none'; }
  function ndHalfUI(){
    if($('cz-ndHalf')) return;
    var th=$('cz-h'), tf=th&&th.closest&&th.closest('.cz-fld'); if(!tf || !tf.parentNode) return;
    var d=document.createElement('div'); d.className='cz-fld cz-ndsplits'; d.id='cz-ndHalf'; d.style.display='none';
    d.innerHTML='<span class="cz-lbl">Halfway time <span style="font-weight:400;text-transform:none;letter-spacing:0">(optional)</span></span>'
      +'<div class="cz-ndsp"><input type="text" id="cz-half" maxlength="9" placeholder="e.g. 1:51:42" aria-label="Halfway time" inputmode="numeric"></div>'
      +'<div class="cz-hint" style="margin-top:6px">From your results or Strava. It splits the outer ring into your two halves and shows the split. Blank, the poster is still complete.</div>';
    tf.parentNode.insertBefore(d, tf.nextSibling);
    var e=$('cz-half'); if(e) e.addEventListener('input',function(){ e.removeAttribute('data-auto'); render(); });
    ndSyncHalf();
  }
  /* A file the customer uploads carries a time on every point: the time at
     half the distance fills the halfway box, unless they typed their own. */
  function ndHalfFromFile(g){
    var f=$('cz-half'), c=g&&g.coords, t=g&&g.times, i;
    if(f && f.getAttribute('data-auto')==='1'){ f.value=''; f.removeAttribute('data-auto'); }
    if(!c || !t || c.length<2 || t.length!==c.length) return;
    var ok=0; for(i=0;i<t.length;i++) if(isFinite(t[i])) ok++;
    if(ok<t.length*0.8) return;
    var cum=[0], R=6371000;
    for(i=1;i<c.length;i++){ var a=c[i-1], b=c[i], dLa=(b[0]-a[0])*Math.PI/180, dLo=(b[1]-a[1])*Math.PI/180;
      var h=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(a[0]*Math.PI/180)*Math.cos(b[0]*Math.PI/180)*Math.sin(dLo/2)*Math.sin(dLo/2);
      cum.push(cum[i-1]+2*R*Math.asin(Math.min(1,Math.sqrt(h)))); }
    var tot=cum[cum.length-1], t0=NaN, th=NaN; if(!(tot>0)) return;
    for(i=0;i<t.length;i++) if(isFinite(t[i])){ t0=t[i]; break; }
    for(i=1;i<c.length;i++) if(cum[i]>=tot/2){
      var ta=t[i-1], tb=t[i], fr=(cum[i]-cum[i-1])>0 ? (tot/2-cum[i-1])/(cum[i]-cum[i-1]) : 0;
      th=(isFinite(ta)&&isFinite(tb)) ? ta+(tb-ta)*fr : (isFinite(tb)?tb:ta); break; }
    var sec=(th-t0)/1000;
    if(!(sec>0) || !f || (f.value && f.getAttribute('data-auto')!=='1')) return;
    f.value=ndClock(sec); f.setAttribute('data-auto','1');
  }
  function ndProps(props){
    if(!ndOn()) return;
    props['Design']=KIND_LABEL[DESIGN_KIND]||DESIGN_KIND;
    if(DESIGN_KIND==='horizon') props['Photo']=splitPhoto ? (ndHzColour()?'Colour':'Blue-toned black & white') : 'None (night sky)';
    if(ndHalfOn() && edtVal('cz-half')) props['Halfway time']=edtVal('cz-half')+(ndHalf()?'':' (not used: not shorter than the finish time)');
  }

  /* ======================================================================
     3D (28 Oct pm) - the "3D poster lab" design, built into the customiser.
     Source of every visual decision: claude/3d-poster-handover.md and
     claude/flyover-lab.html. A tilted MapLibre GL map of the route (the
     illustrated night look: OpenStreetMap shapes from OpenFreeMap, 2x
     terrain + hillshade, a sky with a horizon), the route and its markers
     drawn on top, then the Night text band.

     MapLibre is loaded only when this design is on the page (t3Lib), so no
     other design pays for it. The map is rendered offscreen, once per
     route and shape (poster, magnet, phone), and kept as a bitmap:
     state.mapImg on the page, with the route's screen points (_t3Pts)
     projected on the terrain at the same moment. The route itself is drawn
     on the 2D canvas, so a colour pick never re-renders the map.

     The print file re-renders the map at T3_HI_PX wide with the preview's
     camera (zoom + log2 of the size ratio), as the lab's export does. With
     no WebGL, or the library blocked, the design falls back to a flat
     perspective of the route under the same sky, and says so.
     ====================================================================== */
  var T3_ML='https://cdn.jsdelivr.net/npm/maplibre-gl@5.24.0/dist/maplibre-gl';
  var T3_OFM='https://tiles.openfreemap.org/planet';
  var T3_GLYPHS='https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf';
  var T3_DEM_RAW='https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png';
  /* 29 Oct pm (Marc: "make the color lighter and exaggerate terrains"): every
     tone lifted about a third towards the light, the sky with it, the relief
     at 3.2x (was 2) and the hillshade stronger. */
  var T3_N={land:'#383e44',wood:'#2f5442',grass:'#3b5a45',farm:'#42493c',sand:'#6e6752',res:'#41464d',ind:'#45454c',
    park:'#356146',water:'#1a3a5c',waterEdge:'#4a74a3',road:'#5d6570',roadMajor:'#7a838e',building:'#4b5159'};
  var T3_SKY={'sky-color':'#2f4578','horizon-color':'#a7badb','fog-color':'#4d6394','sky-horizon-blend':0.55,
    'horizon-fog-blend':0.65,'fog-ground-blend':0.55,'atmosphere-blend':0};
  var T3_INK='#17171A', T3_PAPER='#F3EFE7', T3_PITCH=70, T3_EXAG=3.2, T3_LW=4.5;
  /* preview: 600 CSS px at 2x; print: T3_HI_PX device px (A4 at 300 DPI,
     A3 at 212 - the type is drawn at full size on top, only the map is
     scaled). A slow device gets T3_WAIT before the flat fallback is kept;
     meanwhile the page shows the flat perspective and "Building". */
  var T3_PREV_CSS=600, T3_HI_PX=2480, T3_WAIT=120000;
  /* The page's 3D state. Made on first use: a few callers (the map key)
     can run before the closure reaches this line. */
  var T3=T3||null;
  function t3S(){ if(!T3) T3={lib:0, cbs:[], caps:{}, wait:{}, pts:null, ptsFor:null, bear:0, km:0, dem:'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'}; return T3; }

  function t3On(){ return (typeof DESIGN_KIND!=='undefined') && DESIGN_KIND==='3d'; }
  /* The lab's target boxes and band heights, by shape. */
  function t3Fmt(ar){
    if(ar>=0.76) return { box:[0.07,0.24,0.93,0.64], band:0.70 };     /* magnet 4:5 */
    if(ar<0.62)  return { box:[0.08,0.30,0.92,0.66], band:0.72 };     /* phone */
    return { box:[0.07,0.26,0.93,0.68], band:0.73 };                  /* paper */
  }
  function t3AR(prod){
    return (PRODUCTS[prod||((typeof focusProd==='function')?focusProd():state.product)]||PRODUCTS.poster).ar;
  }
  function t3Hav(a,b){
    var R=6371008.8,r=Math.PI/180,dla=(b[1]-a[1])*r,dlo=(b[0]-a[0])*r;
    var h=Math.sin(dla/2)*Math.sin(dla/2)+Math.cos(a[1]*r)*Math.cos(b[1]*r)*Math.sin(dlo/2)*Math.sin(dlo/2);
    return 2*R*Math.asin(Math.min(1,Math.sqrt(h)));
  }
  /* The route as [lon,lat], thinned to what a screen can show, with its
     principal-axis bearing (the lab's "turn auto"). A new route drops the
     rendered maps. */
  function t3Pts(){
    var c=state.coords; if(!c || c.length<2) return null;
    if(t3S().ptsFor===c && t3S().pts) return t3S().pts;
    var s=dpSimplify(c,0.00001);
    if(s.length>1500){ var ix=downsampleIdx(s.length,1500); s=ix.map(function(i){ return s[i]; }); }
    var p=s.map(function(q){ return [q[1],q[0]]; }), km=0, i;
    for(i=1;i<p.length;i++) km+=t3Hav(p[i-1],p[i]);
    t3S().pts=p; t3S().ptsFor=c; t3S().km=km/1000; t3S().bear=t3Axis(p); t3S().caps={}; t3S().wait={};
    return p;
  }
  function t3Axis(p){
    var mx=0,my=0,n=p.length,xs=[],ys=[],i;
    for(i=0;i<n;i++){ var x=p[i][0]*Math.cos(p[i][1]*Math.PI/180), y=p[i][1]; xs.push(x); ys.push(y); mx+=x; my+=y; }
    mx/=n; my/=n; var sxx=0,syy=0,sxy=0;
    for(i=0;i<n;i++){ var dx=xs[i]-mx, dy=ys[i]-my; sxx+=dx*dx; syy+=dy*dy; sxy+=dx*dy; }
    var th=0.5*Math.atan2(2*sxy,sxx-syy);
    var tr=sxx+syy, det=sxx*syy-sxy*sxy, q=Math.sqrt(Math.max(0,tr*tr/4-det)), l1=tr/2+q, l2=tr/2-q;
    if(l1<2.2*Math.max(l2,1e-12)) return 0;           /* roundish: north up */
    var b=(90-th*180/Math.PI)-90;                      /* the long axis left to right */
    while(b>90) b-=180; while(b<-90) b+=180;           /* north-ish at the top */
    return b;
  }
  function t3Key(ar){
    var p=t3Pts(); if(!p) return '';
    var a=p[0], z=p[p.length-1], md=p[p.length>>1];
    return 't3|'+(ar||t3AR()).toFixed(4)+'|'+p.length+'|'+a[0].toFixed(5)+','+a[1].toFixed(5)+'|'+
           z[0].toFixed(5)+','+z[1].toFixed(5)+'|'+md[0].toFixed(5)+','+md[1].toFixed(5);
  }

  /* ---- the library, on demand ---------------------------------------- */
  function t3Lib(cb){
    if(t3S().lib===2){ cb(true); return; }
    if(t3S().lib<0){ cb(false); return; }
    t3S().cbs.push(cb); if(t3S().lib===1) return; t3S().lib=1;
    var fin=function(ok){ if(t3S().lib!==1) return; t3S().lib=ok?2:-1; if(ok) t3CleanDem();
      var q=t3S().cbs; t3S().cbs=[]; q.forEach(function(f){ try{ f(ok); }catch(e){ console.warn('Milestone 3D:',e); } }); };
    if(window.maplibregl){ fin(true); return; }
    var gl=false; try{ var t=document.createElement('canvas'); gl=!!(t.getContext('webgl2')||t.getContext('webgl')); }catch(e){}
    if(!gl){ fin(false); return; }
    var l=document.createElement('link'); l.rel='stylesheet'; l.href=T3_ML+'.css'; document.head.appendChild(l);
    var s=document.createElement('script'); s.src=T3_ML+'.js'; s.async=true;
    s.onload=function(){ fin(!!window.maplibregl); }; s.onerror=function(){ fin(false); };
    setTimeout(function(){ fin(!!window.maplibregl); },20000);
    document.head.appendChild(s);
  }
  /* The free elevation tiles have stray pixels (2,000+ m over Sydney at the
     zoom a whole route uses). Each tile is cleaned as it loads: a pixel far
     from its neighbourhood takes the 5x5 median, three passes. The lab's
     cleanTile, unchanged. */
  function t3CleanTile(e,w,h){
    var buf=new Float32Array(25), pass, x, y, dx, dy, xx, yy;
    for(pass=0;pass<3;pass++){
      var out=e.slice(), changed=0;
      for(y=0;y<h;y++) for(x=0;x<w;x++){
        var i=y*w+x, v=e[i], lo=1e9, hi=-1e9;
        for(dy=-1;dy<=1;dy++) for(dx=-1;dx<=1;dx++){ if(!dx&&!dy) continue;
          yy=Math.min(h-1,Math.max(0,y+dy)); xx=Math.min(w-1,Math.max(0,x+dx)); var n=e[yy*w+xx];
          if(n<lo) lo=n; if(n>hi) hi=n; }
        if(v-lo<=40 && hi-v<=40) continue;
        var k=0;
        for(dy=-2;dy<=2;dy++) for(dx=-2;dx<=2;dx++){
          yy=Math.min(h-1,Math.max(0,y+dy)); xx=Math.min(w-1,Math.max(0,x+dx)); buf[k++]=e[yy*w+xx]; }
        buf.sort(); var med=buf[12];
        if(Math.abs(v-med)>40){ out[i]=med; changed++; }
      }
      e=out; if(!changed) break;
    }
    return e;
  }
  function t3CleanDem(){
    if(t3S().dem!==T3_DEM_RAW) return;
    if(!window.maplibregl || !maplibregl.addProtocol || !window.createImageBitmap) return;
    var cache={}, keys=[];
    try{
      maplibregl.addProtocol('cleandem',function(params){
        var url=params.url.replace(/^cleandem:\/\//,'https://');
        if(!cache[url]){
          cache[url]=fetch(url).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.blob(); })
          .then(function(b){ return createImageBitmap(b,{premultiplyAlpha:'none',colorSpaceConversion:'none'}); })
          .then(function(bmp){
            var w=bmp.width,h=bmp.height, cv;
            if(typeof OffscreenCanvas!=='undefined') cv=new OffscreenCanvas(w,h); else { cv=document.createElement('canvas'); cv.width=w; cv.height=h; }
            var cx=cv.getContext('2d',{willReadFrequently:true}); cx.drawImage(bmp,0,0);
            var img=cx.getImageData(0,0,w,h), d=img.data, e=new Float32Array(w*h), i;
            for(i=0;i<w*h;i++) e[i]=d[4*i]*256+d[4*i+1]+d[4*i+2]/256-32768;
            e=t3CleanTile(e,w,h);
            for(i=0;i<w*h;i++){ var v=Math.max(0,Math.min(65535.99,e[i]+32768)), fl=Math.floor(v);
              d[4*i]=fl>>8; d[4*i+1]=fl&255; d[4*i+2]=Math.floor((v-fl)*256); d[4*i+3]=255; }
            cx.putImageData(img,0,0);
            return cv.convertToBlob?cv.convertToBlob({type:'image/png'}):new Promise(function(res){ cv.toBlob(res,'image/png'); });
          })
          .then(function(b){ return b.arrayBuffer(); })
          .catch(function(err){ delete cache[url]; throw err; });
          keys.push(url); if(keys.length>400) delete cache[keys.shift()];
        }
        return cache[url].then(function(buf){ return {data:buf.slice(0)}; });
      });
      t3S().dem='cleandem://'+T3_DEM_RAW.replace(/^https:\/\//,'');
    }catch(e){ console.warn('Milestone 3D: elevation cleaning unavailable',e); }
  }

  /* ---- the map style ---------------------------------------------------- */
  function t3Style(k,pts){
    var N=T3_N, L=[];
    L.push({id:'o-land',type:'background',paint:{'background-color':N.land}});
    L.push({id:'o-landcover',type:'fill',source:'ofm','source-layer':'landcover',paint:{'fill-color':['match',['get','class'],
      'wood',N.wood,'grass',N.grass,'farmland',N.farm,'sand',N.sand,'wetland',N.grass,'rock','#2e3033',N.land],'fill-antialias':false}});
    L.push({id:'o-landuse',type:'fill',source:'ofm','source-layer':'landuse',paint:{'fill-color':['match',['get','class'],
      'residential',N.res,'suburb',N.res,'neighbourhood',N.res,'industrial',N.ind,'commercial',N.ind,'retail',N.ind,'cemetery',N.grass,'pitch',N.grass,'stadium',N.ind,N.res],'fill-opacity':0.85}});
    L.push({id:'o-park',type:'fill',source:'ofm','source-layer':'park',paint:{'fill-color':N.park,'fill-opacity':0.9}});
    L.push({id:'o-water',type:'fill',source:'ofm','source-layer':'water',paint:{'fill-color':N.water}});
    L.push({id:'o-waterway',type:'line',source:'ofm','source-layer':'waterway',paint:{'line-color':N.water,'line-width':['interpolate',['linear'],['zoom'],10,0.5,15,2]}});
    L.push({id:'o-coast',type:'line',source:'ofm','source-layer':'water',paint:{'line-color':N.waterEdge,'line-width':['interpolate',['linear'],['zoom'],9,0.4,15,1.2],'line-opacity':0.7}});
    L.push({id:'o-roads',type:'line',source:'ofm','source-layer':'transportation',filter:['in',['get','class'],['literal',['minor','tertiary','service','track']]],
      minzoom:11,paint:{'line-color':N.road,'line-width':['interpolate',['linear'],['zoom'],11,0.3,16,1.6],'line-opacity':0.8}});
    L.push({id:'o-roads-major',type:'line',source:'ofm','source-layer':'transportation',filter:['in',['get','class'],['literal',['motorway','trunk','primary','secondary']]],
      paint:{'line-color':N.roadMajor,'line-width':['interpolate',['linear'],['zoom'],8,0.4,16,3],'line-opacity':0.9}});
    L.push({id:'o-building',type:'fill',source:'ofm','source-layer':'building',minzoom:14,paint:{'fill-color':N.building,'fill-opacity':0.8}});
    L.push({id:'hs',type:'hillshade',source:'demhs',paint:{'hillshade-exaggeration':0.62,'hillshade-shadow-color':'#0b1018',
      'hillshade-highlight-color':'#c3cfdc','hillshade-accent-color':'#0b1018'}});
    /* No map labels: the suburb names are drawn on the canvas (t3Names), so
       the start and finish suburbs are always placed (29 Oct pm). */
    return {version:8, glyphs:T3_GLYPHS,
      sources:{ ofm:{type:'vector',url:T3_OFM},
                dem:{type:'raster-dem',tiles:[t3S().dem],tileSize:256,maxzoom:15,encoding:'terrarium'},
                demhs:{type:'raster-dem',tiles:[t3S().dem],tileSize:256,maxzoom:15,encoding:'terrarium'} },
      layers:L, terrain:{source:'dem',exaggeration:T3_EXAG}};
  }
  /* The lab's fit: the route into the target box at 70 degrees and the auto
     turn, ten passes of re-centre and re-zoom. */
  function t3Fit(m,pts,box){
    var c=m.getCanvas(), W=c.clientWidth||parseFloat(c.style.width)||600, H=c.clientHeight||parseFloat(c.style.height)||800;
    var b=new maplibregl.LngLatBounds(); pts.forEach(function(p){ b.extend([p[0],p[1]]); });
    m.jumpTo({center:b.getCenter(),bearing:t3S().bear,pitch:0,zoom:m.getZoom()});
    var cam=m.cameraForBounds(b,{padding:Math.min(40,W*0.06),bearing:t3S().bear});
    if(cam) m.jumpTo({center:cam.center,zoom:cam.zoom,bearing:t3S().bear,pitch:T3_PITCH});
    var st=Math.max(1,Math.floor(pts.length/150)), tx0=box[0]*W, ty0=box[1]*H, tx1=box[2]*W, ty1=box[3]*H, it, i;
    for(it=0;it<10;it++){
      var x0=1e9,y0=1e9,x1=-1e9,y1=-1e9;
      for(i=0;i<pts.length;i+=st){ var s=m.project(pts[i]); if(!isFinite(s.x)||!isFinite(s.y)) continue;
        if(s.x<x0)x0=s.x; if(s.y<y0)y0=s.y; if(s.x>x1)x1=s.x; if(s.y>y1)y1=s.y; }
      var bw=Math.max(1,x1-x0), bh=Math.max(1,y1-y0), sc=Math.min((tx1-tx0)/bw,(ty1-ty0)/bh);
      var dx=(x0+x1)/2-(tx0+tx1)/2, dy=(y0+y1)/2-(ty0+ty1)/2;
      m.jumpTo({center:m.unproject([W/2+dx,H/2+dy]),zoom:m.getZoom()+Math.log2(sc)*0.9});
      if(Math.abs(Math.log2(sc))<0.01 && Math.abs(dx)<1 && Math.abs(dy)<1) break;
    }
  }

  /* ---- one offscreen render -> a bitmap with the route's screen points ---- */
  /* One WebGL map at a time: renders queue rather than run side by side. */
  function t3Capture(ar,cssW,pr,cam,cb){
    var S=t3S(); S.q=S.q||[];
    S.q.push([ar,cssW,pr,cam,cb]);
    if(!S.running) t3Next();
  }
  function t3Next(){
    var S=t3S(), job=S.q.shift(); if(!job){ S.running=false; return; }
    S.running=true;
    t3CaptureNow(job[0],job[1],job[2],job[3],function(cv){
      try{ job[4](cv); }catch(e){ console.warn('Milestone 3D:',e); }
      setTimeout(t3Next,0);
    });
  }
  function t3CaptureNow(ar,cssW,pr,cam,cb){
    var pts=t3Pts(); if(!pts){ cb(null); return; }
    var px=Math.round(cssW*pr);
    t3Lib(function(ok){
      if(!ok){ cb(t3FlatCap(ar,px)); return; }
      var cssH=Math.round(cssW/ar), F=t3Fmt(ar), k=cssW/T3_PREV_CSS;
      var host=document.createElement('div');
      host.setAttribute('aria-hidden','true');
      host.style.cssText='position:fixed;left:-'+(cssW+500)+'px;top:0;width:'+cssW+'px;height:'+cssH+'px;pointer-events:none;overflow:hidden';
      document.body.appendChild(host);
      var m=null, done=false, loaded=false, demOk=0, demBad=0, flat=false, tm, plc=null, plWait=false, plGrab=null;
      if(typeof tplFetch==='function' && state.coords){ plWait=true;
        tplFetch(state.coords,function(l){ plc=l||[]; plWait=false; if(plGrab){ var g2=plGrab; plGrab=null; g2(); } }); }
      var fin=function(cv){ if(done) return; done=true; clearTimeout(tm);
        try{ if(m) m.remove(); }catch(e){} if(host.parentNode) host.parentNode.removeChild(host); cb(cv); };
      var idle=function(f){ var did=false, g=function(){ if(did) return; did=true; f(); };
        m.once('idle',g); try{ m.triggerRepaint(); }catch(e){} setTimeout(g,40000); };
      var grab=function(){
        if(done) return;
        if(plWait){ plGrab=grab; return; }      /* the names give up within 9 s */
        try{
          var src=m.getCanvas(), cv=document.createElement('canvas'); cv.width=src.width; cv.height=src.height;
          cv.getContext('2d').drawImage(src,0,0);
          var sx=src.width/cssW, ctr=m.getCenter();
          cv._t3Pts=pts.map(function(p){ var s=m.project(p); return [s.x*sx, s.y*sx]; });
          cv._t3Places=(plc||[]).map(function(q){ var s=m.project([q.lon,q.lat]); return { name:q.name, cls:q.cls, end:q.end||'', x:s.x*sx, y:s.y*sx }; })
            .filter(function(q){ return isFinite(q.x) && isFinite(q.y) && q.x>0 && q.x<cv.width && q.y>cv.height*0.16 && q.y<cv.height; });
          cv._t3Cam={center:[ctr.lng,ctr.lat], zoom:m.getZoom(), bearing:m.getBearing(), pitch:m.getPitch(), cssW:cssW};
          cv._t3Flat=flat?'relief':'';
          fin(cv);
        }catch(e){ console.warn('Milestone 3D: capture failed',e); fin(t3FlatCap(ar,px)); }
      };
      tm=setTimeout(function(){ if(loaded) grab(); else fin(t3FlatCap(ar,px)); }, T3_WAIT);
      try{
        /* opens flat on the route's bounds, so the first load is a handful of tiles */
        var bx=[[1e9,1e9],[-1e9,-1e9]];
        pts.forEach(function(q){ if(q[0]<bx[0][0]) bx[0][0]=q[0]; if(q[1]<bx[0][1]) bx[0][1]=q[1]; if(q[0]>bx[1][0]) bx[1][0]=q[0]; if(q[1]>bx[1][1]) bx[1][1]=q[1]; });
        m=new maplibregl.Map({container:host, style:t3Style(k,pts), bounds:bx, fitBoundsOptions:{padding:Math.min(40,cssW*0.06)},
          pitch:0, bearing:t3S().bear, maxPitch:80, interactive:false, attributionControl:false, fadeDuration:0,
          pixelRatio:pr, canvasContextAttributes:{preserveDrawingBuffer:true,antialias:true}, preserveDrawingBuffer:true});
      }catch(e){ console.warn('Milestone 3D: no map',e); fin(t3FlatCap(ar,px)); return; }
      m.on('style.load',function(){ try{ m.setSky(T3_SKY); }catch(e){} });
      /* No elevation (blocked or failing): the route flat on the map, as the lab does. */
      m.on('error',function(e){
        var id=e && (e.sourceId || (e.source && e.source.id));
        if(id==='dem' || id==='demhs'){ demBad++;
          if(!demOk && demBad>=3 && !flat){ flat=true; try{ m.setTerrain(null); m.setLayoutProperty('hs','visibility','none'); }catch(_){} } }
      });
      m.on('sourcedata',function(e){ if(e && e.tile && (e.sourceId==='dem'||e.sourceId==='demhs') && e.tile.state==='loaded') demOk++; });
      m.on('load',function(){
        loaded=true;
        if(cam){ m.jumpTo({center:cam.center, zoom:cam.zoom+Math.log2(cssW/cam.cssW), bearing:cam.bearing, pitch:cam.pitch}); idle(grab); }
        /* the first fit on the flat map (cheap), then the terrain on and a
           re-fit once it is in - it changes the projection */
        else {
          try{ m.setTerrain(null); }catch(e){}
          t3Fit(m,pts,F.box);
          if(!flat){ try{ m.setTerrain({source:'dem',exaggeration:T3_EXAG}); }catch(e){} }
          idle(function(){ if(done) return; t3Fit(m,pts,F.box); idle(grab); });
        }
      });
    });
  }
  /* The fallback: the route in a flat perspective under the same sky, fitted
     to the same box. Marked, so the page and the order can say so. */
  function t3FlatPts(W,H,ar,pts){
    var F=t3Fmt(ar), b=t3S().bear*Math.PI/180, la0=pts[0][1]*Math.PI/180, cb=Math.cos(b), sb=Math.sin(b), i;
    var g=pts.map(function(p){ var x=p[0]*Math.cos(la0), y=p[1]; return [x*cb-y*sb, x*sb+y*cb]; });
    var x0=1e9,x1=-1e9,y0=1e9,y1=-1e9;
    g.forEach(function(q){ if(q[0]<x0)x0=q[0]; if(q[0]>x1)x1=q[0]; if(q[1]<y0)y0=q[1]; if(q[1]>y1)y1=q[1]; });
    var s=Math.max(x1-x0,y1-y0,1e-9);
    var r=g.map(function(q){ var gx=(q[0]-(x0+x1)/2)/s, gy=(y1-q[1])/s, z=1+1.8*(1-gy);   /* gy 0 far .. near */
      return [gx/z, 1/z]; });
    var a0=1e9,a1=-1e9,c0=1e9,c1=-1e9;
    r.forEach(function(q){ if(q[0]<a0)a0=q[0]; if(q[0]>a1)a1=q[0]; if(q[1]<c0)c0=q[1]; if(q[1]>c1)c1=q[1]; });
    var bx0=F.box[0]*W, bx1=F.box[2]*W, by0=F.box[1]*H, by1=F.box[3]*H;
    var k=Math.min((bx1-bx0)/Math.max(a1-a0,1e-9),(by1-by0)/Math.max(c1-c0,1e-9));
    var ox=(bx0+bx1)/2-(a0+a1)/2*k, oy=(by0+by1)/2-(c0+c1)/2*k;
    return r.map(function(q){ return [ox+q[0]*k, oy+q[1]*k]; });
  }
  function t3Sky(ctx,W,H,ar){
    var F=t3Fmt(ar), hz=F.box[1]*H*0.82;
    var g=ctx.createLinearGradient(0,0,0,hz);
    g.addColorStop(0,'#1a2647'); g.addColorStop(0.8,'#4a5f8a'); g.addColorStop(1,'#6f84ad');
    ctx.fillStyle=g; ctx.fillRect(0,0,W,hz);
    var f=ctx.createLinearGradient(0,hz,0,H);
    f.addColorStop(0,'#2a3a5e'); f.addColorStop(0.18,T3_N.land); f.addColorStop(1,'#1e2125');
    ctx.fillStyle=f; ctx.fillRect(0,hz,W,H-hz);
  }
  function t3FlatCap(ar,px){
    var pts=t3Pts(); if(!pts) return null;
    var W=Math.max(200,Math.min(px,1600)), H=Math.round(W/ar), cv=document.createElement('canvas');
    cv.width=W; cv.height=H; t3Sky(cv.getContext('2d'),W,H,ar);
    cv._t3Pts=t3FlatPts(W,H,ar,pts); cv._t3Flat='all'; cv._t3Cam=null;
    return cv;
  }

  /* ---- the bitmaps the page keeps -------------------------------------- */
  function t3Get(key,make,cb){
    if(t3S().caps.hasOwnProperty(key)){ cb(t3S().caps[key]); return; }
    if(t3S().wait[key]){ t3S().wait[key].push(cb); return; }
    var q=[cb], W8=t3S().wait; W8[key]=q;
    make(function(cv){
      if(cv) cv._t3For=key.split('#')[0];
      /* a new route since: answer the callers, keep nothing */
      if(t3S().wait===W8 && W8[key]===q){ delete W8[key]; t3S().caps[key]=cv||null; }
      q.forEach(function(f){ try{ f(cv||null); }catch(e){ console.warn('Milestone 3D:',e); } });
    });
  }
  /* The design's own map for the format on screen (hi: the print render). */
  function t3LoadMap(hi,cb){
    var ar=t3AR(), key=t3Key(ar); if(!key){ cb(null); return; }
    t3Get(key,function(done){ t3Capture(ar,T3_PREV_CSS,2,null,done); },function(base){
      if(!hi || !base || base._t3Flat==='all'){ cb(base); return; }
      t3Get(key+'#hi',function(done){ t3Capture(ar,Math.round(T3_HI_PX/2),2,base._t3Cam,done); },function(cv){
        if(cv && cv._t3Flat!=='all'){ cv._t3Hi=1; cb(cv); } else cb(base);
      });
    });
  }
  /* The phone shapes (wallpaper, reel): their own render, built when a
     digital order or its preview first asks; a repaint when it lands. */
  function t3PhoneAR(w,h){ return w/h; }
  function t3Phone(ar,cb){
    /* only the two phone shapes ever get a render */
    if(Math.abs(ar-WALL_W/WALL_H)>1e-6 && Math.abs(ar-REEL_W/REEL_H)>1e-6){ if(cb) cb(null); return; }
    var key=t3Key(ar); if(!key){ if(cb) cb(null); return; }
    var w=(ar<0.5)?WALL_W:REEL_W, had=t3S().caps.hasOwnProperty(key);
    t3Get(key,function(done){ t3Capture(ar,Math.round(w/2),2,null,done); },function(cv){
      if(cb) cb(cv); else if(!had && cv) render();
    });
  }
  /* 30 Oct (Marc: "when i went from poster, to digital, to magnet, it stopped
     loading the 3d map"): a format switch to another shape (the magnet's 4:5)
     asked for nothing - the map is only asked for when the route or the style
     changes. The page's own preview, finding no render of its shape, asks
     once for that shape (the queue keeps it one WebGL map at a time). */
  function t3Kick(){
    var k=t3Key(); if(!k || state.mapUrl===k || t3S().kick===k) return;
    t3S().kick=k;
    setTimeout(function(){ if(t3On() && t3Key()===k && state.mapUrl!==k) ensureMap(function(){ ensureMap2(render); }); },0);
  }
  function t3ImgFor(ar){
    var im=state.mapImg;
    if(t3On() && im && im._t3Pts && Math.abs(im.width/im.height-ar)<0.01) return im;
    var c=t3S().caps[t3Key(ar)];
    return (c && c._t3Pts) ? c : null;
  }
  /* Wanted until this route and shape's files have been made ready - also
     while the preview render is still running, so an early click waits. */
  function t3HiWanted(){
    return !!(t3On() && t3Pts() && t3S().filesFor!==t3Key());
  }
  function t3PhoneWanted(){
    if(!t3On() || !isDigital(state.product) || !t3Pts()) return false;
    return !t3S().caps.hasOwnProperty(t3Key(WALL_W/WALL_H)) || !t3S().caps.hasOwnProperty(t3Key(REEL_W/REEL_H));
  }
  /* Everything an order's files are made from, before any file is made. */
  function t3EnsureFiles(cb){
    var key=t3Key(), left=1, go=function(){ if(--left===0){ t3S().filesFor=key; cb(); } };
    if(isDigital(state.product)){ left+=2; t3Phone(WALL_W/WALL_H,function(){ go(); }); t3Phone(REEL_W/REEL_H,function(){ go(); }); }
    /* joins the preview render if it is still running, then the print one */
    t3LoadMap(true,function(cv){
      if(cv && cv._t3Pts && t3On() && t3Key()===key){ state.mapImg=cv; state.mapUrl=key; state.mapHiFor=key; }
      go();
    });
  }

  /* ---- drawing ---------------------------------------------------------- */
  function t3Route(ctx,P,n,W,col){
    if(!P || P.length<2) return;
    var s=W/600; n=Math.max(2,Math.min(P.length,n||P.length));
    var path=function(){ ctx.beginPath(); ctx.moveTo(P[0][0],P[0][1]); for(var i=1;i<n;i++) ctx.lineTo(P[i][0],P[i][1]); };
    ctx.save(); ctx.lineJoin='round'; ctx.lineCap='round';
    ctx.save(); ctx.filter='blur('+Math.max(0.5,1.5*s)+'px)'; ctx.strokeStyle='rgba(18,10,6,0.55)'; ctx.lineWidth=(T3_LW+3)*s; path(); ctx.stroke(); ctx.restore();
    ctx.strokeStyle=col; ctx.lineWidth=T3_LW*s; path(); ctx.stroke();
    ctx.restore();
  }
  function t3Dot(ctx,x,y,r,fill,stroke,sw){
    ctx.save(); ctx.shadowColor='rgba(0,0,0,0.45)'; ctx.shadowBlur=r*0.8;
    ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.fillStyle=fill; ctx.fill(); ctx.restore();
    ctx.lineWidth=sw; ctx.strokeStyle=stroke; ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.stroke();
  }
  function t3Flag(ctx,x,y,r,u){
    ctx.save(); ctx.shadowColor='rgba(0,0,0,0.45)'; ctx.shadowBlur=r*0.8;
    ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.fillStyle='#FFFFFF'; ctx.fill(); ctx.restore();
    ctx.save(); ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.clip();
    var n=4, s=2*r/n, i, j; ctx.fillStyle=T3_INK;
    for(i=0;i<n;i++) for(j=0;j<n;j++) if((i+j)%2) ctx.fillRect(x-r+i*s,y-r+j*s,s,s);
    ctx.restore(); ctx.lineWidth=3.5*u; ctx.strokeStyle='#FFFFFF'; ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.stroke();
  }
  /* The route's screen points in this canvas: the bitmap's, scaled with it. */
  function t3Place(ctx,W,H,ar,o){
    o=o||{};
    var pts=t3Pts(); if(!pts) return null;
    /* o.cap: the shape the render was made for (the product's, the phone's) -
       a mockup window or preview a hair off that shape still uses it, cover-fitted */
    var im=(o.cap && t3ImgFor(o.cap)) || t3ImgFor(ar);
    if(im){
      var sc=Math.max(W/im.width,H/im.height), dw=im.width*sc, dh=im.height*sc, dx=(W-dw)/2, dy=(H-dh)/2;
      if(o.alpha!=null){ ctx.save(); ctx.globalAlpha=o.alpha; }
      ctx.drawImage(im,dx,dy,dw,dh);
      if(o.alpha!=null) ctx.restore();
      return { P:im._t3Pts.map(function(p){ return [dx+p[0]*sc, dy+p[1]*sc]; }), flat:im._t3Flat||'',
               N:(im._t3Places||[]).map(function(q){ return { name:q.name, cls:q.cls, end:q.end, x:dx+q.x*sc, y:dy+q.y*sc }; }) };
    }
    t3Sky(ctx,W,H,ar);
    return { P:t3FlatPts(W,H,ar,pts), flat:'wait' };
  }
  /* The Night band: the map fades into ink; place and date, the title, a
     rule, the sport's own stats (and the name), the map credits. */
  function t3Band(ctx,W,H,ar,d,a,marks){
    var F=t3Fmt(ar), u=W/1000, bandY=F.band*H, L=70*u, R=W-70*u, maxW=R-L, y;
    ctx.save(); if(a!=null) ctx.globalAlpha=a;
    var g=ctx.createLinearGradient(0,bandY-0.16*H,0,bandY+0.05*H);
    g.addColorStop(0,'rgba(23,23,26,0)'); g.addColorStop(0.7,'rgba(23,23,26,0.86)'); g.addColorStop(1,'rgba(23,23,26,1)');
    ctx.fillStyle=g; ctx.fillRect(0,bandY-0.16*H,W,H-bandY+0.16*H);
    /* the markers sit on the fade, as in the lab; the route goes under it */
    if(marks){ ctx.save(); ctx.globalAlpha=1; marks(); ctx.restore(); }
    y=bandY+40*u;
    ndText(ctx,[d.loc.toUpperCase(),d.date].filter(Boolean).join('   ·   '),L,y,600,17*u,'#9C9AA2','left',0.2,maxW);
    /* the title, one line or two */
    var t=(d.title||'').toUpperCase(), px=ndFit(ctx,t,800,96*u,maxW*1.7,0), lines=[t];
    ctx.font=ndFont(800,px);
    if(ctx.measureText(t).width>maxW){
      var w=t.split(' '), best=null, i;
      for(i=1;i<w.length;i++){ var A=w.slice(0,i).join(' '), B=w.slice(i).join(' '), mw=Math.max(ctx.measureText(A).width,ctx.measureText(B).width);
        if(!best || mw<best.w) best={w:mw,l:[A,B]}; }
      if(best){ lines=best.l; px=Math.min(px,88*u); px=ndFit(ctx,ctx.measureText(lines[0]).width>ctx.measureText(lines[1]).width?lines[0]:lines[1],800,px,maxW,0); }
      else px=ndFit(ctx,t,800,96*u,maxW,0);
    }
    /* the block has to end above the credit line: a two-line title gives way */
    var room=(H-58*u)-(y+40*u+46*u+48*u), need=px*0.98+(lines.length-1)*px*0.95;
    if(need>room && room>0) px*=room/need;
    y+=px*0.98;
    lines.forEach(function(l,i){ ndText(ctx,l,L,y+i*px*0.95,800,px,T3_PAPER,'left',0,maxW); });
    y+=(lines.length-1)*px*0.95+40*u;
    ctx.fillStyle='rgba(243,239,231,0.16)'; ctx.fillRect(L,y,maxW,Math.max(1,1.2*u)); y+=46*u;
    var cells=d.stats.slice(); if(d.name) cells.push(['ATHLETE',d.name.toUpperCase()]);
    var colW=maxW/Math.max(cells.length,3);
    cells.forEach(function(c,i){ var x=L+i*colW;
      ndText(ctx,c[0],x,y,600,14*u,'#9C9AA2','left',0.18,colW-16*u);
      ndText(ctx,c[1],x,y+48*u,700,40*u,T3_PAPER,'left',0,colW-16*u); });
    /* 29 Oct pm (Marc): no credits on the print - they are on the product page */
    ctx.restore();
  }
  /* The suburb names on the render: the start and finish suburbs first, then
     the rest, clear of the route, the band and each other (tplPlace). */
  function t3Names(ctx,W,H,ar,pl){
    if(!pl || !pl.N || !pl.N.length || typeof tplPlace!=='function') return;
    var F=t3Fmt(ar), step=Math.max(1,Math.floor(pl.P.length/600)), rp=[], i;
    for(i=0;i<pl.P.length;i+=step) rp.push(pl.P[i]);
    /* the start dot and the finish flag are obstacles too, not just the line */
    var u=W/1000, rr=15*u*1.4;
    [pl.P[0], pl.P[pl.P.length-1]].forEach(function(e){ for(var a=0;a<16;a++){ var t=a/16*Math.PI*2;
      rp.push([e[0]+Math.cos(t)*rr, e[1]+Math.sin(t)*rr]); rp.push([e[0]+Math.cos(t)*rr*0.5, e[1]+Math.sin(t)*rr*0.5]); } rp.push(e); });
    tplPlace(ctx,W,H,pl.N,rp,{ S:W/800, k:1.1, dark:true, max:10, keep:[[0,(F.band-0.03)*H,W,H]] });
  }
  function t3Marks(ctx,P,W,H,ar,o){
    o=o||{}; if(!P || P.length<2) return;
    var F=t3Fmt(ar), u=W/1000, r=15*u, bandY=F.band*H, a=P[0], z=P[P.length-1];
    if(o.head!=null){ var h=P[o.head]; t3Dot(ctx,h[0],h[1],r*0.9,'#FFFFFF',o.col,3.5*u); }
    if(o.noStart) return;
    if(a[1]<bandY) t3Dot(ctx,a[0],a[1],r,'#8BE04E','#FFFFFF',3.5*u);
    if(!o.noFinish && z[1]<bandY) t3Flag(ctx,z[0],z[1],r,u);
  }
  function renderT3(ctx,ox,oy,W,H,fillBg){
    /* A mockup's window is rarely the sheet's exact shape (the held poster is
       about 1:1.33). The layout is drawn at the window's shape, edge to edge,
       over the product's own render cover-fitted (29 Oct pm, Marc: no black
       margins); the route box keeps the route clear of what that trims. */
    renderT3Sheet(ctx,ox,oy,W,H);
  }
  function renderT3Sheet(ctx,ox,oy,W,H){
    var d=ndData(), ar=W/H;
    ctx.save(); ctx.translate(ox,oy); ctx.beginPath(); ctx.rect(0,0,W,H); ctx.clip();
    ctx.fillStyle=T3_INK; ctx.fillRect(0,0,W,H);
    if(noRoute()){
      t3Sky(ctx,W,H,ar); var F=t3Fmt(ar);
      drawRoutePrompt(ctx,F.box[0]*W,F.box[1]*H,(F.box[2]-F.box[0])*W,(F.box[3]-F.box[1])*H,true);
    } else {
      var pl=t3Place(ctx,W,H,ar,{cap:t3On()?t3AR():0});
      if(pl){ t3Names(ctx,W,H,ar,pl); t3Route(ctx,pl.P,0,W,d.col);
        /* on the page only: say what the customer is looking at */
        if(_splitHeroPaint && t3On() && pl.flat){
          if(pl.flat==='wait') t3Kick();
          var msg=(pl.flat==='wait')?(t3S().lib<0?'3D maps can’t load in this browser — showing the route flat':'Building the 3D map…')
                 :(pl.flat==='all'?'3D maps can’t load in this browser — showing the route flat':'Relief unavailable — showing the route flat');
          ndText(ctx,msg,W/2,H*0.05,600,Math.max(9,W*0.022),'rgba(243,239,231,0.85)','center',0,W*0.9);
        }
      }
    }
    t3Band(ctx,W,H,ar,d,null,(pl&&pl.P)?function(){ t3Marks(ctx,pl.P,W,H,ar); }:null);
    ctx.restore();
  }
  /* Wallpaper: the phone render, the band at the foot; the clock on the preview. */
  function t3Wallpaper(ctx,W,H,chrome){
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      /* one render for the wallpaper's shape, whatever size the preview is drawn at
         (29 Oct: a render per preview size piled up WebGL maps until the page died) */
      var d=ndData(), ar=W/H, cap=WALL_W/WALL_H;
      if(!t3S().caps.hasOwnProperty(t3Key(cap))) t3Phone(cap);
      ctx.fillStyle=T3_INK; ctx.fillRect(0,0,W,H);
      var pl=noRoute()?null:t3Place(ctx,W,H,ar,{cap:cap});
      if(!pl) t3Sky(ctx,W,H,ar);
      else { t3Names(ctx,W,H,ar,pl); t3Route(ctx,pl.P,0,W,d.col); }
      if(chrome){
        ctx.save(); ctx.textAlign='center'; ctx.fillStyle='rgba(243,239,231,0.9)';
        ctx.font=ndFont(600,W*0.028); ctx.fillText('Saturday 25 October',W/2,W*0.195);
        ctx.font=ndFont(700,W*0.208); ctx.fillText('9:41',W/2,W*0.40); ctx.restore();
      }
      t3Band(ctx,W,H,ar,d,null,pl?function(){ t3Marks(ctx,pl.P,W,H,ar); }:null);
    } finally { _splitHeroPaint=keep; }
  }
  /* The reel: the map fades in, the route draws from the start with a head,
     the finish lands, then the band and type. */
  function t3ReelInto(ctx,X,Y,W,H,t){
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      var d=ndData(), ar=W/H, cap=REEL_W/REEL_H, c=function(v){ return v<0?0:(v>1?1:v); };
      if(!t3S().caps.hasOwnProperty(t3Key(cap))) t3Phone(cap);
      ctx.save(); ctx.beginPath(); ctx.rect(X,Y,W,H); ctx.clip(); ctx.translate(X,Y);
      ctx.fillStyle=T3_INK; ctx.fillRect(0,0,W,H);
      var pl=noRoute()?null:t3Place(ctx,W,H,ar,{alpha:c(t/0.15),cap:cap});
      if(pl){
        var r=c((t-0.12)/0.6), n=Math.max(2,Math.round(r*(pl.P.length-1))+1);
        ctx.save(); ctx.globalAlpha=c(t/0.15); t3Names(ctx,W,H,ar,pl); ctx.restore();
        if(r>0) t3Route(ctx,pl.P,n,W,d.col);
      }
      var ta=c((t-0.72)/0.2);
      /* the fade comes in with the type, so the head and dots stay on top of it */
      t3Band(ctx,W,H,ar,d,ta,(pl && r>0)?function(){ t3Marks(ctx,pl.P,W,H,ar,{head:r<1?n-1:null,col:d.col,noFinish:r<1}); }:null);
      ctx.restore();
    } finally { _splitHeroPaint=keep; }
  }
  function t3Props(props){
    if(!t3On()) return;
    props['Design']='Skyline';   /* 30 Oct pm: 3D is Skyline */
    props['Style']='3D map, illustrated night';
    var im=state.mapImg;
    if(!(im && im._t3Pts) || im._t3Flat==='all') props['3D map']='Flat fallback - rebuild in 3D before printing';
    else if(im._t3Flat) props['3D map']='No relief - rebuild before printing';
  }

  /* ===================== TRIATHLON (milestone-tri-engine.js only) =====================
     A 2x2 poster: swim top left, hero (photo, title, finish time, credit) top
     right, ride bottom left, run bottom right. Each leg has its own map or
     terrain, fitted to its own tile, and a band with its icon, distance, split
     and pace. Ported from triathlon-editorial-generator.html (Triathlon chat,
     15 Oct). The single-route machinery stays idle on this page: state.style
     is Neon, state.coords is empty, and the three legs live here. */
  /* Swim top left, ride bottom left, run bottom right; the hero is cell 1. */
  var TRI_LEGS=[ {key:'swim',name:'Swim',cell:0}, {key:'ride',name:'Ride',cell:2}, {key:'run',name:'Run',cell:3} ];
  function triHex(v,d){ v=String(v||'').trim(); return /^#[0-9a-f]{6}$/i.test(v)?v:d; }
  /* The same colours every single-sport route uses: the section's "Route
     colour by activity" settings (MSC[101..105]), else the sport defaults -
     swim neon pink, ride neon amber, run the brand orange (29 Oct pm). */
  function triSportHex(sk,fallback){
    var S=SPORTS[sk]||{}, c=String(MSC[S.msc]||'').trim();
    if(sk==='cycle' && c.toUpperCase()==='#FF2D9A') c='';   /* the old ride default: now amber */
    if(sk==='swim' && c.toUpperCase()==='#FFD028') c='';    /* the old swim default: now pink */
    if(sk==='run' && !c) c=String(MSC[1]||'').trim();
    return triHex(c, S.col||fallback);
  }
  var TRI_COL={ swim:triSportHex('swim','#FF3DB8'), ride:triSportHex('cycle','#FFB000'), run:triSportHex('run','#FF5A1F') };
  var TRI_THEMES={
    paper:{ bg:'#F3EFE7', ink:'#17171A', muted:'#8A8890', hair:'rgba(23,23,26,0.13)', frame:'rgba(23,23,26,0.20)',
            chip:'#F3EFE7', band:'243,239,231', veil:'rgba(243,239,231,0.16)', casing:'rgba(255,255,255,0.78)',
            tile:'#E9E4D9', slot:'rgba(23,23,26,0.30)',
            ramp:[[164,178,150],[198,204,173],[223,222,199],[238,234,219]], water:[176,201,214] }
  };
  /* The photo tile with no photo in it: Gallery's empty photo panel. */
  var TRI_PHOTO_BG='#E2E2DF', TRI_PHOTO_INK='#17171A', TRI_PHOTO_LBL='#5E5B63';
  /* Geoapify styles offered on this page, by the label each button carries.
     Standard (Geoapify's "basic") is the default background. */
  var TRI_MAPSTYLES={ standard:'klokantech-basic', light:'positron', dark:'dark-matter' };
  var TRI={ sf:true, legs:{swim:null,ride:null,run:null}, mode:'map', mapStyle:'standard', theme:'paper', ttheme:'standard',
            photo:null, photoFile:null, focus:0.45, cache:{}, pending:{}, rects:null, pendingLeg:null,
            routeCode:'', lastErr:'' };
  var TRI_WREF=1950, TRI_TSIZE=256, TRI_TMAXZ=15, TRI_TMAXT=28;
  TRI.fx=0.5; TRI.zoom=1;
  var TRI_DEM='https://s3.amazonaws.com/elevation-tiles-prod/terrarium/';
  function triOn(){ return typeof IS_TRI!=='undefined' && IS_TRI; }

  /* ---- legs ---- */
  function triThin(c,max){
    if(c.length<=max) return c;
    var out=[], step=(c.length-1)/(max-1), i;
    for(i=0;i<max;i++) out.push(c[Math.round(i*step)]);
    out[out.length-1]=c[c.length-1];
    return out;
  }
  function triSetLeg(key,coords,eles,file,src){
    TRI.note='';
    if(!coords || coords.length<2){ TRI.legs[key]=null; }
    else {
      var km=routeKm(coords);
      TRI.legs[key]={ coords:coords, eles:eles||null, draw:triThin(coords,2600), km:km,
                      label:(km<10?km.toFixed(2):km.toFixed(1))+' KM', file:file||null, src:src||'upload', views:{} };
    }
    triSyncUI(); render();
  }
  function triAllIn(){ return !!(TRI.legs.swim && TRI.legs.ride && TRI.legs.run); }

  /* ---- time and pace ---- */
  function triParseTime(v){
    v=String(v||'').trim().replace(/[hm]\s*/gi,':').replace(/s$/i,'').replace(/[.]/g,':');
    if(!v) return 0;
    var p=v.split(':').filter(function(x){ return x!==''; }).map(function(x){ return parseFloat(x); });
    if(!p.length || p.some(isNaN)) return 0;
    if(p.length>=3) return p[0]*3600+p[1]*60+p[2];
    if(p.length===2) return p[0]*60+p[1];
    return p[0]*60;
  }
  function triClock(sec){ sec=Math.round(sec);
    var h=Math.floor(sec/3600), m=Math.floor((sec%3600)/60), s=sec%60;
    return h+':'+('0'+m).slice(-2)+':'+('0'+s).slice(-2); }
  function triMS(sec){ sec=Math.round(sec); return Math.floor(sec/60)+':'+('0'+(sec%60)).slice(-2); }
  function triSplit(key){ var el=$('tri-t'+key.charAt(0).toUpperCase()+key.slice(1)); return triParseTime(el?el.value:''); }
  function triPace(key,km,sec){
    if(!sec||!km) return '';
    if(key==='swim') return triMS(sec/(km*10))+' /100M';
    if(key==='ride') return (km/(sec/3600)).toFixed(1)+' KM/H';
    return triMS(sec/km)+' /KM';
  }
  /* ---- what the customer typed for a leg: distance, time, pace or speed.
     Blank = the GPX's distance, and a pace worked out from distance + time. */
  function triCap(key){ return key.charAt(0).toUpperCase()+key.slice(1); }
  function triVal(pre,key){ var el=$('tri-'+pre+triCap(key)); return el?String(el.value||'').trim():''; }
  function triParseKm(key,v){
    v=String(v||'').trim().toLowerCase().replace(/,/g,'.'); if(!v) return 0;
    var m=/^(\d+(?:\.\d+)?)\s*(km|k|m|mi|miles?)?$/.exec(v); if(!m) return 0;
    var n=parseFloat(m[1]), u=m[2]||'';
    if(u==='m') return n/1000;
    if(u==='mi'||/^mile/.test(u)) return n*1.609344;
    if(!u && key==='swim' && n>=100) return n/1000;              /* "1900" on a swim is metres */
    return n;
  }
  function triKm(key){ var t=triParseKm(key,triVal('d',key)); if(t>0) return t; var d=TRI.legs[key]; return d?d.km:0; }
  function triKmLabel(key){
    var t=triParseKm(key,triVal('d',key));
    if(t>0) return (+t.toFixed(2))+' KM';
    var d=TRI.legs[key]; return d?d.label:'';
  }
  function triTypedPace(key){
    var v=triVal('p',key); if(!v) return '';
    var s=v.toLowerCase().replace(/,/g,'.').replace(/\s+/g,' ');
    if(key==='ride'){
      var m=/^(\d+(?:\.\d+)?)/.exec(s);
      return (m && s.indexOf(':')<0) ? (+parseFloat(m[1]).toFixed(1))+' KM/H' : v.toUpperCase();
    }
    var unit=(key==='swim')?' /100M':' /KM', t=/^(\d{1,2})\s*[:.'\u2019]\s*(\d{2})(?!\d)/.exec(s);
    if(t) return (+t[1])+':'+t[2]+unit;
    if(/^\d{1,2}$/.test(s)) return (+s)+':00'+unit;
    return v.toUpperCase();
  }
  function triLegPace(key){ return triTypedPace(key) || triPace(key,triKm(key),triSplit(key)); }
  function triTotal(){
    var el=$('tri-time'), typed=triParseTime(el?el.value:'');
    if(typed) return typed;
    var sum=0; TRI_LEGS.forEach(function(l){ sum+=triSplit(l.key); });
    if(sum) sum+=triTrans();
    return sum;
  }
  var TRI_MON=['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  function triDate(v){ var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v||''); if(!m) return '';
    return (+m[3])+' '+TRI_MON[(+m[2])-1]+' '+m[1]; }

  /* ---- projection: a view is a centre + fractional zoom for one tile ---- */
  function triLon2u(lon){ return (lon+180)/360*TRI_TSIZE; }
  function triLat2u(lat){ var r=lat*Math.PI/180; return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2*TRI_TSIZE; }
  function triU2lon(u){ return u/TRI_TSIZE*360-180; }
  function triU2lat(u){ var n=Math.PI-2*Math.PI*u/TRI_TSIZE; return 180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))); }
  function triViewFor(coords,pw,ph,padT,padB){
    var minLa=Infinity,maxLa=-Infinity,minLo=Infinity,maxLo=-Infinity,i;
    for(i=0;i<coords.length;i++){
      var la=coords[i][0], lo=coords[i][1];
      if(!isFinite(la)||!isFinite(lo)) continue;
      if(la<minLa)minLa=la; if(la>maxLa)maxLa=la; if(lo<minLo)minLo=lo; if(lo>maxLo)maxLo=lo;
    }
    if(!isFinite(minLa)) return null;
    var x0=triLon2u(minLo), x1=triLon2u(maxLo), y0=triLat2u(maxLa), y1=triLat2u(minLa);
    var spanX=Math.max(x1-x0,1e-9), spanY=Math.max(y1-y0,1e-9);
    var availW=pw*0.80, availH=ph-padT-padB;
    var z=Math.min(Math.log(availW/spanX)/Math.LN2, Math.log(availH/spanY)/Math.LN2);
    z=Math.max(1,Math.min(17.4,z));
    var cy=(y0+y1)/2 + ((padB-padT)/2)/Math.pow(2,z);
    return { z:z, cLon:triU2lon((x0+x1)/2), cLat:triU2lat(cy), pw:Math.round(pw), ph:Math.round(ph) };
  }
  function triProject(v,la,lo){
    var s=Math.pow(2,v.z);
    return [ (triLon2u(lo)-triLon2u(v.cLon))*s + v.pw/2, (triLat2u(la)-triLat2u(v.cLat))*s + v.ph/2 ];
  }

  /* ---- layout, in the canvas's own pixels; every size is a share of W ---- */
  function triLayout(ox,oy,W,H){
    var M=W*0.075, g=W*0.030;
    var cw=(W-M*2-g)/2, ch=(H-M*2-g)/2;
    return { cells:[ {x:ox+M,y:oy+M,w:cw,h:ch}, {x:ox+M+cw+g,y:oy+M,w:cw,h:ch},
                     {x:ox+M,y:oy+M+ch+g,w:cw,h:ch}, {x:ox+M+cw+g,y:oy+M+ch+g,w:cw,h:ch} ] };
  }
  function triBandH(pw){ return pw*0.225; }
  function triAspect(prod){ var p=PRODUCTS[prod||'poster']||PRODUCTS.poster; return p.ar; }
  /* The view a leg gets on this format, at the reference width the maps are
     fetched for (1950 px; the request is at 2x, so ~3900 across the sheet). */
  function triRefView(key,prod){
    var d=TRI.legs[key]; if(!d) return null;
    var man=(TRI.layout==='manifesto'), ak=triAspect(prod).toFixed(3)+(man?'m':'');
    if(d.views[ak]!==undefined) return d.views[ak];
    if(man){   /* 30 Oct: Manifesto's panel, at the same reference width */
      var Wm=TRI_WREF, Hm=Math.round(Wm/triAspect(prod)), P=triManPanel(Wm,Hm);
      d.views[ak]=triViewFor(d.coords,P.w,P.h,P.h*0.10,P.h*0.10);
      return d.views[ak];
    }
    var Wr=TRI_WREF, Hr=Math.round(Wr/triAspect(prod)), L=triLayout(0,0,Wr,Hr), leg=null, i;
    for(i=0;i<TRI_LEGS.length;i++) if(TRI_LEGS[i].key===key) leg=TRI_LEGS[i];
    var cell=L.cells[leg.cell], padT=cell.h*0.09, padB=triBandH(cell.w)+cell.h*0.05;
    d.views[ak]=triViewFor(d.coords,cell.w,cell.h,padT,padB);
    return d.views[ak];
  }

  /* ---- basemaps ---- */
  function triKey(v){
    if(!v) return '';
    if(TRI.mode==='terrain') return 't:'+TRI.ttheme+':'+TTINT+':'+TSHADE+':x'+TERRAIN_EXAG+':'+v.z.toFixed(4)+':'+v.cLat.toFixed(6)+':'+v.cLon.toFixed(6)+':'+v.pw+'x'+v.ph;
    return 'm:'+TRI.mapStyle+':'+v.z.toFixed(4)+':'+v.cLat.toFixed(6)+':'+v.cLon.toFixed(6)+':'+v.pw+'x'+v.ph;
  }
  /* Map mode is stitched from Geoapify's raster tiles, on the same grid and
     the same projection as Terrain - so the legs land exactly where they are
     on the map. (It used to be one static map per leg asked for by centre
     and zoom; Geoapify's static zoom is not the tile zoom, and the streets
     came back shifted and scaled under the route.) The @2x tiles are 512 px
     with type sized for that, so the file prints at 2x like Terrain. */
  var TRI_MAP_MAXT=48, TRI_MAP_MAXZ=19;
  function triTileUrl(st,z,x,y,hi){
    return 'https://maps.geoapify.com/v1/tile/'+st+'/'+z+'/'+x+'/'+y+(hi?'@2x':'')+'.png?apiKey='+MAPKEY;
  }
  function triLoadMap(v,cb){
    if(!MAPKEY){ TRI.lastErr='no map key in the section settings'; cb(null); return; }
    var p=triPlanGrid(v,TRI_MAP_MAXT,TRI_MAP_MAXZ); if(!p){ cb(null); return; }
    var st=TRI_MAPSTYLES[TRI.mapStyle]||TRI_MAPSTYLES.standard, T=TRI_TSIZE*2, W=v.pw*2, H=v.ph*2;
    var mos=document.createElement('canvas'); mos.width=p.nx*T; mos.height=p.ny*T;
    var mc=mos.getContext('2d'); mc.fillStyle=(st==='dark-matter')?'#1B1B1D':'#EDEDEB'; mc.fillRect(0,0,mos.width,mos.height);
    var n=p.nx*p.ny, pending=n, failed=0, done=false;
    function finish(){
      if(done) return; done=true; clearTimeout(to);
      if(failed>n*0.25){ TRI.lastErr='map tiles refused'; console.error('Milestone triathlon: map tiles refused',failed+'/'+n); cb(null); return; }
      var out=document.createElement('canvas'); out.width=Math.round(W); out.height=Math.round(H);
      var oc=out.getContext('2d'); oc.imageSmoothingQuality='high';
      oc.drawImage(mos,p.crop.x*2,p.crop.y*2,p.crop.w*2,p.crop.h*2,0,0,out.width,out.height);
      cb(out);
    }
    var to=setTimeout(function(){ failed=n; finish(); },25000);
    function one(tx,ty,hi){
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){ try{ mc.drawImage(im,tx*T,ty*T,T,T); }catch(e){} if(--pending===0) finish(); };
      im.onerror=function(){ if(hi){ one(tx,ty,false); return; }       /* no 2x for this style: the 1x tile, scaled */
        failed++; if(--pending===0) finish(); };
      im.src=triTileUrl(st,p.z,p.x0+tx,p.y0+ty,hi);
    }
    for(var ty=0;ty<p.ny;ty++) for(var tx=0;tx<p.nx;tx++) one(tx,ty,true);
  }
  /* The tile grid that covers view V at the nearest whole zoom, within a tile
     budget - shared by Map and Terrain. Crop is in 256-px tile units. */
  function triPlanGrid(V,maxT,maxZ){
    var zt=Math.min(maxZ,Math.round(V.z));
    while(zt>=1){
      var sc=Math.pow(2,zt-V.z), rw=V.pw*sc, rh=V.ph*sc;
      var cx=triLon2u(V.cLon)*Math.pow(2,zt), cy=triLat2u(V.cLat)*Math.pow(2,zt);
      var wx0=cx-rw/2, wy0=cy-rh/2;
      var x0=Math.floor(wx0/TRI_TSIZE), x1=Math.floor((wx0+rw-0.0001)/TRI_TSIZE);
      var y0=Math.floor(wy0/TRI_TSIZE), y1=Math.floor((wy0+rh-0.0001)/TRI_TSIZE);
      var nx=x1-x0+1, ny=y1-y0+1;
      if(nx*ny<=maxT) return { z:zt,x0:x0,y0:y0,nx:nx,ny:ny,lat:V.cLat,
        crop:{ x:wx0-x0*TRI_TSIZE, y:wy0-y0*TRI_TSIZE, w:rw, h:rh } };
      zt--;
    }
    return null;
  }
  function triPlanTerrain(v){
    /* Planned at twice the tile's pixels, so the print file is not upscaled. */
    return triPlanGrid({z:v.z+1,cLon:v.cLon,cLat:v.cLat,pw:v.pw*2,ph:v.ph*2},TRI_TMAXT,TRI_TMAXZ);
  }
  /* Terrain is the engine's own: the same DEM + topo tiles, the same painter,
     the same themes (Standard, Midnight, Pine, Plum) as the Terrain design -
     planned on this tile's view, and painted with no route on it (the legs
     are drawn over it here). */
  function triLoadTerrain(v,cb){
    var p=triPlanTerrain(v); if(!p){ cb(null); return; }
    var W=v.pw*2, H=v.ph*2, mw=p.nx*TRI_TSIZE, mh=p.ny*TRI_TSIZE;
    var mos=document.createElement('canvas'); mos.width=mw; mos.height=mh;
    var mc=mos.getContext('2d',{willReadFrequently:true});
    mc.fillStyle='rgb(128,0,0)'; mc.fillRect(0,0,mw,mh);       /* 0 m everywhere */
    var wantMap=(TTINT==='topo' && !!MAPKEY), mmos=null, mmc=null;
    if(wantMap){ mmos=document.createElement('canvas'); mmos.width=mw; mmos.height=mh;
      mmc=mmos.getContext('2d',{willReadFrequently:true}); mmc.fillStyle='#EDEADB'; mmc.fillRect(0,0,mw,mh); }
    var n=p.nx*p.ny, pending=n*(wantMap?2:1), demFailed=0, mapFailed=0, done=false;
    function finish(){
      if(done) return; done=true;
      if(demFailed===n){ cb(null); return; }
      var mapOk=wantMap && mapFailed<n*0.25, keep=state.terrainTheme, out=null;
      state.terrainTheme=TRI.ttheme;
      try{ out=paintTerrain(mos,mc,p,W,H,[],mapOk?mmos:null,mapOk?mmc:null); }
      catch(e){ console.error('Milestone triathlon: terrain failed',e); }
      state.terrainTheme=keep;
      cb(out);
    }
    var to=setTimeout(function(){ demFailed=n; finish(); },25000);
    function grid(url,ctx2,isMap){
      for(var ty=0;ty<p.ny;ty++) for(var tx=0;tx<p.nx;tx++){
        (function(tx,ty){
          var im=new Image(); im.crossOrigin='anonymous';
          im.onload=function(){ try{ ctx2.drawImage(im,tx*TRI_TSIZE,ty*TRI_TSIZE); }catch(e){}
            if(--pending===0){ clearTimeout(to); finish(); } };
          im.onerror=function(){ if(isMap) mapFailed++; else demFailed++; if(--pending===0){ clearTimeout(to); finish(); } };
          im.src=url(p.x0+tx,p.y0+ty);
        })(tx,ty);
      }
    }
    grid(function(x,y){ return TRI_DEM+p.z+'/'+x+'/'+y+'.png'; },mc,false);
    if(wantMap) grid(function(x,y){ return 'https://maps.geoapify.com/v1/tile/osm-bright/'+p.z+'/'+x+'/'+y+'.png?apiKey='+MAPKEY; },mmc,true);
  }
  /* Ask for whatever this format still needs; a render follows each arrival. */
  function triEnsure(prod){
    TRI_LEGS.forEach(function(l){
      var v=triRefView(l.key,prod); if(!v) return;
      var k=triKey(v);
      if(TRI.cache.hasOwnProperty(k) || TRI.pending[k]) return;
      TRI.pending[k]=true;
      var got=function(b){ delete TRI.pending[k]; TRI.cache[k]=b||null; triStatus(); render(); };
      if(TRI.mode==='terrain') triLoadTerrain(v,got); else triLoadMap(v,got);
    });
    triStatus();
  }
  /* For the product generator: resolves once this format's maps are in. */
  function triReady(prod){
    return new Promise(function(res){
      triEnsure(prod); var t0=Date.now();
      (function wait(){ if(!triBusy(prod) || Date.now()-t0>45000) res(); else setTimeout(wait,250); })();
    });
  }
  function triMissing(prod){
    var miss=false;
    TRI_LEGS.forEach(function(l){ var v=triRefView(l.key,prod); if(!v){ miss=true; return; }
      var k=triKey(v); if(!TRI.cache[k]) miss=true; });
    return miss;
  }
  function triBusy(prod){
    var busy=false;
    TRI_LEGS.forEach(function(l){ var v=triRefView(l.key,prod); if(v && TRI.pending[triKey(v)]) busy=true; });
    return busy;
  }
  function triStatus(){
    var el=$('tri-status'); if(!el) return;
    if(TRI.layout==='finisher'){ el.style.display='none'; return; }
    var prod=(typeof focusProd==='function'?focusProd():state.product)||'poster';
    var busy=triBusy(prod), miss=[];
    TRI_LEGS.forEach(function(l){ var v=triRefView(l.key,prod); if(v){ var k=triKey(v);
      if(TRI.cache.hasOwnProperty(k) && !TRI.cache[k]) miss.push(l.name.toLowerCase()); } });
    var t=busy?(TRI.mode==='terrain'?'Building terrain…':'Loading maps…')
          :(miss.length?((TRI.mode==='terrain'?'Terrain':'The map')+' didn’t load for the '+miss.join(', ')+' — the route is still drawn.'):(TRI.note||''));
    el.textContent=t; el.style.display=t?'block':'none';
  }

  /* ---- drawing ---- */
  function triTracked(c,str,tx,ty,px,align){
    var i,w=0,ch=String(str).split('');
    for(i=0;i<ch.length;i++) w+=c.measureText(ch[i]).width+(i<ch.length-1?px:0);
    var prev=c.textAlign; c.textAlign='left';
    var cx=tx; if(align==='center') cx=tx-w/2; else if(align==='right') cx=tx-w;
    for(i=0;i<ch.length;i++){ c.fillText(ch[i],cx,ty); cx+=c.measureText(ch[i]).width+px; }
    c.textAlign=prev; return w;
  }
  function triTrackedW(c,str,px){ var i,w=0,ch=String(str).split('');
    for(i=0;i<ch.length;i++) w+=c.measureText(ch[i]).width+(i<ch.length-1?px:0); return w; }
  function triFitLines(c,text,maxW,startPx,maxLines,weight){
    var size=startPx, words=String(text).split(/\s+/).filter(Boolean), lines, i, floor=startPx*0.18;
    while(size>floor){
      c.font=weight+' '+size+'px Inter,Arial,sans-serif';
      lines=[]; var cur='';
      for(i=0;i<words.length;i++){ var trial=cur?cur+' '+words[i]:words[i];
        if(c.measureText(trial).width<=maxW || !cur) cur=trial; else { lines.push(cur); cur=words[i]; } }
      if(cur) lines.push(cur);
      var over=false; for(i=0;i<lines.length;i++) if(c.measureText(lines[i]).width>maxW) over=true;
      if(lines.length<=maxLines && !over) return { size:size, lines:lines };
      size*=0.95;
    }
    return { size:size, lines:[String(text)] };
  }
  function triFitOne(c,text,maxW,startPx,weight){
    var size=startPx, floor=startPx*0.15;
    while(size>floor){ c.font=weight+' '+size+'px Inter,Arial,sans-serif'; if(c.measureText(text).width<=maxW) break; size*=0.96; }
    return size;
  }
  function triShoe(c,s){
    c.lineWidth=s*0.075;
    c.beginPath();
    c.moveTo(-0.50*s,0.10*s); c.quadraticCurveTo(-0.52*s,-0.12*s,-0.44*s,-0.30*s);
    c.lineTo(-0.31*s,-0.20*s); c.lineTo(-0.12*s,-0.32*s); c.lineTo(-0.06*s,-0.31*s);
    c.lineTo(0.17*s,-0.02*s); c.lineTo(0.46*s,0.02*s);
    c.quadraticCurveTo(0.55*s,0.06*s,0.50*s,0.17*s); c.lineTo(-0.46*s,0.17*s); c.closePath(); c.stroke();
    c.lineWidth=s*0.055; c.beginPath(); c.moveTo(-0.47*s,0.05*s); c.quadraticCurveTo(0,0.09*s,0.47*s,0.07*s); c.stroke();
    c.lineWidth=s*0.050;
    var fx=-0.06, fy=-0.31, gx=0.17, gy=-0.02, nx=-0.79, ny=0.61, L=0.13, t;
    c.beginPath();
    for(t=0.2;t<0.9;t+=0.2){ var px=fx+(gx-fx)*t, py=fy+(gy-fy)*t; c.moveTo(px*s,py*s); c.lineTo((px+nx*L)*s,(py+ny*L)*s); }
    c.stroke();
  }
  function triIcon(c,kind,cx,cy,s,col){
    c.save(); c.translate(cx,cy); c.strokeStyle=col; c.fillStyle=col; c.lineCap='round'; c.lineJoin='round';
    if(kind==='swim'){
      c.lineWidth=s*0.115;
      for(var w=0;w<3;w++){ var y=(-0.24+w*0.24)*s; c.beginPath(); c.moveTo(-0.44*s,y);
        c.quadraticCurveTo(-0.30*s,y-0.13*s,-0.15*s,y); c.quadraticCurveTo(0.00*s,y+0.13*s,0.15*s,y);
        c.quadraticCurveTo(0.30*s,y-0.13*s,0.44*s,y); c.stroke(); }
    } else if(kind==='ride'){
      c.lineWidth=s*0.085;
      c.beginPath(); c.arc(-s*0.30,s*0.18,s*0.235,0,6.2832); c.stroke();
      c.beginPath(); c.arc(s*0.30,s*0.18,s*0.235,0,6.2832); c.stroke();
      c.beginPath();
      c.moveTo(-s*0.30,s*0.18); c.lineTo(-s*0.10,-s*0.20); c.lineTo(s*0.22,-s*0.20); c.lineTo(s*0.02,s*0.18); c.lineTo(-s*0.30,s*0.18);
      c.moveTo(s*0.22,-s*0.20); c.lineTo(s*0.30,s*0.18); c.moveTo(-s*0.10,-s*0.20); c.lineTo(s*0.02,s*0.18);
      c.moveTo(-s*0.19,-s*0.25); c.lineTo(-s*0.03,-s*0.25); c.moveTo(s*0.16,-s*0.26); c.lineTo(s*0.29,-s*0.23);
      c.stroke();
      c.beginPath(); c.arc(s*0.02,s*0.18,s*0.055,0,6.2832); c.fill();
    } else {
      c.save(); c.translate(0.08*s,-0.06*s); c.rotate(33*Math.PI/180); triShoe(c,s*0.80); c.restore();
      c.lineWidth=s*0.055; c.beginPath();
      c.moveTo(-0.52*s,0.02*s); c.lineTo(-0.42*s,0.02*s); c.moveTo(-0.54*s,0.14*s); c.lineTo(-0.38*s,0.14*s);
      c.moveTo(-0.52*s,0.26*s); c.lineTo(-0.30*s,0.26*s); c.stroke();
    }
    c.restore();
  }
  function triDrawRoute(c,v,coords,col,TH,pw){
    var pts=[],i;
    for(i=0;i<coords.length;i++) pts.push(triProject(v,coords[i][0],coords[i][1]));
    c.lineJoin='round'; c.lineCap='round';
    c.strokeStyle=(TRI.mode==='terrain')?'rgba(0,0,0,0.35)':TH.casing; c.lineWidth=Math.max(1,pw*0.025);
    c.beginPath(); c.moveTo(pts[0][0],pts[0][1]); for(i=1;i<pts.length;i++) c.lineTo(pts[i][0],pts[i][1]); c.stroke();
    c.strokeStyle=col; c.lineWidth=Math.max(0.6,pw*0.0135);
    c.beginPath(); c.moveTo(pts[0][0],pts[0][1]); for(i=1;i<pts.length;i++) c.lineTo(pts[i][0],pts[i][1]); c.stroke();
  }
  function triBand(c,leg,pw,ph,TH){
    var d=TRI.legs[leg.key], bh=triBandH(pw), by=ph-bh, pad=pw*0.055;
    c.fillStyle='rgba('+TH.band+',0.93)'; c.fillRect(0,by,pw,bh);
    c.strokeStyle=TH.hair; c.lineWidth=Math.max(0.5,pw*0.0023);
    c.beginPath(); c.moveTo(0,by); c.lineTo(pw,by); c.stroke();
    var col=TRI_COL[leg.key], cy=by+bh*0.50, s=pw*0.115;
    triIcon(c,leg.key,pad+s*0.5,cy,s,d?col:TH.muted);
    var tx=pad+s+pw*0.035;
    c.textAlign='left';
    c.fillStyle=TH.muted; c.font='700 '+(pw*0.030)+'px Inter,Arial,sans-serif';
    triTracked(c,leg.name.toUpperCase(),tx,cy-pw*0.016,pw*0.011,'left');
    c.fillStyle=TH.ink; c.font='800 '+(pw*0.052)+'px Inter,Arial,sans-serif';
    c.fillText(triKmLabel(leg.key)||'—',tx,cy+pw*0.047);
    var sec=triSplit(leg.key), pc=triLegPace(leg.key), rx=pw-pad;
    if(sec){
      c.fillStyle=TH.ink; c.font='800 '+(pw*0.052)+'px Inter,Arial,sans-serif';
      c.textAlign='right'; c.fillText(triClock(sec),rx,cy-pw*0.008); c.textAlign='left';
    }
    if(pc){ c.fillStyle=TH.muted; c.font='700 '+(pw*0.028)+'px Inter,Arial,sans-serif'; triTracked(c,pc,rx,cy+pw*0.050,pw*0.008,'right'); }
  }
  /* The empty leg: the same dashed slot as the single-route page. */
  function triSlot(c,leg,pw,h,TH){
    c.save();
    c.strokeStyle=TH.slot; var u=Math.min(pw,h);
    c.setLineDash([u*0.035,u*0.035]); c.lineWidth=Math.max(0.5,u*0.007);
    c.strokeRect(pw*0.07,h*0.08,pw*0.86,h*0.84); c.setLineDash([]);
    c.textAlign='center';
    var t1='+  ADD YOUR '+leg.name.toUpperCase()+' GPX', ps=pw*0.060, g=0;
    c.font='700 '+ps+'px Inter,Arial,sans-serif';
    while(c.measureText(t1).width>pw*0.78 && g++<60){ ps*=0.94; c.font='700 '+ps+'px Inter,Arial,sans-serif'; }
    c.fillStyle=TH.ink; c.fillText(t1,pw/2,h/2);
    c.font='500 '+(ps*0.52)+'px Inter,Arial,sans-serif'; c.fillStyle=TH.muted;
    c.fillText('tap here to upload',pw/2,h/2+ps*1.05);
    c.restore();
  }
  function triCell(c,leg,rect,TH,prod){
    var d=TRI.legs[leg.key], pw=rect.w, ph=rect.h, rv=d?triRefView(leg.key,prod):null, base=null, v=null;
    c.save(); c.beginPath(); c.rect(rect.x,rect.y,pw,ph); c.clip(); c.translate(rect.x,rect.y);
    c.fillStyle=TH.tile; c.fillRect(0,0,pw,ph);
    var bx=0, by=0, bw=pw, bh=ph;
    if(rv){
      var sv=rv, k=triKey(rv); base=TRI.cache[k]||null;
      if(!base){
        var fb=triBorrow(leg.key,rv);
        if(fb){ base=fb.base; sv=fb.v; bw=fb.vv.pw*fb.s*(pw/rv.pw); bh=fb.vv.ph*fb.s*(pw/rv.pw); bx=(pw-bw)/2; by=(ph-bh)/2; }
      }
      v={ z:sv.z+Math.log(pw/sv.pw)/Math.LN2, cLon:sv.cLon, cLat:sv.cLat, pw:pw, ph:ph };
    }
    if(base){ c.drawImage(base,bx,by,bw,bh); }
    if(base){ c.fillStyle=TH.veil; c.fillRect(0,0,pw,ph); }
    if(d && v) triDrawRoute(c,v,d.draw,TRI_COL[leg.key],TH,pw);
    if(d && v && d.draw.length>1) triSfIcons(c,triProject(v,d.draw[0][0],d.draw[0][1]),triProject(v,d.draw[d.draw.length-1][0],d.draw[d.draw.length-1][1]),pw*2.2,pw);
    if(!d) triSlot(c,leg,pw,ph-triBandH(pw),TH);
    triBand(c,leg,pw,ph,TH);
    c.restore();
    c.strokeStyle=TH.frame; c.lineWidth=Math.max(0.5,pw*0.0023);
    c.strokeRect(rect.x+c.lineWidth/2,rect.y+c.lineWidth/2,pw-c.lineWidth,ph-c.lineWidth);
  }
  /* A loaded map of another format's shape for this leg (same background and
     style), and the view that covers this tile with it: same centre, zoomed by
     s >= the larger of the two size ratios. */
  function triBorrow(key,rv){
    var d=TRI.legs[key]; if(!d||!d.views) return null;
    var best=null, ar=rv.pw/rv.ph;
    Object.keys(d.views).forEach(function(ak){
      var vv=d.views[ak]; if(!vv || vv===rv) return;
      var bb=TRI.cache[triKey(vv)]; if(!bb) return;
      var diff=Math.abs(vv.pw/vv.ph-ar);
      if(!best || diff<best.diff) best={ base:bb, vv:vv, diff:diff };
    });
    if(!best) return null;
    var vv=best.vv, s=Math.max(rv.pw/vv.pw, rv.ph/vv.ph);
    return { base:best.base, vv:vv, s:s, v:{ z:vv.z+Math.log(s)/Math.LN2, cLon:vv.cLon, cLat:vv.cLat, pw:rv.pw, ph:rv.ph } };
  }
  /* The photo in a rect: cover-fitted, zoomed, placed by TRI.fx / TRI.focus -
     Gallery's rules (drag to place, pinch or the slider to zoom). At zoom 1,
     centred across, this is exactly the draw it replaced. */
  var TRI_ZOOM_MAX=4, TRI_ZOOM_DPI=150;
  function triPhotoGeom(im,w,h){
    var z=Math.max(1,Math.min(TRI.zoom||1,triZoomCap()));
    var s=Math.max(w/im.width,h/im.height)*z, dw=im.width*s, dh=im.height*s;
    return { dw:dw, dh:dh, dx:-(dw-w)*TRI.fx, dy:-(dh-h)*TRI.focus };
  }
  /* How far the photo can zoom before it prints under 150 DPI in its place on
     this format: the grid's photo tile is 4.8 x 7.2 in on the A3, the
     Finisher's photo 11.69 x 9.1 in; other sheets scale by width. */
  function triZoomCap(){
    var im=TRI.photo; if(!im) return TRI_ZOOM_MAX;
    var sh=[11.69,16.54]; try{ sh=galSheet(state.product||'poster'); }catch(e){}
    var k=sh[0]/11.69, fin=(TRI.layout==='finisher');
    var d1=Math.min(im.width/((fin?11.69:4.8)*k), im.height/((fin?9.1:7.2)*k));
    return Math.max(1,Math.min(TRI_ZOOM_MAX,d1/TRI_ZOOM_DPI));
  }
  function triZoomUI(){
    var zr=$('tri-zoom'); if(!zr) return;
    var cap=triZoomCap(); TRI.zoom=Math.max(1,Math.min(TRI.zoom||1,cap));
    zr.max=String(Math.max(100,Math.round(cap*100))); zr.value=String(Math.round(TRI.zoom*100)); zr.disabled=(cap<=1.001);
  }
  function triPhotoReset(){ TRI.fx=0.5; TRI.focus=0.45; TRI.zoom=1; triZoomUI(); }
  function triHero(c,rect,TH){
    var x=rect.x, y=rect.y, w=rect.w, h=rect.h, pad=w*0.065, ix=x+pad, iw=w-pad*2;
    var photo=TRI.photo, onPhoto=!!photo;
    c.save(); c.beginPath(); c.rect(x,y,w,h); c.clip();
    if(onPhoto){
      var _pg=triPhotoGeom(photo,w,h);
      c.drawImage(photo, x+_pg.dx, y+_pg.dy, _pg.dw, _pg.dh);
      var g=c.createLinearGradient(0,y+h*0.30,0,y+h);
      g.addColorStop(0,'rgba(10,10,12,0)'); g.addColorStop(0.45,'rgba(10,10,12,0.42)'); g.addColorStop(1,'rgba(10,10,12,0.86)');
      c.fillStyle=g; c.fillRect(x,y,w,h);
    } else { c.fillStyle=TRI_PHOTO_BG; c.fillRect(x,y,w,h); }
    var fg=onPhoto?'#FFFFFF':TRI_PHOTO_INK, dim=onPhoto?'rgba(255,255,255,0.72)':TRI_PHOTO_LBL;
    c.textAlign='left'; c.textBaseline='alphabetic';
    var bits=[], nm=(edtVal('cz-name')||'').trim(), loc=(($('cz-loc')||{}).value||'').trim(), dt=triDate(($('cz-date')||{}).value);
    if(nm) bits.push(nm.toUpperCase()); if(loc) bits.push(loc.toUpperCase()); if(dt) bits.push(dt);
    var creditY=y+h-pad, creditH=0;
    if(bits.length){
      var sep='   ·   ', one=bits.join(sep), size=w*0.032, tr=w*0.009;
      c.fillStyle=dim; c.font='700 '+size+'px Inter,Arial,sans-serif';
      while(size>w*0.022 && triTrackedW(c,one,tr)>iw){ size*=0.96; tr=size*0.28; c.font='700 '+size+'px Inter,Arial,sans-serif'; }
      if(triTrackedW(c,one,tr)<=iw){ triTracked(c,one,ix,creditY,tr,'left'); creditH=size*1.9; }
      else {
        var head=bits[0], tail=bits.slice(1).join(sep); size=w*0.030; tr=size*0.28; c.font='700 '+size+'px Inter,Arial,sans-serif';
        while(size>w*0.020 && (triTrackedW(c,head,tr)>iw || triTrackedW(c,tail,tr)>iw)){ size*=0.96; tr=size*0.28; c.font='700 '+size+'px Inter,Arial,sans-serif'; }
        triTracked(c,tail,ix,creditY,tr,'left'); triTracked(c,head,ix,creditY-size*1.45,tr,'left');
        creditH=size*1.45+size*1.9;
      }
    }
    var _ttr=triTrans();
    if(_ttr){
      var _tl='TRANSITIONS  '+triShort(_ttr), _tz=w*0.030, _tk=_tz*0.28;
      c.font='700 '+_tz+'px Inter,Arial,sans-serif';
      while(_tz>w*0.020 && triTrackedW(c,_tl,_tk)>iw){ _tz*=0.96; _tk=_tz*0.28; c.font='700 '+_tz+'px Inter,Arial,sans-serif'; }
      c.fillStyle=onPhoto?'#FF7A45':'#E04A12';
      triTracked(c,_tl,ix,creditY-creditH,_tk,'left'); creditH+=_tz*1.9;
    }
    var sec=triTotal(), big='';
    if(sec) big=triClock(sec);
    else { var tot=0, any=false; TRI_LEGS.forEach(function(l){ var kk=triKm(l.key); if(kk>0){ tot+=kk; any=true; } }); big=any?(tot.toFixed(1)+' KM'):''; }
    var timeY=creditY-(creditH||0), topY=timeY;
    if(big){ var bs=triFitOne(c,big,iw,w*0.215,'800'); c.fillStyle=fg; c.font='800 '+bs+'px Inter,Arial,sans-serif'; c.fillText(big,ix,timeY); topY=timeY-bs*0.75; timeY-=bs*0.90; }
    var title=((($('cz-title')||{}).value)||'').trim().toUpperCase();
    if(title){
      var fit=triFitLines(c,title,iw,w*0.105,3,'800');
      c.fillStyle=fg; c.font='800 '+fit.size+'px Inter,Arial,sans-serif';
      var ty=timeY-w*0.040;
      for(var j=fit.lines.length-1;j>=0;j--){ c.fillText(fit.lines[j],ix,ty); topY=ty-fit.size*0.75; ty-=fit.size*1.02; }
    }
    if(!onPhoto && _splitHeroPaint){
      /* Preview only - a finished file never says "add": Gallery's dashed
         photo box and words, in the space above the title. */
      var bx=x+pad*0.6, by=y+pad*0.6, bw=w-pad*1.2, bh=(topY-pad*0.7)-by;
      if(bh>w*0.25){
        c.save(); c.strokeStyle='rgba(23,23,26,0.28)'; c.setLineDash([w*0.03,w*0.03]); c.lineWidth=Math.max(1,w*0.006);
        c.strokeRect(bx,by,bw,bh); c.restore();
        c.textAlign='center';
        var t1='+  ADD YOUR PHOTO', ps=w*0.075, g2=0;
        c.font='700 '+ps+'px Inter,Arial,sans-serif';
        while(c.measureText(t1).width>bw*0.84 && ps>7 && g2++<60){ ps*=0.95; c.font='700 '+ps+'px Inter,Arial,sans-serif'; }
        c.fillStyle=TRI_PHOTO_INK; c.fillText(t1,bx+bw/2,by+bh/2-ps*0.25);
        c.fillStyle=TRI_PHOTO_LBL; c.font='500 '+Math.max(6,ps*0.54)+'px Inter,Arial,sans-serif';
        c.fillText('tap here to upload \u00b7 optional',bx+bw/2,by+bh/2+ps*0.95);
        c.textAlign='left';
      }
    }
    c.restore();
    c.strokeStyle=TH.frame; c.lineWidth=Math.max(0.5,w*0.0023);
    c.strokeRect(x+c.lineWidth/2,y+c.lineWidth/2,w-c.lineWidth,h-c.lineWidth);
  }
  /* ---- the Finisher design (20 Oct): the splits card ----------------------
     The finish photo across the top, fading into a dark ground; the event's
     finisher line, the finish time, the name, place and date, transitions;
     then the three legs as glowing lines, each with its distance, split and
     pace. One layout for every format: everything is a share of the width,
     the block sits on the bottom margin, and the photo takes what is left
     above it. With no photo the block moves up and the legs grow into the
     space; the preview alone shows the dashed "+ ADD YOUR PHOTO" box.
     ?layout=finisher opens on it. ?brand=1 (not offered anywhere on the page)
     prints MYMILESTONE.COM.AU and adds a 1080 x 1920 download, for giveaway
     cards. */
  var TRI_FIN={ bg:'#0E0E10', ink:'#F2EFE8', dim:'#9A989F', faint:'#6E6C73', acc:'#FF5A1F', edge:'rgba(255,255,255,0.32)' };
  var TRI_BRAND=/^(1|true|yes|on)$/i.test(String(getParam('brand')||'').trim());
  TRI.layout=(function(v){ return (v==='finisher'||v==='manifesto')?v:'grid'; })(String(getParam('layout')||'').trim().toLowerCase());
  /* T1 and T2, each typed like a split; the designs print the total. */
  function triT(n){ var el=$('tri-t'+n); return triParseTime(el?el.value:''); }
  function triTrans(){ return triT(1)+triT(2); }
  function triShort(sec){ sec=Math.round(sec); return sec>=3600?triClock(sec):triMS(sec); }
  var TRI_DOW=['SUN','MON','TUE','WED','THU','FRI','SAT'];
  function triFinDate(v){
    var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v||''); if(!m) return '';
    var d=new Date(+m[1],(+m[2])-1,+m[3]);
    return TRI_DOW[d.getDay()]+' '+m[3]+'.'+m[2]+'.'+m[1];
  }
  /* 2 Nov: the place in the Manifesto sentence. The title less its whole
     trailing distance group ("Noosa 1.5/40/10K" -> "Noosa"); when that still
     carries a number or a slash, or leaves nothing, the location instead. */
  function triPlace(t){
    t=String(t||'').trim();
    var p=t.replace(/[\s\u00b7\-\u2013,]*(?:\d+(?:[.,]\d+)?\s*(?:k|km|m|mi)?\s*[\/|+]\s*)*\d+(?:[.,]\d+)?\s*(?:k|km|m|mi|miles?)?\.?\s*$/i,'').trim();
    if(!p || /[\d\/]/.test(p)) p=triLocHead();
    return p;
  }
  function triLocHead(){ return String((($('cz-loc')||{}).value)||'').split(',')[0].trim(); }
  /* "Port Macquarie 113K" at Port Macquarie -> "113K FINISHER": the place is
     already on the line under the name. */
  function triFinLabel(){ return String((($('cz-title')||{}).value)||'').trim().toUpperCase(); }
  /* "1.9K", "90K", "21.1K", "180K" - the leg's distance as the card says it. */
  function triFinKm(key){
    var km=triKm(key); if(!(km>0)) return '';
    return (km>=100 ? String(Math.round(km)) : String(+km.toFixed(1)))+'K';
  }
  function triFinTotal(){
    var sec=triTotal(); if(sec) return triClock(sec);
    var tot=0, any=false; TRI_LEGS.forEach(function(l){ var k=triKm(l.key); if(k>0){ tot+=k; any=true; } });
    return any ? (tot.toFixed(1)+' KM') : '';
  }
  function triMono(sz,wt){ return (wt||400)+' '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace'; }
  function triSans(sz,wt){ return (wt||800)+' '+sz+'px Inter,Arial,sans-serif'; }
  function triCond(sz,wt){ return (wt||700)+' '+sz+'px Oswald,"Arial Narrow",sans-serif'; }
  /* Tracked text shrunk to fit maxW; returns the size used. */
  function triFitTracked(c,txt,fontFn,size,trk,maxW,floor){
    var g=0; c.font=fontFn(size);
    while(triTrackedW(c,txt,size*trk)>maxW && size>floor && g++<80){ size*=0.96; c.font=fontFn(size); }
    return size;
  }
  /* The geometry, top to bottom, in px of this artwork. */
  function triFinLayout(ox,oy,W,H,hasPhoto){
    var u=W, M=u*0.08, inner=W-2*M, story=(H/W)>=1.6;
    var B=story?u*0.245:u*0.075;
    var name=String(edtVal('cz-name')||'').trim(), tr=triTrans(), big=triFinTotal();
    var L={ u:u, M:M, inner:inner, lx:ox+M, cx:ox+W/2, B:B };
    /* the block, measured from its top; each entry is a baseline */
    var y=0, rows={};
    rows.label=y+u*0.020;             y=rows.label;
    if(big){ rows.time=y+u*0.198; y=rows.time; rows.rule=y+u*0.030; y=rows.rule; }
    if(name){ rows.name=y+u*(big?0.094:0.070); y=rows.name; }
    rows.credit=y+u*0.051;            y=rows.credit;
    if(tr){ rows.trans=y+u*0.040; y=rows.trans; }
    var legTop=y+u*0.037, Rh=u*0.213;
    var after=u*0.039+u*0.054+u*0.039+(TRI_BRAND?u*0.068:0)+u*0.010;
    var C=(legTop+Rh+after);
    var top;
    if(hasPhoto){
      top=oy+H-B-C;
      /* a short format leaves the photo very little: the legs give some back */
      var minTop=u*0.30;
      if(top-oy<minTop){ var give=Math.min(Rh-u*0.15,minTop-(top-oy)); if(give>0){ Rh-=give; C-=give; top+=give; } }
    } else {
      var head=u*0.17, E=H-B-C-head;
      if(E>0){ var grow=Math.min(E*0.6,u*0.16); Rh+=grow; C+=grow; E-=grow; }
      top=oy+head+Math.max(0,E)*0.5;
    }
    L.top=top; L.rows={};
    for(var k in rows) L.rows[k]=top+rows[k];
    L.legTop=top+legTop; L.Rh=Rh;
    var gap=u*0.040, cw=(inner-2*gap)/3;
    L.cols=[0,1,2].map(function(i){ return { x:ox+M+i*(cw+gap), w:cw }; });
    L.legLbl=L.legTop+Rh+u*0.039; L.legTime=L.legLbl+u*0.054; L.legPace=L.legTime+u*0.039;
    L.url=L.legPace+u*0.068;
    L.photoH=Math.min(H, (top-oy)+u*0.25);
    L.fadeA=Math.max(0,(top-oy)-u*0.10); L.fadeB=L.photoH;
    L.prompt={ x:ox+M, y:oy+u*0.045, w:inner, h:Math.max(u*0.08,(top-oy)-u*0.09) };
    return L;
  }
  /* The photo, cover-fitted to the top, fading to transparent at the bottom:
     on the dark ground it fades into the ground, on a tee into the shirt. */
  function triFinPhoto(c,ox,oy,W,L){
    var im=TRI.photo, h=Math.round(L.photoH); if(!im || h<2) return;
    var cv=document.createElement('canvas'); cv.width=Math.max(2,Math.round(W)); cv.height=h;
    var x=cv.getContext('2d'), pg=triPhotoGeom(im,cv.width,h);
    x.drawImage(im,pg.dx,pg.dy,pg.dw,pg.dh);
    x.globalCompositeOperation='destination-in';
    var g=x.createLinearGradient(0,L.fadeA,0,L.fadeB);
    g.addColorStop(0,'rgba(0,0,0,1)'); g.addColorStop(0.55,'rgba(0,0,0,0.55)'); g.addColorStop(1,'rgba(0,0,0,0)');
    x.fillStyle=g; x.fillRect(0,0,cv.width,h);
    c.drawImage(cv,ox,oy,W,h);
  }
  /* One leg: its line fitted to the box, glowing in its colour, with a white
     marker where it starts. */
  function triFinRoute(c,key,box,u){
    var d=TRI.legs[key], col=TRI_COL[key];
    if(!d){
      c.save(); c.strokeStyle=TRI_FIN.edge; c.setLineDash([u*0.012,u*0.012]); c.lineWidth=Math.max(1,u*0.002);
      c.strokeRect(box.x+box.w*0.06,box.y+box.h*0.06,box.w*0.88,box.h*0.88); c.setLineDash([]);
      c.textAlign='center'; c.fillStyle=TRI_FIN.dim;
      var t='+ '+key.toUpperCase()+' GPX', s=triFitTracked(c,t,function(z){ return triMono(z,500); },u*0.020,0.12,box.w*0.78,u*0.008);
      c.font=triMono(s,500); triTracked(c,t,box.x+box.w/2,box.y+box.h/2+s*0.35,s*0.12,'center');
      c.restore(); return;
    }
    var pts=d.draw, la=0, i;
    for(i=0;i<pts.length;i++) la+=pts[i][0]; la/=pts.length;
    var k=Math.cos(la*Math.PI/180), x0=Infinity,x1=-Infinity,y0=Infinity,y1=-Infinity;
    for(i=0;i<pts.length;i++){ var px=pts[i][1]*k, py=pts[i][0];
      if(px<x0)x0=px; if(px>x1)x1=px; if(py<y0)y0=py; if(py>y1)y1=py; }
    var sx=Math.max(x1-x0,1e-9), sy=Math.max(y1-y0,1e-9), pad=u*0.022;
    var sc=Math.min((box.w-2*pad)/sx,(box.h-2*pad)/sy), dx=box.x+(box.w-sx*sc)/2, dy=box.y+(box.h-sy*sc)/2;
    function P(p){ return [dx+(p[1]*k-x0)*sc, dy+(y1-p[0])*sc]; }
    c.save(); c.lineJoin='round'; c.lineCap='round';
    function path(){ c.beginPath(); var a=P(pts[0]); c.moveTo(a[0],a[1]); for(var j=1;j<pts.length;j++){ var q=P(pts[j]); c.lineTo(q[0],q[1]); } }
    c.strokeStyle=col; c.lineWidth=Math.max(1.2,u*0.0060);
    c.shadowColor=col; c.shadowBlur=u*0.024; path(); c.stroke();
    c.shadowBlur=u*0.010; path(); c.stroke();
    c.shadowBlur=0; path(); c.stroke();
    var s0=P(pts[0]), r=Math.max(2,u*0.0085);
    c.beginPath(); c.arc(s0[0],s0[1],r,0,6.2832); c.fillStyle=TRI_FIN.ink; c.fill();
    c.beginPath(); c.arc(s0[0],s0[1],r*0.42,0,6.2832); c.fillStyle='#17171A'; c.fill();
    c.restore();
  }
  function renderTriFin(ctx,ox,oy,W,H,fillBg){
    var tee=(!fillBg && state.product==='tee'), photo=!!TRI.photo;
    var L=triFinLayout(ox,oy,W,H,photo), u=L.u, cx=L.cx, R=L.rows;
    ctx.save();
    ctx.beginPath(); ctx.rect(ox,oy,W,H); ctx.clip();
    if(!tee){ ctx.fillStyle=TRI_FIN.bg; ctx.fillRect(ox,oy,W,H); }
    ctx.textBaseline='alphabetic';
    if(photo) triFinPhoto(ctx,ox,oy,W,L);
    else if(_splitHeroPaint){
      /* Preview only - the print never says "add". */
      var p=L.prompt;
      ctx.save(); ctx.strokeStyle=TRI_FIN.edge; ctx.setLineDash([u*0.016,u*0.016]); ctx.lineWidth=Math.max(1,u*0.0025);
      ctx.strokeRect(p.x,p.y,p.w,p.h); ctx.restore();
      var t1='+  ADD YOUR PHOTO', ps=Math.min(u*0.050,p.h*0.36);
      ctx.textAlign='center'; ctx.fillStyle=TRI_FIN.ink; ctx.font=triSans(ps,700);
      ctx.fillText(t1,p.x+p.w/2,p.y+p.h/2+(p.h>u*0.14?-ps*0.15:ps*0.15));
      if(p.h>u*0.14){ ctx.fillStyle=TRI_FIN.dim; ctx.font=triSans(ps*0.52,600);
        ctx.fillText('tap here to upload · optional',p.x+p.w/2,p.y+p.h/2+ps*0.95); }
      ctx.textAlign='left';
    }
    var shade=photo?'rgba(0,0,0,0.45)':'rgba(0,0,0,0)';
    function txt(fn){ ctx.save(); ctx.shadowColor=shade; ctx.shadowBlur=photo?u*0.018:0; fn(); ctx.restore(); }
    /* the finisher line */
    var lab=triFinLabel(), ls=triFitTracked(ctx,lab,function(z){ return triMono(z,500); },u*0.028,0.35,L.inner,u*0.012);
    txt(function(){ ctx.fillStyle=TRI_FIN.ink; ctx.font=triMono(ls,500); triTracked(ctx,lab,cx,R.label,ls*0.35,'center'); });
    var big=triFinTotal();
    if(big && R.time){
      var bs=triFitOne(ctx,big,L.inner,u*0.190,'800');
      txt(function(){ ctx.fillStyle=TRI_FIN.ink; ctx.font=triSans(bs,800); ctx.textAlign='center'; ctx.fillText(big,cx,R.time); ctx.textAlign='left'; });
      ctx.fillStyle=TRI_FIN.acc; ctx.fillRect(cx-u*0.0925,R.rule-u*0.0028,u*0.185,u*0.0056);
    }
    var nm=String(edtVal('cz-name')||'').trim().toUpperCase();
    if(nm && R.name){
      var ns=triFitOne(ctx,nm,L.inner,u*0.068,'700');
      ctx.font=triCond(ns,700); var g=0; while(ctx.measureText(nm).width>L.inner && ns>u*0.02 && g++<60){ ns*=0.96; ctx.font=triCond(ns,700); }
      ctx.fillStyle=TRI_FIN.ink; ctx.textAlign='center'; ctx.fillText(nm,cx,R.name); ctx.textAlign='left';
    }
    var cr=[triLocHead().toUpperCase(), triFinDate((($('cz-date')||{}).value)||'')].filter(Boolean).join('  ·  ');
    if(cr){ var cs=triFitTracked(ctx,cr,function(z){ return triMono(z,400); },u*0.026,0.25,L.inner,u*0.010);
      ctx.fillStyle=TRI_FIN.dim; ctx.font=triMono(cs,400); triTracked(ctx,cr,cx,R.credit,cs*0.25,'center'); }
    var tr=triTrans();
    if(tr && R.trans){ var tt='TRANSITIONS '+triShort(tr), ts=triFitTracked(ctx,tt,function(z){ return triMono(z,500); },u*0.026,0.25,L.inner,u*0.010);
      ctx.fillStyle=TRI_FIN.acc; ctx.font=triMono(ts,500); triTracked(ctx,tt,cx,R.trans,ts*0.25,'center'); }
    /* the legs */
    var rects={};
    TRI_LEGS.forEach(function(l,i){
      var col=L.cols[i], box={ x:col.x, y:L.legTop, w:col.w, h:L.Rh }, mid=col.x+col.w/2;
      triFinRoute(ctx,l.key,box,u); rects[l.key]=box;
      var kl=triFinKm(l.key), head=l.name.toUpperCase()+(kl?' '+kl:'');
      var hs=triFitTracked(ctx,head,function(z){ return triMono(z,500); },u*0.022,0.25,col.w,u*0.009);
      ctx.fillStyle=TRI_COL[l.key]; ctx.font=triMono(hs,500); triTracked(ctx,head,mid,L.legLbl,hs*0.25,'center');
      var sp=triSplit(l.key);
      if(sp){ var st=triClock(sp), ss=triFitOne(ctx,st,col.w*0.96,u*0.052,'800');
        ctx.fillStyle=TRI_FIN.ink; ctx.font=triSans(ss,800); ctx.textAlign='center'; ctx.fillText(st,mid,L.legTime); ctx.textAlign='left'; }
      var pc=triLegPace(l.key);
      if(pc){ var pz=triFitTracked(ctx,pc,function(z){ return triMono(z,400); },u*0.019,0.25,col.w,u*0.008);
        ctx.fillStyle=TRI_FIN.dim; ctx.font=triMono(pz,400); triTracked(ctx,pc,mid,sp?L.legPace:L.legTime,pz*0.25,'center'); }
    });
    if(TRI_BRAND){
      var ut='MYMILESTONE.COM.AU', us=triFitTracked(ctx,ut,function(z){ return triMono(z,500); },u*0.020,0.42,L.inner,u*0.008);
      ctx.fillStyle=TRI_FIN.faint; ctx.font=triMono(us,500); triTracked(ctx,ut,cx,L.url,us*0.42,'center');
    }
    ctx.restore();
    if(_splitHeroPaint && !TRI.lensPaint){
      rects.hero=photo ? { x:ox, y:oy, w:W, h:L.photoH } : L.prompt;
      TRI.rects=rects; TRI.paints=(TRI.paints||0)+1;
    }
  }
  /* The design switch. Background (Map / Terrain) belongs to the grid. */
  function triSetLayout(v){
    TRI.layout=(v==='finisher'||v==='manifesto')?v:'grid';
    try{
      var u=new URL(window.location.href);
      if(TRI.layout!=='grid') u.searchParams.set('layout',TRI.layout); else u.searchParams.delete('layout');
      history.replaceState(null,'',u.pathname+u.search+u.hash);
    }catch(e){}
    triLayoutTables(); triSyncUI(); render();
    try{ renderShow(); }catch(e){}
  }
  /* The design choice as thumbnails - the single-sport strip's look and
     place (26 Oct, Marc). Painted from the customer's own legs and photo at
     the focused format's shape; repainted shortly after the preview is. */
  var _triStripT=null;
  function triStripSoon(){
    if(_triStripT) clearTimeout(_triStripT);
    _triStripT=setTimeout(function(){ _triStripT=null;
      try{ triDesignStrip(); }catch(e){ console.warn('Milestone: triathlon design strip failed',e); } },350);
  }
  var TRI_DESIGNS=[['grid','Grid'],['finisher','Finisher'],['manifesto','Manifesto']];
  function triDesignStrip(){
    var host=root.querySelector('.cz-pmleft'); if(!host) return;
    var wrap=$('tri-kinds');
    if(!wrap){
      wrap=document.createElement('div'); wrap.className='cz-kinds'; wrap.id='tri-kinds';
      var lab=document.createElement('div'); lab.className='cz-lbl'; lab.textContent='Try another design'; wrap.appendChild(lab);
      var rw=document.createElement('div'); rw.className='cz-kindrow'; wrap.appendChild(rw);
      host.appendChild(wrap);
    }
    var row=wrap.querySelector('.cz-kindrow'); row.innerHTML='';
    var ar=(PRODUCTS[focusProd()]||PRODUCTS.poster).ar, TW=76, TH=Math.round(TW/ar);
    var keep=TRI.layout, pv=state.view, pi=state.mockIdx, hp=_splitHeroPaint, kr=TRI.rects;
    TRI_DESIGNS.forEach(function(d){
      var cur=(d[0]===keep), a=document.createElement(cur?'div':'a');
      a.className='cz-kind'+(cur?' cz-on':''); a.setAttribute('data-layout',d[0]);
      if(!cur){ a.href='#'; a.addEventListener('click',function(ev){ ev.preventDefault(); triSetLayout(d[0]); }); }
      var cv=document.createElement('canvas'); cv.width=TW*2; cv.height=TH*2;
      /* TRI.thumb: drawn with the maps the page already has - a thumbnail
         never asks for any (the Finisher needs none). */
      try{ TRI.layout=d[0]; triLayoutTables(); state.view='flat'; state.mockIdx=0; _splitHeroPaint=false; TRI.thumb=true;
           paint(cv.getContext('2d'),cv.width,cv.height,true); }
      catch(e){ console.warn('Milestone: triathlon thumb failed ('+d[0]+')',e); }
      finally{ TRI.thumb=false; TRI.layout=keep; triLayoutTables(); state.view=pv; state.mockIdx=pi; _splitHeroPaint=hp; TRI.rects=kr; }
      cv.style.width=TW+'px'; cv.style.height=TH+'px';
      var t=document.createElement('span'); t.textContent=d[1];
      a.appendChild(cv); a.appendChild(t); row.appendChild(a);
    });
  }
  /* The mockups: the dark design on the dark blanks, with a dark surround. */
  function triLayoutTables(){
    var fin=(TRI.layout==='finisher');
    KIND_GROUND.triathlon=fin?TRI_FIN.bg:(TRI.layout==='manifesto'?TRI_MAN.bg:TRI_THEMES[TRI.theme].bg);
    KIND_BLANK.triathlon=fin?'':'edt_';
  }
  /* ?brand=1: the giveaway card, 1080 x 1920, whatever format is on screen. */
  function triStoryPng(){
    var cv=document.createElement('canvas'); cv.width=1080; cv.height=1920;
    var keep=_splitHeroPaint, kr=TRI.rects; _splitHeroPaint=false;
    try{ renderTriFin(cv.getContext('2d'),0,0,1080,1920,true); }
    finally{ _splitHeroPaint=keep; TRI.rects=kr; }
    return cv;
  }
  function triStoryDownload(){
    var cv=triStoryPng(), nm=String(edtVal('cz-name')||'finisher').trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')||'finisher';
    try{
      cv.toBlob(function(b){
        if(!b) return;
        var a=document.createElement('a'); a.href=URL.createObjectURL(b); a.download='finisher-card-'+nm+'.png';
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
        setTimeout(function(){ URL.revokeObjectURL(a.href); },4000);
      },'image/png');
    }catch(e){ triMsg('Couldn’t save the card: '+((e&&e.message)||e),true); }
  }
  /* ---- the Digital Pack's phone wallpaper and route reel (22 Oct) ----------
     Marc: "use the photo like gallery design, wallpaper showing the routes and
     reel to show route reveal for all the routes all at once."

     Wallpaper (1440 x 3200, the main engine's file size): Gallery's layout -
     the photo full bleed on the customer's crop, scrims top and bottom, the
     three legs side by side above the title, each glowing in its colour, then
     the event, the place, the rule and the splits. No photo: the dark ground,
     the legs large in the art band. The file never says "add a photo".
     Reel (1080 x 1920): the photo darkened (or the dark ground), the three
     legs drawn at once over 0.06-0.70 with a glowing head each, then the type.
     Both are the same in either layout (Grid or Finisher). */
  var TRI_WALL={ legsH:0.115, legsGap:0.032, titleY:0.675, locY:0.715, ruleY:0.747,
                 statValY:0.800, statLblY:0.832, footY:0.862, artTop:0.315, artBot:0.600 };
  var TRI_REEL={ artTop:0.10, artBot:0.56, titleY:0.700, locY:0.742, ruleY:0.774,
                 statValY:0.836, statLblY:0.868, footY:0.930 };
  /* The legs, each fitted to its own box: [{key, col, pts:[[x,y],...]}]. */
  function triDigLegs(boxes){
    var out=[];
    TRI_LEGS.forEach(function(l,i){
      var d=TRI.legs[l.key], box=boxes[i]; if(!d || !d.draw || d.draw.length<2 || !box) return;
      var pts=d.draw, la=0, j;
      for(j=0;j<pts.length;j++) la+=pts[j][0]; la/=pts.length;
      var k=Math.cos(la*Math.PI/180), x0=Infinity,x1=-Infinity,y0=Infinity,y1=-Infinity;
      for(j=0;j<pts.length;j++){ var px=pts[j][1]*k, py=pts[j][0];
        if(px<x0)x0=px; if(px>x1)x1=px; if(py<y0)y0=py; if(py>y1)y1=py; }
      var sx=Math.max(x1-x0,1e-9), sy=Math.max(y1-y0,1e-9);
      var sc=Math.min(box.w/sx,box.h/sy), dx=box.x+(box.w-sx*sc)/2, dy=box.y+(box.h-sy*sc)/2, P=[];
      for(j=0;j<pts.length;j++) P.push([dx+(pts[j][1]*k-x0)*sc, dy+(y1-pts[j][0])*sc]);
      out.push({ key:l.key, name:l.name, col:TRI_COL[l.key], pts:P, box:box });
    });
    return out;
  }
  function triDigBoxes(W,top,h,colW){
    var gap=W*TRI_WALL.legsGap, bw=(colW-2*gap)/3, x=(W-colW)/2;
    return [0,1,2].map(function(i){ return { x:x+i*(bw+gap), y:top, w:bw, h:h }; });
  }
  /* One leg, the first n points of it, glowing. */
  function triDigStroke(c,L,n,lw,glow){
    if(!L || n<2) return;
    var P=L.pts; n=Math.min(n,P.length);
    function path(){ c.beginPath(); c.moveTo(P[0][0],P[0][1]); for(var j=1;j<n;j++) c.lineTo(P[j][0],P[j][1]); }
    c.save(); c.lineJoin='round'; c.lineCap='round'; c.strokeStyle=L.col; c.lineWidth=lw;
    c.shadowColor=L.col; c.shadowBlur=glow; path(); c.stroke();
    c.shadowBlur=glow*0.45; path(); c.stroke();
    c.shadowBlur=0; path(); c.stroke();
    c.restore();
  }
  function triDigGround(c,W,H){
    var g=c.createRadialGradient(W*0.5,H*0.34,0,W*0.5,H*0.34,H*0.78);
    g.addColorStop(0,'#1a1a20'); g.addColorStop(1,'#0b0b0e');
    c.fillStyle=g; c.fillRect(0,0,W,H);
  }
  function triDigPhoto(c,W,H){
    var im=TRI.photo; if(!im) return false;
    var G=triPhotoGeom(im,W,H);
    c.drawImage(im,G.dx,G.dy,G.dw,G.dh);
    return true;
  }
  /* The splits row: FINISH, then each leg (its split, else its distance). */
  function triDigStats(){
    var out=[], tot=triTotal();
    if(tot) out.push(['FINISH', triClock(tot)]);
    else { var fk=triFinTotal(); if(fk) out.push(['DISTANCE', fk]); }
    TRI_LEGS.forEach(function(l){
      var sp=triSplit(l.key), km=triFinKm(l.key);
      if(sp) out.push([l.name.toUpperCase(), triClock(sp)]);
      else if(km) out.push([l.name.toUpperCase(), km]);
    });
    return out;
  }
  /* The type, shared by the wallpaper and the reel (R = their row table). */
  function triDigType(c,X,Y,W,H,R,lift,cwf){
    lift=lift||0;
    var cx=X+W/2, colW=W*(cwf||0.80), mL=X+(W-colW)/2;
    c.textBaseline='alphabetic'; c.textAlign='center';
    var title=(triFinLabel()||'MY TRIATHLON');
    var tsz=wallFit(c,'800 %spx Inter,sans-serif',title,0.06,colW,W*0.074);
    c.font='800 '+tsz+'px Inter,sans-serif'; c.fillStyle='#F4F4F6';
    c.fillText(spaced(title,0.06), cx, Y+H*R.titleY+lift);
    var loc=String((($('cz-loc')||{}).value)||'').toUpperCase();
    if(loc){
      var lsz=wallFit(c,'600 %spx Inter,sans-serif',loc,0.20,colW,W*0.029);
      c.font='600 '+lsz+'px Inter,sans-serif'; c.fillStyle='#a9a7b0';
      c.fillText(spaced(loc,0.20), cx, Y+H*R.locY+lift);
    }
    var st=triDigStats();
    if(st.length){
      c.fillStyle=TRI_FIN.acc;
      c.fillRect(cx-W*0.08, Y+H*R.ruleY, W*0.16, Math.max(2,W*0.0045));
      var cw=colW/st.length, vs=W*0.046, g=0;
      c.font='800 '+vs+'px Inter,sans-serif';
      while(st.some(function(s){ return c.measureText(s[1]).width>cw*0.94; }) && vs>W*0.02 && g++<60){ vs*=0.95; c.font='800 '+vs+'px Inter,sans-serif'; }
      st.forEach(function(s,i){
        var sx=mL+cw*(i+0.5);
        c.font='800 '+vs+'px Inter,sans-serif'; c.fillStyle='#F4F4F6';
        c.fillText(s[1], sx, Y+H*R.statValY+lift);
        c.font='600 '+(W*0.021)+'px Inter,sans-serif';
        var lk=TRI_LEGS.filter(function(l){ return l.name.toUpperCase()===s[0]; })[0];
        c.fillStyle=lk ? TRI_COL[lk.key] : '#8f8d97';
        c.fillText(spaced(s[0],0.16), sx, Y+H*R.statLblY+lift);
      });
    }
    var tr=triTrans();
    var foot=[dsDate(), dsName(), tr?('TRANSITIONS '+triShort(tr)):''].filter(Boolean).join('   ·   ');
    if(foot){
      var fsz=wallFit(c,'600 %spx Inter,sans-serif',foot,0.14,colW,W*0.022);
      c.font='600 '+fsz+'px Inter,sans-serif'; c.fillStyle='#6f6d77';
      c.fillText(spaced(foot,0.14), cx, Y+H*R.footY);
    }
  }
  function triDigLegLabels(c,legs,W,y){
    legs.forEach(function(L){
      var t=L.name.toUpperCase()+(triFinKm(L.key)?' '+triFinKm(L.key):'');
      var s=wallFit(c,'600 %spx Inter,sans-serif',t,0.16,L.box.w,W*0.020);
      c.font='600 '+s+'px Inter,sans-serif'; c.fillStyle=L.col; c.textAlign='center';
      c.fillText(spaced(t,0.16), L.box.x+L.box.w/2, y);
    });
  }
  function triWallpaper(c,W,H,chrome){
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      triDigGround(c,W,H);
      var photo=triDigPhoto(c,W,H), colW=W*0.80, legs, glow;
      if(photo){
        var top=c.createLinearGradient(0,0,0,H*WALL.clockBot);
        top.addColorStop(0,'rgba(8,8,11,0.70)'); top.addColorStop(1,'rgba(8,8,11,0)');
        c.fillStyle=top; c.fillRect(0,0,W,H*WALL.clockBot);
        var bot=c.createLinearGradient(0,H*0.44,0,H);
        bot.addColorStop(0,'rgba(8,8,11,0)'); bot.addColorStop(0.36,'rgba(8,8,11,0.82)'); bot.addColorStop(1,'rgba(8,8,11,0.95)');
        c.fillStyle=bot; c.fillRect(0,H*0.44,W,H*0.56);
        /* small, above the title, as Gallery's route sits */
        var lh=H*TRI_WALL.legsH, lt=H*TRI_WALL.titleY-W*0.135-lh;
        legs=triDigLegs(triDigBoxes(W,lt,lh,colW*0.86)); glow=W*0.022;
        legs.forEach(function(L){ triDigStroke(c,L,L.pts.length,Math.max(3,W*0.0055),glow); });
        triDigLegLabels(c,legs,W,lt+lh+W*0.050);
      } else {
        var at=H*TRI_WALL.artTop, ah=H*(TRI_WALL.artBot-TRI_WALL.artTop);
        legs=triDigLegs(triDigBoxes(W,at,ah,colW)); glow=W*0.040;
        legs.forEach(function(L){ triDigStroke(c,L,L.pts.length,Math.max(4,W*0.0075),glow); });
        triDigLegLabels(c,legs,W,at+ah+W*0.050);
      }
      triDigType(c,0,0,W,H,TRI_WALL,0);
      if(chrome){
        c.save(); c.textAlign='center';
        c.shadowColor='rgba(0,0,0,0.45)'; c.shadowBlur=W*0.03;
        c.fillStyle='rgba(255,255,255,0.92)'; c.font='600 '+(W*0.045)+'px Inter,sans-serif';
        c.fillText(spaced('SATURDAY 11 OCTOBER',0.08), W/2, H*0.088);
        c.fillStyle='#FFFFFF'; c.font='500 '+(W*0.26)+'px Inter,sans-serif';
        c.fillText('9:41', W/2, H*0.205);
        c.restore();
      }
    } finally { _splitHeroPaint=keep; }
  }
  /* The reel. The backdrop (photo darkened, or the ground) is built once per
     size and photo crop and stamped; the three legs are drawn to the same
     fraction of their length every frame, so they finish together. */
  var _triReelBg=null;
  function triReelBg(W,H){
    var key=Math.round(W)+'x'+Math.round(H)+'|'+(TRI.photo?(TRI.photo.width+':'+TRI.fx+':'+TRI.focus+':'+TRI.zoom):'none');
    if(_triReelBg && _triReelBg.key===key) return _triReelBg.cv;
    var cv=document.createElement('canvas'); cv.width=Math.max(1,Math.round(W)); cv.height=Math.max(1,Math.round(H));
    var g=cv.getContext('2d');
    triDigGround(g,cv.width,cv.height);
    if(triDigPhoto(g,cv.width,cv.height)){
      g.fillStyle='rgba(8,8,11,0.58)'; g.fillRect(0,0,cv.width,cv.height);
      var b=g.createLinearGradient(0,cv.height*0.56,0,cv.height);
      b.addColorStop(0,'rgba(8,8,11,0)'); b.addColorStop(0.5,'rgba(8,8,11,0.6)'); b.addColorStop(1,'rgba(8,8,11,0.85)');
      g.fillStyle=b; g.fillRect(0,cv.height*0.56,cv.width,cv.height*0.44);
    }
    _triReelBg={ key:key, cv:cv };
    return cv;
  }
  function triReelInto(c,X,Y,W,H,t){
    var keep=_splitHeroPaint; _splitHeroPaint=false;
    try{
      c.drawImage(triReelBg(W,H),X,Y,W,H);
      var at=Y+H*TRI_REEL.artTop, ah=H*(TRI_REEL.artBot-TRI_REEL.artTop);
      var legs=triDigLegs(triDigBoxes(W,at,ah,W*0.76).map(function(b){ b.x+=X; return b; }));
      var drawn=reelEase(reelSpan(t,0.06,0.70)), lw=Math.max(4,W*0.0085), glow=W*0.045;
      legs.forEach(function(L){
        var n=Math.max(2,Math.round((L.pts.length-1)*drawn)+1);
        triDigStroke(c,L,n,lw,glow);
        if(drawn<1){ var hp=L.pts[n-1], hd=reelHead(W,L.col); c.drawImage(hd.cv, hp[0]-hd.sz/2, hp[1]-hd.sz/2); }
      });
      var ta=reelSpan(t,0.70,0.86);
      if(ta>0){
        c.save(); c.globalAlpha=ta;
        triDigLegLabels(c,legs,W,at+ah+W*0.055);
        triDigType(c,X,Y,W,H,TRI_REEL,(1-ta)*H*0.018,0.76);
        c.restore();
      }
    } finally { _splitHeroPaint=keep; }
  }
  /* ---- Manifesto (28 Oct): the day as one sentence, one route per sport ---- */
  var TRI_MAN={ bg:'#F3EFE7', ink:'#17171A', muted:'#8A8890', tile:'#E9E4D9' };
  function triManWords(){
    var w=[], dv=edtVal('cz-date'), d=triDate(dv);
    function add(t,c){ String(t).split(/[ \t\n]+/).forEach(function(x){ if(x) w.push([x,c]); }); }
    function val(t,c){ add(String(t).replace(/(\d)\s+(?=\S)/g,'$1 '),c); }
    if(d) add('On '+d+',',''); add('I','');
    var verbs={swim:'swam',ride:'rode',run:'ran'}, parts=[];
    TRI_LEGS.forEach(function(l){ var km=triKmLabel(l.key), sec=triSplit(l.key);
      if(!km && !sec && !TRI.legs[l.key]) return; parts.push([l,km,sec]); });
    parts.forEach(function(p,i){
      if(i && i===parts.length-1) add('and','');
      add(verbs[p[0].key],'');
      if(p[1]) val(p[1],TRI_COL[p[0].key]);
      if(p[2]){ add('in',''); val(triShort(p[2]),TRI_COL[p[0].key]); }
      if(i<parts.length-2) w[w.length-1][2]=',';
    });
    var place=triPlace(edtVal('cz-title'));
    if(place){ add('at',''); add(place,''); }
    if(w.length) w[w.length-1][2]=(w[w.length-1][2]||'')+'.';
    return w.map(function(x){ return [x[0].toUpperCase(), x[1], x[2]||'']; });
  }
  /* One leg's own track over its own map (30 Oct: Map - Standard by default,
     or whatever Background is picked) - planned on this panel the way the
     grid plans its tiles; a map of another shape stands in until it lands. */
  function triManRoute(c,key,box,u){
    var d=TRI.legs[key], col=TRI_COL[key], prod=state.product||'poster';
    c.save(); c.beginPath(); c.rect(box.x,box.y,box.w,box.h); c.clip();
    c.fillStyle=TRI_MAN.tile; c.fillRect(box.x,box.y,box.w,box.h);
    if(!d){
      c.strokeStyle='rgba(23,23,26,0.28)'; c.setLineDash([u*0.012,u*0.012]); c.lineWidth=Math.max(1,u*0.002);
      c.strokeRect(box.x+box.w*0.08,box.y+box.h*0.08,box.w*0.84,box.h*0.84); c.setLineDash([]);
      c.textAlign='center'; c.fillStyle=TRI_MAN.muted; c.font='700 '+(u*0.018)+'px Inter,Arial,sans-serif';
      c.fillText('+ '+key.toUpperCase()+' GPX',box.x+box.w/2,box.y+box.h/2+u*0.006); c.restore(); return;
    }
    var rv=triRefView(key,prod); if(!rv){ c.restore(); return; }
    var sv=rv, base=TRI.cache[triKey(rv)]||null, bx=box.x, by=box.y, bw=box.w, bh=box.h;
    if(!base){
      var fb=triBorrow(key,rv);
      if(fb){ base=fb.base; sv=fb.v; bw=fb.vv.pw*fb.s*(box.w/rv.pw); bh=fb.vv.ph*fb.s*(box.w/rv.pw); bx=box.x+(box.w-bw)/2; by=box.y+(box.h-bh)/2; }
    }
    if(base){ c.drawImage(base,bx,by,bw,bh); c.fillStyle=TRI_THEMES.paper.veil; c.fillRect(box.x,box.y,box.w,box.h); }
    var v={ z:sv.z+Math.log(box.w/sv.pw)/Math.LN2, cLon:sv.cLon, cLat:sv.cLat, pw:box.w, ph:box.h };
    var pts=d.draw.map(function(p){ var q=triProject(v,p[0],p[1]); return [box.x+q[0], box.y+q[1]]; });
    function path(){ c.beginPath(); c.moveTo(pts[0][0],pts[0][1]); for(var j=1;j<pts.length;j++) c.lineTo(pts[j][0],pts[j][1]); }
    c.lineJoin='round'; c.lineCap='round';
    c.strokeStyle=(TRI.mode==='terrain')?'rgba(0,0,0,0.35)':'rgba(255,255,255,0.85)'; c.lineWidth=Math.max(2,u*0.009); path(); c.stroke();
    c.strokeStyle=col; c.lineWidth=Math.max(1.2,u*0.0045); path(); c.stroke();
    triSfIcons(c,pts[0],pts[pts.length-1],u*0.7,box.x+box.w);   /* 30 Oct pm: green dot, chequered flag */
    c.restore();
  }
  /* 30 Oct pm (Marc): start and finish as Terrain and 3D draw them; W sets the
     size, as a poster width (the icon is 1.5% of it). */
  function triSfIcons(c,a,b,W,lim){ if(TRI.sf===false) return; if(typeof terrainSfIcons==='function') terrainSfIcons(c,a,b,W,lim); }
  function triManPanel(W,H){
    var m=W*0.075, gap=W*0.025, pw=(W-2*m-2*gap)/3;
    return { m:m, gap:gap, w:pw, y:H*0.585, h:Math.min(pw*1.15,H*0.235) };
  }
  function renderTriMan(ctx,ox,oy,W,H,fillBg){
    var M=TRI_MAN, m=W*0.075, u=W, i;
    ctx.save(); ctx.translate(ox,oy);
    ctx.fillStyle=M.bg; ctx.fillRect(0,0,W,H);
    /* the sentence, as large as fits above the panels */
    var words=triManWords(), top=H*0.075, room=H*0.535-top, maxW=W-2*m, s=W*0.10, lines, g=0;
    function wrap(sz){ ctx.font='800 '+sz+'px Inter,Arial,sans-serif'; var sp=ctx.measureText(' ').width, out=[], cur=[], cw=0;
      words.forEach(function(wd){ var ww=ctx.measureText(wd[0]+wd[2]).width; if(cur.length && cw+sp+ww>maxW){ out.push(cur); cur=[]; cw=0; }
        cur.push(wd); cw+=(cur.length>1?sp:0)+ww; }); if(cur.length) out.push(cur); return out; }
    for(;;){ lines=wrap(s); if(lines.length*s*1.04<=room || s<W*0.03 || g++>80) break; s*=0.96; }
    ctx.font='800 '+s+'px Inter,Arial,sans-serif'; ctx.textBaseline='alphabetic'; ctx.textAlign='left';
    var sp=ctx.measureText(' ').width, y=top+s*0.86;
    lines.forEach(function(line){ var x=m;
      line.forEach(function(wd){ ctx.fillStyle=wd[1]||M.ink; ctx.fillText(wd[0],x,y); x+=ctx.measureText(wd[0]).width;
        if(wd[2]){ ctx.fillStyle=M.ink; ctx.fillText(wd[2],x,y); x+=ctx.measureText(wd[2]).width; } x+=sp; });
      y+=s*1.04; });
    /* one route per sport */
    var _mp=triManPanel(W,H), gap=_mp.gap, pw=_mp.w, py=_mp.y, ph=_mp.h;
    TRI_LEGS.forEach(function(l,k){
      var bx=m+k*(pw+gap), box={x:bx,y:py,w:pw,h:ph};
      triManRoute(ctx,l.key,box,u);
      var ly=py+ph+W*0.035;
      ctx.fillStyle=TRI_COL[l.key]; ctx.fillRect(bx,ly-W*0.024,W*0.03,Math.max(1,W*0.0035));
      ctx.font='800 '+(W*0.016)+'px Inter,Arial,sans-serif'; ctx.fillStyle=TRI_COL[l.key];
      triTracked(ctx,l.name.toUpperCase(),bx,ly,W*0.003,'left');
      var km=triKmLabel(l.key), sec=triSplit(l.key);
      ctx.font='800 '+(W*0.024)+'px Inter,Arial,sans-serif'; ctx.fillStyle=M.ink;
      ctx.fillText(km||'—',bx,ly+W*0.032);
      if(sec){ ctx.textAlign='right'; ctx.fillText(triShort(sec),bx+pw,ly+W*0.032); ctx.textAlign='left'; }
    });
    /* the footer: the name, the total, the place */
    var fy=H*0.93;
    ctx.fillStyle=M.ink; ctx.fillRect(m,fy-H*0.024,W-2*m,Math.max(1,W*0.0018));
    var nm=(edtVal('cz-name')||'').toUpperCase(), tot=triTotal();
    ctx.font='800 '+(W*0.016)+'px Inter,Arial,sans-serif'; ctx.fillStyle=M.ink;
    if(nm) triTracked(ctx,'— '+nm,m,fy,W*0.0016,'left');
    ctx.font='600 '+(W*0.0135)+'px Inter,Arial,sans-serif'; ctx.fillStyle=M.muted;
    var right=['TRIATHLON', tot?('TOTAL '+triClock(tot)):'', (edtVal('cz-loc')||'').toUpperCase()].filter(Boolean).join(' · ');
    triTracked(ctx,right,W-m,fy,W*0.0019,'right');
    ctx.restore();
    if(_splitHeroPaint && !TRI.lensPaint){ TRI.rects=null; TRI.paints=(TRI.paints||0)+1; }
    var _prod=state.product||'poster', _fp=''; try{ _fp=focusProd(); }catch(e){ _fp=_prod; }
    if(_prod===_fp && !TRI.thumb) triEnsure(_prod);
  }
  function renderTri(ctx,ox,oy,W,H,fillBg){
    if(_splitHeroPaint && !TRI.lensPaint) triStripSoon();
    if(TRI.layout==='finisher'){ renderTriFin(ctx,ox,oy,W,H,fillBg); return; }
    if(TRI.layout==='manifesto'){ renderTriMan(ctx,ox,oy,W,H,fillBg); return; }
    var TH=TRI_THEMES[TRI.theme]||TRI_THEMES.paper, L=triLayout(ox,oy,W,H), prod=state.product||'poster';
    ctx.save();
    ctx.fillStyle=TH.bg; ctx.fillRect(ox,oy,W,H);
    ctx.textBaseline='alphabetic';
    triHero(ctx,L.cells[1],TH);
    TRI_LEGS.forEach(function(l){ triCell(ctx,l,L.cells[l.cell],TH,prod); });
    ctx.restore();
    if(_splitHeroPaint && !TRI.lensPaint){ var _r={ hero:L.cells[1] }; TRI_LEGS.forEach(function(l){ _r[l.key]=L.cells[l.cell]; }); TRI.rects=_r;
      TRI.paints=(TRI.paints||0)+1; }
    var fp=''; try{ fp=focusProd(); }catch(e){ fp=prod; }
    if(prod===fp && !TRI.thumb) triEnsure(prod);
  }

  /* ---- the magnifier's source: the flat preview again, 2.5x, rebuilt only
     when the poster has been repainted since (TRI.paints). Mockups use the
     hero canvas as on every design. */
  var TRI_LENS_K=2.5, _triLens=null;
  function triLensSrc(c,box){
    if(!c || !c.width || !box || box.getAttribute('data-view')!=='flat') return null;
    var key=(TRI.paints||0)+':'+c.width+'x'+c.height;
    if(_triLens && _triLens.key===key) return _triLens.cv;
    var hv=(_triLens && _triLens.cv) || document.createElement('canvas');
    hv.width=Math.round(c.width*TRI_LENS_K); hv.height=Math.round(c.height*TRI_LENS_K);
    var sp=state.product, sv=state.view, keepR=TRI.rects, keepH=_splitHeroPaint, ok=true;
    TRI.lensPaint=true; state.product=focusProd(); state.view='flat'; _splitHeroPaint=true;
    try{ paint(hv.getContext('2d'),hv.width,hv.height); }catch(e){ ok=false; console.error('Milestone triathlon: lens render failed',e); }
    _splitHeroPaint=keepH; state.product=sp; state.view=sv; TRI.rects=keepR; TRI.lensPaint=false;
    _triLens=ok?{key:key,cv:hv}:null;
    return ok?hv:null;
  }

  /* ---- controls ---- */
  function triSyncUI(){
    TRI_LEGS.forEach(function(l){
      var el=root.querySelector('.tri-slot[data-leg="'+l.key+'"]'); if(!el) return;
      var d=TRI.legs[l.key], t=el.querySelector('[data-role="t"]'), s=el.querySelector('[data-role="s"]');
      el.classList.toggle('tri-has',!!d);
      var _dot=el.querySelector('.tri-dot'); if(_dot) _dot.style.background=TRI_COL[l.key];   /* 30 Oct: as the poster draws it */
      if(t) t.textContent=d?(l.name+' ✓'):('Add the '+l.name.toLowerCase()+' GPX');
      if(s) s.textContent=d?(d.src==='route'?'From the race course · tap to replace':'Tap to replace'):el.getAttribute('data-hint')||'';
    });
    var any=TRI.legs.swim||TRI.legs.ride||TRI.legs.run, cl=$('tri-clear'); if(cl) cl.style.display=any?'':'none';
    root.querySelectorAll('#tri-layout [data-v]').forEach(function(b){ b.classList.toggle('cz-on',b.getAttribute('data-v')===TRI.layout); });
    /* The buttons give way to the thumbnails (they stay, hidden, for the wiring). */
    var _ly=$('tri-layout'); if(_ly){ _ly.style.display='none';
      var _lb=_ly.previousElementSibling; if(_lb && _lb.classList && _lb.classList.contains('cz-lbl')) _lb.style.display='none'; }
    triStripSoon();
    var _bg=$('tri-bgRows'); if(_bg) _bg.style.display=(TRI.layout==='finisher')?'none':'';
    var _at=root.querySelector('#tri-look .tri-attrib'); if(_at) _at.style.display=(TRI.layout==='finisher')?'none':'';
    var pb=$('tri-photoBtn'); if(pb) pb.textContent=TRI.photo?'Change photo':'+ Add a finish photo (optional)';
    var pr=$('tri-photoRow'); if(pr) pr.style.display=TRI.photo?'':'none';
    triZoomUI();
    root.querySelectorAll('#tri-mode [data-v]').forEach(function(b){ b.classList.toggle('cz-on',b.getAttribute('data-v')===TRI.mode); });
    triSyncHints();
    var ms=$('tri-mstyleRow'); if(ms) ms.style.display=TRI.mode==='map'?'':'none';
    root.querySelectorAll('#tri-mstyle [data-v]').forEach(function(b){ b.classList.toggle('cz-on',b.getAttribute('data-v')===TRI.mapStyle); });
    var cr=root.querySelector('#tri-look .tri-attrib');
    if(cr) cr.textContent=(TRI.mode==='terrain'?'Elevation: Mapzen Terrain Tiles \u00b7 AWS Open Data. ':'')+'Map data \u00a9 OpenStreetMap contributors, via Geoapify.';
    var ex=$('tri-tthemeRow'); if(ex) ex.style.display=TRI.mode==='terrain'?'':'none';
    root.querySelectorAll('#tri-ttheme [data-v]').forEach(function(b){ b.classList.toggle('cz-on',b.getAttribute('data-v')===TRI.ttheme); });
    triStatus();
  }
  /* Blank fields show what the poster will use: the GPX's distance and the
     pace worked out from it. */
  function triSyncHints(){
    TRI_LEGS.forEach(function(l){
      var C=triCap(l.key), d=TRI.legs[l.key], di=$('tri-d'+C), pi=$('tri-p'+C);
      if(di) di.placeholder=d?(d.km<10?d.km.toFixed(2):d.km.toFixed(1)):'km';
      if(pi){ var a=triPace(l.key,triKm(l.key),triSplit(l.key));
        pi.placeholder=a?a.replace(/ KM\/H$/,'').replace(/ \/(100M|KM)$/,''):'auto'; }
    });
  }
  function triSportOf(g,km){
    var k=''; try{ k=sportKey(g&&g.sport||''); }catch(e){}
    if(k==='swim') return 'swim'; if(k==='cycle') return 'ride'; if(k==='run'||k==='trail') return 'run';
    return '';
  }
  function triReadFile(f){
    return new Promise(function(res){
      var rd=new FileReader();
      rd.onload=function(){ var g=parseGPX(rd.result); res(g&&g.coords&&g.coords.length>1?{g:g,f:f,km:routeKm(g.coords)}:null); };
      rd.onerror=function(){ res(null); };
      rd.readAsText(f);
    });
  }
  function triMsg(t,bad){ try{ splitMsg(t||'',!!bad); }catch(e){} }
  function triFiles(files){
    var leg=TRI.pendingLeg; TRI.pendingLeg=null;
    files=Array.prototype.slice.call(files||[]);
    if(!files.length) return;
    Promise.all(files.map(triReadFile)).then(function(rs){
      var ok=rs.filter(Boolean);
      if(!ok.length){ triMsg('Couldn’t find a route in '+(files.length>1?'those files':'that file')+'. GPX, TCX, KML and GeoJSON all work.',true); return; }
      triMsg('');
      if(leg && leg!=='*'){ var r=ok[0]; TRI.routeCode=''; forgetRouteParam(); triSetLeg(leg,r.g.coords,r.g.eles,r.f,'upload'); return; }
      /* Several at once: the file's own activity first, then by distance -
         swim is always the shortest leg, ride the longest. */
      var want={}, rest=[];
      ok.forEach(function(r){ var k=triSportOf(r.g); if(k && !want[k]) want[k]=r; else rest.push(r); });
      rest.sort(function(a,b){ return a.km-b.km; });
      var order=['swim','run','ride'].filter(function(k){ return !want[k]; });
      if(rest.length===1 && order.length>1){
        /* One unlabelled file: its distance says which leg it is. */
        var km=rest[0].km, k1=km<8?'swim':(km>60?'ride':'run');
        if(order.indexOf(k1)<0) k1=order[0];
        want[k1]=rest[0];
      } else {
        if(rest.length===2 && order.length===2 && order[0]==='swim' && order[1]==='ride'){ want.swim=rest[0]; want.ride=rest[1]; }
        else if(rest.length>=3 && order.length===3){ want.swim=rest[0]; want.run=rest[1]; want.ride=rest[2]; }
        else rest.forEach(function(r,i){ if(order[i]) want[order[i]]=r; });
      }
      TRI.routeCode=''; forgetRouteParam();
      Object.keys(want).forEach(function(k){ var r=want[k]; triSetLeg(k,r.g.coords,r.g.eles,r.f,'upload'); });
    });
  }
  var _triFile=null;
  function triPickGpx(leg){
    TRI.pendingLeg=leg;
    if(!_triFile) _triFile=$('tri-file');
    if(!_triFile) return;
    _triFile.multiple=(leg==='*'); _triFile.value='';
    try{ _triFile.click(); }catch(e){}
  }
  var _triPhotoIn=null;
  function triPickPhoto(){ if(!_triPhotoIn) _triPhotoIn=$('tri-photoFile'); if(_triPhotoIn){ _triPhotoIn.value=''; try{ _triPhotoIn.click(); }catch(e){} } }
  function triSetPhoto(f){
    if(!f || !/^image\//.test(f.type||'')){ triMsg('That file isn’t an image — please choose a photo.',true); return; }
    var u=URL.createObjectURL(f), im=new Image();
    im.onload=function(){
      /* The photo tile on A3 is 0.41 of the width by 0.62 of it: 4.8 x 7.2 in.
         Cover-fitted, so the tighter of the two is what prints. */
      var _fin=(TRI.layout==='finisher');
      var dpi=_fin?Math.min(im.width/11.69, im.height/9.1):Math.min(im.width/4.8, im.height/7.2);
      if(_fin && dpi<150){
        TRI.photo=im; TRI.photoFile=f; triPhotoReset();
        triMsg('Heads up: that photo will look soft on the A3 poster. It is fine on the magnet and the digital file; a higher-resolution original would be sharper on paper.');
        triSyncUI(); render(); return;
      }
      if(dpi<100){ URL.revokeObjectURL(u);
        triMsg('That photo is too small to print sharply in the photo tile — use the original from your camera roll.',true); return; }
      triMsg(dpi<150?'Heads up: that photo will look soft up close. A higher-resolution original would be sharper.':'');
      TRI.photo=im; TRI.photoFile=f; triPhotoReset();
      triSyncUI(); render();
    };
    im.onerror=function(){ URL.revokeObjectURL(u); triMsg('Couldn’t read that image.',true); };
    im.src=u;
  }
  function triClear(){
    TRI.legs={swim:null,ride:null,run:null}; TRI.routeCode=''; forgetRouteParam();
    ['tri-dSwim','tri-tSwim','tri-pSwim','tri-dRide','tri-tRide','tri-pRide','tri-dRun','tri-tRun','tri-pRun','tri-time','tri-t1','tri-t2'].forEach(function(id){ var e=$(id); if(e) e.value=''; });
    var t=$('cz-title'); if(t){ t.value='Your Triathlon'; }
    triSyncUI(); render();
  }
  function triSetMode(m){ TRI.mode=m; triSyncUI(); render(); }
  function triWireBox(box,cv){
    box._zoomCv=cv;
    if(box._triWired) return; box._triWired=true;
    box.style.cursor='pointer';
    var last=0;
    function at(e){
      var c=box._zoomCv, r=TRI.rects; if(!c||!r||!c.width) return '';
      var t=(e.changedTouches&&e.changedTouches.length)?e.changedTouches[0]:e;
      var b=c.getBoundingClientRect(); if(!b.width) return '';
      var px=(t.clientX-b.left)*(c.width/b.width), py=(t.clientY-b.top)*(c.height/b.height), k;
      for(k in r){ var q=r[k]; if(px>=q.x && px<=q.x+q.w && py>=q.y && py<=q.y+q.h) return k; }
      return '';
    }
    var t0=null;
    box.addEventListener('touchstart',function(e){ var t=e.touches&&e.touches[0]; t0=t?{x:t.clientX,y:t.clientY}:null; },{passive:true});
    function tap(e){
      if(e.type==='touchend' && t0 && e.changedTouches && e.changedTouches[0]){
        var u=e.changedTouches[0]; if(Math.abs(u.clientX-t0.x)+Math.abs(u.clientY-t0.y)>12) return;   /* the lens moved: not a tap */
      }
      if(Date.now()-last<600) return; last=Date.now();
      var k=at(e); if(!k) return;
      if(k==='hero'){ if(!TRI.photo) triPickPhoto(); return; }
      if(!TRI.legs[k]) triPickGpx(k);
    }
    box.addEventListener('click',tap);
    box.addEventListener('touchend',tap);
    /* The photo: drag to place it, two fingers to zoom. Only on the preview,
       and only on the photo - anywhere else a finger scrolls the page. */
    var drag=null, pinch=null;
    function onPhoto(t){
      var r=TRI.rects&&TRI.rects.hero, c=box._zoomCv;
      if(!TRI.photo||!r||!c||box.getAttribute('data-view')!=='flat') return false;
      var b=c.getBoundingClientRect(); if(!b.width) return false;
      var px=(t.clientX-b.left)*(c.width/b.width), py=(t.clientY-b.top)*(c.height/b.height);
      return px>=r.x && px<=r.x+r.w && py>=r.y && py<=r.y+r.h;
    }
    function startDrag(t){
      var r=TRI.rects.hero, g=triPhotoGeom(TRI.photo,r.w,r.h);
      drag={ x:t.clientX, y:t.clientY, fx:TRI.fx, fy:TRI.focus, ox:g.dw-r.w, oy:g.dh-r.h, moved:false };
    }
    function moveDrag(t){
      if(!drag) return false;
      if(!drag.moved && Math.abs(t.clientX-drag.x)+Math.abs(t.clientY-drag.y)<=3) return false;
      drag.moved=true;
      var c=box._zoomCv, b=c.getBoundingClientRect(), k=c.width/b.width;
      if(drag.ox>0.5) TRI.fx=Math.max(0,Math.min(1,drag.fx-(t.clientX-drag.x)*k/drag.ox));
      if(drag.oy>0.5) TRI.focus=Math.max(0,Math.min(1,drag.fy-(t.clientY-drag.y)*k/drag.oy));
      render(); return true;
    }
    function gap(e){ return Math.hypot(e.touches[0].clientX-e.touches[1].clientX, e.touches[0].clientY-e.touches[1].clientY); }
    box.addEventListener('mousedown',function(e){ if(onPhoto(e)){ startDrag(e); e.preventDefault(); } });
    window.addEventListener('mousemove',function(e){ if(drag) moveDrag(e); });
    window.addEventListener('mouseup',function(){ if(drag && drag.moved) last=Date.now(); drag=null; });
    box.addEventListener('touchstart',function(e){
      if(e.touches.length===2 && (onPhoto(e.touches[0])||onPhoto(e.touches[1]))){ drag=null; pinch={ d:gap(e), z:TRI.zoom||1 }; return; }
      if(e.touches.length===1 && onPhoto(e.touches[0])) startDrag(e.touches[0]);
    },{passive:true});
    box.addEventListener('touchmove',function(e){
      if(pinch && e.touches.length===2){
        TRI.zoom=Math.max(1,Math.min(triZoomCap(),pinch.z*gap(e)/(pinch.d||1)));
        triZoomUI(); render(); if(e.cancelable) e.preventDefault(); return;
      }
      if(drag && e.touches.length===1 && moveDrag(e.touches[0]) && e.cancelable) e.preventDefault();
    },{passive:false});
    box.addEventListener('touchend',function(e){ if(e.touches.length<2) pinch=null; if(!e.touches.length) drag=null; },{passive:true});
  }
  /* A course's leg distances: its own distance_<leg> fields, else its Distance
     when that is three numbers ("1.9 / 90 / 21.1 km"). Kept as typed. */
  function triCourseKm(rr){
    var o={}, L=rr.legs||{}, any=false;
    TRI_LEGS.forEach(function(l){ var v=String((L[l.key]||{}).dist||'').trim(); if(v){ o[l.key]=v; any=true; } });
    if(any) return o;
    var m=String(rr.dist||'').replace(/,/g,'.').match(/\d+(?:\.\d+)?/g);
    if(m && m.length===3){ o.swim=m[0]; o.ride=m[1]; o.run=m[2]; }
    return o;
  }
  /* A race code loads all three legs - the stored tracks if the entry has
     them, else each GPX. */
  function triLoadRoute(rr){
    if(!rr || !rr.legs) return false;
    TRI.routeCode=rr.code||'';
    var t=$('cz-title'); if(t && rr.name){ t.value=rr.name; titleTouched=true; }
    var lc=$('cz-loc'); if(lc && rr.loc) lc.value=rr.loc;
    var de=$('cz-date'); if(de && rr.date){ de.value=rr.date; dateTouched=true; }
    try{ applyRouteCopy(rr); }catch(e){}
    /* The course's official distances, into the Distance boxes. */
    var dd=triCourseKm(rr);
    TRI_LEGS.forEach(function(l){ var e=$('tri-d'+triCap(l.key)); if(e) e.value=dd[l.key]||''; });
    triSyncHints();
    TRI_LEGS.forEach(function(l){
      var src=rr.legs[l.key]||{}, pd=src.poly?decodePoly(src.poly):null;
      if(pd && pd.coords && pd.coords.length>1){ triSetLeg(l.key,pd.coords,pd.eles,null,'route'); return; }
      if(src.gpx){
        fetchText(src.gpx,12000).then(function(txt){ var g=parseGPX(txt);
          if(g && g.coords && g.coords.length>1) triSetLeg(l.key,g.coords,g.eles,null,'route');
          else triMsg('The '+l.name.toLowerCase()+' course couldn’t be read — upload your own GPX for it.',true);
        }).catch(function(){ triMsg('The '+l.name.toLowerCase()+' course didn’t load — check your connection, or upload your own GPX.',true); });
      }
    });
    return true;
  }
  function triBoot(){
    KIND_GROUND.triathlon=TRI_THEMES[TRI.theme].bg; KIND_BLANK.triathlon='edt_';
    triLayoutTables();
    var f=$('tri-file'); if(f) f.addEventListener('change',function(){ triFiles(f.files); });
    var pf=$('tri-photoFile'); if(pf) pf.addEventListener('change',function(){ var x=pf.files&&pf.files[0]; if(x) triSetPhoto(x); });
    root.querySelectorAll('.tri-slot[data-leg]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); triPickGpx(b.getAttribute('data-leg')); }); });
    var all=$('tri-all'); if(all) all.addEventListener('click',function(e){ e.preventDefault(); triPickGpx('*'); });
    var upd=function(){ triSyncHints(); render(); };
    ['tri-dSwim','tri-tSwim','tri-pSwim','tri-dRide','tri-tRide','tri-pRide','tri-dRun','tri-tRun','tri-pRun','tri-time','tri-t1','tri-t2','cz-date']
      .forEach(function(id){ var e=$(id); if(e){ e.addEventListener('input',upd); e.addEventListener('change',upd); } });
    var pb=$('tri-photoBtn'); if(pb) pb.addEventListener('click',function(e){ e.preventDefault(); triPickPhoto(); });
    var px=$('tri-photoClear'); if(px) px.addEventListener('click',function(e){ e.preventDefault(); TRI.photo=null; TRI.photoFile=null; triSyncUI(); render(); });
    var zm=$('tri-zoom'); if(zm) zm.addEventListener('input',function(){ TRI.zoom=Math.max(1,Math.min(triZoomCap(),(+zm.value||100)/100)); render(); });
    var zr=$('tri-zoomReset'); if(zr) zr.addEventListener('click',function(e){ e.preventDefault(); triPhotoReset(); render(); });
    root.querySelectorAll('#tri-mode [data-v]').forEach(function(b){ b.addEventListener('click',function(){ triSetMode(b.getAttribute('data-v')); }); });
    root.querySelectorAll('#tri-mstyle [data-v]').forEach(function(b){ b.addEventListener('click',function(){ TRI.mapStyle=b.getAttribute('data-v'); triSyncUI(); render(); }); });
    var _sfb=$('tri-sf'); if(_sfb){ _sfb.checked=TRI.sf!==false; _sfb.addEventListener('change',function(){ TRI.sf=!!_sfb.checked; render(); }); }   /* 2 Nov */
    /* Background sits above the preview, where the single-sport designs keep
       their style controls (on a phone too: ordered just above the sticky
       preview). */
    var lk=$('tri-look'), stg=root.querySelector('.cz-pmstage');
    if(lk && stg && stg.parentNode) stg.parentNode.insertBefore(lk,stg);
    root.querySelectorAll('#tri-ttheme [data-v]').forEach(function(b){ b.addEventListener('click',function(){ TRI.ttheme=b.getAttribute('data-v'); triSyncUI(); render(); }); });
    var cl=$('tri-clear'); if(cl) cl.addEventListener('click',function(e){ e.preventDefault(); triClear(); });
    root.querySelectorAll('#tri-layout [data-v]').forEach(function(b){ b.addEventListener('click',function(){ triSetLayout(b.getAttribute('data-v')); }); });
    /* ?brand=1 only: the giveaway card download, made here so it is nowhere
       in the page a customer is sent. */
    if(TRI_BRAND && lk){
      var sb=document.createElement('button'); sb.type='button'; sb.id='tri-story'; sb.className='tri-photobtn';
      sb.textContent='Download the 1080 \u00d7 1920 finisher card'; sb.style.margin='0 0 12px';
      sb.addEventListener('click',function(e){ e.preventDefault(); triStoryDownload(); });
      lk.parentNode.insertBefore(sb,lk.nextSibling);
    }
    var dp=$('cz-date'); if(dp && !dp.value){ /* the race date comes from the course, or the customer */ }
    triSyncUI();
  }
  /* ===================== end TRIATHLON ===================== */

  function renderMain(ctx,ox,oy,W,H,fillBg){
    if(IS_TRI){ renderTri(ctx,ox,oy,W,H,fillBg); return; }
    if(IS_SPLIT){ renderSplit(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    /* Format first: the frame overrides whatever design is selected, because
       the design supplies the art for its panel, not the page layout. The print
       file passes showMedal false - see flatBlob(). */
    if(state.product==='frame'){
      renderFrame(ctx,ox,oy,W,H,fillBg,state.view!=='flat');
      drawAttrib(ctx,ox,oy,W,H); return;
    }
    if(IS_EDT){ renderEditorial(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    if(IS_TD){ renderTerrainDesign(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    if(IS_PO){ renderPhotoOverlay(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    if(IS_GAL){ renderGallery(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    if(sbOn()){ renderStatBar(ctx,ox,oy,W,H,fillBg); return; }
    if(ndOn()){ ndRender(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H); return; }
    if(t3On()){ renderT3(ctx,ox,oy,W,H,fillBg); return; }
    if(has2()) renderDouble(ctx,ox,oy,W,H,fillBg); else renderDesign(ctx,ox,oy,W,H,fillBg); drawAttrib(ctx,ox,oy,W,H);
  }

  function drawSplitRouteArt(ctx,x,y,w,h){
    if(noRoute()){ drawRoutePrompt(ctx,x,y,w,h,true); return; }
    
    if(state.style==='heat' && state.heatCanvas){
      var hb=state.heatBbox, s=Math.min(w*0.86/hb.w, h*0.86/hb.h);
      var dw=hb.w*s, dh=hb.h*s; ctx.drawImage(state.heatCanvas, hb.x,hb.y,hb.w,hb.h, x+(w-dw)/2, y+(h-dh)/2, dw,dh);
    } else if(isMapLike(state.style) && state.mapImg){
      var im=state.mapImg, cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035), sw=im.width, sh=im.height-cropB;
      var s2=Math.min(w*0.9/sw, h*0.9/sh), dw2=sw*s2, dh2=sh*s2;
      ctx.save(); ctx.drawImage(im,0,0,sw,sh, x+(w-dw2)/2, y+(h-dh2)/2, dw2,dh2); ctx.restore();
    } else if(state.mask&&state.bbox){
      var col=colourised(), bb=state.bbox, glow=w*0.05;
      var availW=w*0.82-glow, availH=h*0.82-glow;
      var s3=Math.min(availW/bb.w,availH/bb.h), dw3=bb.w*s3, dh3=bb.h*s3, dx3=x+(w-dw3)/2, dy3=y+(h-dh3)/2;
      var draw=function(blur){ ctx.save(); if(blur){ctx.shadowColor=state.accent;ctx.shadowBlur=blur;}
        ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3); ctx.restore(); };
      glowArt(ctx,col,bb.x,bb.y,bb.w,bb.h,dx3,dy3,dw3,dh3,glow,state.accent);
    }
  }
  function drawSplitPhoto(ctx,x,y,w,h){
    if(splitPhotoLoading){
      ctx.fillStyle='#2a2a30'; ctx.fillRect(x,y,w,h);
      ctx.textAlign='center'; ctx.fillStyle='#e8e4dc';
      ctx.font='600 '+(w*0.05)+'px Inter,sans-serif'; ctx.fillText('Loading photo\u2026', x+w/2, y+h/2);
      return;
    }
    if(splitPhoto){
      var ir=splitPhoto.width/splitPhoto.height, br=w/h, sw,sh,sx,sy;
      if(ir>br){ sh=splitPhoto.height; sw=sh*br; sy=0; sx=(splitPhoto.width-sw)*splitPhotoOff.x; }
      else { sw=splitPhoto.width; sh=sw/br; sx=0; sy=(splitPhoto.height-sh)*splitPhotoOff.y; }
      ctx.save(); ctx.beginPath(); ctx.rect(x,y,w,h); ctx.clip();
      ctx.drawImage(splitPhoto, sx,sy,sw,sh, x,y,w,h);
      
      var chipW=w*0.42, chipH=h*0.085, chipX=x+(w-chipW)/2, chipY=y+h*0.035;
      if(_splitHeroPaint){
        ctx.fillStyle='rgba(13,13,16,0.62)'; roundRect(ctx,chipX,chipY,chipW,chipH,chipH*0.3); ctx.fill();
        ctx.fillStyle='#F2F2F4'; ctx.textAlign='center'; ctx.font='600 '+(h*0.042)+'px Inter,sans-serif';
        ctx.fillText('CHANGE PHOTO', x+w/2, chipY+chipH*0.66);
        ctx.fillStyle='rgba(242,242,244,0.55)'; ctx.font='500 '+(h*0.038)+'px Inter,sans-serif';
        ctx.fillText('drag to reposition', x+w/2, y+h-h*0.04);
      }
      ctx.restore();
      if(_splitHeroPaint) splitChipRect={x:chipX,y:chipY,w:chipW,h:chipH};
    } else {
      
      ctx.fillStyle='#3a3a40'; ctx.fillRect(x,y,w,h);
      ctx.save(); ctx.strokeStyle='rgba(255,255,255,0.35)'; ctx.setLineDash([w*0.02,w*0.02]); ctx.lineWidth=Math.max(2,w*0.006);
      ctx.strokeRect(x+w*0.04,y+h*0.04,w*0.92,h*0.92); ctx.restore();
      ctx.textAlign='center'; ctx.fillStyle='#f0ede6';
      ctx.font='700 '+(w*0.055)+'px Inter,sans-serif'; ctx.fillText('+  ADD YOUR PHOTO', x+w/2, y+h/2-w*0.005);
      ctx.font='500 '+(w*0.03)+'px Inter,sans-serif'; ctx.fillStyle='#c9c6bf';
      ctx.fillText('tap here to upload', x+w/2, y+h/2+w*0.05);
      splitChipRect=null;
    }
  }
  var splitPhotoLoading=false;
  var _splitHeroPaint=false;    
  function renderSplit(ctx,ox,oy,W,H,fillBg){
    ctx.fillStyle='#1a1a1f'; ctx.fillRect(ox,oy,W,H);
    /* Margins clear Printful's safe print area. Type is sized off U, the short
       side: this tile is 1697x1200 landscape, so a fraction of W would print
       at a different physical size here than the same fraction does on the
       900x1273 portrait posters. U is the 11.69in side on both. */
    var U=Math.min(W,H);
    var mL=ox+W*0.085, mR=W*0.085, colW=W*0.83, safe=H*0.095;
    function sp(t,em){ em=em||0.08; return spaced(t,em); }

    var topY=oy+H*0.085, ruleY=topY+H*0.022;
    ctx.textBaseline='alphabetic';
    ctx.font='600 '+(U*0.024)+'px Inter,sans-serif'; ctx.fillStyle='#8a8a90';
    var dd=($('cz-date')&&$('cz-date').value)||'', dm=/^(\d{4})-(\d{2})-(\d{2})$/.exec(dd);
    var _ds=dm?(dm[3]+'.'+dm[2]+'.'+dm[1]):'', _dw2=0;
    ctx.textAlign='left';  ctx.fillText(sp(_ds,0.14), mL, topY);
    if(_ds) _dw2=ctx.measureText(sp(_ds,0.14)).width;
    var _n2=dsName();
    if(_n2){
      var _av2=(ox+W-mR)-(mL+_dw2)-W*0.04, _ns2=U*0.034, _g2=0;
      ctx.font='700 '+_ns2+'px Inter,sans-serif';
      while(ctx.measureText(sp(_n2,0.06)).width>_av2 && _ns2>4 && _g2++<60){
        _ns2*=0.95; ctx.font='700 '+_ns2+'px Inter,sans-serif';
      }
      ctx.textAlign='right'; ctx.fillText(sp(_n2,0.06), ox+W-mR, topY);
    }
    ctx.strokeStyle='rgba(255,255,255,0.14)'; ctx.lineWidth=Math.max(1,W*0.0008);
    ctx.beginPath(); ctx.moveTo(mL,ruleY); ctx.lineTo(ox+W-mR,ruleY); ctx.stroke();

    /* Title sits under the rule at a fixed size and wraps rather than being
       squeezed by whatever the stats need. */
    var track=0.05;
    var title=(($('cz-title')&&$('cz-title').value.trim())||'MY MILESTONE').toUpperCase();
    var lay=dsTitle(ctx,title,U*0.098,colW,2,track,U*0.055);
    var lines=lay.lines, fs=lay.fs, lineH=fs*1.05;
    var titleFirst=ruleY+H*0.070+fs*0.82;
    var titleLast=titleFirst+(lines.length-1)*lineH;
    var loc=(($('cz-loc')&&$('cz-loc').value)||'').toUpperCase();
    var locFs=U*0.026, locBase=titleLast+locFs+H*0.026;

    /* Stat type is measured before anything is placed, because the halves are
       sized off where the stats block actually starts. */
    var stats=statRows('')
      .filter(function(s){return s[1]&&s[1].trim();});
    var valBase=oy+H-safe, valFs=U*0.046, labFs=U*0.021, labBase=valBase, statsTop=valBase, cw=colW;
    if(stats.length){
      cw=colW/stats.length;
      var avail=cw*0.92, mv=0, ml=0;
      ctx.font='800 '+valFs+'px Inter,sans-serif';
      stats.forEach(function(s){ mv=Math.max(mv,ctx.measureText(s[1].toUpperCase()).width); });
      if(mv>avail) valFs*=avail/mv;
      ctx.font='600 '+labFs+'px Inter,sans-serif';
      stats.forEach(function(s){ ml=Math.max(ml,ctx.measureText(sp(s[0],0.1)).width); });
      if(ml>avail) labFs*=avail/ml;
      labBase=valBase-valFs-H*0.018;
      statsTop=labBase-labFs*0.75;
    }

    var halfTop=(loc?locBase:titleLast)+H*0.040;
    var halfBottom=statsTop-H*0.040;
    var halfH=Math.max(H*0.15, halfBottom-halfTop);
    var gap=W*0.028, halfW=(colW-gap)/2;
    var photoX = splitSide==='right' ? mL+halfW+gap : mL;
    var routeX = splitSide==='right' ? mL : mL+halfW+gap;
    drawSplitRouteArt(ctx, routeX, halfTop, halfW, halfH);
    drawSplitPhoto(ctx, photoX, halfTop, halfW, halfH);
    if(_splitHeroPaint){
      splitPhotoRect={x:photoX,y:halfTop,w:halfW,h:halfH,ox:ox,oy:oy,W:W,H:H};
    }

    ctx.textAlign='left'; ctx.textBaseline='alphabetic';
    ctx.font='800 '+fs+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4';
    for(var li=0; li<lines.length; li++) ctx.fillText(sp(lines[li],track), mL, titleFirst+li*lineH);
    if(loc){ ctx.font='600 '+locFs+'px Inter,sans-serif'; ctx.fillStyle='#8a8a90';
      ctx.fillText(sp(loc,0.18), mL, locBase); }
    if(stats.length){
      stats.forEach(function(s,i){ var x=mL+cw*i;
        ctx.font='600 '+labFs+'px Inter,sans-serif'; ctx.fillStyle='#8a8a90';
        ctx.fillText(sp(s[0],0.1), x, labBase);
        ctx.font='800 '+valFs+'px Inter,sans-serif'; ctx.fillStyle='#F2F2F4';
        ctx.fillText(s[1].toUpperCase(), x, valBase); });
    }
  }
  var splitPhotoRect=null;
  var splitChipRect=null;
  var splitPhotoOff={x:0.5,y:0.5};    
  var SPLIT_MIN=1200;
  /* Printed size per product, used to turn a photo's pixel count into a real
     DPI rather than checking one flat number for every product. Tee is the
     usable DTF area, not the garment. */
  /* formats: not frame,a4print,digital - the framed formats fall back to the
     poster's inches below, and nothing here is printed by us. */
  var PRINT_IN={poster:[11.69,16.54], tee:[11,14], magnet:[3.94,4.92]};
  /* The real printed sheet, inches, for every format - which PRINT_IN is not:
     it is the DPI table and lets the framed sizes fall back to the poster's.
     Gallery cannot use that fallback, because two of its rules are physical
     rather than proportional: compact mode below 150 mm of width, and a 6 pt
     floor on any printed text. A4 is not A3, and a magnet is not either.
     formats: all - a format missing from here has no compact decision to make. */
  var SHEET_IN={ poster:[11.69,16.54], a4print:[8.27,11.69], magnet:[3.94,4.92],
                 tee:[11,14], frame:[9.84,9.84], digital:[11.69,16.54] };
  function galSheet(prod){ return SHEET_IN[prod||state.product]||SHEET_IN.poster; }
  /* 150 mm. Under it the five-column info row is unreadable - at magnet size a
     0.015 W label is about 4 pt - so the layout changes rather than shrinking. */
  var GAL_COMPACT_IN=5.9055;
  function galCompact(prod){ return galSheet(prod)[0] < GAL_COMPACT_IN; }
  /* 6 pt at this artwork's own resolution. W px over the sheet's width in
     inches is the DPI, whatever scale the canvas happens to be. */
  function galFloor(W,prod){ return W*6/(72*galSheet(prod)[0]); }
  var DPI_BLOCK=120, DPI_WARN=180;
  function photoDpi(im, prod, fullTile){
    var d=PRINT_IN[prod]||PRINT_IN.poster, iw=d[0], ih=d[1];
    /* photo-split gives the photo half the width; photo-overlay the whole tile. */
    if(!fullTile) iw=iw/2;
    var target=iw/ih, cw, ch;
    if(im.width/im.height > target){ ch=im.height; cw=im.height*target; }
    else { cw=im.width; ch=im.width/target; }
    return Math.min(cw/iw, ch/ih);
  }
  function dpiVerdict(im){
    var worst=null;
    /* formats: partial - the photo-overlay crop box is only drawn on the
       formats whose preview shows a croppable sheet. */
    (IS_PO?['poster','tee','magnet']:['poster']).forEach(function(p){
      var v=photoDpi(im,p,!!IS_PO);
      if(worst===null || v<worst.dpi) worst={prod:p, dpi:v};
    });
    return worst;
  }

  var _splitInput=null;
  function splitFilePick(){
    if(!_splitInput){ _splitInput=document.createElement('input'); _splitInput.type='file'; _splitInput.accept='image/*';
      /* NOT display:none - iOS Safari refuses to present the picker for an
         input that is not rendered. Keep it in the layer, just out of sight. */
      _splitInput.setAttribute('aria-hidden','true'); _splitInput.tabIndex=-1;
      _splitInput.style.cssText='position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none;z-index:-1';
      document.body.appendChild(_splitInput);
      _splitInput.addEventListener('change',function(){ var f=_splitInput.files&&_splitInput.files[0]; if(f) splitSetPhoto(f); _splitInput.value=''; }); }
    _splitInput.click();
  }
  function splitMsg(t,bad){
    
    var el=document.getElementById('cz-splitmsg');
    if(!el){
      el=document.createElement('div'); el.id='cz-splitmsg'; el.className='cz-splitmsg';
      var host=root.querySelector('.cz-pmstage')||root.querySelector('.cz-hero')||root.querySelector('.cz-herocv');
      if(host&&host.parentNode) host.parentNode.insertBefore(el, host.nextSibling); else root.appendChild(el);
    }
    el.textContent=t||''; el.style.display=t?'block':'none';
    el.classList.toggle('cz-bad', !!bad);
  }
  function splitSetPhoto(file){
    if(!/^image\//.test(file.type)){ splitMsg('That file isn\u2019t an image \u2014 please choose a photo.',true); return; }
    splitMsg(''); splitPhotoLoading=true; if(IS_SPLIT) render();     
    var url=URL.createObjectURL(file), im=new Image();
    im.onload=function(){
      /* The old check was a flat 1200px on the short edge, which is too strict
         for a magnet and far too lax for a poster. Judge it in DPI at the size
         it will actually print. */
      var cur=((IS_PO||IS_GAL||sbOn()||ndPh())?state.product:'poster')||'poster';
      /* Gallery measures the panel, not the sheet: half the width and a crop
         of its own, so the sheet figure would wave through photos that are
         thin in the column and reject ones that are fine. */
      var dpiNow=(IS_GAL||sbOn()||ndPh())?galPanelDpiFor(im):photoDpi(im,cur,!!IS_PO);
      if(dpiNow < DPI_BLOCK){
        splitPhotoLoading=false; if(IS_SPLIT||IS_PO) render();
        splitMsg('That photo is too low-resolution to print on the '+cur+
          ' \u2014 it works out to about '+Math.round(dpiNow)+' DPI, and it needs '+DPI_BLOCK+
          '. Use the original from your camera roll rather than one saved from Instagram or a screenshot.',true);
        URL.revokeObjectURL(url); return;
      }
      if(IS_GAL||sbOn()||ndPh()){
        /* Gallery has its own note, under the controls, that re-reads every
           time the crop moves. Two warnings about the same photo with two
           different thresholds - 180 on the sheet here, 150 in the panel there
           - is one warning too many and the wrong one is the louder. */
        splitMsg('');
      } else if(dpiNow < DPI_WARN){
        splitMsg('Heads up: this photo prints at about '+Math.round(dpiNow)+
          ' DPI on the '+cur+'. It will look fine from a step back but soft up close \u2014 '+
          'a higher-resolution original would be sharper.',false);
      } else splitMsg('');
      splitPhoto=im; splitPhotoFile=file; splitPhotoOff={x:0.5,y:0.5};
      /* A new photo starts from the design's own default crop, not whatever the
         last one was dragged to - the subject is somewhere else. */
      if(typeof galPhotoReset==='function'){
        galPhotoReset();
        var _gz=$('cz-galZoom'); if(_gz) _gz.value=100;
      }
      splitPhotoLoading=false; render();
      if(typeof syncGalRow==='function') syncGalRow();
      if(CLOUD.name && CLOUD.preset){
        splitPhotoUrl='';                                 
        cloudUpload(file,'image').then(function(u){ splitPhotoUrl=u; })
          .catch(function(){ console.error('Milestone: split photo upload failed — will retry at add-to-cart'); });
      }
    };
    im.onerror=function(){ splitPhotoLoading=false; if(IS_SPLIT) render();
      splitMsg('Couldn\u2019t read that image \u2014 try another photo.',true); URL.revokeObjectURL(url); };
    im.src=url;
  }
  var splitPhotoFile=null;

  /* ---- Gallery's photo panel ------------------------------------------------
     Its own crop state rather than photo-overlay's: the panels are different
     shapes, so a crop chosen for a full tile is meaningless in a 1:2 column,
     and switching designs should not carry one into the other. */
  var galOff={x:0.5,y:GAL.photoFocus};
  var galZoom=1;
  var GAL_ZOOM_MAX=4;
  function galPhotoReset(){ galOff={x:0.5,y:GAL.photoFocus}; galZoom=1; }

  /* The source rectangle that fills a panel: cover crop, then zoom in on the
     chosen focus. Pulled out so the resolution warning can ask how many source
     pixels the customer is actually printing. */
  /* How far this photo can zoom before the panel drops under GAL_DPI_WARN on
     the current format - DPI falls as 1/zoom, so it is the zoom-1 DPI over
     the threshold. Cached on the things it depends on. */
  var _galCapK='', _galCapV=4;
  function galZoomCap(im){
    im=im||splitPhoto; if(!im) return GAL_ZOOM_MAX;
    var k=im.width+'x'+im.height+'|'+(typeof galSheet==='function'?galSheet().join('x'):'')+'|'
          +(typeof galRibOn==='function'&&galRibOn()?1:0)+'|'+(state.product||'');
    if(k===_galCapK) return _galCapV;
    var d1=galPanelDpiFor(im,1), v=GAL_ZOOM_MAX;
    if(d1 && isFinite(d1)) v=Math.max(1,Math.min(GAL_ZOOM_MAX, d1/GAL_DPI_WARN));
    _galCapK=k; _galCapV=v; return v;
  }
  function galZoomNow(){ return Math.max(1,Math.min(galZoom, galZoomCap())); }
  function galCrop(im,w,h,zo){
    var ir=im.width/im.height, br=w/h, sw, sh;
    if(ir>br){ sh=im.height; sw=sh*br; } else { sw=im.width; sh=sw/br; }
    var z=(zo!=null)?zo:Math.max(1,Math.min(GAL_ZOOM_MAX,galZoom,galZoomCap(im)));
    sw/=z; sh/=z;
    return { sx:(im.width-sw)*galOff.x, sy:(im.height-sh)*galOff.y, sw:sw, sh:sh };
  }

  /* Where the photo panel landed on the hero canvas, for hit-testing. Gated on
     _splitHeroPaint, which is the engine's own "this is the on-screen hero in
     flat view" flag - the thumbnails repaint afterwards and would leave the
     rect pointing at a 58 px tile, and the print render would leave it in
     print-file coordinates, where no tap can ever land. */
  var galPhotoRect=null;
  function drawGalPhoto(ctx,r,fillBg){
    if(_splitHeroPaint) galPhotoRect={x:r.x,y:r.y,w:r.w,h:r.h};
    ctx.save(); ctx.beginPath(); ctx.rect(r.x,r.y,r.w,r.h); ctx.clip();
    ctx.fillStyle=GAL.photoBg; ctx.fillRect(r.x,r.y,r.w,r.h);
    if(!splitPhoto){
      /* The same words and the same dashed box the other photo design uses -
         see drawSplitPhoto. Only the colours differ, because that panel is dark
         and this one is light paper.

         Preview only. The print file renders this same code path, so the prompt
         is gated on the photo rather than on the view: gate it on the view and a
         customer who skipped the upload prints the word. */
      ctx.save();
      ctx.strokeStyle='rgba(23,23,26,0.28)';
      ctx.setLineDash([r.w*0.04,r.w*0.04]);
      ctx.lineWidth=Math.max(1,r.w*0.008);
      ctx.strokeRect(r.x+r.w*0.06,r.y+r.h*0.03,r.w*0.88,r.h*0.94);
      ctx.restore();
      ctx.textAlign='center';
      /* Shrink to fit rather than trusting a fraction: this panel is half the
         width of the one drawSplitPhoto draws into, so the size that suits it
         there runs off the edge here. */
      var _t1='+  ADD YOUR PHOTO', _ps=r.w*0.085, _g2=0;
      ctx.font='700 '+_ps+'px Inter,sans-serif';
      while(ctx.measureText(_t1).width>r.w*0.80 && _ps>7 && _g2++<60){
        _ps*=0.95; ctx.font='700 '+_ps+'px Inter,sans-serif';
      }
      ctx.fillStyle=GAL.ink;
      ctx.fillText(_t1, r.x+r.w/2, r.y+r.h/2-_ps*0.25);
      ctx.fillStyle=GAL.lbl;
      ctx.font='500 '+Math.max(6,_ps*0.54)+'px Inter,sans-serif';
      ctx.fillText('tap here to upload', r.x+r.w/2, r.y+r.h/2+_ps*0.95);
      ctx.textAlign='left'; ctx.restore(); return;
    }
    var c=galCrop(splitPhoto,r.w,r.h);
    ctx.drawImage(splitPhoto, c.sx, c.sy, c.sw, c.sh, r.x, r.y, r.w, r.h);
    ctx.restore();
  }

  function drawGalMap(ctx,r,route){
    ctx.save(); ctx.beginPath(); ctx.rect(r.x,r.y,r.w,r.h); ctx.clip();
    ctx.fillStyle=GAL.mapBg; ctx.fillRect(r.x,r.y,r.w,r.h);
    if(noRoute()){ ctx.restore(); drawRoutePrompt(ctx,r.x,r.y,r.w,r.h,false); return; }
    if(isMapLike(state.style) && state.mapImg){
      /* Cover-fit, with Geoapify's attribution strip cropped - the same crop
         drawArtInto makes, and the reason the request is grossed up. */
      var im=state.mapImg;
      var cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035);
      var sw=im.width, sh=im.height-cropB;
      var sc=Math.max(r.w/sw, r.h/sh), dw=sw*sc, dh=sh*sc;
      ctx.drawImage(im,0,0,sw,sh, r.x+(r.w-dw)/2, r.y+(r.h-dh)/2, dw,dh);
    } else if(state.mask && state.bbox){
      /* No tiles: the route mask alone, fitted inside the brief's inset rather
         than cover-cropped, because there is no surrounding map to lose. */
      var col=colourised(), bb=state.bbox;
      var s2=Math.min(route.w/bb.w, route.h/bb.h), dw2=bb.w*s2, dh2=bb.h*s2;
      ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,
                    route.x+(route.w-dw2)/2, route.y+(route.h-dh2)/2, dw2,dh2);
    } else {
      var ms=Math.max(6,r.w*0.05);
      ctx.fillStyle=GAL.lbl; ctx.font=galMono(ms,400); ctx.textAlign='center';
      ctx.fillText('Loading map\u2026', r.x+r.w/2, r.y+r.h/2);
      ctx.textAlign='left';
    }
    ctx.restore();
  }

  function renderGallery(ctx,ox,oy,W,H,fillBg){
    if(fillBg){ ctx.fillStyle=GAL.paper; ctx.fillRect(ox,oy,W,H); }
    var L=galLayout(ctx,ox,oy,W,H);
    var ink=galInk(fillBg), lblCol=galLblCol(fillBg);
    ctx.textBaseline='alphabetic'; ctx.textAlign='left';

    drawGalMap(ctx,L.mapR,L.routeR);
    drawGalPhoto(ctx,L.photoR,fillBg);
    /* One keyline around the pair, none between them: the panels touch, and a
       line down the middle would read as a gutter that is not there. */
    ctx.strokeStyle=ink; ctx.lineWidth=L.key;
    ctx.strokeRect(L.panel.x+L.key/2, L.panel.y+L.key/2,
                   L.panel.w-L.key, L.panel.h-L.key);
    if(L.ribR) drawRibbon(ctx, L.ribR.x, L.ribR.x+L.ribR.w, L.ribR.y, L.ribR.h, W);

    var ty=L.textY;
    ctx.fillStyle=GAL.acc;
    ctx.fillRect(L.lx, ty+L.accY, W*GAL.accW, W*GAL.accH);

    ctx.fillStyle=ink; ctx.font=galCond(L.tsz,600);
    for(var i=0;i<L.lines.length;i++)
      edtTracked(ctx,L.lines[i],L.lx,ty+L.tBase[i],L.ttr);

    if(L.mergeTxt){
      /* Ink, not the label grey: this line carries the customer's name now, and
         their name is the point of the poster rather than a caption on it. */
      ctx.font=galMono(L.msz,500); ctx.fillStyle=ink;
      edtTracked(ctx,L.mergeTxt,L.lx,ty+L.mBase,L.msz*GAL.mergeTrack);
    }

    ctx.fillStyle=ink;
    ctx.fillRect(L.lx, ty+L.hairY, L.inner, L.key);

    for(var ci=0;ci<L.cols.length;ci++){
      var c=L.cols[ci];
      ctx.fillStyle=lblCol; ctx.font=galMono(c.lsz,400);
      edtTracked(ctx,c.label,c.x,ty+L.labBase,c.ltr);
      ctx.fillStyle=ink; ctx.font=galCond(c.vsz,500);
      for(var vi=0;vi<c.vLines.length;vi++)
        ctx.fillText(c.vLines[vi], c.x, ty+L.valBase+vi*c.vsz*GAL.valLh);
    }
  }
  function roundRect(ctx,x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
  function paintFlat(ctx,W,H){ renderMain(ctx,0,0,W,H,true); }
  /* Is the chosen poster variant the A4 one? Same test posterSpecFor() uses,
     so the size written on the page and the photographs it is shown with can
     never disagree. pickedVariant() already returns null for a format with no
     variants, so this is false everywhere else. */
  function isA4Pick(){
    var pv=pickedVariant();
    return !!(pv && /\ba4\b/i.test(String(pv.title||'')));
  }
  function mockKey(prod){
    if(IS_SPLIT) return 'split';
    /* Before the edt_ check on purpose: at A4 the size is what the photograph
       is of, and these blanks are plain white sheets that suit every design.
       Falls through when no A4 set is configured. */
    if(prod==='poster' && MOCKUPS.poster_a4 && MOCKUPS.poster_a4[0] && isA4Pick())
      return 'poster_a4';
    /* The frame's mockups are of the frame, so the design inside it is
       irrelevant - never fall through to the edt_* sets. */
    if(FRAMED_FMTS[prod]) return prod;

    /* From the table, not a list of design names: naming them here is how
       Gallery ended up on the neon blanks while its own strip tile, its tile
       theme and its generated products all said light paper. */
    var pre=kindBlank(DESIGN_KIND)||'';
    var ek=pre+prod;
    if(pre && MOCKUPS[ek] && MOCKUPS[ek][0]) return ek;
    return prod;
  }
  function paintMockup(ctx,W,H){
    var prod=state.product, mk=mockKey(prod), idx=state.mockIdx||0, mi=mockImgs[mk][idx];
    if(mi){
      /* The surround. A fixed oatmeal is right when the photo fills the
         canvas; against a square canvas holding a tall photo it is a pair of
         bars, so take the colour from the photo's own border instead. */
      ctx.fillStyle=(isDigital(prod)?edgeTint(mi,mk+':'+idx):'#eeeae2'); ctx.fillRect(0,0,W,H);   
      var s=Math.min(W/mi.width,H/mi.height), dw=mi.width*s, dh=mi.height*s, dx=(W-dw)/2, dy=(H-dh)/2;
      /* A mockup saved as a PNG with the opening knocked out needs neither a
         measured rectangle nor a colour key. Lay the artwork down first and
         the photo over it, and whatever was in front of the print in the
         photo - a thumb, a reflection, the moulding's inner lip - is in front
         of it again, exactly as photographed. */
      if(mockHasAlpha[mk] && mockHasAlpha[mk][idx]){
        var aw=alphaWindow(mi,mk+':'+idx);
        if(aw){
          var ax=dx+aw[0]*dw, ay=dy+aw[1]*dh,
              aW=(aw[2]-aw[0])*dw, aH=(aw[3]-aw[1])*dh;
          ctx.save(); ctx.beginPath(); ctx.rect(ax,ay,aW,aH); ctx.clip();
          renderMain(ctx,ax,ay,aW,aH,true); ctx.restore();
          ctx.drawImage(mi,dx,dy,dw,dh);
          return;
        }
        console.warn('Milestone: mockup '+mk+':'+idx+' is transparent but no '+
          'enclosed opening was found in it - falling back to the rectangle. '+
          'Knock the window out of the middle, not the background.');
      }
      /* A format with no rectangle for this mockup used to throw here and take
         the whole stage down. Fall back to the flat render instead. */
      var rc=(MOCKRECT[mk]||[])[idx];
      if(FRAMED_FMTS[mk]){ var _fw=frameWindow(mi,mk+':'+idx); if(_fw) rc=_fw; }
      /* A digital mockup has no measured table at all: the window is found in
         the photo. Wide enough to cover a phone screen and a sheet, because
         either is a reasonable thing to photograph for this product. */
      if(isDigital(mk)){ var _dw=frameWindow(mi,mk+':'+idx,[0.33,1.10]); if(_dw) rc=_dw; }
      if(!rc){ console.warn('Milestone: no MOCKRECT for',mk,idx,'- drawing flat');
               paintFlat(ctx,W,H); return; }
      if(rc && typeof rc[0]!=='number'){
        ctx.drawImage(mi,dx,dy,dw,dh);
        for(var _ri=0;_ri<rc.length;_ri++){
          var _r=rc[_ri], _x=dx+_r[0]*dw, _y=dy+_r[1]*dh,
              _w=(_r[2]-_r[0])*dw, _h=(_r[3]-_r[1])*dh;
          ctx.save(); roundRect(ctx,_x,_y,_w,_h,_w*0.02); ctx.clip();
          renderMain(ctx,_x,_y,_w,_h,true); ctx.restore();
        }
        return;
      }
      var px=dx+rc[0]*dw, py=dy+rc[1]*dh, pw=(rc[2]-rc[0])*dw, ph=(rc[3]-rc[1])*dh;
      if(IS_SPLIT){

        var mask=mockMask(mk,idx,mi,rc);
        if(mask){
          var tmp=mockTmp; if(tmp.width!==Math.round(dw)||tmp.height!==Math.round(dh)){ tmp.width=Math.round(dw); tmp.height=Math.round(dh); }
          var tctx=tmp.getContext('2d'); tctx.clearRect(0,0,tmp.width,tmp.height);
          
          tctx.save(); tctx.beginPath(); tctx.rect(rc[0]*tmp.width, rc[1]*tmp.height, (rc[2]-rc[0])*tmp.width, (rc[3]-rc[1])*tmp.height); tctx.clip();
          renderMain(tctx, rc[0]*tmp.width, rc[1]*tmp.height, (rc[2]-rc[0])*tmp.width, (rc[3]-rc[1])*tmp.height, false); tctx.restore();
          
          tctx.globalCompositeOperation='destination-in'; tctx.drawImage(mask,0,0,tmp.width,tmp.height); tctx.globalCompositeOperation='source-over';
          ctx.drawImage(mi,dx,dy,dw,dh);                  
          ctx.drawImage(tmp,dx,dy,dw,dh);                 
          return;
        }
        ctx.save(); ctx.beginPath(); ctx.rect(px,py,pw,ph); ctx.clip(); renderMain(ctx,px,py,pw,ph,false); ctx.restore();
        ctx.drawImage(mi,dx,dy,dw,dh);
        return;
      }
      /* Poster blanks are black, and the mask keeps anything that is not the
         blank - fingers over the edge, shadows - in front of the artwork. */
      /* Any product, not posters only - the blank being black is what makes
         the mask valid, and _cover is what establishes that. */
      {
        /* Not on the frame: these blanks have a white window on a white wall,
           so a colour-keyed mask cannot tell the two apart and the artwork
           bleeds out past the frame. A plain clip to the rect is correct here. */
        var pmask=LIGHT_BLANKS[mk]?null:mockMask(mk,idx,mi,rc);
        if(pmask && pmask._cover>0.55){
          var ptmp=mockTmp;
          if(ptmp.width!==Math.round(dw)||ptmp.height!==Math.round(dh)){ ptmp.width=Math.round(dw); ptmp.height=Math.round(dh); }
          var pt=ptmp.getContext('2d'); pt.clearRect(0,0,ptmp.width,ptmp.height);
          pt.save(); pt.beginPath();
          pt.rect(rc[0]*ptmp.width, rc[1]*ptmp.height, (rc[2]-rc[0])*ptmp.width, (rc[3]-rc[1])*ptmp.height); pt.clip();
          /* A tee has no sheet - the garment is the ground, so the blank still
             decides. Everything else IS a printed sheet: if its paper is light,
             it has to be painted or the blank's black shows through it. */
          var _pfill = (prod==='tee') ? (pmask._lum>140)
                                      : (groundIsLight() || pmask._lum>140);
          renderMain(pt, rc[0]*ptmp.width, rc[1]*ptmp.height, (rc[2]-rc[0])*ptmp.width, (rc[3]-rc[1])*ptmp.height, _pfill);
          pt.restore();
          pt.globalCompositeOperation='destination-in';
          pt.drawImage(pmask,0,0,ptmp.width,ptmp.height);
          pt.globalCompositeOperation='source-over';
          ctx.drawImage(mi,dx,dy,dw,dh);
          ctx.drawImage(ptmp,dx,dy,dw,dh);
          return;
        }
        if(pmask && pmask._cover<=0.55){
          console.warn('Milestone: mockup '+mk+':'+idx+' — only '+
            Math.round(pmask._cover*100)+'% of the print rect matches the blank\'s '+
            'own colour, so the artwork is drawn unmasked. The rect is probably '+
            'not aligned to the poster in this blank.');
        }
      }
      ctx.drawImage(mi,dx,dy,dw,dh);
      if(prod==='tee'){ ctx.save(); ctx.beginPath(); ctx.rect(px,py,pw,ph); ctx.clip(); renderMain(ctx,px,py,pw,ph,false); ctx.restore(); }
      else if(prod==='magnet'){ ctx.save(); roundRect(ctx,px,py,pw,ph,pw*0.02); ctx.clip(); renderMain(ctx,px,py,pw,ph,true); ctx.restore(); }
      else {
        /* The frame's insert is printed cream stock, so it fills its own
           background. Leave it false and the blank's white window shows
           through and the paper colour is lost. */
        /* The mask used to supply this fill for light blanks. Without it the
           print has to paint its own paper or the blank's white shows through
           and the editorial design renders white on white. */
        ctx.save();
        /* Clip to the opening's own corners, not to a rectangle. A square
           corner on a rounded screen puts artwork on the bezel; the detector
           measured the radius, so use it. rc[4] is absent on the hand-measured
           tables, and 0 on anything with square corners. */
        /* Only a screen. frameWindow() measures this off the blank, and a
           framed photo print with a soft edge measures a radius that paper
           does not have - which rounded all four corners of the artwork inside
           a square mount. A phone mockup still needs it: a square corner there
           puts artwork on the bezel. */
        var _rr=isDigital(prod) ? ((rc.length>4 ? rc[4] : 0)*pw) : 0;
        if(_rr>1){ roundRect(ctx,px,py,pw,ph,_rr); } else { ctx.beginPath(); ctx.rect(px,py,pw,ph); }
        ctx.clip();
        /* The window's own shape says what belongs in it. Nothing but a phone
           is that much taller than it is wide, and the poster laid into one
           would be the letterboxed thing the wallpaper was built to stop
           being. */
        if(isDigital(prod) && (pw/ph)<0.55){
          /* Two phone mockups, two different files. The one the reel is staged
             in previews the reel; the other previews the wallpaper. Otherwise
             the gallery shows the same file twice and never shows the video. */
          var _rs=reelStage();
          /* Drawn at the FILE's own shape and then cropped to this screen, the
             way a phone shows the real file. Drawn straight into the screen,
             every layout decision - full-bleed map or boxed, how big the type
             is - was taken at the mockup photo's screen shape, which is not
             the file's: a Terrain buyer was shown a boxed map and sent a
             full-bleed one. */
          var _isReel=!!(_rs && _rs.idx===idx);
          /* || fallbacks: these are declared further down, and a paint during
             start-up would otherwise read them before they are assigned. */
          var _fa=_isReel ? ((REEL_W/REEL_H)||0.5625) : ((WALL_W/WALL_H)||0.45), _ow, _oh;
          if(typeof t3On==='function' && t3On()) _fa=pw/ph;   /* 3D: laid out at the screen's own shape */
          if(pw/ph < _fa){ _oh=ph; _ow=ph*_fa; } else { _ow=pw; _oh=pw/_fa; }
          /* And at no less than 540 px wide, then scaled down. The renderers
             floor some sizes (the reel's line is never under 4 px), and in a
             70 px screen that floor drew the route several times heavier than
             the file the buyer gets. */
          var _k=Math.max(1, 540/_ow);
          var _rw=Math.max(1,Math.round(_ow*_k)), _rh=Math.max(1,Math.round(_oh*_k));
          var _oc=document.createElement('canvas'); _oc.width=_rw; _oc.height=_rh;
          var _ox=_oc.getContext('2d');
          if(_isReel){
            renderReelInto(_ox,0,0,_rw,_rh,reelPrev.t,reelPts(0,0,_rw,_rh));
          } else {
            /* true = draw the lock-screen clock. This is a mockup; the file the
               customer downloads is built by wallBlob() and must not have one. */
            renderWallpaper(_ox,_rw,_rh,true);
          }
          ctx.save(); ctx.imageSmoothingEnabled=true;
          try{ ctx.imageSmoothingQuality='high'; }catch(e){}
          ctx.drawImage(_oc, 0,0,_rw,_rh, px+(pw-_ow)/2, py+(ph-_oh)/2, _ow, _oh);
          ctx.restore();
        } else {
          renderMain(ctx,px,py,pw,ph, !!LIGHT_BLANKS[mk]);
        }
        ctx.restore();
      }
      return;
    }
    /* No mockup photo for this one. There is no object to draw a stand-in of,
       so show the artwork flat rather than falling through to the tee. */
    if(isDigital(prod)){ paintFlat(ctx,W,H); return; }
    if(prod==='magnet'){
      var g=ctx.createLinearGradient(0,0,0,H); g.addColorStop(0,'#ecebe6'); g.addColorStop(1,'#d7d4cd'); ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
      var size=W*0.58, mh=size/0.8, x=(W-size)/2, y=(H-mh)/2-H*0.02, r=size*0.025;
      ctx.save(); ctx.shadowColor='rgba(0,0,0,0.40)'; ctx.shadowBlur=W*0.05; ctx.shadowOffsetY=H*0.022; ctx.fillStyle='#0d0d10'; roundRect(ctx,x,y,size,mh,r); ctx.fill(); ctx.restore();
      ctx.save(); roundRect(ctx,x,y,size,mh,r); ctx.clip(); renderMain(ctx,x,y,size,mh,false); ctx.restore();
      var sh=ctx.createRadialGradient(x+size*0.5,y,0,x+size*0.5,y,mh*0.95); sh.addColorStop(0,'rgba(255,255,255,0.10)'); sh.addColorStop(1,'rgba(255,255,255,0)');
      ctx.save(); roundRect(ctx,x,y,size,mh,r); ctx.clip(); ctx.fillStyle=sh; ctx.fillRect(x,y,size,mh); ctx.restore();
    } else if(prod==='poster'){
      var g2=ctx.createLinearGradient(0,0,0,H); g2.addColorStop(0,'#dcd6cc'); g2.addColorStop(1,'#cdc7bd'); ctx.fillStyle=g2; ctx.fillRect(0,0,W,H);
      var pw=W*0.6, ph=pw/0.70714, mat=pw*0.07, fr=pw*0.04;
      var fw=pw+2*(mat+fr), fh=ph+2*(mat+fr), fx=(W-fw)/2, fy=(H-fh)/2;
      ctx.save(); ctx.shadowColor='rgba(0,0,0,0.35)'; ctx.shadowBlur=W*0.04; ctx.shadowOffsetY=H*0.02; ctx.fillStyle='#16140f'; ctx.fillRect(fx,fy,fw,fh); ctx.restore();
      ctx.fillStyle='#f4f2ec'; ctx.fillRect(fx+fr,fy+fr,fw-2*fr,fh-2*fr);
      var px=fx+fr+mat, py=fy+fr+mat; ctx.fillStyle='#0d0d10'; ctx.fillRect(px,py,pw,ph);
      renderMain(ctx,px,py,pw,ph,false);
      ctx.strokeStyle='rgba(150,146,138,0.9)'; ctx.lineWidth=2; ctx.strokeRect(px-1,py-1,pw+2,ph+2);
    } else {
      ctx.fillStyle='#efeeea'; ctx.fillRect(0,0,W,H);
      var s=W/1200, cx=W/2, shirt='#2c2c31'; ctx.fillStyle=shirt;
      ctx.beginPath(); ctx.moveTo(cx-250*s,360*s); ctx.lineTo(cx-400*s,470*s); ctx.lineTo(cx-330*s,610*s); ctx.lineTo(cx-250*s,520*s); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.moveTo(cx+250*s,360*s); ctx.lineTo(cx+400*s,470*s); ctx.lineTo(cx+330*s,610*s); ctx.lineTo(cx+250*s,520*s); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.moveTo(cx-250*s,360*s); ctx.lineTo(cx+250*s,360*s); ctx.lineTo(cx+285*s,1120*s); ctx.lineTo(cx-285*s,1120*s); ctx.closePath(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx,430*s,250*s,130*s,0,0,Math.PI*2); ctx.fill();
      ctx.fillStyle='#efeeea'; ctx.beginPath(); ctx.ellipse(cx,377*s,95*s,55*s,0,0,Math.PI*2); ctx.fill();
      ctx.strokeStyle='rgba(20,20,24,0.85)'; ctx.lineWidth=10*s; ctx.beginPath(); ctx.ellipse(cx,360*s,95*s,60*s,0,0.12*Math.PI,0.88*Math.PI); ctx.stroke();
      var cw=430*s; renderMain(ctx,cx-cw/2,470*s,cw,cw,false);
    }
  }
  var sizeGuideImg=null;
  (function(){ var u=(MSC[5]||'').trim(); if(!u)return;
    function load(cross){ var im=new Image(); if(cross) im.crossOrigin='anonymous';
      im.onload=function(){ sizeGuideImg=im; buildDots(); if(state.product==='tee') render(); };
      im.onerror=function(){ if(cross) load(false); };
      im.src=u; } load(true); })();
  function sgOn(){ return state.view==='sizeguide' && state.product==='tee' && sizeGuideImg; }
  function paintSizeGuide(ctx,W,H){ ctx.fillStyle='#eeeae2'; ctx.fillRect(0,0,W,H);
    if(!sizeGuideImg) return; var s=Math.min(W/sizeGuideImg.width,H/sizeGuideImg.height), dw=sizeGuideImg.width*s, dh=sizeGuideImg.height*s;
    ctx.drawImage(sizeGuideImg,(W-dw)/2,(H-dh)/2,dw,dh); }
  function paint(ctx,W,H,forceFlat){ if(!forceFlat && sgOn()){ paintSizeGuide(ctx,W,H); return; }
    if(IS_SPLIT){
      if(forceFlat||state.view==='flat') renderSplit(ctx,0,0,W,H,true);   
      else paintMockup(ctx,W,H);                                          
      return;
    }
    if(forceFlat||state.view==='flat') paintFlat(ctx,W,H); else paintMockup(ctx,W,H); }
  function dims(){ if(sgOn()){ var w=1000; return [w,Math.round(w*sizeGuideImg.height/sizeGuideImg.width)]; }
    if(IS_SPLIT){ return [1697,1200]; }              
    if(state.view==='mockup'){ if(IS_SPLIT){ return mockImgs['split'][state.mockIdx||0]?[1400,1400]:[1697,1200]; } var _mi=(mockImgs[mockKey(state.product)]||[])[state.mockIdx||0];
      /* Square, whatever shape the photo is. A gallery of tiles that are each
         a different height because the photographs were reads badly, and these
         four - printer, flat-lay, hand, kiosk - are all different. */
      if(isDigital(state.product) && _mi && _mi.width) return [1000,1000];
      if(_mi&&_mi.width&&_mi.height) return [1000,Math.round(1000*_mi.height/_mi.width)]; var _ar=PRODUCTS[state.product].ar; return [920,Math.round(920/_ar)]; } var ar=PRODUCTS[state.product].ar; return [900,Math.round(900/ar)]; }
  function render(){ if(EVENT){ renderShow(); return; } var d=dims(), cv=$('cz-cv'); cv.width=d[0]; cv.height=d[1]; paint(cv.getContext('2d'),d[0],d[1]); }

  var PICKER_FIRST = MSC[6];
  var PM = MSC[7];
  var PM_FMT = MSC[8];
  var PM_FAM = MSC[9];
  /* The design the page is on RIGHT NOW. `data-design` is written once by the
     Liquid and never moves, so without this nothing outside the engine - CSS,
     ?czdebug, a browser test - can tell which design is actually showing. */
  function kindAttr(){
    try{ if(root) root.dataset.kind = (typeof DESIGN_KIND!=='undefined' && DESIGN_KIND) || 'neon'; }
    catch(e){}
  }
  MSC[10] = 'triathlon';
  var DESIGN_KIND = MSC[10];
  var IS_SPLIT = (DESIGN_KIND === 'photo-split');
  var IS_EDT   = (DESIGN_KIND === 'editorial');
  /* Gallery: the route on a light street map beside the customer's own photo,
     with a museum-label text block underneath. Shares Street Map's map source
     and tile theme and Full Photo's upload path, and is neither of them. */
  var IS_GAL   = (DESIGN_KIND === 'gallery');
  /* This copy is the triathlon page: the design is fixed. */
  var IS_TRI   = (DESIGN_KIND === 'triathlon');
  if(IS_TRI){ PRODUCTS.digital.spec='Print file \u00b7 3000 \u00d7 4243 px'; }
  /* Design kind 'terrain' - the whole-tile treatment. Distinct from
     state.style==='terrain', which is the hillshade renderer it uses. */
  var IS_TD    = (DESIGN_KIND === 'terrain');
  var IS_PO    = (DESIGN_KIND === 'photo-overlay');
  var STUDIO_TOKEN = MSC[11];
  var STUDIO = !!(STUDIO_TOKEN && (location.search||'').indexOf('studio='+STUDIO_TOKEN) >= 0);     
  /* The map palette a design's artwork is drawn on, by design kind. '' means
     the format's own default from MAPSTYLE_FOR.

     Declared here rather than beside KIND_GROUND and KIND_BLANK because this
     one is read during start-up, a long way above where those live, and a var
     read before its assignment is undefined rather than an error.

     formats: all - a kind missing here gets osm-bright, which is the colourful
     palette the light-paper designs are not drawn for. */
  var KIND_TILE = {'':'', 'editorial':'light', 'terrain':'',
                   'photo-overlay':'', 'photo-split':'', 'gallery':'light', 'statbar':'standard',
                   'manifesto':'light', 'rings':'', 'dashboard':'dark', 'cover':'', 'card':'', 'horizon':'', '3d':''};
  function tileThemeFor(k){ return KIND_TILE[k||'']||''; }
  (function(){
    var _wt=tileThemeFor(DESIGN_KIND);
    if(!_wt || state.mapStyle!=='standard') return;
    state.mapStyle=_wt;
    try{
      var _mt=root.querySelectorAll('#cz-mstyles .cz-mtab');
      for(var _i=0;_i<_mt.length;_i++) _mt[_i].classList.toggle('cz-on',_mt[_i].getAttribute('data-ms')===_wt);
    }catch(e){}
  })();
  var splitPhoto = null;              
  var splitPhotoUrl = '';             
  var splitSide = MSC[12];  
  var PM_VARIANT = 0, PM_VARIANTS = [], PM_PRICE = '', PM_DEF = null;   
  if(MSD.pm){ PM_VARIANT=MSD.pm.vid; PM_VARIANTS=MSD.pm.variants; PM_PRICE=MSD.pm.price; PM_DEF=MSD.pm.def; }

  var PM_SIBS = MSD.sibs || null;
  /* Where the other formats are offered. 'below' is the default, including
     when MSC[79] is missing entirely - an engine uploaded ahead of its section
     must not fall back to the layout we are moving away from. */
  var ALT_RAIL = String(MSC[79]||'below').toLowerCase()==='rail';
  var ALT_TITLE = 'This route also comes as\u2026';
  var FRAME_NOTE = MSC[82] || 'The medal pictured is an illustration \u2014 the real one is yours. You\u2019ll receive the frame and printed insert, ready for it.';
  var DIGI_NOTE  = MSC[92] || 'Files only \u2014 nothing is posted. You\u2019ll get an A3 print file (a 300 DPI PNG, or a 256 DPI JPEG for photo-heavy artwork such as Terrain and Full Photo), a phone wallpaper, and a six-second reel of your route drawing itself \u2014 the wallpaper and reel in this design, as pictured. All three are emailed once your payment goes through.';
  var PM_ORDER = ['poster','a4print','magnet','tee','frame','digital'];
  var EVENT = (MSC[13]==='event') || PM;
  function pmRing(){
    if(IS_SPLIT) return ['poster'];              
    /* Page mode leads with the tee; the rest follows PM_ORDER, so a new format
       does not have to be remembered in two places. */
    if(!PM) return showable(['tee'].concat(PM_ORDER.filter(function(f){ return f!=='tee'; })));
    var r = showable(PM_SIBS ? PM_ORDER.filter(function(f){ return !!PM_SIBS[f]; }) : []);
    /* The product you are ON belongs in its own ring. Without this, a format
       the sibling lookup does not know about leaves RING.indexOf(PM_FMT) at -1,
       and Math.max(0,...) quietly focuses whatever happens to be first. */
    if(PM_FMT && r.indexOf(PM_FMT)<0) r.push(PM_FMT);
    /* Stat Bar: no tee, no medal frame (spec 2). */
    if(typeof DESIGN_KIND!=='undefined' && (DESIGN_KIND==='statbar' || ndOn()) && typeof SB_FMTS!=='undefined')
      r=r.filter(function(f){ return !!SB_FMTS[f]; });
    return r.length ? r : [PM_FMT];            
  }
  var RING = pmRing();
  /* The tab row is static markup, so hiding happens here rather than in the
     template. This has to run AFTER RING, because RING is what says which
     formats this page offers - and pmRing() has already put the format the
     page is ON back into it, so a medal frame product keeps its own tab even
     while 'frame' is hidden everywhere else. */
  (function(){ var row=$('cz-tabs'); if(!row) return;
    Array.prototype.forEach.call(row.querySelectorAll('.cz-tab'),function(t){
      if(RING.indexOf(t.getAttribute('data-p'))<0) t.style.display='none';
    });
  })();
  /* state.product defaults to 'poster' and is only corrected later by
     renderShow(). On any other format that is a visible flash of the wrong
     mockup on first paint. */
  if(PM && PM_FMT && PRODUCTS[PM_FMT]) state.product=PM_FMT;
  var focusIdx = PM ? Math.max(0,RING.indexOf(PM_FMT)) : 1;   
  var heroSel=0;                             
  function focusProd(){ return RING[focusIdx]; }
  function neighbour(dir){
    var L=RING.length;
    for(var k=1;k<L;k++){ var f=RING[(((focusIdx+dir*k)%L)+L)%L]; if(framedOffered(f)) return f; }
    return RING[focusIdx];
  }
  function paintTile(cvId,product,view,mockIdx){
    var cv=$(cvId); if(!cv) return;
    var sp=state.product, sv=state.view, si=state.mockIdx;   
    state.product=product; state.view=view; state.mockIdx=mockIdx||0;
    var d=dims(); cv.width=d[0]; cv.height=d[1];
    try{ paint(cv.getContext('2d'),d[0],d[1]); }catch(e){ console.error('Milestone: tile render failed ('+product+')',e); }
    state.product=sp; state.view=sv; state.mockIdx=si;
  }
  var PLABEL={poster:'Poster',tee:'Tee',magnet:'Magnet',frame:'Medal Frame',
              a4print:'Framed A4',digital:'Digital'};

  function thumbList(){
    var prod=focusProd(), list=[], n=Math.max(1,(mockImgs[mockKey(prod)]||[]).length), i;
    /* The frame leads on its first mockup: the flat square on its own reads as
       an odd off-white card, while the framed shot says what the product is. */
    /* No flat tile on the frame at all: the mockups ARE the preview, and a
       bare cream square alongside them reads as a fourth product. */
    var noFlat=(prod==='frame' && (mockImgs[mockKey(prod)]||[]).filter(function(m){return !!m;}).length>0);
    var flatFirst=!noFlat;
    if(flatFirst) list.push({v:'flat'});
    for(i=0;i<n;i++) list.push({v:'mock',i:i});
    if(prod==='tee' && sizeGuideImg) list.push({v:'sg'});
    if(!flatFirst && !noFlat) list.push({v:'flat'});
    return list;
  }
  /* The same photo can be fine on a magnet and unusable on a poster, so the
     verdict is re-stated whenever the product changes. */
  function poDpiRecheck(){
    if(!IS_PO || !splitPhoto) return;
    var cur=state.product||'poster', d=photoDpi(splitPhoto,cur,true);
    if(d < DPI_BLOCK){
      splitMsg('This photo is too low-resolution for the '+cur+' \u2014 about '+
        Math.round(d)+' DPI against the '+DPI_BLOCK+' needed. It is fine on a magnet.',true);
    } else if(d < DPI_WARN){
      splitMsg('This photo prints at about '+Math.round(d)+' DPI on the '+cur+
        ' \u2014 fine from a step back, soft up close.',false);
    } else splitMsg('');
  }

  function applySel(sel){   
    if(sel.v==='flat'){ state.product=focusProd(); state.view='flat'; state.mockIdx=0; }
    else if(sel.v==='sg'){ state.product='tee'; state.view='sizeguide'; state.mockIdx=0; }
    else { state.product=focusProd(); state.view='mockup'; state.mockIdx=sel.i; }
    poDpiRecheck();
  }
  /* ---- the first-paint poster ------------------------------------------ */
  var _posterGone=false, _posterWhy='not started';
  function posterEl(){ return document.getElementById('cz-heroPoster'); }
  function posterDrop(why){
    if(_posterGone) return;
    _posterGone=true; _posterWhy=why||'dropped';
    var p=posterEl(); if(p && p.parentNode) p.parentNode.removeChild(p);
  }
  /* Deliberate actions only. Touch-scrolling a page fires pointerdown on
     whatever is under the finger, so pointer events would drop the poster the
     moment anybody scrolled; a click, a keystroke or an edit would not.
     isTrusted, because the boot code clicks a style tile itself. */
  function posterUserDrop(e){
    if(e && e.isTrusted===false) return;
    posterDrop('the customer did something');
  }
  function posterWatch(){
    if(!root || !posterEl()) return;
    ['click','input','change'].forEach(function(ev){
      root.addEventListener(ev, posterUserDrop, true);
    });
  }
  /* Is the poster a picture of what the canvas is drawing?
     design_thumb is written by ?generate=family from p.design.kind and
     p.design.style, and those are the same two metafields the page reads back
     as MSC[10] and PM_DEF.style - so the comparison is against what was
     actually rendered, not against a guess.

     The tile theme is NOT stored: the generator derives it from the design
     ((kind==='editorial')?'light') and so does the storefront (IS_EDT &&
     mapStyle==='standard' -> 'light'). verify.py gates that pair, because a
     poster on positron tiles over a canvas on osm-bright is a visible change
     of picture and nothing else would catch it. */
  function posterMatch(){
    var ownKind=String(MSC[10]||'').trim().toLowerCase();
    if(ownKind==='neon') ownKind='';
    if((DESIGN_KIND||'') !== ownKind) return false;
    var sp=String((PM_DEF&&PM_DEF.style)||'neon').toLowerCase().trim().split(':');
    var N={elevation:'heat',elev:'heat',heat:'heat',neon:'neon',map:'map',terrain:'terrain'};
    var ownStyle=N[sp[0]]||'neon', ownVar=(sp[1]||'').trim();
    if(state.style!==ownStyle) return false;
    /* The theme, where one applies. Falling back to the rule the generator
       used rather than to 'whatever is loaded'. */
    if(ownStyle==='map'){
      var wantMs=ownVar || (IS_EDT?'light':'');
      if(wantMs && String(state.mapStyle||'')!==wantMs) return false;
    }
    if(ownStyle==='terrain'){
      var wantTt=ownVar || 'standard';
      if(String(state.terrainTheme||'standard')!==wantTt) return false;
    }
    return true;
  }
  function posterSettle(){
    if(_posterGone) return;
    var p=posterEl(); if(!p) return;
    /* Is it even a picture of this run? */
    if(!(PM && PM_DEF && (PM_DEF.gpx || PM_DEF.poly)) || routeOverridden()){
      posterDrop('the route on screen is not this product\'s own'); return;
    }
    /* paintTile() restores state.view, so the box attribute is the only
       record of what the stage is actually showing. The poster is the FLAT
       artwork, and thumbList() opens on a mockup for the medal frame. */
    var cv=$('cz-hMain'), box=cv&&cv.parentNode;
    if(!box || box.getAttribute('data-view')!=='flat'){
      posterDrop('the stage is not showing the flat view'); return;
    }
    if(!state.coords) return;                      /* no route yet */
    /* The boot code parks the design's real style here, because it cannot be
       applied until a route exists. Until it has run, every route-apply path
       is still showing the neon it starts from - so this paint says nothing
       about whether the canvas is finished. A stored track made that window
       reachable: it is synchronous, so there IS a route on screen during it. */
    if(window.MS_ON_ROUTE) return;
    /* Not the artwork this is a picture of - so go now, rather than fade into
       something that does not match. */
    if(!posterMatch()){
      posterDrop('the stage is showing a different design or style'); return;
    }
    /* A map-like design is not finished when the route arrives - it is
       finished when the map does. Handing over early is the one thing that
       would make this worse than no poster at all. */
    if(isMapLike(state.style) && !state.mapImg && !state.mapUser) return;
    p.setAttribute('data-done','1');
    _posterGone=true; _posterWhy='handed over to the canvas';
    setTimeout(function(){
      var q=posterEl(); if(q && q.parentNode) q.parentNode.removeChild(q);
    }, 320);
  }
  function paintHero(sel){
    _splitHeroPaint=(sel.v==='flat');                 
    if(sel.v==='flat') paintTile('cz-hMain',focusProd(),'flat',0);
    else if(sel.v==='sg') paintTile('cz-hMain','tee','sizeguide',0);
    else paintTile('cz-hMain', focusProd(), 'mockup', sel.i);
    _splitHeroPaint=false;

    var cv=$('cz-hMain'), box=cv&&cv.parentNode;
    if(box) box.setAttribute('data-view', sel.v==='flat'?'flat':(sel.v==='sg'?'sg':'mock'));
    if(cv&&box&&cv.width&&cv.height) sizeStage(box,cv);
    if(box) attachZoom(box, cv);
    /* Last, and on every hero paint: the map arriving calls render(), which
       comes back through here, and that is the handover. */
    posterSettle();
  }

  /* aspect-ratio applies to the border box, so a padded stage needs the
     padding folded back in or the artwork no longer fills the content box. */
  function sizeStage(box, cv){
    /* Mobile product mode is height-driven: the canvas carries the cap and the
       box stays full width. An aspect-ratio here would transfer that cap into a
       max-width and shrink the sticky bar. */
    if(root.hasAttribute('data-pm') && window.matchMedia &&
       window.matchMedia('(max-width:820px)').matches){
      box.style.aspectRatio=''; box._stageCv=cv; return;
    }
    var pad = {x:0, y:0};
    try{
      var cs = getComputedStyle(box);
      pad.x = (parseFloat(cs.paddingLeft)||0) + (parseFloat(cs.paddingRight)||0);
      pad.y = (parseFloat(cs.paddingTop)||0) + (parseFloat(cs.paddingBottom)||0);
    }catch(e){}
    var outer = box.clientWidth;
    if(!outer){ box.style.aspectRatio = cv.width+' / '+cv.height; return; }
    var inner = Math.max(1, outer - pad.x);
    box.style.aspectRatio = outer + ' / ' + (inner*cv.height/cv.width + pad.y);
    box._stageCv = cv;
  }
  var _stageRz;
  window.addEventListener('resize', function(){
    clearTimeout(_stageRz);
    _stageRz = setTimeout(function(){
      var b=$('cz-hMain'); b = b && b.parentNode;
      if(b && b._stageCv) sizeStage(b, b._stageCv);
    }, 120);
  });

  /* The stage pins to the top on mobile and the fields scroll underneath it.
     At full height there is barely a third of the viewport left to read them
     through, so customers scroll past the editor and think it has gone.
     Compact the stage the moment it is pinned. */
  var _stkEl=null, _stkRaf=0;
  function stageEl(){
    if(_stkEl && _stkEl.parentNode) return _stkEl;
    _stkEl = root.querySelector('.cz-pmstage') || root.querySelector('.cz-hero');
    return _stkEl;
  }
  function stuckCheck(){
    _stkRaf=0;
    var el=stageEl(); if(!el) return;
    root.classList.toggle('cz-stuck', el.getBoundingClientRect().top <= 8);
  }
  function stuckQueue(){
    if(_stkRaf) return;
    _stkRaf = (window.requestAnimationFrame||setTimeout)(stuckCheck, 16);
  }
  window.addEventListener('scroll', stuckQueue, {passive:true});
  window.addEventListener('resize', stuckQueue);
  stuckQueue();

  function attachZoom(box, cv){
    if(IS_TRI) triWireBox(box,cv);       /* taps on the tiles; the lens below as for every design */
    if(IS_SPLIT||IS_PO||(IS_GAL||sbOn()||ndPh())){
      if(!box._splitWired){ box._splitWired=true;
        box.style.cursor='pointer';
        var dragging=false, moved=false, startX=0, startY=0, baseOff=null;
        function canvasXY(e){                         
          var c=box._zoomCv||cv, b=c.getBoundingClientRect();
          /* On touchend e.touches is an EMPTY TouchList - an object, so truthy,
             but [0] is undefined. Pick the first list that actually has a touch
             in it, then fall back to the mouse coords. */
          var t=(e.touches&&e.touches.length)?e.touches[0]
               :((e.changedTouches&&e.changedTouches.length)?e.changedTouches[0]:null);
          var clientX=t?t.clientX:e.clientX;
          var clientY=t?t.clientY:e.clientY;
          return { x:(clientX-b.left)*(c.width/b.width), y:(clientY-b.top)*(c.height/b.height) };
        }
        function inRect(e,r){ if(!r) return false; var p=canvasXY(e); return p.x>=r.x && p.x<=r.x+r.w && p.y>=r.y && p.y<=r.y+r.h; }
        function inPhoto(e){
          if((IS_GAL||sbOn()||ndPh())) return inRect(e, galPhotoRect);
          return IS_PO ? !!splitPhoto : inRect(e, splitPhotoRect);
        }
        /* The block can be rotated, so a plain rectangle test would grab the
           wrong area. Bring the point back into the block's own frame first. */
        function inBlock(e){
          if(!poRect) return false;
          var p=canvasXY(e), cx0=poRect.x+poRect.w/2, cy0=poRect.y+poRect.h/2;
          var a=-(poRot||0), dx=p.x-cx0, dy=p.y-cy0;
          var rx=dx*Math.cos(a)-dy*Math.sin(a)+cx0, ry=dx*Math.sin(a)+dy*Math.cos(a)+cy0;
          return rx>=poRect.x && rx<=poRect.x+poRect.w && ry>=poRect.y && ry<=poRect.y+poRect.h;
        }
        var mode='';
        function down(e){
          if(!splitPhoto){ return; }
          if((IS_GAL||sbOn()||ndPh())){
            /* Only inside the panel: a drag that starts on the map or the type
               is the customer scrolling the page, not moving their photo. */
            if(!inPhoto(e)) return;
            mode='photo';
          } else if(IS_PO){
            /* A drag always moves whatever is selected, wherever it starts. */
            mode = (poSel==='text') ? 'block' : 'photo';
          } else {
            if(!inPhoto(e)) return;
            mode='photo';
          }
          dragging=true; moved=false;
          var st=(e.touches&&e.touches.length)?e.touches[0]:null;
          startX=st?st.clientX:e.clientX;
          startY=st?st.clientY:e.clientY;
          baseOff = mode==='block' ? {x:poOff.x,y:poOff.y}
                  : ((IS_GAL||sbOn()||ndPh()) ? {x:galOff.x,y:galOff.y} : {x:splitPhotoOff.x,y:splitPhotoOff.y});
          /* NOT preventDefault here: on iOS that kills the synthetic click and
             the CHANGE PHOTO chip stops responding. Deferred to the first
             move, by which point a drag is genuinely underway. */
        }
        function move(e){ if(!dragging) return;
          if(e.touches && e.touches.length>1) return;      /* pinch, not drag */
          var mt=(e.touches&&e.touches.length)?e.touches[0]:null;
          var cx=mt?mt.clientX:e.clientX, cy=mt?mt.clientY:e.clientY;
          var c=box._zoomCv||cv, b=c.getBoundingClientRect();
          var dx=(cx-startX)/b.width, dy=(cy-startY)/b.height;
          if(Math.abs(cx-startX)+Math.abs(cy-startY)<=3) return;   /* still a tap */
          moved=true;
          if(mode==='block'){
            poOff.x=Math.max(0.05,Math.min(0.95, baseOff.x + dx));
            poOff.y=Math.max(0.05,Math.min(0.95, baseOff.y + dy));
          } else if((IS_GAL||sbOn()||ndPh())){
            /* Scaled by the panel's share of the canvas, not the canvas: the
               panel is about a quarter of the tile's area, so a drag measured
               against the whole thing moves the crop a fraction of the distance
               the finger went and feels stuck. */
            var pr=galPhotoRect, c2=box._zoomCv||cv;
            var kx=pr&&pr.w?(c2.width/pr.w):1, ky=pr&&pr.h?(c2.height/pr.h):1;
            galOff.x=Math.max(0,Math.min(1, baseOff.x - dx*kx));
            galOff.y=Math.max(0,Math.min(1, baseOff.y - dy*ky));
          } else {
            splitPhotoOff.x=Math.max(0,Math.min(1, baseOff.x - dx*1.6));
            splitPhotoOff.y=Math.max(0,Math.min(1, baseOff.y - dy*1.6));
          }
          render(); if(e.cancelable) e.preventDefault();
        }
        /* Taps are resolved here rather than via click, which iOS does not
           reliably deliver after a touch sequence on a canvas. */
        function tap(e){
          if(moved){ moved=false; dragging=false; mode=''; return; }
          dragging=false; mode='';
          if(noRoute() && inRect(e, gpxPromptRect)){ pickGpx(); return; }
          if(splitPhoto && inRect(e, splitChipRect)){ splitFilePick(); return; }
          if((IS_GAL||sbOn()||ndPh())){
            /* Only the empty panel opens the picker. Once there is a photo in
               it, a tap there is the start of a drag that did not move - the
               Change photo button is how it gets replaced. */
            if(!splitPhoto && inPhoto(e)) splitFilePick();
            return;
          }
          if(!splitPhoto){ splitFilePick(); return; }
          if(IS_PO){
            var want = inBlock(e) ? 'text' : 'photo';
            if(want!==poSel){ poSel=want; render(); }
          }
        }
        var lastTouchAt=0;
        function up(e){ if(e && e.type==='touchend'){ lastTouchAt=Date.now(); tap(e); return; } dragging=false; mode=''; }
        /* Pinch resizes the block. */
        var pinchD=0, pinchS=1, pinchA=0, pinchR=0;
        function twoAngle(e){ return Math.atan2(e.touches[1].clientY-e.touches[0].clientY,
                                                e.touches[1].clientX-e.touches[0].clientX); }
        box.addEventListener('touchstart',function(e){
          if(!(IS_PO||(IS_GAL||sbOn()||ndPh())) || e.touches.length!==2) return;
          dragging=false;
          pinchD=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,
                            e.touches[0].clientY-e.touches[1].clientY);
          pinchS=(IS_GAL||sbOn()||ndPh())?galZoom:poScale; pinchA=twoAngle(e); pinchR=poRot||0;
        },{passive:true});
        box.addEventListener('touchmove',function(e){
          if((IS_GAL||sbOn()||ndPh()) && e.touches.length===2 && pinchD){
            var dg=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,
                              e.touches[0].clientY-e.touches[1].clientY);
            galZoom=Math.max(1,Math.min(GAL_ZOOM_MAX, galZoomCap(), pinchS*dg/pinchD));
            var zs=$('cz-galZoom'); if(zs) zs.value=Math.round(galZoom*100);
            render(); galDpiNote();
            if(e.cancelable) e.preventDefault();
            return;
          }
          if(!IS_PO || e.touches.length!==2 || !pinchD) return;
          var d2=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,
                            e.touches[0].clientY-e.touches[1].clientY);
          poScale=Math.max(0.45,Math.min(1.7, pinchS*d2/pinchD));
          var r=pinchR+(twoAngle(e)-pinchA);
          /* Snap to the nearest 15 degrees when close, so level is easy to
             hit and a deliberate angle is still possible. */
          var step=Math.PI/12, near=Math.round(r/step)*step;
          if(Math.abs(r-near)<0.07) r=near;
          poRot=Math.max(-Math.PI/2,Math.min(Math.PI/2, r));
          render(); if(e.cancelable) e.preventDefault();
        },{passive:false});
        box.addEventListener('touchend',function(e){
          if(e.touches.length<2) pinchD=0;
          if((IS_GAL||sbOn()||ndPh())) galDpiNote();
        },{passive:true});
        /* No zoom slider (25 Oct, Marc): the photo itself zooms. A trackpad
           pinch arrives as a wheel event with ctrlKey (as does Ctrl + scroll);
           Safari on a Mac sends gesture events instead. A touch pinch is
           handled above, so a gesture during one is ignored. */
        function galPhotoZoomTo(z){
          galZoom=Math.max(1,Math.min(GAL_ZOOM_MAX, galZoomCap(), z));
          render(); galDpiNote();
        }
        function galPhotoHere(e){
          return (IS_GAL||sbOn()||ndPh()) && !!splitPhoto && box.getAttribute('data-view')==='flat' && inRect(e, galPhotoRect);
        }
        box.addEventListener('wheel',function(e){
          if(!e.ctrlKey || !galPhotoHere(e)) return;
          if(e.cancelable) e.preventDefault();
          galPhotoZoomTo(galZoom*Math.exp(-(e.deltaY||0)*0.01));
        },{passive:false});
        var gestS=0;
        box.addEventListener('gesturestart',function(e){
          if(pinchD || !galPhotoHere(e)){ gestS=0; return; }
          gestS=galZoom; if(e.cancelable) e.preventDefault();
        });
        box.addEventListener('gesturechange',function(e){
          if(!gestS || pinchD) return;
          if(e.cancelable) e.preventDefault();
          galPhotoZoomTo(gestS*(e.scale||1));
        });
        box.addEventListener('gestureend',function(){ gestS=0; });
        box.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
        box.addEventListener('touchstart',down,{passive:false});
        box.addEventListener('touchmove',move,{passive:false});
        box.addEventListener('touchend',up);
        /* Mouse only - touch is handled above, and letting both run would fire
           the picker twice. */
        box.addEventListener('click',function(e){
          /* Safari dispatches click as a MouseEvent, where pointerType is
             undefined - so the old guard never fired and every tap ran twice,
             the second .click() dismissing the picker as it opened. Time since
             the last touchend is interface-independent. */
          if(Date.now()-lastTouchAt < 700) return;
          tap(e);
        });
      }
      box._zoomCv=cv;
      /* Gallery also gets the magnifier below - off its photo panel. */
      if(!(IS_GAL||sbOn()||ndPh())) return;
    }
    if(!box._zoomWired){
      box._zoomWired=true;
      var lc=document.createElement('canvas'); lc.className='cz-lens';
      box.appendChild(lc); box._lensCanvas=lc; box._lensCtx=lc.getContext('2d');
      var Z=IS_TRI?3.2:2.4;
      function drawnRect(){                                
        var c=box._zoomCv; if(!c||!c.width) return null;
        var cb=c.getBoundingClientRect(), bb=box.getBoundingClientRect();
        if(!cb.width||!cb.height) return null;
        var ar=c.width/c.height, br=cb.width/cb.height, w,h;
        if(ar>br){ w=cb.width; h=cb.width/ar; } else { h=cb.height; w=cb.height*ar; }
        return { x:(cb.left-bb.left)+(cb.width-w)/2,
                 y:(cb.top-bb.top)+(cb.height-h)/2, w:w, h:h };
      }
      function sizeLens(){
        var dpr=window.devicePixelRatio||1, d=lc.clientWidth||140;
        if(lc.width!==Math.round(d*dpr)){ lc.width=Math.round(d*dpr); lc.height=Math.round(d*dpr); }
        return {css:d,dpr:dpr};
      }
      /* The preview only: no lens on a mockup photo or the size guide. */
      function lensView(){ return box.getAttribute('data-view')==='flat'; }
      function show(px,py){
        var c=box._zoomCv, r=drawnRect(); if(!c||!r||!lensView()){ hide(); return; }
        if(inGalPanel(px,py)){ hide(); return; }
        var lx=px-r.x, ly=py-r.y;
        if(lx<0||ly<0||lx>r.w||ly>r.h){ hide(); return; }  
        var L=sizeLens(), ctx2=box._lensCtx;
        var sx=c.width  * (lx/r.w);                         
        var sy=c.height * (ly/r.h);
        var srcW=(L.css/Z) * (c.width/r.w);                 
        var srcH=(L.css/Z) * (c.height/r.h);
        ctx2.save();
        ctx2.setTransform(L.dpr,0,0,L.dpr,0,0);
        ctx2.clearRect(0,0,L.css,L.css);
        ctx2.beginPath(); ctx2.arc(L.css/2,L.css/2,L.css/2,0,7); ctx2.closePath(); ctx2.clip();
        ctx2.imageSmoothingEnabled=true; ctx2.imageSmoothingQuality='high';
        var _hs=IS_TRI?triLensSrc(c,box):null, _k=_hs?_hs.width/c.width:1;
        try{ ctx2.drawImage(_hs||c, (sx-srcW/2)*_k, (sy-srcH/2)*_k, srcW*_k, srcH*_k, 0,0, L.css,L.css); }catch(e){}
        ctx2.restore();
        lc.style.left=px+'px'; lc.style.top=py+'px'; lc.classList.add('cz-on');
      }
      function hide(){ lc.classList.remove('cz-on'); }
      /* Gallery: the photo panel keeps its own drag, pinch and tap, so the lens
         covers only the map and the type around it. galPhotoRect is from the
         last flat paint, so it means nothing on a mockup. */
      function inGalPanel(px,py){
        var _tq=(IS_TRI && TRI.photo && TRI.rects) ? TRI.rects.hero : null;
        if(!((IS_GAL||sbOn()||ndPh())||_tq) || !(galPhotoRect||_tq) || box.getAttribute('data-view')!=='flat') return false;
        var c=box._zoomCv, r=drawnRect(); if(!c||!r) return false;
        var x=(px-r.x)*(c.width/r.w), y=(py-r.y)*(c.height/r.h), q=_tq||galPhotoRect;
        return x>=q.x && x<=q.x+q.w && y>=q.y && y<=q.y+q.h;
      }
      /* The empty route slot opens the GPX picker. */
      var _lastPT=0;
      function promptTap(e){
        if(IS_SPLIT||IS_PO||(IS_GAL||sbOn()||ndPh())) return;
        if(!noRoute() || !gpxPromptRect) return;
        if(Date.now()-_lastPT<600) return;
        var c=box._zoomCv; if(!c||!c.width) return;
        var t=(e.changedTouches&&e.changedTouches.length)?e.changedTouches[0]:e;
        var b=c.getBoundingClientRect(); if(!b.width) return;
        var px=(t.clientX-b.left)*(c.width/b.width), py=(t.clientY-b.top)*(c.height/b.height), r=gpxPromptRect;
        if(px>=r.x && px<=r.x+r.w && py>=r.y && py<=r.y+r.h){ _lastPT=Date.now(); hide(); pickGpx(); }
      }
      box.addEventListener('mouseenter',function(e){ var b=box.getBoundingClientRect(); show(e.clientX-b.left,e.clientY-b.top); });
      box.addEventListener('mousemove', function(e){ var b=box.getBoundingClientRect(); show(e.clientX-b.left,e.clientY-b.top); });
      box.addEventListener('mouseleave',hide);
      var lensTouch=false;
      box.addEventListener('touchstart',function(e){ if(!e.touches[0])return; var b=box.getBoundingClientRect();
        var px=e.touches[0].clientX-b.left, py=e.touches[0].clientY-b.top;
        /* A mockup scrolls like the rest of the page. */
        if(!lensView()){ lensTouch=false; hide(); return; }
        /* Gallery: a touch on the photo, or a second finger (pinch), is the photo's. */
        if(((IS_GAL||sbOn()||ndPh())||IS_TRI) && (e.touches.length>1 || inGalPanel(px,py))){ lensTouch=false; hide(); return; }
        lensTouch=true; show(px,py); e.preventDefault(); },{passive:false});
      box.addEventListener('touchmove', function(e){ if(!e.touches[0])return;
        if(!lensTouch || (((IS_GAL||sbOn()||ndPh())||IS_TRI) && e.touches.length>1)){ hide(); return; }
        var b=box.getBoundingClientRect(); show(e.touches[0].clientX-b.left,e.touches[0].clientY-b.top); e.preventDefault(); },{passive:false});
      box.addEventListener('touchend',function(e){ hide(); promptTap(e); });
      box.addEventListener('click',promptTap);
      box.addEventListener('contextmenu',function(e){ e.preventDefault(); });  
    }
    box._zoomCv=cv;
  }
  function buildThumbs(){
    var wrap=$('cz-thumbs'); if(!wrap) return; wrap.innerHTML='';
    var list=thumbList();
    list.forEach(function(sel,idx){
      var b=document.createElement('button'); b.type='button';
      b.className='cz-thumb'+(idx===heroSel?' cz-on':'');
      if(sel.v==='flat'){ b.className+=' cz-special'; b.setAttribute('data-lbl','Preview'); }
      else if(sel.v==='sg'){ b.className+=' cz-special'; b.setAttribute('data-lbl','Sizes'); }
      var cv=document.createElement('canvas'); cv.width=200; cv.height=200; b.appendChild(cv);
      wrap.appendChild(b);
      var sp=state.product,sv=state.view,si=state.mockIdx;
      applySel(sel);
      try{ paint(cv.getContext('2d'),200,200); }catch(e){}
      state.product=sp; state.view=sv; state.mockIdx=si;
      b.onclick=function(){
        heroSel=idx; renderShow();
        /* Tapping the reel's own tile plays the reveal once and holds. */
        if((sel.v==='mockup' || (IS_TRI && sel.v==='mock')) && isDigital(focusProd())){
          var _rs=null; try{ _rs=reelStage(); }catch(e){}
          if(_rs && _rs.idx===sel.i) playReelPreview(focusProd(),sel.i);
        }
      };
    });
  }
  function toggleLoad(){
    var ld=$('cz-heroLoad'); if(!ld) return;
    /* Not after a failure - the hint says what went wrong, and an overlay
       that spins forever reads as a page that never finished. */
    var loading = isMapLike(state.style) && !state.mapImg && !state.mapUser && !!state.coords && !state.mapFailed;
    ld.textContent = state.style==='terrain'?'Building terrain…':'Loading map…';
    ld.style.display = loading?'flex':'none';
  }
  function pmSib(f){ return (PM && PM_SIBS && PM_SIBS[f]) ? PM_SIBS[f] : null; }
  function money(c){
    var s=(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return (PM_PRICE&&PM_PRICE.charAt(0)==='$') ? '$'+s : '$'+s;
  }
  function updateShowBar(){
    var prod=focusProd(), sib=pmSib(prod);
    var amt=$('cz-showAmt');
    /* PM_PRICE is the price of the product this page IS. It is the right
       answer for the page's own format and wrong for every other one, so a
       format with no sibling product falls back to its settings price rather
       than quoting the host product. Without the PM_FMT test, picking Digital
       on a Framed A4 page showed $49 under the word DIGITAL. */
    var _pvp=pickedVariantFor(prod);
    if(amt) amt.textContent = (_pvp && typeof _pvp.price==='number') ? money(_pvp.price)
                            : (packPrice && prod===state.product) ? packPrice
                            : (sib ? sib.price
                                   : ((PM && PM_PRICE && prod===PM_FMT) ? PM_PRICE
                                                                       : PRODUCTS[prod].price));
    var pl=$('cz-showProd'); if(pl) pl.textContent=PLABEL[prod];
    state.product=prod;                                     
    var sp=$('cz-showSpec');
    if(sp){ var dim=(sib&&sib.spec)?sib.spec:(PRODUCTS[prod].spec||'').split('\u00b7')[0].trim();
      /* The chosen variant outranks both - it is the only one of the three that
         knows whether this order is A3 or A4, framed or not. */
      if(prod==='poster' && prod===state.product){
        var _pvs=pickedVariant(), _ps=_pvs?posterSpecFor(_pvs.title):'';
        if(_ps) dim=_ps;
      }
      if(prod==='tee'){ sp.textContent=''; sp.style.display='none'; }      
      else { sp.textContent=dim; sp.style.display=''; } }
    if(typeof toggleSize==='function') toggleSize();
    if(typeof syncNameRow==='function') syncNameRow();
    var sw=$('cz-showSize'), src=$('cz-sizewrap');
    if(sw&&src){ if(hasVars){ if(src.parentNode!==sw) sw.appendChild(src); src.style.display='block'; sw.style.display='block'; } else { sw.style.display='none'; } }
    var _sb=root.querySelector('.cz-showbar');
    if(_sb) _sb.classList[hasVars?'add':'remove']('cz-haspick');
  }
  function customizeLink(prod){
    var base=(MSC[14]||'/pages/create-yours');
    var q=[], add=function(k,v){ v=String(v==null?'':v).trim(); if(v) q.push(k+'='+encodeURIComponent(v)); };
    add('gpx', curGpx||evGet('gpx')); add('img', curImg||evGet('img')); add('race', curRace||evGet('race'));
    add('name', ($('cz-title')||{value:''}).value);
    add('loc',  ($('cz-loc')||{value:''}).value);
    add('dist', ($('cz-dist')||{value:''}).value);
    add('date', ($('cz-date')||{value:''}).value);
    q.push('product='+encodeURIComponent(prod));
    return base+'?'+q.join('&');
  }
  function renderShow(){
    if(!EVENT) return;
    var prod=focusProd(), list=thumbList(); if(heroSel>=list.length) heroSel=0;
    paintHero(list[heroSel]);
    if(!PM){                                          
      paintTile('cz-hL', neighbour(-1), 'mockup', 0);
      paintTile('cz-hR', neighbour(1),  'mockup', 0);
      var ll=$('cz-lblL'); if(ll) ll.textContent=PLABEL[neighbour(-1)];
      var lr=$('cz-lblR'); if(lr) lr.textContent=PLABEL[neighbour(1)];
    }
    var lm=$('cz-lblMain'); if(lm) lm.textContent=PLABEL[prod];
    /* One note element, two formats that need one. Both are claims about
       what does and does not arrive, so they belong under the preview. */
    var _fnote=$('cz-framenote');
    if(_fnote){
      if(prod==='frame'){ _fnote.textContent=FRAME_NOTE; _fnote.style.display=''; }
      else if(isDigital(prod)){ _fnote.textContent=DIGI_NOTE; _fnote.style.display=''; }
      else { _fnote.style.display='none'; }
    }
    /* The rail is the only format switcher once #cz-tabs is hidden by the
       two-column CSS, so it has to build wherever that CSS applies. */
    syncFramedTabs();
    buildThumbs(); if(EVENT) buildRail(); updateShowBar(); toggleLoad();
    if(barFit) barFit();
  }
  function syncFramedTabs(){
    var row=$('cz-tabs'); if(!row) return;
    Array.prototype.forEach.call(row.querySelectorAll('.cz-tab'),function(t){
      var f=t.getAttribute('data-p');
      if(RING.indexOf(f)<0) return;            /* hidden at boot: stays hidden */
      t.style.display=framedOffered(f)?'':'none';
    });
  }
  function setFocus(idx){ focusIdx=((idx%RING.length)+RING.length)%RING.length; heroSel=0; renderShow(); }

  function buildRail(){
    var rail=$('cz-pmrail'); if(!rail) return;
    /* The heading is a sibling of the rail, so hiding the rail alone leaves
       "This route also comes as" sitting over nothing. */
    var altw=$('cz-pmalt');
    var _offer=RING.filter(function(f,i){ return i===focusIdx || framedOffered(f); });   /* 1 Nov: framed with NSW events */
    if(_offer.length<2){ rail.style.display='none'; if(altw) altw.style.display='none'; return; }
    rail.style.display=''; if(altw) altw.style.display=''; rail.innerHTML='';
    RING.forEach(function(f,i){
      if(i===focusIdx || !framedOffered(f)) return;
      var sib=pmSib(f);
      var b=document.createElement('button'); b.type='button'; b.className='cz-pmtile';
      b.setAttribute('aria-label','Show this design as a '+(PLABEL[f]||f));
      var cw=document.createElement('span'); cw.className='cz-pmtcv';
      var cv=document.createElement('canvas'); cv.width=240; cv.height=240; cw.appendChild(cv);
      b.appendChild(cw);
      var lb=document.createElement('span'); lb.className='cz-pmtlbl'; lb.textContent=PLABEL[f]||f; b.appendChild(lb);
      var pr=document.createElement('span'); pr.className='cz-pmtprice';
      pr.textContent=sib?sib.price:((PRODUCTS[f]&&PRODUCTS[f].price)||''); b.appendChild(pr);
      rail.appendChild(b);
      var sp=state.product,sv=state.view,si=state.mockIdx;
      /* Photo belongs to the frame. DESIGN_KIND is global, so without this the
         poster and magnet tiles redraw as photo-overlay the moment the frame
         switches - which reads as the whole product changing design. */
      var _pk=DESIGN_KIND, _swap=(IS_PO && f!=='frame' && _frPrevKind!==null);
      if(_swap) setKind(_frPrevKind||'');
      state.product=f; state.view='mockup'; state.mockIdx=0;
      try{ paint(cv.getContext('2d'),240,240); }catch(e){ console.error('Milestone: rail tile failed ('+f+')',e); }
      state.product=sp; state.view=sv; state.mockIdx=si;
      if(_swap) setKind(_pk);
      b.onclick=function(){
        pmSwitch(f);
        /* In below mode the tile is past the fold: without this the preview
           changes somewhere the customer cannot see and the tap reads as dead. */
        if(!ALT_RAIL){
          var _h=root.querySelector('.cz-hero');
          if(_h && _h.scrollIntoView){
            try{ _h.scrollIntoView({behavior:'smooth',block:'center'}); }
            catch(e){ _h.scrollIntoView(); }
          }
        }
      };
    });
  }

  /* ---- design switcher -------------------------------------------------
     Built on the next tick and appended last, so nothing in here can
     interrupt the page build. */
  var barFit=null;              /* set by buyBar(), read by renderShow() */
  var packPrice=null;           /* set by the variant picker, read by updateShowBar() */
  var hasVars=false;            /* ditto - true when the focused format has a choice */
  var rebuildPicker=null;       /* buildSizePicker() lives deeper; bridge to it */
  var KINS = MSD.kins || null;
  /* What the section could not afford to look up: the route code, each handle
     segment paired with the design kind it means, and the formats worth
     asking about. See the comment above kinq in the section. */
  var KINQ = MSD.kinq || null;
  var KIN_GOT = {};              /* formats already fetched - never twice */
  var KIN_PEND = 0;              /* requests in flight, for ?msdiag=1 */
  var KIND_LABEL = {'':'Neon','editorial':'Street Map','terrain':'Terrain',
                    'photo-overlay':'Photo','photo-split':'Route & Photo',
                    'gallery':'Gallery','statbar':'Stat Bar',
                    'manifesto':'Manifesto','rings':'Rings','dashboard':'Dashboard',
                    'cover':'Cover Story','card':'Trading Card','horizon':'Horizon Split','3d':'Skyline'};   /* 30 Oct pm: 3D is Skyline */
  /* Marc's order (28 Oct pm). Route & Photo was not in his list: last. */
  /* 30 Oct pm (Marc): gallery, terrain, skyline, manifesto, cover story, trading
     card, horizon split, rings, stat bar, dashboard, street map, photo, neon */
  var KIND_ORDER = ['gallery','terrain','3d','manifesto','cover','card','horizon','rings',
                    'statbar','dashboard','editorial','photo-overlay','','photo-split'];
  /* The designs that cannot draw anything without a bitmap. Gallery's left
     panel is the Street Map map, so it belongs here too. */
  var KIND_STYLE = {'editorial':'map','terrain':'terrain','gallery':'map','statbar':'map',
                    'manifesto':'map','rings':'terrain','dashboard':'map','3d':'map'};
  /* The style each design opens in. KIND_STYLE above is only the two that
     cannot render without a bitmap; this one covers all of them, because a
     design tile has to state a style or the route's pinned one carries over. */
  var KIND_STYLE_ALL = {'':'neon','editorial':'map','terrain':'terrain',
                        'photo-overlay':'neon','photo-split':'neon',
                        'gallery':'map','statbar':'map',
                        'manifesto':'map','rings':'terrain','dashboard':'map',
                        'cover':'neon','card':'neon','horizon':'neon','3d':'map'};
  /* The ground each design fills behind its artwork. Read by the mockup
     compositor, which otherwise asks the BLANK whether to paint a background -
     and a black poster blank then answers "no" for a design printed on white
     paper, so the paper is never painted and the mockup shows a black poster.
     The artwork knows what it is printed on; the photograph of the blank does
     not. formats: all - a kind missing here is treated as dark. */
  var KIND_GROUND = {'':'#0d0d10','editorial':'#F3EFE7','terrain':'#101216',
                     'photo-overlay':'#101216','photo-split':'#1a1a1f',
                     'gallery':'#F3EFE7','statbar':'colourway',
                     'manifesto':'#F3EFE7','rings':'#F3EFE7','dashboard':'#0E0E10',
                     'cover':'#121214','card':'#1C1C20','horizon':'#151517','3d':'#17171A', 'triathlon':'#F3EFE7'};
  /* Which set of mockup PHOTOGRAPHS a design's artwork belongs on. The neon
     blanks are a black poster and a black tee; a design printed on white paper
     photographed on those reads as a black poster with pale type on it, which
     is what Gallery was doing on every A3 mockup. '' means the format's own
     set; 'edt_' means the light-paper set beside it.
     Named by design rather than derived from the ground, because Terrain's
     ground is dark and it still belongs on the light blanks - that is a fact
     about Marc's photographs, not about the artwork.
     formats: all - a kind missing here silently lands on the neon blanks. */
  /* 'colourway': the design's colourway decides (kindBlank) - Stat Bar's
     dark three sit on the neon blanks, its light three on the paper ones. */
  var KIND_BLANK = {'':'', 'editorial':'edt_', 'terrain':'edt_',
                    'photo-overlay':'', 'photo-split':'', 'gallery':'edt_', 'statbar':'colourway',
                    'manifesto':'edt_', 'rings':'edt_', 'dashboard':'', 'cover':'', 'card':'', 'horizon':'', '3d':'', 'triathlon':'edt_'};
  /* Is this design's own ground light enough that a dark blank showing through
     would be visibly wrong? */
  function groundIsLight(){
    var c=kindGround(DESIGN_KIND);
    if(!c) return false;
    var n=parseInt(c.slice(1),16);
    return (0.2126*((n>>16)&255) + 0.7152*((n>>8)&255) + 0.0722*(n&255)) > 140;
  }
  function kindStyle(k){
    var ns=KIND_STYLE_ALL[k||'']||'neon', rs='';
    try{
      var _c=currentRoute();
      rs=String(getParam('style')||(_c&&_c.style)||'').trim().toLowerCase();
    }catch(e){}
    /* 'map:dark' pinned on the route is worth keeping when the tile is Street
       Map, and meaningless when it is Neon - so keep it only within a family. */
    if(rs && rs.split(':')[0]===ns) return rs;
    return ns;
  }
  function kindLabel(k){
    if(KIND_LABEL[k]!==undefined) return KIND_LABEL[k];
    return k.replace(/-/g,' ').replace(/\b\w/g,function(c){ return c.toUpperCase(); });
  }
  function setKind(k){
    DESIGN_KIND=k||''; IS_SPLIT=(DESIGN_KIND==='photo-split');
    IS_EDT=(DESIGN_KIND==='editorial'); IS_TD=(DESIGN_KIND==='terrain');
    IS_PO=(DESIGN_KIND==='photo-overlay'); IS_GAL=(DESIGN_KIND==='gallery');
    kindAttr();
  }
  /* Visible only with ?czdebug=1 - shows which siblings the Liquid lookup
     resolved, per format, so a missing tile points straight at the product. */
  function kindDebug(){
    try{
      if(getParam('czdebug')!=='1') return;
      var box=document.createElement('div');
      box.setAttribute('style','position:fixed;right:8px;top:8px;z-index:2147483647;'
        +'max-width:min(92vw,460px);max-height:60vh;overflow:auto;background:#17171A;color:#cfe9cf;'
        +'font:11.5px/1.55 ui-monospace,Menlo,monospace;padding:10px 12px;border-radius:8px;'
        +'border:2px solid #FF5A1F;white-space:pre-wrap');
      var L=['--- design strip ---'];
      L.push('design kind  : '+(DESIGN_KIND||'(neon)'));
      L.push('focus format : '+focusProd());
      if(!KINS){ L.push('KINS         : null  -> no design_code on this product,');
                 L.push('                       or family is statement / type is blank'); }
      else{
        var fmts=PM_ORDER, f, i, a, k, any=false;
        for(i=0;i<fmts.length;i++){
          f=fmts[i]; a=KINS[f]||[];
          var rows=[];
          for(var j=0;j<a.length;j++){ if(a[j]) rows.push((a[j].kind||'neon')+(a[j].cur?' *':'')
            +'  ['+(a[j].img?'thumb':(a[j].fimg?'feat ':'none '))+']  '+(a[j].url||'')); }
          if(rows.length) any=true;
          L.push(f+' : '+(rows.length?rows.length+' found':'(none)'));
          for(var r=0;r<rows.length;r++) L.push('    '+rows[r]);
        }
        if(!any) L.push('nothing matched - check design_code and handles');
      }
      L.push('');
      L.push('--- mockups ---');
      /* Only the formats that have mockups at all - the digital download has
         none by design, and listing it as "0 set" reads like a fault. */
      PM_ORDER.filter(function(f){ return (MOCKUPS[f]||[]).length; }).forEach(function(_mk){
        var _set=(MOCKUPS[_mk]||[]).filter(function(u){ return (u||'').trim(); }).length;
        var _got=(mockImgs[_mk]||[]).filter(function(im){ return !!im; }).length;
        L.push('  '+(_mk+'      ').slice(0,7)+': '+_set+' set, '+_got+' loaded'
          +(_set===0?'   <- nothing in this template\u2019s settings':
            (_got<_set?'   <- some failed to load':'')));
      });
      L.push('');
      L.push('--- map ---');
      L.push('style        : '+state.style+(isMapLike(state.style)?(' / '+(state.mapStyle||'standard')):''));
      L.push('map key      : '+(MAPKEY?'set':'MISSING \u2014 the map can never load'));
      L.push('request      : '+_mapDiag.state+(_mapDiag.note?('  ('+_mapDiag.note+')'):''));
      L.push('url length   : '+_mapDiag.len+(_mapDiag.len>7800?'   <- near the 8 KB ceiling':''));
      if(_mapDiag.px) L.push('image        : '+_mapDiag.px);
      L.push('image in use : '+(state.mapImg?'yes':'no'));
      if(_mapDiag.state==='failed') L.push('failed url   : '+String(_mapDiag.url).slice(0,300)+'\u2026');
      L.push('');
      var n=kindList().length;
      L.push('tiles shown  : '+n+(n<2?'   (needs 2+, so the strip hides)':''));
      if(KINS){
        var _fl=KINS[focusProd()]||[], _at=true, _af=true, _c=0;
        for(var _q=0;_q<_fl.length;_q++){ if(!_fl[_q]) continue; _c++;
          if(!_fl[_q].img) _at=false; if(!_fl[_q].fimg) _af=false; }
        L.push('image source : '+(!_c?'-':(_at?'design_thumb (consistent)'
          :(_af?'featured image  <- set design_thumb on ALL '+_c+' to fix the mismatch'
               :'canvas render'))));
      }
      box.textContent=L.join('\n');
      (document.body||document.documentElement).appendChild(box);
    }catch(e){ console.warn('Milestone kindDebug:',e); }
  }
  function shopRoot(){
    try{ return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; }
    catch(e){ return '/'; }
  }
  /* product.js hands back the full-size CDN url and the strip draws it 76px
     wide, so ask for something near that rather than a poster per tile. */
  function kinThumb(u){
    if(!u) return '';
    u=String(u);
    return u+(u.indexOf('?')<0?'?':'&')+'width=320';
  }
  /* Resolve one format's designs from the Ajax product endpoint, which has no
     20-handle cap. Liquid fills in this page's own format; this is how every
     other tab gets a complete strip, and all it costs is a 404 for a design
     that was never generated.

     Only ever called for the tab on screen. Twenty-odd requests at boot for
     tabs most customers never open is not a trade worth making on a phone. */
  function kinsResolve(f){
    if(!KINQ || !KINQ.code || !KINQ.fmts || !KINQ.segs || !f) return;
    if(KIN_GOT[f]) return;
    if(KINQ.fmts.indexOf(f)<0) return;
    KIN_GOT[f]=1;                /* before the fetch - a second call while the
                                    first is in the air must not double it */
    if(!KINS) KINS={};
    var have={}, cur=KINS[f]||[], i, q;
    for(i=0;i<cur.length;i++) if(cur[i]) have[cur[i].kind||'']=1;
    /* Whatever Liquid or the collection scan already found stays: those
       entries carry the design_thumb metafield, which product.js cannot see. */
    var want=[];
    for(i=0;i<KINQ.segs.length;i++){
      q=KINQ.segs[i];
      if(!q || !q.s) continue;
      if(have[q.k||'']) continue;
      want.push(q);
    }
    if(!want.length) return;
    var root=shopRoot(), added=[];
    KIN_PEND+=want.length;
    var jobs=want.map(function(q){
      var h=KINQ.code+'-'+q.s+'-'+f;
      return fetch(root+'products/'+encodeURIComponent(h)+'.js',
                   {credentials:'same-origin'})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(d){
          KIN_PEND--;
          /* A 404 is the normal answer for a design that does not exist, so
             it is not worth a console line. */
          if(!d || !d.handle) return;
          added.push({ kind:q.k||'',
                       url:d.url||(root+'products/'+d.handle),
                       cur:false,
                       img:'',                       /* metafield, not in product.js */
                       fimg:kinThumb(d.featured_image),
                       net:1 });                     /* fetched, not from Liquid */
        })
        .catch(function(){ KIN_PEND--; });
    });
    Promise.all(jobs).then(function(){
      if(!added.length) return;
      KINS[f]=(KINS[f]||[]).concat(added);
      /* Repaint only if this is still the tab on screen - the customer may
         have moved on while the requests were in the air. */
      if(f===focusProd()) kindStripSoon();
    });
  }
  /* Ask Cloudinary for an image at the size it will be drawn.
     design_thumb is the flat artwork render - 1800px wide and, measured,
     between 2.3 MB and 7.3 MB as a PNG - and the design strip draws it at
     76px. Without this, four tiles pull about fifteen megabytes to paint four
     thumbnails.
     Anything that is not a Cloudinary delivery URL comes back untouched: the
     Shopify CDN has its own ?width= and the section has already applied it. */
  function cdnImg(u,w){
    if(!u) return u;
    u=String(u);
    var i=u.indexOf('/image/upload/');
    if(i<0) return u;
    var tail=u.slice(i+14);
    /* Already carries a transform - a leading segment like f_auto,q_auto,w_320
       rather than a version (v12345) or a bare public id. Doubling it up would
       work, but it would also quietly override whatever was asked for. */
    if(/^[a-z]+_[^\/]*\//.test(tail)) return u;
    return u.slice(0,i+14)+'f_auto,q_auto,w_'+Math.round(w)+'/'+tail;
  }
  function kindList(){
    if(!KINS) return [];
    var src=KINS[focusProd()]; if(!src||!src.length) return [];
    var seen={}, out=[], i, k;
    for(i=0;i<src.length;i++){
      k=src[i]; if(!k) continue;
      if(typeof kindForSport==='function' && !kindForSport(k.kind)) continue;     /* Stat Bar: 5K Run only */
      if(seen[k.kind]) continue;
      seen[k.kind]=1; out.push(k);
    }
    out.sort(function(a,b){
      var ia=KIND_ORDER.indexOf(a.kind), ib=KIND_ORDER.indexOf(b.kind);
      return (ia<0?99:ia)-(ib<0?99:ib);
    });
    /* The Liquid `cur` flag marks the product you are ON. With ?r= or ?design=
       the page can render a different design than that product's own, and then
       the flag marks the wrong tile - and the design you are actually after is
       the one rendered as an unclickable div. The rendered design is the truth.
       Copies, because these objects are shared with KINS and DESIGN_KIND moves. */
    var want=DESIGN_KIND||'', hit=false;
    for(i=0;i<out.length;i++){ if((out[i].kind||'')===want){ hit=true; break; } }
    out=out.map(function(o){
      var c={},p;
      for(p in o){ if(Object.prototype.hasOwnProperty.call(o,p)) c[p]=o[p]; }
      /* No sibling renders what is on screen -> mark nothing, so every tile
         stays reachable rather than one of them lying. */
      c.cur=hit?((o.kind||'')===want):false;
      return c;
    });
    return out;
  }
  /* The event page this product was opened from (26 Oct): &ev=<handle> on
     the event page's cards, carried by carryQS(); or a same-origin
     /pages/<handle> referrer when the page has a route code. */
  function evBackHandle(){
    var e=String(getParam('ev')||'').trim().toLowerCase();
    if(/^[a-z0-9][a-z0-9-]{0,99}$/.test(e)) return e;
    try{
      if(!getParam('r') || !document.referrer) return '';
      var u=new URL(document.referrer), m=/^\/pages\/([a-z0-9][a-z0-9-]{0,99})\/?$/i.exec(u.pathname);
      if(m && u.origin===window.location.origin) return m[1].toLowerCase();
    }catch(e2){}
    return '';
  }
  function evBackLink(btn){
    var h=evBackHandle(); if(!h || !btn) return false;
    btn.textContent='← Go back to event page';
    btn.onclick=function(ev){ if(ev && ev.stopImmediatePropagation) ev.stopImmediatePropagation(); window.location.href='/pages/'+h+(giftOn()?'?gift=1':''); };
    return true;
  }
  /* ---- Gift it mode (p_gift, 28 Oct) ---------------------------------------
     ?gift=1, from the event page's Gift toggle. The panel's values live in
     sessionStorage so a design or format switch keeps them; gift=1 itself
     rides on carryQS() and the format ring's address. */
  var GIFT=(String(getParam('gift')||'')==='1') && !(typeof IS_TRI!=='undefined' && IS_TRI);
  var _giftNameLbl=null, _giftNamePh=null;
  function giftOn(){ return !!GIFT; }
  function giftStore(o){ try{ if(o) sessionStorage.setItem('msGift',JSON.stringify(o)); else sessionStorage.removeItem('msGift'); }catch(e){} }
  function giftLoad(){ try{ return JSON.parse(sessionStorage.getItem('msGift')||'null')||{}; }catch(e){ return {}; } }
  function giftVal(id){ var e=$(id); return e ? String(e.value||'').trim() : ''; }
  function giftLook(){ var c=$('cz-giftLook'); return !!(GIFT && c && c.checked && !isDigital(state.product)); }
  function giftSave(){
    if(!GIFT) return;
    giftStore({ who:giftVal('cz-name'), look:!!($('cz-giftLook')&&$('cz-giftLook').checked),
                bib:giftVal('cz-giftBib'), note:giftVal('cz-giftNote') });
  }
  function giftTimeLock(on){
    ['cz-h','cz-m','cz-s'].forEach(function(id){
      var e=$(id); if(!e) return;
      if(on && e.value){ e.value=''; try{ e.dispatchEvent(new Event('input',{bubbles:true})); }catch(x){} }
      e.disabled=!!on;
    });
    var th=$('cz-h'), tf=th&&th.closest&&th.closest('.cz-fld');
    if(tf) tf.classList.toggle('cz-giftlocked', !!on);
  }
  /* What the panel shows for the format on screen - a Digital Pack is
     emailed to the buyer at once, so there is no parcel and no time to add. */
  function giftSync(){
    var box=$('cz-gift'); if(!box) return;
    var dig=isDigital(state.product);
    var lr=$('cz-giftLookRow'), lh=$('cz-giftLookHint'), br=$('cz-giftBibRow'), nr=$('cz-giftNoteRow'), sh=$('cz-giftShip'), dh=$('cz-giftDig');
    if(lr) lr.style.display=dig?'none':'';
    if(nr) nr.style.display=dig?'none':'';
    if(sh) sh.style.display=dig?'none':'';
    if(dh) dh.style.display=dig?'':'none';
    var look=giftLook();
    if(lh) lh.style.display=look?'':'none';
    if(br) br.style.display=look?'':'none';
    giftTimeLock(look);
  }
  function giftLabels(on){
    var nl=$('cz-nameRow'), ns=nl&&nl.querySelector('.cz-lbl'), ni=$('cz-name');
    if(ns){ if(_giftNameLbl===null) _giftNameLbl=ns.textContent; ns.textContent=on?'Runner’s name':_giftNameLbl; ns.classList.toggle('cz-req',!!on); }
    if(ni){ if(_giftNamePh===null) _giftNamePh=ni.placeholder; ni.placeholder=on?'Printed on their gift':_giftNamePh; }
  }
  function giftInit(){
    if(typeof IS_TRI!=='undefined' && IS_TRI) GIFT=false;   /* declared after this block */
    if(!GIFT || $('cz-gift')) return;
    var nr=$('cz-nameRow'), host=nr&&nr.parentNode; if(!host) return;
    var box=document.createElement('div'); box.className='cz-gift'; box.id='cz-gift';
    box.innerHTML=''
      +'<div class="cz-gifthd"><span class="cz-giftey">Gift</span><b>You’re making this for someone</b>'
      +'<button type="button" class="cz-mini" id="cz-giftOff">Not a gift?</button></div>'
      +'<label class="cz-giftchk" id="cz-giftLookRow"><input type="checkbox" id="cz-giftLook"> '
      +'<span>Don’t know their finish time? <b>We’ll check the official results</b></span></label>'
      +'<div class="cz-hint" id="cz-giftLookHint" style="display:none">If the event publishes results, we add their official time before we print. Not every event does: if it doesn’t, it prints without a time. The preview shows the design without it.</div>'
      +'<label class="cz-fld" id="cz-giftBibRow" style="display:none"><span class="cz-lbl">Bib number (optional)</span>'
      +'<input type="text" id="cz-giftBib" maxlength="10" inputmode="numeric" placeholder="Helps us find them"></label>'
      +'<label class="cz-fld" id="cz-giftNoteRow"><span class="cz-lbl">Gift note (optional)</span>'
      +'<textarea id="cz-giftNote" maxlength="200" rows="3" placeholder="Printed on a card in the parcel"></textarea></label>'
      +'<div class="cz-hint" id="cz-giftShip">Sending it straight to them? Enter their address as the delivery address at checkout. Nothing in the parcel shows a price.</div>'
      +'<div class="cz-hint" id="cz-giftDig" style="display:none">The Digital Pack is emailed to you as soon as you pay, ready to forward. Add their time yourself, or choose a printed format and we’ll check the official results.</div>';
    host.insertBefore(box, nr.nextSibling);
    giftLabels(true);
    var v=giftLoad();
    var who=String(getParam('who')||v.who||'').slice(0,24), ni=$('cz-name');
    if(ni && who && !ni.value){ ni.value=who; try{ ni.dispatchEvent(new Event('input',{bubbles:true})); }catch(x){} }
    var bib=String(getParam('bib')||v.bib||'').slice(0,10);
    if(bib) $('cz-giftBib').value=bib;
    if(v.note) $('cz-giftNote').value=String(v.note).slice(0,200);
    if(v.look || getParam('bib')) $('cz-giftLook').checked=true;
    $('cz-giftLook').addEventListener('change',function(){ giftSync(); giftSave(); render(); });
    ['cz-giftBib','cz-giftNote','cz-name'].forEach(function(id){ var e=$(id); if(e) e.addEventListener('input',giftSave); });
    $('cz-giftOff').addEventListener('click',giftExit);
    giftSync(); giftSave();
  }
  function giftExit(){
    GIFT=false; giftStore(null); giftTimeLock(false); giftLabels(false);
    var b=$('cz-gift'); if(b && b.parentNode) b.parentNode.removeChild(b);
    try{ var u=new URL(window.location.href); u.searchParams.delete('gift'); history.replaceState(null,'',u.pathname+u.search+u.hash); }catch(e){}
    render();
  }
  /* Add to cart: the runner's name is what makes it theirs. */
  function giftCheck(er){
    if(!GIFT) return true;
    if(giftVal('cz-name')) return true;
    var msg='Add the runner’s name — it’s printed on their gift.';
    if(er) er.textContent=msg;
    var ni=$('cz-name'); if(ni){ try{ ni.scrollIntoView({block:'center'}); }catch(e){} try{ ni.focus(); }catch(e){} }
    return false;
  }
  function giftProps(props){
    if(!GIFT) return;
    var dig=isDigital(state.product);
    props['Gift']=dig ? 'Yes — Digital Pack emailed to the buyer' : 'Yes — no prices in the parcel';
    var note=giftVal('cz-giftNote'); if(note && !dig) props['Gift note']=note;
    if(giftLook()){
      delete props['Time'];
      props['Finish time']='Check official results - if not published, print without a time';
      var bib=giftVal('cz-giftBib'); if(bib) props['Bib number']=bib;
      props['Your design']='Saved ✓ — printed as made, with their official finish time added if the event publishes results (otherwise without a time). The photo is just an example.';
      /* Reopens this design with the gift values, for adding the time. */
      try{
        var q=carryQS(), x='product='+encodeURIComponent(state.product||'')+'&style='+encodeURIComponent(state.style||'')+'&who='+encodeURIComponent(giftVal('cz-name'))+(bib?('&bib='+encodeURIComponent(bib)):'');
        props['_Rebuild link']=window.location.origin+window.location.pathname+'?'+(q?(q+'&'):'')+x;
      }catch(e){}
    }
  }
  /* The asset studio: the print file of what is on screen, as a download. */
  function giftStudio(){
    if(!STUDIO || $('cz-giftPrint')) return;
    var b=document.createElement('button'); b.type='button'; b.id='cz-giftPrint'; b.className='cz-mini';
    b.textContent='Download print file (studio)';
    b.style.cssText='display:block;margin:10px 0;font-size:13px';
    b.addEventListener('click',function(){
      b.disabled=true; b.textContent='Building print file…';
      var done=function(){ b.disabled=false; b.textContent='Download print file (studio)'; };
      ensureMapHi(function(){
        physPrintBlob().then(function(bl){
          if(!bl){ done(); return; }
          var a=document.createElement('a'), t=(giftVal('cz-name')||giftVal('cz-title')||'print').toLowerCase().replace(/[^a-z0-9]+/g,'-');
          a.href=URL.createObjectURL(bl); a.download=t+'-'+(state.product||'print')+(/png/.test(bl.type)?'.png':'.jpg');
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
          setTimeout(function(){ URL.revokeObjectURL(a.href); },4000); done();
        },done);
      });
    });
    var host=$('cz-gift')||$('cz-nameRow'); if(host && host.parentNode) host.parentNode.insertBefore(b, host.nextSibling);
  }

  function carryQS(){
    /* curGpx is only set by a param or the picker; on an event product the
       route arrives from the default_gpx metafield, so do not gate on it */
    var gx=curGpx||(PM_DEF&&PM_DEF.gpx)||getParam('gpx')||'';
    var p={}, el;
    /* A route code carries the GPX, the headline, the blurb and the tile style
       in four characters, and keeps the Cloudinary URL out of the address bar.
       Only fall back to the raw gpx= when this page was not opened by code. */
    var rc=(getParam('r')||'').trim();
    if(!rc){ try{ var _cr=currentRoute(); if(_cr&&_cr.code) rc=String(_cr.code).trim(); }catch(e){} }
    if(rc && routeByCode(rc)) p.r=rc; else if(gx) p.gpx=gx;
    else if(state.srcType==='gpx' && state.srcFile && ownHas()) p.own='1';
    var _evh=evBackHandle(); if(_evh) p.ev=_evh;
    if(giftOn()) p.gift='1';
    el=$('cz-title'); if(el&&el.value) p.name=el.value;
    el=$('cz-loc');   if(el&&el.value) p.loc=el.value;
    el=$('cz-dist');  if(el&&el.value) p.dist=el.value;
    el=$('cz-date');  if(el&&el.value) p.date=el.value;
    if(p.r && relayOpt() && relayOpt()!=='solo') p.leg=relayOpt();
    var _hd=Object.keys(STAT_OFF).filter(function(k){ return STAT_OFF[k]; }); if(_hd.length) p.hide=_hd.join(',');
    return Object.keys(p).map(function(k){
      return encodeURIComponent(k)+'='+encodeURIComponent(p[k]); }).join('&');
  }
  function paintKindThumb(cv,kind){
    var pk=DESIGN_KIND, ps=state.style, pv=state.view, pi=state.mockIdx;
    try{
      setKind(kind);
      if(KIND_STYLE[kind]) state.style=KIND_STYLE[kind];
      /* And the palette, not just the style. Without this the Gallery tile in
         the strip was drawn on whatever map theme the page happened to be
         sitting on - an osm-bright thumbnail advertising a positron product. */
      var _kt=tileThemeFor(kind); if(_kt) state.mapStyle=_kt;
      state.view='flat'; state.mockIdx=0;
      paint(cv.getContext('2d'),cv.width,cv.height,true);
    }catch(e){
      console.warn('Milestone: design thumb failed ('+kind+')',e);
    }finally{
      /* must be unconditional - a half-restored kind breaks the whole page */
      setKind(pk); state.style=ps; state.view=pv; state.mockIdx=pi;
    }
  }
  function buildKindStrip(host){
    /* First, and before the early return below: a format the section could not
       afford to look up has an empty list, so returning early would mean never
       asking for it. */
    kinsResolve(focusProd());
    var old=$('cz-kinds'); if(old&&old.parentNode) old.parentNode.removeChild(old);
    var list=kindList();
    if(!host||list.length<2) return;
    var wrap=document.createElement('div'); wrap.className='cz-kinds'; wrap.id='cz-kinds';
    var lab=document.createElement('div'); lab.className='cz-lbl'; lab.textContent='Try another design';
    wrap.appendChild(lab);
    /* p_kindscroll (28 Oct): one line that scrolls, with a fade and (mouse)
       arrows on the side that has more. */
    var kw=document.createElement('div'); kw.className='cz-kindwrap'; wrap.appendChild(kw);
    var row=document.createElement('div'); row.className='cz-kindrow'; kw.appendChild(row);
    var arL=document.createElement('button'), arR=document.createElement('button');
    arL.type=arR.type='button'; arL.className='cz-karr cz-karl'; arR.className='cz-karr cz-karr2';
    arL.setAttribute('aria-label','Previous designs'); arR.setAttribute('aria-label','More designs');
    arL.innerHTML='&#8249;'; arR.innerHTML='&#8250;';
    kw.appendChild(arL); kw.appendChild(arR);
    /* p_kindhint (29 Oct): how many, and "Swipe for more" while there are more */
    var cue=document.createElement('button'); cue.type='button'; cue.className='cz-kcue';
    lab.appendChild(cue);
    var kEdge=function(){
      var m=row.scrollWidth-row.clientWidth, n=row.querySelectorAll('.cz-kind').length;
      kw.classList.toggle('cz-ml', row.scrollLeft>2);
      kw.classList.toggle('cz-mr', row.scrollLeft<m-2);
      cue.innerHTML=n+' designs'+(row.scrollLeft<m-2 ? ' \u00b7 <b>Swipe for more \u2192</b>' : '');
      cue.setAttribute('aria-label', row.scrollLeft<m-2 ? 'More designs' : n+' designs');
    };
    cue.addEventListener('click',function(){ kBy(1); });
    var kBy=function(d){ kw._kTouched=true; try{ row.scrollBy({left:d*Math.max(120,row.clientWidth*0.8),behavior:'smooth'}); }catch(e){ row.scrollLeft+=d*row.clientWidth*0.8; } };
    arL.addEventListener('click',function(){ kBy(-1); });
    arR.addEventListener('click',function(){ kBy(1); });
    row.addEventListener('scroll',kEdge,{passive:true});
    window.addEventListener('resize',kEdge);
    var ar=(PRODUCTS[focusProd()]||PRODUCTS.poster).ar, W=76, H=Math.round(W/ar);
    /* every tile shows the same KIND of image, or the strip reads as broken */
    var allThumb=true, allFeat=true;
    list.forEach(function(k){ if(!k.img) allThumb=false; if(!k.fimg) allFeat=false; });
    var pick=allThumb?'img':(allFeat?'fimg':null);
    list.forEach(function(k){
      var a=document.createElement(k.cur?'div':'a');
      a.className='cz-kind'+(k.cur?' cz-on':'');
      if(!k.cur){
        /* design= is explicit and outranks the route's stored design. Without
           it, r= would re-apply that design at the destination and the click
           would land straight back on the look it was trying to leave. */
        var _kq=(function(kk){ return function(){
          var qs=carryQS(),
              d='design='+encodeURIComponent(kk||'neon')
                +'&style='+encodeURIComponent(kindStyle(kk));
          return qs?(qs+'&'+d):d;
        }; })(k.kind);
        a.href=k.url.split('?')[0]+'?'+_kq();
        a.addEventListener('click',function(ev){
          ev.preventDefault(); location.href=k.url.split('?')[0]+'?'+_kq();
        });
      }
      /* W*3 rather than W: the tile is 76 CSS px and a phone draws it at
         two or three device pixels each. */
      var url=pick?cdnImg(k[pick]||'', W*3):'';
      var thumb;
      if(url){
        thumb=document.createElement('img'); thumb.src=url; thumb.alt='';
        thumb.loading='lazy'; thumb.decoding='async';
        thumb.addEventListener('load',kEdge);
      }else{
        thumb=document.createElement('canvas'); thumb.width=W*2; thumb.height=H*2;
        paintKindThumb(thumb,k.kind);
      }
      thumb.style.width=W+'px'; thumb.style.height=H+'px';
      var t=document.createElement('span'); t.textContent=kindLabel(k.kind);
      a.appendChild(thumb); a.appendChild(t); row.appendChild(a);
    });
    host.appendChild(wrap);
    /* The design on screen, brought into view (centred when it can be). */
    var cur=row.querySelector('.cz-kind.cz-on');
    if(cur){ var to=cur.offsetLeft-(row.clientWidth-cur.offsetWidth)/2;
      row.scrollLeft=Math.max(0,Math.min(to,row.scrollWidth-row.clientWidth)); }
    kEdge();
    kindNudge(row,kw);
  }
  /* Once per page, the first time the strip is on screen with more to see:
     a short slide sideways and back, so a thumb knows it can swipe. */
  var _kindNudged=false;
  function kindNudge(row,kw){
    if(_kindNudged) return;
    /* anything the customer does to the row wins over the nudge */
    ['pointerdown','touchstart','wheel','keydown'].forEach(function(ev){ kw.addEventListener(ev,function(){ kw._kTouched=true; },{passive:true}); });
    try{ if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(e){}
    var go=function(){
      if(_kindNudged || kw._kTouched || !kw.classList.contains('cz-mr')) return;
      _kindNudged=true;
      var x0=row.scrollLeft, d=Math.min(72,row.scrollWidth-row.clientWidth-x0);
      kw.classList.add('cz-knudge');
      try{ row.scrollTo({left:x0+d,behavior:'smooth'}); }catch(e){ row.scrollLeft=x0+d; }
      setTimeout(function(){ if(!kw._kTouched){ try{ row.scrollTo({left:x0,behavior:'smooth'}); }catch(e){ row.scrollLeft=x0; } }
        setTimeout(function(){ kw.classList.remove('cz-knudge'); },600); },650);
    };
    if(typeof IntersectionObserver==='function'){
      var io=new IntersectionObserver(function(es){
        for(var i=0;i<es.length;i++) if(es[i].isIntersecting && es[i].intersectionRatio>0.6){ io.disconnect(); setTimeout(go,350); return; }
      },{threshold:[0.6]});
      io.observe(row);
    } else setTimeout(go,800);
  }
  function kindStripSoon(){
    setTimeout(function(){
      try{ buildKindStrip(document.querySelector('.cz-pmleft')); }
      catch(e){ console.warn('Milestone: design strip failed',e); }
      kindDebug();
    },0);
  }
  /* The sibling's own URL, carrying whatever is currently in the address bar.
     Named rather than inline so it can be tested on its own. */
  function sibUrl(u){
    if(!u) return '';
    var q='';
    try{ q=(window.location&&window.location.search)||''; }catch(e){}
    var s=String(u), h='', hi=s.indexOf('#');
    if(hi>=0){ h=s.slice(hi); s=s.slice(0,hi); }
    /* path + search + fragment, in that order - a query after a '#' is part of
       the fragment and getParam() would never see it. */
    return s.split('?')[0]+q+h;
  }
  function pmSwitch(f){
    var i=RING.indexOf(f); if(i<0||i===focusIdx) return;
    focusIdx=i; heroSel=0;
    var sib=pmSib(f);
    if(sib){
      /* An event headline outranks the sibling product's own copy. */
      var t=$('cz-pmtitle'); if(t && sib.title && !_evTitle) t.textContent=sib.title;
      var d=$('cz-pmdesc');  if(d && !_evBlurb) d.innerHTML=sib.desc||'';
      /* sib.url alone would drop ?r=, and with it the route that the headline,
         the blurb and the next design switch all depend on. */
      try{ if(sib.url && window.history && history.replaceState) history.replaceState(null,'',sibUrl(sib.url)); }catch(e){}
    }
    /* Photo belongs to the frame. Leaving the frame while it is selected has
       to put the design back, or the next format renders photo-overlay while
       its own rail tile promised something else. */
    if(IS_PO && !isPhotoFmt(f) && typeof framePhoto==='function') framePhoto(false);
    if(rebuildPicker) rebuildPicker();   /* options and label follow the format */
    /* Relabels the Elevation/Photo slot for the format being switched TO.
       Without it the button stays "Photo" on a poster and still fires
       framePhoto() when clicked. */
    refreshStyles();
    renderShow();
    updateAlsoLinks();
    kindStripSoon();
  }
  function buildEventPicker(){
    var wrap=$('cz-eventpick'); if(!wrap) return;
    if(!EVENTS || EVENTS.length<2) return;   
    var urlHasRoute = !!(getParam('gpx')||getParam('race')||getParam('img'));  
    var sel=document.createElement('select'); sel.id='cz-eventsel';
    EVENTS.forEach(function(ev,i){ var o=document.createElement('option'); o.value=String(i);
      o.textContent=(ev.name&&ev.name.trim())||('Event '+(i+1)); sel.appendChild(o); });
    wrap.innerHTML='<label>Choose your event</label>'; wrap.appendChild(sel); wrap.classList.add('cz-on');
    sel.value='0';
    sel.addEventListener('change',function(){
      var ev=EVENTS[Number(sel.value)]||EVENTS[0];
      applyEvent({ gpx:ev.gpx, poly:ev.poly, name:ev.name, loc:ev.loc, dist:ev.dist, date:ev.date });
      heroSel=0; renderShow();
    });
    if(!urlHasRoute){ applyEvent(EVENTS[0]); }   
  }
  function updateAlsoLinks(){
    if(!PM) return;
    var cards=document.querySelectorAll('.mprod-alsocard[data-carry]');
    if(!cards.length) return;
    var p={};
    if(curGpx){
      p.gpx=curGpx;
      var el;
      el=$('cz-title'); if(el&&el.value) p.name=el.value;
      el=$('cz-loc');   if(el&&el.value) p.loc=el.value;
      el=$('cz-dist');  if(el&&el.value) p.dist=el.value;
      el=$('cz-date');  if(el&&el.value) p.date=el.value;
    }
    var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+'='+encodeURIComponent(p[k]);}).join('&');
    cards.forEach(function(a){ var base=(a.getAttribute('href')||'').split('?')[0]; a.setAttribute('href', qs?(base+'?'+qs):base); });
  }
  function fmtMonth(m){ return (['January','February','March','April','May','June','July','August','September','October','November','December'][m-1])||''; }
  function _ym(r){ var m=/^(\d{4})-(\d{2})/.exec(r.date||''); return m?{y:+m[1],mo:+m[2]}:{y:0,mo:0}; }

  /* AU state from the location string: "Sydney, NSW" -> NSW. Falls back to the
     full state name, then to '' (shown as International/Other). */
  var _ST_CODES=['NSW','VIC','QLD','WA','SA','TAS','ACT','NT'];
  var _ST_CITY={'SYDNEY':'NSW','NEWCASTLE':'NSW','WOLLONGONG':'NSW','BLUE MOUNTAINS':'NSW',
                'MELBOURNE':'VIC','GEELONG':'VIC','BALLARAT':'VIC',
                'BRISBANE':'QLD','GOLD COAST':'QLD','SUNSHINE COAST':'QLD','CAIRNS':'QLD','TOWNSVILLE':'QLD',
                'PERTH':'WA','FREMANTLE':'WA','ADELAIDE':'SA','HOBART':'TAS','LAUNCESTON':'TAS',
                'CANBERRA':'ACT','DARWIN':'NT'};
  var _ST_FULL={'NEW SOUTH WALES':'NSW','VICTORIA':'VIC','QUEENSLAND':'QLD',
                'WESTERN AUSTRALIA':'WA','SOUTH AUSTRALIA':'SA','TASMANIA':'TAS',
                'AUSTRALIAN CAPITAL TERRITORY':'ACT','NORTHERN TERRITORY':'NT'};
  function routeState(r){
    var L2=String(r.loc||'').toUpperCase();
    for(var f in _ST_FULL){ if(L2.indexOf(f)>=0) return _ST_FULL[f]; }
    for(var i=0;i<_ST_CODES.length;i++){
      if(new RegExp('(^|[^A-Z])'+_ST_CODES[i]+'([^A-Z]|$)').test(L2)) return _ST_CODES[i];
    }
    /* "Sydney, Australia" carries no state - and that is the customiser's own
       default location, so it will be common in the catalogue. */
    for(var c in _ST_CITY){ if(L2.indexOf(c)>=0) return _ST_CITY[c]; }
    return '';
  }
  function routeKmOf(r){
    var m=/(\d+(?:\.\d+)?)/.exec(String(r.dist||'')); return m?parseFloat(m[1]):0;
  }
  /* The vocabulary runners actually use, not raw numbers. */
  var _BANDS=[['5K',0,7.5],['10K',7.5,15],['Half',15,30],['Marathon',30,50],['Ultra',50,1e9]];
  function routeBand(r){
    if(isTriRoute(r)) return '';
    var km=routeKmOf(r); if(!km) return '';
    for(var i=0;i<_BANDS.length;i++){ if(km>=_BANDS[i][1] && km<_BANDS[i][2]) return _BANDS[i][0]; }
    return '';
  }
  var _rQ='', _rState='', _rBand='', _rSport='';
  /* A route with no Sport field is a run. */
  function routeSport(r){ return isTriRoute(r) ? 'tri' : (sportKey(r && r.sport) || 'run'); }
  /* A triathlon course: three legs, its own product. */
  function isTriRoute(r){ return /triathlon/i.test(String((r && r.sport) || '')); }
  /* This product is Stat Bar's own (its design_kind metafield). */
  function pageIsSb(){ return !!PM && String(MSC[10]||'').trim().toLowerCase()==='statbar'; }
  function triRouteUrl(r){
    var base=String(MSC[108]||'').trim(); if(base.charAt(0)!=='/') base='/products/triathlon-poster';
    var f=''; try{ f=String(focusProd()||''); }catch(e){}
    /* formats: not frame,poster - the triathlon product is the poster, and
       triathlons have no medal frame. */
    var TRI_FMTS={tee:1, magnet:1, a4print:1, digital:1};
    var _ev=''; try{ _ev=evBackHandle(); }catch(e){}      /* 30 Oct: the way back to the event page */
    return base.split('?')[0].split('#')[0]+'?r='+encodeURIComponent(r.code)+(TRI_FMTS[f]?'&product='+encodeURIComponent(f):'')+(_ev?'&ev='+encodeURIComponent(_ev):'');
  }
  /* Resolve ?r=<code> against the catalogue. Case and stray spaces are
     forgiven because these codes get typed into Instagram bios by hand. */
  function routeByCode(code){
    code=String(code||'').trim().toLowerCase(); if(!code) return null;
    var L2=ROUTES_CAT||[];
    for(var i=0;i<L2.length;i++){
      if(String(L2[i].code||'').trim().toLowerCase()===code) return L2[i];
    }
    return null;
  }
  /* ---- Relay: one course as a solo run, a team relay, or a single leg -------
     Bondi to Manly (20 Oct). Only a route entry carrying relay_legs has any of
     this: every function here answers "nothing" for any other route, and each
     place that calls one falls straight through to what it did before, so
     every other page draws exactly what it drew before.

     ?leg=solo|relay|1..n picks the option. It rides along in the address, so a
     format switch (which keeps the query) and a design switch (carryQS) both
     keep it. */
  var RELAY_COL=['#FFD028','#FF5A1F','#FF2D9A','#8B5CF6'];
  /* Leg 1's yellow needs an edge on light ground (Standard and Light maps,
     paper). Dark ochre, thin, under the line - not a black casing. */
  var RELAY_EDGE='#8A6A00';
  var RELAY_LEG=null;
  function relayLegsOf(r){
    var v=r&&r.relay; if(!v) return null;
    if(typeof v==='string'){ try{ v=JSON.parse(v); }catch(e){ return null; } }
    var meta=(v && !Array.isArray(v) && typeof v==='object') ? v : null;
    if(meta && Array.isArray(meta.legs)) v=meta.legs;
    if(!Array.isArray(v)) return null;
    var out=[];
    v.forEach(function(o,i){
      if(!o || typeof o!=='object') return;
      var n=parseInt(o.leg,10); if(!(n>0)) n=i+1;
      var asc=parseFloat(String(o.ascent==null?'':o.ascent).replace(/[,\s]/g,''));
      var col=String(o.color||o.colour||'').trim();
      out.push({ n:n, title:String(o.title||'').trim(), km:parseFloat(o.km)||0,
                 ascent:(asc>0?asc:0), gpx:String(o.gpx||'').trim(), poly:String(o.track||o.poly||'').trim(),
                 end:parseFloat(o.end)||0, name:String(o.print||'').trim(),
                 color:/^#[0-9a-f]{6}$/i.test(col)?col.toUpperCase():'' });
    });
    out.sort(function(a,b){ return a.n-b.n; });
    if(out.length<2) return null;
    out.def=meta ? String(meta['default']||meta.option||'').trim().toLowerCase() : '';
    out.title=meta ? String(meta.title||'').trim() : '';
    return out;
  }
  var _relayK=null, _relayR=null, _relayL=null;
  function relayRoute(){
    if(typeof ROUTES_CAT==='undefined' || !ROUTES_CAT || !ROUTES_CAT.length) return null;
    var r=currentRoute(), k=r?('#'+String(r.code||'')+'|'+(typeof r.relay==='string'?r.relay.length:(r.relay?1:0))):'';
    if(k!==_relayK){ _relayK=k; _relayL=r?relayLegsOf(r):null; _relayR=_relayL?r:null; }
    return _relayR;
  }
  function relayLegs(){ return relayRoute() ? _relayL : null; }
  /* 'solo' | 'relay' | '1'..'n', or '' on any route without relay data. A leg
     that has no track of its own is not an option - it falls back to Solo. */
  function relayOpt(){
    var L=relayLegs(); if(!L) return '';
    if(RELAY_LEG===null) RELAY_LEG=String(getParam('leg')||'').trim().toLowerCase();
    var want=RELAY_LEG||L.def||'';
    if(want==='relay') return 'relay';
    var n=parseInt(want,10);
    if(n>0) for(var i=0;i<L.length;i++) if(L[i].n===n && (L[i].gpx||L[i].poly||(relayRoute()||{}).gpx)) return String(n);
    return 'solo';
  }
  function relayIsTeam(){ return relayOpt()==='relay'; }
  function relayLegFor(o){
    var n=parseInt(o,10), L=relayLegs(); if(!(n>0) || !L) return null;
    for(var i=0;i<L.length;i++) if(L[i].n===n) return L[i];
    return null;
  }
  function relayLeg(){ return relayLegFor(relayOpt()); }
  function relayHexN(i,g){ return (g&&g.color) || RELAY_COL[i%RELAY_COL.length]; }
  /* A single leg's colour (the one it has on the relay poster); '' otherwise. */
  function relayHex(){
    var g=relayLeg(); if(!g) return '';
    return relayHexN(_relayL.indexOf(g), g);
  }
  /* Solo: the route in the run colour, whatever the entry's sport - the
     vermilion every run is drawn in. '' on anything but a relay route's Solo. */
  function relaySoloHex(){
    if(relayOpt()!=='solo') return '';
    var c=String(MSC[101]||'').trim()||String(MSC[1]||'').trim();
    return /^#[0-9a-f]{6}$/i.test(c) ? c.toUpperCase() : '#FF5A1F';
  }
  function relayLight(hex){
    var m=/^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex||''); if(!m) return false;
    return (0.2126*parseInt(m[1],16)+0.7152*parseInt(m[2],16)+0.0722*parseInt(m[3],16)) > 175;
  }
  function relayKm1(km){ return String(Math.round(km*10)/10); }
  function relayCourse(){ return String((relayRoute()||{}).name||'').trim(); }
  function relayTitleFor(o){
    var g=relayLegFor(o);
    if(g) return g.name || ((g.title||('Leg '+g.n))+(g.km>0?' '+relayKm1(g.km)+'K':''));
    if(o==='relay') return (_relayL&&_relayL.title) || (relayCourse()+' Relay');
    return relayCourse();
  }
  /* The line under the title. Every design prints the location there, so a
     leg's line goes in as the location - the customer can still change it. */
  function relayLocFor(o){
    var g=relayLegFor(o);
    if(g) return 'Leg '+g.n+' · '+relayTitleFor('relay');
    return String((relayRoute()||{}).loc||'');
  }
  function relayDistFor(o){
    var g=relayLegFor(o);
    if(g) return g.km>0 ? (String(g.km)+' km') : '';
    return String((relayRoute()||{}).dist||'');
  }
  /* A leg's file can be written as a bare name: it is looked for next to the
     course's own GPX, which is where Shopify Files puts every upload. */
  function relayUrl(u,base){
    u=String(u||'').trim(); if(!u) return '';
    if(/^(https?:|data:|blob:)/i.test(u) || u.charAt(0)==='/') return u;
    /* The Files page shows "bondi-manly-leg1" for bondi-manly-leg1.gpx. */
    if(!/\.[a-z0-9]{2,5}$/i.test(u)) u+='.gpx';
    /* The store's own Files address (Liquid's file_url, passed by the section
       with the relay data), else the folder the course's GPX is in. */
    var fb=String((relayRoute()||{}).relayfiles||'').split('#')[0].split('?')[0];
    var b=(fb && fb.lastIndexOf('/')>=0) ? fb : String(base||'').split('#')[0].split('?')[0];
    var i=b.lastIndexOf('/'); return i>=0 ? b.slice(0,i+1)+u : u;
  }
  function relayEvent(o){
    var r=relayRoute()||{}, g=relayLegFor(o);
    var own=g && (g.gpx||g.poly);
    if(g && !own && r.gpx) relaySliceFor(g, r.gpx);
    return { gpx: g ? (own ? relayUrl(g.gpx, r.gpx) : (r.gpx||'')) : (r.gpx||''), poly: g ? g.poly : (r.poly||''), img: g ? '' : (r.img||''),
             name: relayTitleFor(o), loc: relayLocFor(o), dist: relayDistFor(o), date: r.date||'' };
  }
  /* Cutting a leg out of the full course: armed for one URL, applied by
     loadGpxUrl when that file arrives (relayCut), before it is thinned. */
  var _relaySlice=null, _relayRescued={};
  function relaySliceFor(g,url){
    var L=relayLegs(); if(!L || !url) return;
    var i=L.indexOf(g), cuts=relayCuts();
    _relaySlice={ url:url, a:(i>0?cuts[i-1]:0), b:(i<cuts.length?cuts[i]:1) };
  }
  function relayCut(url,g){
    if(!_relaySlice || _relaySlice.url!==url || !g || !g.coords || g.coords.length<3) return;
    var cum=relayCum(g.coords), a=_relaySlice.a, b=_relaySlice.b, i0=0, i1=g.coords.length-1, i;
    if(!cum) return;
    for(i=0;i<cum.length;i++){ if(cum[i]>=a){ i0=Math.max(0,i-(cum[i]>a?1:0)); break; } }
    for(i=cum.length-1;i>=0;i--){ if(cum[i]<=b){ i1=Math.min(cum.length-1,i+(cum[i]<b?1:0)); break; } }
    if(i1-i0<2) return;
    g.coords=g.coords.slice(i0,i1+1); if(g.eles) g.eles=g.eles.slice(i0,i1+1);
  }
  /* A leg's own file would not load: cut it from the full course instead. */
  function relayRescue(url){
    var g=relayLeg(), r=relayRoute(); if(!g || !r || !r.gpx || _relayRescued[url]) return false;
    var mine=relayEvent(relayOpt()).gpx; if(url!==mine || url===r.gpx) return false;
    _relayRescued[url]=true;
    console.warn('Milestone relay: leg '+g.n+' file did not load ('+url+') - cutting it from the course file');
    relaySliceFor(g, r.gpx);
    loadGpxUrl(r.gpx);
    return true;
  }
  /* Where the legs change over, as fractions of the course file's length: the
     JSON's "end" when it is given, else the legs' official km. */
  function relayCuts(){
    var L=relayLegs(); if(!L) return [];
    var tot=0, acc=0, out=[], i;
    for(i=0;i<L.length;i++) tot+=L[i].km||0;
    for(i=0;i<L.length-1;i++){
      acc+=L[i].km||0;
      out.push((L[i].end>0 && L[i].end<1) ? L[i].end : (tot>0 ? acc/tot : (i+1)/L.length));
    }
    return out;
  }
  /* Cumulative distance along a track, 0..1. Cached on the array itself. */
  function relayCum(c){
    if(!c || c.length<2) return null;
    if(c._rcum && c._rcum.length===c.length) return c._rcum;
    var d=[0], t=0, i;
    for(i=1;i<c.length;i++){
      var la=(c[i][0]+c[i-1][0])/2*Math.PI/180, dx=(c[i][1]-c[i-1][1])*Math.cos(la), dy=c[i][0]-c[i-1][0];
      t+=Math.sqrt(dx*dx+dy*dy); d.push(t);
    }
    for(i=0;i<d.length;i++) d[i]=t>0 ? d[i]/t : i/(d.length-1);
    try{ c._rcum=d; }catch(e){}
    return d;
  }
  /* A track cut into the legs: arrays of points, neighbours sharing the
     changeover point so the line has no gap. */
  function relaySplit(c){
    var cum=relayCum(c), cuts=relayCuts(); if(!cum) return null;
    var segs=[], cur=[], k=0, i;
    for(i=0;i<c.length;i++){
      cur.push(c[i]);
      while(k<cuts.length && cum[i]>=cuts[k] && i>0){ segs.push(cur); cur=[c[i]]; k++; }
    }
    segs.push(cur);
    while(segs.length<cuts.length+1) segs.push([]);
    return segs;
  }
  /* Street Map's panel shape on a relay route: the same arithmetic
     renderEditorial does, on the format being looked at. */
  function relayEdtAR(){
    try{
      var ar=PRODUCTS[focusProd()].ar, W=1000, H=W/ar;
      var lines=Math.min(3,Math.max(1,String(edtVal('cz-title')||'x').split(',').filter(function(t){ return t.trim(); }).length));
      var tFirst=EDT.titleLast-(lines-1)*EDT.titleLead, rib=ribbonOn();
      var mh=H*(tFirst-EDT.mapGap-EDT.mapT)-(rib?(H*(EDT.ribbonH+EDT.ribbonGap)+relayRibExtra(W)):0);
      return mh>0 ? (W*(EDT.mR-EDT.mL))/mh : 0;
    }catch(e){ return 0; }
  }
  /* Gallery's team row: two rows of two on the compact formats. */
  function relayLegRows(){ return (IS_GAL && typeof galCompact==='function' && galCompact() && (relayLegs()||[]).length>2) ? 2 : 1; }
  function relayLegStep(W){ return Math.max(W*0.026, (IS_GAL?galFloor(W):0)*1.5); }
  /* For the cache keys of pictures the colours are baked into. */
  function relaySig(){ var o=relayOpt(); return o ? ('|leg:'+o) : ''; }

  /* Street Map: one polyline per leg, in the leg's colour; leg 1's yellow over
     its ochre edge. A single leg in yellow gets the edge too. */
  /* Douglas-Peucker on every part at one tolerance, loosened step by step
     until the parts (and leg 1's edge, which repeats its points) fit the
     300 points one route's map request has always used. Simplifying an
     already-simplified line again by index is what made straight lines. */
  var RELAY_PTS=300;
  function relayFit(parts,edged){
    function at(t){ return parts.map(function(p){ return p.length>2 ? dpSimplify(p,t) : p.slice(); }); }
    function cost(o){ for(var n=0,i=0;i<o.length;i++) n+=o[i].length*(edged[i]?2:1); return n; }
    var lo=Math.log(1e-7), hi=Math.log(0.02), best=null, k;
    if(cost(at(1e-7))<=RELAY_PTS) return at(1e-7);
    for(k=0;k<24;k++){
      var mid=(lo+hi)/2, o=at(Math.exp(mid));
      if(cost(o)<=RELAY_PTS){ best=o; hi=mid; } else lo=mid;
    }
    if(best) return best;
    var out=at(0.02), tot=cost(out);
    return out.map(function(p){ var m=Math.max(2,Math.floor(p.length*RELAY_PTS/tot));
      if(p.length<=m) return p; var ix=downsampleIdx(p.length,m); return ix.map(function(j){ return p[j]; }); });
  }
  function relayGeom(simp){
    var o=relayOpt(); if(!o || o==='solo') return '';
    function pl(pts,col,w){
      return 'polyline:'+pts.map(function(c){ return c[1].toFixed(5)+','+c[0].toFixed(5); }).join(',')
             +';linecolor:'+col.toLowerCase()+';linewidth:'+w+';lineopacity:1';
    }
    var full=(state.coords && state.coords.length>1) ? state.coords : simp;
    if(o!=='relay'){
      var hx=relayHex();
      if(!relayLight(hx)) return '';
      var one=relayFit([full],[true])[0];
      return pl(one,RELAY_EDGE,7)+'|'+pl(one,hx,5);
    }
    var segs=relaySplit(full), L=relayLegs(); if(!segs) return '';
    var edged=segs.map(function(sg,i){ return relayLight(relayHexN(i,L[i])); });
    var fit=relayFit(segs,edged), out=[];
    fit.forEach(function(sg,i){
      if(sg.length<2) return;
      var col=relayHexN(i,L[i]);
      if(edged[i]) out.push(pl(sg,RELAY_EDGE,7));
      out.push(pl(sg,col,5));
    });
    return out.join('|');
  }
  /* ---- the relay's Map style from tiles (21 Oct) -------------------------
     The static map would draw the route from ~300 points. Here the map comes
     from the raster tiles, fitted to the same area and size, and the route
     is drawn from every point of the track. A URL that is not a relay map
     goes to Geoapify untouched. */
  function relayTilesFor(u){
    /* The relay, and (26 Oct) any map that carries markers: Geoapify's static
       map refuses them live, so they are drawn on the tiles instead. */
    var o=relayOpt(); if(!MAPKEY) return false;
    if(!o && !/[?&]marker=/.test(String(u||''))) return false;
    return /maps\.geoapify\.com\/v1\/staticmap\?/.test(String(u||''));
  }
  function relayImgSrc(im,u){
    if(!relayTilesFor(u)){ im.src=u; return; }
    relayTileMap(u,function(cv){
      if(!cv){ im.src=u; return; }
      try{ cv.toBlob(function(b){ if(!b){ im.src=u; return; } im.src=URL.createObjectURL(b); },'image/png'); }
      catch(e){ im.src=u; }
    });
  }
  var RELAY_TILE_MAX=48;
  function relayTileMap(u,cb){
    var q; try{ q=new URL(u).searchParams; }catch(e){ cb(null); return; }
    var sf=parseFloat(q.get('scaleFactor')||'1')||1;
    var W=Math.round((+q.get('width')||600)*sf), H=Math.round((+q.get('height')||800)*sf);
    var st=q.get('style')||'osm-bright';
    var a=String(q.get('area')||'').replace(/^rect:/,'').split(',').map(parseFloat);
    if(a.length!==4 || a.some(function(v){ return !isFinite(v); }) || !(W>1) || !(H>1)){ cb(null); return; }
    function mx(lo){ return (lo+180)/360; }
    function my(la){ var r=la*Math.PI/180; return (1-Math.log(Math.tan(r)+1/Math.cos(r))/Math.PI)/2; }
    /* Cover: the area fills the image, centred - what Geoapify does with it. */
    var X0=mx(a[0]), X1=mx(a[2]), Yn=my(a[3]), Ys=my(a[1]);
    var k=Math.max(W/Math.max(1e-12,X1-X0), H/Math.max(1e-12,Ys-Yn)), cx=(X0+X1)/2, cy=(Yn+Ys)/2;
    var wx0=cx-W/2/k, wx1=cx+W/2/k, wy0=cy-H/2/k, wy1=cy+H/2/k;
    /* @2x tiles at the zoom whose pixels are at least the image's own. */
    var z=Math.max(1,Math.min(19,Math.ceil(Math.log(k/512)/Math.LN2))), n, tx0, tx1, ty0, ty1;
    for(;;){
      n=Math.pow(2,z);
      tx0=Math.floor(wx0*n); tx1=Math.floor(wx1*n-1e-9); ty0=Math.floor(wy0*n); ty1=Math.floor(wy1*n-1e-9);
      if((tx1-tx0+1)*(ty1-ty0+1)<=RELAY_TILE_MAX || z<=1) break;
      z--;
    }
    var cv=document.createElement('canvas'); cv.width=W; cv.height=H;
    var x=cv.getContext('2d'); x.imageSmoothingQuality='high';
    x.fillStyle=(st==='dark-matter')?'#1B1B1D':'#EDEDEB'; x.fillRect(0,0,W,H);
    var T=k/n, total=(tx1-tx0+1)*(ty1-ty0+1), pending=total, failed=0, done=false;
    var to=setTimeout(function(){ failed=total; finish(); },20000);
    function finish(){
      if(done) return; done=true; clearTimeout(to);
      if(failed>total*0.25){ console.warn('Milestone relay: map tiles refused ('+failed+'/'+total+') - using the static map'); cb(null); return; }
      if(q.get('geometry')) relayDrawLines(x,function(la,lo){ return [(mx(lo)-wx0)*k, (my(la)-wy0)*k]; },sf);
      var mk=q.get('marker');
      if(mk){
        var _P=function(la,lo){ return [(mx(lo)-wx0)*k, (my(la)-wy0)*k]; };
        if(!relayOpt() && state.coords && state.coords.length>1){
          /* A plain route (26 Oct): the markers as Terrain draws them. */
          var _pr=state.coords.map(function(c){ return _P(c[0],c[1]); });
          if(kmOn()) drawKmMarks(x,_pr,state.coords,W/800);
          if(sfOn()) terrainSfIcons(x,_pr[0],_pr[_pr.length-1],W,W);   /* 30 Oct: green dot, chequered flag */
        } else relayDrawMarkers(x,mk,_P,sf);
      }
      cb(cv);
    }
    function one(tx,ty,hi){
      var wrap=((tx%n)+n)%n, im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){ try{ x.drawImage(im,(tx/n-wx0)*k,(ty/n-wy0)*k,T+0.5,T+0.5); }catch(e){} if(--pending===0) finish(); };
      im.onerror=function(){ if(hi){ one(tx,ty,false); return; } failed++; if(--pending===0) finish(); };
      im.src='https://maps.geoapify.com/v1/tile/'+st+'/'+z+'/'+wrap+'/'+ty+(hi?'@2x':'')+'.png?apiKey='+MAPKEY;
    }
    for(var ty=ty0;ty<=ty1;ty++) for(var tx=tx0;tx<=tx1;tx++) one(tx,ty,true);
  }
  /* The route on the tiles: every point, the legs in their colours, a light
     colour over its ochre edge - the static map's widths (5 and 7 px a 1x). */
  function relayDrawLines(x,P,sf){
    var c=state.coords; if(!c || c.length<2) return;
    var o=relayOpt(), L=relayLegs()||[];
    var parts=(o==='relay') ? (relaySplit(c)||[c]) : [c];
    x.save(); x.lineJoin='round'; x.lineCap='round';
    parts.forEach(function(sg,i){
      if(!sg || sg.length<2) return;
      var col=(o==='relay') ? relayHexN(i,L[i]) : (relayHex()||routeHex());
      function path(){ x.beginPath(); var p=P(sg[0][0],sg[0][1]); x.moveTo(p[0],p[1]);
        for(var j=1;j<sg.length;j++){ p=P(sg[j][0],sg[j][1]); x.lineTo(p[0],p[1]); } }
      if(relayLight(col)){ x.strokeStyle=RELAY_EDGE; x.lineWidth=7*sf; path(); x.stroke(); }
      else if(o!=='relay' && typeof kmOn==='function' && kmOn()){ x.strokeStyle=mapHaloHex(); x.lineWidth=9*sf; path(); x.stroke(); }
      x.strokeStyle=col; x.lineWidth=5*sf; path(); x.stroke();
    });
    x.restore();
  }
  /* Start and finish, as the static map's own small circles. */
  function relayDrawMarkers(x,mk,P,sf){
    String(mk).split('|').forEach(function(m){
      var o={}; m.split(';').forEach(function(kv){ var i=kv.indexOf(':'); if(i>0) o[kv.slice(0,i)]=kv.slice(i+1); });
      var ll=String(o.lonlat||'').split(',').map(parseFloat); if(ll.length!==2 || !isFinite(ll[0])) return;
      var p=P(ll[1],ll[0]), r=(o.text?9:6)*sf;
      x.beginPath(); x.arc(p[0],p[1],r,0,6.2832); x.fillStyle=o.color||'#ffffff'; x.fill();
      x.lineWidth=2*sf; x.strokeStyle=o.strokecolor||'#17171A'; x.stroke();
      if(o.text){ x.save(); x.fillStyle=o.contentcolor||'#17171A'; x.font='700 '+(9*sf)+'px Inter,sans-serif';
        x.textAlign='center'; x.textBaseline='middle'; x.fillText(o.text,p[0],p[1]+0.5*sf); x.restore(); }
    });
  }
  /* Terrain: the route stroked leg by leg. pr is the projected track, parallel
     to coords. False when this is not the relay option. */
  function relayStroke(ctx,pr,lw,coords){
    if(!relayIsTeam() || !coords || pr.length!==coords.length) return false;
    var cum=relayCum(coords), cuts=relayCuts(), L=relayLegs(), b=[0].concat(cuts).concat([1.0000001]);
    if(!cum) return false;
    ctx.lineJoin='round'; ctx.lineCap='round'; ctx.lineWidth=lw;
    for(var s=0;s<b.length-1;s++){
      var st=false; ctx.beginPath();
      for(var i=0;i<pr.length;i++){
        if(cum[i]>=b[s] && cum[i]<b[s+1]){
          if(!st){ var j=i>0?i-1:i; ctx.moveTo(pr[j][0],pr[j][1]); st=true; }
          ctx.lineTo(pr[i][0],pr[i][1]);
        }
      }
      ctx.strokeStyle=relayHexN(s,L[s]); ctx.stroke();
    }
    return true;
  }
  /* Neon and the plain-route panels: the route mask coloured leg by leg. The
     mask is gpxToCanvas() of state.coords, so the same projection paints the
     colours, drawn wider than the mask and kept only where the mask is. */
  var _relayArt=null;
  function relayColourised(){
    if(!relayIsTeam()) return null;
    var m=state.mask, c=state.coords;
    if(!m || !c || c.length<2 || m.width!==1000 || m.height!==1000) return null;
    if(_relayArt && _relayArt.m===m && _relayArt.c===c) return _relayArt.cv;
    var segsIdx=relayCum(c), cuts=relayCuts(), L=relayLegs(), pj=projectFit(c,1000,0.12).pts;
    var P=document.createElement('canvas'); P.width=1000; P.height=1000;
    var px=P.getContext('2d'); px.lineCap='round'; px.lineJoin='round'; px.lineWidth=36;
    var b=[0].concat(cuts).concat([1.0000001]);
    for(var s=0;s<b.length-1;s++){
      px.beginPath(); var st=false;
      for(var i=0;i<pj.length;i++){
        if(segsIdx[i]>=b[s] && segsIdx[i]<b[s+1]){
          if(!st){ if(i>0) px.moveTo(pj[i-1][0],pj[i-1][1]); else px.moveTo(pj[i][0],pj[i][1]); st=true; }
          px.lineTo(pj[i][0],pj[i][1]);
        }
      }
      px.strokeStyle=relayHexN(s,L[s]); px.stroke();
    }
    var t=document.createElement('canvas'); t.width=1000; t.height=1000;
    var x=t.getContext('2d'); x.drawImage(m,0,0);
    x.globalCompositeOperation='source-in'; x.fillStyle=state.accent; x.fillRect(0,0,1000,1000);
    x.globalCompositeOperation='source-atop'; x.drawImage(P,0,0);
    _relayArt={m:m, c:c, cv:t};
    return t;
  }

  /* ---- the relay ribbon ------------------------------------------------------
     Distance along the course on x (the changeovers are placed by distance),
     each leg's section filled in its colour, a tick at each changeover and its
     LEG n label above. The high point and the gain go under the baseline, and
     a legend row under that when the team has put names or splits in. */
  function relayTeam(){
    var L=relayLegs()||[], out=[];
    L.forEach(function(g,i){
      var n=$('cz-rlName'+g.n), t=$('cz-rlTime'+g.n);
      out.push({ n:g.n, col:relayHexN(i,g), name:((n&&n.value)||'').trim(), time:((t&&t.value)||'').trim() });
    });
    return out;
  }
  function relayHasLegend(){ return relayTeam().some(function(t){ return t.name||t.time; }); }
  /* The extra height under the ribbon, in px of an artwork W wide. */
  function relayRibExtra(W){
    if(!relayIsTeam()) return 0;
    return W*0.030 + (relayHasLegend() ? W*0.036+(relayLegRows()-1)*relayLegStep(W) : 0);
  }
  function relayRibbon(ctx,lx,rx,top,h,W){
    var c=state.coords, e=state.eles, cum=relayCum(c);
    if(!cum || !e || e.length!==c.length) return false;
    var fx=[], fy=[], mn=1/0, mx=-1/0, i;
    for(i=0;i<e.length;i++){ if(!isFinite(e[i])) continue; fx.push(cum[i]); fy.push(e[i]); if(e[i]<mn)mn=e[i]; if(e[i]>mx)mx=e[i]; }
    if(fx.length<3) return false;
    var span=(mx-mn)||1, L=relayLegs(), cuts=relayCuts(), b=[0].concat(cuts).concat([1]);
    var X=function(f){ return lx+(rx-lx)*f; }, Y=function(v){ return top+h-((v-mn)/span)*h; };
    function prof(){ ctx.beginPath(); for(var j=0;j<fx.length;j++){ var x=X(fx[j]), y=Y(fy[j]); j?ctx.lineTo(x,y):ctx.moveTo(x,y); } }
    ctx.save();
    for(var s=0;s<b.length-1;s++){
      ctx.save(); ctx.beginPath(); ctx.rect(X(b[s]), top-h, X(b[s+1])-X(b[s]), h*2+2); ctx.clip();
      prof(); ctx.lineTo(X(fx[fx.length-1]),top+h); ctx.lineTo(X(fx[0]),top+h); ctx.closePath();
      ctx.fillStyle=relayHexN(s,L[s]); ctx.fill(); ctx.restore();
    }
    prof(); ctx.strokeStyle='#17171A'; ctx.lineWidth=Math.max(1,W*0.0016); ctx.lineJoin='round'; ctx.stroke();
    ctx.beginPath(); ctx.moveTo(lx,top+h); ctx.lineTo(rx,top+h);
    ctx.strokeStyle='#cfc9bc'; ctx.lineWidth=Math.max(1,W*0.0012); ctx.stroke();
    /* the changeovers */
    ctx.strokeStyle='#17171A'; ctx.lineWidth=Math.max(1,W*0.0012);
    for(i=0;i<cuts.length;i++){ var tx=X(cuts[i]); ctx.beginPath(); ctx.moveTo(tx,top-W*0.004); ctx.lineTo(tx,top+h); ctx.stroke(); }
    var mono=function(sz,wt){ return (wt||400)+' '+sz+'px "Roboto Mono",ui-monospace,Menlo,monospace'; };
    ctx.font=mono(W*0.0135,500); ctx.fillStyle='#17171A'; ctx.textAlign='center';
    for(s=0;s<b.length-1;s++) ctx.fillText('LEG '+L[s].n, (X(b[s])+X(b[s+1]))/2, top-W*0.008);
    /* high point and gain, under the baseline */
    var ly=top+h+W*0.0195;
    ctx.fillStyle='#8d8a85'; ctx.font=mono(W*0.0155,400);
    ctx.textAlign='left';  ctx.fillText(summitVal('')||(Math.round(mx)+' M'), lx, ly);
    var _rg=gainVal(''); if(_rg){ ctx.textAlign='right'; ctx.fillText(_rg+' GAIN', rx, ly); }
    /* the team, one column per leg */
    var T=relayTeam();
    if(T.some(function(t){ return t.name||t.time; })){
      var rows=relayLegRows(), per=Math.ceil(T.length/rows), cw=(rx-lx)/per, gy0=ly+W*0.030, gap=W*0.006;
      var fmin=IS_GAL?galFloor(W):W*0.006, chip=Math.max(W*0.012,fmin*0.9);
      ctx.textAlign='left';
      T.forEach(function(t,k){
        var x0=lx+cw*(k%per), gy=gy0+Math.floor(k/per)*relayLegStep(W);
        ctx.fillStyle=t.col; ctx.fillRect(x0, gy-chip*0.92, chip, chip);
        if(relayLight(t.col)){ ctx.strokeStyle=RELAY_EDGE; ctx.lineWidth=Math.max(1,W*0.0010); ctx.strokeRect(x0, gy-chip*0.92, chip, chip); }
        var txt=['LEG '+t.n, t.name.toUpperCase(), t.time.toUpperCase()].filter(Boolean).join(' · ');
        var fs=Math.max(W*0.0125,fmin), room=cw-chip-gap-W*0.010, g=0;
        ctx.font=mono(fs,500);
        while(ctx.measureText(txt).width>room && fs>fmin && g++<60){ fs=Math.max(fmin,fs*0.95); ctx.font=mono(fs,500); }
        ctx.fillStyle='#17171A'; ctx.fillText(txt, x0+chip+gap, gy);
      });
    }
    ctx.textAlign='left';
    ctx.restore();
    return true;
  }

  /* ---- the order -------------------------------------------------------- */
  function relayProps(p){
    var o=relayOpt(); if(!o) return;
    p['Option']= o==='solo' ? 'Solo' : (o==='relay' ? 'Relay' : ('Leg '+o));
    if(o!=='relay') return;
    if(p['Name']){ p['Team name']=p['Name']; delete p['Name']; }
    if(p['Time']){ p['Team time']=p['Time']; delete p['Time']; }
    relayTeam().forEach(function(t){
      if(t.name) p['Leg '+t.n+' runner']=t.name;
      if(t.time) p['Leg '+t.n+' split']=t.time;
    });
  }

  /* ---- the page: the option picker, the team's fields ------------------- */
  var _relayNameLbl=null, _relayTimeLbl=null;
  function relayBuild(){
    var L=relayLegs(); if(!L || $('cz-relayteam')) return;
    if(!document.getElementById('cz-relaycss')){
      var css=document.createElement('style'); css.id='cz-relaycss';
      css.textContent='.cz-relaypick{margin:14px 0 6px}.cz-relaypick .cz-lbl{display:block;margin-bottom:7px}'
        +'.cz-relayopts{display:flex;flex-direction:column;gap:6px}'
        +'.cz-relayopt{display:flex;align-items:center;gap:10px;text-align:left;padding:10px 12px;border:1.5px solid #d9d5cc;'
        +'border-radius:10px;background:#fff;font:600 14px/1.3 Inter,system-ui,sans-serif;color:#17171A;cursor:pointer}'
        +'.cz-relayopt.cz-on{border-color:#17171A;box-shadow:0 0 0 1px #17171A inset}'
        +'.cz-relaychip{width:14px;height:14px;border-radius:3px;flex:0 0 14px;background:#cfc9bc}'
        +'.cz-relaychip.cz-split{background:linear-gradient(90deg,#FFD028 0 25%,#FF5A1F 25% 50%,#FF2D9A 50% 75%,#8B5CF6 75%)}'
        +'.cz-relayteam{margin:12px 0 4px;padding:12px;border:1px solid #e4e0d8;border-radius:10px}'
        +'.cz-relayteam .cz-hint{margin:0 0 8px}'
        +'.cz-relayrow{display:grid;grid-template-columns:62px 1fr 96px;gap:8px;align-items:center;margin-top:7px}'
        +'.cz-relayrow b{display:flex;align-items:center;gap:6px;font:600 12.5px Inter,system-ui,sans-serif}'
        +'.cz-relayrow input{min-width:0}'
        +'.cz-relaynote{margin-top:6px}';
      document.head.appendChild(css);
    }
    /* The team: a runner and a split per leg, all optional. */
    var tm=document.createElement('div'); tm.className='cz-relayteam'; tm.id='cz-relayteam'; tm.style.display='none';
    tm.innerHTML='<span class="cz-lbl">Your team (optional)</span>'
      +'<div class="cz-hint">Each runner and their split print in a row under the elevation ribbon.</div>';
    L.forEach(function(g,i){
      var r=document.createElement('div'); r.className='cz-relayrow';
      r.innerHTML='<b><span class="cz-relaychip" style="background:'+relayHexN(i,g)+'"></span>Leg '+g.n+'</b>'
        +'<input type="text" id="cz-rlName'+g.n+'" maxlength="22" placeholder="Runner" aria-label="Leg '+g.n+' runner">'
        +'<input type="text" id="cz-rlTime'+g.n+'" maxlength="9" placeholder="1:52:30" aria-label="Leg '+g.n+' split">';
      tm.appendChild(r);
    });
    var nr=$('cz-nameRow'), host=nr&&nr.parentNode;
    if(host) host.insertBefore(tm, nr.nextSibling);
    else { var dt=$('cz-editDetails')||root; dt.appendChild(tm); }
    Array.prototype.forEach.call(tm.querySelectorAll('input'),function(el){
      el.addEventListener('input',function(){
        /* The legend adds height under the ribbon, and Gallery's map panel is
           measured from it. */
        render();
      });
    });
    /* Gallery: the photo note for a team shot. */
    var gh=$('cz-galHint');
    if(gh && gh.parentNode){
      var nt=document.createElement('div'); nt.className='cz-hint cz-relaynote'; nt.id='cz-relaynote'; nt.style.display='none';
      nt.textContent=(L.length===2) ? 'Upload a portrait or square photo of the two of you. Wide shots get cropped.'
                                    : 'Upload a portrait photo: four people in two rows works best. Wide group shots get cropped.';
      gh.parentNode.insertBefore(nt, gh.nextSibling);
    }
    relaySyncUI();
  }
  function relaySyncUI(){
    if(!$('cz-relayteam')) return;
    var o=relayOpt();
    var team=(o==='relay');
    var tm=$('cz-relayteam'); if(tm) tm.style.display=team?'':'none';
    var nt=$('cz-relaynote'); if(nt) nt.style.display=(team && IS_GAL)?'':'none';
    var nl=$('cz-nameRow'), ns=nl&&nl.querySelector('.cz-lbl');
    if(ns){ if(_relayNameLbl===null) _relayNameLbl=ns.textContent; ns.textContent=team?'Team name':_relayNameLbl; }
    var th=$('cz-h'), tf=th&&th.closest('.cz-fld'), tl=tf&&tf.querySelector('.cz-lbl'), tn=tl&&tl.firstChild;
    if(tn && tn.nodeType===3){ if(_relayTimeLbl===null) _relayTimeLbl=tn.nodeValue; tn.nodeValue=team?'Team time ':_relayTimeLbl; }
    /* No upload on the relay in v1: it always draws the course files. */
    var cl=$('cz-clear'); if(cl && team) cl.style.display='none';
    else if(cl && o && state.locked) cl.style.display='block';
  }
  /* /pages/<handle> - the handle is deliberately the same string as the route
     Code, so an event page needs no query string at all. */
  /* Both shapes, because an event link should be able to be either. A product
     named for the event gives the short URL AND product mode; a page gives the
     short URL and the stacked layout. Neither is a promise - a handle is a
     guess, so a miss is silent (only an explicit ?r= is reported). */
  function pageHandle(){
    try{
      var p=(window.location&&window.location.pathname)||'';
      var m=/\/(?:pages|products)\/([^\/?#]+)/.exec(p);
      return m?decodeURIComponent(m[1]):'';
    }catch(e){ return ''; }
  }
  /* An explicit ?r=, ?gpx=, ?name= or ?race=, or an event page handle, is a
     stronger statement of intent than the product's own default route. Named
     rather than inline because the first-paint poster has to ask exactly the
     same question - it is a picture of the right run only while the product's
     own route is the one being drawn - and two copies of this test would drift
     apart silently, leaving a poster of somebody else's marathon. */
  function routeOverridden(){
    return !!(getParam('gpx')||getParam('name')||getParam('race')||currentRoute());
  }
  function currentRoute(){
    /* An explicit ?r= is the whole answer, hit or miss. Only when there is no
       ?r= at all does the handle get a say - otherwise a dead link would be
       reported to the customer and silently honoured at the same time. */
    var rc=(getParam('r')||'').trim();
    if(rc) return routeByCode(rc);
    return routeByCode(pageHandle());
  }
  var _evTitle='', _evBlurb='', _pmTitle0=null, _pmDesc0=null;
  function captureProductCopy(){
    if(_pmTitle0!==null) return;
    var t=$('cz-pmtitle'), d=$('cz-pmdesc');
    _pmTitle0 = t ? t.textContent : '';
    _pmDesc0  = d ? d.innerHTML  : '';
  }
  /* The event's own headline and blurb replace the generic product copy.
     Plain text, not HTML - this comes from a metaobject field, and pre-line
     turns its blank lines into paragraph breaks without an injection surface. */
  function applyRouteCopy(r){
    captureProductCopy();
    _evTitle=(r&&r.headline||'').trim(); _evBlurb=(r&&r.blurb||'').trim();
    var t=$('cz-pmtitle'), d=$('cz-pmdesc');
    if(t && _evTitle) t.textContent=_evTitle;
    if(d && _evBlurb){ d.style.whiteSpace='pre-line'; d.textContent=_evBlurb; }
  }
  function restoreProductCopy(){
    _evTitle=''; _evBlurb='';
    var t=$('cz-pmtitle'), d=$('cz-pmdesc');
    if(t && _pmTitle0!==null) t.textContent=_pmTitle0;
    if(d && _pmDesc0!==null){ d.style.whiteSpace=''; d.innerHTML=_pmDesc0; }
  }
  function _dkey(r){ var m=/^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(r.date||''); return m?((+m[1])*10000+(+m[2])*100+(+(m[3]||0))):0; }
  /* Blank, 0, a stray '' or anything non-numeric all mean "not pinned". Only a
     positive number puts a route in the rail, and that number is its order. */
  var FAV_MAX=8;
  function routeRank(r){
    var n=parseInt((r&&r.rank)||0,10);
    return (isFinite(n) && n>0) ? n : 0;
  }
  function favList(items){
    return items.filter(routeRank).sort(function(a,b){
      var d=routeRank(a)-routeRank(b);
      /* Same number twice is a typo, not an intent - fall back to the list's
         own newest-first order rather than leaving it to sort stability. */
      return d || (_dkey(b)-_dkey(a));
    }).slice(0,FAV_MAX);
  }
  function buildRoutePicker(){
    /* your-route joins iconic here. It is built but left hidden - the customer
       reaches it from the Browse routes link rather than being shown it first,
       because on a your-route product uploading is still the main path. */
    if(!((PM && (PM_FAM==='iconic'||PM_FAM==='your-route')) || (!PM && PICKER_FIRST))) return;
    var pick=document.getElementById('cz-routepick');
    if(!pick){ pick=document.createElement('div'); pick.id='cz-routepick'; pick.className='cz-routepick';
      var intro=root.querySelector('.cz-intro');
      if(intro&&intro.parentNode){ intro.parentNode.insertBefore(pick,intro.nextSibling); } else { root.insertBefore(pick,root.firstChild); } }
    pick.innerHTML='';
    var hdrow=document.createElement('div'); hdrow.className='cz-rhdrow';
    var hd=document.createElement('div'); hd.className='cz-rhd'; hd.textContent='Choose your route'; hdrow.appendChild(hd);
    pick.appendChild(hdrow);

    var items=(ROUTES_CAT||[]).filter(function(r){ return r.gpx||r.img||(r.legs&&((r.legs.ride||{}).gpx||(r.legs.ride||{}).poly)); });
    items.sort(function(a,b){ return _dkey(b)-_dkey(a); });
    if(!items.length){ var e0=document.createElement('div'); e0.className='cz-rempty'; e0.textContent='Routes coming soon.'; pick.appendChild(e0);
      var up0=uploadCardEl(); if(up0) pick.appendChild(up0); return; }

    /* Controls are built ONCE. Only the results list below is re-rendered as
       you type - rebuilding this row would drop focus on every keystroke. */
    var ctl=document.createElement('div'); ctl.className='cz-rctl';
    var sw=document.createElement('div'); sw.className='cz-rsearchwrap';
    var si=document.createElement('input'); si.type='search'; si.id='cz-rsearch';
    si.className='cz-rsearch'; si.setAttribute('autocomplete','off');
    si.placeholder='Search your race\u2026'; si.value=_rQ;
    si.setAttribute('aria-label','Search routes by race name or place');
    sw.appendChild(si); ctl.appendChild(sw);

    function chipRow(label, vals, cur, onPick, nameOf){
      if(vals.length<2) return null;                 /* one option is not a filter */
      var row=document.createElement('div'); row.className='cz-rchips';
      var lb=document.createElement('span'); lb.className='cz-rchiplb'; lb.textContent=label; row.appendChild(lb);
      var mk=function(v,txt){
        var b=document.createElement('button'); b.type='button';
        b.className='cz-rchip'+(cur===v?' cz-on':''); b.textContent=txt;
        b.setAttribute('aria-pressed', cur===v?'true':'false');
        b.addEventListener('click',function(){ onPick(cur===v?'':v); });
        row.appendChild(b);
      };
      mk('','All');
      vals.forEach(function(v){ mk(v, nameOf ? nameOf(v) : (v||'Other')); });
      return row;
    }
    /* Only offer values that actually have routes behind them. */
    var stAll=[], bdAll=[], spAll=[];
    items.forEach(function(r){
      var sk=routeSport(r); if(spAll.indexOf(sk)<0) spAll.push(sk);
      var st=routeState(r); if(st && stAll.indexOf(st)<0) stAll.push(st);
      var bd=routeBand(r);  if(bd && bdAll.indexOf(bd)<0) bdAll.push(bd);
    });
    stAll.sort();
    var SP_ORDER=['run','run5k','trail','cycle','hike','swim','tri'];
    spAll.sort(function(a,b){ return SP_ORDER.indexOf(a)-SP_ORDER.indexOf(b); });
    bdAll.sort(function(a,b){ var o=['5K','10K','Half','Marathon','Ultra'];
      return o.indexOf(a)-o.indexOf(b); });

    var results=document.createElement('div'); results.id='cz-rresults';

    function rerenderChips(){
      var old=ctl.querySelectorAll('.cz-rchips');
      for(var i=0;i<old.length;i++) old[i].parentNode.removeChild(old[i]);
      var c0=chipRow('Sport', spAll, _rSport, function(v){ _rSport=v; rerenderChips(); draw(); },
                     function(v){ return (SPORTS[v]||{}).name || (v==='tri'?'Triathlon':v); });
      if(c0) ctl.appendChild(c0);
      var c1=chipRow('State', stAll, _rState, function(v){ _rState=v; rerenderChips(); draw(); });
      if(c1) ctl.appendChild(c1);
      var c2=chipRow('Distance', bdAll, _rBand, function(v){ _rBand=v; rerenderChips(); draw(); });
      if(c2) ctl.appendChild(c2);
    }

    function matches(r){
      if(_rSport && routeSport(r)!==_rSport) return false;
      if(_rState && routeState(r)!==_rState) return false;
      if(_rBand && routeBand(r)!==_rBand) return false;
      if(_rQ){
        var hay=((r.name||'')+' '+(r.loc||'')+' '+(r.dist||'')).toLowerCase();
        var terms=_rQ.toLowerCase().split(/\s+/).filter(Boolean);
        for(var t=0;t<terms.length;t++){ if(hay.indexOf(terms[t])<0) return false; }
      }
      return true;
    }
    function card(r){
      var b=document.createElement('button'); b.type='button'; b.className='cz-rcard';
      var im=(r.img||'').replace(/'/g,"%27");
      b.innerHTML='<span class="cz-rcimg"'+(im?' style="background-image:url(\''+im+'\')"':'')+'></span>'
        +'<span class="cz-rcname"></span><span class="cz-rcmeta"></span>';
      b.querySelector('.cz-rcname').textContent=r.name||'Route';
      var _rs=routeSport(r);
      b.querySelector('.cz-rcmeta').textContent=[(_rs==='tri'?'Triathlon':(_rs!=='run'?SPORTS[_rs].name:'')),r.loc,r.dist].filter(Boolean).join(' \u00b7 ');
      b.addEventListener('click',function(){ selectRoute(r); });
      return b;
    }
    function favBand(){
      /* Filtering on -> no band. A "popular" row above filtered results
         misreports what matched, exactly as month headers would. */
      var favs=favList(items); if(!favs.length) return null;
      var w=document.createElement('div'); w.className='cz-rfav';
      var hd=document.createElement('div'); hd.className='cz-rfavhd';
      var b=document.createElement('b'); b.textContent='Popular races'; hd.appendChild(b);
      var sp=document.createElement('span'); sp.textContent='the ones most people are looking for';
      hd.appendChild(sp); w.appendChild(hd);
      var rail=document.createElement('div'); rail.className='cz-rfavrail';
      favs.forEach(function(r){ rail.appendChild(card(r)); });
      w.appendChild(rail);
      var sep=document.createElement('div'); sep.className='cz-rfavsep'; w.appendChild(sep);
      return w;
    }
    function draw(){
      results.innerHTML='';
      var hits=items.filter(matches), filtering=!!(_rQ||_rState||_rBand||_rSport);
      if(!hits.length){
        var ne=document.createElement('div'); ne.className='cz-rempty';
        ne.textContent='No route matches that. Try the race\u2019s suburb or city, clear the filters, or upload your own GPX below.';
        results.appendChild(ne); return;
      }
      if(filtering){
        /* Month headers are noise once a filter is on - show a flat list and
           say how many matched. */
        var cnt=document.createElement('div'); cnt.className='cz-rcount';
        cnt.textContent=hits.length+(hits.length===1?' route':' routes');
        results.appendChild(cnt);
        var g=document.createElement('div'); g.className='cz-rcards';
        hits.forEach(function(r){ g.appendChild(card(r)); });
        results.appendChild(g); return;
      }
      /* Pinned routes stay in the month list below as well - the rail is a
         shortcut, not a move, or browsing by date loses the big races. */
      var fb=favBand(); if(fb) results.appendChild(fb);
      var curKey=null, cards=null;
      hits.forEach(function(r){ var d=_ym(r), key=d.y+'-'+d.mo;
        if(key!==curKey){ curKey=key;
          var h=document.createElement('div'); h.className='cz-rgrouphd';
          h.textContent=(d.mo?fmtMonth(d.mo)+' ':'')+(d.y||'Other'); results.appendChild(h);
          cards=document.createElement('div'); cards.className='cz-rcards'; results.appendChild(cards); }
        cards.appendChild(card(r));
      });
    }

    var _deb=0;
    si.addEventListener('input',function(){
      _rQ=si.value.trim();
      if(_deb) clearTimeout(_deb);
      _deb=setTimeout(draw,90);           /* keystrokes coalesce; focus is kept */
    });
    si.addEventListener('search',function(){ _rQ=si.value.trim(); draw(); });

    rerenderChips();
    pick.appendChild(ctl);
    var upc=uploadCardEl(); if(upc) pick.appendChild(upc);
    pick.appendChild(results);
    draw();
  }
  /* The route entry's Design: a code, or the name the store shows. */
  function designKey(v){
    v=String(v||'').trim().toLowerCase().replace(/[\s_]+/g,'-');
    var A={'neon':'base','base':'base','street-map':'editorial','streetmap':'editorial','map':'editorial','editorial':'editorial',
           'terrain':'terrain','gallery':'gallery','full-photo':'photo-overlay','photo':'photo-overlay','photo-overlay':'photo-overlay',
           'route-photo':'photo-split','photo-split':'photo-split','statbar':'statbar','stat-bar':'statbar',
           'manifesto':'manifesto','rings':'rings','dashboard':'dashboard','cover':'cover','cover-story':'cover',
           'card':'card','trading-card':'card','horizon':'horizon','horizon-split':'horizon',
           '3d':'3d','3d-map':'3d','flyover':'3d','skyline':'3d'};
    return A[v]||'';
  }
  /* Where a picked route opens: its own ?r= link. */
  function routePickUrl(r){
    if(!r || !r.code) return '';
    if(IS_TRI){
      var _tq=''; try{ var _tf=focusProd(); if(PM && _tf!==PM_FMT) _tq='&product='+encodeURIComponent(_tf); }catch(e){}
      return ((window.location&&window.location.pathname)||'')+'?r='+encodeURIComponent(r.code)+_tq;
    }
    if(isTriRoute(r) && !(typeof IS_TRI!=='undefined' && IS_TRI)) return triRouteUrl(r);
    /* A 5K Run route opens on Stat Bar's product. */
    if(isRun5kRoute(r) && !pageIsSb()) return run5kRouteUrl(r);
    var d=designKey(r.design);
    var want=d ? (d==='base'?'':d) : null;
    var base=(window.location&&window.location.pathname)||'';
    /* iconic-route has no upload, so a pick opens the your-route twin (same
       format and design), where the customer can still swap in their own GPX.
       The route's Design is applied there from ?r=. */
    var _yr='';
    try{ if(PM && PM_FAM==='iconic' && UPLOAD_LINK) _yr=String(UPLOAD_LINK).split('?')[0].split('#')[0]; }catch(e){}
    if(_yr) base=_yr;
    else if(want!==null && want!==(DESIGN_KIND||'')){ try{ var ks=kindList(); for(var i=0;i<ks.length;i++){
      if((ks[i].kind||'')===want && ks[i].url){ base=String(ks[i].url).split('?')[0].split('#')[0]; break; } } }catch(e){} }
    var q='r='+encodeURIComponent(r.code);
    /* The section's "A picked route opens on" product (your-route-gallery-
       poster by default). A poster product, so any other format the customer
       is shopping goes along as &product=. */
    var _pk=''; try{ _pk=String(MSC[106]||'').trim(); }catch(e){}
    /* The design the customer chose outranks the route's own: an explicit
       ?design= (the design tiles carry one), else this product's own design
       when it is not the Neon default. */
    var _ch=null, _pkind='';
    try{
      if(PM){
        var _praw=String(MSC[10]||'').trim().toLowerCase();
        _pkind=(_praw==='neon'||_praw==='base')?'':_praw;
        var _dpar=getParam('design');
        if(_dpar){ var _dk=designKey(_dpar); if(_dk) _ch=(_dk==='base'?'':_dk); }
        /* Any design set on the product counts - Neon included. Only a
           product with no design_kind at all is "no design chosen". */
        else if(_praw) _ch=_pkind;
      }
    }catch(e){ _ch=null; }
    if(_ch!==null){
      var _ks=KIND_STYLE_ALL[_ch]||'neon', _rs=String(r.style||'').trim().toLowerCase();
      var _st=(_rs && _rs.split(':')[0]===_ks) ? _rs : _ks;
      var _dq=q+'&design='+(_ch||'neon')+'&style='+_st;
      var _tw='';
      if(_ch===_pkind){
        try{ _tw=(PM_FAM==='iconic') ? (UPLOAD_LINK?String(UPLOAD_LINK).split('?')[0].split('#')[0]:'')
                                      : ((window.location&&window.location.pathname)||''); }catch(e){ _tw=''; }
      }
      var _f1=''; try{ _f1=String(focusProd()||''); }catch(e){}
      if(_tw) return _tw+'?'+_dq+((_f1 && _f1!==PM_FMT)?'&product='+encodeURIComponent(_f1):'');
      if(_pk && _pk.charAt(0)==='/')
        return _pk.split('?')[0].split('#')[0]+'?'+_dq+((_f1 && _f1!=='poster')?'&product='+encodeURIComponent(_f1):'');
    }
    if(_pk && _pk.charAt(0)==='/'){
      var _fp=''; try{ _fp=String(focusProd()||''); }catch(e){}
      return _pk.split('?')[0].split('#')[0]+'?'+q+((_fp && _fp!=='poster')?'&product='+encodeURIComponent(_fp):'');
    }
    try{ if(PM && focusProd()!==PM_FMT) q+='&product='+encodeURIComponent(focusProd()); }catch(e){}
    return base+'?'+q;
  }
  function selectRoute(r){
    var _lk=routePickUrl(r);
    if(_lk){ try{ window.location.href=_lk; return; }catch(e){} }
    /* No Code: load it here, and take any old ?r= off the address so
       currentRoute() stops answering with the previous route. */
    forgetRouteParam();
    /* The route's sport before its map is fetched - the line's colour is in
       the map request. */
    try{ setSport(r.sport||'run','route'); syncSportRow(); }catch(e){}
    applyRouteCopy(r);
    applyEvent({ gpx:r.gpx, poly:r.poly, name:r.name, loc:r.loc, dist:r.dist, date:r.date, img:r.img });
    showPicker(false);
    if(EVENT) renderShow(); else render();
    updateAlsoLinks();
    try{ window.scrollTo({top:0,behavior:'smooth'}); }catch(e){}
  }
  function ensureBack(){
    /* iconic only. your-route has its own row (#cz-yrow) built by pmLayout, and
       building this one as well put a second, unplaced "Back to routes" at the
       top of the page. */
    if(PM && PM_FAM!=='iconic') return null;
    var b=document.getElementById('cz-rback');
    if(!b){
      var row=document.createElement('div'); row.className='cz-rrow'; row.id='cz-rrow';
      b=document.createElement('button'); b.type='button'; b.id='cz-rback'; b.className='cz-rback';
      b.textContent='\u2190 Back to routes';
      b.addEventListener('click',function(){ showPicker(true); });
      row.appendChild(b);
      var up=uploadLinkEl('cz-uplink cz-uplink-row'); if(up) row.appendChild(up);
      var host=root.querySelector('.cz-pmgrid')||root.querySelector('.cz-show');
      if(host&&host.parentNode){ host.parentNode.insertBefore(row,host); }
    }
    var row2=document.getElementById('cz-rrow'); if(row2) row2.style.display='';
    b.style.display=''; return b;
  }
  function showPicker(on){
    var pick=document.getElementById('cz-routepick'); if(pick) pick.style.display=on?'block':'none';
    var grid=root.querySelector('.cz-pmgrid'); if(grid) grid.style.display=on?'none':'';
    var show=root.querySelector('.cz-show'); if(show) show.style.display=on?'none':'';
    var back=document.getElementById('cz-rback'); if(back) back.style.display=on?'none':'';
    var brow=document.getElementById('cz-rrow'); if(brow) brow.style.display=on?'none':'flex';
    /* your-route's own row is the way BACK to the picker, so it hides while the
       picker is up and returns when it closes - same rule, its own element. */
    var yrow=document.getElementById('cz-yrow'); if(yrow) yrow.style.display=on?'none':'flex';
    /* Product title and blurb belong to the thing you're buying, not to the act
       of choosing a route, so they sit out while the picker is up and return
       once a route is chosen. */
    var ti=$('cz-pmtitle'); if(ti) ti.style.display=on?'none':'';
    var de=$('cz-pmdesc');  if(de) de.style.display=on?'none':'';
    if(!on) ensureBack();
    if(barFit) barFit();
  }
  function pmLayout(){
    /* EVENT, not PM: this function only moves elements that the event layout
       renders anyway. Anything needing a real product is guarded below. */
    if(!EVENT) return;
    var show=$('cz-show'); if(!show||!show.parentNode) return;
    if(root.querySelector('.cz-pmgrid')) return;
    var grid=document.createElement('div'); grid.className='cz-pmgrid';
    var left=document.createElement('div'); left.className='cz-pmleft';
    var right=document.createElement('div'); right.className='cz-pmright';
    grid.appendChild(left); grid.appendChild(right);
    show.parentNode.insertBefore(grid, show);
    var hero=show.querySelector('.cz-hero');
    var thumbs=$('cz-thumbs');
    var showbar=show.querySelector('.cz-showbar');
    /* The Gallery photo controls. Like everything else in .cz-show they have to
       be carried across before that block is removed at the end of this
       function - left behind, they are destroyed with it and the design has no
       way to add a photo. */
    var galRow=$('cz-galRow');
    var ep=$('cz-editPanel');
    var styleslot=$('cz-styleslot');
    var col=$('cz-editColor'), mp=$('cz-editMap');
    var det=$('cz-editDetails'), sts=$('cz-editStats');
    var desc=root.querySelector('.cz-pmdesc');
    var upStep=null;
    if(PM_FAM==='your-route'){ var up=$('cz-drop'); upStep=up?up.closest('.cz-step'):null; }
    if(upStep) upStep.classList.add('cz-pmupload');
    if(styleslot) right.appendChild(styleslot);
    if(col) right.appendChild(col);
    if(mp) right.appendChild(mp);
    /* The photo button above the preview, so the preview and its mockups
       below it stay together (25 Oct, Marc). */
    if(galRow) right.appendChild(galRow);
    var _rail=null;
    if(hero){
      var stage=document.createElement('div'); stage.className='cz-pmstage';
      _rail=document.createElement('div'); _rail.className='cz-pmrail'; _rail.id='cz-pmrail';
      stage.appendChild(hero);
      if(ALT_RAIL) stage.appendChild(_rail);
      right.appendChild(stage);
    }
    /* Directly under the preview, where the medal it is talking about is. */
    var _fn=document.createElement('p');
    _fn.className='cz-framenote'; _fn.id='cz-framenote';
    _fn.textContent = FRAME_NOTE;
    _fn.style.display='none';
    right.appendChild(_fn);
    if(thumbs) right.appendChild(thumbs);
    if(showbar) right.appendChild(showbar);
    /* Below the buy bar, so the preview is not competing with three smaller
       previews of itself - and on mobile, where .cz-pmstage is sticky, the
       preview gets the full width back. */
    if(!ALT_RAIL && _rail){
      var alt=document.createElement('div'); alt.className='cz-pmalt'; alt.id='cz-pmalt';
      var ah=document.createElement('div'); ah.className='cz-pmalth'; ah.textContent=ALT_TITLE;
      alt.appendChild(ah); alt.appendChild(_rail);
      right.appendChild(alt);
    }

    var titleEl=$('cz-pmtitle');
    if(titleEl) left.appendChild(titleEl);
    if(desc) left.appendChild(desc);
    if(PM_FAM==='your-route'){
      /* The mirror of iconic's "Back to routes": a your-route customer can
         upload a GPX, but they should also be able to pick a catalogue route
         without leaving the product. Same row, same styling. */
      var _yrow=document.createElement('div'); _yrow.className='cz-rrow'; _yrow.id='cz-yrow';
      var _yb=document.createElement('button'); _yb.type='button'; _yb.className='cz-rback';
      _yb.textContent=IS_TRI?'\u2190 Browse race courses':'\u2190 Browse iconic routes';
      if(!evBackLink(_yb)) _yb.addEventListener('click',function(){ showPicker(true); });
      _yrow.appendChild(_yb);
      left.appendChild(_yrow);
    }
    if(PM_FAM==='iconic'){
      var _brow=document.createElement('div'); _brow.className='cz-rrow'; _brow.id='cz-rrow';
      var _bk=document.createElement('button'); _bk.type='button'; _bk.id='cz-rback'; _bk.className='cz-rback'; _bk.textContent='\u2190 Back to routes'; if(!evBackLink(_bk)) _bk.addEventListener('click',function(){ showPicker(true); });
      _brow.appendChild(_bk);
      var _up=uploadLinkEl('cz-uplink cz-uplink-row'); if(_up) _brow.appendChild(_up);
      _brow.style.display='none';
      left.appendChild(_brow);
    }
    if(upStep) left.appendChild(upStep);
    if(det) left.appendChild(det);
    if(sts) left.appendChild(sts);
    kindStripSoon();

    var introEl=root.querySelector('.cz-intro');
    if(introEl){ var _epk=$('cz-eventpick');
      if(!_epk || !_epk.children.length){ introEl.style.padding='0'; grid.classList.add('cz-pmtop'); } }
    if(ep) ep.style.display='none';
    if(show.parentNode) show.parentNode.removeChild(show);
  }
  function initShow(){
    if(!EVENT) return;
    if(PM){
      VARIANTS[PM_FMT] = String(PM_VARIANT);
      if(PM_SIBS){ PM_ORDER.forEach(function(f){ var s=PM_SIBS[f]; if(s&&s.vid) VARIANTS[f]=String(s.vid); }); }
      PM_ORDER.forEach(function(f){
        var vs=(PM_SIBS&&PM_SIBS[f]&&PM_SIBS[f].variants) || (PM_FMT===f?PM_VARIANTS:null);
        if(vs&&vs.length>1) PVARS[f]=vs.map(function(v){
          return {id:v.id, title:v.title, available:v.available, price:v.price}; });
      });
      buildSizePicker();
    }
    buildEventPicker();
    if(!PM){ var wantP=evGet('product'); var wi=RING.indexOf(wantP); if(wi>=0) focusIdx=wi; }   
    var slot=$('cz-styleslot'), tabs=$('cz-styles');   
    if(slot&&tabs) slot.appendChild(tabs);
    if(tabs) tabs.addEventListener('click',function(e){ var t=e.target.closest('.cz-tab'); if(!t||t.disabled)return;
      var s=t.getAttribute('data-s'), ld=$('cz-heroLoad');       
      /* selectStyle() has already run: a cached map is drawn by now, and an
         overlay put up after it would never come down. */
      var _have=false; try{ _have=!!(state.mapImg && state.mapUrl && state.mapUrl===mapUrlFor()); }catch(e){}
      if(ld){ if((s==='map'||s==='terrain')&&state.coords&&!_have){ ld.textContent=s==='terrain'?'Building terrain…':'Loading map…'; ld.style.display='flex'; } else { ld.style.display='none'; } }
    });
    var sl=$('cz-sideL'); if(sl) sl.onclick=function(){ setFocus(RING.indexOf(neighbour(-1))); };
    var sr=$('cz-sideR'); if(sr) sr.onclick=function(){ setFocus(RING.indexOf(neighbour(1))); };
    var add=$('cz-showAdd'); if(add) add.onclick=function(){ state.product=focusProd(); doAdd($('cz-showAdd'),$('cz-showErr')); };
    
    var ep=$('cz-editPanel');
    if(ep){
      var det=$('cz-editDetails'), tt=$('cz-title'), lc=$('cz-loc');
      if(det){ var tl=tt&&tt.closest('label'); if(tl) det.appendChild(tl);
               var ll=lc&&lc.closest('label'); if(ll) det.appendChild(ll);
               /* The name row lives in .cz-grid, which product mode hides, so it
                  has to come across with the other two or it is never seen. */
               var nl=$('cz-nameRow'); if(nl) det.appendChild(nl); }
      var stg=$('cz-editStats'), opt=$('cz-opt'); if(stg&&opt){ opt.classList.add('cz-show'); stg.appendChild(opt); }
      var col=$('cz-editColor'), pal=$('cz-pal'); if(col&&pal) col.appendChild(pal);
      palBottom();   /* 30 Oct: after the stats instead */
      var mp=$('cz-editMap'), ms=$('cz-mstyles'); if(mp&&ms) mp.appendChild(ms);
      var ts3=$('cz-tstyles'); if(mp&&ts3) mp.appendChild(ts3);
    }
    if(PM && typeof updateStyleHint==='function') updateStyleHint();
    var cust=$('cz-customize');
    if(cust){ cust.onclick=function(e){ if(e&&e.preventDefault) e.preventDefault();
      var open = ep && ep.style.display==='none';
      if(ep) ep.style.display=open?'block':'none';
      cust.textContent=open?'Hide Customizer':'Customize';
      var root=ep&&ep.closest('.cz-root'); if(root) root.classList.toggle('cz-editing', open);   
      if(open){ updateStyleHint();                       
        if(ep){ ep.scrollTop=0; }                        
      }
    }; }
    renderShow();

  /* ---- sticky mobile buy bar -------------------------------------------
     Lives here rather than in the section so it cannot be lost to a missing
     stylesheet, and is appended to <body> because position:fixed resolves
     against any ancestor carrying a transform, filter or containment.
     barFit is declared at module scope - renderShow() calls it. */
  function buyBar(){
    if(document.getElementById('cz-stickybuy')) return;
    /* both buttons exist on a showroom page; cz-showAdd is the live one */
    var real=$('cz-showAdd')||$('cz-add');
    if(!real){ console.warn('Milestone: buy bar found no add button to bind to.'); return; }
    var bar=document.createElement('div'); bar.id='cz-stickybuy';
    bar.style.cssText='position:fixed;left:0;right:0;bottom:0;z-index:2147483000;'+
      'display:none;align-items:center;gap:12px;padding:10px 16px;'+
      'padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));'+
      'background:rgba(243,239,231,.97);border-top:1px solid #ddd7ca;'+
      'box-shadow:0 -4px 18px rgba(0,0,0,.12);'+
      'font:600 15px/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif';
    var amt=document.createElement('span');
    amt.style.cssText='font-weight:800;font-size:17px;color:#17171A;white-space:nowrap';
    var btn=document.createElement('button'); btn.type='button'; btn.textContent='Add to cart';
    btn.style.cssText='flex:1;padding:14px;border:0;border-radius:11px;background:'+ACCENTS[0].hex+';'+
      'color:#fff;font:inherit;font-weight:700;font-size:15px;cursor:pointer';
    bar.appendChild(amt); bar.appendChild(btn);
    document.body.appendChild(bar);

    var src=$('cz-showAmt')||$('cz-price');
    function sync(){ amt.textContent=(src&&src.textContent||'').trim(); }
    sync();
    if(src&&window.MutationObserver){
      new MutationObserver(sync).observe(src,{childList:true,characterData:true,subtree:true});
    }
    function mirror(){
      var b=$('cz-showAdd')||$('cz-add'); if(!b) return;
      var txt=(b.textContent||'').trim();
      if(txt && btn.textContent!==txt) btn.textContent=txt;
      if(btn.disabled!==!!b.disabled) btn.disabled=!!b.disabled;
      btn.style.opacity=btn.disabled?'.6':'';
    }
    if(window.MutationObserver && real){
      new MutationObserver(mirror).observe(real,
        {childList:true,characterData:true,subtree:true,
         attributes:true,attributeFilter:['disabled']});
    }
    mirror();
    btn.addEventListener('click',function(){
      ($('cz-showAdd')||$('cz-add')||real).click();
      setTimeout(function(){
        var e=$('cz-showErr')||$('cz-addErr');   /* showroom errors first */
        if(e&&e.textContent.trim()) e.scrollIntoView({block:'center',behavior:'smooth'});
      },80);
    });
    function czVisible(){
      var g=root.querySelector('.cz-pmgrid');
      if(g) return getComputedStyle(g).display!=='none';
      var s=$('cz-show');
      return !s || getComputedStyle(s).display!=='none';
    }
    var lastOn=null;
    function fit(){
      var on=window.innerWidth<=820 && czVisible();
      if(on===lastOn) return;
      lastOn=on;
      bar.style.display=on?'flex':'none';
      document.documentElement.style.scrollPaddingBottom=on?'86px':'';
      document.body.style.paddingBottom=on?'86px':'';
    }
    barFit=fit; fit(); window.addEventListener('resize',function(){ lastOn=null; fit(); });
    /* layout can settle after boot, so re-check a couple of times */
    [0,300,1200].forEach(function(ms){ setTimeout(fit,ms); });
  }
  try{ buyBar(); }catch(e){ console.warn('Milestone: buy bar failed',e); }

  }

  function slides(){
    /* Flat preview leads on every format - the customer's own design is
       what they came to see, not the blank. */
    var a = ['flat',{m:0}];
    for(var i=1;i<MOCKUPS[mockKey(state.product)].length;i++){ if(mockImgs[mockKey(state.product)][i]) a.push({m:i}); }
    if(state.product==='tee' && sizeGuideImg) a.push({sg:1});
    return a; }
  function showSlide(i){ var s=slides(); if(!s.length)return;
    state.slide=((i%s.length)+s.length)%s.length; var sl=s[state.slide];
    if(sl==='flat'){ state.view='flat'; } else if(sl.sg){ state.view='sizeguide'; } else { state.view='mockup'; state.mockIdx=sl.m; }
    var lbl=$('cz-slideLabel'); if(lbl) lbl.textContent=(sl==='flat')?'Flat design':(sl.sg?'Size guide':'On product');
    buildDots(); render(); }
  function buildDots(){ var d=$('cz-dots'); if(!d)return; var s=slides(); d.innerHTML='';
    s.forEach(function(v,i){ var b=document.createElement('button'); b.type='button';
      b.className='cz-dot'+(i===state.slide?' cz-on':''); b.setAttribute('aria-label',v==='flat'?'Flat design':(v.sg?'Size guide':'On product'));
      b.addEventListener('click',function(){ showSlide(i); }); d.appendChild(b); }); }
  (function(){ var p=$('cz-prev'), n=$('cz-next');
    if(p) p.addEventListener('click',function(){ showSlide(state.slide-1); });
    if(n) n.addEventListener('click',function(){ showSlide(state.slide+1); }); })();

  (function(){ var dl=$('cz-dl'); if(!dl) return;
    /* ?preview=1 used to turn this button on for anyone who typed it, which
       handed out a 2400px render - around 205 DPI on A3, perfectly printable
       - off a page that now sells that file. The theme setting is the only
       switch, and it is off by default. */
    var showIt = dl.getAttribute('data-on')==='true';
    if(showIt) dl.style.display='';
    dl.onclick=function(){
    function doCapture(){
    try{
      var nm=($('cz-title').value||'route').replace(/\s+/g,'-').toLowerCase()+'-'+state.product+(state.style?('-'+state.style):'')+(state.view==='mockup'?'-mockup':'');
      function save(b){ if(!b)return; var a=document.createElement('a'); a.href=URL.createObjectURL(b); a.download=nm+'.png'; a.click(); }
      if(state.view==='mockup'){
        var c=document.createElement('canvas'); c.width=1400;c.height=1400; paint(c.getContext('2d'),1400,1400,false); c.toBlob(save);
      } else {
        var p=PRODUCTS[state.product], W=state.product==='poster'?2400:2000, H=Math.round(W/p.ar);
        var c2=document.createElement('canvas'); c2.width=W;c2.height=H; paint(c2.getContext('2d'),W,H,true); c2.toBlob(save);
      }
    }catch(e){ var st=$('cz-ocrStatus'); if(st){ st.className='cz-ocrstat cz-warn'; st.textContent='That view couldn’t be exported — try the flat view.'; } }
    }
    if(isMapLike(state.style)){ ensureMap(function(){ ensureMap2(doCapture); }); } else { doCapture(); }
  }; })();

  var VARIANTS={ magnet:MSC[15], poster:MSC[16], tee:MSC[17], frame:MSC[77], a4print:MSC[84],
                 digital:MSC[90] };
  var HANDLES={ magnet:MSC[18], poster:MSC[19], tee:MSC[20], frame:MSC[78], a4print:MSC[85],
                digital:MSC[91] };
  var PVARS={};                      /* format -> variants, when there is a choice */
  /* formats: not a4print,digital - one size each, so there is nothing to
     label. A format that gains a variant choice needs a word here. */
  var VLABEL={tee:'Size', magnet:'Pack', poster:'Size', frame:'Frame'};
  /* A3 and A4 are both 1:sqrt(2), so one print file serves both and nothing in
     the render pipeline changes - only the words under the price. Read from the
     variant rather than the size_spec metafield: one product now holds four
     sizes, so a single metafield cannot describe it. */
  var PSPEC={a3:'A3 \u00b7 29.7\u00d742 cm', a4:'A4 \u00b7 21\u00d729.7 cm'};
  function posterSpecFor(t){
    t=String(t||'').toLowerCase();
    var base=/\ba4\b/.test(t)?PSPEC.a4:(/\ba3\b/.test(t)?PSPEC.a3:'');
    if(!base) return '';                       /* unrecognised - say nothing */
    return base+(/fram/.test(t)?' \u00b7 framed':'');
  }
  function varsFor(p){ var v=PVARS[p||state.product]; return (v&&v.length>1)?v:null; }
  rebuildPicker=buildSizePicker;
  function buildSizePicker(){
    var sel=$('cz-size'), vs=varsFor(focusProd());
    if(!sel) return;
    sel.innerHTML='';
    if(vs) vs.forEach(function(v){ var o=document.createElement('option');
      o.value=v.id; o.textContent=(v.title||'').replace(' / ',' ')+(v.available?'':' (sold out)');
      o.disabled=!v.available; sel.appendChild(o); });
    var lb=$('cz-sizelbl'); if(lb) lb.textContent=VLABEL[focusProd()]||'Option';
    toggleSize(); syncPack();
  }
  function toggleSize(){ var w=$('cz-sizewrap');
    /* A3 vs A4 is a print and packing decision. The download is one file. */
    if(w) w.style.display=(varsFor(focusProd()) && !isDigital(focusProd()))?'block':'none'; }
  function syncPack(){
    var pv=pickedVariant();
    packPrice=(pv&&typeof pv.price==='number')?money(pv.price):null;
    hasVars=!!varsFor(focusProd());
    /* Page mode has no #cz-showAmt for updateShowBar() to drive, so the price
       and spec written by the format tab would sit at the default while the
       cart charged for the chosen variant. Gate on its absence rather than on
       PM, so whichever layout is on screen is the one that gets corrected. */
    if($('cz-showAmt')) return;
    var pe=$('cz-price'), se=$('cz-spec'), base=PRODUCTS[state.product]||null;
    if(pe) pe.textContent=packPrice||(base?base.price:pe.textContent);
    if(se){
      var ss=(state.product==='poster'&&pv)?posterSpecFor(pv.title):'';
      se.textContent=ss||(base?base.spec:se.textContent);
    }
  }
  /* 30 Oct: the size picked for a given format (the picker always shows the
     format on screen - focusProd - which may not be state.product yet) */
  function pickedVariantFor(p){
    var vs=varsFor(p); if(!vs) return null;
    var sel=$('cz-size'); if(!sel||!sel.value) return null;
    for(var i=0;i<vs.length;i++) if(String(vs[i].id)===String(sel.value)) return vs[i];
    return null;
  }
  function pickedVariant(){
    var vs=varsFor(state.product); if(!vs) return null;
    var sel=$('cz-size'); if(!sel||!sel.value) return null;
    for(var i=0;i<vs.length;i++) if(String(vs[i].id)===String(sel.value)) return vs[i];
    return null;
  }
  function resolveProducts(){
    /* Every format with a handle, rather than a list that has to be
       remembered. A format missing from here never has its live variants or
       price fetched, so it shows the settings price whatever Shopify says. */
    Object.keys(HANDLES).forEach(function(k){ var h=(HANDLES[k]||'').trim(); if(!h) return;
      fetch('/products/'+h+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(d){
        if(!d||!d.variants||!d.variants.length) return;
        if(d.variants.length>1){ PVARS[k]=d.variants; buildSizePicker(); }
        VARIANTS[k]=String(d.variants[0].id);
      }).catch(function(){});
    });
  }
  var CLOUD={ name:MSC[21], preset:MSC[22] };
  var MAPKEY=MSC[23], MAPSTYLE=MSC[24];
  var UPLOAD_LINK=MSC[25];
  /* Where "Upload your own route" sends the customer: the section's setting
     (your-route-gallery-poster by default), in this page's format. The
     your-route twin (UPLOAD_LINK) is still where picks of a chosen design go. */
  var UPLOAD_GO=(function(){
    var g=String(MSC[107]||'').trim();
    if(g && g.charAt(0)==='/'){ var f=String(PM_FMT||'');
      return g+((f && f!=='poster')?((g.indexOf('?')<0?'?':'&')+'product='+encodeURIComponent(f)):''); }
    return UPLOAD_LINK;
  })();
  /* A wide dashed card under the search, rather than a small link in the
     header: it sits in the scanning path and never lands inside a month group. */
  function uploadCardEl(){
    if(!UPLOAD_GO) return null;
    var a=document.createElement('a'); a.className='cz-upcard'; a.href=UPLOAD_GO;
    a.innerHTML='<span class="cz-upicon" aria-hidden="true">\u2191</span>'
      +'<span class="cz-uptxt"><b>Ran something else? Upload your own route</b>'
      +'<span>Drop in a GPX from Strava, Garmin, Coros or Apple Watch \u2014 any run, any distance.</span></span>'
      +'<span class="cz-upgo" aria-hidden="true">\u2192</span>';
    return a;
  }
  function uploadLinkEl(cls){ if(!UPLOAD_GO) return null;
    var a=document.createElement('a'); a.className=cls; a.href=UPLOAD_GO;
    a.textContent='Or upload your own route \u2192'; return a; }
  var TSHADE=MSC[26];
  var TTINT=MSC[27];
  var MAPSTYLES={ standard:'osm-bright', dark:'dark-matter', light:'positron' };

  

  

  var TTHEMES={
    /* Sampled from the reference: low ground the saturated green, paling to
       khaki on the tops. Hillshade multiplies these by 0.62-1.0, so they are
       set at the lit end and darkened from there. */
    standard:{ ramp:[[150,199,126],[168,208,138],[196,215,163],[219,217,188]],
               green:[140,196,112], road:[240,244,235], water:[120,184,232], paper:'#E4EDE0' },
    midnight:{ ramp:[[36,49,63],[57,77,95],[88,113,134],[129,158,182]],  green:[64,86,96],  road:[186,199,208], water:[168,193,207], paper:'#2D3C4B' },
    pine:    { ramp:[[29,49,40],[49,78,64],[77,116,95],[119,162,136]],   green:[58,96,72],  road:[198,212,201], water:[157,189,178], paper:'#243E32' },
    plum:    { ramp:[[52,38,56],[82,63,86],[120,96,125],[168,141,174]],  green:[86,70,92],  road:[208,198,210], water:[178,172,199], paper:'#3E2E42' }
  };
  var MOCKUPS={
    magnet:[MSC[28],MSC[29],MSC[30]],
    poster:[MSC[31],MSC[32],MSC[33]],
    tee:[MSC[34],MSC[35],MSC[36]],
    split:[MSC[37],MSC[38],MSC[39]],
    edt_poster:[MSC[40],MSC[41],MSC[42]],
    edt_tee:[MSC[43],MSC[44]],
    frame:[MSC[74],MSC[75],MSC[76]],
    a4print:[MSC[86],MSC[87],MSC[88]],
    /* The poster at A4: unframed sheets, used in place of poster[] when the
       customer picks the A4 variant. Blank means "no separate set", and A4
       then shows the poster's own mockups as it always did. */
    poster_a4:[MSC[94],MSC[95],MSC[96]],
    /* A download has no object, but it has two things people look at it on:
       a phone for the wallpaper and a sheet or a screen for the print. */
    digital:[MSC[97],MSC[98],MSC[99],MSC[100]]
  };
  
  var MOCKRECT={
    magnet:[[0.28960,0.27820,0.70960,0.80350],
            [[0.0497,0.2526,0.3333,0.7389],[0.3580,0.2493,0.6369,0.7337],[0.6597,0.2467,0.9503,0.7350]],
            [0.24234,0.18945,0.77199,0.83724]],
    poster:[[0.285,0.25,0.719,0.829],[0.535,0.197,0.743,0.474],[0.283,0.166,0.722,0.751]],
    /* Measured off the three supplied A4 sheets, not eyeballed. Brightness
       alone finds the sheet on the wooden desk and fails on the other two,
       where the paper sits on a surface just as bright - so those were found
       by colour temperature (the paper is a cooler white than the wall and the
       wood) and confirmed by Sobel edge projection. Ratios come out 0.705 /
       0.706 / 0.707 against A4's 0.7071, which is how we know the rectangles
       are on the paper rather than on something else.
         1  flat on a wooden desk
         2  leaning against a wall
         3  flat on white
       Slot 2's sheet leans back a few degrees, so it is very slightly a
       trapezoid; the artwork overhangs the bottom corners by well under a
       percent of the width. */
    poster_a4:[[0.2979,0.2100,0.7065,0.7896],
               [0.2876,0.1987,0.7134,0.8022],
               [0.2681,0.1831,0.7275,0.8325]],
    /* Measured off the three supplied photos, then cross-checked against the
       engine's own frameWindow() - which agrees to 0.003 on slots 1 and 3 and
       finds nothing on slot 2, where the hands break the dark ring. That slot
       is the reason this table is not just a fallback.
         1  frame flat on white       window ratio 0.719
         2  held in both hands        window ratio 0.695
         3  on a sideboard            window ratio 0.710
       A4 is 0.707, so all three are square on. */
    /* 1 flat on white, 2 on a sideboard, 3 held in both hands. The hands
       shot is last because the thumbs cross the opening and a colour-keyed
       mask cannot cut skin from paper cleanly - it renders with a ragged
       edge. Upload the first two and it never comes up. */
    a4print:[[0.2568,0.1611,0.7422,0.8379],
             [0.3545,0.3574,0.6455,0.7744],
             [0.3291,0.2354,0.6689,0.7188]],
    tee:[[0.3194,0.205,0.6906,0.7],[0.3655,0.267,0.6175,0.603],[0.4015,0.385,0.6055,0.657]],
    
    edt_poster:[[0.285,0.25,0.72,0.828],[0.3265,0.276,0.6675,0.731],[0.288,0.107,0.551,0.4585]],
    edt_tee:[[0.35,0.205,0.66,0.70],[0.386,0.267,0.597,0.603]],

    
    split:[[0.19,0.33,0.82,0.79],[0.269,0.328,0.7285,0.6715],[0.4865,0.127,0.7875,0.3505]],

    /* Measured off the three supplied photos, not eyeballed: largest dark
       square blob = the frame, its filled interior hole = the window. Aspect
       ratios came out 1.000 / 0.960 / 0.981, which is the perspective in the
       two room shots. */
    frame:[[0.0896,0.0902,0.9112,0.9090],
           [0.3438,0.3018,0.7236,0.6973],
           [0.3799,0.2041,0.7412,0.5723]]
  };

  var mockImgs={}, mockHasAlpha={};

  /* ---- ?msdiag=1 -------------------------------------------------------
     What the engine sees, on the device that is seeing it. Built for a phone:
     big type, one line per fact, nothing to scroll sideways. */
  function msdiag(){
    var out=[], prod=state.product, mk=mockKey(prod);
    out.push(['format', prod+(mk!==prod?'  (mockup set: '+mk+')':'')]);
    out.push(['design', state.style||'?']);
    var slots=(MOCKUPS[mk]||[]), imgs=(mockImgs[mk]||[]);
    out.push(['mockup slots', String(slots.length)]);
    for(var i=0;i<slots.length;i++){
      var url=slots[i], im=imgs[i], tag='slot '+(i+1);
      if(!url){ out.push([tag,'EMPTY - no image set in the customiser']); continue; }
      if(!im){ out.push([tag,'SET but NOT LOADED - '+String(url).slice(-44)]); continue; }
      var line=im.width+'x'+im.height;
      var fw=null;
      try{ fw=isDigital(mk)?frameWindow(im,mk+':'+i,[0.33,1.10])
                           :(FRAMED_FMTS[mk]?frameWindow(im,mk+':'+i):null); }catch(e){}
      if(FRAMED_FMTS[mk]||isDigital(mk)){
        if(!fw){
          line+='  NO WINDOW FOUND'+((MOCKRECT[mk]||[])[i]?' - using the table':' - DRAWN FLAT, the photo is not used');
        }else{
          var a=((fw[2]-fw[0])*im.width)/(((fw[3]-fw[1])*im.height)||1);
          line+='  window '+fw[0].toFixed(3)+','+fw[1].toFixed(3)+' '+fw[2].toFixed(3)+','+fw[3].toFixed(3)+
                '  w/h '+a.toFixed(3)+'  radius '+((fw.length>4?fw[4]:0)).toFixed(3)+
                '  -> '+(isDigital(mk)?(a<0.55?'WALLPAPER':'PRINT'):'print');
        }
      }else{
        line+=((MOCKRECT[mk]||[])[i]?'  table rectangle':'  NO RECTANGLE');
      }
      out.push([tag,line]);
    }
    try{ out.push(['formats on this page',(typeof RING!=='undefined'&&RING?RING.join(', '):'?')]); }catch(e){}

    /* The stage canvas is a fixed width and CSS scales it. A fringe one canvas
       pixel wide vanishes when that is a reduction and shows when it is an
       enlargement, which is exactly the shape of "fine on desktop, wrong on
       the phone". */
    try{
      var cv=$('cz-hMain');
      if(cv){
        var css=cv.getBoundingClientRect(), dpr=window.devicePixelRatio||1;
        var devw=css.width*dpr;
        out.push(['stage canvas', cv.width+'x'+cv.height+' px']);
        out.push(['shown at', Math.round(css.width)+'x'+Math.round(css.height)+
                  ' css  x'+dpr+' dpr  = '+Math.round(devw)+' device px']);
        out.push(['canvas scale', (devw/(cv.width||1)).toFixed(2)+'x'+
                  (devw>cv.width?'  (ENLARGED - one canvas pixel is '+
                   (devw/(cv.width||1)).toFixed(1)+' device pixels)':'  (reduced)')]);
      }
    }catch(e){}

    /* The first-paint poster: whether there was one, and what became of it.
       Invisible otherwise - a poster that is dropped and one that was never
       emitted look exactly the same on screen. */
    try{
      var _pe=posterEl();
      out.push(['first-paint poster',
        _pe ? ('on screen \u2014 ' + ((PM_DEF && (PM_DEF.gpx||PM_DEF.poly))
                 ? 'waiting for the canvas' : 'but this product has no default route'))
            : _posterWhy]);
      /* Which of the three the page actually used, because "no GPX request"
         is the whole claim and it is otherwise invisible. */
      var _cr=null; try{ _cr=currentRoute(); }catch(e){}
      var _src;
      if(_cr && _cr.poly) _src='the route metaobject\u2019s stored track, '+
        _cr.poly.length+' chars \u2014 no GPX request';
      else if(_cr) _src='the route metaobject\u2019s GPX over the network '+
        '\u2014 no track on this route entry';
      else if(PM_DEF && PM_DEF.poly) _src='this product\u2019s stored track, '+
        PM_DEF.poly.length+' chars \u2014 no GPX request';
      else if(PM_DEF && PM_DEF.gpx) _src='this product\u2019s GPX over the '+
        'network \u2014 no route_poly metafield';
      else _src='no route on this product and no ?r=';
      out.push(['  route source', _src]);
    }catch(e){ out.push(['first-paint poster','could not read: '+e]); }

    /* "Try another design" comes from here. Empty is usually no siblings yet,
       not a fault, and the difference matters. */
    try{
      if(!KINS){ out.push(['try another design','KINS is null - this product has no design_code metafield']); }
      else {
        var kf=KINS[focusProd()]||[], kl=kindList();
        out.push(['try another design', kf.length+' listed, '+kl.length+' usable for '+focusProd()+
          (kl.length<2?'  - the strip needs 2 or more, so it stays hidden':'')]);
        out.push(['  designs offered', kl.length?kl.map(function(k){
          return (k.kind||'?')+(k.handle?'':' [NO HANDLE]'); }).join(', '):'none']);
        var nul=0,net=0,ki;
        for(ki=0;ki<kf.length;ki++){ if(!kf[ki]) nul++; else if(kf[ki].net) net++; }
        if(nul) out.push(['  dropped', nul+' null entr'+(nul===1?'y':'ies')+' in the list']);
        /* Which half of the split did the work. A format other than this
           page's own is expected to say "fetched". */
        out.push(['  resolved by', (KINQ && KINQ.code)
          ? ((kf.length-net)+' from the section, '+net+' fetched from /products/*.js'
             +(KIN_GOT[focusProd()]?'':'  - not asked for yet')
             +(KIN_PEND?'  ('+KIN_PEND+' request'+(KIN_PEND===1?'':'s')+' still in flight)':''))
          : 'the section only - no kinq, so other formats cannot be fetched']);
      }
    }catch(e){ out.push(['try another design','could not read: '+e]); }

    var p=document.createElement('div');
    p.setAttribute('style','position:fixed;left:0;right:0;bottom:0;max-height:62vh;overflow:auto;'+
      'z-index:999999;background:#14141a;color:#e8e6e1;font:13px/1.5 ui-monospace,Menlo,monospace;'+
      'padding:14px 14px 24px;box-shadow:0 -6px 24px rgba(0,0,0,.4)');
    var h='<div style="display:flex;justify-content:space-between;align-items:center;margin:0 0 10px">'+
      '<b style="font:600 14px system-ui">Milestone diagnostics</b>'+
      '<span><button id="msdiag-r" style="background:#33333d;color:#fff;border:0;border-radius:999px;padding:7px 14px;font:600 13px system-ui;margin-right:6px">Refresh</button>'+
      '<button id="msdiag-x" style="background:#33333d;color:#fff;border:0;border-radius:999px;padding:7px 14px;font:600 13px system-ui">Close</button></span></div>';
    for(var j=0;j<out.length;j++){
      h+='<div style="margin:0 0 7px;word-break:break-word"><span style="color:#8d8a97">'+
         out[j][0]+'</span><br>'+String(out[j][1]).replace(/&/g,'&amp;').replace(/</g,'&lt;')+'</div>';
    }
    p.innerHTML=h;
    document.body.appendChild(p);
    var x=document.getElementById('msdiag-x'); if(x) x.onclick=function(){ p.remove(); };
    /* Re-read in place. Every reading before this one described the format the
       page opened as, because the panel rendered once and a URL carries no
       format selection. */
    var rf=document.getElementById('msdiag-r');
    if(rf) rf.onclick=function(){ p.remove(); try{ msdiag(); }catch(e){ console.warn('Milestone diag:',e); } };
  }
  if(getParam('msdiag')==='1'){
    setTimeout(function(){ try{ msdiag(); }catch(e){ console.warn('Milestone diag:',e); } },2500);
  }
  (function(){
    for(var _k in MOCKUPS){
      if(Object.prototype.hasOwnProperty.call(MOCKUPS,_k)){ mockImgs[_k]=[]; mockHasAlpha[_k]=[]; }
    }
  })();
  var mockMaskCache={};              
  var mockTmp=document.createElement('canvas');
  /* Where the frame's opening is in a mockup photo, found rather than declared.
     A hand-measured table is keyed to the upload slot, so re-ordering the
     uploads silently puts every rectangle on the wrong picture. Downscaled to
     220px and cached per image, so the cost is one pass per mockup. */
  var frameWinCache={};
  /* The average colour of a photo's outer border, for filling the margin when
     the photo does not fill the canvas. Cached per mockup: it is one 24x24
     read, but it would otherwise run on every repaint. */
  var edgeTintCache={};
  function edgeTint(mi,key){
    if(key in edgeTintCache) return edgeTintCache[key];
    var out='#eeeae2';
    try{
      var n=24, c=document.createElement('canvas'); c.width=n; c.height=n;
      var x=c.getContext('2d',{willReadFrequently:true});
      x.drawImage(mi,0,0,n,n);
      var d=x.getImageData(0,0,n,n).data, r=0,g=0,b=0,k=0,i,j;
      for(i=0;i<n;i++) for(j=0;j<n;j++){
        if(i>1 && i<n-2 && j>1 && j<n-2) continue;      /* border ring only */
        var o=(j*n+i)*4; r+=d[o]; g+=d[o+1]; b+=d[o+2]; k++;
      }
      if(k) out='rgb('+Math.round(r/k)+','+Math.round(g/k)+','+Math.round(b/k)+')';
    }catch(e){}
    edgeTintCache[key]=out;
    return out;
  }
  /* `ar` is the range of width/height the hole is allowed to have. A frame's
     opening is near-square; a phone screen is about 0.46. Passing it in rather
     than hard-coding near-square is what lets the same detector find both. */
  function frameWindow(mi,key,ar){
    ar = ar || [0.55,1.45];
    if(key in frameWinCache) return frameWinCache[key];
    var out=null;
    try{
      var S=220, c=document.createElement('canvas');
      var sc=Math.min(S/mi.width,S/mi.height),
          w=Math.max(8,Math.round(mi.width*sc)), h=Math.max(8,Math.round(mi.height*sc));
      c.width=w; c.height=h;
      var x=c.getContext('2d',{willReadFrequently:true}); x.drawImage(mi,0,0,w,h);
      var d=x.getImageData(0,0,w,h).data, n=w*h, i;
      var lum=new Uint8Array(n);
      for(i=0;i<n;i++) lum[i]=(d[i*4]+d[i*4+1]+d[i*4+2])/3;

      var lab=new Int32Array(n), q=new Int32Array(n), isF=new Uint8Array(n), seen=new Uint8Array(n);
      var comp=new Int32Array(n);

      function attempt(th){
        var dark=new Uint8Array(n), j;
        for(j=0;j<n;j++) dark[j]=(lum[j]<th)?1:0;
        lab.fill(0);
        var cur=0, best=0, bestSize=0;
        for(j=0;j<n;j++){
          if(!dark[j]||lab[j]) continue;
          cur++; var head=0,tail=0; q[tail++]=j; lab[j]=cur; var size=0;
          while(head<tail){
            var p=q[head++]; size++;
            var px=p%w, py=(p-px)/w;
            if(px>0   && dark[p-1] && !lab[p-1]){ lab[p-1]=cur; q[tail++]=p-1; }
            if(px<w-1 && dark[p+1] && !lab[p+1]){ lab[p+1]=cur; q[tail++]=p+1; }
            if(py>0   && dark[p-w] && !lab[p-w]){ lab[p-w]=cur; q[tail++]=p-w; }
            if(py<h-1 && dark[p+w] && !lab[p+w]){ lab[p+w]=cur; q[tail++]=p+w; }
          }
          if(size>bestSize){ bestSize=size; best=cur; }
        }
        if(!best) return null;
        /* Flood the non-frame background in from the edges. Whatever is left
           untouched and is not the frame is enclosed by it: the opening. */
        isF.fill(0); seen.fill(0);
        for(j=0;j<n;j++) isF[j]=(lab[j]===best)?1:0;
        var head2=0,tail2=0, k;
        for(k=0;k<w;k++){
          if(!isF[k]&&!seen[k]){ seen[k]=1; q[tail2++]=k; }
          var bt=(h-1)*w+k; if(!isF[bt]&&!seen[bt]){ seen[bt]=1; q[tail2++]=bt; }
        }
        for(k=0;k<h;k++){
          var l=k*w, r=k*w+w-1;
          if(!isF[l]&&!seen[l]){ seen[l]=1; q[tail2++]=l; }
          if(!isF[r]&&!seen[r]){ seen[r]=1; q[tail2++]=r; }
        }
        while(head2<tail2){
          var p2=q[head2++], px2=p2%w, py2=(p2-px2)/w;
          if(px2>0   && !isF[p2-1] && !seen[p2-1]){ seen[p2-1]=1; q[tail2++]=p2-1; }
          if(px2<w-1 && !isF[p2+1] && !seen[p2+1]){ seen[p2+1]=1; q[tail2++]=p2+1; }
          if(py2>0   && !isF[p2-w] && !seen[p2-w]){ seen[p2-w]=1; q[tail2++]=p2-w; }
          if(py2<h-1 && !isF[p2+w] && !seen[p2+w]){ seen[p2+w]=1; q[tail2++]=p2+w; }
        }
        /* The opening is ONE connected region. Everything else sealed inside
           the dark shape - a lit power button, a speck of glare on a bezel -
           is not part of it, and boxing it in with the opening is what made a
           perfectly good photo measure 40% full and get thrown away. */
        comp.fill(0);
        var cc=0, bestC=0, bestN=0, j2;
        for(j2=0;j2<n;j2++){
          if(isF[j2]||seen[j2]||comp[j2]) continue;
          cc++; var hd=0, tl=0; q[tl++]=j2; comp[j2]=cc; var sz2=0;
          while(hd<tl){
            var pp=q[hd++]; sz2++;
            var ppx=pp%w, ppy=(pp-ppx)/w;
            if(ppx>0   && !isF[pp-1] && !seen[pp-1] && !comp[pp-1]){ comp[pp-1]=cc; q[tl++]=pp-1; }
            if(ppx<w-1 && !isF[pp+1] && !seen[pp+1] && !comp[pp+1]){ comp[pp+1]=cc; q[tl++]=pp+1; }
            if(ppy>0   && !isF[pp-w] && !seen[pp-w] && !comp[pp-w]){ comp[pp-w]=cc; q[tl++]=pp-w; }
            if(ppy<h-1 && !isF[pp+w] && !seen[pp+w] && !comp[pp+w]){ comp[pp+w]=cc; q[tl++]=pp+w; }
          }
          if(sz2>bestN){ bestN=sz2; bestC=cc; }
        }
        var x0=w,x1=-1,y0=h,y1=-1,cnt=0;
        for(j=0;j<n;j++){
          if(comp[j]!==bestC || !bestC) continue;
          cnt++; var ix=j%w, iy=(j-ix)/w;
          if(ix<x0)x0=ix; if(ix>x1)x1=ix; if(iy<y0)y0=iy; if(iy>y1)y1=iy;
        }
        if(!bestC) return null;
        var bw=x1-x0+1, bh=y1-y0+1;
        var bar=bw/bh;
        if(cnt>(n*0.01) && bw>6 && bh>6 && bar>=ar[0] && bar<=ar[1] && cnt/(bw*bh)>0.80){
          /* How far in the opening starts on its bottom row is its corner
             radius. The bottom and not the top because a notch interrupts the
             top row and would read as an enormous corner. Paper measures 0. */
          /* The radius is how many rows up from the bottom are still inset.
             Reading one row gives one or two pixels of signal on this grid and
             two photos of the same phone measured 0.125 and 0.055; counting
             the rows uses the whole corner, which is what a radius is. */
          var ri=0, ry, rj;
          for(ry=y1; ry>y0; ry--){
            var ins=0;
            for(rj=x0; rj<=x1; rj++){ if(comp[ry*w+rj]===bestC) break; ins++; }
            if(ins<=0) break;
            ri++;
          }
          var rr=Math.min(ri/bw, 0.22);
          /* Out by one cell on every side. Where a white screen meets a
             black bezel the blended pixels read as bezel, so the measured
             opening sits just inside the real one - and on a white blank that
             gap is a bright line round the artwork. Falling short is visible,
             overshooting onto a black bezel is not. */
          return [Math.max(0,(x0-1)/w), Math.max(0,(y0-1)/h),
                  Math.min(1,(x1+2)/w), Math.min(1,(y1+2)/h), rr];
        }
        return null;
      }

      /* Generous first. A dark plant or shadow touching the frame merges with
         it and hides the opening; a stricter cut separates them again. */
      var THS=[95,75,60,48], t;
      for(t=0;t<THS.length && !out;t++) out=attempt(THS[t]);
    }catch(e){ console.warn('Milestone: frame window detection failed',e); }
    frameWinCache[key]=out;
    if(!out) console.warn('Milestone: no frame opening found in mockup',key,'- using the table');
    return out;
  }
  /* The bounding box of the hole in a knocked-out mockup. Transparency round
     the outside is a cut-out background rather than a window, so it is flooded
     in from the border and discarded; what survives is enclosed by the photo,
     which is the opening. Downscaled and cached, as frameWindow() is. */
  var alphaWinCache={};
  function alphaWindow(mi,key){
    if(key in alphaWinCache) return alphaWinCache[key];
    var out=null;
    try{
      var S=260, c=document.createElement('canvas');
      var sc=Math.min(S/mi.width,S/mi.height),
          w=Math.max(8,Math.round(mi.width*sc)), h=Math.max(8,Math.round(mi.height*sc));
      c.width=w; c.height=h;
      var x=c.getContext('2d',{willReadFrequently:true});
      x.clearRect(0,0,w,h); x.drawImage(mi,0,0,w,h);
      var d=x.getImageData(0,0,w,h).data, n=w*h, i;
      var clear=new Uint8Array(n);
      for(i=0;i<n;i++) clear[i]=(d[i*4+3]<128)?1:0;
      var seen=new Uint8Array(n), q=new Int32Array(n), head=0, tail=0, k, b, l, r;
      for(k=0;k<w;k++){
        if(clear[k]&&!seen[k]){ seen[k]=1; q[tail++]=k; }
        b=(h-1)*w+k; if(clear[b]&&!seen[b]){ seen[b]=1; q[tail++]=b; }
      }
      for(k=0;k<h;k++){
        l=k*w; r=k*w+w-1;
        if(clear[l]&&!seen[l]){ seen[l]=1; q[tail++]=l; }
        if(clear[r]&&!seen[r]){ seen[r]=1; q[tail++]=r; }
      }
      while(head<tail){
        var p=q[head++], px=p%w, py=(p-px)/w;
        if(px>0   && clear[p-1] && !seen[p-1]){ seen[p-1]=1; q[tail++]=p-1; }
        if(px<w-1 && clear[p+1] && !seen[p+1]){ seen[p+1]=1; q[tail++]=p+1; }
        if(py>0   && clear[p-w] && !seen[p-w]){ seen[p-w]=1; q[tail++]=p-w; }
        if(py<h-1 && clear[p+w] && !seen[p+w]){ seen[p+w]=1; q[tail++]=p+w; }
      }
      /* 30 Oct: the largest single hole, and only if it is shaped like an
         opening - a cut-out model's arm gaps are not one (p_fix30c) */
      var x0=w, x1=-1, y0=h, y1=-1, cnt=0, best=0, bq=[], hq=0, ht=0;
      for(i=0;i<n;i++){
        if(!clear[i]||seen[i]) continue;
        var bx0=w, bx1=-1, by0=h, by1=-1, bc=0; seen[i]=2; hq=0; ht=0; bq[ht++]=i;
        while(hq<ht){
          var cp=bq[hq++], cx=cp%w, cy=(cp-cx)/w; bc++;
          if(cx<bx0)bx0=cx; if(cx>bx1)bx1=cx; if(cy<by0)by0=cy; if(cy>by1)by1=cy;
          if(cx>0   && clear[cp-1] && !seen[cp-1]){ seen[cp-1]=2; bq[ht++]=cp-1; }
          if(cx<w-1 && clear[cp+1] && !seen[cp+1]){ seen[cp+1]=2; bq[ht++]=cp+1; }
          if(cy>0   && clear[cp-w] && !seen[cp-w]){ seen[cp-w]=2; bq[ht++]=cp-w; }
          if(cy<h-1 && clear[cp+w] && !seen[cp+w]){ seen[cp+w]=2; bq[ht++]=cp+w; }
        }
        if(bc>best){ best=bc; cnt=bc; x0=bx0; x1=bx1; y0=by0; y1=by1; }
      }
      var _bw=x1-x0+1, _bh=y1-y0+1;
      if(cnt>n*0.01 && (x1-x0)>6 && (y1-y0)>6 && cnt>=0.5*_bw*_bh && _bw/_bh>=0.25 && _bw/_bh<=4)
        out=[x0/w, y0/h, (x1+1)/w, (y1+1)/h];
    }catch(e){
      /* Nearly always a tainted canvas - the PNG loaded without CORS. */
      console.warn('Milestone: alpha window detection failed for '+key,e);
    }
    alphaWinCache[key]=out;
    return out;
  }
  function mockMask(mk,idx,mi,rc){
    var key=mk+':'+idx; if(key in mockMaskCache) return mockMaskCache[key];
    try{
      var c=document.createElement('canvas'); c.width=mi.width; c.height=mi.height;
      var x=c.getContext('2d'); x.drawImage(mi,0,0);
      var d=x.getImageData(0,0,c.width,c.height); var p=d.data, w=c.width, h=c.height;

      var rx0=rc?Math.floor(rc[0]*w):0, ry0=rc?Math.floor(rc[1]*h):0,
          rx1=rc?Math.ceil(rc[2]*w):w, ry1=rc?Math.ceil(rc[3]*h):h;

      /* The blank may be black, white or anything else, so take its colour
         from the middle of its own print rect rather than assuming. Median of
         a sampled patch, which ignores any print guide marks or texture. */
      var sr=[], sg=[], sb=[];
      var mx0=rx0+Math.floor((rx1-rx0)*0.35), mx1=rx0+Math.floor((rx1-rx0)*0.65);
      var my0=ry0+Math.floor((ry1-ry0)*0.35), my1=ry0+Math.floor((ry1-ry0)*0.65);
      for(var sy=my0;sy<my1;sy+=2){ for(var sx=mx0;sx<mx1;sx+=2){
        var si=(sy*w+sx)*4; if(p[si+3]<128) continue;
        sr.push(p[si]); sg.push(p[si+1]); sb.push(p[si+2]); } }
      if(!sr.length){ mockMaskCache[key]=false; return false; }
      function med(a){ a.sort(function(x,y){return x-y;}); return a[a.length>>1]; }
      var br=med(sr), bg=med(sg), bb=med(sb);
      /* Wide enough for the lighting gradient across a sheet, tight enough
         that skin, shadow and the poster's own edge fall outside it. */
      var TOL=64;
      for(var yy=0;yy<h;yy++){ for(var xx=0;xx<w;xx++){ var i=(yy*w+xx)*4;
        var inRect=(xx>=rx0&&xx<rx1&&yy>=ry0&&yy<ry1);
        var isBlank=(p[i+3]>=128 &&
                     Math.abs(p[i]-br)<TOL && Math.abs(p[i+1]-bg)<TOL && Math.abs(p[i+2]-bb)<TOL);
        if(inRect && isBlank){ p[i]=255;p[i+1]=255;p[i+2]=255;p[i+3]=255; }
        else { p[i+3]=0; }
      }}
      x.putImageData(d,0,0);
      /* How much of the print rect the mask actually covers. A blank that is
         not black yields almost nothing, and trusting that would erase the
         artwork, so the caller checks this before using it. */
      var cov=0, tot=Math.max(1,(rx1-rx0)*(ry1-ry0));
      for(var cy=ry0;cy<ry1;cy+=3){ for(var cx=rx0;cx<rx1;cx+=3){
        if(p[((cy*w+cx)*4)+3]>128) cov++; } }
      c._cover = cov/(tot/9);
      /* A dark blank supplies its own background and the artwork is left
         unfilled so the blank's lighting shows through. A light blank does
         not, and an unfilled design reads as white-on-white. */
      c._lum = 0.299*br + 0.587*bg + 0.114*bb;
      mockMaskCache[key]=c; return c;
    }catch(e){
      /* Nearly always a tainted canvas: the blank loaded without CORS, so its
         pixels cannot be read and the artwork cannot be masked to it. */
      console.warn('Milestone: mockup mask unavailable for '+mk+':'+idx+
        ' — '+((e&&e.name)||'error')+'. Fingers and other foreground detail '+
        'will be covered by the artwork.');
      mockMaskCache[key]=false; return false; }
  }
  function detectAlpha(im){
    try{ var c=document.createElement('canvas'); var s=Math.min(1,80/Math.max(im.width,im.height));
      c.width=Math.max(1,Math.round(im.width*s)); c.height=Math.max(1,Math.round(im.height*s));
      var x=c.getContext('2d'); x.drawImage(im,0,0,c.width,c.height);
      var d=x.getImageData(0,0,c.width,c.height).data;
      for(var i=3;i<d.length;i+=4){ if(d[i]<200) return true; }   
      return false;
    }catch(e){ return false; }   
  }
  function loadMockups(){ Object.keys(MOCKUPS).forEach(function(k){
    MOCKUPS[k].forEach(function(u,idx){ u=(u||'').trim(); if(!u)return;
      function load(cross){ var im=new Image(); if(cross) im.crossOrigin='anonymous';
        im.onload=function(){ mockImgs[k][idx]=im; mockHasAlpha[k][idx]=cross?detectAlpha(im):false; buildDots(); if(EVENT){ renderShow(); return; } if(state.view==='mockup'&&mockKey(state.product)===k) render(); };
        im.onerror=function(){ if(cross){ load(false); } else { console.warn('Milestone: mockup image failed to load —',k,idx,u); } };
        im.src=u; }
      load(true); });
  }); }

  function cloudUpload(file,rt){
    rt=rt||'image';
    var fd=new FormData(); fd.append('file',file); fd.append('upload_preset',CLOUD.preset);
    return fetch('https://api.cloudinary.com/v1_1/'+CLOUD.name+'/'+rt+'/upload',{method:'POST',body:fd})
      .then(function(r){ if(!r.ok) throw new Error('upload'); return r.json(); })
      .then(function(j){ return j.secure_url; });
  }
  function flatBlob(){
    return new Promise(function(res){
      var draw=function(){
        try{
          var W,H;
          if(IS_SPLIT){ W=1697; H=1200; }              
          else { var p=PRODUCTS[state.product];
                 W=(state.product==='poster'||state.product==='a4print')?1800:1500;
                 H=Math.round(W/p.ar); }
          var c=document.createElement('canvas'); c.width=W;c.height=H;
          if(IS_SPLIT){ renderSplit(c.getContext('2d'),0,0,W,H,true); }   
          else { paint(c.getContext('2d'),W,H,true); }
          c.toBlob(function(b){res(b);},'image/png');
        }catch(e){ console.error('Milestone: flatBlob render failed',e); res(null); }
      };
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(draw, draw); } else { draw(); }
    });
  }

  /* Safari caps a canvas at 16,777,216 px of area - iOS silently draws
     nothing, desktop throws when you read it back. A3 at a true 300 DPI is
     3508 x 4961 = 17.4M, past the cap, so that file cannot be built in a
     browser at all. 3000 x 4243 is 12.7M: 360 DPI on A4, 256 DPI on A3. */
  var CANVAS_MAX = 16777216;
  var DIGI_W = 3000, DIGI_H = 4243;
  /* 20:9. Not an iPhone's exact shape and deliberately so: it is the middle
     of the range of phones this file has to work on, so the worst crop is a
     16:9 Android losing 10% off each end rather than an 18% loss. Everything
     drawn sits inside 0.10-0.90 of the height and 0.10-0.90 of the width, which
     is what survives on every shape in that range. */
  var WALL_W = 1440, WALL_H = 3200;

  /* A3 at 300 DPI. Over the canvas cap as one surface, which is why it is
     built in strips; STRIP_H x PRINT_W stays well under it. */
  var PRINT_W = 3508, PRINT_H = 4961, STRIP_H = 1100;
  /* Cloudinary refuses an unsigned upload over 10 MB on the free plan, so a
     print file bigger than this cannot reach the order at all. */
  var UPLOAD_MAX = 9.5 * 1024 * 1024;

  var crcTable=null;
  function crc32(b){
    if(!crcTable){ crcTable=new Uint32Array(256);
      for(var n=0;n<256;n++){ var c=n;
        for(var k=0;k<8;k++) c=(c&1)?(0xEDB88320^(c>>>1)):(c>>>1);
        crcTable[n]=c>>>0; } }
    var r=0xFFFFFFFF;
    for(var i=0;i<b.length;i++) r=crcTable[(r^b[i])&255]^(r>>>8);
    return (r^0xFFFFFFFF)>>>0;
  }
  function pngChunk(type,data){
    var len=data.length, out=new Uint8Array(12+len), dv=new DataView(out.buffer);
    dv.setUint32(0,len);
    for(var i=0;i<4;i++) out[4+i]=type.charCodeAt(i);
    out.set(data,8);
    dv.setUint32(8+len, crc32(out.subarray(4,8+len)));
    return out;
  }
  function cat(parts){
    var n=0,i; for(i=0;i<parts.length;i++) n+=parts[i].length;
    var out=new Uint8Array(n), o=0;
    for(i=0;i<parts.length;i++){ out.set(parts[i],o); o+=parts[i].length; }
    return out;
  }

  /* Render the print file as horizontal strips and encode the PNG as they
     come, so neither the canvas cap nor the memory of a 52 MB raw buffer is
     ever hit. Resolves null when the browser has no CompressionStream, and
     the caller falls back. */
  function printPNG(PW,PH){
    PW=PW||PRINT_W; PH=PH||PRINT_H;
    return new Promise(function(res){
      if(typeof CompressionStream!=='function'){ res(null); return; }
      var cs, writer;
      try{ cs=new CompressionStream('deflate'); writer=cs.writable.getWriter(); }
      catch(e){ res(null); return; }

      var chunks=[], reading=(function(){
        var reader=cs.readable.getReader();
        return (function pump(){
          return reader.read().then(function(r){
            if(r.done) return; chunks.push(r.value); return pump();
          });
        })();
      })();

      var cv=document.createElement('canvas');
      cv.width=PW; cv.height=STRIP_H;
      var cx=cv.getContext('2d',{willReadFrequently:true});
      var prev=new Uint8Array(PW*3);
      var y0=0;

      function strip(){
        if(y0>=PH){
          return Promise.resolve(writer.close()).then(function(){ return reading; }).then(function(){
            var idat=cat(chunks);
            var ihdr=new Uint8Array(13), dv=new DataView(ihdr.buffer);
            dv.setUint32(0,PW); dv.setUint32(4,PH);
            ihdr[8]=8;              /* 8 bits per channel */
            ihdr[9]=2;              /* truecolour, no alpha - the print is opaque */
            ihdr[10]=0; ihdr[11]=0; ihdr[12]=0;
            res(new Blob([cat([
              new Uint8Array([137,80,78,71,13,10,26,10]),
              pngChunk('IHDR',ihdr), pngChunk('IDAT',idat),
              pngChunk('IEND',new Uint8Array(0))
            ])],{type:'image/png'}));
          });
        }
        var h=Math.min(STRIP_H, PH-y0);
        if(cv.height!==h){ cv.height=h; }
        cx.save(); cx.clearRect(0,0,PW,h); cx.translate(0,-y0);
        paint(cx,PW,PH,true);
        cx.restore();
        var d=cx.getImageData(0,0,PW,h).data;
        /* Filter type 2, Up: these designs are vertical gradients, and the row
           above is the best predictor there is for them. */
        var line=new Uint8Array(PW*3+1);
        for(var y=0;y<h;y++){
          line[0]=2;
          var off=y*PW*4, i, j;
          for(i=0,j=off;i<PW*3;i+=3,j+=4){
            line[1+i]  =(d[j]  -prev[i]  )&255;
            line[1+i+1]=(d[j+1]-prev[i+1])&255;
            line[1+i+2]=(d[j+2]-prev[i+2])&255;
          }
          for(i=0,j=off;i<PW*3;i+=3,j+=4){
            prev[i]=d[j]; prev[i+1]=d[j+1]; prev[i+2]=d[j+2];
          }
          writer.write(line.slice());
        }
        y0+=h;
        /* Yield between strips so a phone is not locked up for a second. */
        return new Promise(function(k){ setTimeout(k,0); }).then(strip);
      }

      strip().catch(function(e){
        console.warn('Milestone: tiled PNG failed, falling back to JPEG',e); res(null);
      });
    });
  }

  /* The print file. Tries the big one first; the 3000 px JPEG is the
     fallback for a browser with no CompressionStream and for the designs whose
     PNG is too big to upload. */
  function digiBlob(){
    return new Promise(function(res){
      var small=function(){ digiJpeg().then(res); };
      var go=function(){
        printPNG().then(function(b){
          if(!b){ small(); return; }
          if(b.size>UPLOAD_MAX){
            console.warn('Milestone: the '+PRINT_W+'x'+PRINT_H+' PNG came out at '+
              (b.size/1048576).toFixed(1)+' MB, past the '+(UPLOAD_MAX/1048576).toFixed(1)+
              ' MB upload limit - sending the 3000px JPEG instead.');
            small(); return;
          }
          res(b);
        }).catch(function(){ small(); });
      };
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(go, go); } else { go(); }
    });
  }

  /* A physical poster's or framed A4's print file, at 300 DPI.

     These went to the printer as flatBlob()'s 1800 px render - 154 DPI on an
     A3 poster - while the digital download was built at a true 300 DPI. Same
     builder now: the strip PNG, and past the upload limit (photographic
     designs) the JPEG, which on A3 is the 3000 px one (256 DPI) and on A4 is
     full size. Only the order uses this; the generator's product images stay
     on flatBlob. Anything else, or any failure, is flatBlob as before. */
  /* formats: not digital,frame,magnet,tee - digital builds its own 300 DPI
     file (digiBlob); the magnet's 1500 px render is already 381 DPI; the tee
     and the medal frame stay on flatBlob until their printers say what they
     want. */
  var PHYS_PRINT={ poster:[3508,4961], a4print:[2480,3508] };
  function physPrintBlob(){
    var d=PHYS_PRINT[state.product];
    if(!d) return flatBlob();
    return new Promise(function(res){
      var small=function(){
        var jw=Math.min(d[0],DIGI_W), jh=Math.round(jw*d[1]/d[0]);
        digiJpeg(jw,jh).then(function(b){ res(b||null); }, function(){ res(null); });
      };
      var go=function(){
        printPNG(d[0],d[1]).then(function(b){
          if(!b || b.size>UPLOAD_MAX){ small(); return; }
          res(b);
        }).catch(small);
      };
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(go, go); } else { go(); }
    }).then(function(b){ return b || flatBlob(); });
  }
  function digiJpeg(JW,JH){
    JW=JW||DIGI_W; JH=JH||DIGI_H;
    return new Promise(function(res){
      var draw=function(){
        try{
          if(JW*JH > CANVAS_MAX){
            console.error('Milestone: digital print size '+DIGI_W+'x'+DIGI_H+
              ' exceeds the '+CANVAS_MAX+' px canvas cap - Safari will render '+
              'nothing. Lower DIGI_W/DIGI_H.'); res(null); return;
          }
          var c=document.createElement('canvas'); c.width=JW; c.height=JH;
          paint(c.getContext('2d'),JW,JH,true);
          /* JPEG rather than PNG. The same artwork as PNG runs well past
             Cloudinary's unsigned upload limit at this size, and these designs
             are gradients and map tiles rather than line art, so 0.94 is
             invisible in print. */
          c.toBlob(function(b){res(b);},'image/jpeg',0.94);
        }catch(e){ console.error('Milestone: digital print render failed',e); res(null); }
      };
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(draw, draw); } else { draw(); }
    });
  }

  /* Where a phone's own furniture sits, as fractions of screen height. Used
     to keep the artwork out from under it rather than to draw anything. */
  /* Checked against a real iOS lock screen rather than guessed: the clock
     block runs to 0.247 of the height, the optional widget row to 0.311, the
     torch and camera buttons sit at 0.885-0.935 and the home indicator below
     that. The art starts past the widget row and the foot line clears the
     buttons. */
  var WALL={ clockBot:0.26, artTop:0.315, artBot:0.625,
             titleY:0.675, locY:0.715, ruleY:0.747,
             statValY:0.800, statLblY:0.832, footY:0.862 };

  /* One line, shrunk until it fits. The poster does this with two measuring
     passes; at these sizes a loop is simpler to read and costs nothing. */
  function wallFit(ctx,tpl,txt,track,avail,size){
    var g=0; ctx.font=tpl.replace('%s',size);
    while(ctx.measureText(spaced(txt,track)).width>avail && size>6 && g++<80){
      size*=0.96; ctx.font=tpl.replace('%s',size);
    }
    return size;
  }

  /* The stats a delivered file shows - the wallpaper and the reel - taken the
     way the design's own print takes them, so the three files agree. Gallery
     works pace out from distance and time when the field is left empty
     (galPace) and prints it; the wallpaper and reel used to read only the
     field, and a Gallery buyer who skipped it got two stats instead of
     three. */
  function fileStats(){
    return statRows('')
      .filter(function(x){ return x[1] && String(x[1]).trim(); });
  }
  /* Designs whose wallpaper and reel are built from the customer's photo:
     the photo full bleed, the glowing route over it. Each names where its
     crop focus lives - Full Photo's drag, or Gallery's panel crop - so the
     phone shows the part of the photo the customer chose. Gallery joined at
     Marc's call: its photo is uploaded, so it is the better picture to keep
     on a phone than a second street map. Until a photo is added, the design's
     own map files stand, and the mockups show that. */
  var KIND_PHOTO_FILES={
    'photo-overlay': function(){ return splitPhotoOff; },
    'gallery':       function(){ return galOff; },
    'cover':         function(){ return galOff; },
    'card':          function(){ return galOff; },
    'horizon':       function(){ return galOff; }
  };
  /* Before a photo is uploaded the layout is still the photo one - with a
     placeholder where the photo goes - because these designs cannot be bought
     without one: the map or Neon version was a picture of something no buyer
     ever receives. */
  function photoFiles(){
    var f=KIND_PHOTO_FILES[DESIGN_KIND];
    if(!f) return null;
    /* Horizon's photo is optional: without one, its own files stand */
    if(!splitPhoto) return (typeof ndPhOptional==='function' && ndPhOptional()) ? null : {img:null, off:{x:0.5,y:0.5}, placeholder:true};
    var o=f()||{x:0.5,y:0.5};
    var _im=(DESIGN_KIND==='horizon' && typeof ndHzColour==='function' && !ndHzColour()) ? ndGrey(splitPhoto) : splitPhoto;
    return {img:_im, off:{x:+o.x||0.5, y:(o.y===0?0:(+o.y||0.5))}};
  }
  /* The photo, cover-fitted on the customer's focus - or, before there is
     one, the placeholder the print preview shows: a dashed frame and
     "ADD YOUR PHOTO". */
  function drawPhotoCover(g,ph,off,W,H){
    if(ph){
      var ir=ph.width/ph.height, br=W/H, psw, psh, psx, psy;
      if(ir>br){ psh=ph.height; psw=psh*br; psy=0; psx=(ph.width-psw)*off.x; }
      else { psw=ph.width; psh=psw/br; psx=0; psy=(ph.height-psh)*off.y; }
      g.drawImage(ph,psx,psy,psw,psh,0,0,W,H);
      return;
    }
    g.save();
    g.fillStyle='#3a3a40'; g.fillRect(0,0,W,H);
    g.strokeStyle='rgba(255,255,255,0.35)'; g.setLineDash([W*0.035,W*0.035]);
    g.lineWidth=Math.max(2,W*0.008);
    g.strokeRect(W*0.08,H*0.12,W*0.84,H*0.40);
    g.setLineDash([]);
    g.textAlign='center'; g.fillStyle='rgba(240,237,230,0.85)';
    g.font='700 '+(W*0.10)+'px Inter,sans-serif'; g.fillText('+', W/2, H*0.30);
    g.font='600 '+(W*0.045)+'px Inter,sans-serif';
    g.fillText(spaced('ADD YOUR PHOTO',0.12), W/2, H*0.35);
    g.restore();
  }
  /* `chrome` draws a stand-in lock-screen clock. Mockups pass it; wallBlob()
     does not, because the customer's phone draws the real one and a painted
     second clock would be stuck at the wrong time forever. */
  function renderWallpaper(ctx,W,H,chrome){
    if(IS_TRI){ triWallpaper(ctx,W,H,chrome); return; }
    if(sbOn()){ sbWallpaper(ctx,W,H,chrome); return; }
    if(t3On()){ t3Wallpaper(ctx,W,H,chrome); return; }
    /* Dark whatever the design is. The editorial design's cream paper is the
       one thing that cannot come across: a phone puts a white clock and white
       icons on top of this, and they vanish on a light ground. */
    var g=ctx.createRadialGradient(W*0.5,H*0.34,0,W*0.5,H*0.34,H*0.75);
    g.addColorStop(0,'#1a1a20'); g.addColorStop(1,'#0b0b0e');
    ctx.fillStyle=g; ctx.fillRect(0,0,W,H);

    var mL=W*0.10, colW=W-mL*2, cx=W/2;
    var fullBleed=false;

    /* How much of the map's width survives a cover fit into this screen.
       Below 60% a wide route is losing its ends, and the ends are the route. */
    /* A design with a phone map uses it here, as Gallery uses its own; until
       it has arrived, the print map as before, and a repaint when it lands. */
    var _pmw=phoneMap();
    if(phoneMapWanted() && !_pmw) ensurePhoneMap({}, function(){ if(phoneMap()) render(); });
    var _ptw=phoneTerrain();
    if(phoneTerrainWanted() && !_ptw) ensurePhoneTerrain(function(){ if(phoneTerrain()) render(); });
    var _wimg=_pmw ? _pmw.img : (_ptw ? _ptw.top : state.mapImg);
    var _mapKeep=(isMapLike(state.style) && _wimg)
      ? Math.min(1, (W/H)/((_wimg.width||1)/
          ((_wimg.height - ((state.mapUser||state.style==='terrain')?0:
            Math.round(_wimg.height*0.035)))||1))) : 0;
    var _wcrop=(state.mapUser||state.style==='terrain')?0:(_wimg?Math.round(_wimg.height*0.035):0);
    var _wfb=(isMapLike(state.style) && _wimg) ?
      fullBleedPlace(_wimg,W,H,_wcrop,_pmw?_pmw.url:state.mapUrl) : null;
    /* ---- the art ------------------------------------------------------- */
    var _pf=photoFiles();
    if(_pf){
      /* The photo designs (KIND_PHOTO_FILES): the photo, with the crop focus
         the customer chose, full bleed, with the small glowing route above
         the title the way the Full Photo print carries it. Full Photo used to
         fall through to the Neon wallpaper, so its buyer got no photo at all. */
      fullBleed=true;
      drawPhotoCover(ctx,_pf.img,_pf.off,W,H);
      var ptop=ctx.createLinearGradient(0,0,0,H*WALL.clockBot);
      ptop.addColorStop(0,'rgba(8,8,11,0.70)'); ptop.addColorStop(1,'rgba(8,8,11,0)');
      ctx.fillStyle=ptop; ctx.fillRect(0,0,W,H*WALL.clockBot);
      var pbot=ctx.createLinearGradient(0,H*0.48,0,H);
      pbot.addColorStop(0,'rgba(8,8,11,0)'); pbot.addColorStop(0.40,'rgba(8,8,11,0.80)');
      pbot.addColorStop(1,'rgba(8,8,11,0.94)');
      ctx.fillStyle=pbot; ctx.fillRect(0,H*0.48,W,H*0.52);
      if(state.mask && state.bbox){
        var pcol=colourised(), pbb=state.bbox, pglow=W*0.030;
        var pah=H*0.11, paw=W*0.40;
        var ps=Math.min(paw/pbb.w, pah/pbb.h), pdw=pbb.w*ps, pdh=pbb.h*ps;
        var pdy=H*WALL.titleY-W*0.09-pdh;
        glowArt(ctx,pcol,pbb.x,pbb.y,pbb.w,pbb.h,cx-pdw/2,pdy,pdw,pdh,pglow,state.accent);
      }
    } else if(isMapLike(state.style) && _wimg && _wfb){
      /* Full bleed, which is the whole point of not being a sheet of paper.
         Cover-fit from the middle, then scrim the top and bottom so the clock
         and the type below stay legible over whatever the map is doing. */
      fullBleed=true;
      /* Trim the provider's watermark off the bottom of the mosaic, exactly as
         the poster and the print do. Not for a user's own map or for terrain -
         neither carries one, and the trim would just lose map. */
      var im=_wimg, sw=im.width;
      var cropB=(state.mapUser||state.style==='terrain')?0:Math.round(im.height*0.035);
      var sh=im.height-cropB;
      ctx.drawImage(im,_wfb.sx,_wfb.sy,_wfb.sw,_wfb.sh,0,0,W,H);
      var top=ctx.createLinearGradient(0,0,0,H*WALL.clockBot);
      top.addColorStop(0,'rgba(8,8,11,0.80)'); top.addColorStop(1,'rgba(8,8,11,0)');
      ctx.fillStyle=top; ctx.fillRect(0,0,W,H*WALL.clockBot);
      var bot=ctx.createLinearGradient(0,H*0.52,0,H);
      bot.addColorStop(0,'rgba(8,8,11,0)'); bot.addColorStop(0.45,'rgba(8,8,11,0.86)');
      bot.addColorStop(1,'rgba(8,8,11,0.96)');
      ctx.fillStyle=bot; ctx.fillRect(0,H*0.52,W,H*0.48);
    } else if(isMapLike(state.style) && _wimg){
      /* Too wide to bleed without cutting the route in half. Fit the whole
         map into the art band instead - both ends stay on the screen, and it
         sits in the same place the other designs put their artwork. */
      var wm=_wimg, wah=H*(WALL.artBot-WALL.artTop);
      var wcb=(state.mapUser||state.style==='terrain')?0:Math.round(wm.height*0.035);
      var wsh=wm.height-wcb;
      var wsc=Math.min(colW/wm.width, wah/wsh);
      var wdw=wm.width*wsc, wdh=wsh*wsc;
      ctx.drawImage(wm, 0,0,wm.width,wsh,
                    cx-wdw/2, H*WALL.artTop+(wah-wdh)/2, wdw, wdh);
    } else if(state.style==='heat' && state.heatCanvas){
      var hb=state.heatBbox, ah=H*(WALL.artBot-WALL.artTop);
      var hs=Math.min(colW/hb.w, ah/hb.h), hw=hb.w*hs, hh=hb.h*hs;
      ctx.drawImage(state.heatCanvas, hb.x,hb.y,hb.w,hb.h,
                    cx-hw/2, H*WALL.artTop+(ah-hh)/2, hw, hh);
    } else if(state.mask && state.bbox){
      /* A bigger glow than the poster gets. On a screen it is light rather
         than ink, and the art has room here that it does not have on paper. */
      var col=colourised(), bb=state.bbox, glow=W*0.075;
      var aw=colW-glow, ah2=H*(WALL.artBot-WALL.artTop)-glow;
      var s2=Math.min(aw/bb.w, ah2/bb.h), dw=bb.w*s2, dh=bb.h*s2;
      var dx=cx-dw/2, dy=H*WALL.artTop+(H*(WALL.artBot-WALL.artTop)-dh)/2;
      var draw=function(blur){ ctx.save();
        if(blur){ ctx.shadowColor=state.accent; ctx.shadowBlur=blur; }
        ctx.drawImage(col,bb.x,bb.y,bb.w,bb.h,dx,dy,dw,dh); ctx.restore(); };
      glowArt(ctx,col,bb.x,bb.y,bb.w,bb.h,dx,dy,dw,dh,glow,state.accent);
    }

    /* ---- the type ------------------------------------------------------ */
    ctx.textBaseline='alphabetic'; ctx.textAlign='center';
    var title=(($('cz-title')||{value:''}).value.trim()||'My Milestone').toUpperCase();
    var loc=((($('cz-loc')||{value:''}).value)||'').toUpperCase();
    var stats=fileStats();

    var tsz=wallFit(ctx,'800 %spx Inter,sans-serif',title,0.06,colW,W*0.078);
    ctx.font='800 '+tsz+'px Inter,sans-serif'; ctx.fillStyle='#F4F4F6';
    ctx.fillText(spaced(title,0.06), cx, H*WALL.titleY);

    if(loc){
      var lsz=wallFit(ctx,'600 %spx Inter,sans-serif',loc,0.20,colW,W*0.030);
      ctx.font='600 '+lsz+'px Inter,sans-serif'; ctx.fillStyle='#a9a7b0';
      ctx.fillText(spaced(loc,0.20), cx, H*WALL.locY);
    }
    if(stats.length){
      ctx.fillStyle=state.accent;
      ctx.fillRect(cx-W*0.085, H*WALL.ruleY, W*0.17, Math.max(2,W*0.0045));
      var cw=colW/stats.length;
      stats.forEach(function(st,i){
        var sx=mL+cw*(i+0.5);
        ctx.font='800 '+(W*0.046)+'px Inter,sans-serif'; ctx.fillStyle='#F4F4F6';
        ctx.fillText(String(st[1]).toUpperCase(), sx, H*WALL.statValY);
        ctx.font='600 '+(W*0.021)+'px Inter,sans-serif'; ctx.fillStyle='#8f8d97';
        ctx.fillText(spaced(st[0],0.16), sx, H*WALL.statLblY);
      });
    }
    /* Date and name go to the FOOT, not the head: the head is where the clock
       is, and nothing put there is ever seen. */
    var foot=[dsDate(), dsName()].filter(Boolean).join('   \u00b7   ');
    if(foot){
      var fsz=wallFit(ctx,'600 %spx Inter,sans-serif',foot,0.14,colW,W*0.022);
      ctx.font='600 '+fsz+'px Inter,sans-serif'; ctx.fillStyle='#6f6d77';
      ctx.fillText(spaced(foot,0.14), cx, H*WALL.footY);
    }
    if(!fullBleed) drawAttrib(ctx,0,0,W,H);

    /* ---- the lock screen's own furniture, for the mockup only ----------- */
    if(chrome){
      ctx.save();
      ctx.textAlign='center';
      ctx.shadowColor='rgba(0,0,0,0.45)'; ctx.shadowBlur=W*0.03;
      ctx.fillStyle='rgba(255,255,255,0.92)';
      ctx.font='600 '+(W*0.045)+'px Inter,sans-serif';
      ctx.fillText(spaced('SATURDAY 11 OCTOBER',0.08), W/2, H*0.088);
      ctx.fillStyle='#FFFFFF';
      ctx.font='500 '+(W*0.26)+'px Inter,sans-serif';
      ctx.fillText('9:41', W/2, H*0.205);
      ctx.restore();
    }
  }

  /* ---- the reel -------------------------------------------------------
     9:16, which is what Reels, Stories and TikTok all want. The route draws
     itself, then the type arrives. No band kept clear at the top: there is no
     clock over a video. */
  var REEL_W = 1080, REEL_H = 1920, REEL_FPS = 30, REEL_SEC = 6;
  var REEL = { artTop:0.10, artBot:0.62, titleY:0.730, locY:0.772,
               ruleY:0.806, statValY:0.862, statLblY:0.894, footY:0.950 };

  /* What this browser can actually record. MP4 first, because it is the only
     container a phone can hand straight to Instagram. Nothing supported means
     no reel, and the order goes out with the other two files as before. */
  function reelMime(){
    if(typeof MediaRecorder!=='function') return '';
    var want=['video/mp4;codecs=avc1.42E01E','video/mp4',
              'video/webm;codecs=vp9','video/webm;codecs=vp8','video/webm'];
    for(var i=0;i<want.length;i++){
      try{ if(MediaRecorder.isTypeSupported(want[i])) return want[i]; }catch(e){}
    }
    return '';
  }

  /* The route, projected into the frame once. Doing this per frame would
     reproject 2000 points thirty times a second for no reason. */
  function reelPts(X,Y,W,H){
    var c=state.coords;
    if(!c || c.length<2) return null;
    var pj=projectFit(c,1000,0.02), bb=pj.bbox;
    if(!bb.w || !bb.h) return null;
    var availW=W*0.80, availH=H*(REEL.artBot-REEL.artTop);
    var sc=Math.min(availW/bb.w, availH/bb.h);
    var ox=X+(W-bb.w*sc)/2-bb.x*sc, oy=Y+H*REEL.artTop+(availH-bb.h*sc)/2-bb.y*sc;
    var out=[],i;
    for(i=0;i<pj.pts.length;i++) out.push([ox+pj.pts[i][0]*sc, oy+pj.pts[i][1]*sc]);
    return out;
  }

  /* The phone-shaped digital mockup, if one is set and the detector likes it.
     Returning a window is also proof the photo can be read back from a canvas,
     which is the same permission recording needs - a cross-origin image that
     tainted the canvas would have failed detection long before it got here. */
  function reelStage(){
    /* The LAST phone-shaped mockup, not the first. The first is the flat-lay,
       which is already the wallpaper's mockup; a shot added after it - a hand
       holding a phone, say - is the one meant for the video. Slot order is the
       control, so there is nothing else to configure. */
    var mk='digital', imgs=mockImgs[mk]||[], i;
    for(i=imgs.length-1;i>=0;i--){
      var mi=imgs[i]; if(!mi || !mi.width) continue;
      var fw=null;
      try{ fw=frameWindow(mi,mk+':'+i,[0.33,1.10]); }catch(e){}
      if(!fw) continue;
      var ar=((fw[2]-fw[0])*mi.width)/(((fw[3]-fw[1])*mi.height)||1);
      if(ar<0.55) return {img:mi, win:fw, idx:i};
    }
    return null;
  }

  function reelEase(u){ return u<0.5 ? 4*u*u*u : 1-Math.pow(-2*u+2,3)/2; }
  function reelSpan(t,a,b){ return Math.max(0,Math.min(1,(t-a)/(b-a))); }

  /* The glowing route so far, on its own canvas.

     Keyed on everything that would make the accumulated picture wrong - size,
     position, colour, and the route itself - so a changed route or a resized
     stage starts again rather than drawing over the last one. A t that goes
     backwards (the preview being scrubbed) also starts again, because you
     cannot un-draw a glow. */
  var _rAcc=null;
  function reelAcc(X,Y,W,H,pts,n,col,bgFn,bgKey){
    var mid=pts[pts.length>>1]||pts[0];
    var key=Math.round(W)+'|'+Math.round(H)+'|'+pts.length+'|'+col+'|'+(bgKey||'')+'|'+
            Math.round(pts[0][0]-X)+'|'+Math.round(pts[0][1]-Y)+'|'+
            Math.round(mid[0]-X)+'|'+Math.round(mid[1]-Y);
    if(!_rAcc || _rAcc.key!==key || n<_rAcc.n){
      var cv=document.createElement('canvas');
      cv.width=Math.max(1,Math.round(W)); cv.height=Math.max(1,Math.round(H));
      /* The backdrop belongs here, not on the frame. It never changes, and
         filling two million pixels of radial gradient thirty times a second
         was costing more than the artwork. */
      var bg=cv.getContext('2d');
      if(bgFn){ bgFn(bg,cv.width,cv.height); }
      else {
        var rg=bg.createRadialGradient(W*0.5,H*0.34,0,W*0.5,H*0.34,H*0.80);
        rg.addColorStop(0,'#1a1a20'); rg.addColorStop(1,'#0b0b0e');
        bg.fillStyle=rg; bg.fillRect(0,0,cv.width,cv.height);
      }
      _rAcc={ cv:cv, key:key, n:1 };
    }
    if(n>_rAcc.n){
      var g=_rAcc.cv.getContext('2d');
      g.save();
      g.lineCap='round'; g.lineJoin='round'; g.strokeStyle=col;
      g.lineWidth=Math.max(4,W*0.011);
      /* From the last point already drawn, so the new piece joins the old one
         rather than starting a stripe of its own. */
      var from=Math.max(1,_rAcc.n);
      var stroke=function(blur){
        g.save();
        if(blur){ g.shadowColor=col; g.shadowBlur=blur; }
        g.beginPath();
        g.moveTo(pts[from-1][0]-X, pts[from-1][1]-Y);
        for(var i=from;i<n;i++) g.lineTo(pts[i][0]-X, pts[i][1]-Y);
        g.stroke(); g.restore();
      };
      stroke(W*0.055); stroke(W*0.028); stroke(0);
      g.restore();
      _rAcc.n=n;
    }
    return _rAcc.cv;
  }
  /* The glowing dot at the head of the route. It moves every frame but never
     changes shape, so it is drawn once into a sprite and stamped - rather than
     a 76px gaussian blur recomputed thirty times a second. */
  var _rHead=null;
  function reelHead(W,col){
    var r=Math.max(5,W*0.013), bl=W*0.07;
    var key=Math.round(r)+'|'+Math.round(bl)+'|'+col;
    if(_rHead && _rHead.key===key) return _rHead;
    var sz=Math.ceil((r+bl)*2)+2;
    var cv=document.createElement('canvas'); cv.width=sz; cv.height=sz;
    var g=cv.getContext('2d');
    g.shadowColor=col; g.shadowBlur=bl; g.fillStyle='#FFFFFF';
    g.beginPath(); g.arc(sz/2,sz/2,r,0,Math.PI*2); g.fill();
    _rHead={ cv:cv, sz:sz, key:key };
    return _rHead;
  }
  /* ---- The reel in the design's own style ---------------------------------
     Every reel used to be the Neon animation, whatever was bought. Now:

       map-like (Street Map, Gallery, Terrain, Neon on the map style)
         the design's own map, laid out as its wallpaper lays it out, with the
         route revealed along its length from a route-free copy of the same
         map. The last frame is the baked map itself.
       Full Photo
         the customer's photo, darkened, with the Neon route drawing over it.
       anything else
         Neon, as before.

     A map reel needs the route-free map and the route's positions on it. If
     either is missing while recording (a failed fetch, an alignment that did
     not convince), the reel is Neon throughout rather than switching style
     half way. */
  var _reelRec=false;
  /* The scene a recording uses, decided once when it starts. A map that
     arrived a second into the recording used to switch the reel from Neon
     to the map partway through. */
  var _reelLock, _reelStyleUsed='';
  /* ---- The phone map ------------------------------------------------------
     Street Map's wallpaper and reel use what Gallery's do: a map requested at
     the phone's own shape, its area padded to that shape (galPadArea), shown
     full bleed. Street Map's print map is wide (1000 x 780), which a phone
     could only show boxed - and its reel, aligned against that wide map, fell
     back to Neon on the real Geoapify, while Gallery's, built from this
     request shape, lined up. Gallery's own map is already this shape, so it is
     not in the table. One extra request per digital page view for these
     designs; its route-free copy only when a reel is previewed or ordered. */
  var KIND_PHONE_MAP={ 'editorial':true, 'manifesto':true, 'rings':true };
  var PHONE_MAP_WAIT=15000;
  /* 1:2, between the wallpaper's 20:9 (0.45) and the reel's 9:16 (0.5625),
     so ONE map full-bleeds both without cutting the route whatever its shape.
     The route plus its 15% margin fills 77% of the padded area's long side.
     The wallpaper keeps 0.45/0.5 = 90% of this map's width - room for a wide
     route - and the reel keeps 0.5/0.5625 = 89% of its height - room for a
     tall one. At 9:16 a wide route ran off the wallpaper's sides; at 20:9
     Marc's tall Melbourne route did not fit the reel, which went boxed. */
  function PHONE_MAP_AR(){ return 0.5; }
  function phoneMapWanted(){
    return !!(KIND_PHONE_MAP[DESIGN_KIND] && state.style==='map' && !state.mapUser &&
              MAPKEY && state.coords && !awaitingRoute());
  }
  function phoneMap(){
    if(!phoneMapWanted()) return null;
    var pm=state._phoneMap, u=mapUrlFor(PHONE_MAP_AR());
    return (u && pm && pm.url===u && pm.img) ? pm : null;
  }
  function ensurePhoneMap(opt,cb){
    opt=opt||{}; cb=cb||function(){};
    if(!phoneMapWanted()){ cb(); return; }
    var u=mapUrlFor(PHONE_MAP_AR()); if(!u){ cb(); return; }
    var pm=state._phoneMap;
    if(!pm || pm.url!==u) pm=state._phoneMap={url:u, img:null, sf:0, bare:null, bareSf:0, inflight:0, failed:0};
    if(pm.img && pm.sfIcons!==(sfOn()?1:0)){ pm.img=mapWithSf(pm.img,u); pm.sfIcons=sfOn()?1:0; }   /* 30 Oct pm: start / finish over the phone map too */
    var sf=opt.hi?2:1;
    var needImg=!pm.img || pm.sf<sf;
    if(needImg && pm.failed>=sf){ cb(); return; }          /* tried and failed: do not loop */
    if(needImg && pm.inflight>=sf){ cb(); return; }        /* already on its way */
    var needBare=!!opt.bare;
    if(!needImg && !(needBare && !(pm.bare && pm.bareSf===pm.sf))){ cb(); return; }
    var done=false, fin=function(){ if(!done){ done=true; cb(); } };
    /* Both at print scale on a phone's connection take seconds each. They
       used to go one after the other inside the print map's 8 s, and on
       Marc's iPhone the Street Map reel came out Neon. Requested together
       now, and given PHONE_MAP_WAIT. */
    var tm=setTimeout(fin, needBare ? PHONE_MAP_WAIT : MAP_HI_WAIT);
    var lift=function(im){ if(im && state.mapStyle==='dark'){ try{ return liftDarkTile(im); }catch(e){ return null; } } return im; };
    var load=function(src,ok){ var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){ ok(im); }; im.onerror=function(){ ok(null); }; relayImgSrc(im,src); };
    var bareStep=function(){
      if(!needBare || done || state._phoneMap!==pm || !pm.img || (pm.bare && pm.bareSf===pm.sf)){
        clearTimeout(tm); fin(); return; }
      var want=pm.sf;
      load(bareUrlOf(u,want), function(im){
        if(im && state._phoneMap===pm && pm.sf===want &&
           (im.naturalWidth||im.width)===pm.img.width && (im.naturalHeight||im.height)===pm.img.height){
          var o=lift(im); if(o){ pm.bare=o; pm.bareSf=want; } }
        clearTimeout(tm); fin(); });
    };
    if(needImg && needBare){
      /* The map and its route-free copy at once; kept only as a matching pair. */
      pm.inflight=sf;
      var got={}, n=0;
      var both=function(){
        if(++n<2) return;
        pm.inflight=0;
        var a=got.img, b=got.bare;
        if(a && state._phoneMap===pm){
          var oa=lift(a);
          if(oa){ pm.img=mapWithSf(oa,u); pm.sfIcons=sfOn()?1:0; pm.sf=sf; pm.bare=null; pm.bareSf=0;
            if(b && (b.naturalWidth||b.width)===oa.width && (b.naturalHeight||b.height)===oa.height){
              var ob=lift(b); if(ob){ pm.bare=ob; pm.bareSf=sf; } } }
        } else if(!a) pm.failed=Math.max(pm.failed,sf);
        clearTimeout(tm); fin();
      };
      load(sf>=2 ? u+'&scaleFactor=2' : u, function(im){ got.img=im; both(); });
      load(bareUrlOf(u,sf), function(im){ got.bare=im; both(); });
      return;
    }
    if(needImg){
      pm.inflight=sf;
      load(sf>=2 ? u+'&scaleFactor=2' : u, function(im){
        pm.inflight=0;
        if(im && state._phoneMap===pm){ var o=lift(im); if(o){ pm.img=mapWithSf(o,u); pm.sfIcons=sfOn()?1:0; pm.sf=sf; pm.bare=null; pm.bareSf=0; } }
        else pm.failed=Math.max(pm.failed,sf);
        if(pm.img) bareStep(); else { clearTimeout(tm); fin(); }
      });
    } else bareStep();
  }
  /* ---- The phone terrain -------------------------------------------------
     Terrain's map is built at the print's portrait shape. A tall route (a
     marathon, a half) fills a phone from it; a wide one (Marc's 5K and 10K)
     cannot be cover-cropped onto a phone without losing its ends, so its
     wallpaper and reel went boxed. Like Street Map's phone map: a second
     terrain, built at 1:2 (PHONE_MAP_AR) from the same tiles, theme and
     route, for the wallpaper and reel only - the print is untouched. It
     carries its own route-free copy and route positions (paintTerrain). */
  var KIND_PHONE_TERRAIN={ 'terrain':true };
  var PHONE_TERRAIN_W=1400;
  function phoneTerrainWanted(){
    return !!(KIND_PHONE_TERRAIN[DESIGN_KIND] && state.style==='terrain' &&
              state.coords && state.coords.length>1 && !awaitingRoute());
  }
  function phoneTerrainKey(){
    var c=state.coords;
    return (state.mapUrl||'')+'|'+c.length+'|'+c[0][0]+','+c[0][1]+'|'+
           c[c.length-1][0]+','+c[c.length-1][1]+'|'+(sfOn()?1:0)+(kmOn()?'k':'');
  }
  function phoneTerrain(){
    if(!phoneTerrainWanted()) return null;
    var pt=state._phoneTerrain;
    return (pt && pt.key===phoneTerrainKey() && pt.top) ? pt : null;
  }
  function ensurePhoneTerrain(cb){
    cb=cb||function(){};
    if(!phoneTerrainWanted() || phoneTerrain()){ cb(); return; }
    var key=phoneTerrainKey(), pt=state._phoneTerrain;
    if(!pt || pt.key!==key) pt=state._phoneTerrain={key:key, top:null, base:null, waiting:[], building:false, failed:false};
    if(pt.failed){ cb(); return; }
    pt.waiting.push(cb);
    if(pt.building) return;
    pt.building=true;
    var W=PHONE_TERRAIN_W, H=Math.round(PHONE_TERRAIN_W/PHONE_MAP_AR());
    buildTerrain(state.coords, function(cv){
      pt.building=false;
      if(cv && state._phoneTerrain===pt){ pt.base=cv; pt.top=terrainWithSf(cv); }
      else if(!cv) pt.failed=true;
      var w=pt.waiting; pt.waiting=[];
      for(var i=0;i<w.length;i++){ try{ w[i](); }catch(e){} }
    }, [W,H]);
  }
  function bareUrlOf(u,sf){
    var b=String(u).replace(/&geometry=[^&]*/,'').replace(/&marker=[^&]*/,'');
    return sf>=2 ? b+'&scaleFactor='+sf : b;
  }
  function reelBareWanted(){
    return !!(MAPKEY && state.style==='map' && state.mapImg && !state.mapUser && !photoFiles() &&
              !state.mapTaint && state.mapUrl && state.mapUrl.indexOf('geoapify')>=0 &&
              !(state._reelBare && state._reelBare.forUrl===state.mapUrl &&
                state._reelBare.top===state.mapImg));
  }
  /* One route-free copy of the map on screen, at the same size and scale,
     fetched only when a reel is about to be made or previewed. Same failure
     rules as the print map: anything short of a CORS-readable image the same
     size as the map on screen, in time, and the reel is Neon. */
  function ensureReelBare(cb){
    if(!reelBareWanted()){ cb(); return; }
    var u=state.mapUrl, top=state.mapImg, done=false;
    var rw=+((/[?&]width=(\d+)/.exec(u)||[0,0])[1])||0;
    var tw=top.naturalWidth||top.width, th=top.naturalHeight||top.height;
    var sf=rw ? Math.round(tw/rw) : 1;
    var fin=function(){ if(!done){ done=true; cb(); } };
    var tm=setTimeout(fin, MAP_HI_WAIT);
    var im=new Image(); im.crossOrigin='anonymous';
    im.onload=function(){
      clearTimeout(tm); if(done) return;
      var iw=im.naturalWidth||im.width, ih=im.naturalHeight||im.height;
      if(state.mapUrl===u && state.mapImg===top && iw===tw && ih===th){
        var out=im;
        if(state.mapStyle==='dark'){ try{ out=liftDarkTile(im); }catch(e){ out=null; } }
        if(out) state._reelBare={forUrl:u, top:top, img:out};
      }
      fin();
    };
    im.onerror=function(){ clearTimeout(tm); fin(); };
    relayImgSrc(im,bareUrlOf(u,sf));
  }
  /* Where the route sits on a Geoapify map. Projected first - Web Mercator,
     the area rect centred and scaled to cover the image, which is how
     Geoapify fits it - then aligned against the orange line already in the
     image, so a small difference in their fitting cannot leave the reveal
     beside the streets. Below MAP_ALIGN of the route landing on that line,
     the answer is no, and the reel is Neon. */
  var MAP_ALIGN=0.80, _geoCal={key:'',res:null};
  function geoPts(url,img){
    var Wp=img.naturalWidth||img.width, Hp=img.naturalHeight||img.height;
    var key=url+'|'+Wp+'x'+Hp+'|'+(state.coords?state.coords.length:0);
    if(_geoCal.key===key) return _geoCal.res;
    var res=null;
    try{
      var q=function(k){ var m=new RegExp('[?&]'+k+'=([^&]*)').exec(url); return m?decodeURIComponent(m[1]):''; };
      var rw=+q('width'), ar=/rect:([-\d.]+),([-\d.]+),([-\d.]+),([-\d.]+)/.exec(q('area'));
      var c=state.coords;
      if(rw && ar && c && c.length>1){
        var sf=Wp/rw, R=Math.PI/180;
        var mx=function(lo){ return lo*R; };
        var my=function(la){ return Math.log(Math.tan(Math.PI/4+la*R/2)); };
        var X0=mx(+ar[1]), Y0=my(+ar[2]), X1=mx(+ar[3]), Y1=my(+ar[4]);
        var k=Math.max(Wp/(X1-X0), Hp/(Math.abs(Y1-Y0)||1e-9));
        var cxm=(X0+X1)/2, cym=(Y0+Y1)/2;
        var ix=downsampleIdx(c.length, Math.min(c.length,1500)), raw=[], i;
        for(i=0;i<ix.length;i++){ var p=c[ix[i]];
          raw.push([Wp/2+(mx(p[1])-cxm)*k, Hp/2-(my(p[0])-cym)*k]); }
        var cv=document.createElement('canvas'); cv.width=Wp; cv.height=Hp;
        var g=cv.getContext('2d',{willReadFrequently:true}); g.drawImage(img,0,0);
        var d=g.getImageData(0,0,Wp,Hp).data, M=new Uint8Array(Wp*Hp), j;
        /* The route's own colour. Brand orange keeps the rule this was tuned
           with; any other activity colour matches on distance and saturation. */
        var _rh=routeHex(), _R=parseInt(_rh.substr(1,2),16), _G=parseInt(_rh.substr(3,2),16), _B=parseInt(_rh.substr(5,2),16);
        var _orange=(_R>170 && _R-_G>70 && _R-_B>100);
        for(j=0;j<Wp*Hp;j++){ var r=d[j*4],gg=d[j*4+1],b=d[j*4+2];
          if(_orange){ if(r>170 && r-gg>70 && r-b>100) M[j]=1; }
          else { var dr=r-_R, dg=gg-_G, db=b-_B;
            if(dr*dr+dg*dg+db*db<4900 && Math.max(r,gg,b)-Math.min(r,gg,b)>60) M[j]=1; } }
        var rad=Math.max(2,Math.round(1.5*sf)), D=new Uint8Array(Wp*Hp), x, y, a;
        for(y=0;y<Hp;y++){ var run=-1e9;                       /* dilate along x */
          for(x=0;x<Wp;x++){ if(M[y*Wp+x]) run=x; if(x-run<=rad) D[y*Wp+x]=1; }
          run=1e9; for(x=Wp-1;x>=0;x--){ if(M[y*Wp+x]) run=x; if(run-x<=rad) D[y*Wp+x]=1; } }
        var E=new Uint8Array(Wp*Hp);
        for(x=0;x<Wp;x++){ var rn=-1e9;                        /* then along y */
          for(y=0;y<Hp;y++){ if(D[y*Wp+x]) rn=y; if(y-rn<=rad) E[y*Wp+x]=1; }
          rn=1e9; for(y=Hp-1;y>=0;y--){ if(D[y*Wp+x]) rn=y; if(rn-y<=rad) E[y*Wp+x]=1; } }
        var smp=[], st=Math.max(1,Math.floor(raw.length/240));
        for(i=0;i<raw.length;i+=st) smp.push(raw[i]);
        var score=function(s,dx,dy){ var h=0,n=0;
          for(var m=0;m<smp.length;m++){
            var px=Math.round(Wp/2+(smp[m][0]-Wp/2)*s+dx), py=Math.round(Hp/2+(smp[m][1]-Hp/2)*s+dy);
            if(px<0||py<0||px>=Wp||py>=Hp) continue; n++; if(E[py*Wp+px]) h++; }
          return n ? h/smp.length : 0; };
        var best={v:-1,s:1,dx:0,dy:0}, s1, dx1, dy1, v;
        for(s1=0.95;s1<=1.0501;s1+=0.01) for(dx1=-30;dx1<=30;dx1+=5) for(dy1=-30;dy1<=30;dy1+=5){
          v=score(s1,dx1*sf,dy1*sf); if(v>best.v) best={v:v,s:s1,dx:dx1*sf,dy:dy1*sf}; }
        var b0=best;
        for(s1=b0.s-0.01;s1<=b0.s+0.0101;s1+=0.0025) for(dx1=-5;dx1<=5;dx1++) for(dy1=-5;dy1<=5;dy1++){
          v=score(s1,b0.dx+dx1*sf,b0.dy+dy1*sf); if(v>best.v) best={v:v,s:s1,dx:b0.dx+dx1*sf,dy:b0.dy+dy1*sf}; }
        _mapDiag.align=Math.round(best.v*100)+'%';
        if(best.v>=MAP_ALIGN){
          var out=[];
          for(i=0;i<raw.length;i++) out.push([Wp/2+(raw[i][0]-Wp/2)*best.s+best.dx,
                                              Hp/2+(raw[i][1]-Hp/2)*best.s+best.dy]);
          res={pts:out, lw:5*sf, score:best.v, s:best.s};
        }
      }
    }catch(e){ res=null; }
    _geoCal={key:key,res:res};
    return res;
  }
  /* The map placed in a W x H frame exactly as the wallpaper places it: full
     bleed when most of its width survives, otherwise fitted into the art band
     so both ends of the route stay on screen. */
  /* Where the route sits on a map image, in its pixels - for the full-bleed
     crop below. Terrain knows exactly (paintTerrain kept it); a Geoapify map
     from the same alignment the reel uses. Null when neither can say. */
  function routeBoxOn(img,url){
    var pts=null;
    if(state.style==='terrain'){
      var ptb=phoneTerrain(), tb=(ptb && ptb.top===img) ? ptb.base : state.terrainBase;
      if(tb && tb._pr && tb.width===img.width && tb.height===img.height) pts=tb._pr;
    } else if(url && url.indexOf('geoapify')>=0){
      var c=geoPts(url,img); if(c) pts=c.pts;
    }
    if(!pts || pts.length<2) return null;
    var x0=1e9,y0=1e9,x1=-1e9,y1=-1e9;
    for(var i=0;i<pts.length;i++){ var p=pts[i];
      if(p[0]<x0)x0=p[0]; if(p[1]<y0)y0=p[1]; if(p[0]>x1)x1=p[0]; if(p[1]>y1)y1=p[1]; }
    return {x:x0, y:y0, w:x1-x0, h:y1-y0};
  }
  /* The full-bleed crop of a map for a W x H phone frame, or null for "box
     it instead". Cover-fit, but centred on the route rather than the image,
     and refused when even that would cut the route: a wide route on a tall
     screen lost both ends off the sides of the Terrain wallpaper and reel. */
  function fullBleedPlace(img,W,H,cropB,url){
    var sw=img.width, sh=img.height-cropB;
    if(!(sw>0 && sh>0)) return null;
    if(Math.min(1,(W/H)/(sw/sh)) < 0.60) return null;
    var sc=Math.max(W/sw,H/sh), vw=W/sc, vh=H/sc;
    var sx=(sw-vw)/2, sy=(sh-vh)/2, rb=routeBoxOn(img,url);
    if(rb){
      var pad=Math.min(vw,vh)*0.04;
      if(rb.w+2*pad>vw || rb.h+2*pad>vh) return null;
      sx=Math.min(Math.max(rb.x+rb.w/2-vw/2,0),sw-vw);
      sy=Math.min(Math.max(rb.y+rb.h/2-vh/2,0),sh-vh);
    }
    return {sx:sx, sy:sy, sw:vw, sh:vh};
  }
  var _rScn=[];
  function reelScene(W,H,t){
    W=Math.max(1,Math.round(W)); H=Math.max(1,Math.round(H));
    if(_reelRec && _reelLock!==undefined && W===REEL_W && H===REEL_H)
      return _reelLock==='neon' ? null : _reelLock;
    var anim=(t<1)||_reelRec, i;
    /* A photo design's reel is its photo, ahead of any map it also has. */
    var _pf=photoFiles();
    if(_pf){
      var ph=_pf.img, off=_pf.off;
      return {kind:'photo', key:'po|'+(ph?(ph.src||ph.width):'none')+'|'+off.x+','+off.y,
        bg:function(g,BW,BH){
          drawPhotoCover(g,ph,off,BW,BH);
          g.fillStyle='rgba(8,8,11,0.42)'; g.fillRect(0,0,BW,BH);
          var bot=g.createLinearGradient(0,BH*0.55,0,BH);
          bot.addColorStop(0,'rgba(8,8,11,0)'); bot.addColorStop(0.5,'rgba(8,8,11,0.80)');
          bot.addColorStop(1,'rgba(8,8,11,0.92)');
          g.fillStyle=bot; g.fillRect(0,BH*0.55,BW,BH*0.45);
        }};
    }
    if(isMapLike(state.style) && state.mapImg && !state.mapUser){
      var top=state.mapImg, isT=(state.style==='terrain'), bare=null, ipts=null, lwI=0;
      if(isT){
        var tb=state.terrainBase, ptr=phoneTerrain();
        if(ptr){ top=ptr.top; tb=ptr.base; }
        if(tb && tb._bare && tb._pr && tb.width===top.width && tb.height===top.height){
          bare=tb._bare; ipts=tb._pr; lwI=tb._lw||6; }
      } else if(phoneMap()){
        var pmr=phoneMap();
        top=pmr.img; bare=(pmr.bare && pmr.bareSf===pmr.sf) ? pmr.bare : null;
        var pcal=bare ? geoPts(pmr.url, top) : null;
        if(pcal){ ipts=pcal.pts; lwI=pcal.lw; }
      } else {
        var rb=state._reelBare;
        if(rb && rb.forUrl===state.mapUrl && rb.top===top) bare=rb.img;
        var cal=bare ? geoPts(state.mapUrl, top) : null;
        if(cal){ ipts=cal.pts; lwI=cal.lw; }
      }
      var ready=!!(bare && ipts && ipts.length>1);
      if(anim && !ready) return null;
      for(i=0;i<_rScn.length;i++){ var o=_rScn[i];
        if(o.top===top && o.bare===bare && o.ipts===ipts && o.W===W && o.H===H && o.style===state.style) return o; }
      var tw=top.width, cropB=isT?0:Math.round(top.height*0.035), sw=tw, sh=top.height-cropB;
      var murl=isT ? '' : (phoneMap() ? phoneMap().url : state.mapUrl);
      var _fb=fullBleedPlace(top,W,H,cropB,murl), full=!!_fb, pl;
      if(full){ pl={sx:_fb.sx, sy:_fb.sy, sw:_fb.sw, sh:_fb.sh, dx:0, dy:0, dw:W, dh:H}; }
      else { var colW=W*0.80, ah=H*(REEL.artBot-REEL.artTop), fs=Math.min(colW/sw, ah/sh);
        pl={sx:0, sy:0, sw:sw, sh:sh, dx:(W-sw*fs)/2, dy:H*REEL.artTop+(ah-sh*fs)/2, dw:sw*fs, dh:sh*fs}; }
      var paintWith=function(img){
        var c=document.createElement('canvas'); c.width=W; c.height=H;
        var g=c.getContext('2d');
        var rg=g.createRadialGradient(W*0.5,H*0.34,0,W*0.5,H*0.34,H*0.80);
        rg.addColorStop(0,'#1a1a20'); rg.addColorStop(1,'#0b0b0e');
        g.fillStyle=rg; g.fillRect(0,0,W,H);
        g.drawImage(img,pl.sx,pl.sy,pl.sw,pl.sh,pl.dx,pl.dy,pl.dw,pl.dh);
        if(full){
          var bot=g.createLinearGradient(0,H*0.52,0,H);
          bot.addColorStop(0,'rgba(8,8,11,0)'); bot.addColorStop(0.45,'rgba(8,8,11,0.86)');
          bot.addColorStop(1,'rgba(8,8,11,0.96)');
          g.fillStyle=bot; g.fillRect(0,H*0.52,W,H*0.48);
        }
        return c;
      };
      var kk=pl.dw/pl.sw, pts=null;
      if(ipts){ pts=[]; for(i=0;i<ipts.length;i++)
        pts.push([pl.dx+(ipts[i][0]-pl.sx)*kk, pl.dy+(ipts[i][1]-pl.sy)*kk]); }
      var scn={kind:'map', top:top, bare:bare, ipts:ipts, W:W, H:H, style:state.style,
               topCv:paintWith(top), baseCv:bare?paintWith(bare):null, pts:pts,
               mw:Math.max(lwI*kk+6, lwI*kk*1.8)};
      _rScn.unshift(scn); if(_rScn.length>4) _rScn.length=4;
      return scn;
    }
    return null;
  }
  /* The reveal. An accumulating canvas starts as the route-free map; each
     frame the new stretch of route is stroked wide into a mask, the baked map
     is kept only inside it, and that is laid on. From 0.70 on - where the
     Neon route finishes too - it is the baked map exactly. */
  var _rMap=null;
  function drawReelMap(ctx,X,Y,W,H,t,sc,acc){
    var drawn=reelEase(reelSpan(t,0.06,0.70));
    if(t>=1 || drawn>=1 || !sc.baseCv || !sc.pts){ ctx.drawImage(sc.topCv,X,Y); return; }
    var pts=sc.pts, n=Math.max(2,Math.round((pts.length-1)*drawn)+1), Wc=sc.topCv.width, Hc=sc.topCv.height;
    if(!_rMap || _rMap.sc!==sc || n<_rMap.n){
      var A=document.createElement('canvas'); A.width=Wc; A.height=Hc;
      A.getContext('2d').drawImage(sc.baseCv,0,0);
      var T=document.createElement('canvas'); T.width=Wc; T.height=Hc;
      _rMap={sc:sc, A:A, T:T, n:1};
    }
    if(n>_rMap.n){
      var from=Math.max(1,_rMap.n), mw=sc.mw, x0=1e9, y0=1e9, x1=-1e9, y1=-1e9, i;
      for(i=from-1;i<n;i++){ var p=pts[i];
        if(p[0]<x0)x0=p[0]; if(p[1]<y0)y0=p[1]; if(p[0]>x1)x1=p[0]; if(p[1]>y1)y1=p[1]; }
      x0=Math.max(0,Math.floor(x0-mw)); y0=Math.max(0,Math.floor(y0-mw));
      x1=Math.min(Wc,Math.ceil(x1+mw)); y1=Math.min(Hc,Math.ceil(y1+mw));
      if(x1>x0 && y1>y0){
        var g=_rMap.T.getContext('2d');
        g.save(); g.clearRect(x0,y0,x1-x0,y1-y0);
        g.lineCap='round'; g.lineJoin='round'; g.lineWidth=mw; g.strokeStyle='#000';
        g.beginPath(); g.moveTo(pts[from-1][0],pts[from-1][1]);
        for(i=from;i<n;i++) g.lineTo(pts[i][0],pts[i][1]);
        g.stroke();
        g.globalCompositeOperation='source-in';
        g.drawImage(sc.topCv,x0,y0,x1-x0,y1-y0,x0,y0,x1-x0,y1-y0);
        g.restore();
        _rMap.A.getContext('2d').drawImage(_rMap.T,x0,y0,x1-x0,y1-y0,x0,y0,x1-x0,y1-y0);
      }
      _rMap.n=n;
    }
    ctx.drawImage(_rMap.A,X,Y);
    var hp=pts[n-1], hd=reelHead(W,acc);
    ctx.drawImage(hd.cv, X+hp[0]-hd.sz/2, Y+hp[1]-hd.sz/2);
  }
  function renderReelInto(ctx,X,Y,W,H,t,pts){
    if(IS_TRI){ triReelInto(ctx,X,Y,W,H,t); return; }
    if(sbOn()){ sbReelInto(ctx,X,Y,W,H,t); return; }
    if(t3On()){ t3ReelInto(ctx,X,Y,W,H,t); return; }
    var _sc=reelScene(W,H,t);
    if(_sc && _sc.kind==='map'){ drawReelMap(ctx,X,Y,W,H,t,_sc,state.accent||'#FF4B1F'); }
    else {
    if(!pts || pts.length<2){
      if(_sc && _sc.bg){ ctx.save(); ctx.translate(X,Y); _sc.bg(ctx,W,H); ctx.restore(); return; }
      /* Nothing to draw yet, so the backdrop still has to come from here -
         there is no accumulator to take it from. */
      var g=ctx.createRadialGradient(X+W*0.5,Y+H*0.34,0,X+W*0.5,Y+H*0.34,H*0.80);
      g.addColorStop(0,'#1a1a20'); g.addColorStop(1,'#0b0b0e');
      ctx.fillStyle=g; ctx.fillRect(X,Y,W,H);
      return;
    }

    var acc=state.accent||'#FF4B1F';
    var drawn=reelEase(reelSpan(t,0.06,0.70));
    var n=Math.max(2,Math.round((pts.length-1)*drawn)+1);

    /* Backdrop and route in one blit, rather than a full-canvas gradient
       fill plus three full-path strokes with two shadowBlurs. */
    ctx.save();
    ctx.drawImage(reelAcc(X,Y,W,H,pts,n,acc,_sc&&_sc.bg,_sc&&_sc.key), X, Y);
    if(drawn<1){
      var hp=pts[n-1], hd=reelHead(W,acc);
      ctx.drawImage(hd.cv, hp[0]-hd.sz/2, hp[1]-hd.sz/2);
    }
    ctx.restore();
    }
    var acc=state.accent||'#FF4B1F';

    var ta=reelSpan(t,0.70,0.86);
    if(ta>0){
      ctx.save(); ctx.globalAlpha=ta;
      ctx.textAlign='center'; ctx.textBaseline='alphabetic';
      var cx=X+W/2, colW=W*0.80, mL=X+(W-colW)/2, lift=(1-ta)*H*0.018;
      var title=(($('cz-title')||{value:''}).value.trim()||'My Milestone').toUpperCase();
      var tsz=wallFit(ctx,'800 %spx Inter,sans-serif',title,0.06,colW,W*0.072);
      ctx.font='800 '+tsz+'px Inter,sans-serif'; ctx.fillStyle='#F4F4F6';
      ctx.fillText(spaced(title,0.06), cx, Y+H*REEL.titleY+lift);
      var loc=((($('cz-loc')||{value:''}).value)||'').toUpperCase();
      if(loc){
        var lsz=wallFit(ctx,'600 %spx Inter,sans-serif',loc,0.20,colW,W*0.028);
        ctx.font='600 '+lsz+'px Inter,sans-serif'; ctx.fillStyle='#a9a7b0';
        ctx.fillText(spaced(loc,0.20), cx, Y+H*REEL.locY+lift);
      }
      var stats=fileStats();
      if(stats.length){
        ctx.fillStyle=acc;
        ctx.fillRect(cx-W*0.075, Y+H*REEL.ruleY, W*0.15, Math.max(2,W*0.004));
        var cw=colW/stats.length;
        stats.forEach(function(st,i){
          var sx=mL+cw*(i+0.5);
          ctx.font='800 '+(W*0.044)+'px Inter,sans-serif'; ctx.fillStyle='#F4F4F6';
          ctx.fillText(String(st[1]).toUpperCase(), sx, Y+H*REEL.statValY+lift);
          ctx.font='600 '+(W*0.020)+'px Inter,sans-serif'; ctx.fillStyle='#8f8d97';
          ctx.fillText(spaced(st[0],0.16), sx, Y+H*REEL.statLblY+lift);
        });
      }
      var foot=[dsDate(), dsName()].filter(Boolean).join('   ·   ');
      if(foot){
        var fsz=wallFit(ctx,'600 %spx Inter,sans-serif',foot,0.14,colW,W*0.021);
        ctx.font='600 '+fsz+'px Inter,sans-serif'; ctx.fillStyle='#6f6d77';
        ctx.fillText(spaced(foot,0.14), cx, Y+H*REEL.footY);
      }
      ctx.restore();
    }
    /* No fade in from black. The first frame of the file is its thumbnail in
       Photos and on Instagram, and every delivered reel opened on 0.3-0.9 s
       of pure black. It opens on the design's own backdrop now. */
  }

  /* The whole 9:16 frame. With a phone mockup the photo fills it and the
     reveal happens inside the screen; without one the reveal fills the frame. */
  function renderReelFrame(ctx,W,H,t,st){
    if(!st || !st.img){ renderReelInto(ctx,0,0,W,H,t,st?st.pts:null); return; }
    var im=st.img, sc=Math.max(W/im.width,H/im.height);
    var dw=im.width*sc, dh=im.height*sc, dx=(W-dw)/2, dy=(H-dh)/2;
    ctx.fillStyle='#0b0b0e'; ctx.fillRect(0,0,W,H);
    ctx.drawImage(im,dx,dy,dw,dh);
    var w=st.win;
    var sx=dx+w[0]*dw, sy=dy+w[1]*dh, sw=(w[2]-w[0])*dw, sh=(w[3]-w[1])*dh;
    ctx.save();
    var rr=(w.length>4?w[4]:0)*sw;
    if(rr>1){ roundRect(ctx,sx,sy,sw,sh,rr); } else { ctx.beginPath(); ctx.rect(sx,sy,sw,sh); }
    ctx.clip();
    renderReelInto(ctx,sx,sy,sw,sh,t,st.pts);
    ctx.restore();
  }

  /* Recorded in real time, because a canvas stream is wall-clock: there is no
     way to hand MediaRecorder frames faster than the video is meant to play.
     Six seconds, and it runs alongside the print file rather than after it.
     Every failure path resolves null - a reel is a bonus, an order is not. */
  /* Cloudinary transcodes on delivery. Ask it for H.264 in an MP4 rather
     than trusting the container the recorder wrote: a browser can report
     video/mp4 support and then encode VP9 into it, which is a file a phone
     will not open. A no-op on a URL that is not a Cloudinary video. */
  /* Set by the reel upload, read one line later. Module scope rather than a
     closure variable so the two halves cannot drift apart. */
  var _reelWasMp4 = false;
  function videoAsMp4(u){
    if(!u) return u;
    var i=u.indexOf('/video/upload/');
    if(i<0) return u;
    var head=u.slice(0,i+14), tail=u.slice(i+14);
    return head+'f_mp4,vc_h264/'+tail.replace(/\.[A-Za-z0-9]+$/,'.mp4');
  }

  /* Progress of the on-page preview. 1 at rest, which is what the thumbnail
     strip and the generator's capture paint - a half-drawn route must never
     end up as a product image. */
  var reelPrev={t:1,raf:0};
  function playReelPreview(prod,idx){
    /* A map reel needs its route-free map to animate. Fetched on the tap that
       plays the preview, not on every page view. */
    var go=function(){ playReelPreviewNow(prod,idx); };
    if(phoneMapWanted()){ ensurePhoneMap({bare:true}, go); return; }
    if(reelBareWanted()){ ensureReelBare(go); return; }
    go();
  }
  function playReelPreviewNow(prod,idx){
    if(typeof requestAnimationFrame!=='function') return;
    if(reelPrev.raf){ cancelAnimationFrame(reelPrev.raf); reelPrev.raf=0; }
    var t0=0, SEC=3.2;
    reelPrev.t=0;
    var step=function(ts){
      if(!t0) t0=ts;
      var u=(ts-t0)/(SEC*1000);
      reelPrev.t = u>=1 ? 1 : u;
      try{ paintTile('cz-hMain',prod,'mockup',idx); }catch(e){}
      if(reelPrev.t<1){ reelPrev.raf=requestAnimationFrame(step); } else { reelPrev.raf=0; }
    };
    reelPrev.raf=requestAnimationFrame(step);
  }

  function reelBlob(){
    return new Promise(function(res){
      var mime=reelMime();
      if(!mime){ console.warn('Milestone: no video recorder in this browser - no reel'); res(null); return; }
      var done=false, fin=function(b){ _reelRec=false; _reelLock=undefined; if(!done){ done=true; res(b); } };
      try{
        _reelRec=true; _reelLock=undefined;
        var _l=reelScene(REEL_W,REEL_H,0);
        _reelLock=_l||'neon'; _reelStyleUsed=_l?_l.kind:'neon';
        var c=document.createElement('canvas'); c.width=REEL_W; c.height=REEL_H;
        var x=c.getContext('2d');
        /* A BARE stage, deliberately - not reelStage(). That one carries a
           phone mockup and its screen window, which is what the product page
           shows: the reel as it looks on a phone. The file the customer gets
           has to be the route alone, full frame at 1080x1920, because they are
           going to post it - and nobody posts a stock photo of a stranger's
           hand. renderReelFrame draws the reveal full frame when there is no
           img on the stage, so the split costs nothing but this. */
        var st={ pts:reelPts(0,0,REEL_W,REEL_H) };
        if(!st.pts && !IS_TRI){ fin(null); return; }
        var chunks=[], stream=c.captureStream(REEL_FPS);
        var rec=new MediaRecorder(stream,{mimeType:mime, videoBitsPerSecond:3500000});
        rec.ondataavailable=function(e){ if(e.data && e.data.size) chunks.push(e.data); };
        rec.onstop=function(){ fin(chunks.length?new Blob(chunks,{type:mime}):null); };
        rec.onerror=function(){ fin(null); };
        var t0=0;
        var step=function(ts){
          if(!t0) t0=ts;
          var t=(ts-t0)/(REEL_SEC*1000);
          if(t>=1){
            renderReelFrame(x,REEL_W,REEL_H,1,st);
            setTimeout(function(){ try{ rec.stop(); }catch(e){ fin(null); } },140);
            return;
          }
          renderReelFrame(x,REEL_W,REEL_H,t,st);
          requestAnimationFrame(step);
        };
        renderReelFrame(x,REEL_W,REEL_H,0,st);
        rec.start();
        requestAnimationFrame(step);
        setTimeout(function(){ try{ if(rec.state!=='inactive') rec.stop(); }catch(e){} },(REEL_SEC+5)*1000);
        setTimeout(function(){ fin(null); },(REEL_SEC+8)*1000);
      }catch(e){ console.warn('Milestone: reel build failed',e); fin(null); }
    });
  }

  function wallBlob(){
    return new Promise(function(res){
      var draw=function(){
        try{
          var c=document.createElement('canvas'); c.width=WALL_W; c.height=WALL_H;
          renderWallpaper(c.getContext('2d'),WALL_W,WALL_H);
          c.toBlob(function(b){res(b);},'image/png');
        }catch(e){ console.error('Milestone: wallpaper render failed',e); res(null); }
      };
      if(document.fonts && document.fonts.ready){ document.fonts.ready.then(draw, draw); } else { draw(); }
    });
  }

  function softJob(p){ return p.catch(function(e){ console.warn('Milestone: upload skipped —',e); return null; }); }
  $('cz-add').onclick=function(){ doAdd($('cz-add'),$('cz-addErr')); };
  (function(){ var sz=$('cz-size');
    if(sz) sz.addEventListener('change',function(){
      syncPack(); updateShowBar();
      /* Until the A4 set existed, size changed the price and nothing else, so
         nothing here repainted. Now the mockups change with it. render()
         routes to renderShow() in the two-column layouts, and that rebuilds
         the thumbnail strip itself; the classic layout needs it asked for. */
      if(!EVENT && typeof buildThumbs==='function') buildThumbs();
      render();
    }); })();
  /* ---- Print-resolution map --------------------------------------------
     The map is requested at roughly screen size (1000, 700 or 600 px wide),
     which is right for the preview and far short of a print. Measured through
     the real Add to Cart: on the A3 digital file a Street Map got 85 map
     pixels per printed inch and Gallery 118 - the tile stretched about 3.5x -
     and Gallery's 600 px map was stretched across the 1440 px wallpaper.

     scaleFactor=2 is Geoapify's own answer for print: the same map, same
     area, same labels and line weights, at twice the pixels. It is fetched
     once, here, rather than on every page view - the preview does not need it,
     it is four times the pixels to download on a phone, and Geoapify does not
     document what scaleFactor costs in credits.

     It must never be the reason an order fails. Anything short of a
     CORS-readable image clearly bigger than the one on screen, for the map
     still on screen, inside MAP_HI_WAIT, and the files are built from the
     preview's map exactly as before. */
  var MAP_HI_SF=2, MAP_HI_WAIT=8000;
  function mapHiWanted(){
    return !!(MAPKEY && state.mapImg && state.style==='map' && !state.mapUser &&
              !state.mapTaint && state.mapUrl && state.mapUrl.indexOf('geoapify')>=0 &&
              state.mapHiFor!==state.mapUrl);
  }
  function ensureMapHi(cb){
    if(!mapHiWanted()){ cb(); return; }
    var u=state.mapUrl, base=state.mapImg, gen=_mapGen, done=false;
    var fin=function(){ if(!done){ done=true; cb(); } };
    var t=setTimeout(function(){ _mapDiag.hi='timed out'; fin(); }, MAP_HI_WAIT);
    var im=new Image(); im.crossOrigin='anonymous';
    im.onload=function(){
      clearTimeout(t);
      /* Arrived after the wait: the files are already being made from the
         preview's map, and swapping mid-build would mix the two. */
      if(done) return;
      var bw=base.naturalWidth||base.width, iw=im.naturalWidth||im.width;
      if(gen===_mapGen && state.mapUrl===u && iw>=bw*1.5){
        var out=im;
        if(state.mapStyle==='dark'){ try{ out=liftDarkTile(im); }catch(e){ out=null; } }
        if(out){ state.mapImg=mapWithSf(out,u); state.mapHiFor=u;
                 _mapDiag.hi=iw+'x'+(im.naturalHeight||im.height); }
      } else _mapDiag.hi='not used: '+iw+' px wide against '+bw;
      fin();
    };
    im.onerror=function(){ clearTimeout(t); _mapDiag.hi='failed'; fin(); };
    relayImgSrc(im,u+'&scaleFactor='+MAP_HI_SF);
  }
  /* Every file is built from state.mapImg inside doAddNow, so the sharper map
     has to be in place before it starts - not raced against it. */
  function doAdd(b,er){
    if(typeof giftCheck==='function' && !giftCheck(er)) return;
    /* 3D: the print render (and a digital order's phone renders) first. */
    if(typeof t3On==='function' && t3On() && (t3HiWanted() || t3PhoneWanted())){
      if(b.disabled) return;
      b.disabled=true; b.textContent=isDigital(state.product)?'Building your files\u2026':'Rendering your 3D map\u2026';
      t3EnsureFiles(function(){ b.disabled=false; doAdd(b,er); });
      return;
    }
    /* Stat Bar's print map, fetched before any file is made from it. */
    if(typeof sbOn==='function' && sbOn() && sbHiWanted()){
      if(b.disabled) return;
      b.disabled=true; b.textContent=isDigital(state.product)?'Building your files\u2026':'Saving design\u2026';
      sbEnsureHi(function(){ b.disabled=false; doAdd(b,er); });
      return;
    }
    var _dig=isDigital(state.product);
    if(!mapHiWanted() && !(_dig && (reelBareWanted() || phoneMapWanted() || phoneTerrainWanted()))){ doAddNow(b,er); return; }
    if(b.disabled) return;
    b.disabled=true;
    b.textContent=isDigital(state.product)?'Building your files\u2026':'Saving design\u2026';
    /* What has to arrive before the files are built: the print map, and for
       a digital order the reel's route-free map. A design with a phone map
       fetches that alongside the print map rather than after it - in series,
       slow print-scale renders ran out the wait and Street Map's reel came
       out Neon - and then needs no route-free copy of the print map. */
    var _pm=_dig && phoneMapWanted(), _pt=_dig && phoneTerrainWanted();
    var _left=1+(_pm?1:0)+(_pt?1:0);
    var go=function(){ if(--_left===0){ b.disabled=false; doAddNow(b,er); } };
    if(_pm) ensurePhoneMap({hi:true, bare:true}, go);
    /* Terrain's phone terrain, if the page has not built it yet - capped, so
       a slow tile server cannot hold the order; the reel is then decided
       without it, as the style lock makes certain. */
    if(_pt){ var _ptDone=false, _ptGo=function(){ if(!_ptDone){ _ptDone=true; go(); } };
             setTimeout(_ptGo, PHONE_MAP_WAIT); ensurePhoneTerrain(_ptGo); }
    ensureMapHi(function(){ if(_dig && !_pm) ensureReelBare(go); else go(); });
  }
  function doAddNow(b,er){
    if(er) er.textContent='';
    var vid;
    var _pv=pickedVariant();
    if(_pv){ vid=String(_pv.id); }
    else { vid=(VARIANTS[state.product]||'').trim().replace(/[^0-9]/g,''); }
    if(!vid){ b.textContent='Add product IDs in settings'; setTimeout(function(){b.textContent='Add to cart';},2200); return; }
    /* A3 vs A4 changes the print scale and framed changes the packing, so the
       variant has to appear on the line item, not just the format name. */
    var _fmt=PRODUCTS[state.product].label.split(' · ')[0];
    if(_pv && _pv.title && String(_pv.title).toLowerCase()!=='default title'){
      _fmt=(PLABEL[state.product]||_fmt)+' \u2014 '+String(_pv.title).replace(' / ',' ');
    }
    /* Nothing is printed on a download, so the usual line is untrue on that
       format - and it is the first thing on the cart line. */
    var props={ 'Your design': isDigital(state.product)
                  ? 'Saved ✓ — your files are made exactly as you designed them. The photo is just an example.'
                  : 'Saved ✓ — printed exactly as you made it. The photo is just an example.',
                'Event name': $('cz-title').value.trim()||'My Milestone',
                'Format': _fmt };
    /* Map and terrain look different per tile theme, so the theme has to be
       recorded or the design cannot be reproduced from the order. */
    if(state.style) props['Style']=state.style+(isMapLike(state.style)?(' ('+(state.mapStyle||'standard')+' tiles)'):'');
    if(typeof sfOn==='function' && sfOn()) props['Start & finish']='Yes';
    if(typeof kmOn==='function' && kmOn()) props['Map details']='Km markers';
    if(routePick() && routePalOn()) props['Route colour']=routeColName(state.accent);
    if(typeof sbOn==='function' && sbOn()) sbProps(props);
    if(typeof ndProps==='function') ndProps(props);
    if(typeof t3Props==='function') t3Props(props);
    if(state.race) props['Race']=state.race;
    /* The name is printed, so it has to reach the order or the insert cannot
       be reproduced from it. */
    /* Every design prints the name since patch 132, so every format has to
       record it. This used to be frame-only, which left a poster order with
       no text record of what was printed on it. */
    if(frameName()) props['Name']=frameName();
    if((DESIGN_KIND==='editorial' || DESIGN_KIND==='gallery') && ribbonOn()) props['Elevation ribbon']='Yes';
    [['cz-loc','Location'],['cz-dist','Distance'],['cz-date','Date']].forEach(function(p){
      if(p[0]==='cz-dist' && STAT_OFF.dist) return;
      var v=($(p[0])||{value:''}).value.trim(); if(p[0]==='cz-date') v=prettyDate(v); if(v) props[p[1]]=v; });
    /* What was printed - typed, or worked out - under the name it was printed as. */
    var _pv=STAT_OFF.pace?'':paceVal(''); if(_pv) props[sp().field]=_pv;
    if(SPORT!=='run') props['Activity']=sp().name;
    /* Elevation is recorded when the activity prints it. */
    var _k3=sp().stats.slice(0,3);
    if((_k3.indexOf('gain')>=0 || sp().gainField) && !STAT_OFF.gain){ var _gv=gainVal(''); if(_gv) props['Elevation gain']=_gv; }
    if(_k3.indexOf('summit')>=0 && !STAT_OFF.summit){ var _hv=summitVal(''); if(_hv) props['High point']=_hv; }
    var tm=STAT_OFF.time?'':timeStr(); if(tm) props['Time']=tm;
    giftProps(props);
    relayProps(props);
    /* Gallery prints a pace it worked out when the field was empty; record
       what was printed, or the order cannot reproduce it. */
    if(has2()){ props['Second route']='Yes (side by side)';
      [['cz-dist2','Route 2 distance'],['cz-date2','Route 2 date']].forEach(function(p){
        var v=($(p[0])||{value:''}).value.trim(); if(p[0]==='cz-date2') v=prettyDate(v); if(v) props[p[1]]=v; });
      var _pv2=paceVal('2'); if(_pv2) props['Route 2 '+sp().field.toLowerCase()]=_pv2;
      var tm2=timeStrN('2'); if(tm2) props['Route 2 time']=tm2; }

    /* The digital file is rendered at A3 300 DPI in five passes and encoded
       here rather than uploaded from somewhere - measured at 2.4 s on a
       laptop and 10.6 s with the CPU throttled 4x, which is roughly a
       mid-range phone. 'Saving design' for ten seconds reads as a page
       that has hung. */
    if(IS_TRI){
      var _miss=TRI_LEGS.filter(function(l){ return !TRI.legs[l.key]; }).map(function(l){ return l.name.toLowerCase(); });
      if(_miss.length){
        splitMsg('Add your '+_miss.join(', ')+' GPX first \u2014 tap the empty tile on the poster, or use the buttons on the left.',true);
        return;
      }
      if(triBusy(state.product)){ splitMsg('The maps are still loading \u2014 give it a moment and try again.',true); return; }
      splitMsg('');
    }
    if(noRoute()){
      splitMsg('Add your route first \u2014 tap \u201c+ Add your GPX\u201d on the preview, or use Upload your route.',true);
      return;
    }
    b.disabled=true;
    b.textContent=isDigital(state.product)?'Building your files…':'Saving design…';
    var jobs=[];
    if(IS_TRI){
      props['Design']=(TRI.layout==='finisher')?'Triathlon Finisher':(TRI.layout==='manifesto'?'Triathlon Manifesto':'Triathlon');
      TRI_LEGS.forEach(function(l){
        var kl=triKmLabel(l.key), sp=triSplit(l.key), pc=triLegPace(l.key);
        props[l.name]=[kl.toLowerCase(), sp?triClock(sp):'', pc.toLowerCase()].filter(Boolean).join(' \u00b7 ');
      });
      var _tt=triTotal(), _typed=(($('tri-time')||{}).value||'').trim();
      var _tr=triTrans();
      if(_tt) props['Finish time']=triClock(_tt)+(_typed?'':(_tr?' (splits + transitions)':' (sum of the splits)'));
      if(_tr) props['Transitions']=triShort(_tr);
      if(triT(1)) props['T1']=triShort(triT(1));
      if(triT(2)) props['T2']=triShort(triT(2));
      if(TRI.photo) props['Photo crop']='x '+TRI.fx.toFixed(3)+' · y '+TRI.focus.toFixed(3)+' · zoom '+Math.max(1,Math.min(TRI.zoom||1,triZoomCap())).toFixed(2)+'×';
      props['Style']=(TRI.layout==='finisher')?'Finisher':(TRI.layout==='manifesto'?('Manifesto, '+(TRI.mode==='terrain'?('Terrain, '+TRI.ttheme):('Map, '+TRI.mapStyle))):(TRI.mode==='terrain'?('Terrain, '+TRI.ttheme):('Map, '+TRI.mapStyle)));
      if(TRI.layout!=='finisher') props['Start & finish']=(TRI.sf===false)?'No':'Yes';   /* 2 Nov */
      if(TRI_BRAND) props['Web address']='Yes';
      if(TRI.routeCode) props['Course']=TRI.routeCode;
      if(TRI.photoFile){
        if(!(CLOUD.name && CLOUD.preset)){ b.disabled=false; b.textContent='Add to cart';
          splitMsg('Photo upload isn\u2019t configured (Cloudinary preset missing in section settings).',true); return; }
        jobs.push(cloudUpload(TRI.photoFile,'image').then(function(u){ props['_Photo']=u; })
          .catch(function(err){ throw new Error('CLOUDINARY UPLOAD FAILED: '+((err&&err.message)||err)); }));
      }
      if(CLOUD.name) TRI_LEGS.forEach(function(l){ var d=TRI.legs[l.key];
        if(d && d.file) jobs.push(softJob(cloudUpload(d.file,'auto').then(function(u){ props['_'+l.name+' GPX']=u; }))); });
    }
    if(IS_GAL||sbOn()||ndPh()){
      if(!splitPhoto && typeof ndPhOptional==='function' && ndPhOptional()){ /* Horizon without a photo: the night sky, nothing to add */ }
      else {
      if(!splitPhoto){
        b.disabled=false; b.textContent='Add to cart';
        splitMsg('Add your photo first \u2014 tap the empty panel '+(sbOn()?'under the map':'on the right')+', '+
                 'or use the Add your photo button.',true);
        return;
      }
      var _gd=galPanelDpi();
      if(_gd!==null && _gd < DPI_BLOCK){
        b.disabled=false; b.textContent='Add to cart';
        splitMsg('This photo is too low-resolution for the panel on the '+(state.product||'poster')+
          ' \u2014 about '+Math.round(_gd)+' DPI. Zoom back out, or choose a higher-resolution photo.',true);
        return;
      }
      if(!(CLOUD.name && CLOUD.preset)){
        b.disabled=false; b.textContent='Add to cart';
        splitMsg('Photo upload isn\u2019t configured (Cloudinary preset missing in section settings).',true);
        return;
      }
      /* The crop, so the print file can be rebuilt exactly as approved. Shown
         to the customer rather than hidden: it is three numbers, and a hidden
         crop is how a reprint quietly comes out different. */
      props['Photo crop']='x '+galOff.x.toFixed(3)+' \u00b7 y '+galOff.y.toFixed(3)+
                          ' \u00b7 zoom '+galZoomNow().toFixed(2)+'\u00d7';
      if(_gd!==null) props['Photo DPI']=Math.round(_gd)+' DPI';
      if(splitPhotoUrl){ props['_Photo']=splitPhotoUrl; }
      else if(splitPhotoFile){
        jobs.push(cloudUpload(splitPhotoFile,'image').then(function(u){ props['_Photo']=u; })
          .catch(function(err){ throw new Error('CLOUDINARY UPLOAD FAILED: '+((err&&err.message)||err)); }));
      }
      }
    }
    if(IS_SPLIT||IS_PO){
      if(!splitPhoto){ b.disabled=false; b.textContent='Add to cart';
        splitMsg(IS_PO ? 'Add your photo first \u2014 tap the poster to choose one.'
                       : 'Add your photo first \u2014 tap the grey photo panel on the poster.',true); return; }
      if(IS_SPLIT) props['Photo side']=splitSide;
      if(IS_PO){
        var _d=photoDpi(splitPhoto,state.product||'poster',true);
        if(_d < DPI_BLOCK){ b.disabled=false; b.textContent='Add to cart';
          splitMsg('This photo is too low-resolution for the '+(state.product||'poster')+
            ' \u2014 about '+Math.round(_d)+' DPI. Choose a higher-resolution photo, or switch to the magnet.',true);
          return; }
        props['Photo DPI']=Math.round(_d)+' DPI';
      }
      if(!(CLOUD.name && CLOUD.preset)){                 
        b.disabled=false; b.textContent='Add to cart';
        splitMsg('Photo upload isn\u2019t configured (Cloudinary preset missing in section settings). CLOUD.name='+(CLOUD.name||'EMPTY')+' preset='+(CLOUD.preset||'EMPTY'),true);
        return;
      }
      if(splitPhotoUrl){ props['_Photo']=splitPhotoUrl; }
      else if(splitPhotoFile){                            
        jobs.push(cloudUpload(splitPhotoFile,'image').then(function(u){ props['_Photo']=u; })
          .catch(function(err){ throw new Error('CLOUDINARY UPLOAD FAILED: '+((err&&err.message)||err)); }));
      }
    }
    /* For every other format the upload is a convenience: the order can be
       rebuilt from the values on it. Here the file IS the product, so this
       one refuses to add rather than create an order nobody can fulfil. */
    /* Every other file waits for the reel. A reel is recorded in real time,
       so anything else rendering on this thread while it records costs it
       frames - and the print file is the heaviest thing the page does. On an
       iPhone, Full Photo's reveal got 8 frames in four seconds and Terrain's
       28, against Gallery's 86: those two render their print twice (PNG, then
       the JPEG). Recording first costs the buyer about six seconds at Add to
       Cart; a reel that stutters is a file they will not post. */
    var _gate=Promise.resolve();
    if(isDigital(state.product)){
      if(!(CLOUD.name && CLOUD.preset)){
        b.disabled=false; b.textContent='Add to cart';
        if(er) er.textContent='Digital delivery isn\u2019t set up yet \u2014 the Cloudinary '+
          'cloud name and upload preset are missing from the section settings.';
        return;
      }
      var _reelP=reelBlob();
      _gate=_reelP.then(function(){},function(){});
      jobs.push(_gate.then(function(){ return digiBlob(); }).then(function(bl){
        if(!bl) throw new Error('the print file could not be built on this device');
        return cloudUpload(bl);
      }).then(function(u){ props['_Digital file']=u; }));
      jobs.push(softJob(_gate.then(function(){ return wallBlob(); }).then(function(bl){ return bl?cloudUpload(bl):null; })
        .then(function(u){ if(u) props['_Wallpaper']=u; })));
      /* resource_type video, or Cloudinary stores an mp4 as an image and
         serves it back as something nobody can play. Soft, like the
         wallpaper: a browser that cannot record one still gets its files. */
      jobs.push(softJob(_reelP.then(function(bl){
          /* Remember what was actually recorded: on Safari and iOS that is
             already h264 in mp4, and asking Cloudinary to "convert" it only
             re-encodes it. A delivered reel measured 182 kbps against the
             3,500 the recorder was told to use. */
          _reelWasMp4 = !!(bl && /mp4/i.test(bl.type||''));
          return bl?cloudUpload(bl,'video'):null; })
        .then(function(u){
          if(!u) return;
          /* The transform is for the browsers that can only record webm, which
             iOS will not play. Everything else is delivered as recorded. */
          props['_Reel'] = _reelWasMp4 ? u : videoAsMp4(u);
          /* For a design whose reel should be its map: which it got, so a
             fall back to Neon shows on the order instead of in a customer's
             feed. */
          if(phoneMapWanted()) props['_Reel style'] = _reelStyleUsed;
        })));
      /* Visible on purpose: it sets the expectation in the cart, on the
         order and in the confirmation, with no theme edit needed. */
      props['Delivery']='Digital download \u2014 emailed after payment, nothing is posted';
    }
    if(CLOUD.name){
      var ext=($('cz-routeurl')||{value:''}).value || state.srcUrl;
      if(ext){ props['_Source image']=ext; }
      else if(state.srcFile && !state.locked){
        if(state.srcType==='gpx'){ jobs.push(softJob(cloudUpload(state.srcFile,'auto').then(function(u){ props['_Source GPX']=u; }))); }
        else { jobs.push(softJob(cloudUpload(state.srcFile).then(function(u){ props['_Source image']=u; }))); }
      }
      /* Never let this fail silently: a missing preview used to leave the order
         with no print file and no indication anything went wrong. */
      jobs.push(softJob(_gate.then(function(){ return physPrintBlob(); }).then(function(bl){ return bl?cloudUpload(bl):null; }).then(function(u){
        props['_Design preview']= u || 'NOT SAVED - rebuild from the values above';
      }).catch(function(){ props['_Design preview']='NOT SAVED - rebuild from the values above'; })));
    }

    Promise.all(jobs).then(function(){
      b.textContent='Adding…';
      var rootPath=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      return fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(vid),quantity:1,properties:props}]})})
        .then(function(r){ if(!r.ok){ return r.text().then(function(t){ console.error('Milestone cart/add failed:',r.status,t); throw new Error(t||r.status); }); } return r.json(); })
        .then(function(){ window.location=rootPath+'cart'; });
    }).catch(function(e){
      console.error('Milestone add-to-cart error:',e);
      var msg=(e&&e.message)||e;
      if(IS_SPLIT){ splitMsg((''+msg).indexOf('CLOUDINARY')>=0 ? (''+msg) : ('Add to cart failed: '+msg),true); }
      else if(er) er.textContent='Shopify said: '+msg+'  — check the variant ID is correct and the product is Active/in stock.';
      b.disabled=false; b.textContent='Couldn’t add'; setTimeout(function(){b.textContent='Add to cart';},2600);
    });
  };

  
  
  window.addEventListener('pageshow', function(){
    var b=$('cz-add'); if(b){ b.disabled=false; b.textContent='Add to cart'; }
    var er=$('cz-addErr'); if(er) er.textContent='';
    var sb=$('cz-showAdd'); if(sb){ sb.disabled=false; sb.textContent='Add to cart'; }   
    var se=$('cz-showErr'); if(se) se.textContent='';
  });

  function getParam(k){ try{ var _v=new URLSearchParams(window.location.search).get(k)||'';
      if(!_v && k==='product') _v=triReferredFormat();
      return _v; }catch(e){ return ''; } }
  function triReferredFormat(){
    try{
      var nav=(performance.getEntriesByType&&performance.getEntriesByType('navigation')[0])||null;
      if(nav && nav.type==='reload') return '';
      var ref=document.referrer||''; if(!ref) return '';
      var ru=new URL(ref), here=new URL(window.location.href);
      if(ru.origin!==here.origin) return '';
      var mine=(here.searchParams.get('r')||'').toLowerCase(), theirs=(ru.searchParams.get('r')||'').toLowerCase();
      if(!mine || mine!==theirs) return '';
      var f=(ru.searchParams.get('product')||'').toLowerCase();
      return /^(poster|a4print|magnet|tee|digital)$/.test(f)?f:'';
    }catch(e){ return ''; }
  }

  

  var EV={ gpx:MSC[45], name:MSC[46], loc:MSC[47], dist:MSC[48], date:MSC[49], product:MSC[50] };
  var EVENTS=[
    { gpx:MSC[51],  name:MSC[52], loc:MSC[53], dist:MSC[54], date:MSC[55] },
    { gpx:MSC[56], name:MSC[57], loc:MSC[58], dist:MSC[59], date:MSC[60] },
    { gpx:MSC[61], name:MSC[62], loc:MSC[63], dist:MSC[64], date:MSC[65] },
    { gpx:MSC[66], name:MSC[67], loc:MSC[68], dist:MSC[69], date:MSC[70] }
  ].filter(function(e){ return (e.gpx&&e.gpx.trim()) || (e.name&&e.name.trim()); });   
  function evGet(k){ var v=getParam(k); if(v&&v.trim()) return v; return (EV[k]||''); }
  var ROUTES_CAT = MSD.routes || [];
  var LINK_TARGETS = MSD.links || [];
  var curGpx=MSC[71], curImg="", curRace="";   
  function lockRoute(label){
    state.locked=true;
    drop.classList.add('cz-has'); drop.style.pointerEvents='none';
    $('cz-dropTitle').textContent='✓ '+(label||'Race')+' route loaded';
    var sp=drop.querySelector('span'); if(sp) sp.textContent='This route is set for your race. Add your name, time and pace below.';
    if(file) file.disabled=true;
    var oc=$('cz-ocrStatus'); if(oc){ oc.className='cz-ocrstat'; oc.textContent=''; }
  }
  /* A fetch that never settles is the common failure on a patchy mobile
     connection, and it used to leave the sample route on screen under the
     event's title with nothing to indicate anything was wrong. Time it out. */
  function fetchText(url, ms){
    return new Promise(function(res, rej){
      var settled=false, ctl=null, t=null;
      try{ if(typeof AbortController==='function') ctl=new AbortController(); }catch(e){}
      t=setTimeout(function(){
        if(settled) return; settled=true;
        if(ctl){ try{ ctl.abort(); }catch(e){} }
        rej(new Error('timeout'));
      }, ms);
      fetch(url, ctl?{signal:ctl.signal}:undefined).then(function(r){
        if(!r.ok) throw new Error('http '+r.status);
        return r.text();
      }).then(function(txt){
        if(settled) return; settled=true; clearTimeout(t); res(txt);
      }, function(e){
        if(settled) return; settled=true; clearTimeout(t); rej(e);
      });
    });
  }

  var GPX_TRIES=3, _gpxTries={}, _gpxImg={};
  /* Bumped whenever a new route is asked for. A fetch that resolves holding an
     older ticket belongs to a route we have since moved on from - dropping it
     is the only thing standing between a slow retry and it quietly replacing
     the route the user just picked. */
  var _routeGen=0;
  function bumpRoute(){ return ++_routeGen; }
  function loadGpxUrl(url, fallbackImg){
    if(!url) return;
    state.emptyRoute=false;
    var rgen=bumpRoute();
    if(fallbackImg!==undefined) _gpxImg[url]=fallbackImg||'';
    var img=_gpxImg[url]||'';
    var n=(_gpxTries[url]||0)+1; _gpxTries[url]=n;
    routeFailHide();
    /* A retry reuses the URL, so bust anything half-cached from the attempt
       that just failed. */
    var u = n>1 ? url+(url.indexOf('?')<0?'?':'&')+'_r='+n+'.'+Date.now() : url;
    fetchText(u, 9000).then(function(txt){
      if(rgen!==_routeGen) return;
      var g=parseGPX(txt);
      if(!g || g.coords.length<2) throw new Error('bad gpx');
      if(g.sport) setSport(g.sport,'file');
      relayCut(url,g);
      var idx=downsampleIdx(g.coords.length,3000), cds=idx.map(function(i){return g.coords[i];}), els=idx.map(function(i){return g.eles[i];});
      state.coords=cds; state.eles=els; state.mapImg=null; state.mapUrl='';
      state.routeIsDefault=false;
      state.style='neon'; markStyle('neon');
      processToMask(gpxToCanvas(cds)); buildHeatCanvas(cds,els);
      var eb=document.getElementById('cz-routeerr'); if(eb) eb.style.display='none';
      _gpxTries[url]=0; routeFailHide();
      refreshStyles();
      if(typeof window.MS_ON_ROUTE==='function'){ var f=window.MS_ON_ROUTE; window.MS_ON_ROUTE=null; try{ f(); }catch(e){} }
      render();
    }).catch(function(){
      if(rgen!==_routeGen) return;
      if(n < GPX_TRIES){ setTimeout(function(){ if(rgen===_routeGen) loadGpxUrl(url); }, n*1400); return; }
      if(img){ var im=new Image(); im.crossOrigin='anonymous';
        im.onload=function(){ if(rgen!==_routeGen) return;
          resetRouteData(); processToMask(im); refreshStyles(); render(); routeFailHide(); };
        im.onerror=function(){ gpxFailed(url); }; im.src=img; return; }
      gpxFailed(url);
    });
  }

  /* On its own element: toggleLoad() and the style tabs both write to
     #cz-heroLoad and would wipe this out. */
  var _routeFailUrl='';
  function routeFailBox(make){
    var cv=$('cz-hMain'), host=cv&&cv.parentNode;
    if(!host) return null;
    var b=host.querySelector('.cz-routefail');
    if(!b && make){
      b=document.createElement('div'); b.className='cz-routefail';
      b.innerHTML='<div class="cz-rf-msg">Your route didn\u2019t load</div>'+
        '<div class="cz-rf-sub">What you can see behind this is a sample route, not your event.</div>'+
        '<button type="button" class="cz-rf-btn">Try again</button>';
      /* Bubble phase, not capture: a capture-phase stopPropagation on the
         container would kill the event before the button ever sees it. This
         still keeps the press off the hero's zoom lens. */
      ['pointerdown','mousedown','touchstart','click'].forEach(function(ev){
        b.addEventListener(ev, function(e){ e.stopPropagation(); });
      });
      b.querySelector('.cz-rf-btn').addEventListener('click', function(e){
        e.preventDefault();
        var u=_routeFailUrl; if(!u) return;
        _gpxTries[u]=0; loadGpxUrl(u);
      });
      host.appendChild(b);
    }
    return b;
  }
  function routeFailHide(){ var b=routeFailBox(false); if(b) b.style.display='none'; }
  function gpxFailed(url){
    if(relayRescue(url)) return;
    /* The stage is about to show a sample route behind a "your route didn't
       load" box. A poster of the real one on top of that is a lie. */
    posterDrop('the route failed to load');
    _routeFailUrl=url||'';
    var b=routeFailBox(true); if(b) b.style.display='flex';
    try{
      var host=$('cz-stage'); if(!host || !host.parentNode) return;
      var eb=document.getElementById('cz-routeerr');
      if(!eb){ eb=document.createElement('div'); eb.id='cz-routeerr';
        eb.style.cssText='margin:10px 0;padding:11px 13px;border-radius:9px;background:#fdecea;color:#a11;border:1px solid #f3b9b3;font-weight:600;font-size:13.5px';
        host.parentNode.insertBefore(eb,host); }
      eb.textContent='This route could not be loaded, so the preview is showing a sample route \u2014 not your event. Reload the page, or pick the route again.';
      eb.style.display='block';
    }catch(e){}
  }
  function openStats(){ $('cz-opt').classList.add('cz-show'); $('cz-moreBtn').textContent='– Hide stats'; }

  function applyEvent(o){
    o=o||{};
    var name=(o.name||'').trim(), loc=(o.loc||'').trim(), dist=(o.dist||'').trim(),
        date=(o.date||'').trim(), gpxurl=(o.gpx||'').trim(), img=(o.img||'').trim(), race=(o.race||'').trim();
    var poly=(o.poly||'').trim();
    if(!race && !img && !gpxurl && !name && !poly) return false;
    /* Words and no route - a design switch carries the title, place,
       distance and date, never an uploaded file: fill the fields and leave
       the route slot as it is, so the customer can still add their GPX. */
    if(!race && !img && !gpxurl && !poly){
      if(name){ $('cz-title').value=name; titleTouched=true; }
      if(loc) $('cz-loc').value=loc;
      if(dist){ $('cz-dist').value=dist; openStats(); }
      if(date){ $('cz-date').value=date; dateTouched=true; openStats(); }
      return false;
    }
    if(gpxurl || poly || race) state.emptyRoute=false;
    curGpx=gpxurl; curImg=img; curRace=race;      
    state.race=race;
    $('cz-title').value = name || 'My Milestone'; titleTouched=!!name;
    $('cz-loc').value  = loc;
    $('cz-dist').value = dist; if(dist) openStats();
    $('cz-date').value = date; dateTouched=!!date; if(date) openStats();
    lockRoute(name||'Race'); showClear(true);
    var rd=(race && typeof RACES!=='undefined') ? RACES[race] : null;
    /* The stored track first. It needs no request at all, so the route is on
       screen before the page has finished booting - and the GPX URL stays as
       the fallback for a product generated before the track was stored, or one
       whose metafield did not survive an import. */
    var _pd = poly ? decodePoly(poly) : null;
    if(_pd){
      state.coords=_pd.coords; state.eles=_pd.eles;
      state.routeIsDefault=false;
      state.mapImg=null; state.mapUrl=''; state.style='neon'; markStyle('neon');
      processToMask(gpxToCanvas(_pd.coords));
      if(_pd.eles) buildHeatCanvas(_pd.coords,_pd.eles);
      else { state.heatCanvas=null; state.heatBbox=null; }
      refreshStyles();
      /* Same handover as loadGpxUrl: the boot code parks the style and the
         ribbon here, because both have to wait for a route to exist. */
      if(typeof window.MS_ON_ROUTE==='function'){ var _f=window.MS_ON_ROUTE; window.MS_ON_ROUTE=null; try{ _f(); }catch(e){} }
      render();
    }
    else if(gpxurl){ loadGpxUrl(gpxurl, img); }
    else if(rd && rd.c && rd.c.length>1){
      state.coords=rd.c.slice(); state.eles=(rd.e?rd.e.slice():null);
      state.routeIsDefault=false;
      state.mapImg=null; state.mapUrl=''; state.style='neon'; markStyle('neon');
      processToMask(gpxToCanvas(rd.c));
      if(rd.e) buildHeatCanvas(rd.c,rd.e); else { state.heatCanvas=null; state.heatBbox=null; }
      refreshStyles(); render();
    } else if(img){
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){ resetRouteData(); processToMask(im); refreshStyles(); render(); };
      im.src=img;
    }
    return true;
  }
  function loadRaceFromUrl(){
    if(IS_TRI){
      var _tc=(getParam('r')||'').trim();
      if(_tc){ var _tr=routeByCode(_tc);
        if(_tr) triLoadRoute(_tr);
        else { console.error('Milestone: no triathlon course with code', _tc);
          TRI.note='That race link is out of date \u2014 browse the race courses, or upload your own three files.'; triStatus(); } }
      return false;
    }
    /* An explicit ?r= is a promise that must be kept or reported. A page handle
       is a guess - most pages are not events - so it stays silent when it
       misses. */
    var rc=(getParam('r')||'').trim(), loud=!!rc;
    if(!rc) rc=pageHandle();
    if(rc){
      var rr=routeByCode(rc);
      if(rr && isTriRoute(rr)){
        /* A triathlon code on a single-route product: its own page draws it. */
        try{ window.location.replace(triRouteUrl(rr)); }catch(e){}
        return false;
      }
      /* A 5K Run code on another product: Stat Bar's page draws it. Every
         other sport's code stays where it is - Stat Bar draws those too. */
      if(rr && PM && isRun5kRoute(rr) && !pageIsSb()){
        try{ window.location.replace(run5kRouteUrl(rr)); }catch(e){}
        return false;
      }
      if(rr && relayOpt()){
        applyRouteCopy(rr);
        var _rev=relayEvent(relayOpt());
        return applyEvent({ gpx:_rev.gpx, poly:_rev.poly, img:_rev.img,
                            name:getParam('name')||_rev.name, loc:getParam('loc')||_rev.loc,
                            dist:getParam('dist')||_rev.dist, date:getParam('date')||_rev.date });
      }
      if(rr){
        applyRouteCopy(rr);
        /* Text params carried across a design switch are the customer's own
           edits, so they outrank the route's stored copy. The GPX and the image
           always come from the route - that is what the code guarantees. */
        return applyEvent({ gpx:rr.gpx, poly:rr.poly, img:rr.img,
                            name:getParam('name')||rr.name,
                            loc :getParam('loc') ||rr.loc,
                            dist:getParam('dist')||rr.dist,
                            date:getParam('date')||rr.date });
      }
      if(loud){
        /* Never fall through to the placeholder in silence - that is how someone
           ends up customising the wrong course without knowing. */
        console.error('Milestone: no route in the catalogue with code', rc);
        try{
          var box=$('cz-styleHint');
          if(box) box.textContent='That race link is out of date \u2014 pick your route below, or upload your GPX.';
        }catch(e){}
      }
    }
    return applyEvent({ race:evGet('race'), img:evGet('img'), gpx:evGet('gpx'),
                        name:evGet('name'), dist:evGet('dist'), loc:evGet('loc'), date:evGet('date') });
  }

  studioBuild();
  /* Generated product descriptions link across with ?design=&style= so the
     customer lands on the same design and style they were looking at. */
  (function(){
    /* An explicit parameter still wins, so an old generated link keeps working. */
    var _rr=currentRoute();
    var d=getParam('design') || (_rr&&_rr.design) || '';
    var st=getParam('style') || (_rr&&_rr.style) || '';
    d=designKey(d);
    /* A 5K Run route draws Stat Bar (spec 2); Stat Bar draws any sport. */
    if(_rr && isRun5kRoute(_rr)) d='statbar';
    if(IS_TRI) d='';
    if(d){
      DESIGN_KIND=(d==='base'?'':d);
      IS_SPLIT=(DESIGN_KIND==='photo-split'); IS_EDT=(DESIGN_KIND==='editorial');
      IS_TD=(DESIGN_KIND==='terrain'); IS_PO=(DESIGN_KIND==='photo-overlay');
      IS_GAL=(DESIGN_KIND==='gallery');
      kindAttr();
    }
    if(st){
      /* 'map:dark' / 'terrain:midnight' - the same shape snapshot products
         store in default_style. A bare 'map' or 'terrain' still works. */
      var _sp=String(st).trim().toLowerCase().split(':');
      var m={neon:'neon',elevation:'heat',heat:'heat',map:'map',terrain:'terrain'}[_sp[0]];
      m=styleForDesign(m);
      var v=(_sp[1]||'').trim();
      function _applyVariant(){
        if(!(m && v)) return;
        var sel=(m==='map')?('#cz-mstyles [data-ms="'+v+'"]')
               :(m==='terrain')?('#cz-tstyles [data-tt="'+v+'"]'):'';
        try{ var btn=sel?document.querySelector(sel):null; if(btn) btn.click(); }catch(e){}
      }
      _applyVariant();
      if(m){
        state.style=m;
        /* loadGpxUrl() forces neon the moment a route resolves, so the choice
           has to be re-stated once the route is actually in. Variant first:
           its handler only refetches when that style is already active. */
        window.MS_ON_ROUTE=function(){ _applyVariant(); selectStyle(m); };
      }
    }
  })();
  /* Activity: ?sport= first, then the route entry's Sport field. Before the
     route loads - the line's colour is baked into the first map request, and
     setting it after meant a map in orange, then the same map again. */
  try{
    var _sr=currentRoute();
    /* Stat Bar's product opens as the 5K Run when it opens empty - no
       route, no ?gpx= or ?race= course. A route with no Sport field is a
       run, as everywhere else (26 Oct: Melbourne 42.2K stayed a 5K Run).
       ?sport= and the Activity row still outrank the default. */
    if(typeof sbOn==='function' && sbOn() && !_sr && !getParam('gpx') && !getParam('race')) setSport('run5k','sbdef');
    if(getParam('sport')) setSport(getParam('sport'),'param');
    else if(_sr && _sr.sport) setSport(_sr.sport,'route');
    /* Run, too, has a colour of its own when the section sets one. */
    if(!_accTouched) state.accent=routeHex();
  }catch(e){ console.error('Milestone sport failed',e); }
  loadDefaultRoute(); loadRaceFromUrl(); try{ ownRestore(); }catch(e){ console.warn('Milestone: own route not restored',e); }
  if(!PM){ resolveProducts(); } loadMockups();
  posterWatch();
  /* currentRoute() included: an explicit ?r= (or an event page handle) is a
     stronger statement of intent than the product's own default. */
  if(PM && PM_DEF && !routeOverridden()){
    try{
      var _MO={JAN:'01',FEB:'02',MAR:'03',APR:'04',MAY:'05',JUN:'06',JUL:'07',AUG:'08',SEP:'09',OCT:'10',NOV:'11',DEC:'12'};
      var _dt=(PM_DEF.date||'').trim(), _m=/^(\d{1,2})\s+([A-Za-z]{3})[a-z]*\s+(\d{4})$/.exec(_dt);
      if(_m && _MO[_m[2].toUpperCase()]) _dt=_m[3]+'-'+_MO[_m[2].toUpperCase()]+'-'+('0'+_m[1]).slice(-2);
      /* Metafields arrive as strings as often as booleans. */
      var _rib=PM_DEF.ribbon; _rib=(_rib===true||_rib==='true'||_rib==='1'||_rib===1);
      function _applyRibbon(){
        if(!_rib) return;
        var c=$('cz-ribbon'); if(!c) return;
        /* syncRibbonRow unticks when the ribbon cannot be drawn, so tick after
           the style is applied - and only if it survived that check. */
        c.checked=true; if(typeof syncRibbonRow==='function') syncRibbonRow();
        if(c.checked) render();
      }
      if(PM_DEF.gpx){
        var _s=null, _v='';
        if(PM_DEF.style){
          /* Snapshot products store 'map:dark' / 'terrain:midnight'. */
          var _parts=String(PM_DEF.style).toLowerCase().trim().split(':');
          _s=styleForDesign(({elevation:'heat',elev:'heat',heat:'heat',neon:'neon',
                              map:'map',terrain:'terrain'})[_parts[0]]);
          _v=(_parts[1]||'').trim();
        }
        if(_s && _v){
          /* Press the tile/theme button first: its handler only fetches when
             the style is already active, so this sets the variant for free and
             the style below loads straight into the right look. */
          var _sel=(_s==='map')?('#cz-mstyles [data-ms="'+_v+'"]'):(_s==='terrain'?('#cz-tstyles [data-tt="'+_v+'"]'):'');
          var _btn=_sel?document.querySelector(_sel):null; if(_btn) _btn.click();
        }
        /* Was a flat 1600ms timer, which raced the very fetch it depended on.
           Fires when the route is actually in instead. */
        window.MS_ON_ROUTE=function(){ if(_s) selectStyle(_s); _applyRibbon(); };
        applyEvent({ gpx:PM_DEF.gpx, poly:PM_DEF.poly, name:PM_DEF.title, loc:PM_DEF.loc, dist:PM_DEF.dist, date:_dt });
      }
      else { var _t=$('cz-title'); if(_t && PM_DEF.title) _t.value=PM_DEF.title; var _l=$('cz-loc'); if(_l && PM_DEF.loc) _l.value=PM_DEF.loc; var _d=$('cz-dist'); if(_d && PM_DEF.dist) _d.value=PM_DEF.dist; }
    }catch(e){ console.error('Milestone default route failed',e); }
  }
  /* Nothing preloaded: the title is the customer's to write. */
  try{ if(noRoute() && !getParam('name')){ var _yt=$('cz-title'); if(_yt && !titleTouched) _yt.value='Your Route'; } }catch(e){}
  (function(){
    var row=$('cz-sport');
    if(row) row.addEventListener('click',function(e){
      var b=e.target.closest('[data-sp]'); if(b) setSport(b.getAttribute('data-sp'),'user'); });
    ['cz-dist','cz-h','cz-m','cz-s','cz-pace','cz-dist2','cz-h2','cz-m2','cz-s2','cz-pace2','cz-gain','cz-summit'].forEach(function(id){
      var e=$(id); if(e) e.addEventListener('input',syncSportUI); });
    ['cz-gain','cz-summit'].forEach(function(id){ var e=$(id); if(e) e.addEventListener('input',render); });
    var rb=$('cz-ribbon'); if(rb) rb.addEventListener('change',function(){ _ribTouched=true; _ribAuto=false; });
    syncSportUI(); syncSportRow();
  })();
  (function(){
    var _rr=currentRoute();
    var pp=(getParam('product') || (_rr&&_rr.fmt) || '').trim().toLowerCase();
    /* Product mode switches format on the ring (below, once it is built);
       the hidden tab row would be overridden by the next renderShow(). */
    if(!PM && pp&&PRODUCTS[pp]){ var b=$('cz-tabs').querySelector('[data-p="'+pp+'"]'); if(b) b.click(); }
  })();
  refreshStyles(); buildPalette(); showSlide(0);   
  initShow();
  try{ relayBuild(); }catch(e){ console.error('Milestone relay failed',e); }
  try{ giftInit(); giftStudio(); }catch(e){ console.error('Milestone gift mode failed',e); }
  try{ ndHalfUI(); }catch(e){ console.error('Milestone halfway field failed',e); }
  try{ palBottom(); }catch(e){ console.error('Milestone colour row failed',e); }
  try{ ndHzUI(); }catch(e){ console.error('Milestone Horizon colour box failed',e); }
  if(!PM && PICKER_FIRST){
    try{ buildRoutePicker();
      /* currentRoute() included, or the picker would cover a route that has
         already been loaded from the page handle. */
      var _hr = getParam('gpx') || getParam('name') || getParam('race') || currentRoute();
      showPicker(_hr ? false : true);
    }catch(e){ console.error('Milestone picker-first failed',e); }
  }
  kindAttr();
  if(EVENT){ try{ pmLayout(); }catch(e){ console.error('Milestone pmLayout failed',e); } }
  if(IS_TRI){ try{ triBoot(); }catch(e){ console.error('Milestone triathlon controls failed',e); } }
  if(PM){
    if(PM_FAM==='your-route'){ try{ buildRoutePicker();
      /* Hide the picker itself rather than calling showPicker(false), which
         also rearranges the stage and builds iconic's back row. */
      var _rp=document.getElementById('cz-routepick'); if(_rp) _rp.style.display='none';
    }catch(e){ console.error('Milestone your-route picker failed',e); } }
    if(PM_FAM==='iconic'){ try{ buildRoutePicker();
      /* currentRoute() included: a route picked from this list comes back as
         ?r=<code>, and without it the list went straight back up. */
      var _hasRoute = getParam('gpx') || getParam('name') || getParam('race') || currentRoute();
      showPicker(_hasRoute ? false : true);
    }catch(e){ console.error('Milestone routepick failed',e); } }
    try{ window.addEventListener('load', updateAlsoLinks); document.addEventListener('input', updateAlsoLinks); updateAlsoLinks(); }catch(e){}
    /* ?product=<format> (an event page's format picker, or a route's own
       Format field): open on that format's sibling, exactly as tapping it in
       the rail does - title, description, price, variant and cart all follow. */
    try{
      var _rq=currentRoute();
      var _pq=(getParam('product') || (_rq&&_rq.fmt) || '').trim().toLowerCase();
      if(_pq && _pq!==focusProd() && RING.indexOf(_pq)>=0) pmSwitch(_pq);
    }catch(e){ console.error('Milestone ?product= switch failed',e); }
  }
  
  if(document.fonts && document.fonts.load){
    var reDraw=function(){ if(EVENT) renderShow(); else render(); };
    Promise.all([document.fonts.load('800 40px Inter'),document.fonts.load('600 20px Inter')]).then(reDraw).catch(function(){});
    /* Gallery's (and the medal frame's) own faces. Canvas text does not ask
       for a web font that nothing on the page uses, so without this Gallery
       drew in the fallback until something else happened to load them. */
    Promise.all(['500 40px Oswald','600 40px Oswald','700 40px Oswald','400 20px "Roboto Mono"','500 20px "Roboto Mono"']
      .map(function(f){ return document.fonts.load(f); })).then(reDraw).catch(function(){});
    document.fonts.ready.then(reDraw);
  }

  try{ if(getParam('generate')==='1' || getParam('generate')==='family'
         || getParam('snap')==='1'){ (function(){
    /* Snapshot mode: three products from the current on-screen configuration,
       instead of twelve across every design. */
    var SNAP=(getParam('snap')==='1');
    /* Family mode: the generic your-route / iconic-route products rather than
       one event's. Same renders, different identity on each row. */
    var FAM=(getParam('generate')==='family');
    var FAMILIES=IS_TRI ? [ {slug:'triathlon', label:'Triathlon', tag:'fam-triathlon'} ] : [
      {slug:'your-route',   label:'Your Route',   tag:'fam-your-route'},
      {slug:'iconic-route', label:'Iconic Route', tag:'fam-iconic'}
    ];
    /* One product per DESIGN per FORMAT. Style is chosen in the customiser,
       never bought, so it is not a variant. */
    var TYPES=['poster','magnet','tee','frame','a4print','digital'];
    /* SEO, per format. Shopify's own columns ("SEO Title", "SEO Description"),
       so an import sets the search listing instead of leaving Shopify to fall
       back on the product title and the first lines of the body.

       The title leads with what people search for, not the internal product
       name - "Iconic Route Street Map Framed A4 Print" is a catalogue entry,
       not a search. The store name is left off: Dawn appends it to the page
       title itself. {design} and {event} are filled per product; {event} is
       blank on generic products and the spacing closes up around it.
       Race names may go here (SEO and body copy) but never in product titles. */
    var SEO_MAX_T=70, SEO_MAX_D=320;
    var SEO_DEF=IS_TRI ? {
      poster:{lab:'Poster', t:'{event} Personalised Triathlon Poster | Swim, Ride, Run',
        d:'Your swim, ride and run on one A3 or A4 poster: each leg on its own map in its own colour, with your splits and finish time. Printed in Sydney and posted flat.'},
      magnet:{lab:'Magnet', t:'{event} Triathlon Fridge Magnet | Swim, Ride, Run',
        d:'All three legs of your triathlon on a 10 \u00d7 12.5 cm magnet, with your splits and finish time. Made in Sydney, sold singly or in packs.'},
      tee:{lab:'Tee', t:'{event} Triathlon T-Shirt | Swim, Ride, Run',
        d:'Wear the race: your swim, ride and run across the chest with your finish time. Printed to order in Brisbane, sizes S\u2013XL.'},
      a4print:{lab:'Framed A4', t:'{event} Framed Triathlon Print | Swim, Ride, Run',
        d:'Your swim, ride and run with your splits and finish time, printed and framed in Sydney on A4, ready to hang out of the box.'},
      digital:{lab:'Digital download', t:'{event} Triathlon Print, Digital Download',
        d:'Your swim, ride and run with your splits and finish time as a high-resolution print file you keep. Emailed after payment.'}
    } : {
      poster:{lab:'Poster',
        t:'{event} Personalised Running Route Poster | {design}',
        d:'Turn your run into wall art: your exact GPS route in the {design} design, personalised with your name, time and pace. Printed in Sydney on A3 or A4 and posted flat.'},
      magnet:{lab:'Magnet',
        t:'{event} Running Route Fridge Magnet | {design}',
        d:'Your run on the fridge: your exact GPS route in the {design} design on a 10 \u00d7 12.5 cm magnet. Made in Sydney, sold singly or in packs.'},
      tee:{lab:'Tee',
        t:'{event} Running Route T-Shirt | {design}',
        d:'Wear the route you ran: your exact GPS route in the {design} design across the chest, with your distance and time. Printed to order in Brisbane, sizes S\u2013XL.'},
      frame:{lab:'Medal frame',
        t:'{event} Race Medal Frame with Route Print | {design}',
        d:'A 25 cm box frame for your race medal, with your exact GPS route printed beside it in the {design} design. Made in Sydney, ready to hang.'},
      a4print:{lab:'Framed A4',
        t:'{event} Framed Running Route Print | {design}',
        d:'Your exact GPS route in the {design} design, personalised with your name, time and pace. Printed and framed in Sydney on A4, ready to hang out of the box.'},
      digital:{lab:'Digital download',
        t:'{event} Running Route Print, Digital Download | {design}',
        d:'Your exact GPS route in the {design} design as files you keep: a high-resolution A3 print file, a phone wallpaper and a six-second reel of your route drawing itself, all in this design. Emailed after payment.'}
    };
    function seoAttr(v){ return String(v).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }
    /* Built from TYPES, so a seventh format gets its fields without anyone
       remembering to add them here. */
    function seoFieldsHtml(){
      var h='<details id="g-seo" style="margin:6px 0 10px;border:1px solid #2a2a31;border-radius:8px;padding:8px 10px">'
        +'<summary style="cursor:pointer;font-size:12px;font-weight:700;color:#d8d4ca">SEO \u2014 search listing per format</summary>'
        +'<p style="margin:8px 0;color:#8d8a82;font-size:11px">Goes into Shopify\u2019s SEO title and description. <b>{design}</b> and <b>{event}</b> are filled in per product; {event} is blank on generic products. Titles over '+SEO_MAX_T+' characters and descriptions over '+SEO_MAX_D+' are trimmed at a word. Leave the store name off \u2014 Dawn adds it to the title. Race names are fine here, never in product titles.</p>';
      TYPES.forEach(function(t){
        var d=SEO_DEF[t]||{lab:t,t:'',d:''};
        h+='<label style="font-size:11px;color:#8d8a82">'+seoAttr(d.lab)+' \u2014 SEO title</label>'
          +'<input id="g-seot-'+t+'" type="text" value="'+seoAttr(d.t)+'" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px;font-size:12px">'
          +'<label style="font-size:11px;color:#8d8a82">'+seoAttr(d.lab)+' \u2014 SEO description</label>'
          +'<textarea id="g-seod-'+t+'" style="width:100%;box-sizing:border-box;height:52px;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'+seoAttr(d.d)+'</textarea>';
      });
      h+='<label style="font-size:11px;color:#8d8a82">Extra tags, added to every product (comma separated)</label>'
        +'<input id="g-tags-extra" type="text" value="" placeholder="e.g. running gift, marathon gift" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px;font-size:12px">'
        +'<p style="margin:0;color:#7d7a72;font-size:11px">Tags drive collections and store search, not Google. The family and design tags are always added.</p>'
        +'</details>';
      return h;
    }
    var seoTrim=0;
    function seoFill(tpl,p,ename){
      var v=String(tpl||'')
        .replace(/\{event\}/g, ename||'')
        .replace(/\{design\}/g, (p.design&&p.design.label)||'')
        .replace(/\{title\}/g, p.title||'')
        .replace(/\{format\}/g, (typeof TYPE_LABEL!=='undefined'&&TYPE_LABEL[p.type])||'');
      /* An empty {event} or {design} leaves a dangling separator or a double
         space; close both up. */
      return v.replace(/\s+/g,' ')
              .replace(/\|(\s*\|)+/g,'|').replace(/^[\s|:,\u2013\u2014-]+|[\s|:,\u2013\u2014-]+$/g,'')
              .trim();
    }
    function seoCut(v,n){
      if(v.length<=n) return v;
      seoTrim++;
      var c=v.slice(0,n+1), i=c.lastIndexOf(' ');
      c=(i>n*0.6)?c.slice(0,i):v.slice(0,n);
      return c.replace(/[\s|:,;\u2013\u2014-]+$/,'');
    }
    function seoTrimNote(){
      return seoTrim?(' \u00b7 '+seoTrim+' SEO field'+(seoTrim>1?'s':'')+' trimmed to fit Shopify\u2019s limit'):'';
    }
    /* formats: not frame,a4print,digital - these take the standard style via
       the fallback at the call site. */
    var MAPSTYLE_FOR={magnet:'dark',poster:'dark',tee:'standard'};
    var EDITIONS=[{style:'neon',label:'Neon'},{style:'heat',label:'Elevation'},{style:'map',label:'Map'},{style:'terrain',label:'Terrain'}];
    var DESIGNS=IS_TRI ? [
      {kind:'triathlon', slug:'triathlon', label:'Triathlon', style:'neon', types:['poster','magnet','tee','a4print','digital']}
    ] : [
      {kind:'',             slug:'neon',     label:'Neon',        style:'neon',    types:['poster','magnet','tee','frame','a4print','digital']},
      {kind:'editorial',    slug:'editorial',label:'Street Map',  style:'map',     types:['poster','magnet','tee','frame','a4print','digital']},
      {kind:'terrain',      slug:'terrain',  label:'Terrain',     style:'terrain', types:['poster','magnet','tee','frame','a4print','digital']},
      {kind:'photo-overlay',slug:'photo',    label:'Full Photo',  style:'neon',    types:['poster','magnet','tee','frame','a4print','digital']},
      /* formats: not frame - the medal frame's right column belongs to the
         medal, so Gallery cannot be two side-by-side panels there. The brief
         proposes splitting Design D's LEFT panel instead; until Marc confirms
         that, gallery stays off the frame. */
      {kind:'gallery',      slug:'gallery',  label:'Gallery',     style:'map',     types:['poster','magnet','tee','a4print','digital']},
      /* formats: not tee,frame - Stat Bar is the 5K Run's design (spec 2):
         poster (A3 / A4), framed A4, magnet and the Digital Pack. Offered on
         that sport only. */
      {kind:'statbar',      slug:'statbar',  label:'Stat Bar',    style:'map',     types:['poster','magnet','a4print','digital']},
      /* 28 Oct: the six from the 100-design canvas - no tee, no medal frame,
         as Stat Bar. */
      {kind:'manifesto',    slug:'manifesto',label:'Manifesto',   style:'map',     types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame */
      {kind:'rings',        slug:'rings',    label:'Rings',       style:'terrain', types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame */
      {kind:'dashboard',    slug:'dashboard',label:'Dashboard',   style:'map',     types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame */
      {kind:'cover',        slug:'cover',    label:'Cover Story', style:'neon',    types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame */
      {kind:'card',         slug:'card',     label:'Trading Card',style:'neon',    types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame */
      {kind:'horizon',      slug:'horizon',  label:'Horizon Split',style:'neon',   types:['poster','magnet','a4print','digital']},
      /* formats: not tee,frame - 3D (28 Oct pm): paper, magnet and the Digital Pack */
      {kind:'3d',           slug:'3d',       label:'Skyline',     style:'map',     types:['poster','magnet','a4print','digital']}
    ];
    var TEE_SIZES=['S','M','L','XL'];
    var MAGNET_PACKS=[{v:'1 magnet',p:'25.00'},{v:'2 magnets',p:'42.00'},
                      {v:'3 magnets',p:'55.00'},{v:'4 magnets',p:'65.00'}];
    var DESIGN_LEDE={
      '':'Your route rendered as glowing neon line art.',
      'editorial':'Your route drawn over a clean street map, in a quiet editorial layout.',
      'terrain':'Your route across the real terrain, so the hills you felt are the hills you see.',
      'photo-overlay':'Your race-day photo fills the frame, with your route laid over it.',
      'gallery':'Your route on a street map beside your favourite race-day photo.',
      'triathlon':'Your swim, ride and run on one piece: each leg on its own map, with your splits and finish time.',
      'statbar':'Your 5K on a street map in your colours, with your time, run number and place beside your photo.',
      'manifesto':'Your day as one sentence, set large - the date, the distance, the place and your time - with your route beneath.',
      'rings':'Your course as a clock face: the distance round the dial, every climb lit, the terrain at its heart.',
      'dashboard':'Your race as an instrument cluster: gauges, a trip computer and your route glowing on the map screen.',
      'cover':'You on the cover: your race-day photo as a magazine cover, your stats as big cover lines and your route on the cover.',
      'card':'Your own player card, edge to edge: your photo in the window with your route glowing in the corner, your ratings and your stats.',
      'horizon':'Your route glowing over your own photo in blue-toned black and white, the course elevation as the horizon and your stats below.',
      '3d':'Your route on a tilted 3D night map of the real hills, with the sky on the horizon and your stats below.'
    };
    /* Family mode has no event name field, and this is read from inside
       buildCSV() whichever mode is running - so it must not assume either
       input is on the page. */
    function gv(id){ var e=g(id); return e?((e.value||'').trim()):''; }
    function evSlug(){
      return (gv('g-slug')||slug(gv('g-name'))).replace(/^-+|-+$/g,'');
    }
    /* Snapshot handles must not collide with the generate=1 set, and must
       distinguish one design rendered two ways (editorial on map tiles vs
       editorial on terrain). Style, and the ribbon, are part of the identity. */
    var SNAP_ID=null;
    function snapVariant(){
      if(state.style==='map') return state.mapStyle||'standard';
      if(state.style==='terrain') return state.terrainTheme||'standard';
      return '';
    }
    function snapSeg(){
      if(SNAP_ID) return SNAP_ID.seg;
      var base=(DESIGN_KIND==='editorial')?'editorial'
              :(DESIGN_KIND==='terrain')?'terrain'
              :(DESIGN_KIND==='gallery')?'gallery'
              :(DESIGN_KIND==='statbar')?'statbar'
              :(DESIGN_KIND==='manifesto'||DESIGN_KIND==='rings'||DESIGN_KIND==='dashboard'||DESIGN_KIND==='cover'||DESIGN_KIND==='card'||DESIGN_KIND==='horizon'||DESIGN_KIND==='3d')?DESIGN_KIND
              :(DESIGN_KIND==='photo-overlay')?'photo':'neon';
      var st=(state.style||'neon');
      var seg=base+'-'+st;
      var vr=snapVariant(); if(vr) seg+='-'+vr;
      if(typeof ribbonOn==='function' && ribbonOn()) seg+='-r';
      if(typeof sfOn==='function' && sfOn()) seg+='-sf';
      if(typeof kmOn==='function' && kmOn()) seg+='-km';
      return seg;
    }
    function handleFor(d,type){
      return evSlug()+'-'+(SNAP?snapSeg():d.slug)+'-'+type;
    }

    var STYLE_LABEL={neon:'Neon',heat:'Elevation',map:'Map',terrain:'Terrain'};
    function setDesignKind(k){
      DESIGN_KIND=k||''; IS_SPLIT=(DESIGN_KIND==='photo-split'); IS_EDT=(DESIGN_KIND==='editorial');
      IS_TD=(DESIGN_KIND==='terrain'); IS_PO=(DESIGN_KIND==='photo-overlay');
      IS_GAL=(DESIGN_KIND==='gallery');
      kindAttr();
    }

    var w=document.createElement('div');
    w.setAttribute('style','position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#17171A;color:#F3EFE7;font:14px/1.45 -apple-system,system-ui,sans-serif;padding:16px 16px calc(16px + env(safe-area-inset-bottom));box-shadow:0 -12px 40px rgba(0,0,0,.55);max-height:82vh;overflow:auto');
    w.innerHTML=
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><b style="font-size:15px">'+(SNAP?'Snapshot \u2014 3 products from this exact look':(FAM?(IS_TRI?'Triathlon product generator \u2014 triathlon-poster, -magnet, -tee, -a4print, -digital':'Generic product generator \u2014 your-route / iconic-route'):'Event collection generator'))+'</b><button id="g-x" style="background:none;border:none;color:#F3EFE7;font-size:22px;line-height:1;cursor:pointer">\u00d7</button></div>'
      +(FAM
        ?('<p style="margin:0 0 10px;color:#b7b2a6;font-size:12px">These are the <b>generic</b> products \u2014 the ones a customer lands on to upload their own GPX. The route loaded above is only the showcase: whatever is on screen is what the product photos will show, so load something good-looking and set a neutral printed title. No route or date is saved onto these products.</p>'
          +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Families</label>'
          +'<div id="g-fams" style="display:flex;gap:14px;flex-wrap:wrap;margin:0 0 10px"></div>'
          +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Designs</label>'
          +'<div id="g-desgs" style="display:flex;gap:14px;flex-wrap:wrap;margin:0 0 10px"></div>'
          +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Formats</label>'
          +'<div id="g-fmts" style="display:flex;gap:14px;flex-wrap:wrap;margin:0 0 10px"></div>'
          +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Handle pattern</label>'
          +'<input id="g-hpat" type="text" value="'+(IS_TRI?'{family}-{format}':'{family}-{design}-{format}')+'" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 6px">'
          +'<p style="margin:0 0 4px;color:#8d8a82;font-size:11px">A handle that already exists is updated on import; one that does not is created as a NEW product. Check these against your store before importing.</p>'
          +'<div id="g-hprev" style="font:11.5px/1.6 ui-monospace,Menlo,monospace;color:#b7b2a6;background:#0f0f12;border:1px solid #2a2a31;border-radius:8px;padding:8px 10px;margin:0 0 10px;max-height:160px;overflow:auto;white-space:pre-wrap"></div>')
        :'<p style="margin:0 0 10px;color:#b7b2a6;font-size:12px">Load the GPX above and set the <b>printed</b> title / distance / date (what\u2019s baked on the product). Then enter the <b>store-facing</b> collection name below \u2014 distance-based, no event trademark \u2014 and generate.</p>')
      +(FAM?'':'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Collection / product name (store-facing)</label>'
      +'<input id="g-name" type="text" placeholder="e.g. Gold Coast 42.2K 2026" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 10px">')
      +'<div style="border-top:1px solid #2a2a31;margin:2px 0 10px;padding-top:10px">'
      +'<p style="margin:0 0 8px;color:#b7b2a6;font-size:12px"><span data-ev="1">These pre-fill the <b>Create your own</b> link in each product description, so a customer arrives with this route, distance and date already loaded, on the product they were viewing.</span></p>'
      +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">GPX file URL (must allow cross-origin fetch)</label>'
      +'<input id="g-gpx" type="url" placeholder="https://res.cloudinary.com/.../gold-coast-2026.gpx" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 8px">'
      +'<button id="g-load" style="width:100%;padding:9px;margin:0 0 10px;border:1px solid #3a3a42;border-radius:8px;background:#0f0f12;color:#FF5A1F;font-weight:700;cursor:pointer">Load this GPX into the preview</button>'
      +'<div data-ev="1"><label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Location</label>'
      +'<input id="g-loc" type="text" placeholder="Gold Coast, Australia" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 8px">'
      +'</div><div data-ev="1" style="display:flex;gap:8px">'
      +'<div style="flex:1"><label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Distance</label>'
      +'<input id="g-dist" type="text" placeholder="42.2 km" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff"></div>'
      +'<div style="flex:1"><label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Date</label>'
      +'<input id="g-date" type="date" style="width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff"></div>'
      +'</div><div id="g-link" data-ev="1" style="font-size:11px;color:#7d7a72;margin-top:8px;word-break:break-all"></div>'
      +'<div style="border-top:1px solid #2a2a31;margin:10px 0 0;padding-top:10px">'
      +'<label style="display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px">Route track \u2014 paste into this route\u2019s metaobject</label>'
      +'<p style="margin:0 0 6px;color:#8d8a82;font-size:11px">The whole route as text, about 9 KB. On the <b>track</b> field of the route metaobject entry (multi-line text) it replaces the GPX download on every page that opens this route \u2014 which is what makes the editorial design land in well under a second. The GPX URL above stays as the fallback.</p>'
      +'<button id="g-trackbtn" type="button" style="width:100%;padding:9px;margin:0 0 6px;border:1px solid #3a3a42;border-radius:8px;background:#0f0f12;color:#FF5A1F;font-weight:700;cursor:pointer">Get the track for the route loaded above</button>'
      +'<textarea id="g-track" readonly placeholder="Load a GPX into the preview first, then press the button." style="width:100%;box-sizing:border-box;height:64px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#9f9c94;font:11px/1.4 ui-monospace,Menlo,monospace"></textarea>'
      +'<div id="g-tracknote" style="font-size:11px;color:#7d7a72;margin-top:4px"></div></div></div>'
      +'<div style="border-top:1px solid #2a2a31;margin:2px 0 10px;padding-top:10px">'
      +'<div data-ev="1"><label style="font-size:11px;color:#8d8a82">Event slug (handles + design_code + tag)</label>'
      +'<input id="g-slug" type="text" placeholder="auto from event name" style="width:100%;box-sizing:border-box;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 8px">'
      +'<div id="g-preview" style="font:11px/1.5 ui-monospace,Menlo,monospace;color:#7d7a72;margin:0 0 10px;white-space:pre-wrap"></div>'
      +'<label style="font-size:11px;color:#8d8a82">Collection title</label>'
      +'<input id="g-colltitle" type="text" placeholder="Gold Coast Marathon 2026" style="width:100%;box-sizing:border-box;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 8px">'
      +'<label style="font-size:11px;color:#8d8a82">Collection description</label>'
      +'<textarea id="g-colldesc" style="width:100%;box-sizing:border-box;height:56px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 10px"></textarea>'
      +'</div>'
      +'<label style="font-size:11px;color:#8d8a82">Poster description</label>'
      +'<textarea id="g-desc-poster" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">Printed edge to edge on A3 (297 \u00d7 420 mm) or A4 (210 \u00d7 297 mm).\n\nPrinted and prepared by hand in Sydney on premium heavyweight paper, and shipped flat in a rigid mailer \u2014 never rolled, because a rolled print never quite lies flat again and the crease always lands somewhere you\u2019ll notice. Want it framed? The Framed A4 is a separate format, assembled here and ready to hang.</textarea>'
      +'<input id="g-spec-poster" type="text" value="A3 or A4 \u00b7 unframed" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'
      +'<label style="font-size:11px;color:#8d8a82">Tee description</label>'
      +'<textarea id="g-desc-tee" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">Printed on soft, mid-weight cotton with a true-to-size unisex fit, S\u2013XL.\n\nThe route sits across the chest at a size you can read from across a room, with your distance and time underneath. Wear it to the next start line, or to the pub afterwards.</textarea>'
      +'<input id="g-spec-tee" type="text" value="Unisex \u00b7 S\u2013XL" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'
      +'<label style="font-size:11px;color:#8d8a82">Digital download description</label>'
      +'<textarea id="g-desc-digital" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">Three files in this design, emailed as soon as your payment goes through. Nothing is posted.\n\nWHAT YOU GET\n\u2022 A3 print file \u2014 a 3508 \u00d7 4961 px PNG, a true 300 DPI at A3 (29.7 \u00d7 42 cm). Photo-heavy artwork such as Terrain and Full Photo comes as a 3000 \u00d7 4243 px JPEG instead, 256 DPI at A3, so the file stays small enough to email. Either prints sharply at A3 and scales down to A4 cleanly.\n\u2022 Phone wallpaper \u2014 a 1440 \u00d7 3200 px PNG in this design, laid out for a phone rather than cropped from the poster, with the top kept clear for the clock.\n\u2022 Route reel \u2014 a six-second 1080 \u00d7 1920 MP4 of your route drawing itself in this design, then your title and stats appearing. Sized for Instagram Reels and Stories and for TikTok, with no sound, so you can add your own track.\n\nHOW YOU GET THEM\n1. Build your route above and add it to the cart \u2014 your files are made there and then, which takes a few seconds.\n2. Check out.\n3. Your download links arrive by email with your order confirmation. Check your junk folder if you cannot see it.\n4. Save all three files, then print the A3 one wherever suits you.\n\nFiles cannot be returned once they have been sent, but if anything is wrong with yours, email us and we will sort it out.</textarea>'
      +'<input id="g-spec-digital" type="text" value="Three files \u00b7 A3 print file, 256\u2013300 DPI \u00b7 wallpaper \u00b7 reel" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'
      +'<label style="font-size:11px;color:#8d8a82">Framed A4 description</label>'
      +'<textarea id="g-desc-a4print" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">Printed on A4 (210 \u00d7 297 mm) and supplied in a slim black frame with a shatter-resistant acrylic front, ready to hang straight out of the box.\n\nPrinted and framed by hand in Sydney on premium heavyweight paper, then boxed with corner protection. Nothing to assemble and nothing to buy separately.</textarea>'
      +'<input id="g-spec-a4print" type="text" value="A4 \u00b7 21 \u00d7 29.7 cm \u00b7 framed" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'
      +'<label style="font-size:11px;color:#8d8a82">Medal frame description</label>'
      +'<textarea id="g-desc-frame" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">A 25 \u00d7 25 cm deep box frame with a printed insert made from your route, ready for your own medal to hang in front of it.\n\nThe insert is printed and trimmed by hand in Sydney. The medal in the photos is an illustration \u2014 the real one is yours.</textarea>'
      +'<input id="g-spec-frame" type="text" value="25 \u00d7 25 cm \u00b7 6 cm deep" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 10px;font-size:12px">'
      +'<label style="font-size:11px;color:#8d8a82">Magnet description</label>'
      +'<textarea id="g-desc-magnet" style="width:100%;box-sizing:border-box;height:70px;padding:9px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 4px">10 \u00d7 12.5 cm on photo paper, mounted on a flexible magnetic sheet and made in Sydney. Small enough to live on the fridge, sturdy enough to survive the door slamming.\n\nAvailable singly or in packs \u2014 most people end up buying one for themselves and one for whoever waited at the finish line.</textarea>'
      +'<input id="g-spec-magnet" type="text" value="10 \u00d7 12.5 cm" style="width:100%;box-sizing:border-box;padding:8px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#b7b2a6;margin:0 0 4px;font-size:12px">'
      +seoFieldsHtml()
      +'</div>'
      +'<button id="g-run" style="width:100%;padding:13px;border:none;border-radius:10px;background:#FF5A1F;color:#fff;font-weight:700;font-size:15px;cursor:pointer">'+(FAM?'Generate generic products':'Generate all products')+'</button>'
      +'<div id="g-status" style="font-size:12px;color:#b7b2a6;margin-top:10px;min-height:16px"></div>'
      +'<textarea id="g-out" readonly style="display:none;width:100%;box-sizing:border-box;height:170px;margin-top:8px;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#cfe9cf;font:12px/1.4 ui-monospace,Menlo,monospace"></textarea>'
      +'<div id="g-act" style="display:none;gap:8px;margin-top:8px"><button id="g-csv" style="flex:1;padding:10px;border:none;border-radius:8px;background:#FF5A1F;color:#fff;font-weight:700;cursor:pointer">Download products CSV</button><button id="g-dl" style="flex:1;padding:10px;border:1px solid #3a3a42;border-radius:8px;background:#0f0f12;color:#fff;cursor:pointer">Print files (.json)</button></div>';
    document.body.appendChild(w);
    var g=function(id){return w.querySelector('#'+id);};
    var setS=function(t){ g('g-status').textContent=t; };
    g('g-x').onclick=function(){ w.remove(); };

    /* ---- family mode: the pickers, and a preview of what will be created --- */
    function famPicked(){
      return FAMILIES.filter(function(f){
        var b=g('g-fam-'+f.slug); return b && b.checked;
      });
    }
    /* Which designs this run covers. Falls back to all of them when the row is
       absent - event mode has no such row, and a missing checkbox must not
       silently mean "render nothing". */
    function designPicked(){
      var row=g('g-desgs');
      if(!row) return DESIGNS.filter(function(d){ return !d.sports || d.sports.indexOf(SPORT)>=0; });
      return DESIGNS.filter(function(d){
        var b=g('g-desg-'+(d.slug||'neon')); return b && b.checked;
      });
    }
    function fmtPicked(){
      return TYPES.filter(function(t){
        var b=g('g-fmt-'+t); return b && b.checked;
      });
    }
    function famHandle(famSlug, designSlug, type){
      return String((g('g-hpat')&&g('g-hpat').value)||'{family}-{design}-{format}')
        .replace(/\{family\}/g, famSlug)
        .replace(/\{design\}/g, designSlug)
        .replace(/\{format\}/g, type)
        .trim().replace(/^-+|-+$/g,'');
    }
    function famPreview(){
      var el=g('g-hprev'); if(!el) return;
      var fams=famPicked(), fmts=fmtPicked(), out=[];
      designPicked().forEach(function(d){
        fams.forEach(function(f){
          /* Only the formats this design is actually built for: Gallery has no
             medal frame, and a handle for one would be imported as a product
             nothing can render. */
          fmts.forEach(function(t){
            if(d.types.indexOf(t)<0) return;
            out.push(famHandle(f.slug,d.slug,t));
          });
        });
      });
      if(!out.length){ el.textContent='Nothing selected.'; return; }
      /* Every one of them, not a sample - the point is to read the list against
         the store before importing, and a truncated list hides the one that is
         wrong. */
      el.textContent=out.length+' product'+(out.length===1?'':'s')+'\n'+out.join('\n');
    }
    if(FAM){
      /* Hidden, not removed: evSlug(), the GPX loader and the link preview all
         reach for these by id, and family mode is not the place to find out
         which of those reads is unguarded. */
      Array.prototype.forEach.call(w.querySelectorAll('[data-ev]'),function(el){
        el.style.display='none';
      });
      (function(){
        var fr=g('g-fams'), tr=g('g-fmts'), dr=g('g-desgs');
        var box='margin:0 6px 0 0;vertical-align:-1px';
        var lab='font-size:12.5px;color:#F3EFE7;cursor:pointer;white-space:nowrap';
        if(fr) fr.innerHTML=FAMILIES.map(function(f){
          return '<label style="'+lab+'"><input type="checkbox" id="g-fam-'+f.slug+
                 '" checked style="'+box+'">'+f.label+'</label>';
        }).join('');
        /* ?generate=family&designs=gallery,terrain pre-ticks just those, so a
           repeat run for one design is a bookmark rather than five clicks.
           An unknown name is ignored rather than silently emptying the row -
           a typo should not look like "nothing to generate". */
        var _wantD=String(getParam('designs')||'').toLowerCase().split(',')
                     .map(function(x){ return x.trim(); }).filter(Boolean);
        var _known={}; DESIGNS.forEach(function(d){ _known[d.slug||'neon']=1; });
        var _badD=_wantD.filter(function(x){ return !_known[x]; });
        _wantD=_wantD.filter(function(x){ return _known[x]; });
        if(dr) dr.innerHTML=DESIGNS.map(function(d){
          var sl=d.slug||'neon';
          /* A sport's own design (Stat Bar) is ticked only when named, or
             when the route on screen is that sport. */
          var on=_wantD.length ? (_wantD.indexOf(sl)>=0) : (!d.sports || d.sports.indexOf(SPORT)>=0);
          return '<label style="'+lab+'"><input type="checkbox" id="g-desg-'+sl+
                 '"'+(on?' checked':'')+' style="'+box+'">'+d.label+'</label>';
        }).join('');
        if(_badD.length && dr){
          var _wd=document.createElement('div');
          _wd.style.cssText='color:#e0a23a;font-size:11.5px;margin:4px 0 0;flex-basis:100%';
          _wd.textContent='\u26a0 Not a design: '+_badD.join(', ')+
            '. Known: '+Object.keys(_known).join(', ')+'.';
          dr.appendChild(_wd);
        }
        if(tr) tr.innerHTML=TYPES.map(function(t){
          /* A format Marc has hidden on the storefront starts unticked - he can
             still generate it deliberately, but a run does not quietly create
             products for something that is not being sold yet. */
          return '<label style="'+lab+'"><input type="checkbox" id="g-fmt-'+t+'"'+
                 (isHidden(t)?'':' checked')+' style="'+box+'">'+(PLABEL[t]||t)+'</label>';
        }).join('');
        FAMILIES.forEach(function(f){ var b=g('g-fam-'+f.slug); if(b) b.onchange=famPreview; });
        DESIGNS.forEach(function(d){ var b=g('g-desg-'+(d.slug||'neon')); if(b) b.onchange=famPreview; });
        TYPES.forEach(function(t){ var b=g('g-fmt-'+t); if(b) b.onchange=famPreview; });
        var hp=g('g-hpat'); if(hp) hp.addEventListener('input',famPreview);
        famPreview();
      })();
    }
    
    g('g-trackbtn').onclick=function(){
      var ta=g('g-track'), note=g('g-tracknote');
      var t=encodePoly(state.coords, state.eles);
      if(!t){
        ta.value=''; note.textContent='No route loaded yet \u2014 load the GPX above first.';
        return;
      }
      ta.value=t;
      note.textContent=t.length.toLocaleString()+' characters \u00b7 '+
        (state.coords?state.coords.length:0)+' points'+
        (state.eles?' with elevation':' (no elevation in this GPX)')+
        ' \u00b7 select all and copy';
      try{ ta.focus(); ta.select(); }catch(e){}
    };
    g('g-load').onclick=function(){
      var u=(g('g-gpx').value||'').trim();
      if(!u){ setS('\u26a0 Paste the GPX file URL first.'); return; }
      setS('Fetching\u2026');
      /* Own fetch so the real failure reason is reported. loadGpxUrl swallows
         its errors, which made every failure look identical. */
      fetch(u).then(function(r){
        if(!r.ok) throw new Error('HTTP '+r.status+' '+r.statusText);
        return r.text();
      }).then(function(txt){
        if(!txt || !txt.length) throw new Error('empty response');
        var gx=parseGPX(txt);
        if(!gx || !gx.coords || gx.coords.length<2){
          throw new Error('no track points found (first bytes: '+txt.slice(0,40).replace(/\s+/g,' ')+')');
        }
        var idx=downsampleIdx(gx.coords.length,3000);
        var cds=idx.map(function(k){return gx.coords[k];}), els=idx.map(function(k){return gx.eles[k];});
        bumpRoute();
        state.coords=cds; state.eles=els; state.mapImg=null; state.mapUrl='';
        state.routeIsDefault=false;
        state.style='neon'; markStyle('neon');
        processToMask(gpxToCanvas(cds)); buildHeatCanvas(cds,els);
        lockRoute('Event'); showClear(true);
        refreshStyles(); render();
        setS('\u2713 Route loaded ('+cds.length+' points). Set the PRINTED title and location in the customiser above, then generate.');
      }).catch(function(e){
        var m=(e&&e.message)||String(e);
        if(/Failed to fetch|NetworkError|Load failed/i.test(m)){
          m='blocked by CORS or unreachable. Open the URL in a browser tab \u2014 if it downloads fine, the server is not sending Access-Control-Allow-Origin.';
        }
        setS('\u2717 '+m);
      });
    };
    g('g-dist').value=($('cz-dist').value||'').trim();
    g('g-date').value=($('cz-date').value||'').trim();
    g('g-loc').value =($('cz-loc').value||'').trim();

    var CUSTOMIZE_BASE=((MSC[72]||'').trim())
                     || ((typeof UPLOAD_LINK!=='undefined' && UPLOAD_LINK)||'').trim();
    function isDefaultRoute(){
      try{
        var c=state.coords;
        if(!c||c.length<2) return true;
        if(typeof BAYRUN==='undefined') return false;
        if(c.length!==BAYRUN.length) return false;
        return Math.abs(c[0][0]-BAYRUN[0][0])<1e-6 && Math.abs(c[0][1]-BAYRUN[0][1])<1e-6;
      }catch(e){ return false; }
    }
    function slug(s){ return String(s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
    function priceOf(t){ return String(PRODUCTS[t].price||'').replace(/[^0-9.]/g,''); }
    function eleOk(){ if(!state.eles) return false; var mn=1/0,mx=-1/0,n=0,i,v; for(i=0;i<state.eles.length;i++){ v=state.eles[i]; if(isFinite(v)){n++; if(v<mn)mn=v; if(v>mx)mx=v;} } return n>2 && (mx-mn)>1; }
    function loadMap(style){ return new Promise(function(res){ state.mapStyle=style; ensureMap(function(){ ensureMap2(function(){ res(); }); }); }); }

    function cap(t){ return t.charAt(0).toUpperCase()+t.slice(1); }
    function dl(fn,txt,mime){ var b=new Blob([txt],{type:mime}); var a=document.createElement('a'); a.href=URL.createObjectURL(b); a.download=fn; a.click(); }
    var TYPE_LABEL={magnet:'Fridge Magnet',poster:'Poster',tee:'T-Shirt',frame:'Medal Frame',
                    a4print:'Framed A4 Print',digital:'Digital Download'};
    var TEE_SIZES=['S','M','L','XL'];
    /* A3 first: Shopify makes the first variant the default, and A3 is the
       anchor price the whole ladder is built from. */
    /* Two, not four. Framed A4 is its own format with its own product, so a
       framed poster variant would sell the same thing twice at two prices, and
       framed A3 is not in the line-up. Matches add_poster_variants.py. */
    var POSTER_SIZES=[{v:'A3',p:'40.00'},{v:'A4',p:'35.00'}];
    var TEE_GUIDE='<h4>Size guide (Bella+Canvas 3001, inches)</h4><table><tr><th>Size</th><th>Chest width</th><th>Body length</th></tr><tr><td>S</td><td>18</td><td>28</td></tr><tr><td>M</td><td>20</td><td>29</td></tr><tr><td>L</td><td>22</td><td>30</td></tr><tr><td>XL</td><td>24</td><td>31</td></tr></table><p>Chest width laid flat, underarm to underarm. Body length from high point of shoulder to hem.</p>';

    function createLink(type){
      var q=[], add=function(k,v){ v=String(v==null?'':v).trim(); if(v) q.push(k+'='+encodeURIComponent(v)); };
      var gpx=(g('g-gpx').value||'').trim();

      
      if(gpx){ add('gpx',gpx); add('dist',g('g-dist').value); add('date',g('g-date').value);
               add('name',$('cz-title').value); add('loc',g('g-loc').value); }
      if(type) q.push('product='+encodeURIComponent(type));
      if(arguments.length>1 && arguments[1]) q.push('design='+encodeURIComponent(arguments[1]));
      if(arguments.length>2 && arguments[2]) q.push('style='+encodeURIComponent(arguments[2]));
      var cbase=CUSTOMIZE_BASE;
      return cbase+(q.length?('?'+q.join('&')):'');
    }
    function esc(u){ return String(u).replace(/&/g,'&amp;'); }   
    function bodyFor(type,ename){ var p='<p>Your route from '+ename+', as a '+TYPE_LABEL[type].toLowerCase()+'. Made to order and printed just for you.</p>'
      +'<p>Add your name, finish time and pace above, or upload your own GPX \u2014 the preview updates as you type.</p>';
      if(type==='tee') p+=TEE_GUIDE; return p; }
    function refreshLinkPreview(){ var el=g('g-link'); if(!el) return;
      var gpx=(g('g-gpx').value||'').trim();
      el.style.color=gpx?'#7d7a72':'#e0a03a';
      el.textContent=(CUSTOMIZE_BASE?'\u2713 Links go to: ':'\u26a0 No your-route destination resolved. ')
        +(gpx?'':'(no GPX URL) ')+createLink('poster'); }
    ['g-gpx','g-dist','g-date','g-loc'].forEach(function(id){ var e=g(id); if(e) e.addEventListener('input',refreshLinkPreview); });
    refreshLinkPreview();

    function mockIdxList(prod){ var mk=mockKey(prod), a=[0],i; for(i=1;i<MOCKUPS[mk].length;i++){ if(mockImgs[mk][i]) a.push(i); } return a; }
    function mockBlobNow(idx){ return new Promise(function(res){
      var pv=state.view, pi=state.mockIdx; state.view='mockup'; state.mockIdx=idx;
      try{ var c=document.createElement('canvas'); c.width=1000; c.height=1000; paint(c.getContext('2d'),1000,1000,false);
        c.toBlob(function(b){ state.view=pv; state.mockIdx=pi; res(b); },'image/png'); }
      catch(e){ state.view=pv; state.mockIdx=pi; res(null); }
    }); }
    function upBlob(b){ return b?cloudUpload(b).catch(function(){return null;}):Promise.resolve(null); }

    function renderProduct(type,ed,prog,kind){
      setDesignKind(kind); state.product=type; state.style=ed.style;
      var pre=Promise.resolve();
      /* The triathlon's own maps, for this format's shape, before it is drawn. */
      if(IS_TRI) pre=triReady(type);
      /* Editorial's map panel is drawn against the light (positron) theme.
         MAPSTYLE_FOR is tuned for the dark neon design, so it would fill half
         the cream poster with dark tiles. */
      var tileStyle=ed.mapStyle ? ed.mapStyle
                   : (tileThemeFor(kind)||MAPSTYLE_FOR[type]);
      if(ed.terrainTheme) state.terrainTheme=ed.terrainTheme;
      if(isMapLike(ed.style)){
        /* Drop whatever the LAST job left behind before asking for this one's.
           loadMap resolves whether or not a map arrived, so the guard below was
           satisfied by the previous design's bitmap: with Terrain rendering
           just before Gallery, a Gallery product was generated with Terrain's
           tiles in its map panel and counted as a success. */
        state.mapImg=null; state.mapUrl='';
        pre=loadMap(tileStyle);
      }
      return pre.then(function(){
        if(isMapLike(ed.style) && !state.mapImg) return {type:type,edition:ed.label,kind:kind,error:ed.style+' tiles not loaded'};
        if(IS_TRI && triMissing(type)) return {type:type,edition:ed.label,kind:kind,error:'triathlon '+(TRI.mode==='terrain'?'terrain':'maps')+' not loaded'};
        return flatBlob().then(upBlob).then(function(flatUrl){
          if(!flatUrl) return {type:type,edition:ed.label,kind:kind,error:'render/upload failed'};
          var idxs=mockIdxList(type), imgs=[];
          return idxs.reduce(function(ch,idx){ return ch.then(function(){
            return mockBlobNow(idx).then(upBlob).then(function(u){ if(u) imgs.push(u); prog&&prog(); });
          }); }, Promise.resolve()).then(function(){
            
            return { type:type, edition:ed.label, kind:kind, mapStyle:(isMapLike(ed.style)?tileStyle:null), printUrl:flatUrl, images:imgs.concat([flatUrl]) };
          });
        });
      });
    }

    var MF={
      code :'Design code (product.metafields.custom.design_code)',
      kind :'design kind (product.metafields.custom.design_kind)',
      thumb:'Design thumb (product.metafields.custom.design_thumb)',
      spec :'Size spec (product.metafields.custom.size_spec)',
      gpx  :'Default GPX (product.metafields.custom.default_gpx)',
      poly :'Route track (product.metafields.custom.route_poly)',
      title:'Default title (product.metafields.custom.default_title)',
      loc  :'Default location (product.metafields.custom.default_location)',
      dist :'Default distance (product.metafields.custom.default_distance)',
      date :'Default date (product.metafields.custom.default_date)',
      style:'default style (product.metafields.custom.default_style)',
      ribbon:'Default ribbon (product.metafields.custom.default_ribbon)',
      seg  :'Handle segment (product.metafields.custom.handle_seg)'
    };
    function csvEsc(v){ v=(v==null?'':String(v)); return '"'+v.replace(/"/g,'""')+'"'; }
    function buildCSV(ename, tag, prods){
      var cols=['Handle','Title','Body (HTML)','Vendor','Type','Tags','Published',
        'Option1 Name','Option1 Value','Variant SKU','Variant Inventory Policy',
        'Variant Fulfillment Service','Variant Price','Variant Requires Shipping',
        'Variant Taxable','Variant Image','Image Src','Image Position','Image Alt Text','Status',
        /* Shopify's own product columns, spelled as in the CSV layout this
           file uses (the one with "Body (HTML)" and "Image Src"). */
        'SEO Title','SEO Description',
        /* verbatim from the store's own export - Shopify keys on the
           parenthetical, and these are the keys the section actually reads */
        MF.code, MF.kind, MF.thumb, MF.spec,
        MF.gpx, MF.poly, MF.title, MF.loc, MF.dist, MF.date, MF.style, MF.ribbon, MF.seg];
      function row(o){ return cols.map(function(c){ return csvEsc(o[c]); }).join(','); }
      var lines=[cols.map(csvEsc).join(',')];
      var code=evSlug();
      var gpx=(g('g-gpx').value||'').trim();
      /* The track as it stands right now: the same downsampled arrays the
         engine would have parsed out of that GPX. Encoded once, not per row -
         every product in this run shares the one route. */
      var _polyNow=encodePoly(state.coords, state.eles);
      var dTitle=($('cz-title').value||'').trim();
      var dLoc=($('cz-loc').value||'').trim();
      var dDist=($('cz-dist').value||'').trim();
      var dDate=($('cz-date').value||'').trim();
      function fdesc(t){ var e=g('g-desc-'+t); return e?(e.value||'').trim():''; }
      function fspec(t){ var e=g('g-spec-'+t); return e?(e.value||'').trim():''; }
      function fseo(k,t){ var e=g('g-seo'+k+'-'+t);
        return e?(e.value||''):((SEO_DEF[t]||{})[k]||''); }
      var _xtags=((g('g-tags-extra')||{value:''}).value||'').split(',')
        .map(function(v){ return v.trim(); }).filter(Boolean);
      seoTrim=0;

      prods.forEach(function(p){
        /* Family mode supplies its own identity per row; event mode derives it
           from the event. One writer, two callers. */
        var handle=p.handle||handleFor(p.design,p.type);
        var gallery=[], seen={};
        p.images.forEach(function(u){ if(u&&!seen[u]){ seen[u]=1; gallery.push(u); } });

        var opts;
        if(p.type==='tee')        opts=TEE_SIZES.map(function(s){ return {name:'Size',val:s,price:p.price}; });
        else if(p.type==='magnet')opts=MAGNET_PACKS.map(function(m){ return {name:'Pack',val:m.v,price:m.p}; });
        else if(p.type==='poster')opts=POSTER_SIZES.map(function(z){ return {name:'Size',val:z.v,price:z.p}; });
        else                      opts=[{name:'',val:'',price:p.price}];

        opts.forEach(function(v,vi){
          var o={Handle:handle};
          if(vi===0){
            o.Title=p.title;
            o['Body (HTML)']='<p>'+(DESIGN_LEDE[p.design.kind]||'')+'</p>'+
                             '<p>'+fdesc(p.type).replace(/\n{2,}/g,'</p><p>')+'</p>';
            o.Vendor='Milestone'; o.Type=(IS_TRI?'Triathlon ':'')+TYPE_LABEL[p.type];
            o.Tags=p.tags||[tag,'fam-your-route',p.design.label].filter(Boolean).join(', ');
            if(_xtags.length){
              var _tg=o.Tags.split(',').map(function(v){ return v.trim(); }).filter(Boolean), _lc={};
              _tg.forEach(function(v){ _lc[v.toLowerCase()]=1; });
              _xtags.forEach(function(v){ if(!_lc[v.toLowerCase()]){ _lc[v.toLowerCase()]=1; _tg.push(v); } });
              o.Tags=_tg.join(', ');
            }
            o['SEO Title']=seoCut(seoFill(fseo('t',p.type),p,ename),SEO_MAX_T);
            o['SEO Description']=seoCut(seoFill(fseo('d',p.type),p,ename),SEO_MAX_D);
            o.Published='TRUE'; o.Status='active';
            o[MF.code]=p.code||code;   o[MF.kind]=p.design.kind||'';
            o[MF.thumb]=p.flatUrl||''; o[MF.spec]=fspec(p.type);
            /* A generic product must not carry an event's route, title or
               date: the customer brings their own, and a stale default is
               worse than none. Only the design's style is kept. */
            if(!p.noDefaults){
              /* Alongside the GPX URL, not instead of it: the URL is what a
                 customer's "create your own" link carries, and it is the
                 fallback if this column never makes it through an import. */
              o[MF.gpx]=gpx;     o[MF.poly]=_polyNow;
              o[MF.title]=dTitle;
              o[MF.loc]=dLoc;    o[MF.dist]=dDist;
              o[MF.date]=dDate;
            }
            /* 'map:light', not a bare 'map', for a design drawn against the
               light palette. default_style already carries that shape - it is
               what snapshot products store - and the product page's parser
               splits on the colon and presses the Light tab. Without it the
               stored default says only 'map' and the palette is left to the
               page's start-up override to supply. */
            var _dsty=p.design.style;
            var _dtile=(typeof tileThemeFor==='function')?tileThemeFor(p.design.kind):'';
            if(_dtile && _dsty==='map') _dsty=_dsty+':'+_dtile;
            o[MF.style]=(SNAP && SNAP_ID)?SNAP_ID.styleVal:_dsty;
            /* Without these the product page cannot reproduce the look it
               was generated in, and the sibling lookup cannot find the
               other two formats. */
            if(SNAP){ o[MF.ribbon]=(typeof ribbonOn==='function' && ribbonOn())?'true':'false';
                      o[MF.seg]=snapSeg(); }
            if(gallery[0]){ o['Image Src']=gallery[0]; o['Image Position']='1';
                            o['Image Alt Text']=p.design.label+' \u2014 '+p.title; }
          }
          if(v.name){ o['Option1 Name']=v.name; o['Option1 Value']=v.val; }
          o['Variant SKU']='MS-'+handle+(v.val?('-'+slug(v.val)):'');
          o['Variant Inventory Policy']='continue';
          o['Variant Fulfillment Service']='manual';
          o['Variant Price']=v.price;
          /* The single most important difference on a digital row: left TRUE,
             Shopify asks for an address and charges postage on a file. */
          o['Variant Requires Shipping']=isDigital(p.type)?'FALSE':'TRUE';
          o['Variant Taxable']='TRUE';
          lines.push(row(o));
        });
        for(var k=1;k<gallery.length;k++){
          lines.push(row({Handle:handle,'Image Src':gallery[k],'Image Position':String(k+1),
                          'Image Alt Text':p.design.label+' \u2014 '+p.title}));
        }
      });
      return lines.join('\r\n');
    }
    /* The generic products. The event-mode guards do not apply: there is no
       event, the route on screen is a showcase rather than a promise, and the
       default route is a perfectly reasonable thing to photograph. */
    function famRun(){
      if(!CLOUD.name){ setS('\u26a0 Set Cloudinary cloud name + preset in section settings first.'); return; }
      var fams=famPicked(), fmts=fmtPicked();
      if(!fams.length){ setS('\u26a0 Pick at least one family.'); return; }
      if(!fmts.length){ setS('\u26a0 Pick at least one format.'); return; }

      /* Render once per design x format. Both families show the same artwork -
         only the default route a customer lands on differs - so rendering per
         family would double a slow job to produce identical bytes. */
      var jobs=[];
      designPicked().forEach(function(d){
        d.types.forEach(function(t){
          if(fmts.indexOf(t)<0) return;
          jobs.push({type:t, kind:d.kind, dlabel:d.label, design:d,
                     ed:{style:d.style,label:STYLE_LABEL[d.style]}});
        });
      });
      if(!jobs.length){
        setS('\u26a0 Nothing to render \u2014 pick at least one design and one format '+
             'it is built for.');
        return;
      }

      var prevKind=DESIGN_KIND;
      var prev={product:state.product,style:state.style,mapStyle:state.mapStyle,view:state.view,mockIdx:state.mockIdx};
      var results=[], done=0, imgN=0;
      g('g-run').disabled=true; setS('Rendering 0/'+jobs.length+' \u2026');
      jobs.reduce(function(ch,job){ return ch.then(function(){
        return renderProduct(job.type,job.ed,function(){ imgN++; },job.kind).then(function(r){
          r.dlabel=job.dlabel; r.design=job.design; results.push(r); done++;
          setS('Rendering '+done+'/'+jobs.length+' \u2014 '+(job.dlabel||'Route')+' '+job.type+
               (r.error?' \u2717':' \u2713')+' \u00b7 '+imgN+' images'); }); }); }, Promise.resolve())
      .then(function(){
        setDesignKind(prevKind);
        state.product=prev.product; state.style=prev.style; state.mapStyle=prev.mapStyle;
        state.view=prev.view; state.mockIdx=prev.mockIdx;
        refreshStyles();
        if(isMapLike(state.style)){ ensureMap(function(){ ensureMap2(render); }); } else { render(); }

        var ok=results.filter(function(r){ return !r.error; });
        var errs=results.filter(function(r){ return r.error; });
        var prods=[];
        ok.forEach(function(r){
          var fl=r.images[r.images.length-1];
          fams.forEach(function(f){
            prods.push({ type:r.type, kind:r.kind, design:r.design,
              handle:famHandle(f.slug, r.design.slug, r.type),
              title:(IS_TRI?['Triathlon', TYPE_LABEL[r.type]]:[f.label, r.design.label, TYPE_LABEL[r.type]]).join(' '),
              code:f.slug, tags:f.tag, noDefaults:true,
              price:priceOf(r.type), flatUrl:fl, images:r.images });
          });
        });
        var csv=buildCSV('', '', prods);
        var nVar=0; prods.forEach(function(p){
          nVar += (p.type==='tee') ? TEE_SIZES.length
                : (p.type==='magnet') ? MAGNET_PACKS.length
                : (p.type==='poster') ? POSTER_SIZES.length : 1; });
        var out=g('g-out'); out.style.display='block'; out.value=csv;
        g('g-act').style.display='flex';
        /* Name the failures. A bare count tells you something did not render
           but not what, and the run takes long enough that nobody repeats it to
           find out - so the missing products get imported as a short CSV and
           noticed in the store instead. */
        var errTxt='';
        if(errs.length){
          errTxt=' \u00b7 '+errs.length+' failed: '+errs.map(function(r){
            return (r.dlabel||'Route')+' '+r.type;
          }).join(', ');
        }
        setS('Done \u2014 '+prods.length+' products, '+nVar+' variants, '+imgN+' mockups'+errTxt+
             seoTrimNote()+'. Check the handles above against your store, then import in Shopify \u2192 Products \u2192 Import.');
        g('g-run').disabled=false;
        g('g-csv').onclick=function(){ dl('generic-products.csv', csv, 'text/csv'); };
        var gd=g('g-dl'); if(gd) gd.onclick=function(){
          dl('generic-printfiles.json', JSON.stringify(prods.map(function(p){
            return {handle:p.handle, type:p.type, design:(p.kind||'base'),
                    price:p.price, printUrl:p.flatUrl};
          }),null,2), 'application/json'); };
      });
    }

    g('g-run').onclick=function(){
      if(IS_TRI ? !triAllIn() : (!state.coords || state.coords.length<2)){
        setS(IS_TRI?'\u26a0 Load all three legs above first \u2014 or open a race course with ?r=<code>&generate=family.':'\u26a0 Load a GPX above first.'); return; }
      if(FAM) return famRun();
      if(isDefaultRoute()){
        setS('\u26a0 The route is still the DEFAULT (Bay Run). Load the event GPX above before generating.');
        return;
      }
      if(($('cz-title').value||'').trim().toLowerCase()==='the bay run'){
        setS('\u26a0 The printed title is still "The Bay Run". Change it in the customiser above - it is baked onto every product generated.');
        return;
      }
      /* The fields are sticky across events. Measuring the loaded route is the
         only check that actually catches a previous event's title and distance
         being carried into a new one. */
      var _measured=routeKm(state.coords);
      var _typed=parseFloat(String($('cz-dist').value||'').replace(/[^0-9.]/g,''));
      if(isFinite(_typed) && _typed>0 && _measured>0){
        var _off=Math.abs(_typed-_measured)/_measured;
        if(_off>0.05){
          setS('\u26a0 The typed distance ('+_typed.toFixed(1)+' km) does not match the loaded route ('+
               _measured.toFixed(1)+' km). The printed title / distance / date are still from the previous event. '+
               'Fix them in the customiser above before generating.');
          return;
        }
      }
      if(!isFinite(_typed) || _typed<=0){
        setS('\u26a0 No distance set. The measured route is '+_measured.toFixed(1)+
             ' km \u2014 put that in the customiser above so it bakes onto the artwork.');
        return;
      }
      if(!CLOUD.name){ setS('\u26a0 Set Cloudinary cloud name + preset in section settings first.'); return; }
      var name=(g('g-name').value||'').trim();
      if(!name){ setS('\u26a0 Enter a store-facing collection name.'); return; }
      var okEle=eleOk(), jobs=[];
      if(SNAP){
        /* Whatever is on screen right now, in all three formats. */
        SNAP_ID=null;
        var _vr=snapVariant(), _seg=snapSeg();
        SNAP_ID={ seg:_seg, variant:_vr,
                  mapStyle:state.mapStyle, terrainTheme:state.terrainTheme,
                  styleVal:(state.style||'neon')+(_vr?(':'+_vr):'') };
        var sd={kind:DESIGN_KIND, slug:SNAP_ID.seg, style:(state.style||'neon'),
                label:(STYLE_LABEL[state.style]||'Neon'), types:['poster','magnet','tee','frame','a4print','digital']};
        sd.types.forEach(function(t){
          if(TYPES.indexOf(t)<0) return;
          /* Same tiles and theme on every format - that is what a snapshot is. */
          jobs.push({type:t, kind:sd.kind, dlabel:sd.label, design:sd,
                     ed:{style:sd.style,label:STYLE_LABEL[sd.style],
                         mapStyle:SNAP_ID.mapStyle, terrainTheme:SNAP_ID.terrainTheme}});
        });
      } else {
        DESIGNS.forEach(function(d){
          if(d.sports && d.sports.indexOf(SPORT)<0) return;   /* Stat Bar: 5K Run events only */
          d.types.forEach(function(t){
            if(TYPES.indexOf(t)<0) return;
            /* one product per design per format - twelve, not one per style */
            jobs.push({type:t, kind:d.kind, dlabel:d.label, design:d,
                       ed:{style:d.style,label:STYLE_LABEL[d.style]}});
          });
        });
      }
      var prevKind=DESIGN_KIND;
      var prev={product:state.product,style:state.style,mapStyle:state.mapStyle,view:state.view,mockIdx:state.mockIdx};
      var results=[], done=0, imgN=0;
      g('g-run').disabled=true; setS('Generating 0/'+jobs.length+' products\u2026');
      jobs.reduce(function(ch,job){ return ch.then(function(){
        return renderProduct(job.type,job.ed,function(){ imgN++; },job.kind).then(function(r){ r.dlabel=job.dlabel; r.design=job.design; results.push(r); done++;
          setS('Generating '+done+'/'+jobs.length+' \u2014 '+(job.dlabel||'Route')+' '+job.ed.label+' '+job.type+(r.error?' \u2717':' \u2713')+' \u00b7 '+imgN+' images'); }); }); }, Promise.resolve())
      .then(function(){
        setDesignKind(prevKind);
        state.product=prev.product; state.style=prev.style; state.mapStyle=prev.mapStyle; state.view=prev.view; state.mockIdx=prev.mockIdx;
        refreshStyles();
        if(isMapLike(state.style)){ ensureMap(function(){ ensureMap2(render); }); } else { render(); }
        /* evSlug(), not slug(name) - handles and design_code use evSlug */
        var s=evSlug(), tag='evt-'+s, ok=results.filter(function(r){return !r.error;}), errs=results.filter(function(r){return r.error;});
        
        /* One product per design x style x type. The Style option is retained
           with a single value so the CSV shape stays valid in Shopify. */
        var prods=ok.map(function(r){
          var fl=r.images[r.images.length-1];
          return { type:r.type, kind:r.kind, design:r.design,
            title:[name, r.design.label, cap(r.type)].join(' '),
            price:priceOf(r.type), flatUrl:fl, images:r.images };
        });
        var manifest={ event:{ name:name, handle:s, collectionTag:tag,
            printedTitle:($('cz-title').value||'').trim(), distance:($('cz-dist').value||'').trim(), date:($('cz-date').value||'').trim(),
            gpxUrl:(g('g-gpx').value||'').trim() },
          products: ok.map(function(r){ return { type:r.type, design:(r.kind||'base'), style:r.edition, mapStyle:r.mapStyle,
            price:priceOf(r.type), printUrl:r.printUrl, createLink:createLink(r.type,r.kind,r.edition.toLowerCase()) }; }) };
        var csv=buildCSV(name, tag, prods);
        /* must match buildCSV: tee -> sizes, magnet -> packs, poster -> one */
        var nVar=0; prods.forEach(function(p){
          nVar += (p.type==='tee') ? TEE_SIZES.length
                : (p.type==='magnet') ? MAGNET_PACKS.length
                : (p.type==='poster') ? POSTER_SIZES.length : 1; });
        var out=g('g-out'); out.style.display='block'; out.value=csv;
        g('g-act').style.display='flex';
        setS('Done \u2014 '+prods.length+' products, '+nVar+' variants, '+imgN+' mockups'+(okEle?'':' (elevation skipped)')+(errs.length?(' \u00b7 '+errs.length+' failed'):'')+seoTrimNote()+'. Import the CSV in Shopify \u2192 Products \u2192 Import.');
        g('g-run').disabled=false;
        g('g-csv').onclick=function(){ dl(s+'-products.csv', csv, 'text/csv'); };
        g('g-dl').onclick=function(){ dl(s+'-printfiles.json', JSON.stringify(manifest,null,2), 'application/json'); };
      });
    };
  })(); } }catch(e){ console.warn('Milestone generator:',e); }

  try{ if(getParam('makelink')==='1'){ (function(){
    var w=document.createElement('div');
    w.setAttribute('style','position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#17171A;color:#F3EFE7;font:14px/1.45 -apple-system,system-ui,sans-serif;padding:16px 16px calc(16px + env(safe-area-inset-bottom));box-shadow:0 -12px 40px rgba(0,0,0,.55);max-height:82vh;overflow:auto');
    var inp='width:100%;box-sizing:border-box;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#fff;margin:0 0 8px';
    var lbl='display:block;font-size:11.5px;color:#b7b2a6;margin:0 0 4px';
    w.innerHTML=
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><b style="font-size:15px">Product link builder</b><button id="m-x" style="background:none;border:none;color:#F3EFE7;font-size:22px;line-height:1;cursor:pointer">\u00d7</button></div>'
      +'<p style="margin:0 0 10px;color:#b7b2a6;font-size:12px">Every route in your catalogue, with its links ready to copy. The page link is the short one for Instagram.</p>'
      +'<label style="'+lbl+'">Link the product buttons to</label>'
      +'<select id="m-dirtarget" style="'+inp+'"></select>'
      +'<input id="m-dirq" type="search" placeholder="Filter routes\u2026" style="'+inp+'">'
      +'<div id="m-dir" style="margin:0 0 6px"></div>'
      +'<details style="margin-top:14px;border-top:1px solid #2a2a31;padding-top:12px">'
      +'<summary style="cursor:pointer;color:#b7b2a6;font-size:12.5px;margin-bottom:10px">One-off link for a GPX that isn\u2019t in the catalogue</summary>'
      +'<label style="'+lbl+'">Destination product</label>'
      +'<select id="m-target" style="'+inp+'"></select>'
      +'<div id="m-pathwrap" style="display:none"><label style="'+lbl+'">Custom path</label><input id="m-path" type="text" value="/pages/create-yours" style="'+inp+'"></div>'
      +'<label style="'+lbl+'">Pick a route from your catalogue</label>'
      +'<select id="m-route" style="'+inp+'"></select>'
      +'<label style="'+lbl+'">GPX file URL (must allow cross-origin fetch)</label>'
      +'<input id="m-gpx" type="url" placeholder="https://res.cloudinary.com/.../gold-coast-2026.gpx" style="'+inp+'">'
      +'<label style="'+lbl+'">Event name (printed title)</label>'
      +'<input id="m-name" type="text" placeholder="Gold Coast 42.2K 2026" style="'+inp+'">'
      +'<label style="'+lbl+'">Location</label>'
      +'<input id="m-loc" type="text" placeholder="Gold Coast, Australia" style="'+inp+'">'
      +'<div style="display:flex;gap:8px">'
      +'<div style="flex:1"><label style="'+lbl+'">Distance</label><input id="m-dist" type="text" placeholder="42.2 km" style="'+inp+'"></div>'
      +'<div style="flex:1"><label style="'+lbl+'">Date</label><input id="m-date" type="date" style="'+inp+'"></div>'
      +'</div>'
      +'<label style="'+lbl+'">Product to pre-select (optional)</label>'
      +'<select id="m-prod" style="'+inp+'"><option value="">\u2014 none \u2014</option><option value="poster">Poster</option><option value="tee">Tee</option><option value="magnet">Magnet</option></select>'
      +'<label style="'+lbl+'"><input id="m-abs" type="checkbox" checked style="vertical-align:-1px;margin-right:6px">Full URL (for sharing)</label>'
      +'<label style="'+lbl+'">Your link</label>'
      +'<textarea id="m-out" readonly style="width:100%;box-sizing:border-box;height:74px;padding:10px;border-radius:8px;border:1px solid #3a3a42;background:#0f0f12;color:#cfe9cf;font:12px/1.4 ui-monospace,Menlo,monospace;margin:0 0 8px"></textarea>'
      +'<button id="m-copy" style="width:100%;padding:12px;border:none;border-radius:10px;background:#FF5A1F;color:#fff;font-weight:700;font-size:15px;cursor:pointer">Copy link</button>'
      +'<div id="m-msg" style="font-size:12px;color:#b7b2a6;margin-top:8px;min-height:16px">Without a GPX URL, only the product is pre-selected.</div>'
      +'</details>';
    document.body.appendChild(w);
    var g=function(id){return w.querySelector('#'+id);};
    g('m-x').onclick=function(){ w.remove(); };

    /* ---- route directory ---------------------------------------------- */
    function copyText(t,btn,okLabel){
      var done=function(){ if(!btn) return; var was=btn.textContent;
        btn.textContent=okLabel||'Copied'; btn.style.background='#2e7d32';
        setTimeout(function(){ btn.textContent=was; btn.style.background=''; },1200); };
      try{
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(t).then(done,function(){ fallback(); }); return;
        }
      }catch(e){}
      fallback();
      function fallback(){
        var ta=document.createElement('textarea'); ta.value=t;
        ta.setAttribute('readonly',''); ta.style.cssText='position:fixed;top:0;left:0;opacity:0';
        document.body.appendChild(ta); ta.select();
        try{ document.execCommand('copy'); done(); }catch(e2){}
        document.body.removeChild(ta);
      }
    }
    (function(){
      var sel=g('m-dirtarget'), html='';
      (LINK_TARGETS||[]).forEach(function(t){ html+='<option value="'+t.url+'">'+t.label+'</option>'; });
      sel.innerHTML=html||'<option value="/products/your-route-poster">your-route-poster</option>';
    })();
    function drawDir(){
      var host=g('m-dir'); if(!host) return;
      var q=((g('m-dirq')||{value:''}).value||'').trim().toLowerCase();
      var prod=(g('m-dirtarget')||{value:''}).value||'';
      var org=window.location.origin;
      var rows=(ROUTES_CAT||[]).filter(function(r){
        if(!q) return true;
        return ((r.name||'')+' '+(r.loc||'')+' '+(r.code||'')).toLowerCase().indexOf(q)>=0;
      });
      host.innerHTML='';
      if(!rows.length){
        host.innerHTML='<div style="color:#b7b2a6;font-size:12.5px;padding:8px 0">No route matches that.</div>'; return;
      }
      rows.forEach(function(r){
        var row=document.createElement('div');
        row.setAttribute('style','border:1px solid #2a2a31;border-radius:10px;padding:10px 11px;margin:0 0 8px;background:#0f0f12');
        var hasKey=(typeof r.code!=='undefined');
        var code=(r.code||'').trim();
        var head=document.createElement('div');
        head.setAttribute('style','font-weight:700;font-size:13.5px;margin-bottom:2px');
        head.textContent=r.name||'Route';
        row.appendChild(head);
        var meta=document.createElement('div');
        meta.setAttribute('style','font-size:11.5px;color:#b7b2a6;margin-bottom:8px');
        meta.textContent=[r.loc,r.dist,r.date].filter(Boolean).join(' \u00b7 ');
        row.appendChild(meta);
        if(!code){
          var warn=document.createElement('div');
          warn.setAttribute('style','font-size:12px;color:#e0a03a;line-height:1.5');
          warn.textContent = hasKey
            ? '\u26a0 Code is empty. Check the entry is saved, and that the field\u2019s KEY is exactly \u201ccode\u201d (the label can differ from the key).'
            : '\u26a0 This theme\u2019s section file predates the code field \u2014 re-upload milestone-customizer-v2.liquid, then hard-refresh.';
          row.appendChild(warn); host.appendChild(row); return;
        }
        var pageUrl=org+'/pages/'+code;
        var prodUrl=org+prod+'?r='+encodeURIComponent(code);
        var bar=document.createElement('div');
        bar.setAttribute('style','display:flex;gap:8px;flex-wrap:wrap');
        var mk=function(label,url,accent){
          var b=document.createElement('button'); b.type='button'; b.textContent=label;
          b.setAttribute('style','flex:1 1 120px;padding:9px 10px;border:none;border-radius:8px;cursor:pointer;'
            +'font-weight:700;font-size:12.5px;color:#fff;background:'+(accent?'#FF5A1F':'#3a3a42'));
          b.addEventListener('click',function(){ copyText(url,b,'Copied \u2713'); });
          bar.appendChild(b);
        };
        mk('Copy page link',pageUrl,true);
        mk('Copy product link',prodUrl,false);
        row.appendChild(bar);
        var shown=document.createElement('div');
        shown.setAttribute('style','font:11px/1.5 ui-monospace,Menlo,monospace;color:#cfe9cf;margin-top:7px;word-break:break-all');
        shown.textContent='/pages/'+code;
        row.appendChild(shown);
        host.appendChild(row);
      });
    }
    (function(){
      var qd=g('m-dirq'); if(qd) qd.addEventListener('input',drawDir);
      var td=g('m-dirtarget'); if(td) td.addEventListener('change',drawDir);
      drawDir();
    })();
    (function(){
      var sel=g('m-target'), html='';
      (LINK_TARGETS||[]).forEach(function(t){ html+='<option value="'+t.url+'">'+t.label+'</option>'; });
      html+='<option value="__custom__">\\u2014 custom path \\u2014</option>';
      sel.innerHTML=html;
      var rs=g('m-route'), rh='<option value="">\\u2014 none / paste GPX below \\u2014</option>';
      (ROUTES_CAT||[]).forEach(function(r,i){ if(r.gpx){ rh+='<option value="'+i+'">'+(r.name||'Route')+(r.date?(' \\u00b7 '+r.date):'')+'</option>'; } });
      rs.innerHTML=rh;
    })();
    g('m-gpx').value=(getParam('gpx')||'').trim();
    g('m-name').value=($('cz-title')||{value:''}).value.trim();
    g('m-loc').value =($('cz-loc')||{value:''}).value.trim();
    g('m-dist').value=($('cz-dist')||{value:''}).value.trim();
    g('m-date').value=($('cz-date')||{value:''}).value.trim();
    function pickRoute(){
      var v=g('m-route').value; if(v===''){ build(); return; }
      var r=(ROUTES_CAT||[])[+v]; if(!r){ build(); return; }
      g('m-gpx').value=r.gpx||''; g('m-name').value=r.name||''; g('m-loc').value=r.loc||'';
      g('m-dist').value=r.dist||''; g('m-date').value=r.date||''; build();
    }
    function build(){
      var tv=g('m-target').value, custom=(tv==='__custom__');
      var pw=g('m-pathwrap'); if(pw) pw.style.display=custom?'block':'none';
      var path=custom?((g('m-path').value||'/pages/create-yours').trim()):tv;
      var q=[], add=function(k,v){ v=String(v==null?'':v).trim(); if(v) q.push(k+'='+encodeURIComponent(v)); };
      var gpx=(g('m-gpx').value||'').trim();
      /* A catalogue route with a code collapses the whole query to ?r=<code>:
         short enough for a bio, no Cloudinary URL on show, and the copy and
         the file can both change later without reissuing the link. */
      var _rsel=g('m-route').value;
      var _robj=(_rsel!=='')?((ROUTES_CAT||[])[+_rsel]||null):null;
      var _code=(_robj&&_robj.code||'').trim();
      var noCode=!!(_robj && !_code);
      if(_code){ add('r',_code); }
      else if(gpx){ add('gpx',gpx); add('name',g('m-name').value); add('loc',g('m-loc').value); add('dist',g('m-dist').value); add('date',g('m-date').value); }
      if(g('m-prod').value) q.push('product='+encodeURIComponent(g('m-prod').value));
      var url=path+(q.length?('?'+q.join('&')):'');
      if(g('m-abs') && g('m-abs').checked && url.charAt(0)==='/'){ url=window.location.origin+url; }
      g('m-out').value=url;
      var msg=g('m-msg');
      if(msg){
        if(noCode){ msg.style.color='#e0a03a';
          msg.textContent='\u26a0 This route has no Code yet \u2014 add one in Content \u203a Metaobjects \u203a Routes and the link becomes ?r='+((_robj.name||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')||'your-code')+'.'; }
        else if(_code){ msg.style.color='#8fc98f';
          msg.textContent='Short link \u2014 the GPX URL stays off the address bar, and the title, blurb and design all follow the route record.'; }
        else { msg.style.color=gpx?'#8fc98f':'#e0a03a';
          msg.textContent=gpx?'Ready. Paste this anywhere. (Pick a catalogue route to get a short ?r= link instead.)':'\u26a0 No GPX URL \u2014 only the product is pre-selected.'; }
      }
    }
    ['m-path','m-gpx','m-name','m-loc','m-dist','m-date','m-prod','m-target','m-abs'].forEach(function(id){ var e=g(id); if(e){ e.addEventListener('input',build); e.addEventListener('change',build); } });
    (function(){ var r=g('m-route'); if(r) r.addEventListener('change',pickRoute); })();
    g('m-copy').onclick=function(){ g('m-out').select();
      try{ if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(g('m-out').value); } else { document.execCommand('copy'); }
        g('m-copy').textContent='Copied \u2713'; setTimeout(function(){ g('m-copy').textContent='Copy link'; },1500);
      }catch(e){ document.execCommand('copy'); } };
    build();
  })(); } }catch(e){ console.warn('Milestone link builder:',e); }
}

window.MSBOOT = function(){
  var Q = window.MSQ || (window.MSQ = []);
  while(Q.length){
    var cfg = Q.shift();
    try{ MSENGINE(cfg.c || [], cfg.d || {}); }
    catch(e){ console.warn('Milestone engine:', e); }
  }
};
window.MSBOOT();
